(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = "amp-story-access{position:absolute!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;top:0!important;left:0!important;height:100%!important;width:100%!important;z-index:100003!important;transform:translate3d(0,100vh,0)!important;transition-delay:0.15s!important;pointer-events:none!important}amp-story-access[amp-access-hide]{display:none!important}amp-story-access[type=blocking]{z-index:100004!important}amp-story-access.i-amphtml-story-access-visible{transform:translateZ(0)!important;transition-delay:0s!important}amp-story-access[type=blocking]:before{content:\"\"!important;position:absolute!important;top:0!important;left:0!important;height:100%!important;width:100%!important;background:#000!important;opacity:0!important;pointer-events:auto!important;transition:opacity 0.15s cubic-bezier(0.4,0.0,1,1)!important}amp-story-access[type=blocking].i-amphtml-story-access-visible:before{opacity:0.55!important;transition:opacity 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-access-overflow{margin-top:auto!important;overflow-y:auto!important;overflow-x:hidden!important;pointer-events:auto!important;-webkit-overflow-scrolling:touch!important}.i-amphtml-story-access-container{position:relative!important;margin:88px 0 0!important;padding:0px!important;background:#fff!important;border-radius:8px 8px 0 0!important;color:rgba(0,0,0,0.87)!important;font-family:Roboto,sans-serif!important;overflow:hidden!important;text-align:start!important;transform:translate3d(0,100%,0)!important;transition:transform 0.15s cubic-bezier(0.4,0.0,1,1)!important}.i-amphtml-story-access-visible .i-amphtml-story-access-container{transform:translateZ(0)!important;transition:transform 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}[type=notification] .i-amphtml-story-access-container{box-shadow:0 -1px 2px 1px rgba(0,0,0,0.12)!important;max-height:calc(var(--story-page-vh, 1vh)*20)!important}.i-amphtml-story-access-header{position:relative!important;margin:0 0 48px!important;height:80px!important;min-height:80px!important;background:var(--primary-color,#f0f0f0)!important;z-index:2!important}.i-amphtml-story-access-logo{position:absolute!important;bottom:-32px!important;margin-left:-32px!important;left:50%!important;height:64px!important;width:64px!important;background:#f0f0f0!important;background-position:50%!important;background-repeat:no-repeat!important;background-size:contain!important;border-radius:5px!important}.i-amphtml-story-access-logo:before{content:\"\"!important;position:absolute!important;top:-6px!important;bottom:-6px!important;left:-6px!important;right:-6px!important;background:#fff!important;border-radius:6px!important;box-shadow:0 2px 3px rgba(0,0,0,0.12)!important;z-index:-1!important}.i-amphtml-story-access-close-button{position:absolute!important;top:0!important;right:0!important;height:36px!important;width:36px!important;color:#757575!important;cursor:pointer!important;font-size:24px!important;line-height:36px!important;text-align:center!important}.i-amphtml-story-access-content{padding:16px!important;font-size:14px!important;z-index:0!important}@media (min-width:420px){amp-story-access{-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important}.i-amphtml-story-access-container{margin:0!important;width:calc(100vw - 80px)!important;max-width:800px!important}.i-amphtml-story-access-content{margin:0 auto!important;max-width:424px!important;-ms-flex-positive:1!important;flex-grow:1!important;overflow-y:auto!important}.i-amphtml-story-access-content::-webkit-scrollbar,.i-amphtml-story-access-overflow::-webkit-scrollbar{width:0px!important;background:transparent!important}[type=blocking] .i-amphtml-story-access-overflow{margin-top:0!important;border-radius:6px!important;box-shadow:0 1px 3px 1px rgba(0,0,0,0.2)!important}[type=blocking] .i-amphtml-story-access-container{display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;max-height:60vh!important;min-height:20vh!important;border-radius:0px!important;opacity:0!important;transform:translateZ(0)!important;transition:opacity 0.15s cubic-bezier(0.4,0.0,1,1)!important}[type=blocking].i-amphtml-story-access-visible .i-amphtml-story-access-container{opacity:1!important;transition:opacity 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}}[affiliate-link-icon]{position:relative!important;width:50px!important;height:50px!important}[affiliate-link-icon]:not([expanded]),[affiliate-link-icon]:not([expanded]) .i-amphtml-story-affiliate-link-circle{animation:i-amphtml-story-affiliate-link-collapse 0.2s cubic-bezier(0.4,0.0,0.2,1) forwards!important}[affiliate-link-icon][pristine],[affiliate-link-icon][pristine] .i-amphtml-story-affiliate-link-circle{animation:none!important}amp-story-page[active] [affiliate-link-icon][expanded],amp-story-page[active] [affiliate-link-icon][expanded] .i-amphtml-story-affiliate-link-circle{animation:i-amphtml-story-affiliate-link-expand 0.2s cubic-bezier(0.4,0.0,0.2,1) forwards!important;transform-origin:left!important}@keyframes i-amphtml-story-affiliate-link-expand{0%{width:40px;border-radius:50%}to{width:160px;border-radius:20px}}@keyframes i-amphtml-story-affiliate-link-collapse{0%{width:160px;border-radius:20px}to{width:40px;border-radius:50%}}.i-amphtml-story-affiliate-link-circle{position:absolute!important;background:#fff!important;margin:5px!important;width:40px!important;height:40px!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:justify!important;justify-content:space-between!important;border-radius:20px!important}[affiliate-link-icon][expanded] .i-amphtml-story-affiliate-link-circle{overflow:hidden!important}[affiliate-link-icon] .i-amphtml-story-reset.i-amphtml-hidden{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.i-amphtml-story-affiliate-link-text{visibility:hidden!important;text-align:center!important;text-overflow:ellipsis!important;overflow:hidden!important;white-space:nowrap!important;max-width:70px!important;width:70px!important;font-family:Roboto,sans-serif!important;font-size:14px!important;color:#3c4043!important;letter-spacing:0!important;line-height:40px!important}.i-amphtml-story-affiliate-link-launch{visibility:hidden!important;background-position:50%!important;background-repeat:no-repeat!important;background-size:18px 18px!important;width:40px!important;height:40px!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 48 48' fill='%23757575'%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3Cpath d='M38 38H10V10h14V6H10c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V24h-4v14zM28 6v4h7.17L15.51 29.66l2.83 2.83L38 12.83V20h4V6H28z'/%3E%3C/svg%3E\")!important}amp-story-page[active] .i-amphtml-story-affiliate-link-pulse{position:absolute!important;border-radius:50%!important;background:hsla(0,0%,100%,0.4)!important;margin:5px!important;width:40px!important;height:40px!important;animation:pulse 1.5s cubic-bezier(0.4,0.0,0.2,1) infinite alternate!important}@keyframes pulse{0%{transform:scale(1)}to{transform:scale(1.3)}}[affiliate-link-icon][expanded] .i-amphtml-story-affiliate-link-pulse{animation:none!important}[affiliate-link-icon][expanded] .i-amphtml-story-affiliate-link-launch,[affiliate-link-icon][expanded] .i-amphtml-story-affiliate-link-text{visibility:visible!important}@media any-hover{[affiliate-link-icon]:hover .i-amphtml-story-affiliate-link-circle{background:hsla(0,0%,100%,0.4)!important}[affiliate-link-icon]:hover .i-amphtml-story-affiliate-link-pulse{background:none!important;animation:none!important}}.i-amphtml-story-affiliate-link-icon{background-position:50%!important;background-repeat:no-repeat!important;background-size:24px 24px!important;color:rgba(0,0,0,0.54)!important;width:40px!important;height:40px!important}[affiliate-link-icon=shopping-cart] .i-amphtml-story-affiliate-link-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23005AF0'%3E%3Cpath d='M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}[affiliate-link-icon=offer] .i-amphtml-story-affiliate-link-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23005AF0'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z'/%3E%3C/svg%3E\")!important}[affiliate-link-icon=flight] .i-amphtml-story-affiliate-link-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23005AF0'%3E%3Cpath d='M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}[affiliate-link-icon=hotel] .i-amphtml-story-affiliate-link-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23005AF0'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z'/%3E%3C/svg%3E\")!important}[affiliate-link-icon=movie] .i-amphtml-story-affiliate-link-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23005AF0'%3E%3Cpath d='M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}[affiliate-link-icon=activity] .i-amphtml-story-affiliate-link-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23005AF0'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z'/%3E%3C/svg%3E\")!important}[affiliate-link-icon=more-to-read] .i-amphtml-story-affiliate-link-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23005AF0'%3E%3Cpath fill='none' d='M-74 29h48v48h-48V29zM0 0h24v24H0V0zm0 0h24v24H0V0z'/%3E%3Cpath d='M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z'/%3E%3C/svg%3E\")!important}.i-amphtml-story-background{background-color:transparent}amp-sidebar{background-color:#fff}amp-story[standalone].i-amphtml-story-desktop-panels{max-width:none!important;max-height:none!important;width:100vw!important}.i-amphtml-story-desktop-panels amp-story-page.i-amphtml-element{transform:perspective(1px) scale(0.9) translateX(calc(250% + 192px)) translateY(0%)!important;opacity:0.05!important;transform-origin:left!important;border-radius:0!important;box-shadow:none!important}.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-visited],[dir=rtl] .i-amphtml-story-desktop-panels amp-story-page.i-amphtml-element{transform:perspective(1px) scale(0.9) translateX(calc(-350% - 192px)) translateY(0%)!important}[dir=rtl] .i-amphtml-story-desktop-panels amp-story-page[i-amphtml-visited]{transform:perspective(1px) scale(0.9) translateX(calc(250% + 192px)) translateY(0%)!important}.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"1\"],.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"2\"],.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"-1\"],.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"-2\"]{transition:opacity 350ms ease-out,transform 350ms cubic-bezier(0.4,0.0,0.2,1)!important}.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"0\"]{transition:opacity 350ms cubic-bezier(0.0,0.0,0.2,1),transform 350ms cubic-bezier(0.4,0.0,0.2,1)!important}.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"-2\"],[dir=rtl] .i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"2\"]{transform:perspective(1px) scale(0.9) translateX(calc(-5*var(--i-amphtml-story-page-50vw, 50%) - 128px)) translateY(0%)!important}.i-amphtml-story-desktop-panels .prev-container>.i-amphtml-story-page-sentinel,.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"-1\"],[dir=rtl] .i-amphtml-story-desktop-panels .next-container>.i-amphtml-story-page-sentinel,[dir=rtl] .i-amphtml-story-desktop-panels amp-story-page[active]+amp-story-page:not([i-amphtml-desktop-position]):not([distance]),[dir=rtl] .i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"1\"]{transform:perspective(1px) scale(0.9) translateX(calc(-3*var(--i-amphtml-story-page-50vw, 50%) - 64px)) translateY(0%)!important}.i-amphtml-story-desktop-panels amp-story-page[active],.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"0\"],[dir=rtl] .i-amphtml-story-desktop-panels amp-story-page[active],[dir=rtl] .i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"0\"]{transform:perspective(1px) scale(1.0) translateX(calc(-1*var(--i-amphtml-story-page-50vw, 50%))) translateY(0%)!important;opacity:1!important}.i-amphtml-story-desktop-panels .next-container>.i-amphtml-story-page-sentinel,.i-amphtml-story-desktop-panels amp-story-page[active]+amp-story-page:not([i-amphtml-desktop-position]):not([distance]),.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"1\"],[dir=rtl] .i-amphtml-story-desktop-panels .prev-container>.i-amphtml-story-page-sentinel,[dir=rtl] .i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"-1\"]{transform:perspective(1px) scale(0.9) translate(calc(var(--i-amphtml-story-page-50vw, 50%) + 64px))!important}.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"2\"],[dir=rtl] .i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"-2\"]{transform:perspective(1px) scale(0.9) translate(calc(3*var(--i-amphtml-story-page-50vw, 50%) + 128px))!important}.i-amphtml-story-next-hover>amp-story-page[i-amphtml-desktop-position=\"0\"]+amp-story-page,.i-amphtml-story-prev-hover>amp-story-page[i-amphtml-desktop-position=\"-1\"]{opacity:0.3!important}.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"1\"][amp-access-hide]:before{content:\"\"!important;position:absolute!important;top:50%!important;left:50%!important;margin:-48px 0 0 -48px!important;width:96px!important;height:96px!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='96' height='96' viewBox='0 0 24 24' fill='%23FFF'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h24v24H0V0z'/%3E%3C/defs%3E%3CclipPath id='b'%3E%3Cuse xlink:href='%23a' overflow='visible'/%3E%3C/clipPath%3E%3Cpath clip-path='url(%23b)' d='M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z'/%3E%3C/svg%3E\")!important;z-index:4!important}.i-amphtml-story-desktop-panels amp-story-page[i-amphtml-desktop-position=\"1\"][amp-access-hide]>*{filter:blur(8px)!important}.i-amphtml-story-desktop-panels .i-amphtml-story-media-query-matcher,.i-amphtml-story-desktop-panels .i-amphtml-story-page-sentinel,.i-amphtml-story-desktop-panels>amp-story-page{left:50%!important;right:auto!important;margin:auto!important;max-height:75vh!important;max-width:45vh!important;min-width:320px!important;min-height:533px!important}.amp-story-draggable-drawer-root{display:block!important;position:absolute!important;top:0!important;left:0!important;height:100%!important;width:100%!important;overflow:hidden!important;z-index:4!important;transform:translate3d(0,100%,0)!important;transition:transform 0.25s cubic-bezier(0.4,0.0,1,1)!important}.amp-story-draggable-drawer-root[hidden]{display:none!important}.amp-story-draggable-drawer-root.i-amphtml-story-draggable-drawer-open{transform:translateZ(0)!important;transition:transform 0.4s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-draggable-drawer{height:100%!important}.i-amphtml-story-draggable-drawer-container{height:calc(100% - 40px)!important;background:#fff!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;transition:background 0.3s cubic-bezier(0.4,0.0,0.2,1)!important}.i-amphtml-story-draggable-drawer-theme-dark .i-amphtml-story-draggable-drawer-container{background:#202125!important}.i-amphtml-story-draggable-drawer-container[hidden]{display:block!important;background:hsla(0,0%,100%,0.92)!important}.i-amphtml-story-draggable-drawer-theme-dark .i-amphtml-story-draggable-drawer-container[hidden]{background:rgba(32,33,37,0.82)!important}.i-amphtml-story-draggable-drawer-content{opacity:1!important;transition:opacity 0.3s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-draggable-drawer-container[hidden] .i-amphtml-story-draggable-drawer-content{opacity:0!important}.i-amphtml-story-draggable-drawer-container[hidden] .i-amphtml-story-draggable-drawer-content>*{display:none!important}[desktop] .amp-story-draggable-drawer-root{display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important;background:rgba(0,0,0,0.55)!important;opacity:0!important;transition:opacity 0.15s cubic-bezier(0.4,0.0,1,1),transform 0s linear 0.15s!important}[desktop] .amp-story-draggable-drawer-root.i-amphtml-story-draggable-drawer-open{opacity:1!important;transition:opacity 0.3s cubic-bezier(0.0,0.0,0.2,1)!important;transform:translateZ(0)!important}[desktop] .i-amphtml-story-draggable-drawer{height:60vh!important;width:800px!important;border-radius:8px!important;overflow:hidden!important}.i-amphtml-story-draggable-drawer-bookend .i-amphtml-story-draggable-drawer-container,.i-amphtml-story-draggable-drawer-bookend .i-amphtml-story-draggable-drawer-container[hidden]{height:100%!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;background:transparent!important;transition:none!important}.i-amphtml-story-draggable-drawer-bookend .i-amphtml-story-draggable-drawer-content{margin-top:auto!important;padding-top:88px!important}.i-amphtml-story-draggable-drawer-bookend .i-amphtml-story-draggable-drawer-container[hidden] .i-amphtml-story-draggable-drawer-content{opacity:1!important}[desktop] .i-amphtml-story-draggable-drawer-bookend .i-amphtml-story-draggable-drawer{height:100%!important;width:100%!important}[desktop] .i-amphtml-story-draggable-drawer-bookend .i-amphtml-story-draggable-drawer-content{padding-top:0!important}.i-amphtml-story-page-attachment-remote{height:48px!important;bottom:0!important;top:auto!important}.i-amphtml-story-page-attachment-remote .i-amphtml-story-draggable-drawer-container{height:100%!important;border-radius:8px 8px 0 0!important;box-shadow:0 1px 2px 1px rgba(0,0,0,0.12)!important}.i-amphtml-story-page-attachment-remote-content{display:-ms-flexbox!important;display:flex!important;padding:0 24px!important;-ms-flex-align:center!important;align-items:center!important;color:rgba(0,0,0,0.87)!important;font-family:Roboto,sans-serif!important;font-size:15px!important;-ms-flex-pack:justify!important;justify-content:space-between!important;line-height:48px!important;text-decoration:none!important}.i-amphtml-story-page-attachment-remote-title{max-width:calc(100% - 30px)!important;overflow:hidden!important;text-overflow:ellipsis!important}.i-amphtml-story-draggable-drawer-theme-dark .i-amphtml-story-page-attachment-remote-title{color:#9aa0a6!important}.i-amphtml-story-page-attachment-remote-icon{display:block!important;height:24px!important;width:24px!important;padding:0px!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 48 48' fill='%239AA0A6'%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3Cpath d='M38 38H10V10h14V6H10c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V24h-4v14zM28 6v4h7.17L15.51 29.66l2.83 2.83L38 12.83V20h4V6H28z'/%3E%3C/svg%3E\")!important}@keyframes open-attachment-fly-in{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}@keyframes open-attachment-icon{0%{transform:translateY(14px)}to{transform:translateY(0)}}@keyframes open-attachment-icon-explode{0%{transform:scale(0)}to{transform:scale(1);box-shadow:0 1px 3px 1px rgba(0,0,0,0.12)}}@keyframes open-attachment-icon-color{0%{background:#fff}to{background:rgba(0,0,0,0.87);text-shadow:none}}@keyframes open-attachment-bar-left{0%{transform:rotate(0deg)}to{transform:rotate(-30deg)}}@keyframes open-attachment-bar-right{0%{transform:rotate(0deg)}to{transform:rotate(30deg)}}amp-story-page .i-amphtml-story-page-open-attachment{display:none!important}amp-story-page[active] .i-amphtml-story-page-open-attachment{display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important;-ms-flex-direction:column!important;flex-direction:column!important;position:absolute!important;bottom:0!important;left:0!important;width:100%!important;background:linear-gradient(0,rgba(0,0,0,0.15),transparent)!important;pointer-events:none!important;z-index:3!important;animation:open-attachment-fly-in 0.3s cubic-bezier(0.4,0.0,0.2,1) both!important}amp-story-page .i-amphtml-story-page-open-attachment>*{cursor:pointer!important;pointer-events:auto!important}amp-story-page .i-amphtml-story-page-open-attachment-icon{display:block!important;height:32px!important;width:32px!important;cursor:pointer!important;animation:open-attachment-icon 0.2s cubic-bezier(0.4,0.0,0.2,1) 2s both!important}amp-story-page .i-amphtml-story-page-open-attachment-icon:after{content:\"\"!important;position:absolute!important;top:0!important;left:0!important;height:100%!important;width:100%!important;background:#fff!important;border-radius:100%!important;z-index:-1!important;animation:open-attachment-icon-explode 0.25s cubic-bezier(0.4,0.0,0.2,1) 2s both!important}amp-story-page .i-amphtml-story-page-open-attachment-bar-left,amp-story-page .i-amphtml-story-page-open-attachment-bar-right{position:absolute!important;display:block!important;height:3px!important;width:12px!important;border-radius:3px!important;top:14px!important}amp-story-page .i-amphtml-story-page-open-attachment-bar-left{left:6px!important;animation:open-attachment-icon-color 0.25s cubic-bezier(0.4,0.0,0.2,1) 2s both,open-attachment-bar-left 0.3s cubic-bezier(0.4,0.0,0.2,1) both!important}amp-story-page .i-amphtml-story-page-open-attachment-bar-right{right:6px!important;animation:open-attachment-icon-color 0.25s cubic-bezier(0.4,0.0,0.2,1) 2s both,open-attachment-bar-right 0.3s cubic-bezier(0.4,0.0,0.2,1) both!important}amp-story-page .i-amphtml-story-page-open-attachment-label{position:relative!important;padding:12px 32px 20px!important;height:16px!important;max-width:calc(100% - 64px)!important;color:#fff!important;font-family:Roboto,sans-serif!important;font-size:16px!important;font-weight:700!important;letter-spacing:0.3px;line-height:16px!important;overflow:hidden!important;text-overflow:ellipsis!important;text-shadow:0px 0px 6px rgba(0,0,0,0.36)!important;white-space:nowrap!important}.i-amphtml-story-page-attachment-expand{position:relative!important;width:100%!important;height:100%!important;background:#fff!important;z-index:100000!important;animation:i-amphtml-open-3p-attachment 120ms cubic-bezier(0.0,0.0,0.2,1) forwards!important}@keyframes i-amphtml-open-3p-attachment{0%{transform:scaleX(0);opacity:0.3}to{transform:scaleX(1);opacity:1}}[orientation=landscape] [position=landscape-half-left]{width:50%!important;left:0!important;right:auto!important}[orientation=landscape] [position=landscape-half-right]{width:50%!important;left:auto!important;right:0!important}amp-story{font-display:optional}amp-story-grid-layer{overflow:hidden}amp-story-grid-layer *{box-sizing:border-box;margin:0}.i-amphtml-story-grid-template-fill amp-anim img,.i-amphtml-story-grid-template-fill amp-img img,.i-amphtml-story-grid-template-fill amp-video video,.i-amphtml-story-grid-template-with-full-bleed-animation amp-img img{-o-object-fit:cover;object-fit:cover}.i-amphtml-story-grid-template-vertical{-ms-flex-line-pack:start;align-content:start;grid-gap:16px;-ms-flex-pack:stretch;justify-content:stretch;justify-items:start}.i-amphtml-story-grid-template-vertical>*{width:100%}.i-amphtml-story-grid-template-horizontal{-ms-flex-line-pack:stretch;align-content:stretch;-ms-flex-align:start;align-items:start;grid-gap:16px;-ms-flex-pack:start;justify-content:start}amp-story-grid-layer{padding:68px 32px 32px}amp-story-grid-layer.i-amphtml-story-has-page-attachment.i-amphtml-story-has-interactive{padding-bottom:104px}amp-story-grid-layer.i-amphtml-story-has-CTA-layer.i-amphtml-story-has-interactive{padding-bottom:20%}amp-story[standalone][i-amphtml-vertical]{height:auto!important;contain:initial!important}[i-amphtml-vertical] *{transition-delay:0s!important;transition-duration:0s!important}[i-amphtml-vertical] amp-story-page{position:relative!important;height:178vw!important;contain:initial!important;overflow:visible!important}amp-story[i-amphtml-vertical].i-amphtml-element amp-story-page.i-amphtml-element{transform:none!important}[i-amphtml-vertical] .i-amphtml-story-draggable-drawer-container[hidden] .i-amphtml-story-draggable-drawer-content{opacity:1!important}[i-amphtml-vertical] .i-amphtml-story-draggable-drawer-container[hidden] .i-amphtml-story-draggable-drawer-content>*{display:block!important}[i-amphtml-vertical] amp-story-bookend,[i-amphtml-vertical] amp-story-page-attachment{display:block!important;position:relative!important;transform:none!important}[i-amphtml-vertical] .i-amphtml-story-page-attachment-remote-title{overflow:visible!important}[i-amphtml-vertical].i-amphtml-story-bookend-active amp-story-page[active]:after{content:none!important}[i-amphtml-vertical] .i-amphtml-story-page-description{background:#fff!important;display:block!important;padding:32px!important;width:auto!important;z-index:9999999!important}[i-amphtml-vertical] .i-amphtml-story-page-description>*{background:#fff!important;color:#000!important;font-size:1rem!important}[i-amphtml-vertical] .i-amphtml-story-page-description>h2{font-size:1.5rem!important}.i-amphtml-story-desktop-fullbleed .i-amphtml-story-button-container,.i-amphtml-story-desktop-panels .i-amphtml-story-button-container{position:absolute!important;top:0!important;bottom:0!important;left:0!important;right:0!important;z-index:100002!important;pointer-events:none!important;display:block!important}.i-amphtml-story-back-prev>.i-amphtml-story-page-sentinel,.i-amphtml-story-button-move,.i-amphtml-story-fwd-next>.i-amphtml-story-page-sentinel{pointer-events:all!important}.i-amphtml-story-button-container.next-container>.i-amphtml-story-button-move{left:auto!important;right:0!important}[dir=rtl] .i-amphtml-story-button-container.next-container>.i-amphtml-story-button-move{right:auto!important;left:0!important}.i-amphtml-story-page-sentinel{position:absolute!important;width:100vw!important;height:100vh!important;top:0!important;bottom:0!important;margin-left:-32px!important;z-index:100002!important;cursor:pointer}.i-amphtml-story-desktop-fullbleed .i-amphtml-story-page-sentinel{display:none!important}.i-amphtml-story-button-move{position:absolute!important;top:0!important;bottom:0!important;margin:auto 40px!important;width:60px!important;height:60px!important;border-radius:50%!important;border:0!important;background-color:#fff!important;background-repeat:no-repeat!important;background-size:12px 17px!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;-ms-flex-align:center!important;align-items:center!important;opacity:.5!important;transition:opacity 150ms linear,transform 350ms linear!important;cursor:pointer!important;z-index:100002!important}.i-amphtml-story-desktop-fullbleed .i-amphtml-story-button-move{height:48px!important;width:48px!important;margin:auto 12px!important;background-color:transparent!important;background-size:auto!important;filter:drop-shadow(0 0 16px rgba(0,0,0,0.5))!important;opacity:1!important}.prev-container>.i-amphtml-story-button-move,[dir=rtl] .i-amphtml-story-fwd-next>.i-amphtml-story-button-move{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='25' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.7 22l-9.5-9.5L15.7 3l-3-3L.4 12.6 12.8 25'/%3E%3C/svg%3E\")!important;background-position:45% 50%!important;left:0!important;right:auto!important}.i-amphtml-story-desktop-fullbleed .prev-container>.i-amphtml-story-button-move,.i-amphtml-story-desktop-fullbleed[dir=rtl] .i-amphtml-story-fwd-next>.i-amphtml-story-button-move{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 24 24' fill='%23FFF'%3E%3Cpath d='M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z'/%3E%3Cpath fill='none' d='M0 0h24v24H0z'/%3E%3C/svg%3E\")!important;background-position:10px 0!important}.i-amphtml-story-fwd-next>.i-amphtml-story-button-move,[dir=rtl] .prev-container>.i-amphtml-story-button-move{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='25' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.3 3l9.5 9.5L.3 22l3 3 12.4-12.5L3.2 0'/%3E%3C/svg%3E\")!important;background-position:55% 50%!important;left:auto!important;right:0!important}.i-amphtml-story-desktop-fullbleed .i-amphtml-story-fwd-next>.i-amphtml-story-button-move,.i-amphtml-story-desktop-fullbleed[dir=rtl] .prev-container>.i-amphtml-story-button-move{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='%23FFF'%3E%3Cpath d='M11.76 8.24L27.51 24 11.76 39.76 16 44l20-20L16 4z'/%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3C/svg%3E\")!important}.i-amphtml-story-fwd-replay>.i-amphtml-story-button-move{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24'%3E%3Cpath d='M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important;background-position:50%;background-size:32px 32px!important}.i-amphtml-story-desktop-fullbleed .i-amphtml-story-fwd-replay>.i-amphtml-story-button-move{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='%23FFF'%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3Cpath d='M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z'/%3E%3C/svg%3E\")!important;background-size:auto!important}.i-amphtml-story-fwd-more>.i-amphtml-story-button-move{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'/%3E%3C/svg%3E\")!important;background-position:50%;background-size:32px 32px!important}.i-amphtml-story-desktop-fullbleed .i-amphtml-story-fwd-more>.i-amphtml-story-button-move{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='%23FFF'%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3Cpath d='M12 20c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm24 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-12 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z'/%3E%3C/svg%3E\")!important;background-size:auto!important}.i-amphtml-story-desktop-panels.i-amphtml-story-next-hover>.next-container>.i-amphtml-story-button-move,.i-amphtml-story-desktop-panels.i-amphtml-story-prev-hover>.prev-container>.i-amphtml-story-button-move{transform:scale(1.1)!important;opacity:1!important}.i-amphtml-story-next-hover>.i-amphtml-story-button-hidden>.i-amphtml-story-button-move,.i-amphtml-story-prev-hover>.i-amphtml-story-button-hidden>.i-amphtml-story-button-move{opacity:0!important}.i-amphtml-story-button-hidden>.i-amphtml-story-button-move{cursor:default!important;pointer-events:none!important;opacity:0!important}.i-amphtml-story-desktop-panels.i-amphtml-story-next-hover>.i-amphtml-story-fwd-next>.i-amphtml-story-button-move{transform:translateX(8px)!important;opacity:1!important}.i-amphtml-story-desktop-panels.i-amphtml-story-prev-hover>.i-amphtml-story-back-close-bookend>.i-amphtml-story-button-move,.i-amphtml-story-desktop-panels.i-amphtml-story-prev-hover>.i-amphtml-story-back-prev>.i-amphtml-story-button-move{transform:translateX(-8px)!important;opacity:1!important}amp-story,amp-story-cta-layer,amp-story-page{contain:strict!important;overflow:hidden!important;-webkit-touch-callout:none!important}amp-story-grid-layer{contain:size layout!important;-webkit-touch-callout:none!important}amp-story amp-consent{position:absolute!important;top:0!important;left:0!important;height:100%!important;width:100%!important;background:none!important;z-index:initial!important}@media (prefers-reduced-motion:reduce){*,:after,:before{animation-duration:0s!important;transition-duration:0s!important}}amp-consent.amp-hidden{display:none!important}.i-amphtml-story-system-reset,.i-amphtml-story-system-reset *{border:none!important;box-sizing:initial!important;color:initial!important;font-family:Roboto,sans-serif!important;font-size:initial!important;font-weight:initial!important;height:auto!important;margin:0!important;padding:0!important;text-align:start!important;text-shadow:none!important;width:auto!important}amp-story{height:100%!important;position:relative!important;text-rendering:geometricPrecision!important;-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important;width:100%!important;-ms-touch-action:manipulation!important;touch-action:manipulation!important}html.i-amphtml-story-standalone{font-size:calc(2.5*var(--story-page-vmax, 8px))}html.i-amphtml-story-standalone,html.i-amphtml-story-standalone body{font-size:calc(2.5*var(--story-page-vh, 8px));height:100%!important;margin:0!important;padding:0!important;width:100%!important;border:0!important;cursor:auto!important;-webkit-tap-highlight-color:rgba(0,0,0,0)!important}h4,p{font-size:1rem}h1{font-size:2rem}h2{font-size:1.5rem}h3{font-size:1.17rem}h5{font-size:0.83rem}h6{font-size:0.67rem}html.i-amphtml-story-standalone #i-amphtml-wrapper body{border-top:none!important;overflow:hidden!important}amp-story[standalone]{-ms-flex-item-align:center!important;align-self:center!important;box-shadow:2px 2px 20px rgba(0,0,0,0.5)!important;height:100%!important;justify-self:center!important;max-height:initial!important;max-width:initial!important;min-height:initial!important;min-width:initial!important}amp-story[standalone].amp-notbuilt{min-height:1px!important}amp-story[standalone]:-webkit-full-screen{height:100vh!important;max-height:none!important;max-width:none!important}amp-story[standalone]:-ms-fullscreen{height:100vh!important;max-height:none!important;max-width:none!important}amp-story[standalone]:fullscreen{height:100vh!important;max-height:none!important;max-width:none!important}amp-story .amp-video-eq{height:14px!important;width:14px!important}amp-story .amp-video-eq .amp-video-eq-col{margin-right:2px!important}amp-story .amp-video-eq .amp-video-eq-col:last-child{margin-right:0!important}amp-story .amp-video-eq:not(.amp-video-eq-play){display:none!important}.i-amphtml-story-media-query-matcher,amp-story-page{bottom:0!important;height:auto!important;left:0!important;position:absolute!important;right:0!important;top:0!important;opacity:1!important;-ms-touch-action:none!important;touch-action:none!important;transition:none!important;z-index:0!important}.i-amphtml-story-media-query-matcher{height:inherit!important;width:inherit!important;border:0!important;z-index:-1!important}amp-story-page[active]{z-index:1!important}.i-amphtml-story-sidebar[open]{animation-timing-function:cubic-bezier(0.0,0.0,0.2,1)!important;animation-duration:0.3s!important;animation-name:i-amphtml-sidebar-slide-in-right}[desktop] .i-amphtml-story-sidebar{min-width:25%!important;max-width:600px!important}.i-amphtml-story-sidebar{min-width:75%!important;max-width:360px!important;animation-timing-function:cubic-bezier(0.4,0.0,1,1)!important;animation-duration:0.2s!important;animation-name:i-amphtml-sidebar-slide-out-right}amp-story-page:not(:first-of-type):not([distance]):not([active]),amp-story-page:not([active]){transform:translateY(1000vh)!important}amp-story-page[active],amp-story-page[distance=\"0\"],amp-story-page[distance=\"1\"]{transform:translateY(0)!important}amp-story-page[distance=\"2\"]{transform:translateY(100%)!important}amp-story-page [data-text-background-color]{border-radius:3px!important;line-height:1.5em!important;padding:2px 4px!important;text-indent:0!important;box-decoration-break:clone!important;-webkit-box-decoration-break:clone!important}[desktop].i-amphtml-story-bookend-active amp-story-page[active]{filter:blur(3px)!important;transition:filter 0.3s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-bookend-active amp-story-page[active]:after{content:\"\"!important;display:block!important;left:0!important;top:0!important;bottom:0!important;right:0!important;position:absolute!important;background:#000!important;z-index:2!important;animation:i-amphtml-bookend-overlay-opacity 0.3s cubic-bezier(0.0,0.0,0.2,1) forwards!important}@keyframes i-amphtml-bookend-overlay-opacity{0%{opacity:0}to{opacity:0.75}}.i-amphtml-story-opacity-mask{position:absolute!important;top:0!important;bottom:0!important;width:100%!important;height:100%!important;opacity:1!important;display:block!important;background-image:none!important;background-color:rgba(0,0,0,0.75)!important;visibility:visible;z-index:100003!important;transition:visibility 0.3s,opacity 0.3s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-opacity-mask[hidden]{opacity:0!important;pointer-events:none!important;display:block!important;visibility:hidden;transition:visibility 0.2s,opacity 0.2s cubic-bezier(0.4,0.0,1,1)!important}.i-amphtml-sidebar-mask{display:none!important}amp-story-cta-layer{display:block!important;top:80%!important;margin:0!important;z-index:3!important}amp-story-cta-layer,amp-story-grid-layer{position:absolute!important;right:0!important;bottom:0!important;left:0!important}amp-story-grid-layer{box-sizing:border-box!important;display:grid!important;top:0!important;z-index:2!important;pointer-events:none!important}amp-story-grid-layer amp-video:after{content:\"\"!important;position:absolute!important;height:100%!important;width:100%!important;top:0!important;left:0!important}.i-amphtml-story-grid-template-fill amp-img img,.i-amphtml-story-grid-template-fill amp-video video{position:absolute!important}amp-story-page[active]:not(.i-amphtml-layout) amp-video.i-amphtml-poolbound{display:none!important}amp-story-grid-layer>*{pointer-events:auto!important}amp-story-grid-layer a *{pointer-events:none!important}amp-story-grid-layer .i-amphtml-embedded-component:after{content:\"\"!important;position:absolute!important;height:100%!important;width:100%!important;top:0!important;left:0!important}.i-amphtml-expanded-mode .i-amphtml-embedded-component:after{height:0px!important;width:0px!important}.i-amphtml-expanded-mode amp-story-grid-layer,.i-amphtml-expanded-mode amp-story-grid-layer *{contain:none!important;z-index:auto!important}.i-amphtml-expanded-mode .i-amphtml-embedded-component.i-amphtml-expanded-component{z-index:1!important;transition:transform 0.225s cubic-bezier(0.4,0.0,0.2,1)!important}.i-amphtml-story-grid-template-with-full-bleed-animation{position:absolute!important;display:block!important;padding:0!important}.i-amphtml-story-grid-template-fill>*{bottom:0!important;height:auto!important;left:0!important;position:absolute!important;right:0!important;top:0!important;width:auto!important}.i-amphtml-story-grid-template-vertical{grid-auto-flow:row!important;grid-template-columns:100%!important}.i-amphtml-story-grid-template-horizontal{grid-auto-flow:column!important;grid-template-rows:100%!important}.i-amphtml-story-grid-template-thirds{height:100%!important;grid-template-rows:33% 33% 33%!important;grid-template-areas:\"upper-third\" \"middle-third\" \"lower-third\"!important}.i-amphtml-story-grid-template-aspect{margin:auto;width:var(--i-amphtml-story-layer-width,100%);height:var(--i-amphtml-story-layer-height,100%);font-size:calc(var(--i-amphtml-story-layer-height, 100vh)/10)}.i-amphtml-story-bookend-active .i-amphtml-story-dev-logs-button,.i-amphtml-story-dev-logs-button[data-count=\"0\"]{display:none!important}.i-amphtml-story-dev-logs-button{background-position:50%!important;background-repeat:no-repeat!important}.i-amphtml-story-dev-logs-button:after{background-color:#fff!important;border-radius:6px!important;box-sizing:border-box!important;color:#444;content:attr(data-count)!important;display:inline-block!important;font-family:Roboto!important;font-size:11px!important;height:12px!important;line-height:12px!important;padding:0 6px!important;position:absolute!important;right:0!important;top:6px!important}.i-amphtml-story-error-button{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23DB4437'%3E%3Cpath d='M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-warning-button{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFC107'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'/%3E%3C/svg%3E\")!important}.i-amphtml-story-success-button{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%230F9D58'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'/%3E%3C/svg%3E\")!important}amp-story[standalone] .i-amphtml-story-developer-log{background:rgba(0,0,0,0.85)!important;bottom:0!important;box-sizing:border-box!important;color:#fff!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;font-family:Roboto!important;left:0!important;max-height:45%!important;padding:0!important;position:fixed!important;right:0!important;text-align:start!important;z-index:100002!important}.i-amphtml-story-developer-log-header{-ms-flex-align:center!important;align-items:center!important;background:rgba(3,169,244,0.85)!important;display:-ms-flexbox!important;display:flex!important;font-weight:700!important;-ms-flex-pack:justify!important;justify-content:space-between!important;padding:12px 20px!important;text-align:center!important}.i-amphtml-story-developer-log-close,.i-amphtml-story-developer-log-header{-ms-flex-positive:0!important;flex-grow:0!important;-ms-flex-negative:0!important;flex-shrink:0!important}.i-amphtml-story-developer-log-close{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg fill='%23FFF' height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-developer-log-context{color:#000!important;font-family:Roboto Mono!important}.i-amphtml-story-developer-log-entries{list-style-type:none!important;margin:0!important;overflow-x:hidden!important;overflow-y:auto!important;padding:0!important}.i-amphtml-story-developer-log-entry{-ms-flex-align:center!important;align-items:center!important;border-bottom:1px solid hsla(0,0%,100%,0.5)!important;display:-ms-flexbox!important;display:flex!important;padding:20px!important}.i-amphtml-story-developer-log-entry:before{background-position:50%!important;background-repeat:no-repeat!important;background-size:cover!important;content:\"\";display:inline-block!important;-ms-flex-positive:0!important;flex-grow:0!important;-ms-flex-negative:0!important;flex-shrink:0!important;height:32px!important;margin-right:20px!important;width:32px!important}.i-amphtml-story-developer-log-entry-error:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23DB4437'%3E%3Cpath d='M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-developer-log-entry-warning:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFC107'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'/%3E%3C/svg%3E\")!important}.i-amphtml-story-developer-log-entry-success:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%230F9D58'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'/%3E%3C/svg%3E\")!important}.i-amphtml-story-toast{position:absolute!important;bottom:0!important;left:0!important;right:0!important;display:inline-block!important;padding:1.16em 1.33em!important;line-height:1.33!important;color:#fff!important;background:#212121!important;animation:toast 2.2s!important;animation-fill-mode:both!important;font-family:Roboto,sans-serif!important;font-weight:400!important;font-size:12px!important;max-width:640px!important;z-index:100004!important}@media (min-width:640px){.i-amphtml-story-toast{right:auto!important;font-size:14px!important;margin:0 auto 1.16em 1.16em!important;border-radius:6px}}@keyframes toast{0%{transform:translateY(100px);easing:cubic-bezier(0.0,0.0,0.2,1)}8%{transform:translateY(0)}92%{transform:translateY(0);easing:cubic-bezier(0.4,0.0,1,1)}to{transform:translateY(100px)}}.i-amphtml-story-copy-successful{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'/%3E%3C/svg%3E\")!important;background-repeat:no-repeat!important;background-size:16px 16px!important;padding-left:24px!important;color:#fff!important;display:-ms-flexbox!important;display:flex!important}.i-amphtml-story-copy-url{-ms-flex:1!important;flex:1!important;color:hsla(0,0%,100%,0.5)!important;margin-left:40px!important;text-overflow:ellipsis!important;overflow:hidden!important;white-space:nowrap!important}.i-amphtml-story-button-container{display:none!important}.i-amphtml-story-spinner,amp-story .amp-video-eq{right:12px!important;bottom:12px!important}[dir=rtl] .i-amphtml-story-spinner,[dir=rtl]amp-story .amp-video-eq{left:12px!important;right:auto!important}.i-amphtml-story-spinner{display:inline-block!important;position:absolute!important;width:24px!important;height:24px!important;z-index:10!important}.i-amphtml-story-spinner-container{width:100%!important;height:100%!important;direction:ltr!important}.i-amphtml-story-spinner[active] .i-amphtml-story-spinner-container{animation:container-rotate 1294ms linear infinite!important}@keyframes container-rotate{to{transform:rotate(360deg)}}.i-amphtml-story-spinner-layer{position:absolute!important;width:100%!important;height:100%!important;opacity:0!important;white-space:nowrap!important;color:#fff!important}.i-amphtml-story-spinner[active] .i-amphtml-story-spinner-layer{animation-name:fill-unfill-rotate!important;animation-duration:4400ms!important;animation-timing-function:cubic-bezier(0.4,0.0,0.2,1)!important;animation-iteration-count:infinite!important;opacity:1!important;filter:drop-shadow(0px 1px 3px rgba(0,0,0,0.25))!important}@keyframes fill-unfill-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}to{transform:rotate(1080deg)}}.i-amphtml-story-spinner-circle-clipper{display:inline-block!important;position:relative!important;width:50%!important;height:100%!important;overflow:hidden!important}.i-amphtml-story-spinner-layer:after{left:45%!important;width:10%!important;border-top-style:solid!important}.i-amphtml-story-spinner-circle-clipper:after,.i-amphtml-story-spinner-layer:after{content:\"\"!important;box-sizing:border-box!important;position:absolute!important;top:0!important;border-width:3px!important;border-radius:50%!important}.i-amphtml-story-spinner-circle-clipper:after{bottom:0!important;width:200%!important;border-style:solid!important;border-bottom-color:transparent!important}.i-amphtml-story-spinner-circle-clipper.left:after{left:0!important;border-right-color:transparent!important;transform:rotate(129deg)!important}.i-amphtml-story-spinner-circle-clipper.right:after{left:-100%!important;border-left-color:transparent!important;transform:rotate(-129deg)!important}.i-amphtml-story-spinner[active] .i-amphtml-story-spinner-circle-clipper:after{animation-duration:1100ms!important;animation-timing-function:cubic-bezier(0.4,0.0,0.2,1)!important;animation-iteration-count:infinite!important}.i-amphtml-story-spinner[active] .i-amphtml-story-spinner-circle-clipper.left:after{animation-name:left-spin!important}.i-amphtml-story-spinner[active] .i-amphtml-story-spinner-circle-clipper.right:after{animation-name:right-spin!important}@keyframes left-spin{0%{transform:rotate(130deg)}50%{transform:rotate(-5deg)}to{transform:rotate(130deg)}}@keyframes right-spin{0%{transform:rotate(-130deg)}50%{transform:rotate(5deg)}to{transform:rotate(-130deg)}}.i-amphtml-story-page-error,.i-amphtml-story-page-play-button{display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;position:absolute!important;bottom:0!important;right:0!important;height:40px!important;border:0!important;margin:8px 0 0 8px!important;padding:0!important;animation:play-button-fly-in 0.4s cubic-bezier(0.4,0.0,0.2,1)!important;background-color:transparent!important;z-index:10000!important}.i-amphtml-story-expanded-view-overflow{top:0!important;left:0!important;width:100%!important;height:100%!important;background-color:#000!important;position:absolute!important}.i-amphtml-expanded-view-close-button{position:absolute!important;top:0!important;left:0!important;margin:12px!important;height:24px!important;width:24px!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 36 36' fill='rgba(255, 255, 255, 0.8)'%3E%3Cpath d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'/%3E%3Cpath d='M0 0h36v36H0z' fill='none'/%3E%3C/svg%3E\")!important;cursor:pointer!important;text-align:center!important}@keyframes play-button-fly-in{0%{opacity:0;transform:translateX(12px)}to{opacity:1;transform:translateX(0)}}.i-amphtml-story-page-error[hidden],.i-amphtml-story-page-play-button[hidden]{display:none!important}.i-amphtml-story-page-error-label,.i-amphtml-story-page-play-label{color:#fff!important;font-family:Roboto,sans-serif!important;font-size:16px!important;text-shadow:0px 0px 6px rgba(0,0,0,0.36)!important}.i-amphtml-story-page-error-icon,.i-amphtml-story-page-play-icon{display:inline-block!important;height:24px!important;width:24px!important;margin:0 8px!important;border-radius:24px!important;filter:drop-shadow(0px 0px 6px rgba(0,0,0,0.36))!important}.i-amphtml-story-page-error-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'/%3E%3C/svg%3E\")!important}.i-amphtml-story-page-play-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 48 48' fill='%23FFF'%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3Cpath d='M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm-4 29V15l12 9-12 9z'/%3E%3C/svg%3E\")!important}.i-amphtml-story-interactive-component{-ms-flex-item-align:center;align-self:center;width:auto!important;height:auto!important;min-width:224px!important;max-width:400px!important;--interactive-accent-color:#005af0;--interactive-prompt-background:var(--interactive-accent-color);--interactive-prompt-text-color:#fff;--interactive-prompt-alignment:initial;--i-amphtml-interactive-option-accent-color:var(--interactive-accent-color)!important;--i-amphtml-interactive-option-background-color:#fff!important;--i-amphtml-interactive-option-text-color:#55595e!important;--i-amphtml-interactive-theme-border:rgba(85,89,94,0.2)!important;--i-amphtml-interactive-theme-shading:rgba(85,89,94,0.2)!important;--i-amphtml-interactive-theme-shading-flash:rgba(85,89,94,0.5)!important;--i-amphtml-interactive-chip-radius:32px!important;--i-amphtml-interactive-chip-shadow:0px 0px 0px transparent!important;--i-amphtml-interactive-chip-shadow-inset:inset 0px 0px 0px transparent!important;--i-amphtml-interactive-answer-choice-border:var(--interactive-accent-color)!important;--i-amphtml-interactive-answer-choice-background:#fff!important;--i-amphtml-interactive-prompt-text-size:22px!important;--i-amphtml-interactive-prompt-line-height:28px!important;--i-amphtml-interactive-strong-text-color:#000!important;--i-amphtml-interactive-animation-time:.3s!important;--i-amphtml-interactive-ease-out-curve:cubic-bezier(.3,0,0,1)!important;--i-amphtml-interactive-animation-delay:0s!important;--i-amphtml-interactive-component-shadow:0px 4px 12px rgba(60,64,67,0.08),0px 2px 4px rgba(60,64,67,0.12)}.i-amphtml-story-interactive-component[theme=dark]{--i-amphtml-interactive-option-text-color:#a7adb4!important;--i-amphtml-interactive-option-background-color:#202124!important;--i-amphtml-interactive-theme-border:rgba(167,173,180,0.2)!important;--i-amphtml-interactive-theme-shading:rgba(167,173,180,0.2)!important;--i-amphtml-interactive-theme-shading-flash:rgba(167,173,180,0.5)!important;--i-amphtml-interactive-strong-text-color:#fff!important}.i-amphtml-story-interactive-component[chip-style=shadow]{--i-amphtml-interactive-chip-shadow:0px 2px 8px rgba(60,60,60,0.2)!important;--i-amphtml-interactive-chip-shadow-inset:inset 4px 4px 8px rgba(0,0,0,0.2)!important;--i-amphtml-interactive-theme-border:transparent!important}.i-amphtml-story-interactive-component[chip-style=shadow][theme=dark]{--i-amphtml-interactive-chip-shadow:0px 2px 8px 0px rgba(0,0,0,0.6)!important;--i-amphtml-interactive-chip-shadow-inset:inset 4px 4px 8px rgba(0,0,0,0.4)!important}.i-amphtml-story-interactive-component[prompt-size=large]{--i-amphtml-interactive-prompt-text-size:28px!important;--i-amphtml-interactive-prompt-line-height:36px!important}.i-amphtml-story-interactive-component[prompt-size=small]{--i-amphtml-interactive-prompt-text-size:18px!important;--i-amphtml-interactive-prompt-line-height:24px!important}amp-story-interactive-binary-poll[theme=dark],amp-story-interactive-poll[theme=dark]{--i-amphtml-interactive-option-accent-color:#fff!important}amp-story-page.i-amphtml-story-desktop-panels .i-amphtml-story-interactive-component{--i-amphtml-interactive-animation-delay:350ms!important}.i-amphtml-story-screen-reader-back-button{width:10px!important;position:absolute!important;top:0!important;left:0!important;bottom:0!important;z-index:1!important;height:calc(100vh - 150px)!important;margin:auto 0!important;background:none!important;border:none!important}[dir=rtl]amp-story .i-amphtml-story-screen-reader-back-button{right:0!important}.i-amphtml-story-desktop-panels .i-amphtml-story-screen-reader-back-button,.i-amphtml-story-screen-reader-back-button-hidden{display:none!important}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story.css*/";
exports.CSS = CSS;

},{}],2:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ":host{all:initial!important;color:initial!important}.amp-social-share-facebook{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M211.9 197.4h-36.7v59.9h36.7v175.8h70.5V256.5h49.2l5.2-59.1h-54.4v-33.7c0-13.9 2.8-19.5 16.3-19.5h38.2V82.9h-48.8c-52.5 0-76.1 23.1-76.1 67.3-.1 38.6-.1 47.2-.1 47.2z'/%3E%3C/svg%3E\")}.amp-social-share-pinterest{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M266.6 76.5c-100.2 0-150.7 71.8-150.7 131.7 0 36.3 13.7 68.5 43.2 80.6 4.8 2 9.2.1 10.6-5.3 1-3.7 3.3-13 4.3-16.9 1.4-5.3.9-7.1-3-11.8-8.5-10-13.9-23-13.9-41.3 0-53.3 39.9-101 103.8-101 56.6 0 87.7 34.6 87.7 80.8 0 60.8-26.9 112.1-66.8 112.1-22.1 0-38.6-18.2-33.3-40.6 6.3-26.7 18.6-55.5 18.6-74.8 0-17.3-9.3-31.7-28.4-31.7-22.5 0-40.7 23.3-40.7 54.6 0 19.9 6.7 33.4 6.7 33.4s-23.1 97.8-27.1 114.9c-8.1 34.1-1.2 75.9-.6 80.1.3 2.5 3.6 3.1 5 1.2 2.1-2.7 28.9-35.9 38.1-69 2.6-9.4 14.8-58 14.8-58 7.3 14 28.7 26.3 51.5 26.3 67.8 0 113.8-61.8 113.8-144.5-.1-62.6-53.1-120.8-133.6-120.8z'/%3E%3C/svg%3E\")}.amp-social-share-linkedin{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M186.4 142.4c0 19-15.3 34.5-34.2 34.5-18.9 0-34.2-15.4-34.2-34.5 0-19 15.3-34.5 34.2-34.5 18.9 0 34.2 15.5 34.2 34.5zm-5 58.9h-57.8v186.8h57.8V201.3zm92.4 0h-55.4v186.8h55.4v-98c0-26.3 12.1-41.9 35.2-41.9 21.3 0 31.5 15 31.5 41.9v98H398V269.8c0-50-28.3-74.2-68-74.2-39.6 0-56.3 30.9-56.3 30.9v-25.2h.1z'/%3E%3C/svg%3E\")}.amp-social-share-gplus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M179.7 237.6v46.6h77c-3.1 20-23.3 58.7-77 58.7-46.3 0-84.1-38.5-84.1-85.9 0-47.4 37.8-85.9 84.1-85.9 26.4 0 44 11.3 54.1 21l36.8-35.5C247 134.4 216.4 121 179.7 121 104.7 121 44 181.8 44 257s60.7 136 135.7 136C258 393 310 337.8 310 260.1c0-8.9-1-15.7-2.1-22.5H179.7zm288.3-.9h-38.7V198h-38.6v38.7H352v38.6h38.7V314h38.6v-38.7H468'/%3E%3C/svg%3E\")}.amp-social-share-email{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M101.3 141.6v228.9h309.5V141.6H101.3zm274.4 26.2L256 259.3l-119.6-91.5h239.3zm-248.1 26.3l64.1 49.1-64.1 64.1V194.1zm.2 150.1l84.9-84.9 43.2 33.1 43-32.9 84.7 84.7H127.8zm256.6-36.4L320 243.4l64.4-49.3v113.7z'/%3E%3C/svg%3E\")}.amp-social-share-twitter{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h400v400H0z'/%3E%3Cpath fill='%23FFF' fill-rule='nonzero' d='M153.62 301.59c94.34 0 145.94-78.16 145.94-145.94 0-2.22 0-4.43-.15-6.63A104.36 104.36 0 00325 122.47a102.38 102.38 0 01-29.46 8.07 51.47 51.47 0 0022.55-28.37 102.79 102.79 0 01-32.57 12.45c-15.9-16.906-41.163-21.044-61.625-10.093-20.461 10.95-31.032 34.266-25.785 56.873A145.62 145.62 0 0192.4 107.81c-13.614 23.436-6.66 53.419 15.88 68.47A50.91 50.91 0 0185 169.86v.65c.007 24.416 17.218 45.445 41.15 50.28a51.21 51.21 0 01-23.16.88c6.72 20.894 25.976 35.208 47.92 35.62a102.92 102.92 0 01-63.7 22 104.41 104.41 0 01-12.21-.74 145.21 145.21 0 0078.62 23'/%3E%3C/g%3E%3C/svg%3E\")}.amp-social-share-tumblr{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M210.8 80.3c-2.3 18.3-6.4 33.4-12.4 45.2-6 11.9-13.9 22-23.9 30.5-9.9 8.5-21.8 14.9-35.7 19.5v50.6h38.9v124.5c0 16.2 1.7 28.6 5.1 37.1 3.4 8.5 9.5 16.6 18.3 24.2 8.8 7.6 19.4 13.4 31.9 17.5s26.8 6.1 43 6.1c14.3 0 27.6-1.4 39.9-4.3 12.3-2.9 26-7.9 41.2-15v-55.9c-17.8 11.7-35.7 17.5-53.7 17.5-10.1 0-19.1-2.4-27-7.1-5.9-3.5-10-8.2-12.2-14-2.2-5.8-3.3-19.1-3.3-39.7v-91.1h84.6v-55.8h-84.4v-90h-50.3z'/%3E%3C/svg%3E\")}.amp-social-share-whatsapp{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='46' height='46'%3E%3Cpath fill='%23FFF' d='M35.4 10.4C32 6.9 27.3 5 22.5 5 12.3 5 4.1 13.3 4.2 23.4c0 3.2.9 6.3 2.4 9.1L4 42l9.7-2.5c2.7 1.5 5.7 2.2 8.7 2.2 10.1 0 18.3-8.3 18.3-18.4 0-4.9-1.9-9.5-5.3-12.9zM22.5 38.6c-2.7 0-5.4-.7-7.7-2.1l-.6-.3-5.8 1.5L9.9 32l-.4-.6c-4.4-7.1-2.3-16.5 4.9-20.9 7.2-4.4 16.5-2.3 20.9 4.9 4.4 7.2 2.3 16.5-4.9 20.9-2.3 1.5-5.1 2.3-7.9 2.3zm8.8-11.1l-1.1-.5s-1.6-.7-2.6-1.2c-.1 0-.2-.1-.3-.1-.3 0-.5.1-.7.2 0 0-.1.1-1.5 1.7-.1.2-.3.3-.5.3h-.1c-.1 0-.3-.1-.4-.2l-.5-.2c-1.1-.5-2.1-1.1-2.9-1.9-.2-.2-.5-.4-.7-.6-.7-.7-1.4-1.5-1.9-2.4l-.1-.2c-.1-.1-.1-.2-.2-.4 0-.2 0-.4.1-.5 0 0 .4-.5.7-.8.2-.2.3-.5.5-.7.2-.3.3-.7.2-1-.1-.5-1.3-3.2-1.6-3.8-.2-.3-.4-.4-.7-.5h-1.1c-.2 0-.4.1-.6.1l-.1.1c-.2.1-.4.3-.6.4-.2.2-.3.4-.5.6-.7.9-1.1 2-1.1 3.1 0 .8.2 1.6.5 2.3l.1.3c.9 1.9 2.1 3.6 3.7 5.1l.4.4c.3.3.6.5.8.8 2.1 1.8 4.5 3.1 7.2 3.8.3.1.7.1 1 .2h1c.5 0 1.1-.2 1.5-.4.3-.2.5-.2.7-.4l.2-.2c.2-.2.4-.3.6-.5.2-.2.4-.4.5-.6.2-.4.3-.9.4-1.4v-.7s-.1-.1-.3-.2z'/%3E%3C/svg%3E\")}.amp-social-share-line{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 511.99'%3E%3Cpath d='M443.2 233.29c0-84.14-84.35-152.6-188-152.6s-188 68.46-188 152.6c0 75.43 66.9 138.61 157.26 150.55 6.13 1.32 14.46 4 16.57 9.27 1.89 4.76 1.24 12.2.61 17 0 0-2.21 13.26-2.69 16.09-.82 4.75-3.78 18.6 16.29 10.14s108.21-63.76 147.66-109.16c27.25-29.89 40.3-60.18 40.3-93.89zm-254.38 44.92a3.67 3.67 0 01-3.66 3.67h-52.69a3.6 3.6 0 01-2.53-1l-.06-.05v-.05a3.65 3.65 0 01-1-2.53v-81.96a3.66 3.66 0 013.66-3.66h13.19a3.66 3.66 0 013.66 3.66v65.07h35.84a3.66 3.66 0 013.66 3.66zm31.8 0a3.65 3.65 0 01-3.66 3.65h-13.2a3.65 3.65 0 01-3.66-3.65v-81.92a3.66 3.66 0 013.66-3.66H217a3.66 3.66 0 013.66 3.66zm90.78 0a3.65 3.65 0 01-3.66 3.65h-13.19a3.67 3.67 0 01-.94-.12h-.05l-.25-.08h-.11l-.18-.08-.17-.08-.11-.06-.22-.14a3.45 3.45 0 01-.93-.9L254 229.56v48.66a3.66 3.66 0 01-3.67 3.65H237.1a3.65 3.65 0 01-3.66-3.65v-81.93a3.66 3.66 0 013.66-3.66h13.86l.21.05h.13l.21.07h.12a1.31 1.31 0 01.21.08l.12.06.19.11a.41.41 0 01.11.07l.19.13.1.07.19.16.07.07a2.28 2.28 0 01.22.22 3.58 3.58 0 01.28.37L290.89 245v-48.71a3.66 3.66 0 013.66-3.66h13.19a3.66 3.66 0 013.66 3.66zm72.83-68.74a3.66 3.66 0 01-3.65 3.67h-35.84V227h35.84a3.66 3.66 0 013.65 3.67v13.19a3.65 3.65 0 01-3.65 3.66h-35.84v13.85h35.84a3.65 3.65 0 013.65 3.66v13.19a3.66 3.66 0 01-3.65 3.67h-52.7a3.66 3.66 0 01-2.53-1l-.05-.05a.12.12 0 01-.05-.05 3.65 3.65 0 01-1-2.53V196.3a3.6 3.6 0 011-2.52l.06-.07a3.63 3.63 0 012.54-1h52.7a3.66 3.66 0 013.65 3.67z' fill='%23fff' data-name='レイヤー 1'/%3E%3C/svg%3E\")}.amp-social-share-sms{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='30' height='29' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23FFF' stroke-width='3' d='M8.73 26v-5.658H2V2h25.97L28 20.355l-12.062.042z' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E\")}.amp-social-share-system{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg fill='%23fff' height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z'/%3E%3C/svg%3E\")}amp-social-share{background-repeat:no-repeat;background-position:50%;background-size:contain;text-decoration:none;cursor:pointer;position:relative}.amp-social-share-twitter{background-color:#1da1f2}.amp-social-share-facebook{background-color:#32529f}.amp-social-share-pinterest{background-color:#e60023}.amp-social-share-linkedin{background-color:#0077b5}.amp-social-share-gplus{background-color:#dc4e41}.amp-social-share-tumblr{background-color:#3c5a77}.amp-social-share-email{background-color:#000}.amp-social-share-whatsapp{background-color:#25d366}.amp-social-share-line{background-color:#52b448}.amp-social-share-sms{background-color:#ca2b63}.amp-social-share-system{background-color:#000}.i-amphtml-story-share-widget{display:block!important;margin:16px 8px!important}.i-amphtml-story-no-sharing .i-amphtml-story-share-widget{display:none!important}.i-amphtml-story-share-widget-scrollable{padding:16px 0!important;overflow:auto!important}.i-amphtml-story-bookend-fullbleed .i-amphtml-story-share-widget{margin-left:0!important;margin-right:0!important}.i-amphtml-story-share-widget::-webkit-scrollbar{width:0px!important;background:transparent!important}.i-amphtml-story-share-list{list-style:none!important;padding:0 8px!important;margin:0!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-wrap:wrap!important;flex-wrap:wrap!important;width:100%!important}.i-amphtml-story-bookend-fullbleed .i-amphtml-story-share-list{padding-left:16px!important;padding-right:16px!important}.i-amphtml-story-share-item{width:48px!important;height:66px!important;padding:0 16px!important;margin-bottom:12px!important}@media (max-width:410px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;min-width:60px!important;width:25%!important}}@media (min-width:410px) and (max-width:500px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;width:20%!important}}@media (min-width:500px) and (max-width:720px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;width:16.66%!important}}.i-amphtml-story-share-widget-scrollable .i-amphtml-story-share-list{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.i-amphtml-story-share-widget-scrollable>*>.i-amphtml-story-share-item{display:block!important;margin:0!important;padding:0 16px!important;min-width:auto!important}.i-amphtml-story-share-item:empty{display:none!important}.i-amphtml-story-share-icon{box-sizing:border-box!important;position:relative!important;width:48px!important;height:48px!important;display:block!important;cursor:pointer!important;border-radius:4px!important;overflow:visible!important;background-position:8px 8px!important;background-size:32px 32px!important;background-repeat:no-repeat!important}.i-amphtml-story-share-icon.amp-social-share-facebook{background-size:38px 38px!important;background-position:5px 5px!important}.i-amphtml-story-share-icon:active,.i-amphtml-story-share-icon:focus{outline:none!important;box-shadow:none!important}.i-amphtml-story-share-icon:active:before{background-color:#787878!important}.i-amphtml-story-share-icon[type=email]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon[type=system]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon-link{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon .i-amphtml-story-share-label{position:absolute!important;top:48px!important;left:0!important;width:100%!important;color:rgba(0,0,0,0.87)!important;padding-top:5px!important;text-transform:capitalize!important;font-family:Roboto,sans-serif!important;font-weight:400!important;line-height:13px!important;font-size:11px!important;text-align:center!important}.i-amphtml-story-bookend{display:-ms-flexbox!important;display:flex!important;font-family:Roboto,sans-serif!important;-ms-flex-direction:column!important;flex-direction:column!important;background:#202125!important;border-radius:8px 8px 0 0!important;color:#fff!important;text-align:start!important;z-index:100001!important}.i-amphtml-story-bookend-handle{height:4px!important;width:40px!important;margin:12px auto 24px!important;background:hsla(0,0%,100%,0.24)!important;border-radius:4px!important}.i-amphtml-story-bookend-heading{width:100%!important;text-transform:uppercase!important;font-size:12px!important;padding-bottom:8px!important;margin:0!important;border-bottom:1px solid hsla(0,0%,100%,0.25)!important;color:hsla(0,0%,100%,0.54)!important;font-weight:700!important;letter-spacing:0.83px!important;line-height:1.48!important;overflow:hidden!important}.i-amphtml-story-bookend-top-level{margin-left:24px!important;margin-right:24px!important}.i-amphtml-story-bookend-consent:last-child{margin-bottom:24px!important}.i-amphtml-story-bookend-consent .i-amphtml-story-bookend-heading{margin-left:0!important;margin-right:0!important}.i-amphtml-story-bookend-component-meta{font-weight:400!important;font-size:14px!important;text-overflow:ellipsis!important;overflow:hidden!important;white-space:nowrap!important;line-height:16px!important;color:hsla(0,0%,100%,0.6)!important;margin-top:8px!important}.i-amphtml-story-bookend-article{text-decoration:none!important;color:inherit!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:justify!important;justify-content:space-between!important;max-height:100px!important}.i-amphtml-story-bookend-article-text-content{width:100%!important;overflow:hidden!important;padding-right:10px!important}[dir=rtl] .i-amphtml-story-bookend-article-text-content{padding-right:0px!important;padding-left:10px!important}.i-amphtml-story-bookend-article-heading,.i-amphtml-story-bookend-consent-button,.i-amphtml-story-bookend-text{font-weight:400!important;font-size:16px!important;overflow:hidden!important;text-overflow:ellipsis!important;color:#fff!important;line-height:1.45em!important;max-height:4.35em!important;margin:0 0 8px!important}.i-amphtml-story-bookend-component{width:100%!important;margin-bottom:24px!important}.i-amphtml-story-bookend-landscape,.i-amphtml-story-bookend-portrait{box-sizing:border-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;text-decoration:none!important;color:inherit!important;overflow:hidden!important}@media (min-width:640px){.i-amphtml-story-bookend-component-set{display:-ms-flexbox!important;display:flex!important;-ms-flex-wrap:wrap!important;flex-wrap:wrap!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.i-amphtml-story-bookend-component:not(.i-amphtml-story-bookend-heading){width:calc(50% - 12px)!important}}@media (min-width:960px){.i-amphtml-story-bookend-component:not(.i-amphtml-story-bookend-heading){width:calc(33% - 16px)!important}}.i-amphtml-story-bookend-text{font-size:14px!important}.i-amphtml-story-bookend-component-category{margin-top:0px!important;margin-bottom:8px!important;font-weight:400!important;font-size:12px!important;text-transform:uppercase!important;text-overflow:ellipsis!important;overflow:hidden!important;white-space:nowrap!important;width:100%!important;color:#fff!important;letter-spacing:0.5px!important;line-height:1.48!important}.i-amphtml-story-bookend-article-image,.i-amphtml-story-bookend-replay-image{width:100px!important;height:100px!important;border-radius:8px!important;overflow:hidden!important}@media (max-width:376px){.i-amphtml-story-bookend-landscape-image,.i-amphtml-story-bookend-portrait-image{width:100%!important}}.i-amphtml-story-bookend-article-image>img,.i-amphtml-story-bookend-landscape-image>img,.i-amphtml-story-bookend-portrait-image>img{-o-object-fit:cover!important;object-fit:cover!important;width:100%!important;height:100%!important}.i-amphtml-story-bookend-landscape-image,.i-amphtml-story-bookend-portrait-image{width:100%!important;position:relative!important;border-radius:8px!important;overflow:hidden!important}.i-amphtml-story-bookend-portrait-image{padding-bottom:125%!important}.i-amphtml-story-bookend-landscape-image{padding-bottom:75%!important}.i-amphtml-story-bookend-landscape-image>img,.i-amphtml-story-bookend-portrait-image>img{position:absolute!important}.i-amphtml-story-bookend-replay-image{background-position:50%!important;background-size:cover!important}.i-amphtml-story-bookend-article-image,.i-amphtml-story-bookend-replay-icon,.i-amphtml-story-bookend-replay-image{position:relative!important;-ms-flex:none!important;flex:none!important}.i-amphtml-story-bookend-replay{overflow:hidden!important;display:-ms-flexbox!important;display:flex!important;max-height:120px!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.i-amphtml-story-bookend-replay-icon{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\") 50% no-repeat!important}.i-amphtml-story-bookend-replay-image>.i-amphtml-story-bookend-replay-icon{width:100%!important;height:100%!important;background-color:rgba(0,0,0,0.3)!important;position:absolute!important;margin-left:0!important}.i-amphtml-story-bookend-replay>.i-amphtml-story-bookend-replay-icon{width:48px!important;height:48px!important;background-color:rgba(60,60,60,0.5)!important;position:static!important;border-radius:4px!important}.i-amphtml-story-bookend-component-set{margin-bottom:24px!important}.i-amphtml-story-bookend-cta-link-wrapper,.i-amphtml-story-bookend-textbox{display:-ms-flexbox!important;display:flex!important;-ms-flex-wrap:wrap!important;flex-wrap:wrap!important;box-sizing:border-box!important;color:inherit!important;overflow:hidden!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.i-amphtml-story-bookend-textbox{-ms-flex-direction:column;flex-direction:column}.i-amphtml-story-bookend-cta-link{background-color:hsla(0,0%,100%,0.15)!important;border-radius:100px!important;height:40px!important;overflow:hidden!important;text-decoration:none!important;width:calc(50% - 6px)!important;cursor:pointer!important;margin-bottom:12px!important}.i-amphtml-story-bookend-cta-link:nth-child(odd):last-child{width:100%!important}.i-amphtml-story-bookend-cta-link-text{color:#fff!important;text-transform:uppercase!important;text-align:center!important;font-size:13px!important;font-weight:700!important;line-height:40px!important;padding:0 24px!important;text-overflow:ellipsis!important;overflow:hidden!important;white-space:nowrap!important}.i-amphtml-story-bookend .i-amphtml-story-share-widget{margin-left:0!important;margin-right:0!important}.i-amphtml-story-bookend .i-amphtml-story-share-list{padding-left:16px!important;padding-right:16px!important}.i-amphtml-story-bookend .i-amphtml-story-share-item .i-amphtml-story-share-icon{background-color:hsla(0,0%,100%,0.15)!important}.i-amphtml-story-bookend .i-amphtml-story-share-icon .i-amphtml-story-share-label{color:#fff!important}[desktop].i-amphtml-story-bookend{box-sizing:border-box!important;min-height:100vh!important;padding:104px 156px 64px!important;margin:0!important}[desktop] .i-amphtml-story-bookend-handle,[desktop] .i-amphtml-story-bookend-replay,[desktop].i-amphtml-story-bookend .i-amphtml-story-share-widget{display:none!important}@media (min-width:952px){[desktop] .i-amphtml-story-bookend-component:not(.i-amphtml-story-bookend-heading){width:calc(50% - 12px)!important}}@media (min-width:1272px){[desktop] .i-amphtml-story-bookend-component:not(.i-amphtml-story-bookend-heading){width:calc(33% - 16px)!important}}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-bookend.css*/";
exports.CSS = CSS;

},{}],3:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ":host{all:initial!important;color:initial!important}.i-amphtml-story-consent{display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;z-index:100005!important}.i-amphtml-story-consent,.i-amphtml-story-consent:before{position:absolute!important;top:0!important;left:0!important;height:100%!important;width:100%!important}.i-amphtml-story-consent:before{content:\"\"!important;background:#000!important;opacity:0.55!important}.i-amphtml-story-consent-overflow{margin-top:auto!important;overflow-y:auto!important;overflow-x:hidden!important;-webkit-overflow-scrolling:touch!important}.i-amphtml-story-consent-container{position:relative!important;margin:88px 0 72px!important;background:#fff!important;border-radius:8px 8px 0 0!important;color:rgba(0,0,0,0.87)!important;font-family:Roboto,sans-serif!important;text-align:start!important;overflow:hidden!important}.i-amphtml-story-consent-header{position:relative!important;height:80px!important;min-height:80px!important;background:var(--primary-color,#f0f0f0)!important;z-index:2!important}.i-amphtml-story-consent-logo{position:absolute!important;bottom:-32px!important;margin-left:-32px!important;left:50%!important;height:64px!important;width:64px!important;background:#f0f0f0!important;background-position:50%!important;background-repeat:no-repeat!important;background-size:contain!important;border-radius:5px!important}.i-amphtml-story-consent-logo:before{content:\"\"!important;position:absolute!important;top:-6px!important;bottom:-6px!important;left:-6px!important;right:-6px!important;background:#fff!important;border-radius:6px!important;box-shadow:0 2px 3px rgba(0,0,0,0.12)!important;z-index:-1!important}.i-amphtml-story-consent-content{padding:42px 16px 16px!important;font-size:14px!important;z-index:0!important}.i-amphtml-story-consent-vendors{margin:0!important;padding:0!important;list-style:none!important}.i-amphtml-story-consent-vendor{height:40px!important;border-bottom:1px solid #f0f0f0!important;line-height:40px!important;text-overflow:ellipsis!important;overflow:hidden!important}.i-amphtml-story-consent-external-link{position:relative!important;display:inline-block!important;margin:24px 0!important;color:rgba(0,0,0,0.87)!important;font-size:15px!important;font-weight:700!important;text-decoration:none!important}.i-amphtml-story-consent-external-link:hover{text-decoration:underline!important}.i-amphtml-story-consent-external-link:after{content:\"\"!important;position:absolute!important;display:block!important;height:16px!important;width:16px!important;top:3px!important;right:-20px!important;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='rgba(0, 0, 0, 0.87)'%3E%3Cpath d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\") 50% no-repeat!important}.i-amphtml-story-consent-external-link.i-amphtml-hidden{display:none!important}.i-amphtml-story-consent-actions{position:absolute!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;-ms-flex-align:center!important;align-items:center!important;bottom:0!important;left:0!important;right:0!important;height:72px!important;min-height:72px!important;background:#fff!important;box-shadow:0 -2px 3px rgba(0,0,0,0.12)!important;z-index:1!important}.i-amphtml-story-consent-action{position:relative!important;padding:0 24px!important;margin:0 12px!important;height:40px!important;width:40vw!important;background:#fff!important;border:none!important;border-radius:40px!important;box-sizing:border-box!important;cursor:pointer!important;font-size:13px!important;font-weight:700!important;line-height:40px!important;text-align:center!important;text-transform:uppercase!important}.i-amphtml-story-consent-action.i-amphtml-hidden{display:none!important}.i-amphtml-story-consent-action-accept{background:var(--primary-color,#000)!important;color:#fff!important}.i-amphtml-story-consent-action-reject{border:1px solid #000!important}@media (min-width:420px){.i-amphtml-story-consent{-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important}.i-amphtml-story-consent-overflow{margin-top:0!important}.i-amphtml-story-consent-container{display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;margin:0!important;max-height:60vh!important;min-height:40vh!important;width:calc(100vw - 80px)!important;max-width:800px!important}.i-amphtml-story-consent-content{margin:0 auto!important;max-width:424px!important;-ms-flex-positive:1!important;flex-grow:1!important;overflow-y:auto!important}.i-amphtml-story-consent-content::-webkit-scrollbar{width:0px!important;background:transparent!important}.i-amphtml-story-consent-actions{position:relative!important;left:0px!important;right:0px!important}.i-amphtml-story-consent-action{width:33vw!important;max-width:200px!important}}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-consent.css*/";
exports.CSS = CSS;

},{}],4:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ":host{all:initial!important;color:initial!important}.i-amphtml-story-draggable-drawer-header{display:-ms-flexbox!important;display:flex!important;position:relative!important;height:40px!important;background:#fff!important;border-radius:8px 8px 0 0!important;box-shadow:0 1px 2px 1px rgba(0,0,0,0.12)!important;z-index:1!important}.i-amphtml-story-draggable-drawer-theme-dark{background:#202125!important}.i-amphtml-story-page-attachment-close-button{display:block!important;padding:8px!important;height:24px!important;width:24px!important;background-origin:content-box!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 36 36' fill='rgba(0, 0, 0, 0.54)'%3E%3Cpath d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'/%3E%3Cpath d='M0 0h36v36H0z' fill='none'/%3E%3C/svg%3E\")!important;background-repeat:no-repeat!important;color:rgba(0,0,0,0.87)!important;cursor:pointer!important}.i-amphtml-story-draggable-drawer-theme-dark .i-amphtml-story-page-attachment-close-button{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 36 36' fill='rgba(255, 255, 255, 0.54)'%3E%3Cpath d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'/%3E%3Cpath d='M0 0h36v36H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-page-attachment-title{font-family:Roboto,sans-serif!important;width:calc(100% - 80px)!important;padding-right:40px!important;color:rgba(0,0,0,0.87)!important;font-size:16px!important;line-height:40px!important;overflow:hidden!important;text-align:center!important;text-overflow:ellipsis!important;white-space:nowrap!important}.i-amphtml-story-draggable-drawer-theme-dark .i-amphtml-story-page-attachment-close-button,.i-amphtml-story-draggable-drawer-theme-dark .i-amphtml-story-page-attachment-title{color:#9aa0a6!important}.i-amphtml-story-draggable-drawer-header-attachment-remote,.i-amphtml-story-draggable-drawer-header-bookend{display:none!important}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-draggable-drawer-header.css*/";
exports.CSS = CSS;

},{}],5:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ".i-amphtml-story-hint-container{transition-property:opacity!important;transition-duration:200ms!important;contain:strict!important;pointer-events:none!important;position:absolute!important;left:0!important;top:0!important;right:0!important;bottom:0!important;z-index:2!important}.i-amphtml-story-hint-container.i-amphtml-hidden{opacity:0!important}.i-amphtml-story-hint-container .i-amphtml-story-navigation-help-overlay{position:absolute!important;left:0!important;top:0!important;right:0!important;bottom:0!important;background:rgba(0,0,0,0.7)!important;-ms-flex-direction:row!important;flex-direction:row!important;color:#fff!important;font-size:20px!important;padding:16px 0!important}.i-amphtml-story-navigation-help-section{position:relative!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important}.prev-page,[dir=rtl].prev-page{-ms-flex:1!important;flex:1!important}.show-first-page-overlay .i-amphtml-story-navigation-help-overlay{background:transparent!important}.show-first-page-overlay .prev-page{background:linear-gradient(90deg,rgba(0,0,0,0.5),transparent)!important}[dir=rtl].show-first-page-overlay .prev-page{background:linear-gradient(270deg,rgba(0,0,0,0.5),transparent)!important}.show-first-page-overlay .next-page{opacity:0!important}.show-first-page-overlay .i-amphtml-story-hint-placeholder{display:none!important}.show-first-page-overlay .i-amphtml-story-navigation-help-overlay{padding:0px!important}.i-amphtml-story-hint-container .next-page{-ms-flex:3!important;flex:3!important;background-image:linear-gradient(#e0d5d5 60%,hsla(0,0%,100%,0) 0)!important;background-position:0!important;background-size:1px 15px!important;background-repeat:repeat-y!important}[dir=rtl].i-amphtml-story-hint-container .next-page{border-left:none!important;background-position:100%!important}.show-first-page-overlay .i-amphtml-story-navigation-help-overlay,.show-navigation-overlay .i-amphtml-story-navigation-help-overlay{display:-ms-flexbox!important;display:flex!important}.show-first-page-overlay .prev-page .i-amphtml-story-hint-tap-button{visibility:hidden}.show-navigation-overlay .prev-page .i-amphtml-story-hint-tap-button-icon:before{content:\"\"!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'%3E%3Cpath d='M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important;width:30px!important;height:30px!important;display:inline-block!important}[dir=rtl].show-navigation-overlay .prev-page .i-amphtml-story-hint-tap-button-icon:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'%3E%3Cpath d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-hint-container .i-amphtml-story-hint-tap-button{position:relative!important;width:44px!important;height:44px!important}.i-amphtml-story-hint-tap-button:after,.i-amphtml-story-hint-tap-button:before{position:absolute!important;content:\"\"!important;width:44px!important;height:44px!important;border-radius:50%!important;background-color:hsla(0,0%,100%,0.5)!important;left:0!important;right:0!important}.i-amphtml-story-hint-tap-button:before{animation:expandingBubble 1000ms cubic-bezier(0.4,0,0.2,1) infinite!important}.i-amphtml-story-hint-tap-button:after{background-color:#fff!important}.i-amphtml-story-hint-container .i-amphtml-story-hint-tap-button-icon{position:absolute!important;z-index:1!important;height:44px!important;width:44px!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;-ms-flex-align:center!important;align-items:center!important}.i-amphtml-story-hint-tap-button-icon:after,.i-amphtml-story-hint-tap-button-icon:before{vertical-align:middle!important;margin:0 2px!important;background-position:50%}.next-page .i-amphtml-story-hint-tap-button-icon:after{content:\"\"!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'%3E%3Cpath d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important;width:24px!important;height:24px!important;display:inline-block!important}[dir=rtl] .next-page .i-amphtml-story-hint-tap-button-icon:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 24 24'%3E%3Cpath d='M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-hint-placeholder{top:50%!important;position:absolute!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;-ms-flex-align:center!important;align-items:center!important}.i-amphtml-story-hint-container .i-amphtml-story-hint-tap-button-text{color:#fff!important;font-size:16px!important;font-family:Roboto-Medium,sans-serif!important;margin-top:24px!important;text-align:center!important;word-break:break-word!important;padding:0 6px!important}@keyframes expandingBubble{0%{transform:scale(1);opacity:0}50%{transform:scale(1.5);opacity:1}to{transform:scale(1);opacity:0}}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-hint.css*/";
exports.CSS = CSS;

},{}],6:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ":host{all:initial!important;color:initial!important}.amp-social-share-facebook{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M211.9 197.4h-36.7v59.9h36.7v175.8h70.5V256.5h49.2l5.2-59.1h-54.4v-33.7c0-13.9 2.8-19.5 16.3-19.5h38.2V82.9h-48.8c-52.5 0-76.1 23.1-76.1 67.3-.1 38.6-.1 47.2-.1 47.2z'/%3E%3C/svg%3E\")}.amp-social-share-pinterest{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M266.6 76.5c-100.2 0-150.7 71.8-150.7 131.7 0 36.3 13.7 68.5 43.2 80.6 4.8 2 9.2.1 10.6-5.3 1-3.7 3.3-13 4.3-16.9 1.4-5.3.9-7.1-3-11.8-8.5-10-13.9-23-13.9-41.3 0-53.3 39.9-101 103.8-101 56.6 0 87.7 34.6 87.7 80.8 0 60.8-26.9 112.1-66.8 112.1-22.1 0-38.6-18.2-33.3-40.6 6.3-26.7 18.6-55.5 18.6-74.8 0-17.3-9.3-31.7-28.4-31.7-22.5 0-40.7 23.3-40.7 54.6 0 19.9 6.7 33.4 6.7 33.4s-23.1 97.8-27.1 114.9c-8.1 34.1-1.2 75.9-.6 80.1.3 2.5 3.6 3.1 5 1.2 2.1-2.7 28.9-35.9 38.1-69 2.6-9.4 14.8-58 14.8-58 7.3 14 28.7 26.3 51.5 26.3 67.8 0 113.8-61.8 113.8-144.5-.1-62.6-53.1-120.8-133.6-120.8z'/%3E%3C/svg%3E\")}.amp-social-share-linkedin{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M186.4 142.4c0 19-15.3 34.5-34.2 34.5-18.9 0-34.2-15.4-34.2-34.5 0-19 15.3-34.5 34.2-34.5 18.9 0 34.2 15.5 34.2 34.5zm-5 58.9h-57.8v186.8h57.8V201.3zm92.4 0h-55.4v186.8h55.4v-98c0-26.3 12.1-41.9 35.2-41.9 21.3 0 31.5 15 31.5 41.9v98H398V269.8c0-50-28.3-74.2-68-74.2-39.6 0-56.3 30.9-56.3 30.9v-25.2h.1z'/%3E%3C/svg%3E\")}.amp-social-share-gplus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M179.7 237.6v46.6h77c-3.1 20-23.3 58.7-77 58.7-46.3 0-84.1-38.5-84.1-85.9 0-47.4 37.8-85.9 84.1-85.9 26.4 0 44 11.3 54.1 21l36.8-35.5C247 134.4 216.4 121 179.7 121 104.7 121 44 181.8 44 257s60.7 136 135.7 136C258 393 310 337.8 310 260.1c0-8.9-1-15.7-2.1-22.5H179.7zm288.3-.9h-38.7V198h-38.6v38.7H352v38.6h38.7V314h38.6v-38.7H468'/%3E%3C/svg%3E\")}.amp-social-share-email{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M101.3 141.6v228.9h309.5V141.6H101.3zm274.4 26.2L256 259.3l-119.6-91.5h239.3zm-248.1 26.3l64.1 49.1-64.1 64.1V194.1zm.2 150.1l84.9-84.9 43.2 33.1 43-32.9 84.7 84.7H127.8zm256.6-36.4L320 243.4l64.4-49.3v113.7z'/%3E%3C/svg%3E\")}.amp-social-share-twitter{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h400v400H0z'/%3E%3Cpath fill='%23FFF' fill-rule='nonzero' d='M153.62 301.59c94.34 0 145.94-78.16 145.94-145.94 0-2.22 0-4.43-.15-6.63A104.36 104.36 0 00325 122.47a102.38 102.38 0 01-29.46 8.07 51.47 51.47 0 0022.55-28.37 102.79 102.79 0 01-32.57 12.45c-15.9-16.906-41.163-21.044-61.625-10.093-20.461 10.95-31.032 34.266-25.785 56.873A145.62 145.62 0 0192.4 107.81c-13.614 23.436-6.66 53.419 15.88 68.47A50.91 50.91 0 0185 169.86v.65c.007 24.416 17.218 45.445 41.15 50.28a51.21 51.21 0 01-23.16.88c6.72 20.894 25.976 35.208 47.92 35.62a102.92 102.92 0 01-63.7 22 104.41 104.41 0 01-12.21-.74 145.21 145.21 0 0078.62 23'/%3E%3C/g%3E%3C/svg%3E\")}.amp-social-share-tumblr{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M210.8 80.3c-2.3 18.3-6.4 33.4-12.4 45.2-6 11.9-13.9 22-23.9 30.5-9.9 8.5-21.8 14.9-35.7 19.5v50.6h38.9v124.5c0 16.2 1.7 28.6 5.1 37.1 3.4 8.5 9.5 16.6 18.3 24.2 8.8 7.6 19.4 13.4 31.9 17.5s26.8 6.1 43 6.1c14.3 0 27.6-1.4 39.9-4.3 12.3-2.9 26-7.9 41.2-15v-55.9c-17.8 11.7-35.7 17.5-53.7 17.5-10.1 0-19.1-2.4-27-7.1-5.9-3.5-10-8.2-12.2-14-2.2-5.8-3.3-19.1-3.3-39.7v-91.1h84.6v-55.8h-84.4v-90h-50.3z'/%3E%3C/svg%3E\")}.amp-social-share-whatsapp{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='46' height='46'%3E%3Cpath fill='%23FFF' d='M35.4 10.4C32 6.9 27.3 5 22.5 5 12.3 5 4.1 13.3 4.2 23.4c0 3.2.9 6.3 2.4 9.1L4 42l9.7-2.5c2.7 1.5 5.7 2.2 8.7 2.2 10.1 0 18.3-8.3 18.3-18.4 0-4.9-1.9-9.5-5.3-12.9zM22.5 38.6c-2.7 0-5.4-.7-7.7-2.1l-.6-.3-5.8 1.5L9.9 32l-.4-.6c-4.4-7.1-2.3-16.5 4.9-20.9 7.2-4.4 16.5-2.3 20.9 4.9 4.4 7.2 2.3 16.5-4.9 20.9-2.3 1.5-5.1 2.3-7.9 2.3zm8.8-11.1l-1.1-.5s-1.6-.7-2.6-1.2c-.1 0-.2-.1-.3-.1-.3 0-.5.1-.7.2 0 0-.1.1-1.5 1.7-.1.2-.3.3-.5.3h-.1c-.1 0-.3-.1-.4-.2l-.5-.2c-1.1-.5-2.1-1.1-2.9-1.9-.2-.2-.5-.4-.7-.6-.7-.7-1.4-1.5-1.9-2.4l-.1-.2c-.1-.1-.1-.2-.2-.4 0-.2 0-.4.1-.5 0 0 .4-.5.7-.8.2-.2.3-.5.5-.7.2-.3.3-.7.2-1-.1-.5-1.3-3.2-1.6-3.8-.2-.3-.4-.4-.7-.5h-1.1c-.2 0-.4.1-.6.1l-.1.1c-.2.1-.4.3-.6.4-.2.2-.3.4-.5.6-.7.9-1.1 2-1.1 3.1 0 .8.2 1.6.5 2.3l.1.3c.9 1.9 2.1 3.6 3.7 5.1l.4.4c.3.3.6.5.8.8 2.1 1.8 4.5 3.1 7.2 3.8.3.1.7.1 1 .2h1c.5 0 1.1-.2 1.5-.4.3-.2.5-.2.7-.4l.2-.2c.2-.2.4-.3.6-.5.2-.2.4-.4.5-.6.2-.4.3-.9.4-1.4v-.7s-.1-.1-.3-.2z'/%3E%3C/svg%3E\")}.amp-social-share-line{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 511.99'%3E%3Cpath d='M443.2 233.29c0-84.14-84.35-152.6-188-152.6s-188 68.46-188 152.6c0 75.43 66.9 138.61 157.26 150.55 6.13 1.32 14.46 4 16.57 9.27 1.89 4.76 1.24 12.2.61 17 0 0-2.21 13.26-2.69 16.09-.82 4.75-3.78 18.6 16.29 10.14s108.21-63.76 147.66-109.16c27.25-29.89 40.3-60.18 40.3-93.89zm-254.38 44.92a3.67 3.67 0 01-3.66 3.67h-52.69a3.6 3.6 0 01-2.53-1l-.06-.05v-.05a3.65 3.65 0 01-1-2.53v-81.96a3.66 3.66 0 013.66-3.66h13.19a3.66 3.66 0 013.66 3.66v65.07h35.84a3.66 3.66 0 013.66 3.66zm31.8 0a3.65 3.65 0 01-3.66 3.65h-13.2a3.65 3.65 0 01-3.66-3.65v-81.92a3.66 3.66 0 013.66-3.66H217a3.66 3.66 0 013.66 3.66zm90.78 0a3.65 3.65 0 01-3.66 3.65h-13.19a3.67 3.67 0 01-.94-.12h-.05l-.25-.08h-.11l-.18-.08-.17-.08-.11-.06-.22-.14a3.45 3.45 0 01-.93-.9L254 229.56v48.66a3.66 3.66 0 01-3.67 3.65H237.1a3.65 3.65 0 01-3.66-3.65v-81.93a3.66 3.66 0 013.66-3.66h13.86l.21.05h.13l.21.07h.12a1.31 1.31 0 01.21.08l.12.06.19.11a.41.41 0 01.11.07l.19.13.1.07.19.16.07.07a2.28 2.28 0 01.22.22 3.58 3.58 0 01.28.37L290.89 245v-48.71a3.66 3.66 0 013.66-3.66h13.19a3.66 3.66 0 013.66 3.66zm72.83-68.74a3.66 3.66 0 01-3.65 3.67h-35.84V227h35.84a3.66 3.66 0 013.65 3.67v13.19a3.65 3.65 0 01-3.65 3.66h-35.84v13.85h35.84a3.65 3.65 0 013.65 3.66v13.19a3.66 3.66 0 01-3.65 3.67h-52.7a3.66 3.66 0 01-2.53-1l-.05-.05a.12.12 0 01-.05-.05 3.65 3.65 0 01-1-2.53V196.3a3.6 3.6 0 011-2.52l.06-.07a3.63 3.63 0 012.54-1h52.7a3.66 3.66 0 013.65 3.67z' fill='%23fff' data-name='レイヤー 1'/%3E%3C/svg%3E\")}.amp-social-share-sms{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='30' height='29' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23FFF' stroke-width='3' d='M8.73 26v-5.658H2V2h25.97L28 20.355l-12.062.042z' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E\")}.amp-social-share-system{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg fill='%23fff' height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z'/%3E%3C/svg%3E\")}amp-social-share{background-repeat:no-repeat;background-position:50%;background-size:contain;text-decoration:none;cursor:pointer;position:relative}.amp-social-share-twitter{background-color:#1da1f2}.amp-social-share-facebook{background-color:#32529f}.amp-social-share-pinterest{background-color:#e60023}.amp-social-share-linkedin{background-color:#0077b5}.amp-social-share-gplus{background-color:#dc4e41}.amp-social-share-tumblr{background-color:#3c5a77}.amp-social-share-email{background-color:#000}.amp-social-share-whatsapp{background-color:#25d366}.amp-social-share-line{background-color:#52b448}.amp-social-share-sms{background-color:#ca2b63}.amp-social-share-system{background-color:#000}.i-amphtml-story-share-widget{display:block!important;margin:16px 8px!important}.i-amphtml-story-no-sharing .i-amphtml-story-share-widget{display:none!important}.i-amphtml-story-share-widget-scrollable{padding:16px 0!important;overflow:auto!important}.i-amphtml-story-bookend-fullbleed .i-amphtml-story-share-widget{margin-left:0!important;margin-right:0!important}.i-amphtml-story-share-widget::-webkit-scrollbar{width:0px!important;background:transparent!important}.i-amphtml-story-share-list{list-style:none!important;padding:0 8px!important;margin:0!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-wrap:wrap!important;flex-wrap:wrap!important;width:100%!important}.i-amphtml-story-bookend-fullbleed .i-amphtml-story-share-list{padding-left:16px!important;padding-right:16px!important}.i-amphtml-story-share-item{width:48px!important;height:66px!important;padding:0 16px!important;margin-bottom:12px!important}@media (max-width:410px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;min-width:60px!important;width:25%!important}}@media (min-width:410px) and (max-width:500px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;width:20%!important}}@media (min-width:500px) and (max-width:720px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;width:16.66%!important}}.i-amphtml-story-share-widget-scrollable .i-amphtml-story-share-list{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.i-amphtml-story-share-widget-scrollable>*>.i-amphtml-story-share-item{display:block!important;margin:0!important;padding:0 16px!important;min-width:auto!important}.i-amphtml-story-share-item:empty{display:none!important}.i-amphtml-story-share-icon{box-sizing:border-box!important;position:relative!important;width:48px!important;height:48px!important;display:block!important;cursor:pointer!important;border-radius:4px!important;overflow:visible!important;background-position:8px 8px!important;background-size:32px 32px!important;background-repeat:no-repeat!important}.i-amphtml-story-share-icon.amp-social-share-facebook{background-size:38px 38px!important;background-position:5px 5px!important}.i-amphtml-story-share-icon:active,.i-amphtml-story-share-icon:focus{outline:none!important;box-shadow:none!important}.i-amphtml-story-share-icon:active:before{background-color:#787878!important}.i-amphtml-story-share-icon[type=email]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon[type=system]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon-link{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon .i-amphtml-story-share-label{position:absolute!important;top:48px!important;left:0!important;width:100%!important;color:rgba(0,0,0,0.87)!important;padding-top:5px!important;text-transform:capitalize!important;font-family:Roboto,sans-serif!important;font-weight:400!important;line-height:13px!important;font-size:11px!important;text-align:center!important}.i-amphtml-story-info-dialog{position:absolute!important;top:0!important;left:0!important;height:100%!important;width:100%!important;z-index:100001!important;transform:translate3d(0,-100%,0)!important;transition-delay:0.15s!important}.i-amphtml-story-info-dialog-visible{transform:translateZ(0)!important;transition-delay:0s!important}.i-amphtml-story-info-dialog:before{content:\"\"!important;position:absolute!important;top:0!important;left:0!important;height:100%!important;width:100%!important;background:#000!important;opacity:0!important;transition:opacity 0.15s cubic-bezier(0.4,0.0,1,1)!important}.i-amphtml-story-info-dialog.i-amphtml-story-info-dialog-visible:before{opacity:0.55!important;transition:opacity 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-info-dialog-container{position:absolute!important;top:0!important;left:0!important;right:0!important;height:auto!important;background:#fff!important;border-radius:0 0 8px 8px!important;transform:translate3d(0,-100%,0)!important;transition:transform 0.15s cubic-bezier(0.4,0.0,1,1)!important;padding:20px!important;font-family:Roboto,sans-serif!important}.i-amphtml-story-info-dialog-visible .i-amphtml-story-info-dialog-container{transform:translateZ(0)!important;transition:transform 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-info-heading{display:block!important;font-size:14px!important;font-weight:700!important;margin:0 0 8px!important}.i-amphtml-story-info-link{color:#000!important;display:block!important;margin:0!important;opacity:0.64!important;font-size:12px!important;text-decoration:none!important}.i-amphtml-story-info-moreinfo{color:#4285f4!important;display:none!important;font-family:Roboto-Medium,sans-serif!important;font-size:12px!important;letter-spacing:0.5px!important;margin:16px 0 0;text-decoration:none!important}.i-amphtml-story-info-moreinfo.i-amphtml-story-info-moreinfo-visible{display:block!important}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-info-dialog.css*/";
exports.CSS = CSS;

},{}],7:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ":host{all:initial!important;color:initial!important}.amp-social-share-facebook{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M211.9 197.4h-36.7v59.9h36.7v175.8h70.5V256.5h49.2l5.2-59.1h-54.4v-33.7c0-13.9 2.8-19.5 16.3-19.5h38.2V82.9h-48.8c-52.5 0-76.1 23.1-76.1 67.3-.1 38.6-.1 47.2-.1 47.2z'/%3E%3C/svg%3E\")}.amp-social-share-pinterest{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M266.6 76.5c-100.2 0-150.7 71.8-150.7 131.7 0 36.3 13.7 68.5 43.2 80.6 4.8 2 9.2.1 10.6-5.3 1-3.7 3.3-13 4.3-16.9 1.4-5.3.9-7.1-3-11.8-8.5-10-13.9-23-13.9-41.3 0-53.3 39.9-101 103.8-101 56.6 0 87.7 34.6 87.7 80.8 0 60.8-26.9 112.1-66.8 112.1-22.1 0-38.6-18.2-33.3-40.6 6.3-26.7 18.6-55.5 18.6-74.8 0-17.3-9.3-31.7-28.4-31.7-22.5 0-40.7 23.3-40.7 54.6 0 19.9 6.7 33.4 6.7 33.4s-23.1 97.8-27.1 114.9c-8.1 34.1-1.2 75.9-.6 80.1.3 2.5 3.6 3.1 5 1.2 2.1-2.7 28.9-35.9 38.1-69 2.6-9.4 14.8-58 14.8-58 7.3 14 28.7 26.3 51.5 26.3 67.8 0 113.8-61.8 113.8-144.5-.1-62.6-53.1-120.8-133.6-120.8z'/%3E%3C/svg%3E\")}.amp-social-share-linkedin{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M186.4 142.4c0 19-15.3 34.5-34.2 34.5-18.9 0-34.2-15.4-34.2-34.5 0-19 15.3-34.5 34.2-34.5 18.9 0 34.2 15.5 34.2 34.5zm-5 58.9h-57.8v186.8h57.8V201.3zm92.4 0h-55.4v186.8h55.4v-98c0-26.3 12.1-41.9 35.2-41.9 21.3 0 31.5 15 31.5 41.9v98H398V269.8c0-50-28.3-74.2-68-74.2-39.6 0-56.3 30.9-56.3 30.9v-25.2h.1z'/%3E%3C/svg%3E\")}.amp-social-share-gplus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M179.7 237.6v46.6h77c-3.1 20-23.3 58.7-77 58.7-46.3 0-84.1-38.5-84.1-85.9 0-47.4 37.8-85.9 84.1-85.9 26.4 0 44 11.3 54.1 21l36.8-35.5C247 134.4 216.4 121 179.7 121 104.7 121 44 181.8 44 257s60.7 136 135.7 136C258 393 310 337.8 310 260.1c0-8.9-1-15.7-2.1-22.5H179.7zm288.3-.9h-38.7V198h-38.6v38.7H352v38.6h38.7V314h38.6v-38.7H468'/%3E%3C/svg%3E\")}.amp-social-share-email{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M101.3 141.6v228.9h309.5V141.6H101.3zm274.4 26.2L256 259.3l-119.6-91.5h239.3zm-248.1 26.3l64.1 49.1-64.1 64.1V194.1zm.2 150.1l84.9-84.9 43.2 33.1 43-32.9 84.7 84.7H127.8zm256.6-36.4L320 243.4l64.4-49.3v113.7z'/%3E%3C/svg%3E\")}.amp-social-share-twitter{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h400v400H0z'/%3E%3Cpath fill='%23FFF' fill-rule='nonzero' d='M153.62 301.59c94.34 0 145.94-78.16 145.94-145.94 0-2.22 0-4.43-.15-6.63A104.36 104.36 0 00325 122.47a102.38 102.38 0 01-29.46 8.07 51.47 51.47 0 0022.55-28.37 102.79 102.79 0 01-32.57 12.45c-15.9-16.906-41.163-21.044-61.625-10.093-20.461 10.95-31.032 34.266-25.785 56.873A145.62 145.62 0 0192.4 107.81c-13.614 23.436-6.66 53.419 15.88 68.47A50.91 50.91 0 0185 169.86v.65c.007 24.416 17.218 45.445 41.15 50.28a51.21 51.21 0 01-23.16.88c6.72 20.894 25.976 35.208 47.92 35.62a102.92 102.92 0 01-63.7 22 104.41 104.41 0 01-12.21-.74 145.21 145.21 0 0078.62 23'/%3E%3C/g%3E%3C/svg%3E\")}.amp-social-share-tumblr{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M210.8 80.3c-2.3 18.3-6.4 33.4-12.4 45.2-6 11.9-13.9 22-23.9 30.5-9.9 8.5-21.8 14.9-35.7 19.5v50.6h38.9v124.5c0 16.2 1.7 28.6 5.1 37.1 3.4 8.5 9.5 16.6 18.3 24.2 8.8 7.6 19.4 13.4 31.9 17.5s26.8 6.1 43 6.1c14.3 0 27.6-1.4 39.9-4.3 12.3-2.9 26-7.9 41.2-15v-55.9c-17.8 11.7-35.7 17.5-53.7 17.5-10.1 0-19.1-2.4-27-7.1-5.9-3.5-10-8.2-12.2-14-2.2-5.8-3.3-19.1-3.3-39.7v-91.1h84.6v-55.8h-84.4v-90h-50.3z'/%3E%3C/svg%3E\")}.amp-social-share-whatsapp{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='46' height='46'%3E%3Cpath fill='%23FFF' d='M35.4 10.4C32 6.9 27.3 5 22.5 5 12.3 5 4.1 13.3 4.2 23.4c0 3.2.9 6.3 2.4 9.1L4 42l9.7-2.5c2.7 1.5 5.7 2.2 8.7 2.2 10.1 0 18.3-8.3 18.3-18.4 0-4.9-1.9-9.5-5.3-12.9zM22.5 38.6c-2.7 0-5.4-.7-7.7-2.1l-.6-.3-5.8 1.5L9.9 32l-.4-.6c-4.4-7.1-2.3-16.5 4.9-20.9 7.2-4.4 16.5-2.3 20.9 4.9 4.4 7.2 2.3 16.5-4.9 20.9-2.3 1.5-5.1 2.3-7.9 2.3zm8.8-11.1l-1.1-.5s-1.6-.7-2.6-1.2c-.1 0-.2-.1-.3-.1-.3 0-.5.1-.7.2 0 0-.1.1-1.5 1.7-.1.2-.3.3-.5.3h-.1c-.1 0-.3-.1-.4-.2l-.5-.2c-1.1-.5-2.1-1.1-2.9-1.9-.2-.2-.5-.4-.7-.6-.7-.7-1.4-1.5-1.9-2.4l-.1-.2c-.1-.1-.1-.2-.2-.4 0-.2 0-.4.1-.5 0 0 .4-.5.7-.8.2-.2.3-.5.5-.7.2-.3.3-.7.2-1-.1-.5-1.3-3.2-1.6-3.8-.2-.3-.4-.4-.7-.5h-1.1c-.2 0-.4.1-.6.1l-.1.1c-.2.1-.4.3-.6.4-.2.2-.3.4-.5.6-.7.9-1.1 2-1.1 3.1 0 .8.2 1.6.5 2.3l.1.3c.9 1.9 2.1 3.6 3.7 5.1l.4.4c.3.3.6.5.8.8 2.1 1.8 4.5 3.1 7.2 3.8.3.1.7.1 1 .2h1c.5 0 1.1-.2 1.5-.4.3-.2.5-.2.7-.4l.2-.2c.2-.2.4-.3.6-.5.2-.2.4-.4.5-.6.2-.4.3-.9.4-1.4v-.7s-.1-.1-.3-.2z'/%3E%3C/svg%3E\")}.amp-social-share-line{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 511.99'%3E%3Cpath d='M443.2 233.29c0-84.14-84.35-152.6-188-152.6s-188 68.46-188 152.6c0 75.43 66.9 138.61 157.26 150.55 6.13 1.32 14.46 4 16.57 9.27 1.89 4.76 1.24 12.2.61 17 0 0-2.21 13.26-2.69 16.09-.82 4.75-3.78 18.6 16.29 10.14s108.21-63.76 147.66-109.16c27.25-29.89 40.3-60.18 40.3-93.89zm-254.38 44.92a3.67 3.67 0 01-3.66 3.67h-52.69a3.6 3.6 0 01-2.53-1l-.06-.05v-.05a3.65 3.65 0 01-1-2.53v-81.96a3.66 3.66 0 013.66-3.66h13.19a3.66 3.66 0 013.66 3.66v65.07h35.84a3.66 3.66 0 013.66 3.66zm31.8 0a3.65 3.65 0 01-3.66 3.65h-13.2a3.65 3.65 0 01-3.66-3.65v-81.92a3.66 3.66 0 013.66-3.66H217a3.66 3.66 0 013.66 3.66zm90.78 0a3.65 3.65 0 01-3.66 3.65h-13.19a3.67 3.67 0 01-.94-.12h-.05l-.25-.08h-.11l-.18-.08-.17-.08-.11-.06-.22-.14a3.45 3.45 0 01-.93-.9L254 229.56v48.66a3.66 3.66 0 01-3.67 3.65H237.1a3.65 3.65 0 01-3.66-3.65v-81.93a3.66 3.66 0 013.66-3.66h13.86l.21.05h.13l.21.07h.12a1.31 1.31 0 01.21.08l.12.06.19.11a.41.41 0 01.11.07l.19.13.1.07.19.16.07.07a2.28 2.28 0 01.22.22 3.58 3.58 0 01.28.37L290.89 245v-48.71a3.66 3.66 0 013.66-3.66h13.19a3.66 3.66 0 013.66 3.66zm72.83-68.74a3.66 3.66 0 01-3.65 3.67h-35.84V227h35.84a3.66 3.66 0 013.65 3.67v13.19a3.65 3.65 0 01-3.65 3.66h-35.84v13.85h35.84a3.65 3.65 0 013.65 3.66v13.19a3.66 3.66 0 01-3.65 3.67h-52.7a3.66 3.66 0 01-2.53-1l-.05-.05a.12.12 0 01-.05-.05 3.65 3.65 0 01-1-2.53V196.3a3.6 3.6 0 011-2.52l.06-.07a3.63 3.63 0 012.54-1h52.7a3.66 3.66 0 013.65 3.67z' fill='%23fff' data-name='レイヤー 1'/%3E%3C/svg%3E\")}.amp-social-share-sms{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='30' height='29' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23FFF' stroke-width='3' d='M8.73 26v-5.658H2V2h25.97L28 20.355l-12.062.042z' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E\")}.amp-social-share-system{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg fill='%23fff' height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z'/%3E%3C/svg%3E\")}amp-social-share{background-repeat:no-repeat;background-position:50%;background-size:contain;text-decoration:none;cursor:pointer;position:relative}.amp-social-share-twitter{background-color:#1da1f2}.amp-social-share-facebook{background-color:#32529f}.amp-social-share-pinterest{background-color:#e60023}.amp-social-share-linkedin{background-color:#0077b5}.amp-social-share-gplus{background-color:#dc4e41}.amp-social-share-tumblr{background-color:#3c5a77}.amp-social-share-email{background-color:#000}.amp-social-share-whatsapp{background-color:#25d366}.amp-social-share-line{background-color:#52b448}.amp-social-share-sms{background-color:#ca2b63}.amp-social-share-system{background-color:#000}.i-amphtml-story-share-widget{display:block!important;margin:16px 8px!important}.i-amphtml-story-no-sharing .i-amphtml-story-share-widget{display:none!important}.i-amphtml-story-share-widget-scrollable{padding:16px 0!important;overflow:auto!important}.i-amphtml-story-bookend-fullbleed .i-amphtml-story-share-widget{margin-left:0!important;margin-right:0!important}.i-amphtml-story-share-widget::-webkit-scrollbar{width:0px!important;background:transparent!important}.i-amphtml-story-share-list{list-style:none!important;padding:0 8px!important;margin:0!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-wrap:wrap!important;flex-wrap:wrap!important;width:100%!important}.i-amphtml-story-bookend-fullbleed .i-amphtml-story-share-list{padding-left:16px!important;padding-right:16px!important}.i-amphtml-story-share-item{width:48px!important;height:66px!important;padding:0 16px!important;margin-bottom:12px!important}@media (max-width:410px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;min-width:60px!important;width:25%!important}}@media (min-width:410px) and (max-width:500px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;width:20%!important}}@media (min-width:500px) and (max-width:720px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;width:16.66%!important}}.i-amphtml-story-share-widget-scrollable .i-amphtml-story-share-list{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.i-amphtml-story-share-widget-scrollable>*>.i-amphtml-story-share-item{display:block!important;margin:0!important;padding:0 16px!important;min-width:auto!important}.i-amphtml-story-share-item:empty{display:none!important}.i-amphtml-story-share-icon{box-sizing:border-box!important;position:relative!important;width:48px!important;height:48px!important;display:block!important;cursor:pointer!important;border-radius:4px!important;overflow:visible!important;background-position:8px 8px!important;background-size:32px 32px!important;background-repeat:no-repeat!important}.i-amphtml-story-share-icon.amp-social-share-facebook{background-size:38px 38px!important;background-position:5px 5px!important}.i-amphtml-story-share-icon:active,.i-amphtml-story-share-icon:focus{outline:none!important;box-shadow:none!important}.i-amphtml-story-share-icon:active:before{background-color:#787878!important}.i-amphtml-story-share-icon[type=email]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon[type=system]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon-link{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon .i-amphtml-story-share-label{position:absolute!important;top:48px!important;left:0!important;width:100%!important;color:rgba(0,0,0,0.87)!important;padding-top:5px!important;text-transform:capitalize!important;font-family:Roboto,sans-serif!important;font-weight:400!important;line-height:13px!important;font-size:11px!important;text-align:center!important}.i-amphtml-story-share-menu{position:absolute!important;top:0!important;left:0!important;height:100%!important;width:100%!important;z-index:100003!important;transform:translate3d(0,100vh,0)!important;transition-delay:0.15s!important;pointer-events:none!important}.i-amphtml-story-share-menu-visible{transform:translateZ(0)!important;transition-delay:0s!important;pointer-events:auto!important}.i-amphtml-story-share-menu:before{content:\"\"!important;position:absolute!important;top:0!important;left:0!important;height:100%!important;width:100%!important;background:#000!important;opacity:0!important;transition:opacity 0.15s cubic-bezier(0.4,0.0,1,1)!important}.i-amphtml-story-share-menu.i-amphtml-story-share-menu-visible:before{opacity:0.55!important;transition:opacity 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-share-menu-container{position:absolute!important;bottom:0!important;left:0!important;right:0!important;height:auto!important;background:#fff!important;border-radius:8px 8px 0 0!important;transform:translate3d(0,100%,0)!important;transition:transform 0.15s cubic-bezier(0.4,0.0,1,1)!important}.i-amphtml-story-share-menu-visible .i-amphtml-story-share-menu-container{transform:translateZ(0)!important;transition:transform 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-share-menu-close-button{display:none!important}.i-amphtml-story-share-menu .i-amphtml-story-share-item{height:72px!important}[desktop].i-amphtml-story-share-menu{display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important}[desktop] .i-amphtml-story-share-menu-container{position:relative!important;margin:0!important;max-width:320px!important;opacity:0!important;transform:none!important;transition:opacity 0.15s cubic-bezier(0.4,0.0,1,1)!important}[desktop].i-amphtml-story-share-menu-visible .i-amphtml-story-share-menu-container{border-radius:8px!important;opacity:1!important;transform:none!important;transition:opacity 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}[desktop] .i-amphtml-story-share-menu-close-button{display:block!important;position:absolute!important;top:0!important;right:0!important;height:30px!important;width:30px!important;color:#9aa0a6!important;cursor:pointer!important;font-size:24px!important;line-height:30px!important;text-align:center!important}[desktop].i-amphtml-story-share-menu .i-amphtml-story-share-item{padding:0!important;height:66px!important;margin:12px!important}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-share-menu.css*/";
exports.CSS = CSS;

},{}],8:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ".amp-social-share-facebook{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M211.9 197.4h-36.7v59.9h36.7v175.8h70.5V256.5h49.2l5.2-59.1h-54.4v-33.7c0-13.9 2.8-19.5 16.3-19.5h38.2V82.9h-48.8c-52.5 0-76.1 23.1-76.1 67.3-.1 38.6-.1 47.2-.1 47.2z'/%3E%3C/svg%3E\")}.amp-social-share-pinterest{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M266.6 76.5c-100.2 0-150.7 71.8-150.7 131.7 0 36.3 13.7 68.5 43.2 80.6 4.8 2 9.2.1 10.6-5.3 1-3.7 3.3-13 4.3-16.9 1.4-5.3.9-7.1-3-11.8-8.5-10-13.9-23-13.9-41.3 0-53.3 39.9-101 103.8-101 56.6 0 87.7 34.6 87.7 80.8 0 60.8-26.9 112.1-66.8 112.1-22.1 0-38.6-18.2-33.3-40.6 6.3-26.7 18.6-55.5 18.6-74.8 0-17.3-9.3-31.7-28.4-31.7-22.5 0-40.7 23.3-40.7 54.6 0 19.9 6.7 33.4 6.7 33.4s-23.1 97.8-27.1 114.9c-8.1 34.1-1.2 75.9-.6 80.1.3 2.5 3.6 3.1 5 1.2 2.1-2.7 28.9-35.9 38.1-69 2.6-9.4 14.8-58 14.8-58 7.3 14 28.7 26.3 51.5 26.3 67.8 0 113.8-61.8 113.8-144.5-.1-62.6-53.1-120.8-133.6-120.8z'/%3E%3C/svg%3E\")}.amp-social-share-linkedin{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M186.4 142.4c0 19-15.3 34.5-34.2 34.5-18.9 0-34.2-15.4-34.2-34.5 0-19 15.3-34.5 34.2-34.5 18.9 0 34.2 15.5 34.2 34.5zm-5 58.9h-57.8v186.8h57.8V201.3zm92.4 0h-55.4v186.8h55.4v-98c0-26.3 12.1-41.9 35.2-41.9 21.3 0 31.5 15 31.5 41.9v98H398V269.8c0-50-28.3-74.2-68-74.2-39.6 0-56.3 30.9-56.3 30.9v-25.2h.1z'/%3E%3C/svg%3E\")}.amp-social-share-gplus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M179.7 237.6v46.6h77c-3.1 20-23.3 58.7-77 58.7-46.3 0-84.1-38.5-84.1-85.9 0-47.4 37.8-85.9 84.1-85.9 26.4 0 44 11.3 54.1 21l36.8-35.5C247 134.4 216.4 121 179.7 121 104.7 121 44 181.8 44 257s60.7 136 135.7 136C258 393 310 337.8 310 260.1c0-8.9-1-15.7-2.1-22.5H179.7zm288.3-.9h-38.7V198h-38.6v38.7H352v38.6h38.7V314h38.6v-38.7H468'/%3E%3C/svg%3E\")}.amp-social-share-email{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M101.3 141.6v228.9h309.5V141.6H101.3zm274.4 26.2L256 259.3l-119.6-91.5h239.3zm-248.1 26.3l64.1 49.1-64.1 64.1V194.1zm.2 150.1l84.9-84.9 43.2 33.1 43-32.9 84.7 84.7H127.8zm256.6-36.4L320 243.4l64.4-49.3v113.7z'/%3E%3C/svg%3E\")}.amp-social-share-twitter{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h400v400H0z'/%3E%3Cpath fill='%23FFF' fill-rule='nonzero' d='M153.62 301.59c94.34 0 145.94-78.16 145.94-145.94 0-2.22 0-4.43-.15-6.63A104.36 104.36 0 00325 122.47a102.38 102.38 0 01-29.46 8.07 51.47 51.47 0 0022.55-28.37 102.79 102.79 0 01-32.57 12.45c-15.9-16.906-41.163-21.044-61.625-10.093-20.461 10.95-31.032 34.266-25.785 56.873A145.62 145.62 0 0192.4 107.81c-13.614 23.436-6.66 53.419 15.88 68.47A50.91 50.91 0 0185 169.86v.65c.007 24.416 17.218 45.445 41.15 50.28a51.21 51.21 0 01-23.16.88c6.72 20.894 25.976 35.208 47.92 35.62a102.92 102.92 0 01-63.7 22 104.41 104.41 0 01-12.21-.74 145.21 145.21 0 0078.62 23'/%3E%3C/g%3E%3C/svg%3E\")}.amp-social-share-tumblr{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23fff' d='M210.8 80.3c-2.3 18.3-6.4 33.4-12.4 45.2-6 11.9-13.9 22-23.9 30.5-9.9 8.5-21.8 14.9-35.7 19.5v50.6h38.9v124.5c0 16.2 1.7 28.6 5.1 37.1 3.4 8.5 9.5 16.6 18.3 24.2 8.8 7.6 19.4 13.4 31.9 17.5s26.8 6.1 43 6.1c14.3 0 27.6-1.4 39.9-4.3 12.3-2.9 26-7.9 41.2-15v-55.9c-17.8 11.7-35.7 17.5-53.7 17.5-10.1 0-19.1-2.4-27-7.1-5.9-3.5-10-8.2-12.2-14-2.2-5.8-3.3-19.1-3.3-39.7v-91.1h84.6v-55.8h-84.4v-90h-50.3z'/%3E%3C/svg%3E\")}.amp-social-share-whatsapp{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='46' height='46'%3E%3Cpath fill='%23FFF' d='M35.4 10.4C32 6.9 27.3 5 22.5 5 12.3 5 4.1 13.3 4.2 23.4c0 3.2.9 6.3 2.4 9.1L4 42l9.7-2.5c2.7 1.5 5.7 2.2 8.7 2.2 10.1 0 18.3-8.3 18.3-18.4 0-4.9-1.9-9.5-5.3-12.9zM22.5 38.6c-2.7 0-5.4-.7-7.7-2.1l-.6-.3-5.8 1.5L9.9 32l-.4-.6c-4.4-7.1-2.3-16.5 4.9-20.9 7.2-4.4 16.5-2.3 20.9 4.9 4.4 7.2 2.3 16.5-4.9 20.9-2.3 1.5-5.1 2.3-7.9 2.3zm8.8-11.1l-1.1-.5s-1.6-.7-2.6-1.2c-.1 0-.2-.1-.3-.1-.3 0-.5.1-.7.2 0 0-.1.1-1.5 1.7-.1.2-.3.3-.5.3h-.1c-.1 0-.3-.1-.4-.2l-.5-.2c-1.1-.5-2.1-1.1-2.9-1.9-.2-.2-.5-.4-.7-.6-.7-.7-1.4-1.5-1.9-2.4l-.1-.2c-.1-.1-.1-.2-.2-.4 0-.2 0-.4.1-.5 0 0 .4-.5.7-.8.2-.2.3-.5.5-.7.2-.3.3-.7.2-1-.1-.5-1.3-3.2-1.6-3.8-.2-.3-.4-.4-.7-.5h-1.1c-.2 0-.4.1-.6.1l-.1.1c-.2.1-.4.3-.6.4-.2.2-.3.4-.5.6-.7.9-1.1 2-1.1 3.1 0 .8.2 1.6.5 2.3l.1.3c.9 1.9 2.1 3.6 3.7 5.1l.4.4c.3.3.6.5.8.8 2.1 1.8 4.5 3.1 7.2 3.8.3.1.7.1 1 .2h1c.5 0 1.1-.2 1.5-.4.3-.2.5-.2.7-.4l.2-.2c.2-.2.4-.3.6-.5.2-.2.4-.4.5-.6.2-.4.3-.9.4-1.4v-.7s-.1-.1-.3-.2z'/%3E%3C/svg%3E\")}.amp-social-share-line{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 511.99'%3E%3Cpath d='M443.2 233.29c0-84.14-84.35-152.6-188-152.6s-188 68.46-188 152.6c0 75.43 66.9 138.61 157.26 150.55 6.13 1.32 14.46 4 16.57 9.27 1.89 4.76 1.24 12.2.61 17 0 0-2.21 13.26-2.69 16.09-.82 4.75-3.78 18.6 16.29 10.14s108.21-63.76 147.66-109.16c27.25-29.89 40.3-60.18 40.3-93.89zm-254.38 44.92a3.67 3.67 0 01-3.66 3.67h-52.69a3.6 3.6 0 01-2.53-1l-.06-.05v-.05a3.65 3.65 0 01-1-2.53v-81.96a3.66 3.66 0 013.66-3.66h13.19a3.66 3.66 0 013.66 3.66v65.07h35.84a3.66 3.66 0 013.66 3.66zm31.8 0a3.65 3.65 0 01-3.66 3.65h-13.2a3.65 3.65 0 01-3.66-3.65v-81.92a3.66 3.66 0 013.66-3.66H217a3.66 3.66 0 013.66 3.66zm90.78 0a3.65 3.65 0 01-3.66 3.65h-13.19a3.67 3.67 0 01-.94-.12h-.05l-.25-.08h-.11l-.18-.08-.17-.08-.11-.06-.22-.14a3.45 3.45 0 01-.93-.9L254 229.56v48.66a3.66 3.66 0 01-3.67 3.65H237.1a3.65 3.65 0 01-3.66-3.65v-81.93a3.66 3.66 0 013.66-3.66h13.86l.21.05h.13l.21.07h.12a1.31 1.31 0 01.21.08l.12.06.19.11a.41.41 0 01.11.07l.19.13.1.07.19.16.07.07a2.28 2.28 0 01.22.22 3.58 3.58 0 01.28.37L290.89 245v-48.71a3.66 3.66 0 013.66-3.66h13.19a3.66 3.66 0 013.66 3.66zm72.83-68.74a3.66 3.66 0 01-3.65 3.67h-35.84V227h35.84a3.66 3.66 0 013.65 3.67v13.19a3.65 3.65 0 01-3.65 3.66h-35.84v13.85h35.84a3.65 3.65 0 013.65 3.66v13.19a3.66 3.66 0 01-3.65 3.67h-52.7a3.66 3.66 0 01-2.53-1l-.05-.05a.12.12 0 01-.05-.05 3.65 3.65 0 01-1-2.53V196.3a3.6 3.6 0 011-2.52l.06-.07a3.63 3.63 0 012.54-1h52.7a3.66 3.66 0 013.65 3.67z' fill='%23fff' data-name='レイヤー 1'/%3E%3C/svg%3E\")}.amp-social-share-sms{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='30' height='29' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23FFF' stroke-width='3' d='M8.73 26v-5.658H2V2h25.97L28 20.355l-12.062.042z' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E\")}.amp-social-share-system{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg fill='%23fff' height='24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z'/%3E%3C/svg%3E\")}amp-social-share{background-repeat:no-repeat;background-position:50%;background-size:contain;text-decoration:none;cursor:pointer;position:relative}.amp-social-share-twitter{background-color:#1da1f2}.amp-social-share-facebook{background-color:#32529f}.amp-social-share-pinterest{background-color:#e60023}.amp-social-share-linkedin{background-color:#0077b5}.amp-social-share-gplus{background-color:#dc4e41}.amp-social-share-tumblr{background-color:#3c5a77}.amp-social-share-email{background-color:#000}.amp-social-share-whatsapp{background-color:#25d366}.amp-social-share-line{background-color:#52b448}.amp-social-share-sms{background-color:#ca2b63}.amp-social-share-system{background-color:#000}.i-amphtml-story-share-widget{display:block!important;margin:16px 8px!important}.i-amphtml-story-no-sharing .i-amphtml-story-share-widget{display:none!important}.i-amphtml-story-share-widget-scrollable{padding:16px 0!important;overflow:auto!important}.i-amphtml-story-bookend-fullbleed .i-amphtml-story-share-widget{margin-left:0!important;margin-right:0!important}.i-amphtml-story-share-widget::-webkit-scrollbar{width:0px!important;background:transparent!important}.i-amphtml-story-share-list{list-style:none!important;padding:0 8px!important;margin:0!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-wrap:wrap!important;flex-wrap:wrap!important;width:100%!important}.i-amphtml-story-bookend-fullbleed .i-amphtml-story-share-list{padding-left:16px!important;padding-right:16px!important}.i-amphtml-story-share-item{width:48px!important;height:66px!important;padding:0 16px!important;margin-bottom:12px!important}@media (max-width:410px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;min-width:60px!important;width:25%!important}}@media (min-width:410px) and (max-width:500px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;width:20%!important}}@media (min-width:500px) and (max-width:720px){.i-amphtml-story-share-item{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important;padding:0!important;width:16.66%!important}}.i-amphtml-story-share-widget-scrollable .i-amphtml-story-share-list{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.i-amphtml-story-share-widget-scrollable>*>.i-amphtml-story-share-item{display:block!important;margin:0!important;padding:0 16px!important;min-width:auto!important}.i-amphtml-story-share-item:empty{display:none!important}.i-amphtml-story-share-icon{box-sizing:border-box!important;position:relative!important;width:48px!important;height:48px!important;display:block!important;cursor:pointer!important;border-radius:4px!important;overflow:visible!important;background-position:8px 8px!important;background-size:32px 32px!important;background-repeat:no-repeat!important}.i-amphtml-story-share-icon.amp-social-share-facebook{background-size:38px 38px!important;background-position:5px 5px!important}.i-amphtml-story-share-icon:active,.i-amphtml-story-share-icon:focus{outline:none!important;box-shadow:none!important}.i-amphtml-story-share-icon:active:before{background-color:#787878!important}.i-amphtml-story-share-icon[type=email]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon[type=system]{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon-link{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='%23fff'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'/%3E%3C/svg%3E\")!important;background-color:#9aa0a6!important}.i-amphtml-story-share-icon .i-amphtml-story-share-label{position:absolute!important;top:48px!important;left:0!important;width:100%!important;color:rgba(0,0,0,0.87)!important;padding-top:5px!important;text-transform:capitalize!important;font-family:Roboto,sans-serif!important;font-weight:400!important;line-height:13px!important;font-size:11px!important;text-align:center!important}.i-amphtml-story-system-layer{background:linear-gradient(180deg,rgba(0,0,0,0.35),transparent)!important;position:absolute!important;top:0!important;left:0!important;right:0!important;height:56px!important;opacity:1!important;z-index:100000!important;box-sizing:border-box!important;transition:opacity 0.3s cubic-bezier(0.0,0.0,0.2,1)!important;pointer-events:none!important;font-family:Roboto,sans-serif!important}.i-amphtml-story-bookend-active.i-amphtml-story-system-layer{opacity:0.3!important;z-index:1!important;transition:opacity 0.15s cubic-bezier(0.4,0.0,1,1)!important}.i-amphtml-story-hidden.i-amphtml-story-system-layer{opacity:0!important;transition:opacity 0.15s cubic-bezier(0.4,0.0,1,1)!important}.i-amphtml-story-hidden.i-amphtml-story-system-layer *{pointer-events:none!important}.i-amphtml-story-desktop-panels.i-amphtml-story-bookend-active.i-amphtml-story-system-layer{opacity:0!important}.i-amphtml-story-system-layer-buttons{margin-top:8px;display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:row!important;flex-direction:row!important;-ms-flex-pack:end!important;justify-content:flex-end!important}.i-amphtml-story-button{background-repeat:no-repeat!important;background-position:50%!important;height:48px!important;width:48px!important;cursor:pointer!important;border-radius:50%!important;border-width:0!important;box-sizing:border-box!important;position:relative!important;pointer-events:auto!important;background:50% no-repeat!important}.i-amphtml-story-button:active{background-color:rgba(0,0,0,0.2)!important}.i-amphtml-story-system-layer .i-amphtml-story-button{float:left!important}.i-amphtml-story-progress-bar{border:0!important;display:-ms-flexbox!important;display:flex!important;height:2px!important;left:0!important;margin:4px 0 0!important;padding:0 2px!important;position:absolute!important;right:0!important;top:0!important;visibility:visible!important;z-index:100001!important}[ad-showing] .i-amphtml-story-progress-bar{visibility:hidden!important}[ad-showing] .i-amphtml-story-share-control{display:none!important}[ad-showing]:not([i-amphtml-current-page-has-audio]) .i-amphtml-story-mute-audio-control,[ad-showing]:not([i-amphtml-current-page-has-audio]) .i-amphtml-story-unmute-audio-control{visibility:hidden!important}.i-amphtml-story-page-progress-bar{background:hsla(0,0%,100%,0.4)!important;border-radius:1px!important;height:100%!important;list-style-type:none!important;margin:0 2px!important;overflow:hidden!important;width:100%!important}.i-amphtml-story-page-progress-value{background:#fff!important;height:100%!important;width:100%!important;transform:translateZ(0) scaleX(0)!important;transform-origin:left!important}[dir=rtl] .i-amphtml-story-page-progress-value{transform-origin:right!important}.i-amphtml-first-page-active[info] .i-amphtml-message-container{padding-right:48px!important}.i-amphtml-first-page-active[info][dir=rtl] .i-amphtml-message-container{padding-right:auto!important;padding-left:48px!important}.i-amphtml-message-container{display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;width:-webkit-max-content!important;width:-moz-max-content!important;width:max-content!important;transition-property:opacity,transform!important;position:absolute!important;top:0!important;right:48px!important;height:100%!important;color:#fff!important;font-size:16px!important;text-shadow:0px 0px 6px rgba(0,0,0,0.36)!important}[dir=rtl] .i-amphtml-message-container{right:auto!important;left:48px!important}[i-amphtml-story-messagedisplay=noshow] .i-amphtml-message-container{transition:opacity 0.2s cubic-bezier(0.4,0.0,1,1),visibility 0.2s,transform 0.0s 0.2s!important;opacity:0!important;visibility:hidden!important;transform:translateX(10px)!important}[i-amphtml-story-has-new-page=noshow] .i-amphtml-story-has-new-page-notification-container{transition:opacity 1.5s,visibility 1.5s!important;opacity:0!important;visibility:hidden!important}.i-amphtml-last-page-active[i-amphtml-story-has-new-page=show] .i-amphtml-story-has-new-page-notification-container{transition:opacity 1.5s,visibility 1.5s!important;opacity:1!important;visibility:visible!important}[dir=rtl][i-amphtml-story-messagedisplay=noshow] .i-amphtml-message-container{transform:translateX(-10px)!important}[i-amphtml-story-messagedisplay=show] .i-amphtml-message-container{transition:opacity 0.2s cubic-bezier(0.0,0.0,0.2,1),visibility 0.2s,transform 0.2s cubic-bezier(0.4,0.0,0.2,1)!important;opacity:1!important;visibility:visible!important;transform:translateX(0px)!important}.i-amphtml-story-mute-text,.i-amphtml-story-unmute-no-sound-text,.i-amphtml-story-unmute-sound-text{width:-webkit-max-content!important;width:-moz-max-content!important;width:max-content!important;color:#fff!important}.i-amphtml-story-sound-display{display:inline-block!important;height:46px!important;position:relative!important}.i-amphtml-paused-display,.i-amphtml-story-mute-audio-control,.i-amphtml-story-mute-text,.i-amphtml-story-no-audio-ui .i-amphtml-story-sound-display,.i-amphtml-story-pause-control,.i-amphtml-story-play-control,.i-amphtml-story-sidebar-control,.i-amphtml-story-unmute-audio-control,.i-amphtml-story-unmute-no-sound-text,.i-amphtml-story-unmute-sound-text{display:none!important}.i-amphtml-story-desktop-fullbleed .i-amphtml-paused-display,.i-amphtml-story-desktop-panels .i-amphtml-paused-display,.i-amphtml-story-has-audio:not([muted]) .i-amphtml-story-mute-audio-control,.i-amphtml-story-has-audio[muted] .i-amphtml-story-unmute-audio-control,[i-amphtml-story-has-sidebar] .i-amphtml-story-sidebar-control{display:block!important}.i-amphtml-paused-display button[disabled]{opacity:0.3!important;cursor:initial!important}.i-amphtml-story-has-audio[muted] .i-amphtml-story-mute-text,.i-amphtml-story-has-playback-ui:not([paused]) .i-amphtml-story-pause-control,.i-amphtml-story-has-playback-ui[paused] .i-amphtml-story-play-control,:not([i-amphtml-current-page-has-audio]).i-amphtml-story-has-audio:not([muted]) .i-amphtml-story-unmute-no-sound-text,[i-amphtml-current-page-has-audio].i-amphtml-story-has-audio:not([muted]) .i-amphtml-story-unmute-sound-text{display:block!important}.i-amphtml-story-ui-no-buttons .i-amphtml-story-button,.i-amphtml-story-ui-no-buttons .i-amphtml-story-system-layer-buttons{visibility:hidden!important}.i-amphtml-story-unmute-audio-control{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFF'%3E%3Cpath d='M16.5 12A4.5 4.5 0 0014 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0021 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 003.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-mute-audio-control{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFF'%3E%3Cpath d='M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-pause-control{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFF'%3E%3Cpath d='M6 19h4V5H6v14zm8-14v14h4V5h-4z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-play-control{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFF'%3E%3Cpath d='M8 5v14l11-7z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-sidebar-control{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFF'%3E%3Cpath d='M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-share-control{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFF'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z'/%3E%3C/svg%3E\")!important}[ios] .i-amphtml-story-share-control{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FFF'%3E%3Cpath fill='none' d='M0 0h24v24H0V0z'/%3E%3Cpath d='M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6a2 2 0 01-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3a2 2 0 012 2z'/%3E%3C/svg%3E\")!important;background-position-y:calc(50% - 2px)!important}.i-amphtml-story-info-control{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 48 48' fill='%23FFF'%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3Cpath d='M22 34h4V22h-4v12zm2-30C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm-2-22h4v-4h-4v4z'/%3E%3C/svg%3E\")!important;display:none!important}.i-amphtml-story-has-new-page-notification-container{position:absolute!important;z-index:100002!important;top:32px!important;right:0!important;left:0!important;opacity:0!important}.i-amphtml-story-has-new-page-notification-container,.i-amphtml-story-has-new-page-text-wrapper{display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:center!important;justify-content:center!important}.i-amphtml-story-has-new-page-text-wrapper{background-color:rgba(32,33,37,0.8)!important;-ms-flex-align:center!important;align-items:center!important;padding:4px 10px 4px 0!important;border-radius:5px!important}[dir=rtl] .i-amphtml-story-has-new-page-text-wrapper{padding-right:0!important;padding-left:10px!important}.i-amphtml-story-has-new-page-text{color:#fff!important;font-size:16px!important;text-shadow:0px 0px 6px rgba(0,0,0,0.36)!important;font-weight:700!important}.i-amphtml-story-has-new-page-circle-icon{background:#03ffa0!important;border-radius:50%!important;height:6px!important;width:6px!important;position:relative!important;box-shadow:0 0 0 2px rgba(3,255,160,0.5)!important;margin:0px 10px!important}.i-amphtml-story-desktop-panels .i-amphtml-story-has-new-page-notification-container{top:0!important}.i-amphtml-embedded.i-amphtml-first-page-active .i-amphtml-story-info-control{display:block!important}.i-amphtml-story-no-sharing .i-amphtml-story-info-control,.i-amphtml-story-no-sharing .i-amphtml-story-share-control{display:none!important}.i-amphtml-story-desktop-panels.i-amphtml-story-system-layer{background:transparent!important;top:auto!important;bottom:0!important;height:96px!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important;-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.i-amphtml-animate-progress li{transition:transform 0.8s cubic-bezier(0.4,0.0,0.2,1)!important}.i-amphtml-progress-bar-overflow.i-amphtml-story-progress-bar{width:calc(100% - 4px)!important;margin:4px 2px 0!important;overflow:hidden!important;padding:0!important}.i-amphtml-story-desktop-panels .i-amphtml-story-progress-bar{position:relative!important;height:3px!important;width:33.33333vw!important;margin:0 24px!important}.i-amphtml-story-desktop-fullbleed .i-amphtml-story-progress-bar{height:3px!important}.i-amphtml-story-desktop-panels .i-amphtml-story-page-progress-bar{border-radius:100px!important}.i-amphtml-progress-bar-overflow .i-amphtml-story-page-progress-bar{border-radius:0px!important;list-style:none!important;margin:0 2px!important;width:2px!important;position:absolute!important;transform-origin:left!important}[dir=rtl].i-amphtml-progress-bar-overflow .i-amphtml-story-page-progress-bar{transform-origin:right!important}.i-amphtml-story-desktop-fullbleed .i-amphtml-progress-bar-overflow .i-amphtml-story-page-progress-bar,.i-amphtml-story-desktop-panels .i-amphtml-progress-bar-overflow .i-amphtml-story-page-progress-bar{width:3px!important}.i-amphtml-story-desktop-panels.i-amphtml-story-system-layer .i-amphtml-story-system-layer-buttons{position:fixed!important;top:0!important;right:0!important}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-system-layer.css*/";
exports.CSS = CSS;

},{}],9:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ".i-amphtml-story-focused-state-layer{top:0!important;left:0!important;width:100%!important;height:100%!important;z-index:100001!important;position:absolute!important}.i-amphtml-story-focused-state-layer.i-amphtml-hidden{opacity:0!important;pointer-events:none!important;transition:opacity 0.1s cubic-bezier(0.4,0.0,1,1)!important}.i-amphtml-story-focused-state-layer-nav-button-container{height:100%!important;width:160px!important;position:absolute!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column!important;flex-direction:column!important;-ms-flex-pack:center!important;justify-content:center!important}.i-amphtml-story-focused-state-layer-nav-button-container.i-amphtml-story-tooltip-nav-button-left{background-image:linear-gradient(90deg,rgba(33,33,33,0.15) 2%,rgba(33,33,33,0))!important;left:0!important}.i-amphtml-story-focused-state-layer-nav-button-container.i-amphtml-story-tooltip-nav-button-right{background-image:linear-gradient(90deg,rgba(33,33,33,0) 2%,rgba(33,33,33,0.15))!important;right:0!important}.i-amphtml-story-focused-state-layer-nav-button{position:absolute!important;top:0!important;bottom:0!important;margin:auto!important;width:48px!important;height:48px!important;padding:0!important;border:0!important;background-color:transparent!important;filter:drop-shadow(0px 0px 16px rgba(0,0,0,0.5))!important;transition:transform 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-focused-state-layer-nav-button.i-amphtml-story-tooltip-nav-button-left{left:-8px!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='%23FFF'%3E%3Cpath d='M30.83 14.83L28 12 16 24l12 12 2.83-2.83L21.66 24z'/%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-hidden .i-amphtml-story-focused-state-layer-nav-button.i-amphtml-story-tooltip-nav-button-left{transform:translate3d(8px,0,0);transition:transform 0s linear .1s!important}.i-amphtml-story-focused-state-layer-nav-button.i-amphtml-story-tooltip-nav-button-right{right:-8px!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='%23FFF'%3E%3Cpath d='M20 12l-2.83 2.83L26.34 24l-9.17 9.17L20 36l12-12z'/%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-hidden .i-amphtml-story-focused-state-layer-nav-button.i-amphtml-story-tooltip-nav-button-right{transform:translate3d(-8px,0,0);transition:transform 0s linear .1s!important}[desktop] .i-amphtml-story-focused-state-layer-nav-button-container{display:none!important}.i-amphtml-hidden>.i-amphtml-story-tooltip,.i-amphtml-hidden>.i-amphtml-story-tooltip.i-amphtml-tooltip-arrow-on-top{transform:translateZ(0)!important;transition:transform 0s linear 0.1s!important}.i-amphtml-story-tooltip{max-width:248px!important;height:40px!important;border-radius:6px!important;padding:8px!important;position:absolute!important;box-sizing:border-box!important;text-decoration:none!important;text-shadow:none!important;font-weight:500!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-align:center!important;align-items:center!important;background:#fff!important;box-shadow:0px 6px 16px rgba(0,0,0,0.16)!important;transform:translate3d(0,-16px,0)!important;transition:transform 0.2s cubic-bezier(0.0,0.0,0.2,1)!important}.i-amphtml-story-tooltip-theme-dark{background:#202125!important}.i-amphtml-story-tooltip.i-amphtml-tooltip-arrow-on-top{transform:translate3d(0,16px,0)!important}.i-amphtml-tooltip-text{text-overflow:ellipsis!important;overflow:hidden!important;white-space:nowrap!important;max-width:172px!important;margin:0px 5px!important;font-family:Roboto,sans-serif!important;font-size:14px!important;color:#3c4043!important;letter-spacing:0!important;line-height:20px!important}.i-amphtml-story-tooltip-theme-dark .i-amphtml-tooltip-text{color:#9aa0a6!important}.i-amphtml-story-tooltip-custom-icon{width:24px!important;height:24px!important;margin:0px 5px!important;background-size:cover!important;background-position:50%!important;background-repeat:no-repeat!important;filter:drop-shadow(0px 0px 8px rgba(0,0,0,0.08))!important}.i-amphtml-story-tooltip-custom-icon.i-amphtml-hidden{display:none!important}.i-amphtml-tooltip-action-icon{width:16px!important;height:16px!important;margin:0px 5px!important;padding-bottom:2px!important}.i-amphtml-tooltip-action-icon-launch{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 48 48' fill='%23757575'%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3Cpath d='M38 38H10V10h14V6H10c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V24h-4v14zM28 6v4h7.17L15.51 29.66l2.83 2.83L38 12.83V20h4V6H28z'/%3E%3C/svg%3E\")!important}.i-amphtml-tooltip-action-icon-expand{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 48 48' fill='%23757575'%3E%3Cpath d='M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z'/%3E%3Cpath d='M0-.25h48v48H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-tooltip-theme-dark .i-amphtml-tooltip-action-icon-launch{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 48 48' fill='rgba(255, 255, 255, 0.54)'%3E%3Cpath d='M0 0h48v48H0z' fill='none'/%3E%3Cpath d='M38 38H10V10h14V6H10c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V24h-4v14zM28 6v4h7.17L15.51 29.66l2.83 2.83L38 12.83V20h4V6H28z'/%3E%3C/svg%3E\")!important}.i-amphtml-story-tooltip-theme-dark .i-amphtml-tooltip-action-icon-expand{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 48 48' fill='rgba(255, 255, 255, 0.54)'%3E%3Cpath d='M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z'/%3E%3Cpath d='M0-.25h48v48H0z' fill='none'/%3E%3C/svg%3E\")!important}.i-amphtml-story-tooltip-arrow{border-right:8px solid transparent!important;border-left:8px solid transparent!important;border-top:10px solid #fff!important;position:absolute!important;bottom:-8px!important}.i-amphtml-story-tooltip-theme-dark .i-amphtml-story-tooltip-arrow{border-top:10px solid #202125!important}.i-amphtml-tooltip-arrow-on-top .i-amphtml-story-tooltip-arrow{bottom:auto!important;top:-8px!important;border-top:0px!important;border-bottom:10px solid #fff!important}.i-amphtml-story-tooltip-theme-dark .i-amphtml-tooltip-arrow-on-top .i-amphtml-story-tooltip-arrow{border-bottom:10px solid #202125!important}.amp-social-share-twitter-no-background{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h400v400H0z'/%3E%3Cpath fill='%231da1f2' fill-rule='nonzero' d='M153.62 301.59c94.34 0 145.94-78.16 145.94-145.94 0-2.22 0-4.43-.15-6.63A104.36 104.36 0 00325 122.47a102.38 102.38 0 01-29.46 8.07 51.47 51.47 0 0022.55-28.37 102.79 102.79 0 01-32.57 12.45c-15.9-16.906-41.163-21.044-61.625-10.093-20.461 10.95-31.032 34.266-25.785 56.873A145.62 145.62 0 0192.4 107.81c-13.614 23.436-6.66 53.419 15.88 68.47A50.91 50.91 0 0185 169.86v.65c.007 24.416 17.218 45.445 41.15 50.28a51.21 51.21 0 01-23.16.88c6.72 20.894 25.976 35.208 47.92 35.62a102.92 102.92 0 01-63.7 22 104.41 104.41 0 01-12.21-.74 145.21 145.21 0 0078.62 23'/%3E%3C/g%3E%3C/svg%3E\")}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-tooltip.css*/";
exports.CSS = CSS;

},{}],10:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ".i-amphtml-story-unsupported-browser-overlay{position:absolute!important;z-index:200001!important;font-family:Roboto,sans-serif;font-weight:700!important;line-height:1.5;padding:32px;background-color:#000!important;color:#fff!important;top:0!important;left:0!important;right:0!important;bottom:0!important;-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important;text-align:center!important;display:none!important}.i-amphtml-story-unsupported-browser-overlay .i-amphtml-story-overlay-text{color:#fff!important}.i-amphtml-story-unsupported-browser-overlay{display:-ms-flexbox!important;display:flex!important}.i-amphtml-gear-icon{background-repeat:no-repeat!important;background-position:50%!important;border-radius:50%!important;background-color:#fff!important;padding:16px!important;height:24px!important;width:24px!important;margin:16px auto!important;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 20 20'%3E%3Cpath fill='none' d='M0 0h20v20H0V0z'/%3E%3Cpath d='M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34a.4.4 0 00-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z'/%3E%3C/svg%3E\")!important}.i-amphtml-continue-button{border-radius:20px;font-family:Roboto,sans-serif;color:#000;font-weight:400!important;font-size:16px;background:#fff;padding:10px 20px;border:2px solid #aaa;text-decoration:none;display:block;margin-top:25px;margin-right:auto;margin-left:auto;-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important;text-align:center!important}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-unsupported-browser-layer.css*/";
exports.CSS = CSS;

},{}],11:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CSS = void 0;
var CSS = ":host{all:initial!important;color:initial!important}.i-amphtml-story-no-rotation-overlay{position:absolute!important;z-index:200000!important;font-family:Roboto,sans-serif!important;font-size:20px!important;font-weight:700!important;line-height:1.5!important;padding:32px!important;background-color:#000!important;color:#fff!important;top:0!important;left:0!important;right:0!important;bottom:0!important;-ms-flex-align:center!important;align-items:center!important;-ms-flex-pack:center!important;justify-content:center!important;text-align:center!important;display:none!important}.i-amphtml-story-no-rotation-overlay .i-amphtml-story-overlay-text{color:#fff!important}.i-amphtml-story-landscape.i-amphtml-story-no-rotation-overlay{display:-ms-flexbox!important;display:flex!important}.i-amphtml-desktop-size-icon,.i-amphtml-rotate-icon{background-repeat:no-repeat!important;background-position:50%!important;border-radius:50%!important;background-color:#fff!important;padding:16px!important;height:24px!important;width:24px!important;margin:16px auto!important}.i-amphtml-rotate-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77a1.49 1.49 0 00-2.12 0L1.75 8.11a1.49 1.49 0 000 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z'/%3E%3C/svg%3E\")!important}.i-amphtml-desktop-size-icon{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z'/%3E%3C/svg%3E\")!important}\n/*# sourceURL=/extensions/amp-story/1.0/amp-story-viewport-warning-layer.css*/";
exports.CSS = CSS;

},{}],12:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isAllowlistedProp = isAllowlistedProp;
exports.WebAnimationTimingFill = exports.WebAnimationTimingDirection = exports.WebAnimationPlayState = exports.WebAnimationBuilderOptionsDef = exports.WebAnimationSubtargetDef = exports.WebAnimationSelectorDef = exports.WebAnimationConditionalDef = exports.WebAnimationVarsDef = exports.WebAnimationTimingDef = exports.WebKeyframesDef = exports.WebKeyframeAnimationDef = exports.WebCompAnimationDef = exports.WebSwitchAnimationDef = exports.WebMultiAnimationDef = exports.WebAnimationDef = exports.InternalWebAnimationRequestDef = void 0;

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// WARNING
// WARNING
// WARNING
// WARNING
// File must be synced with amp.extens.js

/**
 * A struct for parameters for `Element.animate` call.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Element/animate
 *
 * @typedef {{
 *   target: !Element,
 *   keyframes: !WebKeyframesDef,
 *   vars: ?Object<string, *>,
 *   timing: !WebAnimationTimingDef,
 * }}
 */
var InternalWebAnimationRequestDef;
exports.InternalWebAnimationRequestDef = InternalWebAnimationRequestDef;

/**
 * @typedef {
 *   !WebMultiAnimationDef|
 *   !WebSwitchAnimationDef|
 *   !WebCompAnimationDef|
 *   !WebKeyframeAnimationDef
 * }
 */
var WebAnimationDef;
exports.WebAnimationDef = WebAnimationDef;

/**
 * @mixes WebAnimationSelectorDef
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @mixes WebAnimationConditionalDef
 * @typedef {{
 *   animations: !Array<!WebAnimationDef>,
 * }}
 */
var WebMultiAnimationDef;
exports.WebMultiAnimationDef = WebMultiAnimationDef;

/**
 * @mixes WebAnimationSelectorDef
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @mixes WebAnimationConditionalDef
 * @typedef {{
 *   switch: !Array<!WebAnimationDef>,
 * }}
 */
var WebSwitchAnimationDef;
exports.WebSwitchAnimationDef = WebSwitchAnimationDef;

/**
 * @mixes WebAnimationSelectorDef
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @mixes WebAnimationConditionalDef
 * @typedef {{
 *   animation: string,
 * }}
 */
var WebCompAnimationDef;
exports.WebCompAnimationDef = WebCompAnimationDef;

/**
 * @mixes WebAnimationSelectorDef
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @mixes WebAnimationConditionalDef
 * @typedef {{
 *   keyframes: (string|!WebKeyframesDef),
 * }}
 */
var WebKeyframeAnimationDef;
exports.WebKeyframeAnimationDef = WebKeyframeAnimationDef;

/**
 * @typedef {!Object<string, *>|!Array<!Object<string, *>>}
 */
var WebKeyframesDef;
exports.WebKeyframesDef = WebKeyframesDef;

/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/AnimationEffectTimingProperties
 *
 * @mixin
 * @typedef {{
 *   duration: (time|undefined),
 *   delay: (time|undefined),
 *   endDelay: (time|undefined),
 *   iterations: (number|string|undefined),
 *   iterationStart: (number|undefined),
 *   easing: (string|undefined),
 *   direction: (!WebAnimationTimingDirection|undefined),
 *   fill: (!WebAnimationTimingFill|undefined),
 * }}
 */
var WebAnimationTimingDef;
exports.WebAnimationTimingDef = WebAnimationTimingDef;

/**
 * Indicates an extension to a type that allows specifying vars. Vars are
 * specified as properties with the name in the format of `--varName`.
 *
 * @mixin
 * @typedef {Object}
 */
var WebAnimationVarsDef;
exports.WebAnimationVarsDef = WebAnimationVarsDef;

/**
 * Defines media parameters for an animation.
 *
 * @mixin
 * @typedef {{
 *   media: (string|undefined),
 *   supports: (string|undefined),
 * }}
 */
var WebAnimationConditionalDef;
exports.WebAnimationConditionalDef = WebAnimationConditionalDef;

/**
 * @typedef {{
 *   target: (!Element|undefined),
 *   selector: (string|undefined),
 *   subtargets: (!Array<!WebAnimationSubtargetDef>|undefined),
 * }}
 */
var WebAnimationSelectorDef;
exports.WebAnimationSelectorDef = WebAnimationSelectorDef;

/**
 * @mixes WebAnimationTimingDef
 * @mixes WebAnimationVarsDef
 * @typedef {{
 *   matcher: (function(!Element, number):boolean|undefined),
 *   index: (number|undefined),
 *   selector: (string|undefined),
 * }}
 */
var WebAnimationSubtargetDef;
exports.WebAnimationSubtargetDef = WebAnimationSubtargetDef;

/**
 * @typedef {{
 *   scope: (!Element|undefined),
 *   scaleByScope: (boolean|undefined),
 * }}
 *
 * - scope delimits selectors.
 * - scaleByScope determines that CSS resolution should treat the scope
 *   element as a virtual viewport, so that:
 *   1. vw/vh units are relative to the scope's size
 *   2. element's x() and y() coords are relative to the scope's top-left corner
 *   3. element's size and position (width()/height()/x()/y()) are inversely
 *      relative to the scope's transformed scale, e.g. if the scope is scaled
 *      to 90%, the element's dimensions will be returned as if it was unscaled
 *      to 100%.
 */
var WebAnimationBuilderOptionsDef;
exports.WebAnimationBuilderOptionsDef = WebAnimationBuilderOptionsDef;

/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/Animation/playState
 * @enum {string}
 */
var WebAnimationPlayState = {
  IDLE: 'idle',
  PENDING: 'pending',
  RUNNING: 'running',
  PAUSED: 'paused',
  FINISHED: 'finished'
};
exports.WebAnimationPlayState = WebAnimationPlayState;

/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/AnimationEffectTimingProperties/direction
 * @enum {string}
 */
var WebAnimationTimingDirection = {
  NORMAL: 'normal',
  REVERSE: 'reverse',
  ALTERNATE: 'alternate',
  ALTERNATE_REVERSE: 'alternate-reverse'
};
exports.WebAnimationTimingDirection = WebAnimationTimingDirection;

/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/AnimationEffectTimingProperties/fill
 * @enum {string}
 */
var WebAnimationTimingFill = {
  NONE: 'none',
  FORWARDS: 'forwards',
  BACKWARDS: 'backwards',
  BOTH: 'both',
  AUTO: 'auto'
};
exports.WebAnimationTimingFill = WebAnimationTimingFill;

/** @const {!Object<string, boolean>} */
var ALLOWLISTED_PROPS = {
  'opacity': true,
  'transform': true,
  'transform-origin': true,
  'visibility': true,
  'offset-distance': true,
  'offsetDistance': true,
  'clip-path': true,
  'clipPath': true
};

/**
 * @param {string} prop
 * @return {boolean}
 */
function isAllowlistedProp(prop) {
  return ALLOWLISTED_PROPS[prop] || false;
}

},{}],13:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for ar strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'إيقاف الصوت'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'لا تحتوي هذه الصفحة على أي محتوى صوتي'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'تم تفعيل الصوت'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'قراءة المزيد'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'تعديل إعدادات خصوصية البيانات'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'إعدادات الخصوصية'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'قبول'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'رفض'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'المتابعة على أي حال'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'العرض على النطاق الأصلي:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'المزيد عن نتائج AMP'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'انقر على "التالي"'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'انقر على "رجوع"'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'التمرير سريعًا لأعلى'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'تشغيل الفيديو'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'تعذّر نسخ الرابط إلى الحافظة :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'تمّ نسخ الرابط.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'البريد إلكتروني'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: '+Google'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'الحصول على الرابط'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'توسيع التغريدة'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'يمكنك توسيع النافذة طولاً لاستعراض هذه التجربة.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'يمكنك توسيع النافذة طولاً وعرضًا لاستعراض هذه التجربة.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'يمكنك توسيع النافذة عرضًا لاستعراض هذه التجربة.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'يجب تفعيل تجربة سجلّ AMP لعرض هذا المحتوى.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'للحصول على أفضل عرض، يمكن استعراض الصفحة في الوضع الرأسي.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'عذرًا، يبدو أن متصفّحك لا يوفّر هذه التجربة.'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],14:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for de strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Ton aus'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Diese Seite hat keinen Ton'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Ton an'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Weitere Artikel'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Datenschutzeinstellungen ändern'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Datenschutzeinstellungen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Annehmen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Ablehnen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Trotzdem fortfahren'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'In ursprünglicher Domain ansehen:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Weitere Informationen zu AMP-Ergebnissen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Auf "Weiter" tippen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Auf "Zurück" tippen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Nach oben wischen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Video abspielen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Der Link konnte nicht in die Zwischenablage kopiert werden'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Link kopiert.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'E-Mail'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Link abrufen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Tweet maximieren'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Maximiere die Höhe deines Fensters, um diese Funktion nutzen zu ' + 'können'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Maximiere die Höhe und Breite deines Fensters, um diese ' + 'Funktion nutzen zu können'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Maximiere die Breite deines Fensters, um diese Funktion nutzen ' + 'zu können'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Wenn du diesen Inhalt aufrufen möchtest, musst du den ' + 'amp-story-Test aktivieren.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'Diese Seite lässt sich am besten im Hochformat ansehen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Dein aktueller Browser unterstützt diese Funktion leider nicht.'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],15:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for English strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Sound off'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Sound on'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'This page has no sound'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'More to read'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Privacy settings'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Change data privacy settings'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Accept'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Decline'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Continue Anyway'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'View on original domain:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'More about AMP results'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_SWIPE_PROGRESS] = {
  string: 'Tip 2/2'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_SWIPE_INSTRUCTIONS] = {
  string: 'Swipe to go to the next story'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_SWIPE_DISMISS] = {
  string: 'Got it'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_TAP_PROGRESS] = {
  string: 'Tip 1/2'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_TAP_PROGRESS_SINGLE] = {
  string: 'Tip'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_TAP_INSTRUCTIONS] = {
  string: 'Tap to go to the next screen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_TAP_DISMISS] = {
  string: 'Next'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HAS_NEW_PAGE_TEXT] = {
  string: 'Updated'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_QUIZ_ANSWER_CHOICE_A] = {
  string: 'A'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_QUIZ_ANSWER_CHOICE_B] = {
  string: 'B'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_QUIZ_ANSWER_CHOICE_C] = {
  string: 'C'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_QUIZ_ANSWER_CHOICE_D] = {
  string: 'D'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: ':('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Expand the height of your window to view this experience'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Expand both the height and width of your window to view this ' + 'experience'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Expand the width of your window to view this experience'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'You must enable the amp-story experiment to view this content.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'The page is best viewed in portrait mode'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: "We're sorry, it looks like your browser doesn't support " + 'this experience'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],16:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for en-GB strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Sound off'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'This page has no sound'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Sound on'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'More to read'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Change data privacy settings'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Privacy settings'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Accept'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Decline'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Continue Anyway'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'View on original domain:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'More about AMP results'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Tap Next'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Tap Back'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Swipe up'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Play video'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Could not copy link to clipboard :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Link copied!'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'Email'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Get Link'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Expand Tweet'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Expand the height of your window to view this experience'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Expand both the height and width of your window to view this ' + 'experience'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Expand the width of your window to view this experience'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'You must enable the amp-story experiment to view this content.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'The page is best viewed in portrait mode'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: "We're sorry, it looks like your browser doesn't support this " + 'experience'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],17:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for English strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_LABEL] = {
  string: 'Mute story',
  description: 'Label for the mute button that turns off the sound in the story'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Sound off',
  description: 'Text that informs users that the sound is off after they ' + 'click the mute button'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_BUTTON_LABEL] = {
  string: 'Unmute story',
  description: 'Label for the unmute button that turns the sound ' + 'in the story back on'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'This page has no sound',
  description: 'Text that informs users that the sound is on after they ' + 'click the unmute button on a page without sound'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Sound on',
  description: 'Text that informs users that the sound is on after they ' + 'click the unmute button on a page with sound'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'More to read',
  description: 'Label to be placed as a title on top of related articles ' + 'at the end of a story.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Privacy settings',
  description: 'Title for a section that allows the user to configure ' + 'their privacy settings'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Change data privacy settings',
  description: 'Label for a button that allows the user to change their ' + 'choice to consent to providing their cookie access.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Accept',
  description: 'Label for a button that allows the user to consent to ' + 'providing their cookie access.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Decline',
  description: 'Label for a button that allows the user to disconsent to ' + 'providing their cookie access.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Continue Anyway',
  description: 'Button label to allow the user to continue even if they ' + 'are not using a supportive browser.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'View on original domain:',
  description: 'Label for a heading of a dialog that shows the user the ' + 'domain from which the story is served.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'More about AMP results',
  description: 'Label for a link to documentation on how AMP links are handled.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_SWIPE_PROGRESS] = {
  string: 'Tip 2/2',
  description: 'Label for a hint indicating progress on a multistep onboarding user education tutorial.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_SWIPE_INSTRUCTIONS] = {
  string: 'Swipe to go to the next story',
  description: 'Instruction on how to use the product, within an onboarding user education tutorial.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_SWIPE_DISMISS] = {
  string: 'Got it',
  description: 'Label for a button dismissing or advancing to the next step of an onboarding user education tutorial.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_TAP_PROGRESS] = {
  string: 'Tip 1/2',
  description: 'Label for a hint indicating progress on a multistep onboarding user education tutorial.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_TAP_PROGRESS_SINGLE] = {
  string: 'Tip',
  description: 'Label for a hint in the context of an onboarding user education tutorial.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_TAP_INSTRUCTIONS] = {
  string: 'Tap to go to the next screen',
  description: 'Instruction on how to use the product, within an onboarding user education tutorial.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_EDUCATION_NAVIGATION_TAP_DISMISS] = {
  string: 'Next',
  description: 'Label for a button dismissing or advancing to the next step of an onboarding user education tutorial.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HAS_NEW_PAGE_TEXT] = {
  string: 'Updated',
  description: 'Label that indicates that additional content has been added to a story'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Tap Next',
  description: 'Label indicating that users can navigate to the next ' + 'page, in the amp-story hint UI.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Tap Back',
  description: 'Label indicating that users can navigate to the previous ' + 'page, in the amp-story hint UI.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_INFO_BUTTON_LABEL] = {
  string: 'Story information',
  description: 'Label for the information button that pulls up ' + 'relevant information about the story content'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Swipe up',
  description: 'Label for a button to open a drawer containing additional ' + 'content via a "swipe up" user gesture.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGINATION_BUTTON_PREVIOUS_PAGE_LABEL] = {
  string: 'Previous page',
  description: 'Label indicating that users can navigate to the previous page.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ERROR_VIDEO] = {
  string: 'Video failed to play',
  description: 'Label indicating that the video visible on the page failed to play.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Play video',
  description: 'Label for a button to play the video visible on the page.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_QUIZ_ANSWER_CHOICE_A] = {
  string: 'A',
  description: 'Label for the first answer choice from a multiple choice quiz (e.g. A in A/B/C/D)'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_QUIZ_ANSWER_CHOICE_B] = {
  string: 'B',
  description: 'Label for the second answer choice from a multiple choice quiz (e.g. B in A/B/C/D)'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_QUIZ_ANSWER_CHOICE_C] = {
  string: 'C',
  description: 'Label for the third answer choice from a multiple choice quiz (e.g. C in A/B/C/D)'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_QUIZ_ANSWER_CHOICE_D] = {
  string: 'D',
  description: 'Label for the fourth answer choice from a multiple choice quiz (e.g. D in A/B/C/D)'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARE_BUTTON_LABEL] = {
  string: 'Share story',
  description: 'Label for the share button that pulls up a panel ' + 'of options for sharing the story'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PAGE_LABEL] = {
  string: 'Share starting from this page',
  description: 'Checkbox label when the branching experiment is turned on ' + ' and the story is in landscape mode; checking the checkbox lets the ' + 'user share the story from the current page.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Could not copy link to clipboard :(',
  description: 'String shown in a failure message to inform the user that ' + 'a link could not be successfully copied to their clipboard.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Link copied!',
  description: 'String shown in a confirmation message to inform the user ' + 'that a link was successfully copied to their clipboard.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'Email',
  description: 'Button label for the share target that shares a link via email.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook',
  description: 'Button label for the share target that shares a link via Facebook.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+',
  description: 'Button label for the share target that shares a link via Google+.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line',
  description: 'Button label for the share target that shares a link via Line.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Get Link',
  description: 'Button label for the share target that shares a link via ' + "by copying it to the user's clipboard."
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn',
  description: 'Button label for the share target that shares a link via LinkedIn.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest',
  description: 'Button label for the share target that shares a link via ' + 'Pinterest.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS',
  description: 'Button label for the share target that shares a link via SMS.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SYSTEM] = {
  string: 'More',
  description: 'Button label for the share target that shares a link via ' + "deferral to the operating system's native sharing handler."
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr',
  description: 'Button label for the share target that shares a link via Tumblr.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter',
  description: 'Button label for the share target that shares a link via Twitter.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp',
  description: 'Button label for the share target that shares a link via WhatsApp.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SIDEBAR_BUTTON_LABEL] = {
  string: 'Toggle story menu',
  description: 'Label for the sidebar button that pulls up a menu ' + 'of options for interacting with the story'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Expand Tweet',
  description: 'Label in the tooltip text for when a Twitter embed is expandable.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Expand the height of your window to view this experience',
  description: 'Text for a warning screen that informs the user that ' + 'stories are only supported in taller browser windows.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Expand both the height and width of your window to view this ' + 'experience',
  description: 'Text for a warning screen that informs the user that ' + 'stories are only supported in larger browser windows.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Expand the width of your window to view this experience',
  description: 'Text for a warning screen that informs the user that ' + 'stories are only supported in wider browser windows.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'You must enable the amp-story experiment to view this content.',
  description: 'Text for a warning screen that informs the user that ' + 'they must enable an experiment to use stories.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'The page is best viewed in portrait mode',
  description: 'Text for a warning screen that informs the user that ' + 'stories are only supported in portrait orientation.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: "We're sorry, it looks like your browser doesn't support " + 'this experience',
  description: 'Text for a warning screen that informs the user that ' + 'their browser does not support stories.'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],18:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for es-419 strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Sonido desactivado'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Esta página no tiene sonido'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Sonido activado'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Más para leer'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Cambiar la configuración de privacidad de los datos'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Configuración de privacidad'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Aceptar'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Rechazar'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Continuar de todos modos'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Ver en el dominio original:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Más información sobre los resultados de AMP'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Presiona Siguiente'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Presiona Atrás'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Deslizar el dedo hacia arriba'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Reproducir video'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'No se pudo copiar el vínculo en el portapapeles :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Se copió el vínculo.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'Correo electrónico'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Obtener vínculo'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Expandir tweet'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Expande la altura de la ventana para ver esta experiencia'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Expande el ancho y la altura de la ventana para ver esta ' + 'experiencia'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Expande el ancho de la ventana para ver esta experiencia'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Debes habilitar el experimento de historia en formato AMP para ' + 'ver este contenido.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'La página está optimizada para verse en orientación vertical.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Parece que el navegador no es compatible con esta experiencia'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],19:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for es strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Sonido desactivado'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Esta página no tiene sonido'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Sonido activado'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Más lecturas'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Cambiar configuración de privacidad de datos'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Configuración de privacidad'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Aceptar'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Rechazar'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Continuar de todos modos'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Ver en dominio original:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Más información sobre los resultados de AMP'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Toca Siguiente'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Toca Atrás'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Deslizar el dedo hacia arriba'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Reproducir vídeo'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'No se ha podido copiar el enlace en el portapapeles :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Se ha copiado el enlace.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'Correo electrónico'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Obtener enlace'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Mostrar tuit'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Amplía el alto de la ventana para ver esta experiencia'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Amplía el alto y el ancho de la ventana para ver esta experiencia'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Amplía el ancho de la ventana para ver esta experiencia'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Para ver este contenido, debes habilitar el experimento de ' + 'historia AMP.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'La página se visualiza mejor en modo vertical'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Parece que este servicio no está disponible para tu navegador'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],20:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for fr strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Son désactivé'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: "Cette page n'a pas de son"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Son activé'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Autres articles à lire'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Modifier les paramètres de confidentialité des données'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Paramètres de confidentialité'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Accepter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Refuser'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Continuer quand même'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: "Afficher sur le domaine d'origine :"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'En savoir plus sur les résultats AMP'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Appuyer sur Suivant'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Appuyer sur Retour'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: "Balayer l'écran vers le haut"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Regarder la vidéo'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Impossible de copier le lien dans le presse-papiers :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Lien copié.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'E-mail'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Obtenir le lien'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Développer le tweet'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Augmentez la hauteur de votre fenêtre pour voir cette expérience'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Modifiez la hauteur et la largeur de la fenêtre pour voir cette ' + 'expérience'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Élargissez la fenêtre pour voir cette expérience'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: "Vous devez activer l'expérience story AMP pour voir ce contenu."
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: "La page s'affiche mieux en mode Portrait"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: "Nous sommes désolés, mais votre navigateur n'est pas " + 'compatible avec cette expérience'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],21:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for hi strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'आवाज़ बंद है'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'इस पेज में कोई आवाज़ नहीं है'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'आवाज़ चालू है'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'ये भी पढ़ें'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'डेटा की निजता सेटिंग बदलें'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'निजता सेटिंग'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'स्वीकार करें'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'अस्वीकार करें'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'फिर भी जारी रखें'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'मूल डोमेन पर देखें:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'एएमपी नतीजों के बारे में ज़्यादा जानें'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: "'अगला' पर टैप करें"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: "'वापस जाएं' पर टैप करें"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'ऊपर की ओर स्वाइप करें'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'वीडियो चलाएं'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'लिंक क्लिपबोर्ड पर कॉपी नहीं किया जा सका :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'लिंक कॉपी किया गया!'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'ईमेल'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'लिंक पाएं'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'मैसेज (एसएमएस)'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'ट्वीट को बड़ा करके देखें'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'इस वर्शन को देखने के लिए अपनी विंडो की लंबाई बढ़ाएं'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'यह वर्शन देखने के लिए अपनी विंडो की लंबाई और चौड़ाई, दोनों को ' + 'बढ़ाएं'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'यह वर्शन देखने के लिए अपनी विंडो की चौड़ाई बढ़ाएं'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'यह सामग्री देखने के लिए आपको एएमपी-कहानी की परफ़ॉर्मेंस जाँच ' + 'चालू करनी होगी.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'यह पेज पोर्ट्रेट मोड में सबसे अच्छा दिखाई देता है'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'माफ़ करें, लगता है कि आपका ब्राउज़र इस वर्शन पर काम नहीं करता'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],22:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for id strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Suara nonaktif'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Suara tidak aktif di halaman ini'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Suara aktif'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Artikel lain untuk dibaca'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Ubah setelan privasi data'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Setelan privasi'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Setuju'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Tolak'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Tetap Lanjutkan'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Lihat di domain asal:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Lebih lanjut tentang hasil AMP'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Tap Berikutnya'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Tap Kembali.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Geser ke atas'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Putar video'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Tidak dapat menyalin link ke papan klip :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Link disalin!'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'Email'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Dapatkan Link'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Luaskan Tweet'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Luaskan tinggi jendela untuk menampilkan pengalaman ini'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Luaskan tinggi dan lebar jendela untuk menampilkan pengalaman ini'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Luaskan lebar jendela untuk menampilkan pengalaman ini'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Anda harus mengaktifkan eksperimen cerita AMP untuk melihat ' + 'konten ini.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'Halaman ini ditampilkan paling baik dalam mode potret'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Maaf, sepertinya browser Anda tidak mendukung pengalaman ini'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],23:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for it strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Audio disattivato'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Questa pagina non ha audio'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Audio attivo'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Altri articoli da leggere'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Modifica le impostazioni per la privacy dei dati'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Impostazioni sulla privacy'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Accetta'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Rifiuta'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Continua comunque'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Visualizza sul dominio originale:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Ulteriori informazioni sui risultati AMP'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Tocca Avanti'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Tocca Indietro'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: "Scorri verso l'alto"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Riproduci video'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Impossibile copiare il link negli appunti :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Link copiato.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'Email'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Ottieni link'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Espandi tweet'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: "Espandi l'altezza della finestra per visualizzare questa " + 'esperienza'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: "Espandi sia l'altezza che la larghezza della finestra per " + 'visualizzare questa esperienza'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Espandi la larghezza della finestra per visualizzare questa ' + 'esperienza'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: "Devi attivare l'esperimento di storia AMP per visualizzare " + 'questi contenuti.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'La pagina viene visualizzata in modo ottimale in orientamento ' + 'verticale'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Spiacenti, sembra che il tuo browser non supporti questa ' + 'esperienza'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],24:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for ja strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'サウンドはオフです'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'このページには音声がありません'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'サウンドオン'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'その他のおすすめ'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'データのプライバシー設定を変更'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'プライバシー設定'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: '同意する'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: '同意しない'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: '続行する'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: '元のドメインで表示:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'AMP の結果に関する詳細'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: '[次へ] をタップ'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: '戻るアイコンをタップ'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: '上にスワイプ'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: '動画を再生'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'リンクをクリップボードにコピーできませんでした。'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'リンクをコピーしました'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'メール'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'リンクを取得'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'ツイートを展開'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'この記事を表示するには、ウィンドウの高さを拡大してください'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'この記事を表示するには、ウィンドウの高さと幅の両方を拡大してください'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'この記事を表示するには、ウィンドウの幅を拡大してください'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'このコンテンツを表示するには amp-story テストを有効にする必要があります。'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'このページはポートレート モードで最適に表示されます'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'ご利用のブラウザはこの記事に対応していません'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],25:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for ko strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: '사운드 꺼짐'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: '이 페이지에는 사운드가 없습니다.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: '사운드 켜짐'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: '더 읽기'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: '데이터 공개 설정 변경'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: '공개 설정'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: '수락'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: '거부'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: '계속하기'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: '원래 도메인에서 보기:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'AMP 결과 자세히 알아보기'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: '다음을 탭하세요.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: '뒤로를 탭하세요.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: '위로 스와이프'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: '동영상 재생'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: '링크를 클립보드에 복사할 수 없습니다.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: '링크가 복사되었습니다.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: '이메일'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: '링크 받기'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: '트윗 펼치기'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: '이 환경을 보려면 창 높이를 늘리세요.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: '이 환경을 보려면 창 높이와 너비를 늘리세요.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: '이 환경을 보려면 창 너비를 늘리세요.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: '이 콘텐츠를 보려면 amp-story 실험을 사용하도록 설정해야 합니다.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: '이 페이지는 세로 모드에서 가장 잘 표시됩니다.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: '사용 중인 브라우저에서 이 환경을 지원하지 않는 것 같습니다.'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],26:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for nl strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Geluid uit'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Deze pagina heeft geen geluid'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Geluid aan'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Meer om te lezen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Privacyinstellingen voor gegevens wijzigen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Privacyinstellingen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Accepteren'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Weigeren'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Toch doorgaan'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Bekijken op oorspronkelijk domein:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Meer over AMP-resultaten'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Tik op Volgende'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Tik op Terug'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Omhoog vegen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Video afspelen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Kan link niet kopiëren naar klembord :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Link gekopieerd'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'E-mail'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Link ophalen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'Sms'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Tweet uitvouwen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Maak je venster hoger om deze functionaliteit te bekijken'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Maak je venster hoger en breder om deze functionaliteit te ' + 'bekijken'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Maak je venster breder om deze functionaliteit te bekijken'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Je moet het amp-story-experiment inschakelen om deze content te ' + 'bekijken.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'De pagina kan het beste worden bekeken in de staande modus'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Je browser ondersteunt deze functionaliteit niet'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],27:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for no strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Lyd av'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Denne siden har ikke noe lyd'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Lyd på'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Mer å lese'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Endre personverninnstillingene for data'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Personverninnstillinger'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Godta'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Avslå'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Fortsett likevel'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Se på det opprinnelige domenet:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Mer om AMP-resultater'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Trykk på Neste'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Trykk på Tilbake'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Sveip opp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Spill av videoen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Kunne ikke kopiere linken til utklippstavlen :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Linken er kopiert.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'E-post'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Hent linken'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Vis Twitter-meldingen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Gjør vinduet ditt større for å se denne opplevelsen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Gjør vinduet ditt større for å se denne opplevelsen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Gjør vinduet ditt bredere for å se denne opplevelsen'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Du må aktivere eksperimentet med AMP-snuttsamlinger for å se ' + 'dette innholdet.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'Den beste visningen av siden er i stående retning'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Beklager, men det ser ut til at nettleseren din ikke støtter ' + 'denne opplevelsen'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],28:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for pt-BR strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Som desativado'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Esta página não tem som'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Som ativado'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Leituras sugeridas'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Alterar as configurações de privacidade de dados'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Configurações de privacidade'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Aceitar'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Recusar'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Continuar mesmo assim'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Ver no domínio original:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Mais sobre resultados de AMP'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Toque em "Próxima"'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Toque em "Voltar"'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Deslizar para cima'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Assistir vídeo'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Não foi possível copiar o link para a área de transferência :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Link copiado'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'E-mail'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Copiar link'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Expandir tweet'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Aumente a altura da janela para ver esta experiência'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Aumente a altura e largura da janela para ver esta experiência'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Aumente a largura da janela para ver esta experiência'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Você precisa ativar o experimento amp-story para ver este ' + 'conteúdo.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'Melhor visualização da página no modo retrato'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Parece que o navegador não é compatível com esta experiência'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],29:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for pt-PT strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Som desativado'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Esta página não tem som.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Som ativado'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Mais para ler'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Alterar as definições de privacidade dos dados'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Definições de privacidade'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Aceitar'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Recusar'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Continuar mesmo assim'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Veja no domínio original:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Mais acerca dos resultados AMP'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Toque em Seguinte.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Toque em Anterior'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Deslizar rapidamente para cima'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Reproduzir vídeo'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Não foi possível copiar o link para a área de transferência :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Link copiado!'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'Email'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Obter link'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Expandir twit'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Expanda a altura da janela para ver esta experiência.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Expanda a altura e a largura da sua janela para ver esta ' + 'experiência.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Expanda a largura da janela para ver esta experiência.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Tem de ativar a experiência da história AMP para ver este ' + 'conteúdo.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'Conseguirá visualizar melhor esta página no modo retrato.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Lamentamos, mas parece que o seu navegador não suporta esta ' + 'experiência.'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],30:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for ru strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Звук отключен'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'В контенте на странице нет звука.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Звук включен'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Ещё статьи'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Настройки доступа к данным'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Настройки доступа.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Принять'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Отклонить'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Все равно продолжить'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Исходный домен:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Сведения о AMP-результатах'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Нажмите "Далее"'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Нажмите "Назад"'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Провести вверх'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Воспроизвести видео'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Не удалось скопировать ссылку в буфер обмена.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Ссылка скопирована'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'По электронной почте'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Получить ссылку'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Твиттер'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Развернуть твит'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Увеличьте высоту окна браузера, чтобы посмотреть контент.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Увеличьте высоту и ширину окна браузера, чтобы посмотреть контент.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Увеличьте ширину окна браузера, чтобы посмотреть контент.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Для доступа к этому контенту нужно включить эксперимент с ' + 'AMP-историями.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'Страница доступна только в вертикальной ориентации.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Ваш браузер не поддерживает эту функцию.'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],31:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for tr strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Ses kapalı'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Bu sayfada ses yok'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Ses açık'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Okuyabileceğiniz diğer makaleler'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Veri gizlilik ayarlarını değiştir'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Gizlilik ayarları'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Kabul et'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Reddet'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Yine de Devam Et'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Orijinal alanda görüntüle:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'AMP sonuçları hakkında daha fazla bilgi'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: "Sonraki'ye dokunun"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: "Geri'ye dokunun"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Yukarı kaydır'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Videoyu oynat'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Bağlantı panoya kopyalanamadı :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Bağlantı kopyalandı!'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'E-posta'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Bağlantıyı Al'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: "Tweet'i genişlet"
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Bu deneyimi görebilmek için pencerenizin yüksekliğini artırın'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Bu deneyimi görebilmek için pencerenizin hem yüksekliğini hem ' + 'de genişliğini artırın'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Bu deneyimi görebilmek için pencerenizin genişliğini artırın'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Bu içeriği görebilmek için amp hikayesi deneyimini ' + 'etkinleştirmeniz gerekir.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'Sayfa en iyi dikey modda görüntülenir'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Maalesef tarayıcınız bu deneyimi desteklemiyor gibi görünüyor'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],32:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for vi strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: 'Tắt âm thanh'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: 'Trang này không có âm thanh'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: 'Bật âm thanh'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: 'Những nội dung khác nên đọc'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: 'Thay đổi dữ liệu các tùy chọn cài đặt bảo mật'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: 'Các tùy chọn cài đặt quyền riêng tư'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: 'Chấp nhận'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: 'Từ chối'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: 'Vẫn tiếp tục'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: 'Xem trên miền gốc:'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: 'Thêm thông tin về kết quả AMP'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: 'Nhấn vào Tiếp theo'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: 'Nhấn vào Quay lại'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: 'Vuốt lên'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: 'Phát video'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: 'Không thể sao chép liên kết vào khay nhớ tạm :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: 'Đã sao chép liên kết!'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: 'Email'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: 'Lấy liên kết'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: 'SMS'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: 'Mở rộng Tweet'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: 'Mở rộng chiều cao cửa sổ để xem trải nghiệm này'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: 'Mở rộng cả chiều cao và chiều rộng cửa sổ để xem trải nghiệm này'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: 'Mở rộng chiều rộng cửa sổ để xem trải nghiệm này'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: 'Bạn cần phải bật thử nghiệm câu chuyện amp để xem nội dung này.'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: 'Trang này được xem tốt nhất ở chế độ chân dung'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: 'Rất tiếc, có vẻ như trình duyệt của bạn không hỗ trợ trải ' + 'nghiệm này'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],33:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for zh-CN strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: '声音已关闭'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: '此页没有声音'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: '声音已开启'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: '阅读更多内容'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: '更改数据隐私设置'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: '隐私权设置'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: '接受'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: '拒绝'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: '仍然继续'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: '在原始网域中查看：'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: '关于 AMP 结果的更多内容'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: '点按“下一页”'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: '点按“返回”'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: '向上滑动'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: '播放视频'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: '无法将链接复制到剪贴板 :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: '已复制链接！'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: '电子邮件'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: '获取链接'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: '短信'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: '展开 Twitter 微博'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: '要查看这种体验，请加大窗口高度'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: '要查看这种体验，请同时加大窗口高度和宽度'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: '要查看这种体验，请加大窗口宽度'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: '您必须启用 amp-story 实验性功能，才能查看此内容。'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: '最好以纵向模式查看此页面'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: '抱歉，您的浏览器好像不支持这种体验'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],34:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.default = void 0;

var _localizedStrings = require("../../../../src/localized-strings");

var _strings;

/**
 * Localized string bundle used for zh-TW strings.
 * @const {!LocalizedStringBundleDef}
 */
var strings = (_strings = {}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT] = {
  string: '已關閉音效'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT] = {
  string: '這個頁面沒有音效'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT] = {
  string: '已開啟音效'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL] = {
  string: '閱讀更多相關文章'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL] = {
  string: '變更資料隱私權設定'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE] = {
  string: '隱私權設定'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL] = {
  string: '接受'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL] = {
  string: '拒絕'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL] = {
  string: '仍要繼續'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL] = {
  string: '在原始網域中查看：'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK] = {
  string: '更多與 AMP 結果相關的資訊'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL] = {
  string: '輕觸 [下一頁]'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL] = {
  string: '輕觸 [上一頁]'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL] = {
  string: '向上滑動'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO] = {
  string: '播放影片'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT] = {
  string: '無法將連結複製到剪貼簿 :('
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT] = {
  string: '已複製連結！'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL] = {
  string: '電子郵件'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK] = {
  string: 'Facebook'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS] = {
  string: 'Google+'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE] = {
  string: 'Line'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK] = {
  string: '取得連結'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN] = {
  string: 'LinkedIn'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST] = {
  string: 'Pinterest'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS] = {
  string: '簡訊'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR] = {
  string: 'Tumblr'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER] = {
  string: 'Twitter'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP] = {
  string: 'WhatsApp'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET] = {
  string: '展開 Tweet'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT] = {
  string: '如要查看故事，請將視窗高度調高'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT] = {
  string: '如要查看故事，請將視窗調高並調寬'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT] = {
  string: '如要查看故事，請將視窗寬度調寬'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT] = {
  string: '你必須啟用 AMP 故事實驗才能查看此內容。'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT] = {
  string: '你只能縱向查看這個頁面'
}, _strings[_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT] = {
  string: '很抱歉，你的瀏覽器不支援這項服務'
}, _strings);
var _default = strings;
exports.default = _default;

},{"../../../../src/localized-strings":122}],35:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryAccess = exports.Type = void 0;

var _ampStoryStoreService = require("./amp-story-store-service");

var _layout = require("../../../src/layout");

var _url = require("../../../src/url");

var _dom = require("../../../src/dom");

var _log = require("../../../src/log");

var _staticTemplate = require("../../../src/static-template");

var _types = require("../../../src/types");

var _json = require("../../../src/json");

var _style = require("../../../src/style");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      <div class=\"i-amphtml-story-access-overflow\">\n        <div class=\"i-amphtml-story-access-container\">\n          <div class=\"i-amphtml-story-access-content\">\n            <span class=\"i-amphtml-story-access-close-button\" role=\"button\">\n              &times;\n            </span>\n          </div>\n        </div>\n      </div>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <div class=\"i-amphtml-story-access-overflow\">\n        <div class=\"i-amphtml-story-access-container\">\n          <div class=\"i-amphtml-story-access-header\">\n            <div class=\"i-amphtml-story-access-logo\"></div>\n          </div>\n          <div class=\"i-amphtml-story-access-content\"></div>\n        </div>\n      </div>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/** @const {string} */
var TAG = 'amp-story-access';

/**
 * @enum {string}
 */
var Type = {
  BLOCKING: 'blocking',
  NOTIFICATION: 'notification'
};
exports.Type = Type;

/**
 * Story access blocking type template.
 * @param {!Element} element
 * @return {!Element}
 */
var getBlockingTemplate = function getBlockingTemplate(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject());
};

/**
 * Story access notification type template.
 * @param {!Element} element
 * @return {!Element}
 */
var getNotificationTemplate = function getNotificationTemplate(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject2());
};

/**
 * The <amp-story-access> custom element.
 */
var AmpStoryAccess = /*#__PURE__*/function (_AMP$BaseElement) {
  _inherits(AmpStoryAccess, _AMP$BaseElement);

  var _super = _createSuper(AmpStoryAccess);

  /** @param {!AmpElement} element */
  function AmpStoryAccess(element) {
    var _this;

    _classCallCheck(this, AmpStoryAccess);

    _this = _super.call(this, element);

    /** @private {?Element} */
    _this.containerEl_ = null;

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    _this.storeService_ = (0, _ampStoryStoreService.getStoreService)(_this.win);
    return _this;
  }

  /** @override */
  _createClass(AmpStoryAccess, [{
    key: "buildCallback",
    value: function buildCallback() {
      // Defaults to blocking paywall.
      if (!this.element.hasAttribute('type')) {
        this.element.setAttribute('type', Type.BLOCKING);
      }

      var drawerEl = this.renderDrawerEl_();
      this.containerEl_ = (0, _log.dev)().assertElement(drawerEl.querySelector('.i-amphtml-story-access-container'));
      var contentEl = (0, _log.dev)().assertElement(drawerEl.querySelector('.i-amphtml-story-access-content'));
      (0, _dom.copyChildren)(this.element, contentEl);
      (0, _dom.removeChildren)(this.element);
      this.element.appendChild(drawerEl);
      this.allowlistActions_();
      this.initializeListeners_();
    }
    /** @override */

  }, {
    key: "isLayoutSupported",
    value: function isLayoutSupported(layout) {
      return layout == _layout.Layout.CONTAINER;
    }
    /**
     * @private
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this2 = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.ACCESS_STATE, function (isAccess) {
        _this2.onAccessStateChange_(isAccess);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CURRENT_PAGE_INDEX, function (currentPageIndex) {
        _this2.onCurrentPageIndexChange_(currentPageIndex);
      }, true
      /** callToInitialize */
      );
      this.element.addEventListener('click', function (event) {
        return _this2.onClick_(event);
      });
    }
    /**
     * Reacts to access state updates, and shows/hides the UI accordingly.
     * @param {boolean} isAccess
     * @private
     */

  }, {
    key: "onAccessStateChange_",
    value: function onAccessStateChange_(isAccess) {
      if (this.getType_() === Type.BLOCKING) {
        this.toggle_(isAccess);
      }
    }
    /**
     * Reacts to story active page index update, and maybe display the
     * "notification" story-access.
     * @param {number} currentPageIndex
     */

  }, {
    key: "onCurrentPageIndexChange_",
    value: function onCurrentPageIndexChange_(currentPageIndex) {
      if (this.getType_() === Type.NOTIFICATION) {
        // Only show the notification if on the first page of the story.
        // Note: this can be overriden by an amp-access attribute that might
        // show/hide the notification based on the user's authorizations.
        this.toggle_(currentPageIndex === 0);
      }
    }
    /**
     * Handles click events and maybe closes the paywall.
     * @param {!Event} event
     * @return {*} TODO(#23582): Specify return type
     * @private
     */

  }, {
    key: "onClick_",
    value: function onClick_(event) {
      var _this3 = this;

      var el = (0, _log.dev)().assertElement(event.target);

      if (el.classList.contains('i-amphtml-story-access-close-button')) {
        return this.toggle_(false);
      }

      // Closes the menu if click happened outside of the main container.
      if (!(0, _dom.closest)(el, function (el) {
        return el === _this3.containerEl_;
      }, this.element)) {
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_ACCESS, false);
      }
    }
    /**
     * @param {boolean} show
     * @private
     */

  }, {
    key: "toggle_",
    value: function toggle_(show) {
      var _this4 = this;

      this.mutateElement(function () {
        _this4.element.classList.toggle('i-amphtml-story-access-visible', show);
      });
    }
    /**
     * Returns the element's type.
     * @return {string}
     * @private
     */

  }, {
    key: "getType_",
    value: function getType_() {
      return this.element.getAttribute('type').toLowerCase();
    }
    /**
     * Renders and returns an empty drawer element element that will contain the
     * publisher provided DOM, depending on the type of <amp-story-access>.
     * Blocking template gets a header containing the publisher's logo, and
     * notification template gets a "dismiss" button.
     * @return {!Element|undefined}
     * @private
     */

  }, {
    key: "renderDrawerEl_",
    value: function renderDrawerEl_() {
      switch (this.getType_()) {
        case Type.BLOCKING:
          var drawerEl = getBlockingTemplate(this.element);
          var logoSrc = this.getLogoSrc_();

          if (logoSrc) {
            var logoEl = (0, _log.dev)().assertElement(drawerEl.querySelector('.i-amphtml-story-access-logo'));
            (0, _style.setImportantStyles)(logoEl, {
              'background-image': "url(" + logoSrc + ")"
            });
          }

          return drawerEl;
          break;

        case Type.NOTIFICATION:
          return getNotificationTemplate(this.element);
          break;

        default:
          (0, _log.user)().error(TAG, 'Unknown "type" attribute, expected one of: ' + 'blocking, notification.');
      }
    }
    /**
     * Retrieves the publisher-logo-src set on the <amp-story> element, and
     * validates it's a valid https or relative URL.
     * @return {?string}
     * @private
     */

  }, {
    key: "getLogoSrc_",
    value: function getLogoSrc_() {
      var storyEl = (0, _log.dev)().assertElement((0, _dom.closestAncestorElementBySelector)(this.element, 'AMP-STORY'));
      var logoSrc = storyEl && storyEl.getAttribute('publisher-logo-src');
      logoSrc ? (0, _url.assertHttpsUrl)(logoSrc, storyEl, 'publisher-logo-src') : (0, _log.user)().warn(TAG, 'Expected "publisher-logo-src" attribute on <amp-story>');
      return logoSrc;
    }
    /**
     * Allowlists the <amp-access> actions.
     * Depending on the publisher configuration, actions can be:
     *   - login
     *   - login-<namespace>
     *   - login-<namespace>-<type>
     *
     * Publishers can provide one (object) or multiple (array) configurations,
     * identified by their "namespace" property.
     * Each configuration can have one or multiple login URLs, called "type".
     * All the namespace/type pairs have to be allowlisted.
     * @private
     */

  }, {
    key: "allowlistActions_",
    value: function allowlistActions_() {
      var _this5 = this;

      var accessEl = (0, _log.dev)().assertElement(this.win.document.getElementById('amp-access'), 'Cannot find the amp-access configuration');
      // Configuration validation is handled by the amp-access extension.
      var accessConfig =
      /** @type {!Array|!Object} */
      (0, _json.parseJson)(accessEl.textContent);

      if (!(0, _types.isArray)(accessConfig)) {
        accessConfig = [accessConfig];

        // If there is only one configuration and the publisher provided a
        // namespace, we want to allow actions with or without namespace.
        if (accessConfig[0].namespace) {
          accessConfig.push(_extends({}, accessConfig[0], {
            namespace: undefined
          }));
        }
      }

      var actions = [];

      /** @type {!Array} */
      accessConfig.forEach(function (config) {
        var login =
        /** @type {{login, namespace}} */
        config.login,
            namespace = config.namespace;

        if ((0, _types.isObject)(login)) {
          var types = Object.keys(login);
          types.forEach(function (type) {
            return actions.push(_this5.getActionObject_(namespace, type));
          });
        } else {
          actions.push(_this5.getActionObject_(namespace));
        }
      });
      this.storeService_.dispatch(_ampStoryStoreService.Action.ADD_TO_ACTIONS_ALLOWLIST, actions);
    }
    /**
     * Allowlists an action for the given namespace / type pair.
     * @param {string=} namespace
     * @param {string=} type
     * @return {*} TODO(#23582): Specify return type
     * @private
     */

  }, {
    key: "getActionObject_",
    value: function getActionObject_(namespace, type) {
      if (namespace === void 0) {
        namespace = undefined;
      }

      if (type === void 0) {
        type = undefined;
      }

      var method = ['login', namespace, type].filter(function (s) {
        return !!s;
      }).join('-');
      return {
        tagOrTarget: 'SCRIPT',
        method: method
      };
    }
  }]);

  return AmpStoryAccess;
}(AMP.BaseElement);

exports.AmpStoryAccess = AmpStoryAccess;

},{"../../../src/dom":106,"../../../src/json":120,"../../../src/layout":121,"../../../src/log":123,"../../../src/static-template":135,"../../../src/style":138,"../../../src/types":139,"../../../src/url":142,"./amp-story-store-service":53}],36:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryAffiliateLink = exports.AFFILIATE_LINK_BUILT = exports.AFFILIATE_LINK_SELECTOR = void 0;

var _services = require("../../../src/services");

var _ampStoryStoreService = require("./amp-story-store-service");

var _storyAnalytics = require("./story-analytics");

var _service = require("../../../src/service");

var _staticTemplate = require("../../../src/static-template");

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      <div class=\"i-amphtml-story-affiliate-link-pulse\"></div>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <div class=\"i-amphtml-story-affiliate-link-circle\">\n        <i class=\"i-amphtml-story-affiliate-link-icon\"></i>\n        <div class=\"i-amphtml-story-reset i-amphtml-hidden\">\n          <span class=\"i-amphtml-story-affiliate-link-text\" hidden></span>\n          <i class=\"i-amphtml-story-affiliate-link-launch\" hidden></i>\n        </div>\n      </div>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Links that are affiliate links.
 * @const {string}
 */
var AFFILIATE_LINK_SELECTOR = 'a[affiliate-link-icon]';
exports.AFFILIATE_LINK_SELECTOR = AFFILIATE_LINK_SELECTOR;

/**
 * Custom property signifying a built link.
 * @const {string}
 */
var AFFILIATE_LINK_BUILT = '__AMP_AFFILIATE_LINK_BUILT';
exports.AFFILIATE_LINK_BUILT = AFFILIATE_LINK_BUILT;

var AmpStoryAffiliateLink = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} element
   */
  function AmpStoryAffiliateLink(win, element) {
    _classCallCheck(this, AmpStoryAffiliateLink);

    /** @private {!Window} */
    this.win_ = win;

    /** @private {!Element} */
    this.element_ = element;

    /** @private {?Element} */
    this.textEl_ = null;

    /** @private {?Element} */
    this.launchEl_ = null;

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.win_);

    /** @private {string} */
    this.text_ = this.element_.textContent;

    /** @private @const {!../../../src/service/mutator-interface.MutatorInterface} */
    this.mutator_ = _services.Services.mutatorForDoc((0, _service.getAmpdoc)(this.win_.document));

    /** @private @const {!./story-analytics.StoryAnalyticsService} */
    this.analyticsService_ = (0, _storyAnalytics.getAnalyticsService)(this.win_, element);
  }

  /**
   * Builds affiliate link.
   */
  _createClass(AmpStoryAffiliateLink, [{
    key: "build",
    value: function build() {
      var _this = this;

      if (this.element_[AFFILIATE_LINK_BUILT]) {
        return;
      }

      this.mutator_.mutateElement(this.element_, function () {
        _this.element_.textContent = '';

        _this.element_.setAttribute('pristine', '');

        _this.addPulseElement_();

        _this.addIconElement_();

        _this.addText_();

        _this.addLaunchElement_();
      });
      this.initializeListeners_();
      this.element_[AFFILIATE_LINK_BUILT] = true;
    }
    /**
     * Initializes listeners.
     * @private
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this2 = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.AFFILIATE_LINK_STATE, function (elementToToggleExpand) {
        var expand = _this2.element_ === elementToToggleExpand;

        if (expand) {
          _this2.element_.setAttribute('expanded', '');

          _this2.textEl_.removeAttribute('hidden');

          _this2.launchEl_.removeAttribute('hidden');
        } else {
          _this2.element_.removeAttribute('expanded');

          _this2.textEl_.setAttribute('hidden', '');

          _this2.launchEl_.setAttribute('hidden', '');
        }

        if (expand) {
          _this2.element_.removeAttribute('pristine');

          _this2.analyticsService_.triggerEvent(_storyAnalytics.StoryAnalyticsEvent.FOCUS, _this2.element_);
        }
      });
      this.element_.addEventListener('click', function (event) {
        if (_this2.element_.hasAttribute('expanded')) {
          event.stopPropagation();

          _this2.analyticsService_.triggerEvent(_storyAnalytics.StoryAnalyticsEvent.CLICK_THROUGH, _this2.element_);
        }
      });
    }
    /**
     * Adds icon as a child element of <amp-story-affiliate-link>.
     * @private
     */

  }, {
    key: "addIconElement_",
    value: function addIconElement_() {
      var iconEl = (0, _staticTemplate.htmlFor)(this.element_)(_templateObject());
      this.element_.appendChild(iconEl);
    }
    /**
     * Adds text from <a> tag to expanded link.
     * @private
     */

  }, {
    key: "addText_",
    value: function addText_() {
      this.textEl_ = this.element_.querySelector('.i-amphtml-story-affiliate-link-text');
      this.textEl_.textContent = this.text_;
      this.textEl_.setAttribute('hidden', '');
    }
    /**
     * Adds launch arrow to expanded link.
     * @private
     */

  }, {
    key: "addLaunchElement_",
    value: function addLaunchElement_() {
      this.launchEl_ = this.element_.querySelector('.i-amphtml-story-affiliate-link-launch');
      this.launchEl_.setAttribute('hidden', '');
    }
    /**
     * Adds pulse as a child element of <amp-story-affiliate-link>.
     * @private
     */

  }, {
    key: "addPulseElement_",
    value: function addPulseElement_() {
      var pulseEl = (0, _staticTemplate.htmlFor)(this.element_)(_templateObject2());
      this.element_.appendChild(pulseEl);
    }
  }]);

  return AmpStoryAffiliateLink;
}();

exports.AmpStoryAffiliateLink = AmpStoryAffiliateLink;

},{"../../../src/service":130,"../../../src/services":133,"../../../src/static-template":135,"./amp-story-store-service":53,"./story-analytics":91}],37:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryBaseLayer = void 0;

var _layout = require("../../../src/layout");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Base layer template.
 */
var AmpStoryBaseLayer = /*#__PURE__*/function (_AMP$BaseElement) {
  _inherits(AmpStoryBaseLayer, _AMP$BaseElement);

  var _super = _createSuper(AmpStoryBaseLayer);

  /** @param {!AmpElement} element */
  function AmpStoryBaseLayer(element) {
    _classCallCheck(this, AmpStoryBaseLayer);

    return _super.call(this, element);
  }

  /** @override */
  _createClass(AmpStoryBaseLayer, [{
    key: "isLayoutSupported",
    value: function isLayoutSupported(layout) {
      return layout == _layout.Layout.CONTAINER;
    }
    /** @override */

  }, {
    key: "buildCallback",
    value: function buildCallback() {
      this.element.classList.add('i-amphtml-story-layer');
    }
  }]);

  return AmpStoryBaseLayer;
}(AMP.BaseElement);

exports.AmpStoryBaseLayer = AmpStoryBaseLayer;

},{"../../../src/layout":121}],38:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryConsent = void 0;

var _ampStoryStoreService = require("./amp-story-store-service");

var _actionConstants = require("../../../src/action-constants");

var _ampStoryConsent = require("../../../build/amp-story-consent-1.0.css");

var _layout = require("../../../src/layout");

var _localizedStrings = require("../../../src/localized-strings");

var _services = require("../../../src/services");

var _url = require("../../../src/url");

var _dom = require("../../../src/dom");

var _style = require("../../../src/style");

var _utils = require("./utils");

var _log = require("../../../src/log");

var _object = require("./../../../src/utils/object");

var _types = require("../../../src/types");

var _json = require("../../../src/json");

var _simpleTemplate = require("./simple-template");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/** @const {string} */
var TAG = 'amp-story-consent';

/**
 * Default optional config parameters.
 * @const {!Object}
 */
var DEFAULT_OPTIONAL_PARAMETERS = {
  externalLink: {},
  onlyAccept: false
};

// TODO(gmajoulet): switch to `htmlFor` static template helper.

/**
 * Story consent template.
 * @param {!Object} config
 * @param {string} consentId
 * @param {?string} logoSrc
 * @return {!./simple-template.ElementDef}
 * @private @const
 */
var getTemplate = function getTemplate(config, consentId, logoSrc) {
  return {
    tag: 'div',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-consent i-amphtml-story-system-reset'
    }),
    children: [{
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-consent-overflow'
      }),
      children: [{
        tag: 'div',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-consent-container'
        }),
        children: [{
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-consent-header'
          }),
          children: [{
            tag: 'div',
            attrs: (0, _object.dict)({
              'class': 'i-amphtml-story-consent-logo',
              'style': logoSrc ? "background-image: url('" + logoSrc + "') !important;" : ''
            }),
            children: []
          }]
        }, {
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-consent-content'
          }),
          children: [{
            tag: 'h3',
            attrs: (0, _object.dict)({}),
            children: [],
            unlocalizedString: config.title
          }, {
            tag: 'p',
            attrs: (0, _object.dict)({}),
            children: [],
            unlocalizedString: config.message
          }, {
            tag: 'ul',
            attrs: (0, _object.dict)({
              'class': 'i-amphtml-story-consent-vendors'
            }),
            children: config.vendors && config.vendors.map(function (vendor) {
              return {
                tag: 'li',
                attrs: (0, _object.dict)({
                  'class': 'i-amphtml-story-consent-vendor'
                }),
                children: [],
                unlocalizedString: vendor
              };
            })
          }, {
            tag: 'a',
            attrs: (0, _object.dict)({
              'class': 'i-amphtml-story-consent-external-link ' + (!(config.externalLink.title && config.externalLink.href) ? 'i-amphtml-hidden' : ''),
              'href': config.externalLink.href,
              'target': '_top',
              'title': config.externalLink.title
            }),
            children: [],
            unlocalizedString: config.externalLink.title
          }]
        }]
      }, {
        tag: 'div',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-consent-actions'
        }),
        children: [{
          tag: 'button',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-consent-action ' + 'i-amphtml-story-consent-action-reject' + (config.onlyAccept === true ? ' i-amphtml-hidden' : ''),
            'on': "tap:" + consentId + ".reject"
          }),
          children: [],
          localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL
        }, {
          tag: 'button',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-consent-action ' + 'i-amphtml-story-consent-action-accept',
            'on': "tap:" + consentId + ".accept"
          }),
          children: [],
          localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL
        }]
      }]
    }]
  };
};

/**
 * The <amp-story-consent> custom element.
 */
var AmpStoryConsent = /*#__PURE__*/function (_AMP$BaseElement) {
  _inherits(AmpStoryConsent, _AMP$BaseElement);

  var _super = _createSuper(AmpStoryConsent);

  /** @param {!AmpElement} element */
  function AmpStoryConsent(element) {
    var _this;

    _classCallCheck(this, AmpStoryConsent);

    _this = _super.call(this, element);

    /** @const @private {!../../../src/service/action-impl.ActionService} */
    _this.actions_ = _services.Services.actionServiceForDoc(_this.element);

    /** @private {?Object} */
    _this.consentConfig_ = null;

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    _this.storeService_ = (0, _ampStoryStoreService.getStoreService)(_this.win);

    /** @private {?Object} */
    _this.storyConsentConfig_ = null;

    /** @private {?Element} */
    _this.storyConsentEl_ = null;
    return _this;
  }

  /** @override */
  _createClass(AmpStoryConsent, [{
    key: "buildCallback",
    value: function buildCallback() {
      this.assertAndParseConfig_();
      var storyEl = (0, _log.dev)().assertElement((0, _dom.closestAncestorElementBySelector)(this.element, 'AMP-STORY'));
      var consentEl = (0, _dom.closestAncestorElementBySelector)(this.element, 'AMP-CONSENT');
      var consentId = consentEl.id;
      this.storeConsentId_(consentId);
      var logoSrc = storyEl && storyEl.getAttribute('publisher-logo-src');
      logoSrc ? (0, _url.assertHttpsUrl)(logoSrc, storyEl, 'publisher-logo-src') : (0, _log.user)().warn(TAG, 'Expected "publisher-logo-src" attribute on <amp-story>');

      // Story consent config is set by the `assertAndParseConfig_` method.
      if (this.storyConsentConfig_) {
        this.storyConsentEl_ = (0, _simpleTemplate.renderAsElement)(this.win.document, getTemplate(this.storyConsentConfig_, consentId, logoSrc));
        (0, _utils.createShadowRootWithStyle)(this.element, this.storyConsentEl_, _ampStoryConsent.CSS);
        // Allow <amp-consent> actions in STAMP (defaults to no actions allowed).
        var actions = [{
          tagOrTarget: 'AMP-CONSENT',
          method: 'accept'
        }, {
          tagOrTarget: 'AMP-CONSENT',
          method: 'prompt'
        }, {
          tagOrTarget: 'AMP-CONSENT',
          method: 'reject'
        }];
        this.storeService_.dispatch(_ampStoryStoreService.Action.ADD_TO_ACTIONS_ALLOWLIST, actions);
        this.setAcceptButtonFontColor_();
        this.initializeListeners_();
      }
    }
    /** @override */

  }, {
    key: "isLayoutSupported",
    value: function isLayoutSupported(layout) {
      return layout == _layout.Layout.NODISPLAY;
    }
    /**
     * @private
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this2 = this;

      this.storyConsentEl_.addEventListener('click', function (event) {
        return _this2.onClick_(event);
      }, true
      /** useCapture */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.RTL_STATE, function (rtlState) {
        _this2.onRtlStateUpdate_(rtlState);
      }, true
      /** callToInitialize */
      );
    }
    /**
     * Listens to click events to trigger the actions programatically.
     * Since events bubble up from the Shadow DOM but their target is updated to
     * the Shadow root, the top level actions event listeners would not detect
     * and trigger the actions upon click events.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onClick_",
    value: function onClick_(event) {
      if (event.target && event.target.hasAttribute('on')) {
        var targetEl = (0, _log.dev)().assertElement(event.target);
        this.actions_.trigger(targetEl, 'tap', event, _actionConstants.ActionTrust.HIGH);
      }
    }
    /**
     * Reacts to RTL state updates and triggers the UI for RTL.
     * @param {boolean} rtlState
     * @private
     */

  }, {
    key: "onRtlStateUpdate_",
    value: function onRtlStateUpdate_(rtlState) {
      var _this3 = this;

      var mutator = function mutator() {
        rtlState ? _this3.storyConsentEl_.setAttribute('dir', 'rtl') : _this3.storyConsentEl_.removeAttribute('dir');
      };

      this.mutateElement(mutator, this.storyConsentEl_);
    }
    /**
     * Validates the story-consent config. `story-consent` is a new parameter
     * specific to stories, added on the `amp-consent` JSON config.
     * @private
     */

  }, {
    key: "assertAndParseConfig_",
    value: function assertAndParseConfig_() {
      // Validation of the amp-consent config is handled by the amp-consent
      // javascript.
      var parentEl = (0, _log.dev)().assertElement(this.element.parentElement);
      var consentScript = (0, _dom.childElementByTag)(parentEl, 'script');
      this.consentConfig_ = consentScript && (0, _json.parseJson)(consentScript.textContent);
      this.mergeLegacyConsents_();

      // amp-consent already triggered console errors, step out to avoid polluting
      // the console.
      if (!this.consentConfig_) {
        return;
      }

      var storyConsentScript = (0, _dom.childElementByTag)(this.element, 'script');
      (0, _log.userAssert)(storyConsentScript && (0, _dom.isJsonScriptTag)(storyConsentScript), TAG + " config should be put in a <script> tag with " + 'type="application/json"');
      this.storyConsentConfig_ = _extends({}, DEFAULT_OPTIONAL_PARAMETERS, (0, _json.parseJson)(storyConsentScript.textContent));
      (0, _log.user)().assertString(this.storyConsentConfig_.title, TAG + ": config requires a title");
      (0, _log.user)().assertString(this.storyConsentConfig_.message, TAG + ": config requires a message");
      (0, _log.userAssert)(this.storyConsentConfig_.vendors && (0, _types.isArray)(this.storyConsentConfig_.vendors), TAG + ": config requires an array of vendors");
      (0, _log.user)().assertBoolean(this.storyConsentConfig_.onlyAccept, TAG + ": config requires \"onlyAccept\" to be a boolean");

      // Runs the validation if any of the title or link are provided, since
      // both have to be provided for the external link to be displayed.
      if (this.storyConsentConfig_.externalLink.href || this.storyConsentConfig_.externalLink.title) {
        (0, _log.user)().assertString(this.storyConsentConfig_.externalLink.title, TAG + ": config requires \"externalLink.title\" to be a string");
        (0, _log.user)().assertString(this.storyConsentConfig_.externalLink.href, TAG + ": config requires \"externalLink.href\" to be an absolute URL");
        (0, _url.assertAbsoluteHttpOrHttpsUrl)(this.storyConsentConfig_.externalLink.href);
      }
    }
    /**
     * Merge legacy `consents` policy object from
     * amp-consent config into top level.
     * @private
     */

  }, {
    key: "mergeLegacyConsents_",
    value: function mergeLegacyConsents_() {
      var legacyConsents = this.consentConfig_['consents'];

      if (legacyConsents) {
        var policyId = Object.keys(legacyConsents)[0];
        var policy = legacyConsents[policyId];
        this.consentConfig_.consentInstanceId = policyId;
        this.consentConfig_.checkConsentHref = policy.checkConsentHref;
        this.consentConfig_.promptIfUnknownForGeoGroup = policy.promptIfUnknownForGeoGroup;
        delete this.consentConfig_['consents'];
      }
    }
    /**
     * @param {string} consentId
     * @private
     */

  }, {
    key: "storeConsentId_",
    value: function storeConsentId_(consentId) {
      var _this4 = this;

      // checkConsentHref response overrides the amp-geo config, if provided.
      if (this.consentConfig_.checkConsentHref) {
        this.storeService_.dispatch(_ampStoryStoreService.Action.SET_CONSENT_ID, consentId);
        return;
      }

      // If using amp-access with amp-geo, only set the consent id if the user is
      // in the expected geo group.
      var geoGroup = this.consentConfig_.promptIfUnknownForGeoGroup;

      if (geoGroup) {
        _services.Services.geoForDocOrNull(this.element).then(function (geo) {
          var matchedGeoGroups =
          /** @type {!Array<string>} */
          geo.matchedISOCountryGroups;

          if (geo && !matchedGeoGroups.includes(geoGroup)) {
            return;
          }

          _this4.storeService_.dispatch(_ampStoryStoreService.Action.SET_CONSENT_ID, consentId);
        });
      }
    }
    /**
     * Sets the accept button font color to either white or black, depending on
     * the publisher custom background color.
     * Must be called from the `buildCallback` or in another vsync mutate state.
     * @private
     */

  }, {
    key: "setAcceptButtonFontColor_",
    value: function setAcceptButtonFontColor_() {
      var buttonEl = (0, _log.dev)().assertElement(this.storyConsentEl_.querySelector('.i-amphtml-story-consent-action-accept'));
      var styles = (0, _style.computedStyle)(this.win, buttonEl);
      var rgb = (0, _utils.getRGBFromCssColorValue)(styles['background-color']);
      var color = (0, _utils.getTextColorForRGB)(rgb);
      (0, _style.setImportantStyles)(buttonEl, {
        color: color
      });
    }
  }]);

  return AmpStoryConsent;
}(AMP.BaseElement);

exports.AmpStoryConsent = AmpStoryConsent;

},{"../../../build/amp-story-consent-1.0.css":3,"../../../src/action-constants":96,"../../../src/dom":106,"../../../src/json":120,"../../../src/layout":121,"../../../src/localized-strings":122,"../../../src/log":123,"../../../src/services":133,"../../../src/style":138,"../../../src/types":139,"../../../src/url":142,"./../../../src/utils/object":149,"./amp-story-store-service":53,"./simple-template":89,"./utils":93}],39:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryCtaLayer = void 0;

var _ampStoryBaseLayer = require("./amp-story-base-layer");

var _dom = require("../../../src/dom");

var _object = require("../../../src/utils/object");

var _log = require("../../../src/log");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @type {string}
 * @const
 */
var TAG = 'amp-story-cta-layer';

/**
 * Call to action button layer template.
 *
 * No pre-rendering to let more computing-intensive elements (like
 * videos) get pre-rendered first. Since this layer will not contain
 * computing-intensive resources such as videos, we can just risk rendering
 * while the user is looking.
 */
var AmpStoryCtaLayer = /*#__PURE__*/function (_AmpStoryBaseLayer) {
  _inherits(AmpStoryCtaLayer, _AmpStoryBaseLayer);

  var _super = _createSuper(AmpStoryCtaLayer);

  function AmpStoryCtaLayer() {
    _classCallCheck(this, AmpStoryCtaLayer);

    return _super.apply(this, arguments);
  }

  _createClass(AmpStoryCtaLayer, [{
    key: "buildCallback",

    /** @override */
    value: function buildCallback() {
      _get(_getPrototypeOf(AmpStoryCtaLayer.prototype), "buildCallback", this).call(this);

      this.setOrOverwriteAttributes_();
      this.checkAndRemoveLayerIfOnFirstPage_();
    }
    /**
     * Overwrite or set target attributes that are cta-layer-specific.
     * @private
     */

  }, {
    key: "setOrOverwriteAttributes_",
    value: function setOrOverwriteAttributes_() {
      var ctaLinks = this.element.querySelectorAll('a');

      for (var i = 0; i < ctaLinks.length; i++) {
        (0, _dom.addAttributesToElement)(ctaLinks[i], (0, _object.dict)({
          'target': '_blank'
        }));

        if (!ctaLinks[i].getAttribute('role')) {
          (0, _dom.addAttributesToElement)(ctaLinks[i], (0, _object.dict)({
            'role': 'link'
          }));
        }
      }

      var ctaButtons = this.element.querySelectorAll('button');

      for (var _i = 0; _i < ctaButtons.length; _i++) {
        if (!ctaButtons[_i].getAttribute('role')) {
          (0, _dom.addAttributesToElement)(ctaButtons[_i], (0, _object.dict)({
            'role': 'button'
          }));
        }
      }
    }
    /**
     * CTA links or buttons are not allowed on the first amp-story page. Remove
     * the amp-story-cta-layer if it is found on the first page of the story.
     * @private
     */

  }, {
    key: "checkAndRemoveLayerIfOnFirstPage_",
    value: function checkAndRemoveLayerIfOnFirstPage_() {
      if ((0, _dom.matches)(this.element, 'amp-story-page:first-of-type > amp-story-cta-layer')) {
        (0, _dom.removeElement)(this.element);
        (0, _log.user)().error(TAG, 'amp-story-cta-layer is not allowed on the first page' + ' of an amp-story.');
      }
    }
  }]);

  return AmpStoryCtaLayer;
}(_ampStoryBaseLayer.AmpStoryBaseLayer);

exports.AmpStoryCtaLayer = AmpStoryCtaLayer;

},{"../../../src/dom":106,"../../../src/log":123,"../../../src/utils/object":149,"./amp-story-base-layer":37}],40:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.DraggableDrawer = exports.DrawerState = void 0;

var _resolvedPromise2 = require("./../../../src/resolved-promise");

var _ampStoryStoreService = require("./amp-story-store-service");

var _ampStoryDraggableDrawerHeader = require("../../../build/amp-story-draggable-drawer-header-1.0.css");

var _layout = require("../../../src/layout");

var _services = require("../../../src/services");

var _dom = require("../../../src/dom");

var _utils = require("./utils");

var _log = require("../../../src/log");

var _staticTemplate = require("../../../src/static-template");

var _eventHelper = require("../../../src/event-helper");

var _style = require("../../../src/style");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    <div class=\"i-amphtml-story-draggable-drawer-header\"></div>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    <div class=\"i-amphtml-story-draggable-drawer\">\n      <div class=\"i-amphtml-story-draggable-drawer-container\">\n        <div class=\"i-amphtml-story-draggable-drawer-content\"></div>\n      </div>\n    </div>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/** @const {number} */
var TOGGLE_THRESHOLD_PX = 50;

/**
 * @enum {number}
 */
var DrawerState = {
  CLOSED: 0,
  DRAGGING_TO_CLOSE: 1,
  DRAGGING_TO_OPEN: 2,
  OPEN: 3
};
exports.DrawerState = DrawerState;

/**
 * Drawer's template.
 * @param {!Element} element
 * @return {!Element}
 */
var getTemplateEl = function getTemplateEl(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject());
};

/**
 * Drawer's header template.
 * @param {!Element} element
 * @return {!Element}
 */
var getHeaderEl = function getHeaderEl(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject2());
};

/**
 * Abstract draggable drawer.
 * @abstract
 */
var DraggableDrawer = /*#__PURE__*/function (_AMP$BaseElement) {
  _inherits(DraggableDrawer, _AMP$BaseElement);

  var _super = _createSuper(DraggableDrawer);

  /** @param {!AmpElement} element */
  function DraggableDrawer(element) {
    var _this;

    _classCallCheck(this, DraggableDrawer);

    _this = _super.call(this, element);

    /** @private {!Array<!Element>} AMP components within the drawer. */
    _this.ampComponents_ = [];

    /** @protected {?Element} */
    _this.containerEl_ = null;

    /** @protected {?Element} */
    _this.contentEl_ = null;

    /** @private {number} Max value in pixels that can be dragged when opening the drawer. */
    _this.dragCap_ = Infinity;

    /** @protected {?Element} */
    _this.headerEl_ = null;

    /** @private {boolean} */
    _this.ignoreCurrentSwipeYGesture_ = false;

    /** @protected {!DrawerState} */
    _this.state_ = DrawerState.CLOSED;

    /** @protected @const {!./amp-story-store-service.AmpStoryStoreService} */
    _this.storeService_ = (0, _ampStoryStoreService.getStoreService)(_this.win);

    /** @private {!Object} */
    _this.touchEventState_ = {
      startX: 0,
      startY: 0,
      lastY: 0,
      swipingUp: null,
      isSwipeY: null
    };

    /** @private {!Array<function()>} */
    _this.touchEventUnlisteners_ = [];

    /** @private {number} Threshold in pixels above which the drawer opens itself. */
    _this.openThreshold_ = Infinity;
    return _this;
  }

  /** @override */
  _createClass(DraggableDrawer, [{
    key: "isLayoutSupported",
    value: function isLayoutSupported(layout) {
      return layout === _layout.Layout.NODISPLAY;
    }
    /** @override */

  }, {
    key: "prerenderAllowed",
    value: function prerenderAllowed() {
      return false;
    }
    /** @override */

  }, {
    key: "buildCallback",
    value: function buildCallback() {
      this.element.classList.add('amp-story-draggable-drawer-root');
      var templateEl = getTemplateEl(this.element);
      var headerShadowRootEl = this.win.document.createElement('div');
      this.headerEl_ = getHeaderEl(this.element);
      (0, _utils.createShadowRootWithStyle)(headerShadowRootEl, this.headerEl_, _ampStoryDraggableDrawerHeader.CSS);
      templateEl.insertBefore(headerShadowRootEl, templateEl.firstChild);
      this.containerEl_ = (0, _log.dev)().assertElement(templateEl.querySelector('.i-amphtml-story-draggable-drawer-container'));
      this.contentEl_ = (0, _log.dev)().assertElement(this.containerEl_.querySelector('.i-amphtml-story-draggable-drawer-content'));
      this.element.appendChild(templateEl);
      this.element.setAttribute('aria-hidden', true);
    }
    /** @override */

  }, {
    key: "layoutCallback",
    value: function layoutCallback() {
      this.initializeListeners_();
      var walker = this.win.document.createTreeWalker(this.element, NodeFilter.SHOW_ELEMENT, null
      /** filter */
      , false
      /** entityReferenceExpansion */
      );

      while (walker.nextNode()) {
        var el = (0, _log.dev)().assertElement(walker.currentNode);

        if ((0, _dom.isAmpElement)(el)) {
          this.ampComponents_.push(el);

          _services.Services.ownersForDoc(this.element).setOwner(el, this.element);
        }
      }

      return (0, _resolvedPromise2.resolvedPromise)();
    }
    /**
     * @protected
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this2 = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.UI_STATE, function (uiState) {
        _this2.onUIStateUpdate_(uiState);
      }, true
      /** callToInitialize */
      );
    }
    /**
     * Reacts to UI state updates.
     * @param {!UIType} uiState
     * @protected
     */

  }, {
    key: "onUIStateUpdate_",
    value: function onUIStateUpdate_(uiState) {
      uiState === _ampStoryStoreService.UIType.MOBILE ? this.startListeningForTouchEvents_() : this.stopListeningForTouchEvents_();
    }
    /**
     * @private
     */

  }, {
    key: "startListeningForTouchEvents_",
    value: function startListeningForTouchEvents_() {
      // If the element is a direct descendant of amp-story-page, authorize
      // swiping up by listening to events at the page level. Otherwise, only
      // authorize swiping down to close by listening to events at the current
      // element level.
      var parentEl = this.element.parentElement;
      var el = (0, _log.dev)().assertElement(parentEl.tagName === 'AMP-STORY-PAGE' ? parentEl : this.element);
      this.touchEventUnlisteners_.push((0, _eventHelper.listen)(el, 'touchstart', this.onTouchStart_.bind(this), {
        capture: true
      }));
      this.touchEventUnlisteners_.push((0, _eventHelper.listen)(el, 'touchmove', this.onTouchMove_.bind(this), {
        capture: true
      }));
      this.touchEventUnlisteners_.push((0, _eventHelper.listen)(el, 'touchend', this.onTouchEnd_.bind(this), {
        capture: true
      }));
    }
    /**
     * @private
     */

  }, {
    key: "stopListeningForTouchEvents_",
    value: function stopListeningForTouchEvents_() {
      this.touchEventUnlisteners_.forEach(function (fn) {
        return fn();
      });
      this.touchEventUnlisteners_ = [];
    }
    /**
     * Helper to retrieve the touch coordinates from a TouchEvent.
     * @param {!Event} event
     * @return {?{x: number, y: number}}
     * @private
     */

  }, {
    key: "getClientTouchCoordinates_",
    value: function getClientTouchCoordinates_(event) {
      var touches = event.touches;

      if (!touches || touches.length < 1) {
        return null;
      }

      var _touches$ = touches[0],
          x = _touches$.clientX,
          y = _touches$.clientY;
      return {
        x: x,
        y: y
      };
    }
    /**
     * Handles touchstart events to detect swipeY interactions.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onTouchStart_",
    value: function onTouchStart_(event) {
      var coordinates = this.getClientTouchCoordinates_(event);

      if (!coordinates) {
        return;
      }

      this.touchEventState_.startX = coordinates.x;
      this.touchEventState_.startY = coordinates.y;
    }
    /**
     * Handles touchmove events to detect swipeY interactions.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onTouchMove_",
    value: function onTouchMove_(event) {
      if (this.touchEventState_.isSwipeY === false) {
        return;
      }

      var coordinates = this.getClientTouchCoordinates_(event);

      if (!coordinates) {
        return;
      }

      var x = coordinates.x,
          y = coordinates.y;
      this.touchEventState_.swipingUp = y < this.touchEventState_.lastY;
      this.touchEventState_.lastY = y;

      if (this.state_ === DrawerState.CLOSED && !this.touchEventState_.swipingUp) {
        return;
      }

      event.stopPropagation();

      if (this.touchEventState_.isSwipeY === null) {
        this.touchEventState_.isSwipeY = Math.abs(this.touchEventState_.startY - y) > Math.abs(this.touchEventState_.startX - x);

        if (!this.touchEventState_.isSwipeY) {
          return;
        }
      }

      this.onSwipeY_({
        event: event,
        data: {
          swipingUp: this.touchEventState_.swipingUp,
          deltaY: y - this.touchEventState_.startY,
          last: false
        }
      });
    }
    /**
     * Handles touchend events to detect swipeY interactions.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onTouchEnd_",
    value: function onTouchEnd_(event) {
      if (this.touchEventState_.isSwipeY === true) {
        this.onSwipeY_({
          event: event,
          data: {
            swipingUp: this.touchEventState_.swipingUp,
            deltaY: this.touchEventState_.lastY - this.touchEventState_.startY,
            last: true
          }
        });
      }

      this.touchEventState_.startX = 0;
      this.touchEventState_.startY = 0;
      this.touchEventState_.lastY = 0;
      this.touchEventState_.swipingUp = null;
      this.touchEventState_.isSwipeY = null;
    }
    /**
     * Handles swipeY events, detected by the touch events listeners.
     * @param {{event: !Event, data: !Object}} gesture
     * @private
     */

  }, {
    key: "onSwipeY_",
    value: function onSwipeY_(gesture) {
      var data = gesture.data;

      if (this.ignoreCurrentSwipeYGesture_ === true) {
        this.ignoreCurrentSwipeYGesture_ = !data.last;
        return;
      }

      var deltaY = data.deltaY,
          swipingUp = data.swipingUp;

      // If the drawer is open, figure out if the user is trying to scroll the
      // content, or actually close the drawer.
      if (this.state_ === DrawerState.OPEN) {
        var isContentSwipe = this.isDrawerContentDescendant_((0, _log.dev)().assertElement(gesture.event.target));

        // If user is swiping up, exit so the event bubbles up and maybe scrolls
        // the drawer content.
        // If user is swiping down and scrollTop is above zero, exit and let the
        // user scroll the content.
        // If user is swiping down and scrollTop is zero, don't exit and start
        // dragging/closing the drawer.
        if (isContentSwipe && deltaY < 0 || isContentSwipe && deltaY > 0 && this.containerEl_.
        /*OK*/
        scrollTop > 0) {
          this.ignoreCurrentSwipeYGesture_ = true;
          return;
        }
      }

      gesture.event.preventDefault();

      if (data.last === true) {
        if (this.state_ === DrawerState.DRAGGING_TO_CLOSE) {
          !swipingUp && deltaY > TOGGLE_THRESHOLD_PX ? this.close_() : this.open();
        }

        if (this.state_ === DrawerState.DRAGGING_TO_OPEN) {
          swipingUp && -deltaY > TOGGLE_THRESHOLD_PX ? this.open() : this.close_();
        }

        return;
      }

      if (this.state_ === DrawerState.DRAGGING_TO_OPEN && swipingUp && -deltaY > this.openThreshold_) {
        this.open();
        return;
      }

      this.drag_(deltaY);
    }
    /**
     * Whether the element is a descendant of drawer-content.
     * @param {!Element} element
     * @return {boolean}
     * @private
     */

  }, {
    key: "isDrawerContentDescendant_",
    value: function isDrawerContentDescendant_(element) {
      return !!(0, _dom.closest)(element, function (el) {
        return el.classList.contains('i-amphtml-story-draggable-drawer-content');
      },
      /* opt_stopAt */
      this.element);
    }
    /**
     * Sets a swipe threshold in pixels above which the drawer opens itself.
     * @param {number} openThreshold
     * @protected
     */

  }, {
    key: "setOpenThreshold_",
    value: function setOpenThreshold_(openThreshold) {
      this.openThreshold_ = openThreshold;
    }
    /**
     * Sets the max value in pixels that can be dragged when opening the drawer.
     * @param {number} dragCap
     * @protected
     */

  }, {
    key: "setDragCap_",
    value: function setDragCap_(dragCap) {
      this.dragCap_ = dragCap;
    }
    /**
     * Drags the drawer on the screen upon user interaction.
     * @param {number} deltaY
     * @private
     */

  }, {
    key: "drag_",
    value: function drag_(deltaY) {
      var _this3 = this;

      var translate;

      switch (this.state_) {
        case DrawerState.CLOSED:
        case DrawerState.DRAGGING_TO_OPEN:
          if (deltaY > 0) {
            return;
          }

          this.state_ = DrawerState.DRAGGING_TO_OPEN;
          var drag = Math.max(deltaY, -this.dragCap_);
          translate = "translate3d(0, calc(100% + " + drag + "px), 0)";
          break;

        case DrawerState.OPEN:
        case DrawerState.DRAGGING_TO_CLOSE:
          if (deltaY < 0) {
            return;
          }

          this.state_ = DrawerState.DRAGGING_TO_CLOSE;
          translate = "translate3d(0, " + deltaY + "px, 0)";
          break;
      }

      this.mutateElement(function () {
        (0, _style.setImportantStyles)(_this3.element, {
          transform: translate,
          transition: 'none'
        });
      });
    }
    /**
     * Fully opens the drawer from its current position.
     * @param {boolean=} shouldAnimate
     */

  }, {
    key: "open",
    value: function open(shouldAnimate) {
      var _this4 = this;

      if (shouldAnimate === void 0) {
        shouldAnimate = true;
      }

      if (this.state_ === DrawerState.OPEN) {
        return;
      }

      this.state_ = DrawerState.OPEN;
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, true);
      this.mutateElement(function () {
        _this4.element.setAttribute('aria-hidden', false);

        (0, _style.resetStyles)(_this4.element, ['transform', 'transition']);

        if (!shouldAnimate) {
          // Resets the 'transition' property, and removes this override in the
          // next frame, after the element is positioned.
          (0, _style.setImportantStyles)(_this4.element, {
            transition: 'initial'
          });

          _this4.mutateElement(function () {
            return (0, _style.resetStyles)(_this4.element, ['transition']);
          });
        }

        _this4.element.classList.add('i-amphtml-story-draggable-drawer-open');

        (0, _style.toggle)((0, _log.dev)().assertElement(_this4.containerEl_), true);
      }).then(function () {
        var owners = _services.Services.ownersForDoc(_this4.element);

        owners.scheduleLayout(_this4.element, _this4.ampComponents_);
        owners.scheduleResume(_this4.element, _this4.ampComponents_);
        owners.updateInViewport(_this4.element, _this4.ampComponents_, true);
      });
    }
    /**
     * Can be overriden for implementations using the browser history to close the
     * drawer.
     * @protected
     */

  }, {
    key: "close_",
    value: function close_() {
      this.closeInternal_();
    }
    /**
     * Fully closes the drawer from its current position.
     * @param {boolean=} shouldAnimate
     * @protected
     */

  }, {
    key: "closeInternal_",
    value: function closeInternal_(shouldAnimate) {
      var _this5 = this;

      if (shouldAnimate === void 0) {
        shouldAnimate = true;
      }

      if (this.state_ === DrawerState.CLOSED) {
        return;
      }

      this.state_ = DrawerState.CLOSED;
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, false);
      this.mutateElement(function () {
        _this5.element.setAttribute('aria-hidden', true);

        (0, _style.resetStyles)(_this5.element, ['transform', 'transition']);

        if (!shouldAnimate) {
          // Resets the 'transition' property, and removes this override in the
          // next frame, after the element is positioned.
          (0, _style.setImportantStyles)(_this5.element, {
            transition: 'initial'
          });

          _this5.mutateElement(function () {
            return (0, _style.resetStyles)(_this5.element, ['transition']);
          });
        }

        _this5.element.classList.remove('i-amphtml-story-draggable-drawer-open');
      }).then(function () {
        var owners = _services.Services.ownersForDoc(_this5.element);

        owners.schedulePause(_this5.element, _this5.ampComponents_);
        owners.updateInViewport(_this5.element, _this5.ampComponents_, false);
      });
    }
  }]);

  return DraggableDrawer;
}(AMP.BaseElement);

exports.DraggableDrawer = DraggableDrawer;

},{"../../../build/amp-story-draggable-drawer-header-1.0.css":4,"../../../src/dom":106,"../../../src/event-helper":111,"../../../src/layout":121,"../../../src/log":123,"../../../src/services":133,"../../../src/static-template":135,"../../../src/style":138,"./../../../src/resolved-promise":129,"./amp-story-store-service":53,"./utils":93}],41:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.expandableElementsSelectors = expandableElementsSelectors;
exports.interactiveElementsSelectors = interactiveElementsSelectors;
exports.AmpStoryEmbeddedComponent = exports.EMBED_ID_ATTRIBUTE_NAME = exports.EXPANDABLE_COMPONENTS = void 0;

var _ampStoryStoreService = require("./amp-story-store-service");

var _storyAnalytics = require("./story-analytics");

var _ampStoryTooltip = require("../../../build/amp-story-tooltip-1.0.css");

var _events = require("./events");

var _keyCodes = require("../../../src/utils/key-codes");

var _localizedStrings = require("../../../src/localized-strings");

var _services = require("../../../src/services");

var _dom = require("../../../src/dom");

var _utils = require("./utils");

var _log = require("../../../src/log");

var _object = require("../../../src/utils/object");

var _service = require("../../../src/service");

var _ampStoryLocalizationService = require("./amp-story-localization-service");

var _staticTemplate = require("../../../src/static-template");

var _url = require("../../../src/url");

var _style = require("../../../src/style");

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose([" <style></style> "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      <section\n        class=\"i-amphtml-story-focused-state-layer\n            i-amphtml-story-system-reset i-amphtml-hidden\"\n      >\n        <div\n          class=\"i-amphtml-story-focused-state-layer-nav-button-container\n              i-amphtml-story-tooltip-nav-button-left\"\n        >\n          <button\n            role=\"button\"\n            ref=\"buttonLeft\"\n            class=\"i-amphtml-story-focused-state-layer-nav-button\n                i-amphtml-story-tooltip-nav-button-left\"\n          ></button>\n        </div>\n        <div\n          class=\"i-amphtml-story-focused-state-layer-nav-button-container\n              i-amphtml-story-tooltip-nav-button-right\"\n        >\n          <button\n            role=\"button\"\n            ref=\"buttonRight\"\n            class=\"i-amphtml-story-focused-state-layer-nav-button\n                    i-amphtml-story-tooltip-nav-button-right\"\n          ></button>\n        </div>\n        <a\n          class=\"i-amphtml-story-tooltip\"\n          target=\"_blank\"\n          ref=\"tooltip\"\n          role=\"tooltip\"\n        >\n          <div class=\"i-amphtml-story-tooltip-custom-icon\"></div>\n          <p class=\"i-amphtml-tooltip-text\" ref=\"text\"></p>\n          <div class=\"i-amphtml-tooltip-action-icon\"></div>\n          <div class=\"i-amphtml-story-tooltip-arrow\" ref=\"arrow\"></div>\n        </a>\n      </section>\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    <div class=\"i-amphtml-story-expanded-view-overflow\n        i-amphtml-story-system-reset\">\n      <span class=\"i-amphtml-expanded-view-close-button\" role=\"button\">\n      </span>\n    </div>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Action icons to be placed in tooltip.
 * @enum {string}
 * @private
 */
var ActionIcon = {
  LAUNCH: 'i-amphtml-tooltip-action-icon-launch',
  EXPAND: 'i-amphtml-tooltip-action-icon-expand'
};

/** @private @const {number} */
var TOOLTIP_CLOSE_ANIMATION_MS = 100;

/** @const {string} */
var DARK_THEME_CLASS = 'i-amphtml-story-tooltip-theme-dark';

/**
 * @enum {string}
 */
var TooltipTheme = {
  LIGHT: 'light',
  // default
  DARK: 'dark'
};

/**
 * Since we don't know the actual width of the content inside the iframe
 * and in responsive environments the iframe takes the whole width, we
 * hardcode a limit based on what we know of how the embed behaves (only true
 * for Twitter embeds). See #22334.
 * @const {number}
 * @private
 */
var MAX_TWEET_WIDTH_PX = 500;

/**
 * Components that can be expanded.
 * @const {!Object}
 * @package
 */
var EXPANDABLE_COMPONENTS = {
  'amp-twitter': {
    customIconClassName: 'amp-social-share-twitter-no-background',
    actionIcon: ActionIcon.EXPAND,
    localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_TOOLTIP_EXPAND_TWEET,
    selector: 'amp-twitter'
  }
};
exports.EXPANDABLE_COMPONENTS = EXPANDABLE_COMPONENTS;

/**
 * Components that can be launched.
 * @const {!Object}
 * @private
 */
var LAUNCHABLE_COMPONENTS = {
  'a': {
    actionIcon: ActionIcon.LAUNCH,
    selector: 'a[href]:not([affiliate-link-icon])'
  }
};

/**
 * Union of expandable and launchable components.
 * @private
 * @const {!Object}
 */
var INTERACTIVE_COMPONENTS = _extends({}, EXPANDABLE_COMPONENTS, LAUNCHABLE_COMPONENTS);

/**
 * Gets the list of components with their respective selectors.
 * @param {!Object} components
 * @param {string=} opt_predicate
 * @return {!Object<string, string>}
 */
function getComponentSelectors(components, opt_predicate) {
  var componentSelectors = {};
  Object.keys(components).forEach(function (componentName) {
    componentSelectors[componentName] = opt_predicate ? components[componentName].selector + opt_predicate : components[componentName].selector;
  });
  return componentSelectors;
}

/** @const {string} */
var INTERACTIVE_EMBED_SELECTOR = '[interactive]';

/**
 * Selectors of elements that can go into expanded view.
 * @return {!Object}
 */
function expandableElementsSelectors() {
  // Using indirect invocation to prevent no-export-side-effect issue.
  return getComponentSelectors(EXPANDABLE_COMPONENTS, INTERACTIVE_EMBED_SELECTOR);
}

/**
 * Contains all interactive component CSS selectors.
 * @type {!Object}
 */
var interactiveSelectors = _extends({}, getComponentSelectors(LAUNCHABLE_COMPONENTS), getComponentSelectors(EXPANDABLE_COMPONENTS, INTERACTIVE_EMBED_SELECTOR), {
  EXPANDED_VIEW_OVERLAY: '.i-amphtml-story-expanded-view-overflow, ' + '.i-amphtml-expanded-view-close-button'
});

/**
 * All selectors that should delegate to the AmpStoryEmbeddedComponent class.
 * @return {!Object}
 */
function interactiveElementsSelectors() {
  // Using indirect invocation to prevent no-export-side-effect issue.
  return interactiveSelectors;
}

/**
 * Maps each embedded element to its corresponding style.
 * @type {!JsonObject}
 */
var embedStyleEls = (0, _object.dict)();

/**
 * Generates ids for embedded component styles.
 * @type {number}
 */
var embedIds = 0;

/**
 * Contains metadata about embedded components, found in <style> elements.
 * @const {string}
 */
var AMP_EMBED_DATA = '__AMP_EMBED_DATA__';

/**
 * @typedef {{
 *  id: number,
 *  width: number,
 *  height: number,
 *  scaleFactor: number,
 *  transform: string,
 *  verticalMargin: number,
 *  horizontalMargin: number,
 * }}
 */
var EmbedDataDef;

/**
 * @const {string}
 */
var EMBED_ID_ATTRIBUTE_NAME = 'i-amphtml-embed-id';
exports.EMBED_ID_ATTRIBUTE_NAME = EMBED_ID_ATTRIBUTE_NAME;

/**
 * Builds expanded view overlay for expandable components.
 * @param {!Element} element
 * @return {!Element}
 */
var buildExpandedViewOverlay = function buildExpandedViewOverlay(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject());
};

/**
 * Updates embed's corresponding <style> element with embedData.
 * @param {!Element} target
 * @param {!Element} embedStyleEl
 * @param {!EmbedDataDef} embedData
 */
function updateEmbedStyleEl(target, embedStyleEl, embedData) {
  var embedId = embedData.id;
  embedStyleEl.textContent = "[" + EMBED_ID_ATTRIBUTE_NAME + "=\"" + embedId + "\"]\n  " + buildStringStyleFromEl(target, embedData);
}

/**
 * Builds a string containing the corresponding style depending on the
 * element.
 * @param {!Element} target
 * @param {!EmbedDataDef} embedData
 * @return {string}
 */
function buildStringStyleFromEl(target, embedData) {
  switch (target.tagName.toLowerCase()) {
    case EXPANDABLE_COMPONENTS['amp-twitter'].selector:
      return buildStringStyleForTweet(embedData);

    default:
      return buildDefaultStringStyle(embedData);
  }
}

/**
 * Builds string used in the <style> element for tweets. We ignore the height
 * as its non-deterministic.
 * @param {!EmbedDataDef} embedData
 * @return {string}
 */
function buildStringStyleForTweet(embedData) {
  return "{\n    width: " + (0, _style.px)(embedData.width) + " !important;\n    transform: " + embedData.transform + " !important;\n    margin: 0 " + embedData.horizontalMargin + "px !important;\n    }";
}

/**
 * Builds string used in the <style> element for default embeds.
 * @param {!EmbedDataDef} embedData
 * @return {string}
 */
function buildDefaultStringStyle(embedData) {
  return "{\n    width: " + (0, _style.px)(embedData.width) + " !important;\n    height: " + (0, _style.px)(embedData.height) + " !important;\n    transform: " + embedData.transform + " !important;\n    margin: " + embedData.verticalMargin + "px " + embedData.horizontalMargin + "px !important;\n    }";
}

/**
 * Measures syles for a given element in preparation for its expanded animation.
 * @param {!Element} element
 * @param {!Object} state
 * @param {!DOMRect} pageRect
 * @param {!DOMRect} elRect
 * @return {!Object}
 */
function measureStyleForEl(element, state, pageRect, elRect) {
  switch (element.tagName.toLowerCase()) {
    case EXPANDABLE_COMPONENTS['amp-twitter'].selector:
      return measureStylesForTwitter(state, pageRect, elRect);

    default:
      return measureDefaultStyles(state, pageRect, elRect);
  }
}

/**
 * Since amp-twitter handles its own resize events for its height, we don't
 * resize based on its height, but rather just based on its width.
 * @param {!Object} state
 * @param {!DOMRect} pageRect
 * @param {!DOMRect} elRect
 * @return {!Object}
 */
function measureStylesForTwitter(state, pageRect, elRect) {
  // If screen is very wide and story has supports-landscape attribute,
  // we don't want it to take the whole width. We take the maximum width
  // that the tweet can actually use instead.
  state.newWidth = Math.min(pageRect.width, MAX_TWEET_WIDTH_PX);
  state.scaleFactor = Math.min(elRect.width, MAX_TWEET_WIDTH_PX) / state.newWidth;
  state.horizontalMargin = -1 * ((state.newWidth - elRect.width) / 2);
  return state;
}

/**
 * Measures styles for a given element in preparation for its expanded
 * animation.
 * @param {!Object} state
 * @param {!DOMRect} pageRect
 * @param {!DOMRect} elRect
 * @return {!Object}
 */
function measureDefaultStyles(state, pageRect, elRect) {
  if (elRect.width >= elRect.height) {
    state.newWidth = pageRect.width;
    state.scaleFactor = elRect.width / state.newWidth;
    state.newHeight = elRect.height / elRect.width * state.newWidth;
  } else {
    var maxHeight = pageRect.height - VERTICAL_PADDING;
    state.newWidth = Math.min(elRect.width / elRect.height * maxHeight, pageRect.width);
    state.newHeight = elRect.height / elRect.width * state.newWidth;
    state.scaleFactor = elRect.height / state.newHeight;
  }

  state.verticalMargin = -1 * ((state.newHeight - elRect.height) / 2);
  state.horizontalMargin = -1 * ((state.newWidth - elRect.width) / 2);
  return state;
}

/**
 * Gets updated style object for a given element.
 * @param {!Element} element
 * @param {number} elId
 * @param {!Object} state
 * @return {!Object}
 */
function updateStyleForEl(element, elId, state) {
  switch (element.tagName.toLowerCase()) {
    case EXPANDABLE_COMPONENTS['amp-twitter'].selector:
      return updateStylesForTwitter(elId, state);

    default:
      return updateDefaultStyles(elId, state);
  }
}

/**
 * Gets style object for an embedded component, setting negative margins
 * to make up for the expanded size in preparation of the expanded animation.
 * @param {number} elId
 * @param {!Object} state
 * @return {!Object}
 */
function updateDefaultStyles(elId, state) {
  return {
    id: elId,
    width: state.newWidth,
    height: state.newHeight,
    scaleFactor: state.scaleFactor,
    transform: "scale(" + state.scaleFactor + ")",
    verticalMargin: state.verticalMargin,
    horizontalMargin: state.horizontalMargin
  };
}

/**
 * Gets style object for twitter. Notice there is no height or vertical margin
 * since we don't know the final height of tweets even after layout, so we just
 * let the embed handle its own height.
 * @param {number} elId
 * @param {!Object} state
 * @return {!Object}
 */
function updateStylesForTwitter(elId, state) {
  return {
    id: elId,
    width: state.newWidth,
    scaleFactor: state.scaleFactor,
    transform: "scale(" + state.scaleFactor + ")",
    horizontalMargin: state.horizontalMargin
  };
}

/**
 * Minimum vertical space needed to position tooltip.
 * @const {number}
 */
var MIN_VERTICAL_SPACE = 48;

/**
 * Limits the amount of vertical space a component can take in a page, this
 * makes sure no component is blocking the close button at the top of the
 * expanded view.
 * @const {number}
 * @private
 */
var VERTICAL_PADDING = 96;

/**
 * Padding between tooltip and vertical edges of screen.
 * @const {number}
 */
var VERTICAL_EDGE_PADDING = 24;

/**
 * Padding between tooltip and horizontal edges of screen.
 * @const {number}
 */
var HORIZONTAL_EDGE_PADDING = 32;

/**
 * Padding between tooltip arrow and right edge of the tooltip.
 * @const {number}
 */
var TOOLTIP_ARROW_RIGHT_PADDING = 24;

/**
 * @struct @typedef {{
 *   tooltip: !Element,
 *   buttonLeft: !Element,
 *   buttonRight: !Element,
 *   arrow: !Element,
 * }}
 */
var tooltipElementsDef;
var TAG = 'amp-story-embedded-component';

/**
 * Embedded components found in amp-story.
 */
var AmpStoryEmbeddedComponent = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} storyEl
   */
  function AmpStoryEmbeddedComponent(win, storyEl) {
    var _this = this;

    _classCallCheck(this, AmpStoryEmbeddedComponent);

    /** @private {!Window} */
    this.win_ = win;

    /** @private {!Element} */
    this.storyEl_ = storyEl;

    /** @private {?Element} */
    this.shadowRoot_ = null;

    /** @private {?Element} */
    this.focusedStateOverlay_ = null;

    /** @private {?Element} */
    this.tooltip_ = null;

    /** @private {?Element} */
    this.tooltipArrow_ = null;

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.win_);

    /** @private @const {!../../../src/service/mutator-interface.MutatorInterface} */
    this.mutator_ = _services.Services.mutatorForDoc((0, _service.getAmpdoc)(this.win_.document));

    /** @private @const {!./story-analytics.StoryAnalyticsService} */
    this.analyticsService_ = (0, _storyAnalytics.getAnalyticsService)(this.win_, storyEl);

    /** @private @const {!../../../src/service/owners-interface.OwnersInterface} */
    this.owners_ = _services.Services.ownersForDoc((0, _service.getAmpdoc)(this.win_.document));

    /** @private @const {!../../../src/service/timer-impl.Timer} */
    this.timer_ = _services.Services.timerFor(this.win_);

    /** @private {?Element} */
    this.expandedViewOverlay_ = null;

    /**
     * Target producing the tooltip and going to expanded view (when
     * expandable).
     * @private {?Element}
     */
    this.triggeringTarget_ = null;

    /**
     * Page containing component.
     * @private {?Element}
     */
    this.componentPage_ = null;

    /** @private */
    this.expandComponentHandler_ = this.onExpandComponent_.bind(this);

    /** @private */
    this.embedsToBePaused_ = [];
    this.storeService_.subscribe(_ampStoryStoreService.StateProperty.INTERACTIVE_COMPONENT_STATE,
    /** @param {!InteractiveComponentDef} component */
    function (component) {
      _this.onComponentStateUpdate_(component);
    });

    /** @type {!../../../src/service/history-impl.History} */
    this.historyService_ = _services.Services.historyForDoc((0, _service.getAmpdoc)(this.win_.document));

    /** @private {EmbeddedComponentState} */
    this.state_ = _ampStoryStoreService.EmbeddedComponentState.HIDDEN;

    /** @private {?Element} */
    this.buttonLeft_ = null;

    /** @private {?Element} */
    this.buttonRight_ = null;

    /** @private {number} */
    this.historyId_ = -1;
  }

  /**
   * Reacts to embedded component state updates.
   * Possible state updates:
   *
   *    HIDDEN ==> FOCUSED ==> EXPANDED
   *      /\ _________|           |
   *      ||______________________|
   *
   * @param {!InteractiveComponentDef} component
   * @private
   */
  _createClass(AmpStoryEmbeddedComponent, [{
    key: "onComponentStateUpdate_",
    value: function onComponentStateUpdate_(component) {
      switch (component.state) {
        case _ampStoryStoreService.EmbeddedComponentState.HIDDEN:
          this.setState_(_ampStoryStoreService.EmbeddedComponentState.HIDDEN, null
          /** component */
          );
          break;

        case _ampStoryStoreService.EmbeddedComponentState.FOCUSED:
          if (this.state_ !== _ampStoryStoreService.EmbeddedComponentState.HIDDEN) {
            (0, _log.dev)().warn(TAG, "Invalid component update. Not possible to go from " + this.state_ + "\n              to " + component.state);
          }

          this.setState_(_ampStoryStoreService.EmbeddedComponentState.FOCUSED, component);
          break;

        case _ampStoryStoreService.EmbeddedComponentState.EXPANDED:
          if (this.state_ === _ampStoryStoreService.EmbeddedComponentState.FOCUSED) {
            this.setState_(_ampStoryStoreService.EmbeddedComponentState.EXPANDED, component);
          } else if (this.state_ === _ampStoryStoreService.EmbeddedComponentState.EXPANDED) {
            this.maybeCloseExpandedView_(component.element);
          } else {
            (0, _log.dev)().warn(TAG, "Invalid component update. Not possible to go from " + this.state_ + "\n               to " + component.state);
          }

          break;
      }
    }
    /**
     * Sets new state for the embedded component.
     * @param {EmbeddedComponentState} state
     * @param {?InteractiveComponentDef} component
     * @private
     */

  }, {
    key: "setState_",
    value: function setState_(state, component) {
      var _this2 = this;

      switch (state) {
        case _ampStoryStoreService.EmbeddedComponentState.FOCUSED:
          this.state_ = state;
          this.onFocusedStateUpdate_(component);
          this.analyticsService_.triggerEvent(_storyAnalytics.StoryAnalyticsEvent.FOCUS, this.triggeringTarget_);
          break;

        case _ampStoryStoreService.EmbeddedComponentState.HIDDEN:
          this.state_ = state;
          this.onFocusedStateUpdate_(null);
          break;

        case _ampStoryStoreService.EmbeddedComponentState.EXPANDED:
          this.state_ = state;
          this.onFocusedStateUpdate_(null);
          this.scheduleEmbedToPause_(component.element);
          this.toggleExpandedView_(component.element);
          this.historyService_.push(function () {
            return _this2.close_();
          }).then(function (historyId) {
            _this2.historyId_ = historyId;
          });
          break;

        default:
          (0, _log.dev)().warn(TAG, "EmbeddedComponentState " + this.state_ + " does not exist");
          break;
      }
    }
    /**
     * Schedules embeds to be paused.
     * @param {!Element} embedEl
     * @private
     */

  }, {
    key: "scheduleEmbedToPause_",
    value: function scheduleEmbedToPause_(embedEl) {
      // Resources that previously called `schedulePause` must also call
      // `scheduleResume`. Calling `scheduleResume` on resources that did not
      // previously call `schedulePause` has no effect.
      this.owners_.scheduleResume(this.storyEl_, embedEl);

      if (!this.embedsToBePaused_.includes(embedEl)) {
        this.embedsToBePaused_.push(embedEl);
      }
    }
    /**
     * Toggles expanded view for interactive components that support it.
     * @param {?Element} targetToExpand
     * @private
     */

  }, {
    key: "toggleExpandedView_",
    value: function toggleExpandedView_(targetToExpand) {
      var _this3 = this;

      if (!targetToExpand) {
        this.expandedViewOverlay_ && this.mutator_.mutateElement(this.expandedViewOverlay_, function () {
          _this3.componentPage_.classList.toggle('i-amphtml-expanded-mode', false);

          (0, _style.toggle)((0, _log.dev)().assertElement(_this3.expandedViewOverlay_), false);

          _this3.closeExpandedEl_();
        });
        return;
      }

      this.animateExpanded_((0, _log.devAssert)(targetToExpand));
      this.expandedViewOverlay_ = this.componentPage_.querySelector('.i-amphtml-story-expanded-view-overflow');

      if (!this.expandedViewOverlay_) {
        this.buildAndAppendExpandedViewOverlay_();
      }

      this.mutator_.mutateElement((0, _log.dev)().assertElement(this.expandedViewOverlay_), function () {
        (0, _style.toggle)((0, _log.dev)().assertElement(_this3.expandedViewOverlay_), true);

        _this3.componentPage_.classList.toggle('i-amphtml-expanded-mode', true);
      });
    }
    /**
     * Builds the expanded view overlay element and appends it to the page.
     * @private
     */

  }, {
    key: "buildAndAppendExpandedViewOverlay_",
    value: function buildAndAppendExpandedViewOverlay_() {
      var _this4 = this;

      this.expandedViewOverlay_ = buildExpandedViewOverlay(this.storyEl_);
      this.mutator_.mutateElement((0, _log.dev)().assertElement(this.componentPage_), function () {
        return _this4.componentPage_.appendChild(_this4.expandedViewOverlay_);
      });
    }
    /**
     * Closes the expanded view overlay.
     * @param {?Element} target
     * @param {boolean=} forceClose Force closing the expanded view.
     * @private
     */

  }, {
    key: "maybeCloseExpandedView_",
    value: function maybeCloseExpandedView_(target, forceClose) {
      if (forceClose === void 0) {
        forceClose = false;
      }

      if (target && (0, _dom.matches)(target, '.i-amphtml-expanded-view-close-button') || forceClose) {
        if (this.historyId_ !== -1) {
          this.historyService_.goBack();
        } else {
          // Used for visual diff testing viewer.
          this.close_();
        }
      }
    }
    /**
     * Builds the tooltip overlay and appends it to the provided story.
     * @private
     * @return {Node}
     */

  }, {
    key: "buildFocusedState_",
    value: function buildFocusedState_() {
      var _this5 = this;

      this.shadowRoot_ = this.win_.document.createElement('div');
      this.focusedStateOverlay_ = (0, _log.devAssert)(this.buildFocusedStateTemplate_(this.win_.document));
      (0, _utils.createShadowRootWithStyle)(this.shadowRoot_, this.focusedStateOverlay_, _ampStoryTooltip.CSS);
      this.focusedStateOverlay_.addEventListener('click', function (event) {
        return _this5.onOutsideTooltipClick_(event);
      });
      this.tooltip_.addEventListener('click', function (event) {
        event.stopPropagation();

        _this5.analyticsService_.triggerEvent(_storyAnalytics.StoryAnalyticsEvent.CLICK_THROUGH, _this5.triggeringTarget_);
      }, true
      /** capture */
      );
      return this.shadowRoot_;
    }
    /**
     * Clears tooltip UI and updates store state to hidden.
     * @private
     */

  }, {
    key: "close_",
    value: function close_() {
      var _this6 = this;

      // Wait until tooltip closing animation is finished before clearing it.
      // Otherwise jank is noticeable.
      this.timer_.delay(function () {
        _this6.clearTooltip_();
      }, TOOLTIP_CLOSE_ANIMATION_MS);
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_INTERACTIVE_COMPONENT, {
        state: _ampStoryStoreService.EmbeddedComponentState.HIDDEN
      });
      this.toggleExpandedView_(null);
      this.tooltip_.removeEventListener('click', this.expandComponentHandler_, true
      /** capture */
      );
    }
    /**
     * Reacts to store updates related to the focused state, when a tooltip is
     * active.
     * @param {?InteractiveComponentDef} component
     * @private
     */

  }, {
    key: "onFocusedStateUpdate_",
    value: function onFocusedStateUpdate_(component) {
      var _this7 = this;

      if (!component) {
        this.mutator_.mutateElement((0, _log.dev)().assertElement(this.focusedStateOverlay_), function () {
          _this7.focusedStateOverlay_.classList.toggle('i-amphtml-hidden', true);
        });
        return;
      }

      this.triggeringTarget_ = component.element;

      // First time attaching the overlay. Runs only once.
      if (!this.focusedStateOverlay_) {
        this.storyEl_.appendChild(this.buildFocusedState_());
        this.initializeListeners_();
      }

      // Delay building the tooltip to make sure it runs after clearTooltip_,
      // in the case the user taps on a target in quick succession.
      this.timer_.delay(function () {
        _this7.buildTooltip_(component);
      }, TOOLTIP_CLOSE_ANIMATION_MS);
    }
    /**
     * Builds and displays tooltip
     * @param {?InteractiveComponentDef} component
     * @private
     */

  }, {
    key: "buildTooltip_",
    value: function buildTooltip_(component) {
      var _this8 = this;

      this.updateTooltipBehavior_(component.element);
      this.updateTooltipEl_(component);
      this.componentPage_ = (0, _log.devAssert)(this.storyEl_.querySelector('amp-story-page[active]'));
      this.mutator_.mutateElement((0, _log.dev)().assertElement(this.focusedStateOverlay_), function () {
        _this8.focusedStateOverlay_.classList.toggle('i-amphtml-hidden', false);

        (0, _dom.tryFocus)((0, _log.dev)().assertElement(_this8.focusedStateOverlay_.querySelector('a.i-amphtml-story-tooltip')));
      });
    }
    /**
     * Attaches listeners that listen for UI updates.
     * @private
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this9 = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.UI_STATE, function (uiState) {
        _this9.onUIStateUpdate_(uiState);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CURRENT_PAGE_ID, function () {
        // Hide active tooltip when page switch is triggered by keyboard or
        // desktop buttons.
        if (_this9.state_ === _ampStoryStoreService.EmbeddedComponentState.FOCUSED) {
          _this9.close_();
        }

        // Hide expanded view when page switch is triggered by keyboard or desktop
        // buttons.
        if (_this9.state_ === _ampStoryStoreService.EmbeddedComponentState.EXPANDED) {
          _this9.maybeCloseExpandedView_(null
          /** target */
          , true
          /** forceClose */
          );
        }

        // Pauses content inside embeds when a page change occurs.
        while (_this9.embedsToBePaused_.length > 0) {
          var embedEl = _this9.embedsToBePaused_.pop();

          _this9.owners_.schedulePause(_this9.storyEl_, embedEl);
        }
      });
      this.win_.addEventListener('keyup', function (event) {
        if (event.key === _keyCodes.Keys.ESCAPE && _this9.state_ === _ampStoryStoreService.EmbeddedComponentState.EXPANDED) {
          event.preventDefault();

          _this9.maybeCloseExpandedView_(null
          /** target */
          , true
          /** forceClose */
          );
        }
      });
    }
    /**
     * Reacts to desktop state updates and hides navigation buttons since we
     * already have in the desktop UI.
     * @param {!UIType} uiState
     * @private
     */

  }, {
    key: "onUIStateUpdate_",
    value: function onUIStateUpdate_(uiState) {
      var _this10 = this;

      this.mutator_.mutateElement((0, _log.dev)().assertElement(this.focusedStateOverlay_), function () {
        [_ampStoryStoreService.UIType.DESKTOP_FULLBLEED, _ampStoryStoreService.UIType.DESKTOP_PANELS].includes(uiState) ? _this10.focusedStateOverlay_.setAttribute('desktop', '') : _this10.focusedStateOverlay_.removeAttribute('desktop');
      });
    }
    /**
     * Builds and attaches the tooltip.
     * @param {!InteractiveComponentDef} component
     * @private
     */

  }, {
    key: "updateTooltipEl_",
    value: function updateTooltipEl_(component) {
      var embedConfig =
      /** @type {!Object} */
      (0, _log.userAssert)(this.getEmbedConfigFor_(component.element), 'Invalid embed config for target', component.element);
      var theme = this.triggeringTarget_.getAttribute('theme');

      if (theme && TooltipTheme.DARK === theme.toLowerCase()) {
        this.tooltip_.classList.add(DARK_THEME_CLASS);
      }

      this.updateTooltipText_(component.element, embedConfig);
      this.updateTooltipComponentIcon_(component.element, embedConfig);
      this.updateTooltipActionIcon_(embedConfig);
      this.updateNavButtons_();
      this.positionTooltip_(component);
    }
    /**
     * Updates tooltip behavior depending on the target.
     * @param {!Element} target
     * @private
     */

  }, {
    key: "updateTooltipBehavior_",
    value: function updateTooltipBehavior_(target) {
      if ((0, _dom.matches)(target, LAUNCHABLE_COMPONENTS['a'].selector)) {
        (0, _dom.addAttributesToElement)((0, _log.dev)().assertElement(this.tooltip_), (0, _object.dict)({
          'href': this.getElementHref_(target)
        }));
        return;
      }

      if (EXPANDABLE_COMPONENTS[target.tagName.toLowerCase()]) {
        this.tooltip_.addEventListener('click', this.expandComponentHandler_, true);
      }
    }
    /**
     * Handles the event of an interactive element coming into expanded view.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onExpandComponent_",
    value: function onExpandComponent_(event) {
      event.preventDefault();
      event.stopPropagation();
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_INTERACTIVE_COMPONENT, {
        state: _ampStoryStoreService.EmbeddedComponentState.EXPANDED,
        element: this.triggeringTarget_
      });
    }
    /**
     * Gets href from an element containing a url.
     * @param {!Element} target
     * @return {string}
     * @private
     */

  }, {
    key: "getElementHref_",
    value: function getElementHref_(target) {
      var elUrl = target.getAttribute('href');

      if (!(0, _url.isProtocolValid)(elUrl)) {
        (0, _log.user)().error(TAG, 'The tooltip url is invalid');
        return '';
      }

      return (0, _url.parseUrlDeprecated)(elUrl).href;
    }
    /**
     * Gets corresponding config for a given embed target.
     * @param {!Element} target
     * @return {?Object}
     */

  }, {
    key: "getEmbedConfigFor_",
    value: function getEmbedConfigFor_(target) {
      var config = INTERACTIVE_COMPONENTS[target.tagName.toLowerCase()];

      if (config && (0, _dom.matches)(target, config.selector)) {
        return config;
      }

      (0, _log.user)().error(TAG, 'No config matching provided target.');
      return null;
    }
    /**
     * Returns expanded element back to original state.
     * @private
     */

  }, {
    key: "closeExpandedEl_",
    value: function closeExpandedEl_() {
      this.triggeringTarget_.classList.toggle('i-amphtml-expanded-component', false);
      var embedId = this.triggeringTarget_.getAttribute(EMBED_ID_ATTRIBUTE_NAME);
      var embedStyleEl = (0, _log.dev)().assertElement(embedStyleEls[embedId], "Failed to look up embed style element with ID " + embedId);
      embedStyleEl[AMP_EMBED_DATA].transform = "scale(" + embedStyleEl[AMP_EMBED_DATA].scaleFactor + ")";
      updateEmbedStyleEl(this.triggeringTarget_, embedStyleEl, embedStyleEl[AMP_EMBED_DATA]);
    }
    /**
     * Animates into expanded view. It calculates what the full-screen dimensions
     * of the element will be, and uses them to deduce the translateX/Y values
     * once the element reaches its full-screen size.
     * @param {!Element} target
     * @private
     */

  }, {
    key: "animateExpanded_",
    value: function animateExpanded_(target) {
      var _this11 = this;

      var embedId = target.getAttribute(EMBED_ID_ATTRIBUTE_NAME);
      var state = {};
      var embedStyleEl = (0, _log.dev)().assertElement(embedStyleEls[embedId], "Failed to look up embed style element with ID " + embedId);
      var embedData = embedStyleEl[AMP_EMBED_DATA];
      this.mutator_.measureMutateElement(target,
      /** measure */
      function () {
        var targetRect = target.
        /*OK*/
        getBoundingClientRect();

        // TODO(#20832): Store DOMRect for the page in the store to avoid
        // having to call getBoundingClientRect().
        var pageRect = _this11.componentPage_.
        /*OK*/
        getBoundingClientRect();

        var realHeight = target.
        /*OK*/
        offsetHeight;
        var maxHeight = pageRect.height - VERTICAL_PADDING;
        state.scaleFactor = 1;

        if (realHeight > maxHeight) {
          state.scaleFactor = maxHeight / realHeight;
        }

        // Gap on the left of the element between full-screen size and
        // current size.
        var leftGap = (embedData.width - targetRect.width) / 2;
        // Distance from left of page to what will be the left of the
        // element in full-screen.
        var fullScreenLeft = targetRect.left - leftGap - pageRect.left;
        var centeredLeft = pageRect.width / 2 - embedData.width / 2;
        state.translateX = centeredLeft - fullScreenLeft;
        // Gap on the top of the element between full-screen size and
        // current size.
        var topGap = (realHeight * state.scaleFactor - targetRect.height) / 2;
        // Distance from top of page to what will be the top of the element in
        // full-screen.
        var fullScreenTop = targetRect.top - topGap - pageRect.top;
        var centeredTop = pageRect.height / 2 - realHeight * state.scaleFactor / 2;
        state.translateY = centeredTop - fullScreenTop;
      },
      /** mutate */
      function () {
        target.classList.toggle('i-amphtml-expanded-component', true);
        embedData.transform = "translate3d(" + state.translateX + "px,\n            " + state.translateY + "px, 0) scale(" + state.scaleFactor + ")";
        updateEmbedStyleEl(target, embedStyleEl, embedData);
      });
    }
    /**
     * Resizes expandable element before it is expanded to full-screen, in
     * preparation for its animation. It resizes it to its full-screen size, and
     * scales it down to match size set by publisher, adding negative margins so
     * that content around stays put.
     * @param {!Element} pageEl
     * @param {!Element} element
     * @param {!../../../src/service/mutator-interface.MutatorInterface} mutator
     */

  }, {
    key: "updateTooltipText_",

    /**
     * Updates tooltip text content.
     * @param {!Element} target
     * @param {!Object} embedConfig
     * @private
     */
    value: function updateTooltipText_(target, embedConfig) {
      var tooltipText = target.getAttribute('data-tooltip-text') || (0, _ampStoryLocalizationService.getLocalizationService)(this.storyEl_).getLocalizedString(embedConfig.localizedStringId) || (0, _utils.getSourceOriginForElement)(target, this.getElementHref_(target));
      var existingTooltipText = this.tooltip_.querySelector('.i-amphtml-tooltip-text');
      existingTooltipText.textContent = tooltipText;
    }
    /**
     * Updates tooltip action icon. This is found on the right of the text.
     * @param {!Object} embedConfig
     * @private
     */

  }, {
    key: "updateTooltipActionIcon_",
    value: function updateTooltipActionIcon_(embedConfig) {
      var actionIcon = this.tooltip_.querySelector('.i-amphtml-tooltip-action-icon');
      this.mutator_.mutateElement((0, _log.dev)().assertElement(actionIcon), function () {
        actionIcon.classList.toggle(embedConfig.actionIcon, true);
      });
    }
    /**
     * Updates tooltip icon. If no icon src is declared, it sets a default for a
     * given component type.
     * @param {!Element} target
     * @param {!Object} embedConfig
     * @private
     */

  }, {
    key: "updateTooltipComponentIcon_",
    value: function updateTooltipComponentIcon_(target, embedConfig) {
      var iconUrl = target.getAttribute('data-tooltip-icon');

      if (!(0, _url.isProtocolValid)(iconUrl)) {
        (0, _log.user)().error(TAG, 'The tooltip icon url is invalid');
        return;
      }

      var tooltipCustomIcon = this.tooltip_.querySelector('.i-amphtml-story-tooltip-custom-icon');

      // No icon src specified by publisher and no default icon in config.
      if (!iconUrl && !embedConfig.customIconClassName) {
        tooltipCustomIcon.classList.toggle('i-amphtml-hidden', true);
        return;
      }

      // Publisher specified a valid icon url.
      if (iconUrl) {
        this.mutator_.mutateElement((0, _log.dev)().assertElement(tooltipCustomIcon), function () {
          (0, _style.setImportantStyles)((0, _log.dev)().assertElement(tooltipCustomIcon), {
            'background-image': "url(" + (0, _url.parseUrlDeprecated)(iconUrl).href + ")"
          });
        });
        return;
      }

      // No icon src specified by publisher. Use default icon found in the config.
      this.mutator_.mutateElement((0, _log.dev)().assertElement(tooltipCustomIcon), function () {
        tooltipCustomIcon.classList.add(embedConfig.customIconClassName);
      });
    }
    /**
     * Show or hide arrows based on current page.
     * @private
     */

  }, {
    key: "updateNavButtons_",
    value: function updateNavButtons_() {
      if (!this.isLastPage_()) {
        this.buttonLeft_.removeAttribute('hidden');
        this.buttonRight_.removeAttribute('hidden');
      } else {
        this.storeService_.get(_ampStoryStoreService.StateProperty.RTL_STATE) ? this.buttonLeft_.setAttribute('hidden', true) : this.buttonRight_.setAttribute('hidden', true);
      }
    }
    /**
     * Is last page.
     * @return {boolean}
     * @private
     */

  }, {
    key: "isLastPage_",
    value: function isLastPage_() {
      var pageIndex = this.storeService_.get(_ampStoryStoreService.StateProperty.CURRENT_PAGE_INDEX);
      var pageCount = this.storeService_.get(_ampStoryStoreService.StateProperty.PAGE_IDS).length;
      return pageIndex + 1 === pageCount;
    }
    /**
     * Positions tooltip and its pointing arrow according to the position of the
     * target.
     * @param {!InteractiveComponentDef} component
     * @private
     */

  }, {
    key: "positionTooltip_",
    value: function positionTooltip_(component) {
      var _this12 = this;

      var state = {
        arrowOnTop: false
      };
      this.mutator_.measureMutateElement(this.storyEl_,
      /** measure */
      function () {
        var pageRect = _this12.componentPage_.
        /*OK*/
        getBoundingClientRect();

        _this12.horizontalPositioning_(component, pageRect, state);

        _this12.verticalPositioning_(component, pageRect, state);
      },
      /** mutate */
      function () {
        // Arrow on top or bottom of tooltip.
        _this12.tooltip_.classList.toggle('i-amphtml-tooltip-arrow-on-top', state.arrowOnTop);

        (0, _style.setImportantStyles)((0, _log.dev)().assertElement(_this12.tooltipArrow_), {
          left: state.arrowLeftOffset + "px"
        });
        (0, _style.setImportantStyles)((0, _log.devAssert)(_this12.tooltip_), {
          top: state.tooltipTop + "px",
          left: state.tooltipLeft + "px"
        });
      });
    }
    /**
     * Positions tooltip and its arrow vertically.
     * @param {!InteractiveComponentDef} component
     * @param {!ClientRect} pageRect
     * @param {!Object} state
     * @private
     */

  }, {
    key: "verticalPositioning_",
    value: function verticalPositioning_(component, pageRect, state) {
      var tooltipHeight = this.tooltip_.
      /*OK*/
      offsetHeight;
      var verticalOffset = VERTICAL_EDGE_PADDING;
      state.tooltipTop = component.clientY - tooltipHeight - verticalOffset;

      if (state.tooltipTop < pageRect.top + MIN_VERTICAL_SPACE) {
        // Target is too high up screen, place tooltip facing down with
        // arrow on top.
        state.arrowOnTop = true;
        state.tooltipTop = component.clientY + verticalOffset;
      }
    }
    /**
     * Positions tooltip and its arrow horizontally.
     * @param {!InteractiveComponentDef} component
     * @param {!ClientRect} pageRect
     * @param {!Object} state
     * @private
     */

  }, {
    key: "horizontalPositioning_",
    value: function horizontalPositioning_(component, pageRect, state) {
      var tooltipWidth = this.tooltip_.
      /*OK*/
      offsetWidth;
      state.tooltipLeft = component.clientX - tooltipWidth / 2;
      var maxLeft = pageRect.left + pageRect.width - HORIZONTAL_EDGE_PADDING - tooltipWidth;
      var minLeft = pageRect.left + HORIZONTAL_EDGE_PADDING;
      // Make sure tooltip is inside bounds of the page.
      state.tooltipLeft = Math.min(state.tooltipLeft, maxLeft);
      state.tooltipLeft = Math.max(state.tooltipLeft, minLeft);
      state.arrowLeftOffset = Math.abs(component.clientX - state.tooltipLeft - this.tooltipArrow_.
      /*OK*/
      offsetWidth / 2);
      // Make sure tooltip arrow is inside bounds of the tooltip.
      state.arrowLeftOffset = Math.min(state.arrowLeftOffset, tooltipWidth - TOOLTIP_ARROW_RIGHT_PADDING);
      state.arrowLeftOffset = Math.max(state.arrowLeftOffset, 0);
    }
    /**
     * Handles click outside the tooltip.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onOutsideTooltipClick_",
    value: function onOutsideTooltipClick_(event) {
      var _this13 = this;

      if (!(0, _dom.closest)((0, _log.dev)().assertElement(event.target), function (el) {
        return el == _this13.tooltip_;
      })) {
        event.stopPropagation();
        this.close_();
      }
    }
    /**
     * Clears any attributes or handlers that may have been added to the tooltip,
     * but weren't used because the user dismissed the tooltip.
     * @private
     */

  }, {
    key: "clearTooltip_",
    value: function clearTooltip_() {
      var _this14 = this;

      this.mutator_.mutateElement((0, _log.dev)().assertElement(this.tooltip_), function () {
        var actionIcon = _this14.tooltip_.querySelector('.i-amphtml-tooltip-action-icon');

        actionIcon.className = 'i-amphtml-tooltip-action-icon';

        var customIcon = _this14.tooltip_.querySelector('.i-amphtml-story-tooltip-custom-icon');

        customIcon.className = 'i-amphtml-story-tooltip-custom-icon';
        (0, _style.resetStyles)(customIcon, ['background-image']);

        _this14.tooltip_.removeEventListener('click', _this14.expandComponentHandler_, true);

        _this14.tooltip_.classList.remove(DARK_THEME_CLASS);

        _this14.tooltip_.removeAttribute('href');
      });
    }
    /**
     * Builds the focused state template.
     * @param {!Document} doc
     * @return {!Element}
     * @private
     */

  }, {
    key: "buildFocusedStateTemplate_",
    value: function buildFocusedStateTemplate_(doc) {
      var _this15 = this;

      var html = (0, _staticTemplate.htmlFor)(doc);
      var tooltipOverlay = html(_templateObject2());
      var overlayEls = (0, _staticTemplate.htmlRefs)(tooltipOverlay);
      var tooltip =
      /** @type {!tooltipElementsDef} */
      overlayEls.tooltip,
          buttonLeft = overlayEls.buttonLeft,
          buttonRight = overlayEls.buttonRight,
          arrow = overlayEls.arrow;
      this.tooltip_ = tooltip;
      this.tooltipArrow_ = arrow;
      this.buttonLeft_ = buttonLeft;
      this.buttonRight_ = buttonRight;
      var rtlState = this.storeService_.get(_ampStoryStoreService.StateProperty.RTL_STATE);
      this.buttonLeft_.addEventListener('click', function (e) {
        return _this15.onNavigationalClick_(e, rtlState ? _events.EventType.NEXT_PAGE : _events.EventType.PREVIOUS_PAGE);
      });
      this.buttonRight_.addEventListener('click', function (e) {
        return _this15.onNavigationalClick_(e, rtlState ? _events.EventType.PREVIOUS_PAGE : _events.EventType.NEXT_PAGE);
      });
      return tooltipOverlay;
    }
    /**
     * Navigates to next/previous page.
     * @param {!Event} event
     * @param {string} direction
     * @private
     */

  }, {
    key: "onNavigationalClick_",
    value: function onNavigationalClick_(event, direction) {
      event.preventDefault();
      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.MANUAL_ADVANCE);
      (0, _events.dispatch)(this.win_, (0, _log.dev)().assertElement(this.shadowRoot_), direction, undefined, {
        bubbles: true
      });
    }
    /**
     * @visibleForTesting
     * @return {?Element}
     */

  }, {
    key: "getShadowRootForTesting",
    value: function getShadowRootForTesting() {
      return this.shadowRoot_;
    }
  }], [{
    key: "prepareForAnimation",
    value: function prepareForAnimation(pageEl, element, mutator) {
      var elId = null;

      // When a window resize happens, we must reset the styles and prepare the
      // animation again.
      if (element.hasAttribute(EMBED_ID_ATTRIBUTE_NAME)) {
        elId = parseInt(element.getAttribute(EMBED_ID_ATTRIBUTE_NAME), 10);
        var embedStyleEl = (0, _log.dev)().assertElement(embedStyleEls[elId], "Failed to look up embed style element with ID " + elId);
        embedStyleEl.textContent = '';
        embedStyleEl[AMP_EMBED_DATA] = {};
      }

      var state = {};
      mutator.measureMutateElement(element,
      /** measure */
      function () {
        var pageRect = pageEl.
        /*OK*/
        getBoundingClientRect();
        var elRect = element.
        /*OK*/
        getBoundingClientRect();
        state = measureStyleForEl(element, state, pageRect, elRect);
      },
      /** mutate */
      function () {
        elId = elId ? elId : ++embedIds;

        if (!element.hasAttribute(EMBED_ID_ATTRIBUTE_NAME)) {
          // First time creating <style> element for embed.
          var html = (0, _staticTemplate.htmlFor)(pageEl);

          var _embedStyleEl = html(_templateObject3());

          element.setAttribute(EMBED_ID_ATTRIBUTE_NAME, elId);
          pageEl.insertBefore(_embedStyleEl, pageEl.firstChild);
          embedStyleEls[elId] = _embedStyleEl;
        }

        embedStyleEls[elId][AMP_EMBED_DATA] = _extends({}, updateStyleForEl(element, elId, state));
        var embedStyleEl = (0, _log.dev)().assertElement(embedStyleEls[elId], "Failed to look up embed style element with ID " + elId);
        updateEmbedStyleEl(element, embedStyleEl, embedStyleEl[AMP_EMBED_DATA]);
      });
    }
  }]);

  return AmpStoryEmbeddedComponent;
}();

exports.AmpStoryEmbeddedComponent = AmpStoryEmbeddedComponent;

},{"../../../build/amp-story-tooltip-1.0.css":9,"../../../src/dom":106,"../../../src/localized-strings":122,"../../../src/log":123,"../../../src/service":130,"../../../src/services":133,"../../../src/static-template":135,"../../../src/style":138,"../../../src/url":142,"../../../src/utils/key-codes":147,"../../../src/utils/object":149,"./amp-story-localization-service":45,"./amp-story-store-service":53,"./events":76,"./story-analytics":91,"./utils":93}],42:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryGridLayer = exports.GRID_LAYER_TEMPLATE_CLASS_NAMES = void 0;

var _ampStoryBaseLayer = require("./amp-story-base-layer");

var _ampStoryStoreService = require("./amp-story-store-service");

var _style = require("../../../src/style");

var _dom = require("../../../src/dom");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * A mapping of attribute names we support for grid layers to the CSS Grid
 * properties they control.
 * @private @const {!Object<string, string>}
 */
var SUPPORTED_CSS_GRID_ATTRIBUTES = {
  'align-content': 'alignContent',
  'align-items': 'alignItems',
  'align-self': 'alignSelf',
  'grid-area': 'gridArea',
  'justify-content': 'justifyContent',
  'justify-items': 'justifyItems',
  'justify-self': 'justifySelf'
};

/**
 * Converts the keys of the SUPPORTED_CSS_GRID_ATTRIBUTES object above into a
 * selector for the specified attributes.
 * (e.g. [align-content], [align-items], ...)
 * @private @const {string}
 */
var SUPPORTED_CSS_GRID_ATTRIBUTES_SELECTOR = Object.keys(SUPPORTED_CSS_GRID_ATTRIBUTES).map(function (key) {
  return "[" + key + "]";
}).join(',');

/**
 * The attribute name for grid layer templates.
 * @private @const {string}
 */
var TEMPLATE_ATTRIBUTE_NAME = 'template';

/**
 * A mapping of template attribute values to CSS class names.
 * @const {!Object<string, string>}
 */
var GRID_LAYER_TEMPLATE_CLASS_NAMES = {
  'fill': 'i-amphtml-story-grid-template-fill',
  'vertical': 'i-amphtml-story-grid-template-vertical',
  'horizontal': 'i-amphtml-story-grid-template-horizontal',
  'thirds': 'i-amphtml-story-grid-template-thirds'
};
exports.GRID_LAYER_TEMPLATE_CLASS_NAMES = GRID_LAYER_TEMPLATE_CLASS_NAMES;

/**
 * Grid layer template templating system.
 */
var AmpStoryGridLayer = /*#__PURE__*/function (_AmpStoryBaseLayer) {
  _inherits(AmpStoryGridLayer, _AmpStoryBaseLayer);

  var _super = _createSuper(AmpStoryGridLayer);

  /** @param {!AmpElement} element */
  function AmpStoryGridLayer(element) {
    var _this;

    _classCallCheck(this, AmpStoryGridLayer);

    _this = _super.call(this, element);

    /** @private {boolean} */
    _this.prerenderAllowed_ = false;

    /** @private {?{horiz: number, vert: number}} */
    _this.aspectRatio_ = null;
    return _this;
  }

  /** @override */
  _createClass(AmpStoryGridLayer, [{
    key: "firstAttachedCallback",
    value: function firstAttachedCallback() {
      // Only prerender if child of the first page.
      this.prerenderAllowed_ = (0, _dom.matches)(this.element, 'amp-story-page:first-of-type amp-story-grid-layer');
    }
    /** @override */

  }, {
    key: "buildCallback",
    value: function buildCallback() {
      _get(_getPrototypeOf(AmpStoryGridLayer.prototype), "buildCallback", this).call(this);

      this.applyTemplateClassName_();
      this.setOwnCssGridStyles_();
      this.setDescendentCssGridStyles_();
      this.initializeListeners_();
    }
    /** @override */

  }, {
    key: "prerenderAllowed",
    value: function prerenderAllowed() {
      return this.prerenderAllowed_;
    }
    /** @private */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var aspectRatio = this.element.getAttribute('aspect-ratio');

      if (aspectRatio) {
        var aspectRatioSplits = aspectRatio.split(':');
        var horiz = parseInt(aspectRatioSplits[0], 10);
        var vert = parseInt(aspectRatioSplits[1], 10);

        if (horiz > 0 && vert > 0) {
          this.aspectRatio_ = {
            horiz: horiz,
            vert: vert
          };
          var storeService = (0, _ampStoryStoreService.getStoreService)(this.win);
          storeService.subscribe(_ampStoryStoreService.StateProperty.PAGE_SIZE, this.updatePageSize_.bind(this), true
          /* callToInitialize */
          );
        }
      }
    }
    /**
     * @param {?{width: number, height: number}} pageSize
     * @private
     */

  }, {
    key: "updatePageSize_",
    value: function updatePageSize_(pageSize) {
      var _this2 = this;

      if (!pageSize) {
        return;
      }

      var vw = pageSize.width,
          vh = pageSize.height;
      var _this$aspectRatio_ = this.aspectRatio_,
          horiz = _this$aspectRatio_.horiz,
          vert = _this$aspectRatio_.vert;
      var width = Math.min(vw, vh * horiz / vert);
      var height = Math.min(vh, vw * vert / horiz);

      if (width > 0 && height > 0) {
        this.getVsync().mutate(function () {
          _this2.element.classList.add('i-amphtml-story-grid-template-aspect');

          (0, _style.setStyles)(_this2.element, {
            '--i-amphtml-story-layer-width': (0, _style.px)(width),
            '--i-amphtml-story-layer-height': (0, _style.px)(height)
          });
        });
      }
    }
    /**
     * Applies internal CSS class names for the template attribute, so that styles
     * can use the class name instead of compound
     * amp-story-grid-layer[template="..."] selectors, since the latter increases
     * CSS specificity and can prevent users from being able to override styles.
     * @private
     */

  }, {
    key: "applyTemplateClassName_",
    value: function applyTemplateClassName_() {
      if (this.element.hasAttribute(TEMPLATE_ATTRIBUTE_NAME)) {
        var templateName = this.element.getAttribute(TEMPLATE_ATTRIBUTE_NAME);
        var templateClassName = GRID_LAYER_TEMPLATE_CLASS_NAMES[templateName];
        this.element.classList.add(templateClassName);
      }
    }
    /**
     * Copies the allowlisted CSS grid styles for descendants of the
     * <amp-story-grid-layer> element.
     * @private
     */

  }, {
    key: "setDescendentCssGridStyles_",
    value: function setDescendentCssGridStyles_() {
      var _this3 = this;

      var elementsToUpgradeStyles = (0, _dom.scopedQuerySelectorAll)(this.element, SUPPORTED_CSS_GRID_ATTRIBUTES_SELECTOR);
      Array.prototype.forEach.call(elementsToUpgradeStyles, function (element) {
        _this3.setCssGridStyles_(element);
      });
    }
    /**
     * Copies the allowlisted CSS grid styles for the <amp-story-grid-layer>
     * element itself.
     * @private
     */

  }, {
    key: "setOwnCssGridStyles_",
    value: function setOwnCssGridStyles_() {
      this.setCssGridStyles_(this.element);
    }
    /**
     * Copies the values of an element's attributes to its styles, if the
     * attributes/properties are in the allowlist.
     *
     * @param {!Element} element The element whose styles should be copied from
     *     its attributes.
     */

  }, {
    key: "setCssGridStyles_",
    value: function setCssGridStyles_(element) {
      var styles = {};

      for (var i = element.attributes.length - 1; i >= 0; i--) {
        var attribute = element.attributes[i];
        var attributeName = attribute.name.toLowerCase();
        var propertyName = SUPPORTED_CSS_GRID_ATTRIBUTES[attributeName];

        if (propertyName) {
          styles[propertyName] = attribute.value;
          element.removeAttribute(attributeName);
        }
      }

      (0, _style.setStyles)(element, (0, _style.assertDoesNotContainDisplay)(styles));
    }
  }]);

  return AmpStoryGridLayer;
}(_ampStoryBaseLayer.AmpStoryBaseLayer);

exports.AmpStoryGridLayer = AmpStoryGridLayer;

},{"../../../src/dom":106,"../../../src/style":138,"./amp-story-base-layer":37,"./amp-story-store-service":53}],43:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryHint = void 0;

var _ampStoryHint = require("../../../build/amp-story-hint-1.0.css");

var _ampStoryStoreService = require("./amp-story-store-service");

var _localizedStrings = require("../../../src/localized-strings");

var _services = require("../../../src/services");

var _utils = require("./utils");

var _object = require("../../../src/utils/object");

var _simpleTemplate = require("./simple-template");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @private @const {!./simple-template.ElementDef} */
var TEMPLATE = {
  tag: 'aside',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-hint-container ' + 'i-amphtml-story-system-reset i-amphtml-hidden'
  }),
  children: [{
    tag: 'div',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-navigation-help-overlay'
    }),
    children: [{
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-navigation-help-section prev-page'
      }),
      children: [{
        tag: 'div',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-hint-placeholder'
        }),
        children: [{
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-hint-tap-button'
          }),
          children: [{
            tag: 'div',
            attrs: (0, _object.dict)({
              'class': 'i-amphtml-story-hint-tap-button-icon'
            })
          }]
        }, {
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-hint-tap-button-text'
          }),
          localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_PREVIOUS_LABEL
        }]
      }]
    }, {
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-navigation-help-section next-page'
      }),
      children: [{
        tag: 'div',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-hint-placeholder'
        }),
        children: [{
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-hint-tap-button'
          }),
          children: [{
            tag: 'div',
            attrs: (0, _object.dict)({
              'class': 'i-amphtml-story-hint-tap-button-icon'
            })
          }]
        }, {
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-hint-tap-button-text'
          }),
          localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_HINT_UI_NEXT_LABEL
        }]
      }]
    }]
  }]
};

/** @type {string} */
var NAVIGATION_OVERLAY_CLASS = 'show-navigation-overlay';

/** @type {string} */
var FIRST_PAGE_OVERLAY_CLASS = 'show-first-page-overlay';

/** @type {number} */
var NAVIGATION_OVERLAY_TIMEOUT = 3000;

/** @type {number} */
var FIRST_PAGE_NAVIGATION_OVERLAY_TIMEOUT = 275;

/**
 * User Hint Layer for <amp-story>.
 */
var AmpStoryHint = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} parentEl Element where to append the component
   */
  function AmpStoryHint(win, parentEl) {
    _classCallCheck(this, AmpStoryHint);

    /** @private {!Window} */
    this.win_ = win;

    /** @private {boolean} Whether the component is built. */
    this.isBuilt_ = false;

    /** @private {!Document} */
    this.document_ = this.win_.document;

    /** @const @private {!../../../src/service/vsync-impl.Vsync} */
    this.vsync_ = _services.Services.vsyncFor(this.win_);

    /** @const @private {!../../../src/service/timer-impl.Timer} */
    this.timer_ = _services.Services.timerFor(this.win_);

    /** @private {?Element} */
    this.hintContainer_ = null;

    /** @private {?(number|string)} */
    this.hintTimeout_ = null;

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.win_);

    /** @private @const {!Element} */
    this.parentEl_ = parentEl;
  }

  /**
   * Builds the hint layer DOM.
   */
  _createClass(AmpStoryHint, [{
    key: "build",
    value: function build() {
      var _this = this;

      if (this.isBuilt()) {
        return;
      }

      this.isBuilt_ = true;
      var root = this.document_.createElement('div');
      this.hintContainer_ = (0, _simpleTemplate.renderAsElement)(this.document_, TEMPLATE);
      (0, _utils.createShadowRootWithStyle)(root, this.hintContainer_, _ampStoryHint.CSS);
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.RTL_STATE, function (rtlState) {
        _this.onRtlStateUpdate_(rtlState);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.SYSTEM_UI_IS_VISIBLE_STATE, function (isVisible) {
        _this.onSystemUiIsVisibleStateUpdate_(isVisible);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.BOOKEND_STATE, function (isOpen) {
        _this.onBookendStateUpdate_(isOpen);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.INTERACTIVE_COMPONENT_STATE,
      /** @param {./amp-story-store-service.InteractiveComponentDef} component */
      function (component) {
        _this.hideOnFocusedState_(component.state === _ampStoryStoreService.EmbeddedComponentState.FOCUSED);
      });
      this.vsync_.mutate(function () {
        _this.parentEl_.appendChild(root);
      });
    }
    /**
     * Whether the component is built.
     * @return {boolean}
     */

  }, {
    key: "isBuilt",
    value: function isBuilt() {
      return this.isBuilt_;
    }
    /**
     * Shows the given hint, only if not desktop.
     * @param {string} hintClass
     * @private
     */

  }, {
    key: "showHint_",
    value: function showHint_(hintClass) {
      var _this2 = this;

      if (this.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) !== _ampStoryStoreService.UIType.MOBILE) {
        return;
      }

      this.build();
      this.vsync_.mutate(function () {
        _this2.hintContainer_.classList.toggle(NAVIGATION_OVERLAY_CLASS, hintClass == NAVIGATION_OVERLAY_CLASS);

        _this2.hintContainer_.classList.toggle(FIRST_PAGE_OVERLAY_CLASS, hintClass == FIRST_PAGE_OVERLAY_CLASS);

        _this2.hintContainer_.classList.remove('i-amphtml-hidden');

        var hideTimeout = hintClass == NAVIGATION_OVERLAY_CLASS ? NAVIGATION_OVERLAY_TIMEOUT : FIRST_PAGE_NAVIGATION_OVERLAY_TIMEOUT;

        _this2.hideAfterTimeout(hideTimeout);
      });
    }
    /**
     * Show navigation overlay DOM.
     */

  }, {
    key: "showNavigationOverlay",
    value: function showNavigationOverlay() {
      // Don't show the overlay if the share menu is open.
      if (this.storeService_.get(_ampStoryStoreService.StateProperty.SHARE_MENU_STATE)) {
        return;
      }

      this.showHint_(NAVIGATION_OVERLAY_CLASS);
    }
    /**
     * Show navigation overlay DOM.
     */

  }, {
    key: "showFirstPageHintOverlay",
    value: function showFirstPageHintOverlay() {
      this.showHint_(FIRST_PAGE_OVERLAY_CLASS);
    }
    /**
     * Hides the overlay after a given time
     * @param {number} timeout
     */

  }, {
    key: "hideAfterTimeout",
    value: function hideAfterTimeout(timeout) {
      var _this3 = this;

      this.hintTimeout_ = this.timer_.delay(function () {
        return _this3.hideInternal_();
      }, timeout);
    }
    /**
     * Hide all navigation hints.
     */

  }, {
    key: "hideAllNavigationHint",
    value: function hideAllNavigationHint() {
      this.hideInternal_();

      if (this.hintTimeout_ !== null) {
        this.timer_.cancel(this.hintTimeout_);
        this.hintTimeout_ = null;
      }
    }
    /** @private */

  }, {
    key: "hideInternal_",
    value: function hideInternal_() {
      var _this4 = this;

      if (!this.isBuilt()) {
        return;
      }

      this.vsync_.mutate(function () {
        _this4.hintContainer_.classList.add('i-amphtml-hidden');
      });
    }
    /**
     * Reacts to RTL state updates and triggers the UI for RTL.
     * @param {boolean} rtlState
     * @private
     */

  }, {
    key: "onRtlStateUpdate_",
    value: function onRtlStateUpdate_(rtlState) {
      var _this5 = this;

      this.vsync_.mutate(function () {
        rtlState ? _this5.hintContainer_.setAttribute('dir', 'rtl') : _this5.hintContainer_.removeAttribute('dir');
      });
    }
    /**
     * Reacts to system UI visibility state updates.
     * @param {boolean} isVisible
     * @private
     */

  }, {
    key: "onSystemUiIsVisibleStateUpdate_",
    value: function onSystemUiIsVisibleStateUpdate_(isVisible) {
      if (!isVisible) {
        this.hideAllNavigationHint();
      }
    }
    /**
     * Reacts to bookend state updates.
     * @param {boolean} isOpen
     * @private
     */

  }, {
    key: "onBookendStateUpdate_",
    value: function onBookendStateUpdate_(isOpen) {
      if (isOpen) {
        this.hideAllNavigationHint();
      }
    }
    /**
     * Hides navigation hint if tooltip is open.
     * @param {boolean} isActive
     * @private
     */

  }, {
    key: "hideOnFocusedState_",
    value: function hideOnFocusedState_(isActive) {
      if (isActive) {
        this.hideAllNavigationHint();
      }
    }
  }]);

  return AmpStoryHint;
}();

exports.AmpStoryHint = AmpStoryHint;

},{"../../../build/amp-story-hint-1.0.css":5,"../../../src/localized-strings":122,"../../../src/services":133,"../../../src/utils/object":149,"./amp-story-store-service":53,"./simple-template":89,"./utils":93}],44:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.InfoDialog = exports.MOREINFO_VISIBLE_CLASS = exports.DIALOG_VISIBLE_CLASS = void 0;

var _resolvedPromise3 = require("./../../../src/resolved-promise");

var _storyAnalytics = require("./story-analytics");

var _ampStoryStoreService = require("./amp-story-store-service");

var _ampStoryInfoDialog = require("../../../build/amp-story-info-dialog-1.0.css");

var _localizedStrings = require("../../../src/localized-strings");

var _services = require("../../../src/services");

var _url = require("../../../src/url");

var _dom = require("../../../src/dom");

var _utils = require("./utils");

var _log = require("../../../src/log");

var _service = require("../../../src/service");

var _ampStoryLocalizationService = require("./amp-story-localization-service");

var _staticTemplate = require("../../../src/static-template");

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <div class=\"i-amphtml-story-info-dialog i-amphtml-story-system-reset\">\n        <div class=\"i-amphtml-story-info-dialog-container\">\n          <h1 class=\"i-amphtml-story-info-heading\"></h1>\n          <a class=\"i-amphtml-story-info-link\"></a>\n          <a class=\"i-amphtml-story-info-moreinfo\"></a>\n        </div>\n      </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {string} Class to toggle the info dialog. */
var DIALOG_VISIBLE_CLASS = 'i-amphtml-story-info-dialog-visible';
exports.DIALOG_VISIBLE_CLASS = DIALOG_VISIBLE_CLASS;

/** @const {string} Class to toggle the info dialog link. */
var MOREINFO_VISIBLE_CLASS = 'i-amphtml-story-info-moreinfo-visible';
exports.MOREINFO_VISIBLE_CLASS = MOREINFO_VISIBLE_CLASS;

/**
 * A dialog that provides a link to the canonical URL of the story, as well as
 * a link to any more information that the viewer would like to provide about
 * linking on that platform.
 */
var InfoDialog = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} parentEl Element where to append the component
   */
  function InfoDialog(win, parentEl) {
    _classCallCheck(this, InfoDialog);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {?Element} */
    this.element_ = null;

    /** @private {?Element} */
    this.innerContainerEl_ = null;

    /** @private {boolean} */
    this.isBuilt_ = false;

    /** @private @const {!../../../src/service/localization.LocalizationService} */
    this.localizationService_ = (0, _ampStoryLocalizationService.getLocalizationService)(parentEl);

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.win_);

    /** @private {!./story-analytics.StoryAnalyticsService} */
    this.analyticsService_ = (0, _storyAnalytics.getAnalyticsService)(this.win_, parentEl);

    /** @private @const {!Element} */
    this.parentEl_ = parentEl;

    /** @private @const {!../../../src/service/mutator-interface.MutatorInterface} */
    this.mutator_ = _services.Services.mutatorForDoc((0, _service.getAmpdoc)(this.win_.document));

    /** @private {?Element} */
    this.moreInfoLinkEl_ = null;

    /** @const @private {!../../../src/service/viewer-interface.ViewerInterface} */
    this.viewer_ = _services.Services.viewerForDoc(this.parentEl_);
  }

  /**
   * Builds and appends the component in the story.
   * @return {!Promise} used for testing to ensure that the component is built
   *     before assertions.
   */
  _createClass(InfoDialog, [{
    key: "build",
    value: function build() {
      var _this = this;

      if (this.isBuilt()) {
        return (0, _resolvedPromise3.resolvedPromise)();
      }

      this.isBuilt_ = true;
      var root = this.win_.document.createElement('div');
      var html = (0, _staticTemplate.htmlFor)(this.parentEl_);
      this.element_ = html(_templateObject());
      (0, _utils.createShadowRootWithStyle)(root, this.element_, _ampStoryInfoDialog.CSS);
      this.initializeListeners_();
      this.innerContainerEl_ = this.element_.querySelector('.i-amphtml-story-info-dialog-container');
      var appendPromise = this.mutator_.mutateElement(this.parentEl_, function () {
        _this.parentEl_.appendChild(root);
      });

      var pageUrl = _services.Services.documentInfoForDoc((0, _service.getAmpdoc)(this.parentEl_)).canonicalUrl;

      return Promise.all([appendPromise, this.setHeading_(), this.setPageLink_(pageUrl), this.requestMoreInfoLink_().then(function (moreInfoUrl) {
        return _this.setMoreInfoLinkUrl_(moreInfoUrl);
      })]);
    }
    /**
     * Whether the element has been built.
     * @return {boolean}
     */

  }, {
    key: "isBuilt",
    value: function isBuilt() {
      return this.isBuilt_;
    }
    /**
     * @private
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this2 = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.INFO_DIALOG_STATE, function (isOpen) {
        _this2.onInfoDialogStateUpdated_(isOpen);
      });
      this.element_.addEventListener('click', function (event) {
        return _this2.onInfoDialogClick_(event);
      });
    }
    /**
     * Reacts to dialog state updates and decides whether to show either the
     * native system sharing, or the fallback UI.
     * @param {boolean} isOpen
     * @private
     */

  }, {
    key: "onInfoDialogStateUpdated_",
    value: function onInfoDialogStateUpdated_(isOpen) {
      var _this3 = this;

      this.mutator_.mutateElement((0, _log.dev)().assertElement(this.element_), function () {
        _this3.element_.classList.toggle(DIALOG_VISIBLE_CLASS, isOpen);
      });
      this.element_[_storyAnalytics.ANALYTICS_TAG_NAME] = 'amp-story-info-dialog';
      this.analyticsService_.triggerEvent(isOpen ? _storyAnalytics.StoryAnalyticsEvent.OPEN : _storyAnalytics.StoryAnalyticsEvent.CLOSE, this.element_);
    }
    /**
     * Handles click events and maybe closes the dialog.
     * @param  {!Event} event
     */

  }, {
    key: "onInfoDialogClick_",
    value: function onInfoDialogClick_(event) {
      var _this4 = this;

      var el = (0, _log.dev)().assertElement(event.target);

      // Closes the dialog if click happened outside of the dialog main container.
      if (!(0, _dom.closest)(el, function (el) {
        return el === _this4.innerContainerEl_;
      }, this.element_)) {
        this.close_();
      }
    }
    /**
     * Closes the info dialog.
     * @private
     */

  }, {
    key: "close_",
    value: function close_() {
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_INFO_DIALOG, false);
    }
    /**
     * @return {!Promise<?string>} The URL to visit to receive more info on this
     *     page.
     * @private
     */

  }, {
    key: "requestMoreInfoLink_",
    value: function requestMoreInfoLink_() {
      if (!this.viewer_.isEmbedded()) {
        return Promise.resolve(null);
      }

      return this.viewer_.
      /*OK*/
      sendMessageAwaitResponse('moreInfoLinkUrl',
      /* data */
      undefined).then(function (moreInfoUrl) {
        if (!moreInfoUrl) {
          return null;
        }

        return (0, _url.assertAbsoluteHttpOrHttpsUrl)((0, _log.dev)().assertString(moreInfoUrl));
      });
    }
    /**
     * Sets the heading on the dialog.
     * @return {*} TODO(#23582): Specify return type
     */

  }, {
    key: "setHeading_",
    value: function setHeading_() {
      var label = this.localizationService_.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL);
      var headingEl = (0, _log.dev)().assertElement(this.element_.querySelector('.i-amphtml-story-info-heading'));
      return this.mutator_.mutateElement(headingEl, function () {
        headingEl.textContent = label;
      });
    }
    /**
     * @param {string} pageUrl The URL to the canonical version of the current
     *     document.
     * @return {*} TODO(#23582): Specify return type
     */

  }, {
    key: "setPageLink_",
    value: function setPageLink_(pageUrl) {
      var linkEl = (0, _log.dev)().assertElement(this.element_.querySelector('.i-amphtml-story-info-link'));
      return this.mutator_.mutateElement(linkEl, function () {
        linkEl.setAttribute('href', pageUrl);
        // Add zero-width space character (\u200B) after "." and "/" characters
        // to help line-breaks occur more naturally.
        linkEl.textContent = pageUrl.replace(/([/.]+)/gi, "$1\u200B");
      });
    }
    /**
     * @param {?string} moreInfoUrl The URL to the "more info" page, if there is
     * one.
     * @return {*} TODO(#23582): Specify return type
     */

  }, {
    key: "setMoreInfoLinkUrl_",
    value: function setMoreInfoLinkUrl_(moreInfoUrl) {
      var _this5 = this;

      if (!moreInfoUrl) {
        return (0, _resolvedPromise3.resolvedPromise)();
      }

      this.moreInfoLinkEl_ = (0, _log.dev)().assertElement(this.element_.querySelector('.i-amphtml-story-info-moreinfo'));
      return this.mutator_.mutateElement(this.moreInfoLinkEl_, function () {
        var label = _this5.localizationService_.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_DOMAIN_DIALOG_HEADING_LINK);

        _this5.moreInfoLinkEl_.classList.add(MOREINFO_VISIBLE_CLASS);

        _this5.moreInfoLinkEl_.setAttribute('href', (0, _log.dev)().assertString(moreInfoUrl));

        _this5.moreInfoLinkEl_.setAttribute('target', '_blank');

        _this5.moreInfoLinkEl_.textContent = label;
      });
    }
  }]);

  return InfoDialog;
}();

exports.InfoDialog = InfoDialog;

},{"../../../build/amp-story-info-dialog-1.0.css":6,"../../../src/dom":106,"../../../src/localized-strings":122,"../../../src/log":123,"../../../src/service":130,"../../../src/services":133,"../../../src/static-template":135,"../../../src/url":142,"./../../../src/resolved-promise":129,"./amp-story-localization-service":45,"./amp-story-store-service":53,"./story-analytics":91,"./utils":93}],45:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getLocalizationService = void 0;

var _localization = require("../../../src/service/localization");

var _services = require("../../../src/services");

var _service = require("../../../src/service");

/**
 * Copyright 2020 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Util function to retrieve the localization service. Ensures we can retrieve
 * the service synchronously from the amp-story codebase without running into
 * race conditions.
 * @param {!Element} element
 * @return {!../../../src/service/localization.LocalizationService}
 */
var getLocalizationService = function getLocalizationService(element) {
  var localizationService = _services.Services.localizationForDoc(element);

  if (!localizationService) {
    localizationService = new _localization.LocalizationService(element);
    (0, _service.registerServiceBuilderForDoc)(element, 'localization', function () {
      return localizationService;
    });
  }

  return localizationService;
};

exports.getLocalizationService = getLocalizationService;

},{"../../../src/service":130,"../../../src/service/localization":132,"../../../src/services":133}],46:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryMediaQueryService = exports.getMediaQueryService = void 0;

var _services = require("../../../src/services");

var _log = require("../../../src/log");

var _service = require("../../../src/service");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Util function to retrieve the media query service. Ensures we can retrieve
 * the service synchronously from the amp-story codebase without running into
 * race conditions.
 * @param  {!Window} win
 * @return {!AmpStoryMediaQueryService}
 */
var getMediaQueryService = function getMediaQueryService(win) {
  var service = _services.Services.storyMediaQueryService(win);

  if (!service) {
    service = new AmpStoryMediaQueryService(win);
    (0, _service.registerServiceBuilder)(win, 'story-media-query', function () {
      return service;
    });
  }

  return service;
};

exports.getMediaQueryService = getMediaQueryService;

/**
 * Media query service.
 */
var AmpStoryMediaQueryService = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function AmpStoryMediaQueryService(win) {
    _classCallCheck(this, AmpStoryMediaQueryService);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {?Promise} */
    this.initializePromise_ = null;

    /** @private {?Element} Iframe matcher. */
    this.matcher_ = null;

    /** @private @const {!Element} */
    this.storyEl_ = (0, _log.dev)().assertElement(this.win_.document.querySelector('amp-story'));
  }

  /**
   * Registers the media query and triggering the provided callback on match.
   * @param {string} media The media query, ie: '(orientation: portrait)'
   * @param {function(boolean)} callback Called when the media query matches.
   * @return {!Promise<!MediaQueryList>}
   */
  _createClass(AmpStoryMediaQueryService, [{
    key: "onMediaQueryMatch",
    value: function onMediaQueryMatch(media, callback) {
      var _this = this;

      return this.initialize_().then(function () {
        var mediaQueryList = _this.matcher_.contentWindow.matchMedia(media);

        mediaQueryList.addListener(function (event) {
          return callback(event.matches);
        });
        callback(mediaQueryList.matches);
        return mediaQueryList;
      });
    }
    /**
     * Creates an iframe that is positioned like an amp-story-page, used to match
     * media queries.
     * @return {!Promise} Resolves when the iframe is ready.
     * @private
     */

  }, {
    key: "initialize_",
    value: function initialize_() {
      var _this2 = this;

      if (this.initializePromise_) {
        return this.initializePromise_;
      }

      this.initializePromise_ = new Promise(function (resolve) {
        _this2.matcher_ = _this2.win_.document.createElement('iframe');

        _this2.matcher_.classList.add('i-amphtml-story-media-query-matcher');

        _this2.matcher_.onload = resolve;

        _this2.storyEl_.appendChild(_this2.matcher_);
      });
      return this.initializePromise_;
    }
  }]);

  return AmpStoryMediaQueryService;
}();

exports.AmpStoryMediaQueryService = AmpStoryMediaQueryService;

},{"../../../src/log":123,"../../../src/service":130,"../../../src/services":133}],47:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryPageAttachment = void 0;

var _ampStoryStoreService = require("./amp-story-store-service");

var _ampStoryDraggableDrawer = require("./amp-story-draggable-drawer");

var _history = require("./history");

var _services = require("../../../src/services");

var _storyAnalytics = require("./story-analytics");

var _dom = require("../../../src/dom");

var _log = require("../../../src/log");

var _history2 = require("../../../src/history");

var _staticTemplate = require("../../../src/static-template");

var _style = require("../../../src/style");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    <a class=\"i-amphtml-story-page-attachment-remote-content\" target=\"_blank\">\n      <span class=\"i-amphtml-story-page-attachment-remote-title\"></span>\n      <span class=\"i-amphtml-story-page-attachment-remote-icon\"></span>\n    </a>"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n          <span class=\"i-amphtml-story-page-attachment-title\"></span>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n          <span class=\"i-amphtml-story-page-attachment-close-button\" aria-label=\"X\"\n              role=\"button\">\n          </span>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/** @const {string} */
var DARK_THEME_CLASS = 'i-amphtml-story-draggable-drawer-theme-dark';

/**
 * @enum {string}
 */
var AttachmentTheme = {
  LIGHT: 'light',
  // default
  DARK: 'dark'
};

/**
 * @enum
 */
var AttachmentType = {
  INLINE: 0,
  REMOTE: 1
};

/**
 * AMP Story page attachment.
 */
var AmpStoryPageAttachment = /*#__PURE__*/function (_DraggableDrawer) {
  _inherits(AmpStoryPageAttachment, _DraggableDrawer);

  var _super = _createSuper(AmpStoryPageAttachment);

  /** @param {!AmpElement} element */
  function AmpStoryPageAttachment(element) {
    var _this;

    _classCallCheck(this, AmpStoryPageAttachment);

    _this = _super.call(this, element);

    /** @private @const {!./story-analytics.StoryAnalyticsService} */
    _this.analyticsService_ = (0, _storyAnalytics.getAnalyticsService)(_this.win, _this.element);

    /** @private @const {!../../../src/service/history-impl.History} */
    _this.historyService_ = _services.Services.historyForDoc(_this.element);

    /** @private {?AttachmentType} */
    _this.type_ = null;
    return _this;
  }

  /**
   * @override
   */
  _createClass(AmpStoryPageAttachment, [{
    key: "buildCallback",
    value: function buildCallback() {
      var _this2 = this;

      _get(_getPrototypeOf(AmpStoryPageAttachment.prototype), "buildCallback", this).call(this);

      var theme = this.element.getAttribute('theme');

      if (theme && AttachmentTheme.DARK === theme.toLowerCase()) {
        this.headerEl_.classList.add(DARK_THEME_CLASS);
        this.element.classList.add(DARK_THEME_CLASS);
      }

      // URL will be validated and resolved based on the canonical URL if relative
      // when navigating.
      var href = this.element.getAttribute('href');
      this.type_ = href ? AttachmentType.REMOTE : AttachmentType.INLINE;

      if (this.type_ === AttachmentType.INLINE) {
        this.buildInline_();
      }

      if (this.type_ === AttachmentType.REMOTE) {
        this.buildRemote_();
      }

      this.win.addEventListener('pageshow', function (event) {
        // On browser back, Safari does not reload the page but resumes its cached
        // version. This event's parameter lets us know when this happens so we
        // can cleanup the remote opening animation.
        if (event.persisted) {
          _this2.closeInternal_(false
          /** shouldAnimate */
          );
        }
      });
      (0, _style.toggle)(this.element, true);
      this.element.setAttribute('aria-live', 'assertive');
    }
    /**
     * Builds inline page attachment's UI.
     * @private
     */

  }, {
    key: "buildInline_",
    value: function buildInline_() {
      this.headerEl_.appendChild((0, _staticTemplate.htmlFor)(this.element)(_templateObject()));
      this.headerEl_.appendChild((0, _staticTemplate.htmlFor)(this.element)(_templateObject2()));

      if (this.element.hasAttribute('data-title')) {
        this.headerEl_.querySelector('.i-amphtml-story-page-attachment-title').textContent = this.element.getAttribute('data-title');
      }

      var templateEl = this.element.querySelector('.i-amphtml-story-draggable-drawer');

      while (this.element.firstChild && this.element.firstChild !== templateEl) {
        this.contentEl_.appendChild(this.element.firstChild);
      }

      // Ensures the content of the attachment won't be rendered/loaded until we
      // actually need it.
      (0, _style.toggle)((0, _log.dev)().assertElement(this.containerEl_), true);
    }
    /**
     * Builds remote page attachment's UI.
     * @private
     */

  }, {
    key: "buildRemote_",
    value: function buildRemote_() {
      this.setDragCap_(48
      /* pixels */
      );
      this.setOpenThreshold_(150
      /* pixels */
      );
      this.headerEl_.classList.add('i-amphtml-story-draggable-drawer-header-attachment-remote');
      this.element.classList.add('i-amphtml-story-page-attachment-remote');
      // Use an anchor element to make this a real link in vertical rendering.
      var link = (0, _staticTemplate.htmlFor)(this.element)(_templateObject3());
      link.setAttribute('href', this.element.getAttribute('href'));
      this.contentEl_.appendChild(link);
      this.contentEl_.querySelector('.i-amphtml-story-page-attachment-remote-title').textContent = this.element.getAttribute('data-title') || _services.Services.urlForDoc(this.element).getSourceOrigin(this.element.getAttribute('href'));
    }
    /**
     * @override
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this3 = this;

      _get(_getPrototypeOf(AmpStoryPageAttachment.prototype), "initializeListeners_", this).call(this);

      var closeButtonEl = this.headerEl_.querySelector('.i-amphtml-story-page-attachment-close-button');

      if (closeButtonEl) {
        closeButtonEl.addEventListener('click', function () {
          return _this3.close_();
        }, true
        /** useCapture */
        );
      }

      // Always open links in a new tab.
      this.contentEl_.addEventListener('click', function (event) {
        var target = event.target;

        if (target.tagName.toLowerCase() === 'a') {
          target.setAttribute('target', '_blank');
        }
      }, true
      /** useCapture */
      );
      // Closes the attachment on opacity background clicks.
      this.element.addEventListener('click', function (event) {
        if (event.target.tagName.toLowerCase() === 'amp-story-page-attachment') {
          _this3.close_();
        }
      }, true
      /** useCapture */
      );

      // Closes the remote attachment drawer when navigation deeplinked to an app.
      if (this.type_ === AttachmentType.REMOTE) {
        var ampdoc = this.getAmpDoc();
        ampdoc.onVisibilityChanged(function () {
          if (ampdoc.isVisible() && _this3.state_ === _ampStoryDraggableDrawer.DrawerState.OPEN) {
            _this3.closeInternal_(false
            /** shouldAnimate */
            );
          }
        });
      }
    }
    /**
     * @override
     */

  }, {
    key: "open",
    value: function open(shouldAnimate) {
      var _this4 = this;

      if (shouldAnimate === void 0) {
        shouldAnimate = true;
      }

      if (this.state_ === _ampStoryDraggableDrawer.DrawerState.OPEN) {
        return;
      }

      _get(_getPrototypeOf(AmpStoryPageAttachment.prototype), "open", this).call(this, shouldAnimate);

      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAGE_ATTACHMENT_STATE, true);
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SYSTEM_UI_IS_VISIBLE, false);

      // Don't create a new history entry for remote attachment as user is
      // navigating away.
      if (this.type_ !== AttachmentType.REMOTE) {
        var _extends2;

        var currentHistoryState =
        /** @type {!Object} */
        (0, _history2.getState)(this.win.history);

        var historyState = _extends({}, currentHistoryState, (_extends2 = {}, _extends2[_history.HistoryState.ATTACHMENT_PAGE_ID] = this.storeService_.get(_ampStoryStoreService.StateProperty.CURRENT_PAGE_ID), _extends2));

        this.historyService_.push(function () {
          return _this4.closeInternal_();
        }, historyState);
      }

      this.analyticsService_.triggerEvent(_storyAnalytics.StoryAnalyticsEvent.OPEN, this.element);
      this.analyticsService_.triggerEvent(_storyAnalytics.StoryAnalyticsEvent.PAGE_ATTACHMENT_ENTER);

      if (this.type_ === AttachmentType.REMOTE) {
        this.openRemote_();
      }
    }
    /**
     * Triggers a remote attachment opening animation, and redirects to the
     * specified URL.
     * @private
     */

  }, {
    key: "openRemote_",
    value: function openRemote_() {
      var _this5 = this;

      var animationEl = this.win.document.createElement('div');
      animationEl.classList.add('i-amphtml-story-page-attachment-expand');
      var storyEl = (0, _dom.closest)(this.element, function (el) {
        return el.tagName === 'AMP-STORY';
      });
      this.mutateElement(function () {
        storyEl.appendChild(animationEl);
      }).then(function () {
        // Give some time for the 120ms CSS animation to run (cf
        // amp-story-page-attachment.css). The navigation itself will take some
        // time, depending on the target and network conditions.
        _this5.win.setTimeout(function () {
          var navigationService = _services.Services.navigationForDoc(_this5.getAmpDoc());

          navigationService.navigateTo(_this5.win, _this5.element.getAttribute('href'));
        }, 50);
      });
    }
    /**
     * Ensures the history state we added when opening the drawer is popped,
     * and closes the drawer either directly, or through the onPop callback.
     * @override
     */

  }, {
    key: "close_",
    value: function close_() {
      switch (this.state_) {
        // If the drawer was open, pop the history entry that was added, which
        // will close the drawer through the onPop callback.
        case _ampStoryDraggableDrawer.DrawerState.OPEN:
        case _ampStoryDraggableDrawer.DrawerState.DRAGGING_TO_CLOSE:
          this.historyService_.goBack();
          break;
        // If the drawer was not open, no history entry was added, so we can
        // close the drawer directly.

        case _ampStoryDraggableDrawer.DrawerState.DRAGGING_TO_OPEN:
          this.closeInternal_();
          break;
      }
    }
    /**
     * @override
     */

  }, {
    key: "closeInternal_",
    value: function closeInternal_(shouldAnimate) {
      if (shouldAnimate === void 0) {
        shouldAnimate = true;
      }

      if (this.state_ === _ampStoryDraggableDrawer.DrawerState.CLOSED) {
        return;
      }

      _get(_getPrototypeOf(AmpStoryPageAttachment.prototype), "closeInternal_", this).call(this, shouldAnimate);

      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAGE_ATTACHMENT_STATE, false);
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SYSTEM_UI_IS_VISIBLE, true);
      var storyEl = (0, _dom.closest)(this.element, function (el) {
        return el.tagName === 'AMP-STORY';
      });
      var animationEl = storyEl.querySelector('.i-amphtml-story-page-attachment-expand');

      if (animationEl) {
        this.mutateElement(function () {
          (0, _dom.removeElement)((0, _log.dev)().assertElement(animationEl));
        });
      }

      (0, _history.setHistoryState)(this.win, _history.HistoryState.ATTACHMENT_PAGE_ID, null);
      this.analyticsService_.triggerEvent(_storyAnalytics.StoryAnalyticsEvent.CLOSE, this.element);
      this.analyticsService_.triggerEvent(_storyAnalytics.StoryAnalyticsEvent.PAGE_ATTACHMENT_EXIT);
    }
  }]);

  return AmpStoryPageAttachment;
}(_ampStoryDraggableDrawer.DraggableDrawer);

exports.AmpStoryPageAttachment = AmpStoryPageAttachment;

},{"../../../src/dom":106,"../../../src/history":117,"../../../src/log":123,"../../../src/services":133,"../../../src/static-template":135,"../../../src/style":138,"./amp-story-draggable-drawer":40,"./amp-story-store-service":53,"./history":77,"./story-analytics":91}],48:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryPage = exports.NavigationDirection = exports.PageState = exports.Selectors = void 0;

var _resolvedPromise9 = require("./../../../src/resolved-promise");

var _ampStoryAffiliateLink = require("./amp-story-affiliate-link");

var _ampStoryStoreService = require("./amp-story-store-service");

var _pageAdvancement = require("./page-advancement");

var _ampEvents = require("../../../src/amp-events");

var _ampStoryEmbeddedComponent = require("./amp-story-embedded-component");

var _animation = require("./animation");

var _commonSignals = require("../../../src/common-signals");

var _promise = require("../../../src/utils/promise");

var _events = require("./events");

var _layout = require("../../../src/layout");

var _loadingSpinner = require("./loading-spinner");

var _localizedStrings = require("../../../src/localized-strings");

var _mediaPool = require("./media-pool");

var _services = require("../../../src/services");

var _video = require("../../../src/utils/video");

var _dom = require("../../../src/dom");

var _rateLimit = require("../../../src/utils/rate-limit");

var _videoInterface = require("../../../src/video-interface");

var _log = require("../../../src/log");

var _object = require("../../../src/utils/object");

var _service = require("../../../src/service");

var _iframeHelper = require("../../../src/iframe-helper");

var _ampStoryLocalizationService = require("./amp-story-localization-service");

var _logging = require("./logging");

var _mediaPerformanceMetricsService = require("./media-performance-metrics-service");

var _mode = require("../../../src/mode");

var _staticTemplate = require("../../../src/static-template");

var _experiments = require("../../../src/experiments");

var _eventHelper = require("../../../src/event-helper");

var _style = require("../../../src/style");

var _semanticRender = require("./semantic-render");

var _utils = require("./utils");

var _types = require("../../../src/types");

var _audio = require("./audio");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      <div class=\"\n          i-amphtml-story-page-open-attachment i-amphtml-story-system-reset\"\n          role=\"button\">\n        <span class=\"i-amphtml-story-page-open-attachment-icon\">\n          <span class=\"i-amphtml-story-page-open-attachment-bar-left\"></span>\n          <span class=\"i-amphtml-story-page-open-attachment-bar-right\"></span>\n        </span>\n        <span class=\"i-amphtml-story-page-open-attachment-label\"></span>\n      </div>"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      <div class=\"i-amphtml-story-page-error i-amphtml-story-system-reset\">\n        <span class=\"i-amphtml-story-page-error-label\"></span>\n        <span class='i-amphtml-story-page-error-icon'></span>\n      </div>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <button role=\"button\"\n          class=\"i-amphtml-story-page-play-button i-amphtml-story-system-reset\">\n        <span class=\"i-amphtml-story-page-play-label\"></span>\n        <span class='i-amphtml-story-page-play-icon'></span>\n      </button>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/**
 * CSS class for an amp-story-page that indicates the entire page is loaded.
 * @const {string}
 */
var PAGE_LOADED_CLASS_NAME = 'i-amphtml-story-page-loaded';

/**
 * Selectors for media elements.
 * Only get the page media: direct children of amp-story-page (ie:
 * background-audio), or descendant of amp-story-grid-layer. That excludes media
 * contained in amp-story-page-attachment.
 * @enum {string}
 */
var Selectors = {
  // which media to wait for on page layout.
  ALL_AMP_MEDIA: 'amp-story-grid-layer amp-audio, ' + 'amp-story-grid-layer amp-video, amp-story-grid-layer amp-img, ' + 'amp-story-grid-layer amp-anim',
  ALL_AMP_VIDEO: 'amp-story-grid-layer amp-video',
  ALL_IFRAMED_MEDIA: 'audio, video',
  ALL_PLAYBACK_AMP_MEDIA: 'amp-story-grid-layer amp-audio, amp-story-grid-layer amp-video',
  // TODO(gmajoulet): Refactor the way these selectors are used. They will be
  // passed to scopedQuerySelectorAll which expects only one selector and not
  // multiple separated by commas. `> audio` has to be kept first of the list to
  // work with this current implementation.
  ALL_PLAYBACK_MEDIA: '> audio, amp-story-grid-layer audio, amp-story-grid-layer video',
  ALL_STORY_360: 'amp-story-360',
  ALL_VIDEO: 'amp-story-grid-layer video'
};
exports.Selectors = Selectors;

/** @private @const {string} */
var EMBEDDED_COMPONENTS_SELECTORS = Object.keys(_ampStoryEmbeddedComponent.EXPANDABLE_COMPONENTS).join(', ');

/** @private @const {string} */
var INTERACTIVE_EMBEDDED_COMPONENTS_SELECTORS = Object.values((0, _ampStoryEmbeddedComponent.expandableElementsSelectors)()).join(',');

/** @private @const {number} */
var RESIZE_TIMEOUT_MS = 350;

/** @private @const {string} */
var TAG = 'amp-story-page';

/** @private @const {string} */
var ADVERTISEMENT_ATTR_NAME = 'ad';

/** @private @const {number} */
var REWIND_TIMEOUT_MS = 350;

/** @private @const {string} */
var DEFAULT_PREVIEW_AUTO_ADVANCE_DURATION = '2s';

/** @private @const {string} */
var VIDEO_PREVIEW_AUTO_ADVANCE_DURATION = '5s';

/**
 * @param {!Element} element
 * @return {!Element}
 */
var buildPlayMessageElement = function buildPlayMessageElement(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject());
};

/**
 * @param {!Element} element
 * @return {!Element}
 */
var buildErrorMessageElement = function buildErrorMessageElement(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject2());
};

/**
 * @param {!Element} element
 * @return {!Element}
 */
var buildOpenAttachmentElement = function buildOpenAttachmentElement(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject3());
};

/**
 * amp-story-page states.
 * @enum {number}
 */
var PageState = {
  NOT_ACTIVE: 0,
  // Page is not displayed. Could still be visible on desktop.
  PLAYING: 1,
  // Page is currently the main page, and playing.
  PAUSED: 2 // Page is currently the main page, but not playing.

};
exports.PageState = PageState;

/** @const @enum {string}*/
var NavigationDirection = {
  NEXT: 'next',
  PREVIOUS: 'previous'
};
exports.NavigationDirection = NavigationDirection;

/**
 * Prepares an embed for its expanded mode animation. Since this requires
 * calculating the size of the embed, we debounce after each resize event to
 * make sure we have the final size before doing the calculation for the
 * animation.
 * @param {!Window} win
 * @param {!Element} page
 * @param {!../../../src/service/mutator-interface.MutatorInterface} mutator
 * @return {function(!Element, ?UnlistenDef)}
 */
function debounceEmbedResize(win, page, mutator) {
  return (0, _rateLimit.debounce)(win, function (el, unlisten) {
    _ampStoryEmbeddedComponent.AmpStoryEmbeddedComponent.prepareForAnimation(page, (0, _log.dev)().assertElement(el), mutator);

    if (unlisten) {
      unlisten();
    }
  }, RESIZE_TIMEOUT_MS);
}

/**
 * The <amp-story-page> custom element, which represents a single page of
 * an <amp-story>.
 */
var AmpStoryPage = /*#__PURE__*/function (_AMP$BaseElement) {
  _inherits(AmpStoryPage, _AMP$BaseElement);

  var _super = _createSuper(AmpStoryPage);

  /** @param {!AmpElement} element */
  function AmpStoryPage(element) {
    var _this;

    _classCallCheck(this, AmpStoryPage);

    _this = _super.call(this, element);

    /** @private {?AnimationManager} */
    _this.animationManager_ = null;

    /** @private {?AdvancementConfig} */
    _this.advancement_ = null;

    /** @const @private {!function(boolean)} */
    _this.debounceToggleLoadingSpinner_ = (0, _rateLimit.debounce)(_this.win, function (isActive) {
      return _this.toggleLoadingSpinner_(!!isActive);
    }, 100);

    /** @private {boolean}  */
    _this.isFirstPage_ = false;

    /** @private {?LoadingSpinner} */
    _this.loadingSpinner_ = null;

    /** @private {?Element} */
    _this.playMessageEl_ = null;

    /** @private {?Element} */
    _this.errorMessageEl_ = null;

    /** @private {?Element} */
    _this.openAttachmentEl_ = null;

    /** @private @const {!../../../src/service/mutator-interface.MutatorInterface} */
    _this.mutator_ = _services.Services.mutatorForDoc((0, _service.getAmpdoc)(_this.win.document));
    var deferred = new _promise.Deferred();

    /** @private @const {!./media-performance-metrics-service.MediaPerformanceMetricsService} */
    _this.mediaPerformanceMetricsService_ = (0, _mediaPerformanceMetricsService.getMediaPerformanceMetricsService)(_this.win);

    /** @private {!Array<!HTMLMediaElement>} */
    _this.performanceTrackedVideos_ = [];

    /** @private {?Promise} */
    _this.registerAllMediaPromise_ = null;

    /** @private @const {!Promise<!MediaPool>} */
    _this.mediaPoolPromise_ = deferred.promise;

    /** @private @const {!function(!MediaPool)} */
    _this.mediaPoolResolveFn_ = deferred.resolve;

    /** @private @const {!function(*)} */
    _this.mediaPoolRejectFn_ = deferred.reject;

    /** @private {!PageState} */
    _this.state_ = PageState.NOT_ACTIVE;

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    _this.storeService_ = (0, _ampStoryStoreService.getStoreService)(_this.win);

    /** @private {?Element} */
    _this.cssVariablesStyleEl_ = null;

    /** @private {?../../../src/layout-rect.LayoutRectDef} */
    _this.layoutBox_ = null;

    /** @private {!Array<function()>} */
    _this.unlisteners_ = [];

    /** @private @const {!../../../src/service/timer-impl.Timer} */
    _this.timer_ = _services.Services.timerFor(_this.win);

    /**
     * Whether the user agent matches a bot.  This is used to prevent resource
     * optimizations that make the document less useful at crawl time, e.g.
     * removing sources from videos.
     * @private @const {boolean}
     */
    _this.isBotUserAgent_ = _services.Services.platformFor(_this.win).isBot();

    /** @private {?number} Time at which an audio element failed playing. */
    _this.playAudioElementFromTimestamp_ = null;

    /** @private {?Array<!Promise<!../../amp-story-360/0.1/amp-story-360.AmpStory360>>}*/
    _this.story360componentsCache_ = null;
    return _this;
  }

  /**
   * @private
   */
  _createClass(AmpStoryPage, [{
    key: "maybeCreateAnimationManager_",
    value: function maybeCreateAnimationManager_() {
      if (!this.animationManager_) {
        if (!(0, _animation.hasAnimations)(this.element)) {
          return;
        }

        this.animationManager_ = _animation.AnimationManager.create(this.element, this.getAmpDoc(), this.getAmpDoc().getUrl());
      }
    }
    /** @override */

  }, {
    key: "firstAttachedCallback",
    value: function firstAttachedCallback() {
      // Only prerender the first story page.
      this.isFirstPage_ = (0, _dom.matches)(this.element, 'amp-story-page:first-of-type');
    }
    /** @override */

  }, {
    key: "buildCallback",
    value: function buildCallback() {
      var _this2 = this;

      this.delegateVideoAutoplay();
      this.markMediaElementsWithPreload_();
      this.initializeMediaPool_();
      this.maybeCreateAnimationManager_();
      this.maybeSetPreviewDuration_();
      this.advancement_ = _pageAdvancement.AdvancementConfig.forElement(this.win, this.element);
      this.advancement_.addPreviousListener(function () {
        return _this2.previous();
      });
      this.advancement_.addAdvanceListener(function () {
        return _this2.next(
        /* opt_isAutomaticAdvance */
        true);
      });
      this.advancement_.addProgressListener(function (progress) {
        return _this2.emitProgress_(progress);
      });
      this.setDescendantCssTextStyles_();
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.UI_STATE, function (uiState) {
        return _this2.onUIStateUpdate_(uiState);
      }, true
      /* callToInitialize */
      );
      this.setPageDescription_();
      this.element.setAttribute('role', 'region');
      this.initializeImgAltTags_();
    }
    /** @private */

  }, {
    key: "maybeSetPreviewDuration_",
    value: function maybeSetPreviewDuration_() {
      if (this.storeService_.get(_ampStoryStoreService.StateProperty.PREVIEW_STATE)) {
        var videos = this.getAllVideos_();
        var autoAdvanceAttr = videos.length > 0 ? VIDEO_PREVIEW_AUTO_ADVANCE_DURATION : DEFAULT_PREVIEW_AUTO_ADVANCE_DURATION;
        (0, _dom.addAttributesToElement)(this.element, (0, _object.dict)({
          'auto-advance-after': autoAdvanceAttr
        }));
      }
    }
    /**
     * Delegates video autoplay so the video manager does not follow the
     * autoplay attribute that may have been set by a publisher, which could
     * play videos from an inactive page.
     */

  }, {
    key: "delegateVideoAutoplay",
    value: function delegateVideoAutoplay() {
      (0, _dom.iterateCursor)(this.element.querySelectorAll('amp-video'), _videoInterface.delegateAutoplay);
    }
    /** @private */

  }, {
    key: "initializeMediaPool_",
    value: function initializeMediaPool_() {
      var _this3 = this;

      var storyEl = (0, _log.dev)().assertElement((0, _dom.closestAncestorElementBySelector)(this.element, 'amp-story'), 'amp-story-page must be a descendant of amp-story.');
      storyEl.getImpl().then(function (storyImpl) {
        _this3.mediaPoolResolveFn_(_mediaPool.MediaPool.for(storyImpl));
      }, function (reason) {
        return _this3.mediaPoolRejectFn_(reason);
      });
    }
    /**
     * Marks any AMP elements that represent media elements with preload="auto".
     * @private
     */

  }, {
    key: "markMediaElementsWithPreload_",
    value: function markMediaElementsWithPreload_() {
      var mediaSet = this.element.querySelectorAll('amp-audio, amp-video');
      Array.prototype.forEach.call(mediaSet, function (mediaItem) {
        mediaItem.setAttribute('preload', 'auto');
      });
    }
    /** @override */

  }, {
    key: "isLayoutSupported",
    value: function isLayoutSupported(layout) {
      return layout == _layout.Layout.CONTAINER;
    }
    /**
     * Updates the state of the page.
     * @param {!PageState} state
     */

  }, {
    key: "setState",
    value: function setState(state) {
      switch (state) {
        case PageState.NOT_ACTIVE:
          this.element.removeAttribute('active');
          this.pause_();
          this.state_ = state;
          break;

        case PageState.PLAYING:
          if (this.state_ === PageState.NOT_ACTIVE) {
            this.element.setAttribute('active', '');
            this.resume_();
          }

          if (this.state_ === PageState.PAUSED) {
            this.advancement_.start();
            this.playAllMedia_();

            if (this.animationManager_) {
              this.animationManager_.resumeAll();
            }
          }

          this.state_ = state;
          break;

        case PageState.PAUSED:
          // canResume keeps the time advancement timer if set to true, and resets
          // it when set to false. If the bookend if open, reset the timer. If
          // user is long pressing, don't reset it.
          var canResume = !this.storeService_.get(_ampStoryStoreService.StateProperty.BOOKEND_STATE);
          this.advancement_.stop(canResume);
          this.pauseAllMedia_(false
          /** rewindToBeginning */
          );

          if (this.animationManager_) {
            this.animationManager_.pauseAll();
          }

          this.state_ = state;
          break;

        default:
          (0, _log.dev)().warn(TAG, "PageState " + state + " does not exist");
          break;
      }
    }
    /**
     * @private
     */

  }, {
    key: "pause_",
    value: function pause_() {
      var _this4 = this;

      this.advancement_.stop();
      this.stopMeasuringAllVideoPerformance_();
      this.stopListeningToVideoEvents_();
      this.toggleErrorMessage_(false);
      this.togglePlayMessage_(false);
      this.playAudioElementFromTimestamp_ = null;

      if (this.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) === _ampStoryStoreService.UIType.DESKTOP_PANELS) {
        // The rewinding is delayed on desktop so that it happens at a lower
        // opacity instead of immediately jumping to the first frame. See #17985.
        this.pauseAllMedia_(false
        /** rewindToBeginning */
        );
        this.timer_.delay(function () {
          _this4.rewindAllMedia_();
        }, REWIND_TIMEOUT_MS);
      } else {
        this.pauseAllMedia_(true
        /** rewindToBeginning */
        );
      }

      if (!this.storeService_.get(_ampStoryStoreService.StateProperty.MUTED_STATE)) {
        this.muteAllMedia();
      }

      if (this.animationManager_) {
        this.animationManager_.cancelAll();
      }

      this.story360components_.forEach(function (componentPromise) {
        componentPromise.then(function (component) {
          component.pause();
          component.rewind();
        });
      });
    }
    /**
     * @private
     */

  }, {
    key: "resume_",
    value: function resume_() {
      var _this5 = this;

      var registerAllPromise = this.registerAllMedia_();

      if (this.isActive()) {
        registerAllPromise.then(function () {
          _this5.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END).then(function () {
            if (_this5.state_ == PageState.PLAYING) {
              _this5.advancement_.start();
            }
          });

          _this5.preloadAllMedia_().then(function () {
            _this5.startMeasuringAllVideoPerformance_();

            _this5.startListeningToVideoEvents_();

            _this5.playAllMedia_();

            if (!_this5.storeService_.get(_ampStoryStoreService.StateProperty.MUTED_STATE)) {
              _this5.unmuteAllMedia();
            }
          });
        });
        this.prefersReducedMotion_() ? this.maybeFinishAnimations_() : this.maybeStartAnimations_();
        this.checkPageHasAudio_();
        this.checkPageHasElementWithPlayback_();
        this.renderOpenAttachmentUI_();
        this.findAndPrepareEmbeddedComponents_();
        this.story360components_.forEach(function (componentPromise) {
          componentPromise.then(function (component) {
            if (component.canAnimate) {
              component.play();
            }
          });
        });
      }

      this.reportDevModeErrors_();
    }
    /** @override */

  }, {
    key: "layoutCallback",
    value: function layoutCallback() {
      var _this6 = this;

      // Do not loop if the audio is used to auto-advance.
      var loop = this.element.getAttribute('id') !== this.element.getAttribute('auto-advance-after');
      var audioEl = (0, _audio.upgradeBackgroundAudio)(this.element, loop);

      if (audioEl) {
        this.mediaPoolPromise_.then(function (mediaPool) {
          return _this6.registerMedia_(mediaPool, (0, _log.dev)().assertElement(audioEl)).then(function () {
            return mediaPool.preload((0, _log.dev)().assertElement(audioEl));
          });
        });
      }

      this.muteAllMedia();
      this.getViewport().onResize((0, _rateLimit.debounce)(this.win, function () {
        return _this6.onResize_();
      }, RESIZE_TIMEOUT_MS));
      return Promise.all([this.beforeVisible(), this.waitForMediaLayout_(), this.mediaPoolPromise_]);
    } // TODO(26866): switch back to onMeasuredChange and remove the layoutBox
    // equality checks.

    /** @override */

  }, {
    key: "onLayoutMeasure",
    value: function onLayoutMeasure() {
      var _this7 = this;

      var layoutBox = this.getLayoutBox();

      // Only measures from the first story page, that always gets built because
      // of the prerendering optimizations in place.
      if (!this.isFirstPage_ || this.layoutBox_ && this.layoutBox_.width === layoutBox.width && this.layoutBox_.height === layoutBox.height) {
        return;
      }

      this.layoutBox_ = layoutBox;
      return this.getVsync().runPromise({
        measure: function measure(state) {
          var uiState = _this7.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE);

          // The desktop panels UI uses CSS scale. Retrieving clientHeight/Width
          // ensures we are getting the raw size, ignoring the scale.
          var _ref = uiState === _ampStoryStoreService.UIType.DESKTOP_PANELS ? {
            height: _this7.element.
            /*OK*/
            clientHeight,
            width: _this7.element.
            /*OK*/
            clientWidth
          } : layoutBox,
              width = _ref.width,
              height = _ref.height;

          state.height = height;
          state.width = width;
          state.vh = height / 100;
          state.vw = width / 100;
          state.fiftyVw = Math.round(width / 2);
          state.vmin = Math.min(state.vh, state.vw);
          state.vmax = Math.max(state.vh, state.vw);
        },
        mutate: function mutate(state) {
          var height = state.height,
              width = state.width;

          if (state.vh === 0 && state.vw === 0) {
            return;
          }

          _this7.storeService_.dispatch(_ampStoryStoreService.Action.SET_PAGE_SIZE, {
            height: height,
            width: width
          });

          if (!_this7.cssVariablesStyleEl_) {
            var doc = _this7.win.document;
            _this7.cssVariablesStyleEl_ = doc.createElement('style');

            _this7.cssVariablesStyleEl_.setAttribute('type', 'text/css');

            doc.head.appendChild(_this7.cssVariablesStyleEl_);
          }

          _this7.cssVariablesStyleEl_.textContent = ":root {" + ("--story-page-vh: " + (0, _style.px)(state.vh) + ";") + ("--story-page-vw: " + (0, _style.px)(state.vw) + ";") + ("--story-page-vmin: " + (0, _style.px)(state.vmin) + ";") + ("--story-page-vmax: " + (0, _style.px)(state.vmax) + ";") + ("--i-amphtml-story-page-50vw: " + (0, _style.px)(state.fiftyVw) + ";") + "}";
        }
      }, {});
    }
    /**
     * @private
     */

  }, {
    key: "onResize_",
    value: function onResize_() {
      this.findAndPrepareEmbeddedComponents_(true
      /* forceResize */
      );
    }
    /**
     * Reacts to UI state updates.
     * @param {!UIType} uiState
     * @private
     */

  }, {
    key: "onUIStateUpdate_",
    value: function onUIStateUpdate_(uiState) {
      // On vertical rendering, render all the animations with their final state.
      if (uiState === _ampStoryStoreService.UIType.VERTICAL) {
        this.maybeFinishAnimations_();
      }
    }
    /** @return {!Promise} */

  }, {
    key: "beforeVisible",
    value: function beforeVisible() {
      return this.maybeApplyFirstAnimationFrame();
    }
    /**
     * @return {!Promise}
     * @private
     */

  }, {
    key: "waitForMediaLayout_",
    value: function waitForMediaLayout_() {
      var _this8 = this;

      var mediaSet = (0, _types.toArray)(this.getMediaBySelector_(Selectors.ALL_AMP_MEDIA));
      var mediaPromises = mediaSet.map(function (mediaEl) {
        return new Promise(function (resolve) {
          switch (mediaEl.tagName.toLowerCase()) {
            case 'amp-anim':
            case 'amp-img':
            case 'amp-story-360':
              (0, _dom.whenUpgradedToCustomElement)(mediaEl).then(function (el) {
                return el.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END);
              }).then(resolve, resolve);
              break;

            case 'amp-audio':
            case 'amp-video':
              if (mediaEl.readyState >= 2) {
                resolve();
                return;
              }

              mediaEl.addEventListener('canplay', resolve, true
              /* useCapture */
              );
              break;

            default:
              // Any other tags should not block loading.
              resolve();
          }

          // We suppress errors so that Promise.all will still wait for all
          // promises to complete, even if one has failed.  We do nothing with the
          // error, as the resource itself and/or code that loads it should handle
          // the error.
          mediaEl.addEventListener('error', resolve, true
          /* useCapture */
          );
        });
      });
      return Promise.all(mediaPromises).then(function () {
        return _this8.markPageAsLoaded_();
      });
    }
    /**
     * @return {!Promise}
     * @private
     */

  }, {
    key: "waitForPlaybackMediaLayout_",
    value: function waitForPlaybackMediaLayout_() {
      var mediaSet = (0, _types.toArray)(this.getMediaBySelector_(Selectors.ALL_PLAYBACK_AMP_MEDIA));
      var mediaPromises = mediaSet.map(function (mediaEl) {
        return new Promise(function (resolve) {
          switch (mediaEl.tagName.toLowerCase()) {
            case 'amp-audio':
            case 'amp-video':
              var signal = mediaEl.getAttribute('layout') === _layout.Layout.NODISPLAY ? _commonSignals.CommonSignals.BUILT : _commonSignals.CommonSignals.LOAD_END;
              (0, _dom.whenUpgradedToCustomElement)(mediaEl).then(function (el) {
                return el.signals().whenSignal(signal);
              }).then(resolve, resolve);
              break;

            case 'audio': // Already laid out as built from background-audio attr.

            default:
              // Any other tags should not block loading.
              resolve();
          }
        });
      });
      return Promise.all(mediaPromises);
    }
    /**
     * Finds embedded components in page and prepares them.
     * @param {boolean=} forceResize
     * @private
     */

  }, {
    key: "findAndPrepareEmbeddedComponents_",
    value: function findAndPrepareEmbeddedComponents_(forceResize) {
      if (forceResize === void 0) {
        forceResize = false;
      }

      this.addClickShieldToEmbeddedComponents_();
      this.resizeInteractiveEmbeddedComponents_(forceResize);
      this.buildAffiliateLinks_();
    }
    /**
     * Adds a pseudo element on top of the embed to block clicks from going into
     * the iframe.
     * @private
     */

  }, {
    key: "addClickShieldToEmbeddedComponents_",
    value: function addClickShieldToEmbeddedComponents_() {
      var componentEls = (0, _types.toArray)((0, _dom.scopedQuerySelectorAll)(this.element, EMBEDDED_COMPONENTS_SELECTORS));

      if (componentEls.length <= 0) {
        return;
      }

      this.mutateElement(function () {
        componentEls.forEach(function (el) {
          el.classList.add('i-amphtml-embedded-component');
        });
      });
    }
    /**
     * Resizes interactive embeds to prepare them for their expanded animation.
     * @param {boolean} forceResize
     * @private
     */

  }, {
    key: "resizeInteractiveEmbeddedComponents_",
    value: function resizeInteractiveEmbeddedComponents_(forceResize) {
      var _this9 = this;

      (0, _types.toArray)((0, _dom.scopedQuerySelectorAll)(this.element, INTERACTIVE_EMBEDDED_COMPONENTS_SELECTORS)).forEach(function (el) {
        var debouncePrepareForAnimation = debounceEmbedResize(_this9.win, _this9.element, _this9.mutator_);

        if (forceResize) {
          debouncePrepareForAnimation(el, null
          /* unlisten */
          );
        } else if (!el.hasAttribute(_ampStoryEmbeddedComponent.EMBED_ID_ATTRIBUTE_NAME)) {
          // Element has not been prepared for its animation yet.
          var unlisten = (0, _eventHelper.listen)(el, _ampEvents.AmpEvents.SIZE_CHANGED, function () {
            debouncePrepareForAnimation(el, unlisten);
          });
          // Run in case target never changes size.
          debouncePrepareForAnimation(el, null
          /* unlisten */
          );
        }
      });
    }
    /**
     * Initializes affiliate links.
     */

  }, {
    key: "buildAffiliateLinks_",
    value: function buildAffiliateLinks_() {
      var _this10 = this;

      (0, _types.toArray)((0, _dom.scopedQuerySelectorAll)(this.element, _ampStoryAffiliateLink.AFFILIATE_LINK_SELECTOR)).forEach(function (el) {
        var link = new _ampStoryAffiliateLink.AmpStoryAffiliateLink(_this10.win, el);
        link.build();
      });
    }
    /** @private */

  }, {
    key: "markPageAsLoaded_",
    value: function markPageAsLoaded_() {
      var _this11 = this;

      (0, _events.dispatch)(this.win, this.element, _events.EventType.PAGE_LOADED,
      /* payload */
      undefined, {
        bubbles: true
      });
      this.mutateElement(function () {
        _this11.element.classList.add(PAGE_LOADED_CLASS_NAME);
      });
    }
    /** @override */

  }, {
    key: "prerenderAllowed",
    value: function prerenderAllowed() {
      return this.isFirstPage_;
    }
    /**
     * Gets all media elements on this page.
     * @return {!Array<?Element>}
     * @private
     */

  }, {
    key: "getAllMedia_",
    value: function getAllMedia_() {
      return this.getMediaBySelector_(Selectors.ALL_PLAYBACK_MEDIA);
    }
    /**
     * Gets all video elements on this page.
     * @return {!Array<?Element>}
     * @private
     */

  }, {
    key: "getAllVideos_",
    value: function getAllVideos_() {
      return this.getMediaBySelector_(Selectors.ALL_VIDEO);
    }
    /**
     * Gets media on page by given selector. Finds elements through friendly
     * iframe (if one exists).
     * @param {string} selector
     * @return {!Array<?Element>}
     * @private
     */

  }, {
    key: "getMediaBySelector_",
    value: function getMediaBySelector_(selector) {
      var iframe = this.element.querySelector('iframe');
      var fie = iframe && (0, _iframeHelper.getFriendlyIframeEmbedOptional)(
      /** @type {!HTMLIFrameElement} */
      iframe);
      var mediaSet = [];
      (0, _dom.iterateCursor)((0, _dom.scopedQuerySelectorAll)(this.element, selector), function (el) {
        return mediaSet.push(el);
      });

      if (fie) {
        (0, _dom.iterateCursor)((0, _dom.scopedQuerySelectorAll)(fie.win.document.body, Selectors.ALL_IFRAMED_MEDIA), function (el) {
          return mediaSet.push(el);
        });
      }

      return mediaSet;
    }
    /**
     * @return {!Promise<boolean>}
     * @private
     */

  }, {
    key: "isAutoplaySupported_",
    value: function isAutoplaySupported_() {
      _video.VideoUtils.resetIsAutoplaySupported();

      return _video.VideoUtils.isAutoplaySupported(this.win, (0, _mode.getMode)(this.win).lite);
    }
    /**
     * Applies the specified callback to each media element on the page, after the
     * media element is loaded.
     * @param {!function(!./media-pool.MediaPool, !Element)} callbackFn The
     *     callback to be applied to each media element.
     * @return {!Promise} Promise that resolves after the callbacks are called.
     * @private
     */

  }, {
    key: "whenAllMediaElements_",
    value: function whenAllMediaElements_(callbackFn) {
      var mediaSet = (0, _types.toArray)(this.getAllMedia_());
      return this.mediaPoolPromise_.then(function (mediaPool) {
        var promises = mediaSet.map(function (mediaEl) {
          return callbackFn(mediaPool, (0, _log.dev)().assertElement(mediaEl));
        });
        return Promise.all(promises);
      });
    }
    /**
     * Pauses all media on this page.
     * @param {boolean=} rewindToBeginning Whether to rewind the currentTime
     *     of media items to the beginning.
     * @return {!Promise} Promise that resolves after the callbacks are called.
     * @private
     */

  }, {
    key: "pauseAllMedia_",
    value: function pauseAllMedia_(rewindToBeginning) {
      var _this12 = this;

      if (rewindToBeginning === void 0) {
        rewindToBeginning = false;
      }

      return this.whenAllMediaElements_(function (mediaPool, mediaEl) {
        return _this12.pauseMedia_(mediaPool, mediaEl,
        /** @type {boolean} */
        rewindToBeginning);
      });
    }
    /**
     * Pauses the given media.
     * @param {!./media-pool.MediaPool} mediaPool
     * @param {!Element} mediaEl
     * @param {boolean} rewindToBeginning Whether to rewind the currentTime
     *     of media items to the beginning.
     * @return {!Promise} Promise that resolves after the media is paused.
     * @private
     */

  }, {
    key: "pauseMedia_",
    value: function pauseMedia_(mediaPool, mediaEl, rewindToBeginning) {
      if (this.isBotUserAgent_) {
        mediaEl.pause();
        return (0, _resolvedPromise9.resolvedPromise)();
      } else {
        return mediaPool.pause(
        /** @type {!./media-pool.DomElementDef} */
        mediaEl, rewindToBeginning);
      }
    }
    /**
     * Plays all media on this page.
     * @return {!Promise} Promise that resolves after the callbacks are called.
     * @private
     */

  }, {
    key: "playAllMedia_",
    value: function playAllMedia_() {
      var _this13 = this;

      return this.whenAllMediaElements_(function (mediaPool, mediaEl) {
        return _this13.playMedia_(mediaPool, mediaEl);
      });
    }
    /**
     * Plays the given media.
     * @param {!./media-pool.MediaPool} mediaPool
     * @param {!Element} mediaEl
     * @return {!Promise} Promise that resolves after the media is played.
     * @private
     */

  }, {
    key: "playMedia_",
    value: function playMedia_(mediaPool, mediaEl) {
      var _this14 = this;

      if (this.isBotUserAgent_) {
        mediaEl.play();
        return (0, _resolvedPromise9.resolvedPromise)();
      } else {
        return this.loadPromise(mediaEl).then(function () {
          return mediaPool.play(
          /** @type {!./media-pool.DomElementDef} */
          mediaEl).catch(function (unusedError) {
            // Auto playing the media failed, which could be caused by a data
            // saver, or a battery saving mode. Display a message so we can
            // get a user gesture to bless the media elements, and play them.
            if (mediaEl.tagName === 'VIDEO') {
              _this14.debounceToggleLoadingSpinner_(false);

              // If autoplay got rejected, display a "play" button. If
              // autoplay was supported, dispay an error message.
              _this14.isAutoplaySupported_().then(function (isAutoplaySupported) {
                if (isAutoplaySupported) {
                  _this14.toggleErrorMessage_(true);

                  return;
                }

                // Error was expected, don't send the performance metrics.
                _this14.stopMeasuringAllVideoPerformance_(false
                /** sendMetrics */
                );

                _this14.togglePlayMessage_(true);
              });
            }

            if (mediaEl.tagName === 'AUDIO') {
              _this14.playAudioElementFromTimestamp_ = Date.now();
            }
          });
        }, function () {
          _this14.debounceToggleLoadingSpinner_(false);

          _this14.toggleErrorMessage_(true);
        });
      }
    }
    /**
     * Preloads all media on this page.
     * @return {!Promise} Promise that resolves after the callbacks are called.
     * @private
     */

  }, {
    key: "preloadAllMedia_",
    value: function preloadAllMedia_() {
      var _this15 = this;

      return this.whenAllMediaElements_(function (mediaPool, mediaEl) {
        _this15.preloadMedia_(mediaPool, mediaEl);
      });
    }
    /**
     * Preloads the given media.
     * @param {!./media-pool.MediaPool} mediaPool
     * @param {!Element} mediaEl
     * @return {!Promise<!Element|undefined>} Promise that resolves with the preloading element.
     * @private
     */

  }, {
    key: "preloadMedia_",
    value: function preloadMedia_(mediaPool, mediaEl) {
      if (this.isBotUserAgent_) {
        // No-op.
        return (0, _resolvedPromise9.resolvedPromise)();
      } else {
        return mediaPool.preload(
        /** @type {!./media-pool.DomElementDef} */
        mediaEl);
      }
    }
    /**
     * Mutes all media on this page.
     * @return {!Promise} Promise that resolves after the callbacks are called.
     */

  }, {
    key: "muteAllMedia",
    value: function muteAllMedia() {
      var _this16 = this;

      return this.whenAllMediaElements_(function (mediaPool, mediaEl) {
        _this16.muteMedia_(mediaPool, mediaEl);
      });
    }
    /**
     * Mutes the given media.
     * @param {!./media-pool.MediaPool} mediaPool
     * @param {!Element} mediaEl
     * @return {!Promise} Promise that resolves after the media is muted.
     * @private
     */

  }, {
    key: "muteMedia_",
    value: function muteMedia_(mediaPool, mediaEl) {
      if (this.isBotUserAgent_) {
        mediaEl.muted = true;
        mediaEl.setAttribute('muted', '');
        return (0, _resolvedPromise9.resolvedPromise)();
      } else {
        return mediaPool.mute(
        /** @type {!./media-pool.DomElementDef} */
        mediaEl);
      }
    }
    /**
     * Unmutes all media on this page.
     * @return {!Promise} Promise that resolves after the callbacks are called.
     */

  }, {
    key: "unmuteAllMedia",
    value: function unmuteAllMedia() {
      var _this17 = this;

      return this.whenAllMediaElements_(function (mediaPool, mediaEl) {
        _this17.unmuteMedia_(mediaPool, mediaEl);
      });
    }
    /**
     * Unmutes the given media.
     * @param {!./media-pool.MediaPool} mediaPool
     * @param {!Element} mediaEl
     * @return {!Promise} Promise that resolves after the media is unmuted.
     * @private
     */

  }, {
    key: "unmuteMedia_",
    value: function unmuteMedia_(mediaPool, mediaEl) {
      if (this.isBotUserAgent_) {
        mediaEl.muted = false;
        mediaEl.removeAttribute('muted');

        if (mediaEl.tagName === 'AUDIO' && mediaEl.paused) {
          mediaEl.play();
        }

        return (0, _resolvedPromise9.resolvedPromise)();
      } else {
        mediaEl =
        /** @type {!./media-pool.DomElementDef} */
        mediaEl;
        var promises = [mediaPool.unmute(mediaEl)];

        // Audio element might not be playing if the page navigation did not
        // happen after a user intent, and the media element was not "blessed".
        // On unmute, make sure this audio element is playing, at the expected
        // currentTime.
        if (mediaEl.tagName === 'AUDIO' && mediaEl.paused) {
          var currentTime = (Date.now() - this.playAudioElementFromTimestamp_) / 1000;

          if (mediaEl.hasAttribute('loop') || currentTime < mediaEl.duration) {
            promises.push(mediaPool.setCurrentTime(mediaEl, currentTime % mediaEl.duration));
            promises.push(mediaPool.play(mediaEl));
          }

          this.playAudioElementFromTimestamp_ = null;
        }

        return Promise.all(promises);
      }
    }
    /**
     * Registers all media on this page.
     * @return {!Promise} Promise that resolves after the callbacks are called.
     * @private
     */

  }, {
    key: "registerAllMedia_",
    value: function registerAllMedia_() {
      var _this18 = this;

      if (!this.registerAllMediaPromise_) {
        this.registerAllMediaPromise_ = this.waitForPlaybackMediaLayout_().then(function () {
          return _this18.whenAllMediaElements_(function (p, e) {
            return _this18.registerMedia_(p, e);
          });
        });
      }

      return this.registerAllMediaPromise_;
    }
    /**
     * Registers the given media.
     * @param {!./media-pool.MediaPool} mediaPool
     * @param {!Element} mediaEl
     * @return {!Promise} Promise that resolves after the media is registered.
     * @private
     */

  }, {
    key: "registerMedia_",
    value: function registerMedia_(mediaPool, mediaEl) {
      if (this.isBotUserAgent_) {
        // No-op.
        return (0, _resolvedPromise9.resolvedPromise)();
      } else {
        return mediaPool.register(
        /** @type {!./media-pool.DomElementDef} */
        mediaEl);
      }
    }
    /**
     * Rewinds all media on this page.
     * @return {!Promise} Promise that resolves after the callbacks are called.
     * @private
     */

  }, {
    key: "rewindAllMedia_",
    value: function rewindAllMedia_() {
      var _this19 = this;

      return this.whenAllMediaElements_(function (mediaPool, mediaEl) {
        if (_this19.isBotUserAgent_) {
          mediaEl.currentTime = 0;
          return (0, _resolvedPromise9.resolvedPromise)();
        } else {
          return mediaPool.rewindToBeginning(
          /** @type {!./media-pool.DomElementDef} */
          mediaEl);
        }
      });
    }
    /**
     * Starts playing animations, if the animation manager is available.
     * @private
     */

  }, {
    key: "maybeStartAnimations_",
    value: function maybeStartAnimations_() {
      if (!this.animationManager_) {
        return;
      }

      this.animationManager_.animateIn();
    }
    /**
     * Finishes playing animations instantly, if the animation manager is
     * available.
     * @private
     */

  }, {
    key: "maybeFinishAnimations_",
    value: function maybeFinishAnimations_() {
      var _this20 = this;

      if (!this.animationManager_) {
        return;
      }

      this.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END).then(function () {
        return _this20.maybeApplyFirstAnimationFrame();
      }).then(function () {
        _this20.animationManager_.finishAll();
      });
    }
    /**
     * Whether the device opted in prefers-reduced-motion.
     * @return {boolean}
     * @private
     */

  }, {
    key: "prefersReducedMotion_",
    value: function prefersReducedMotion_() {
      return this.win.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    /**
     * @return {!Promise}
     */

  }, {
    key: "maybeApplyFirstAnimationFrame",
    value: function maybeApplyFirstAnimationFrame() {
      if (!this.animationManager_) {
        return (0, _resolvedPromise9.resolvedPromise)();
      }

      return this.animationManager_.applyFirstFrame();
    }
    /**
     * @return {number} The distance from the current page to the active page.
     */

  }, {
    key: "getDistance",
    value: function getDistance() {
      return parseInt(this.element.getAttribute('distance'), 10);
    }
    /**
     * @param {number} distance The distance from the current page to the active
     *     page.
     */

  }, {
    key: "setDistance",
    value: function setDistance(distance) {
      var _this21 = this;

      // TODO(ccordry) refactor this when pages are managed
      if (this.isAd()) {
        distance = Math.min(distance, 2);
      }

      this.element.setAttribute('distance', distance);
      this.element.setAttribute('aria-hidden', distance != 0);
      var registerAllPromise = this.registerAllMedia_();

      if (distance > 0 && distance <= 2) {
        this.findAndPrepareEmbeddedComponents_();
        registerAllPromise.then(function () {
          return _this21.preloadAllMedia_();
        });
      }
    }
    /**
     * @return {boolean} Whether this page is currently active.
     */

  }, {
    key: "isActive",
    value: function isActive() {
      return this.element.hasAttribute('active');
    }
    /**
     * Emits an event indicating that the progress of the current page has changed
     * to the specified value.
     * @param {number} progress The progress from 0.0 to 1.0.
     */

  }, {
    key: "emitProgress_",
    value: function emitProgress_(progress) {
      // Don't emit progress for ads, since the progress bar is hidden.
      // Don't emit progress for inactive pages, because race conditions.
      if (this.isAd() || this.state_ === PageState.NOT_ACTIVE) {
        return;
      }

      var payload = (0, _object.dict)({
        'pageId': this.element.id,
        'progress': progress
      });
      var eventInit = {
        bubbles: true
      };
      (0, _events.dispatch)(this.win, this.element, _events.EventType.PAGE_PROGRESS, payload, eventInit);
    }
    /**
     * Returns all of the pages that are one hop from this page.
     * @return {!Array<string>}
     */

  }, {
    key: "getAdjacentPageIds",
    value: function getAdjacentPageIds() {
      var adjacentPageIds = (0, _experiments.isExperimentOn)(this.win, 'amp-story-branching') ? this.actions_() : [];
      var autoAdvanceNext = this.getNextPageId(true
      /* opt_isAutomaticAdvance */
      );
      var manualAdvanceNext = this.getNextPageId(false
      /* opt_isAutomaticAdvance */
      );
      var previous = this.getPreviousPageId();

      if (autoAdvanceNext) {
        adjacentPageIds.push(autoAdvanceNext);
      }

      if (manualAdvanceNext && manualAdvanceNext != autoAdvanceNext) {
        adjacentPageIds.push(manualAdvanceNext);
      }

      if (previous) {
        adjacentPageIds.push(previous);
      }

      return adjacentPageIds;
    }
    /**
     * Gets the ID of the previous page in the story (before the current page).
     * @return {?string} Returns the ID of the next page in the story, or null if
     *     there isn't one.
     */

  }, {
    key: "getPreviousPageId",
    value: function getPreviousPageId() {
      if (this.element.hasAttribute('i-amphtml-return-to')) {
        return this.element.getAttribute('i-amphtml-return-to');
      }

      var navigationPath = this.storeService_.get(_ampStoryStoreService.StateProperty.NAVIGATION_PATH);
      var pagePathIndex = navigationPath.lastIndexOf(this.element.id);
      var previousPageId = navigationPath[pagePathIndex - 1];

      if (previousPageId) {
        return previousPageId;
      }

      // If the page was loaded with a `#page=foo` hash, it could have no
      // navigation path but still a previous page in the DOM.
      var previousElement = this.element.previousElementSibling;

      if (previousElement && previousElement.tagName.toLowerCase() === TAG) {
        return previousElement.id;
      }

      return null;
    }
    /**
     * Gets the ID of the next page in the story (after the current page).
     * @param {boolean=} isAutomaticAdvance Whether this navigation was caused
     *     by an automatic advancement after a timeout.
     * @return {?string} Returns the ID of the next page in the story, or null if
     *     there isn't one.
     */

  }, {
    key: "getNextPageId",
    value: function getNextPageId(isAutomaticAdvance) {
      if (isAutomaticAdvance === void 0) {
        isAutomaticAdvance = false;
      }

      if (isAutomaticAdvance && this.element.hasAttribute('auto-advance-to')) {
        return this.element.getAttribute('auto-advance-to');
      }

      var advanceAttr = (0, _experiments.isExperimentOn)(this.win, 'amp-story-branching') ? 'advance-to' : 'i-amphtml-advance-to';

      if (this.element.hasAttribute(advanceAttr)) {
        return this.element.getAttribute(advanceAttr);
      }

      var nextElement = this.element.nextElementSibling;

      if (nextElement && nextElement.tagName.toLowerCase() === TAG) {
        return nextElement.id;
      }

      return null;
    }
    /**
     * Finds any elements in the page that has a goToPage action.
     * @return {!Array<string>} The IDs of the potential next pages in the story
     * or null if there aren't any.
     * @private
     */

  }, {
    key: "actions_",
    value: function actions_() {
      var actionElements = Array.prototype.slice.call(this.element.querySelectorAll('[on*=goToPage]'));
      var actionAttrs = actionElements.map(function (action) {
        return action.getAttribute('on');
      });
      return actionAttrs.reduce(function (res, actions) {
        // Handling for multiple actions on one event or multiple events.
        var actionList =
        /** @type {!Array} */
        actions.split(/[;,]+/);
        actionList.forEach(function (action) {
          if (action.indexOf('goToPage') >= 0) {
            // The pageId is in between the equals sign & closing parenthesis.
            res.push(action.slice(action.search('=(.*)') + 1, -1));
          }
        });
        return res;
      }, []);
    }
    /**
     * Navigates to the previous page in the story.
     */

  }, {
    key: "previous",
    value: function previous() {
      var pageId = this.getPreviousPageId();

      if (pageId === null) {
        (0, _events.dispatch)(this.win, this.element, _events.EventType.NO_PREVIOUS_PAGE,
        /* payload */
        undefined, {
          bubbles: true
        });
        return;
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, false);
      this.switchTo_(pageId, NavigationDirection.PREVIOUS);
    }
    /**
     * Navigates to the next page in the story.
     * @param {boolean=} isAutomaticAdvance Whether this navigation was caused
     *     by an automatic advancement after a timeout.
     */

  }, {
    key: "next",
    value: function next(isAutomaticAdvance) {
      if (isAutomaticAdvance === void 0) {
        isAutomaticAdvance = false;
      }

      var pageId = this.getNextPageId(isAutomaticAdvance);

      if (!pageId) {
        (0, _events.dispatch)(this.win, this.element, _events.EventType.NO_NEXT_PAGE,
        /* payload */
        undefined, {
          bubbles: true
        });
        return;
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, false);
      this.switchTo_(pageId, NavigationDirection.NEXT);
    }
    /**
     * @param {string} targetPageId
     * @param {!NavigationDirection} direction
     * @private
     */

  }, {
    key: "switchTo_",
    value: function switchTo_(targetPageId, direction) {
      var payload = (0, _object.dict)({
        'targetPageId': targetPageId,
        'direction': direction
      });
      var eventInit = {
        bubbles: true
      };
      (0, _events.dispatch)(this.win, this.element, _events.EventType.SWITCH_PAGE, payload, eventInit);
    }
    /**
     * Checks if the page has any audio.
     * @private
     */

  }, {
    key: "checkPageHasAudio_",
    value: function checkPageHasAudio_() {
      var pageHasAudio = this.element.hasAttribute('background-audio') || this.element.querySelector('amp-audio') || this.hasVideoWithAudio_();
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAGE_HAS_AUDIO, pageHasAudio);
    }
    /**
     * Checks if the page has any videos with audio.
     * @return {boolean}
     * @private
     */

  }, {
    key: "hasVideoWithAudio_",
    value: function hasVideoWithAudio_() {
      var ampVideoEls = this.element.querySelectorAll('amp-video');
      return Array.prototype.some.call(ampVideoEls, function (video) {
        return !video.hasAttribute('noaudio');
      });
    }
    /**
     * Checks if the page has elements with playback.
     * @private
     */

  }, {
    key: "checkPageHasElementWithPlayback_",
    value: function checkPageHasElementWithPlayback_() {
      var pageHasElementWithPlayback = this.isAutoAdvance() || this.element.hasAttribute('background-audio') || this.getAllMedia_().length > 0;
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAGE_HAS_ELEMENT_WITH_PLAYBACK, pageHasElementWithPlayback);
    }
    /**
     * @private
     */

  }, {
    key: "reportDevModeErrors_",
    value: function reportDevModeErrors_() {
      var _this22 = this;

      if (!(0, _mode.getMode)().development) {
        return;
      }

      (0, _logging.getLogEntries)(this.element).then(function (logEntries) {
        (0, _events.dispatch)(_this22.win, _this22.element, _events.EventType.DEV_LOG_ENTRIES_AVAILABLE, // ? is OK because all consumers are internal.

        /** @type {?} */
        logEntries, {
          bubbles: true
        });
      });
    }
    /**
     * Starts measuring video performance metrics, if performance tracking is on.
     * Has to be called directly before playing the video.
     * @private
     */

  }, {
    key: "startMeasuringAllVideoPerformance_",
    value: function startMeasuringAllVideoPerformance_() {
      if (!this.mediaPerformanceMetricsService_.isPerformanceTrackingOn()) {
        return;
      }

      var videoEls =
      /** @type {!Array<!HTMLMediaElement>} */
      this.getAllVideos_();

      for (var i = 0; i < videoEls.length; i++) {
        this.startMeasuringVideoPerformance_(videoEls[i]);
      }
    }
    /**
     * @param {!HTMLMediaElement} videoEl
     * @private
     */

  }, {
    key: "startMeasuringVideoPerformance_",
    value: function startMeasuringVideoPerformance_(videoEl) {
      if (!this.mediaPerformanceMetricsService_.isPerformanceTrackingOn()) {
        return;
      }

      this.performanceTrackedVideos_.push(videoEl);
      this.mediaPerformanceMetricsService_.startMeasuring(videoEl);
    }
    /**
     * Stops measuring video performance metrics, if performance tracking is on.
     * Computes and sends the metrics.
     * @param {boolean=} sendMetrics
     * @private
     */

  }, {
    key: "stopMeasuringAllVideoPerformance_",
    value: function stopMeasuringAllVideoPerformance_(sendMetrics) {
      if (sendMetrics === void 0) {
        sendMetrics = true;
      }

      if (!this.mediaPerformanceMetricsService_.isPerformanceTrackingOn()) {
        return;
      }

      for (var i = 0; i < this.performanceTrackedVideos_.length; i++) {
        this.mediaPerformanceMetricsService_.stopMeasuring(this.performanceTrackedVideos_[i], sendMetrics);
      }
    }
    /**
     * Displays a loading spinner whenever the video is buffering.
     * Has to be called after the mediaPool preload method, that swaps the video
     * elements with new amp elements.
     * @private
     */

  }, {
    key: "startListeningToVideoEvents_",
    value: function startListeningToVideoEvents_() {
      var _this23 = this;

      var videoEls = this.getAllVideos_();

      if (videoEls.length) {
        var alreadyPlaying = videoEls.some(function (video) {
          return video.currentTime != 0;
        });

        if (!alreadyPlaying) {
          this.debounceToggleLoadingSpinner_(true);
        }
      }

      Array.prototype.forEach.call(videoEls, function (videoEl) {
        _this23.unlisteners_.push((0, _eventHelper.listen)(videoEl, 'playing', function () {
          return _this23.debounceToggleLoadingSpinner_(false);
        }));

        _this23.unlisteners_.push((0, _eventHelper.listen)(videoEl, 'waiting', function () {
          return _this23.debounceToggleLoadingSpinner_(true);
        }));
      });
    }
    /**
     * @private
     */

  }, {
    key: "stopListeningToVideoEvents_",
    value: function stopListeningToVideoEvents_() {
      this.debounceToggleLoadingSpinner_(false);
      this.unlisteners_.forEach(function (unlisten) {
        return unlisten();
      });
      this.unlisteners_ = [];
    }
    /**
     * @private
     */

  }, {
    key: "buildAndAppendLoadingSpinner_",
    value: function buildAndAppendLoadingSpinner_() {
      this.loadingSpinner_ = new _loadingSpinner.LoadingSpinner(this.win.document);
      this.element.appendChild(this.loadingSpinner_.build());
    }
    /**
     * Has to be called through the `debounceToggleLoadingSpinner_` method, to
     * avoid the spinner flashing on the screen when the video loops, or during
     * navigation transitions.
     * Builds the loading spinner and attaches it to the DOM on first call.
     * @param {boolean} isActive
     * @private
     */

  }, {
    key: "toggleLoadingSpinner_",
    value: function toggleLoadingSpinner_(isActive) {
      var _this24 = this;

      this.mutateElement(function () {
        if (!_this24.loadingSpinner_) {
          _this24.buildAndAppendLoadingSpinner_();
        }

        _this24.loadingSpinner_.toggle(isActive);
      });
    }
    /**
     * Builds and appends a message and icon to play the story on tap.
     * This message is built when the playback failed (data saver, low battery
     * modes, ...).
     * @private
     */

  }, {
    key: "buildAndAppendPlayMessage_",
    value: function buildAndAppendPlayMessage_() {
      var _this25 = this;

      this.playMessageEl_ = buildPlayMessageElement(this.element);
      var labelEl = this.playMessageEl_.querySelector('.i-amphtml-story-page-play-label');
      labelEl.textContent = (0, _ampStoryLocalizationService.getLocalizationService)(this.element).getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_PLAY_VIDEO);
      this.playMessageEl_.addEventListener('click', function () {
        _this25.togglePlayMessage_(false);

        _this25.startMeasuringAllVideoPerformance_();

        _this25.mediaPoolPromise_.then(function (mediaPool) {
          return mediaPool.blessAll();
        }).then(function () {
          return _this25.playAllMedia_();
        });
      });
      this.mutateElement(function () {
        return _this25.element.appendChild(_this25.playMessageEl_);
      });
    }
    /**
     * Toggles the visibility of the "Play video" fallback message.
     * @param {boolean} isActive
     * @private
     */

  }, {
    key: "togglePlayMessage_",
    value: function togglePlayMessage_(isActive) {
      var _this26 = this;

      if (!isActive) {
        this.playMessageEl_ && this.mutateElement(function () {
          return (0, _style.toggle)((0, _log.dev)().assertElement(_this26.playMessageEl_), false);
        });
        return;
      }

      if (!this.playMessageEl_) {
        this.buildAndAppendPlayMessage_();
      }

      this.mutateElement(function () {
        return (0, _style.toggle)((0, _log.dev)().assertElement(_this26.playMessageEl_), true);
      });
    }
    /**
     * Builds and appends a message and icon to indicate a video error state.
     * @private
     */

  }, {
    key: "buildAndAppendErrorMessage_",
    value: function buildAndAppendErrorMessage_() {
      var _this27 = this;

      this.errorMessageEl_ = buildErrorMessageElement(this.element);
      var labelEl = this.errorMessageEl_.querySelector('.i-amphtml-story-page-error-label');
      labelEl.textContent = (0, _ampStoryLocalizationService.getLocalizationService)(this.element).getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ERROR_VIDEO);
      this.mutateElement(function () {
        return _this27.element.appendChild(_this27.errorMessageEl_);
      });
    }
    /**
     * Toggles the visibility of the "Play video" fallback message.
     * @param {boolean} isActive
     * @private
     */

  }, {
    key: "toggleErrorMessage_",
    value: function toggleErrorMessage_(isActive) {
      var _this28 = this;

      if (!isActive) {
        this.errorMessageEl_ && this.mutateElement(function () {
          return (0, _style.toggle)((0, _log.dev)().assertElement(_this28.errorMessageEl_), false);
        });
        return;
      }

      if (!this.errorMessageEl_) {
        this.buildAndAppendErrorMessage_();
      }

      this.mutateElement(function () {
        return (0, _style.toggle)((0, _log.dev)().assertElement(_this28.errorMessageEl_), true);
      });
    }
    /**
     * Renders the open attachment UI affordance.
     * @private
     */

  }, {
    key: "renderOpenAttachmentUI_",
    value: function renderOpenAttachmentUI_() {
      var _this29 = this;

      var attachmentEl = this.element.querySelector('amp-story-page-attachment');

      if (!attachmentEl) {
        return;
      }

      if (!this.openAttachmentEl_) {
        this.openAttachmentEl_ = buildOpenAttachmentElement(this.element);
        this.openAttachmentEl_.addEventListener('click', function () {
          return _this29.openAttachment();
        });
        var textEl = this.openAttachmentEl_.querySelector('.i-amphtml-story-page-open-attachment-label');
        var openLabelAttr = attachmentEl.getAttribute('data-cta-text');
        var openLabel = openLabelAttr && openLabelAttr.trim() || (0, _ampStoryLocalizationService.getLocalizationService)(this.element).getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL);
        this.mutateElement(function () {
          textEl.textContent = openLabel;

          _this29.element.appendChild(_this29.openAttachmentEl_);
        });
      }
    }
    /**
     * Opens the attachment, if any.
     * @param {boolean=} shouldAnimate
     */

  }, {
    key: "openAttachment",
    value: function openAttachment(shouldAnimate) {
      if (shouldAnimate === void 0) {
        shouldAnimate = true;
      }

      var attachmentEl = this.element.querySelector('amp-story-page-attachment');

      if (!attachmentEl) {
        return;
      }

      attachmentEl.getImpl().then(function (attachment) {
        return attachment.open(shouldAnimate);
      });
    }
    /**
     * check to see if this page is a wrapper for an ad
     * @return {boolean}
     */

  }, {
    key: "isAd",
    value: function isAd() {
      return this.element.hasAttribute(ADVERTISEMENT_ATTR_NAME);
    }
    /**
     * Sets text styles for descendants of the
     * <amp-story-page> element.
     * @private
     */

  }, {
    key: "setDescendantCssTextStyles_",
    value: function setDescendantCssTextStyles_() {
      (0, _utils.setTextBackgroundColor)(this.element);
    }
    /**
     * Sets the description of the page, from its title and its videos
     * alt/title attributes.
     * @private
     */

  }, {
    key: "setPageDescription_",
    value: function setPageDescription_() {
      if (this.isBotUserAgent_) {
        (0, _semanticRender.renderPageDescription)(this, this.getMediaBySelector_(Selectors.ALL_AMP_VIDEO));
      }

      if (!this.isBotUserAgent_ && this.element.hasAttribute('title')) {
        // Strip the title attribute from the page on non-bot user agents, to
        // prevent the browser tooltip.
        if (!this.element.getAttribute('aria-label')) {
          this.element.setAttribute('aria-label', this.element.getAttribute('title'));
        }

        this.element.removeAttribute('title');
      }
    }
    /**
     * Adds an empty alt tag to amp-img elements if not present.
     * Prevents screen readers from announcing the img src value.
     * @private
     */

  }, {
    key: "initializeImgAltTags_",
    value: function initializeImgAltTags_() {
      (0, _types.toArray)(this.element.querySelectorAll('amp-img')).forEach(function (ampImgNode) {
        if (!ampImgNode.getAttribute('alt')) {
          ampImgNode.setAttribute('alt', ' ');
          // If the child img element is in the dom, propogate the attribute to it.
          var childImgNode = ampImgNode.querySelector('img');
          childImgNode && ampImgNode.getImpl().then(function (ampImg) {
            return ampImg.propagateAttributes('alt', childImgNode);
          });
        }
      });
    }
    /**
     * Returns whether the page will automatically advance
     * @return {boolean}
     */

  }, {
    key: "isAutoAdvance",
    value: function isAutoAdvance() {
      return this.advancement_.isAutoAdvance();
    }
    /**
     * @private
     * @return {!Array<!Promise<!../../amp-story-360/0.1/amp-story-360.AmpStory360>>}
     */

  }, {
    key: "story360components_",
    get: function get() {
      if (!this.story360componentsCache_) {
        this.story360componentsCache_ = (0, _types.toArray)((0, _dom.scopedQuerySelectorAll)(this.element, Selectors.ALL_STORY_360)).map(function (element) {
          return (0, _dom.whenUpgradedToCustomElement)(element).then(function (customEl) {
            return customEl.getImpl();
          });
        });
      }

      return this.story360componentsCache_;
    }
  }]);

  return AmpStoryPage;
}(AMP.BaseElement);

exports.AmpStoryPage = AmpStoryPage;

},{"../../../src/amp-events":97,"../../../src/common-signals":101,"../../../src/dom":106,"../../../src/event-helper":111,"../../../src/experiments":112,"../../../src/iframe-helper":118,"../../../src/layout":121,"../../../src/localized-strings":122,"../../../src/log":123,"../../../src/mode":124,"../../../src/service":130,"../../../src/services":133,"../../../src/static-template":135,"../../../src/style":138,"../../../src/types":139,"../../../src/utils/object":149,"../../../src/utils/promise":150,"../../../src/utils/rate-limit":151,"../../../src/utils/video":152,"../../../src/video-interface":153,"./../../../src/resolved-promise":129,"./amp-story-affiliate-link":36,"./amp-story-embedded-component":41,"./amp-story-localization-service":45,"./amp-story-store-service":53,"./animation":62,"./audio":63,"./events":76,"./loading-spinner":80,"./logging":81,"./media-performance-metrics-service":82,"./media-pool":83,"./page-advancement":85,"./semantic-render":88,"./utils":93}],49:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryRenderService = void 0;

var _commonSignals = require("../../../src/common-signals");

var _dom = require("../../../src/dom");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @implements {../../../src/render-delaying-services.RenderDelayingService} */
var AmpStoryRenderService = /*#__PURE__*/function () {
  /**
   * @param {!../../../src/service/ampdoc-impl.AmpDoc} ampdoc
   */
  function AmpStoryRenderService(ampdoc) {
    _classCallCheck(this, AmpStoryRenderService);

    /**
     * @private {!../../../src/service/ampdoc-impl.AmpDoc}
     */
    this.ampdoc_ = ampdoc;
  }

  /**
   * Function to return a promise for when it is finished delaying render, and
   * is ready.  Implemented from RenderDelayingService
   * @return {!Promise}
   */
  _createClass(AmpStoryRenderService, [{
    key: "whenReady",
    value: function whenReady() {
      return this.ampdoc_.whenReady().then(function (body) {
        var storyEl = body.querySelector('amp-story[standalone]');

        if (!storyEl) {
          return;
        }

        return (0, _dom.whenUpgradedToCustomElement)(storyEl).then(function () {
          return storyEl.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END);
        });
      });
    }
  }]);

  return AmpStoryRenderService;
}();

exports.AmpStoryRenderService = AmpStoryRenderService;

},{"../../../src/common-signals":101,"../../../src/dom":106}],50:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getRequestService = exports.AmpStoryRequestService = exports.BOOKEND_CREDENTIALS_ATTRIBUTE_NAME = exports.BOOKEND_CONFIG_ATTRIBUTE_NAME = void 0;

var _services = require("../../../src/services");

var _dom = require("../../../src/dom");

var _json = require("../../../src/json");

var _url = require("../../../src/url");

var _function = require("../../../src/utils/function");

var _service = require("../../../src/service");

var _log = require("../../../src/log");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @private @const {string} */
var BOOKEND_CONFIG_ATTRIBUTE_NAME = 'src';
exports.BOOKEND_CONFIG_ATTRIBUTE_NAME = BOOKEND_CONFIG_ATTRIBUTE_NAME;

/** @private const {string} */
var BOOKEND_CREDENTIALS_ATTRIBUTE_NAME = 'data-credentials';
exports.BOOKEND_CREDENTIALS_ATTRIBUTE_NAME = BOOKEND_CREDENTIALS_ATTRIBUTE_NAME;

/** @private @const {string} */
var TAG = 'amp-story-request-service';

/**
 * Service to send XHRs.
 */
var AmpStoryRequestService = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} storyElement
   */
  function AmpStoryRequestService(win, storyElement) {
    var _this = this;

    _classCallCheck(this, AmpStoryRequestService);

    /** @private @const {!Element} */
    this.storyElement_ = storyElement;

    /** @private @const {!../../../src/service/xhr-impl.Xhr} */
    this.xhr_ = _services.Services.xhrFor(win);

    /** @const @type {function():(!Promise<!JsonObject>|!Promise<null>)} */
    this.loadBookendConfig = (0, _function.once)(function () {
      return _this.loadBookendConfigImpl_();
    });
  }

  /**
   * Retrieves the publisher bookend configuration, including the share
   * providers.
   * Has to be called through `loadBookendConfig`.
   * @return {(!Promise<!JsonObject>|!Promise<null>)}
   * @private
   */
  _createClass(AmpStoryRequestService, [{
    key: "loadBookendConfigImpl_",
    value: function loadBookendConfigImpl_() {
      var bookendEl = (0, _dom.childElementByTag)(this.storyElement_, 'amp-story-bookend');

      if (!bookendEl) {
        return Promise.resolve(null);
      }

      if (bookendEl.hasAttribute(BOOKEND_CONFIG_ATTRIBUTE_NAME)) {
        var rawUrl = bookendEl.getAttribute(BOOKEND_CONFIG_ATTRIBUTE_NAME);
        var credentials = bookendEl.getAttribute(BOOKEND_CREDENTIALS_ATTRIBUTE_NAME);
        return this.executeRequest(rawUrl, credentials ? {
          credentials: credentials
        } : {});
      }

      // Fallback. Check for an inline json config.
      var config = null;

      try {
        config = (0, _json.getChildJsonConfig)(bookendEl);
      } catch (err) {}

      return Promise.resolve(config);
    }
    /**
     * @param {string} rawUrl
     * @param {Object=} opts
     * @return {(!Promise<!JsonObject>|!Promise<null>)}
     */

  }, {
    key: "executeRequest",
    value: function executeRequest(rawUrl, opts) {
      var _this2 = this;

      if (opts === void 0) {
        opts = {};
      }

      if (!(0, _url.isProtocolValid)(rawUrl)) {
        (0, _log.user)().error(TAG, 'Invalid config url.');
        return Promise.resolve(null);
      }

      return _services.Services.urlReplacementsForDoc(this.storyElement_).expandUrlAsync((0, _log.user)().assertString(rawUrl)).then(function (url) {
        return _this2.xhr_.fetchJson(url, opts);
      }).then(function (response) {
        (0, _log.userAssert)(response.ok, 'Invalid HTTP response');
        return response.json();
      });
    }
  }]);

  return AmpStoryRequestService;
}();

exports.AmpStoryRequestService = AmpStoryRequestService;

/**
 * Util function to retrieve the request service. Ensures we can retrieve the
 * service synchronously from the amp-story codebase without running into race
 * conditions.
 * @param  {!Window} win
 * @param  {!Element} storyEl
 * @return {!AmpStoryRequestService}
 */
var getRequestService = function getRequestService(win, storyEl) {
  var service = _services.Services.storyRequestService(win);

  if (!service) {
    service = new AmpStoryRequestService(win, storyEl);
    (0, _service.registerServiceBuilder)(win, 'story-request', function () {
      return service;
    });
  }

  return service;
};

exports.getRequestService = getRequestService;

},{"../../../src/dom":106,"../../../src/json":120,"../../../src/log":123,"../../../src/service":130,"../../../src/services":133,"../../../src/url":142,"../../../src/utils/function":145}],51:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.ShareMenu = exports.VISIBLE_CLASS = void 0;

var _storyAnalytics = require("./story-analytics");

var _ampStoryStoreService = require("./amp-story-store-service");

var _ampStoryShareMenu = require("../../../build/amp-story-share-menu-1.0.css");

var _keyCodes = require("../../../src/utils/key-codes");

var _services = require("../../../src/services");

var _ampStoryShare = require("./amp-story-share");

var _dom = require("../../../src/dom");

var _utils = require("./utils");

var _log = require("../../../src/log");

var _service = require("../../../src/service");

var _staticTemplate = require("../../../src/static-template");

var _style = require("../../../src/style");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["<amp-social-share type=\"system\"></amp-social-share>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    <div class=\"i-amphtml-story-share-menu i-amphtml-story-system-reset\" aria-hidden=\"true\" role=\"alert\">\n      <div class=\"i-amphtml-story-share-menu-container\">\n        <span class=\"i-amphtml-story-share-menu-close-button\" role=\"button\">\n          &times;\n        </span>\n      </div>\n    </div>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/** @const {string} Class to toggle the share menu. */
var VISIBLE_CLASS = 'i-amphtml-story-share-menu-visible';
exports.VISIBLE_CLASS = VISIBLE_CLASS;

/**
 * Quick share template, used as a fallback if native sharing is not supported.
 * @param {!Element} element
 * @return {!Element}
 */
var getTemplate = function getTemplate(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject());
};

/**
 * System amp-social-share button template.
 * @param {!Element} element
 * @return {!Element}
 */
var getAmpSocialSystemShareTemplate = function getAmpSocialSystemShareTemplate(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject2());
};

/**
 * Share menu UI.
 */
var ShareMenu = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} storyEl Element where to append the component
   */
  function ShareMenu(win, storyEl) {
    _classCallCheck(this, ShareMenu);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {?Element} */
    this.element_ = null;

    /** @private {?Element} */
    this.innerContainerEl_ = null;

    /** @private {boolean} */
    this.isBuilt_ = false;

    /** @private {boolean} */
    this.isSystemShareSupported_ = false;

    /** @private @const {!ShareWidget} */
    this.shareWidget_ = _ampStoryShare.ShareWidget.create(this.win_, storyEl);

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.win_);

    /** @private {!./story-analytics.StoryAnalyticsService} */
    this.analyticsService_ = (0, _storyAnalytics.getAnalyticsService)(this.win_, storyEl);

    /** @private @const {!Element} */
    this.parentEl_ = storyEl;

    /** @const @private {!../../../src/service/vsync-impl.Vsync} */
    this.vsync_ = _services.Services.vsyncFor(this.win_);
  }

  /**
   * Builds and appends the component in the story. Could build either the
   * amp-social-share button to display the native system sharing, or a fallback
   * UI.
   */
  _createClass(ShareMenu, [{
    key: "build",
    value: function build() {
      if (this.isBuilt()) {
        return;
      }

      this.isBuilt_ = true;
      this.isSystemShareSupported_ = this.shareWidget_.isSystemShareSupported((0, _service.getAmpdoc)(this.parentEl_));
      this.isSystemShareSupported_ ? this.buildForSystemSharing_() : this.buildForFallbackSharing_();
    }
    /**
     * Whether the element has been built.
     * @return {boolean}
     */

  }, {
    key: "isBuilt",
    value: function isBuilt() {
      return this.isBuilt_;
    }
    /**
     * Builds a hidden amp-social-share button that triggers the native system
     * sharing UI.
     * @private
     */

  }, {
    key: "buildForSystemSharing_",
    value: function buildForSystemSharing_() {
      var _this = this;

      this.shareWidget_.loadRequiredExtensions((0, _service.getAmpdoc)(this.parentEl_));
      this.element_ = getAmpSocialSystemShareTemplate(this.parentEl_);
      this.initializeListeners_();
      this.vsync_.mutate(function () {
        (0, _style.setStyles)((0, _log.dev)().assertElement(_this.element_), {
          'visibility': 'hidden',
          'pointer-events': 'none',
          'z-index': -1
        });

        _this.parentEl_.appendChild(_this.element_);
      });
    }
    /**
     * Builds and appends the fallback UI.
     * @private
     */

  }, {
    key: "buildForFallbackSharing_",
    value: function buildForFallbackSharing_() {
      var _this2 = this;

      var root = this.win_.document.createElement('div');
      root.classList.add('i-amphtml-story-share-menu-host');
      this.element_ = getTemplate(this.parentEl_);
      (0, _utils.createShadowRootWithStyle)(root, this.element_, _ampStoryShareMenu.CSS);
      this.initializeListeners_();
      this.vsync_.run({
        measure: function measure() {
          _this2.innerContainerEl_ = _this2.element_.
          /*OK*/
          querySelector('.i-amphtml-story-share-menu-container');
        },
        mutate: function mutate() {
          _this2.parentEl_.appendChild(root);

          // Preloads and renders the share widget content.
          var shareWidget = _this2.shareWidget_.build((0, _service.getAmpdoc)(_this2.parentEl_));

          _this2.innerContainerEl_.appendChild(shareWidget);
        }
      });
    }
    /**
     * @private
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this3 = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.UI_STATE, function (uiState) {
        _this3.onUIStateUpdate_(uiState);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.SHARE_MENU_STATE, function (isOpen) {
        _this3.onShareMenuStateUpdate_(isOpen);
      });

      // Don't listen to click events if the system share is supported, since the
      // native layer handles all the UI interactions.
      if (!this.isSystemShareSupported_) {
        this.element_.addEventListener('click', function (event) {
          return _this3.onShareMenuClick_(event);
        });
        this.win_.addEventListener('keyup', function (event) {
          if (event.key == _keyCodes.Keys.ESCAPE) {
            event.preventDefault();

            _this3.close_();
          }
        });
      }
    }
    /**
     * Reacts to menu state updates and decides whether to show either the native
     * system sharing, or the fallback UI.
     * @param {boolean} isOpen
     * @private
     */

  }, {
    key: "onShareMenuStateUpdate_",
    value: function onShareMenuStateUpdate_(isOpen) {
      var _this4 = this;

      if (this.isSystemShareSupported_ && isOpen) {
        // Dispatches a click event on the amp-social-share button to trigger the
        // native system sharing UI. This has to be done upon user interaction.
        this.element_.dispatchEvent(new Event('click'));
        // There is no way to know when the user dismisses the native system share
        // menu, so we pretend it is closed on the story end, and let the native
        // end handle the UI interactions.
        this.close_();
      }

      if (!this.isSystemShareSupported_) {
        this.vsync_.mutate(function () {
          _this4.element_.classList.toggle(VISIBLE_CLASS, isOpen);

          _this4.element_.setAttribute('aria-hidden', !isOpen);
        });
      }

      this.element_[_storyAnalytics.ANALYTICS_TAG_NAME] = 'amp-story-share-menu';
      this.analyticsService_.triggerEvent(isOpen ? _storyAnalytics.StoryAnalyticsEvent.OPEN : _storyAnalytics.StoryAnalyticsEvent.CLOSE, this.element_);
    }
    /**
     * Handles click events and maybe closes the menu for the fallback UI.
     * @param  {!Event} event
     */

  }, {
    key: "onShareMenuClick_",
    value: function onShareMenuClick_(event) {
      var _this5 = this;

      var el = (0, _log.dev)().assertElement(event.target);

      if (el.classList.contains('i-amphtml-story-share-menu-close-button')) {
        this.close_();
      }

      // Closes the menu if click happened outside of the menu main container.
      if (!(0, _dom.closest)(el, function (el) {
        return el === _this5.innerContainerEl_;
      }, this.element_)) {
        this.close_();
      }
    }
    /**
     * Reacts to UI state updates and triggers the right UI.
     * @param {!UIType} uiState
     * @private
     */

  }, {
    key: "onUIStateUpdate_",
    value: function onUIStateUpdate_(uiState) {
      var _this6 = this;

      this.vsync_.mutate(function () {
        uiState !== _ampStoryStoreService.UIType.MOBILE ? _this6.element_.setAttribute('desktop', '') : _this6.element_.removeAttribute('desktop');
      });
    }
    /**
     * Closes the share menu.
     * @private
     */

  }, {
    key: "close_",
    value: function close_() {
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SHARE_MENU, false);
    }
  }]);

  return ShareMenu;
}();

exports.ShareMenu = ShareMenu;

},{"../../../build/amp-story-share-menu-1.0.css":7,"../../../src/dom":106,"../../../src/log":123,"../../../src/service":130,"../../../src/services":133,"../../../src/static-template":135,"../../../src/style":138,"../../../src/utils/key-codes":147,"./amp-story-share":52,"./amp-story-store-service":53,"./story-analytics":91,"./utils":93}],52:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.ScrollableShareWidget = exports.ShareWidget = exports.DEPRECATED_SHARE_PROVIDERS_KEY = exports.SHARE_PROVIDERS_KEY = void 0;

var _localizedStrings = require("../../../src/localized-strings");

var _services = require("../../../src/services");

var _toast = require("./toast");

var _clipboard = require("../../../src/clipboard");

var _log = require("../../../src/log");

var _object = require("./../../../src/utils/object");

var _ampStoryLocalizationService = require("./amp-story-localization-service");

var _ampStoryRequestService = require("./amp-story-request-service");

var _types = require("../../../src/types");

var _eventHelper = require("../../../src/event-helper");

var _style = require("../../../src/style");

var _simpleTemplate = require("./simple-template");

var _rateLimit = require("../../../src/utils/rate-limit");

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Maps share provider type to visible name.
 * If the name only needs to be capitalized (e.g. `facebook` to `Facebook`) it
 * does not need to be included here.
 * @const {!Object<string, !LocalizedStringId>}
 */
var SHARE_PROVIDER_LOCALIZED_STRING_ID = (0, _object.map)({
  'system': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SYSTEM,
  'email': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_EMAIL,
  'facebook': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK,
  'line': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINE,
  'linkedin': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN,
  'pinterest': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST,
  'gplus': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS,
  'tumblr': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR,
  'twitter': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_TWITTER,
  'whatsapp': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP,
  'sms': _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_SMS
});

/**
 * Default left/right padding for share buttons.
 * @private @const {number}
 */
var DEFAULT_BUTTON_PADDING = 16;

/**
 * Minimum left/right padding for share buttons.
 * @private @const {number}
 */
var MIN_BUTTON_PADDING = 10;

/**
 * Key for share providers in bookend config.
 * @const {string}
 */
var SHARE_PROVIDERS_KEY = 'shareProviders';
exports.SHARE_PROVIDERS_KEY = SHARE_PROVIDERS_KEY;

/**
 * Deprecated key for share providers in bookend config.
 * @const {string}
 */
var DEPRECATED_SHARE_PROVIDERS_KEY = 'share-providers';
exports.DEPRECATED_SHARE_PROVIDERS_KEY = DEPRECATED_SHARE_PROVIDERS_KEY;

/** @private @const {!./simple-template.ElementDef} */
var TEMPLATE = {
  tag: 'div',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-share-widget'
  }),
  children: [{
    tag: 'ul',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-share-list'
    }),
    children: [{
      tag: 'li',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-share-system'
      })
    }]
  }]
};

/** @private @const {!./simple-template.ElementDef} */
var SHARE_ITEM_TEMPLATE = {
  tag: 'li',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-share-item'
  })
};

/** @private @const {!./simple-template.ElementDef} */
var LINK_SHARE_ITEM_TEMPLATE = {
  tag: 'div',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-share-icon i-amphtml-story-share-icon-link'
  }),
  children: [{
    tag: 'span',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-share-label'
    }),
    localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_PROVIDER_NAME_LINK
  }]
};

/** @private @const {string} */
var SCROLLABLE_CLASSNAME = 'i-amphtml-story-share-widget-scrollable';

/**
 * @param {!JsonObject=} opt_params
 * @return {!JsonObject}
 */
function buildProviderParams(opt_params) {
  var attrs = (0, _object.dict)();

  if (opt_params) {
    Object.keys(opt_params).forEach(function (field) {
      if (field === 'provider') {
        return;
      }

      attrs["data-param-" + field] = opt_params[field];
    });
  }

  return attrs;
}

/**
 * @param {!Document} doc
 * @param {string} shareType
 * @param {!JsonObject=} opt_params
 * @return {!Node}
 */
function buildProvider(doc, shareType, opt_params) {
  var shareProviderLocalizedStringId = (0, _log.devAssert)(SHARE_PROVIDER_LOCALIZED_STRING_ID[shareType], "No localized string to display name for share type " + shareType + ".");
  return (0, _simpleTemplate.renderSimpleTemplate)(doc,
  /** @type {!Array<!./simple-template.ElementDef>} */
  [{
    tag: 'amp-social-share',
    attrs:
    /** @type {!JsonObject} */
    Object.assign((0, _object.dict)({
      'width': 48,
      'height': 48,
      'class': 'i-amphtml-story-share-icon',
      'type': shareType
    }), buildProviderParams(opt_params)),
    children: [{
      tag: 'span',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-share-label'
      }),
      localizedStringId: shareProviderLocalizedStringId
    }]
  }]);
}

/**
 * @param {!Document} doc
 * @param {string} url
 * @return {!Element}
 */
function buildCopySuccessfulToast(doc, url) {
  return (0, _simpleTemplate.renderAsElement)(doc,
  /** @type {!./simple-template.ElementDef} */
  {
    tag: 'div',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-copy-successful'
    }),
    children: [{
      tag: 'div',
      localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT
    }, {
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-copy-url'
      }),
      unlocalizedString: url
    }]
  });
}

/**
 * Social share widget for story bookend.
 */
var ShareWidget = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} storyEl
   */
  function ShareWidget(win, storyEl) {
    _classCallCheck(this, ShareWidget);

    /** @private {?../../../src/service/ampdoc-impl.AmpDoc} */
    this.ampdoc_ = null;

    /** @protected @const {!Window} */
    this.win = win;

    /** @protected @const {!Element} */
    this.storyEl = storyEl;

    /** @protected {?Element} */
    this.root = null;

    /** @private @const {!./amp-story-request-service.AmpStoryRequestService} */
    this.requestService_ = (0, _ampStoryRequestService.getRequestService)(this.win, storyEl);
  }

  /**
   * @param {!Window} win
   * @param {!Element} storyEl
   * @return {!ShareWidget}
   */
  _createClass(ShareWidget, [{
    key: "build",

    /**
     * @param {!../../../src/service/ampdoc-impl.AmpDoc} ampdoc
     * @return {!Element}
     */
    value: function build(ampdoc) {
      (0, _log.devAssert)(!this.root, 'Already built.');
      this.ampdoc_ = ampdoc;
      this.root = (0, _simpleTemplate.renderAsElement)(this.win.document, TEMPLATE);
      this.loadProviders();
      this.maybeAddLinkShareButton_();
      this.maybeAddSystemShareButton_();
      return this.root;
    }
    /**
     * @return {!../../../src/service/ampdoc-impl.AmpDoc}
     * @private
     */

  }, {
    key: "getAmpDoc_",
    value: function getAmpDoc_() {
      return (0, _log.devAssert)(this.ampdoc_);
    }
    /** @private */

  }, {
    key: "maybeAddLinkShareButton_",
    value: function maybeAddLinkShareButton_() {
      var _this = this;

      if (!(0, _clipboard.isCopyingToClipboardSupported)(this.win.document)) {
        return;
      }

      var linkShareButton = (0, _simpleTemplate.renderAsElement)(this.win.document, LINK_SHARE_ITEM_TEMPLATE);
      this.add_(linkShareButton);
      (0, _eventHelper.listen)(linkShareButton, 'click', function (e) {
        e.preventDefault();

        _this.copyUrlToClipboard_();
      });
    }
    /**
     * @private
     */

  }, {
    key: "copyUrlToClipboard_",
    value: function copyUrlToClipboard_() {
      var url = _services.Services.documentInfoForDoc(this.getAmpDoc_()).canonicalUrl;

      if (!(0, _clipboard.copyTextToClipboard)(this.win, url)) {
        var localizationService = (0, _ampStoryLocalizationService.getLocalizationService)(this.storyEl);
        (0, _log.devAssert)(localizationService, 'Could not retrieve LocalizationService.');
        var failureString = localizationService.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT);

        _toast.Toast.show(this.storyEl, (0, _log.dev)().assertString(failureString));

        return;
      }

      _toast.Toast.show(this.storyEl, buildCopySuccessfulToast(this.win.document, url));
    }
    /** @private */

  }, {
    key: "maybeAddSystemShareButton_",
    value: function maybeAddSystemShareButton_() {
      if (!this.isSystemShareSupported()) {
        // `amp-social-share` will hide `system` buttons when not supported, but
        // we also need to avoid adding it for rendering reasons.
        return;
      }

      var container = (0, _log.dev)().assertElement(this.root).querySelector('.i-amphtml-story-share-system');
      this.loadRequiredExtensions();
      container.appendChild(buildProvider(this.win.document, 'system'));
    }
    /**
     * NOTE(alanorozco): This is a duplicate of the logic in the
     * `amp-social-share` component.
     * @param  {!../../../src/service/ampdoc-impl.AmpDoc=}  ampdoc
     * @return {boolean} Whether the browser supports native system sharing.
     */

  }, {
    key: "isSystemShareSupported",
    value: function isSystemShareSupported(ampdoc) {
      if (ampdoc === void 0) {
        ampdoc = this.getAmpDoc_();
      }

      var viewer = _services.Services.viewerForDoc(ampdoc);

      var platform = _services.Services.platformFor(this.win);

      // Chrome exports navigator.share in WebView but does not implement it.
      // See https://bugs.chromium.org/p/chromium/issues/detail?id=765923
      var isChromeWebview = viewer.isWebviewEmbedded() && platform.isChrome();
      return 'share' in navigator && !isChromeWebview;
    }
    /**
     * Loads and applies the share providers configured by the publisher.
     * @protected
     */

  }, {
    key: "loadProviders",
    value: function loadProviders() {
      var _this2 = this;

      this.loadRequiredExtensions();
      this.requestService_.loadBookendConfig().then(function (config) {
        var providers = config && (config[SHARE_PROVIDERS_KEY] || config[DEPRECATED_SHARE_PROVIDERS_KEY]);

        if (!providers) {
          return;
        }

        _this2.setProviders_(providers);
      });
    }
    /**
     * @param {(!Object<string, (!JsonObject|boolean)> | !Array<!Object|string>)} providers
     * @private
     * TODO(alanorozco): Set story metadata in share config.
     */

  }, {
    key: "setProviders_",
    value: function setProviders_(providers) {
      var _this3 = this;

      /** @type {!Array} */
      providers.forEach(function (provider) {
        if ((0, _types.isObject)(provider)) {
          _this3.add_(buildProvider(_this3.win.document, provider['provider'],
          /** @type {!JsonObject} */
          provider));

          return;
        }

        if (provider == 'system') {
          (0, _log.user)().warn('AMP-STORY', '`system` is not a valid share provider type. Native sharing is ' + 'enabled by default and cannot be turned off.', provider);
          return;
        }

        _this3.add_(buildProvider(_this3.win.document,
        /** @type {string} */
        provider));
      });
    }
    /**
     * @param {!../../../src/service/ampdoc-impl.AmpDoc=} ampdoc
     */

  }, {
    key: "loadRequiredExtensions",
    value: function loadRequiredExtensions(ampdoc) {
      if (ampdoc === void 0) {
        ampdoc = this.getAmpDoc_();
      }

      _services.Services.extensionsFor(this.win).installExtensionForDoc(ampdoc, 'amp-social-share');
    }
    /**
     * @param {!Node} node
     * @private
     */

  }, {
    key: "add_",
    value: function add_(node) {
      var list = (0, _log.devAssert)(this.root).lastElementChild;
      var item = (0, _simpleTemplate.renderAsElement)(this.win.document, SHARE_ITEM_TEMPLATE);
      item.appendChild(node);
      // `lastElementChild` is the system share button container, which should
      // always be last in list
      list.insertBefore(item, list.lastElementChild);
    }
  }], [{
    key: "create",
    value: function create(win, storyEl) {
      return new ShareWidget(win, storyEl);
    }
  }]);

  return ShareWidget;
}();

exports.ShareWidget = ShareWidget;

/**
 * Social share widget for story bookend with a scrollable layout.
 * This class is coupled to the DOM structure for ShareWidget, but that's ok.
 */
var ScrollableShareWidget = /*#__PURE__*/function (_ShareWidget) {
  _inherits(ScrollableShareWidget, _ShareWidget);

  var _super = _createSuper(ScrollableShareWidget);

  /**
   * @param {!Window} win
   * @param {!Element} storyEl
   */
  function ScrollableShareWidget(win, storyEl) {
    var _this4;

    _classCallCheck(this, ScrollableShareWidget);

    _this4 = _super.call(this, win, storyEl);

    /** @private @const {!../../../src/service/vsync-impl.Vsync} */
    _this4.vsync_ = _services.Services.vsyncFor(win);

    /**
     * Container width is being tracked to prevent unnecessary layout
     * calculations.
     * @private {?number}
     */
    _this4.containerWidth_ = null;
    return _this4;
  }

  /**
   * @param {!Window} win
   * @param {!Element} storyEl
   * @return {!ScrollableShareWidget}
   */
  _createClass(ScrollableShareWidget, [{
    key: "build",

    /**
     * @param {!../../../src/service/ampdoc-impl.AmpDoc} ampdoc
     * @return {!Element}
     */
    value: function build(ampdoc) {
      var _this5 = this;

      _get(_getPrototypeOf(ScrollableShareWidget.prototype), "build", this).call(this, ampdoc);

      this.root.classList.add(SCROLLABLE_CLASSNAME);

      _services.Services.viewportForDoc(ampdoc).onResize((0, _rateLimit.throttle)(this.win, function () {
        return _this5.applyButtonPadding_();
      }, 100));

      this.vsync_.measure(function () {
        // If the element is actually scrollable, don't propagate the touch events
        // so it is not interpreted as a swipe to the next story.
        if (_this5.root.
        /*OK*/
        offsetWidth < _this5.root.
        /*OK*/
        scrollWidth) {
          _this5.root.addEventListener('touchstart', function (event) {
            return event.stopPropagation();
          }, {
            capture: true
          });

          _this5.root.addEventListener('touchmove', function (event) {
            return event.stopPropagation();
          }, {
            capture: true
          });

          _this5.root.addEventListener('touchend', function (event) {
            return event.stopPropagation();
          }, {
            capture: true
          });
        }
      });
      return this.root;
    }
    /**
     * Calculates padding between buttons so that the result is that there's
     * always one item visually "cut off" for scroll affordance.
     * @private
     */

  }, {
    key: "applyButtonPadding_",
    value: function applyButtonPadding_() {
      var _this6 = this;

      var items = this.getVisibleItems_();

      if (!items.length) {
        return;
      }

      this.vsync_.run({
        measure: function measure(state) {
          var containerWidth = _this6.root.
          /*OK*/
          clientWidth;

          if (containerWidth == _this6.containerWidth_) {
            // Don't recalculate if width has not changed (i.e. onscreen keyboard)
            state.noop = true;
            return;
          }

          var icon = (0, _log.devAssert)(items[0].firstElementChild);
          var leftMargin = icon.
          /*OK*/
          offsetLeft - _this6.root.
          /*OK*/
          offsetLeft;
          var iconWidth = icon.
          /*OK*/
          offsetWidth;
          // Total width that the buttons will occupy with minimum padding.
          var totalItemWidth = iconWidth * items.length + 2 * MIN_BUTTON_PADDING * (items.length - 1);

          // If buttons don't fit within the available area, calculate padding so
          // that there will be an element cut-off.
          if (totalItemWidth > containerWidth - leftMargin * 2) {
            var availableWidth = containerWidth - leftMargin - iconWidth / 2;
            var amountVisible = Math.floor(availableWidth / (iconWidth + MIN_BUTTON_PADDING * 2));
            state.padding = 0.5 * (availableWidth / amountVisible - iconWidth);
          } else {
            // Otherwise, calculate padding in from MIN_PADDING to DEFAULT_PADDING
            // so that all elements fit and take as much area as possible.
            var totalPadding = (containerWidth - leftMargin * 2 - iconWidth * items.length) / (items.length - 1);
            state.padding = Math.min(DEFAULT_BUTTON_PADDING, 0.5 * totalPadding);
          }

          _this6.containerWidth_ = containerWidth;
        },
        mutate: function mutate(state) {
          if (state.noop) {
            return;
          }

          items.forEach(function (el, i) {
            if (i != 0) {
              (0, _style.setImportantStyles)(el, {
                'padding-left': (0, _style.px)(state.padding)
              });
            }

            if (i != items.length - 1) {
              (0, _style.setImportantStyles)(el, {
                'padding-right': (0, _style.px)(state.padding)
              });
            }
          });
        }
      }, {});
    }
    /**
     * @return {!Array<!Element>}
     * @private
     */

  }, {
    key: "getVisibleItems_",
    value: function getVisibleItems_() {
      return Array.prototype.filter.call((0, _log.dev)().assertElement(this.root).querySelectorAll('li'), function (el) {
        return !!el.firstElementChild;
      });
    }
    /**
     * Loads and applies the share providers configured by the publisher.
     * @protected
     */

  }, {
    key: "loadProviders",
    value: function loadProviders() {
      _get(_getPrototypeOf(ScrollableShareWidget.prototype), "loadProviders", this).call(this);

      this.applyButtonPadding_();
    }
  }], [{
    key: "create",
    value: function create(win, storyEl) {
      return new ScrollableShareWidget(win, storyEl);
    }
  }]);

  return ScrollableShareWidget;
}(ShareWidget);

exports.ScrollableShareWidget = ScrollableShareWidget;

},{"../../../src/clipboard":100,"../../../src/event-helper":111,"../../../src/localized-strings":122,"../../../src/log":123,"../../../src/services":133,"../../../src/style":138,"../../../src/types":139,"../../../src/utils/rate-limit":151,"./../../../src/utils/object":149,"./amp-story-localization-service":45,"./amp-story-request-service":50,"./simple-template":89,"./toast":92}],53:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryStoreService = exports.Action = exports.StateProperty = exports.State = exports.InteractiveReactData = exports.InteractiveComponentDef = exports.EmbeddedComponentState = exports.UIType = exports.getStoreService = void 0;

var _embedMode = require("./embed-mode");

var _observable = require("../../../src/observable");

var _services = require("../../../src/services");

var _json = require("../../../src/json");

var _log = require("../../../src/log");

var _object = require("../../../src/utils/object");

var _service = require("../../../src/service");

var _stateComparisonFunct;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @type {string} */
var TAG = 'amp-story';

/**
 * Util function to retrieve the store service. Ensures we can retrieve the
 * service synchronously from the amp-story codebase without running into race
 * conditions.
 * @param  {!Window} win
 * @return {!AmpStoryStoreService}
 */
var getStoreService = function getStoreService(win) {
  var service = _services.Services.storyStoreService(win);

  if (!service) {
    service = new AmpStoryStoreService(win);
    (0, _service.registerServiceBuilder)(win, 'story-store', function () {
      return service;
    });
  }

  return service;
};

exports.getStoreService = getStoreService;

/**
 * Different UI experiences to display the story.
 * @const @enum {number}
 */
var UIType = {
  MOBILE: 0,
  DESKTOP_PANELS: 1,
  // Default desktop UI.
  DESKTOP_FULLBLEED: 2,
  // Desktop UI if landscape mode is enabled.
  VERTICAL: 3 // Vertical scrolling versions, for search engine bots indexing.

};
exports.UIType = UIType;

/**
 * States in which an embedded component could be found in.
 * @enum {number}
 */
var EmbeddedComponentState = {
  HIDDEN: 0,
  // Component is present in page, but hasn't been interacted with.
  FOCUSED: 1,
  // Component has been clicked, a tooltip should be shown.
  EXPANDED: 2 // Component is in expanded mode.

};
exports.EmbeddedComponentState = EmbeddedComponentState;

/**
 * @typedef {{
 *    element: !Element,
 *    state: !EmbeddedComponentState,
 *    clientX: number,
 *    clientY: number,
 * }}
 */
var InteractiveComponentDef;
exports.InteractiveComponentDef = InteractiveComponentDef;

/**
 * @typedef {{
 *    option: ?../../amp-story-interactive/1.0/amp-story-interactive-abstract.OptionConfigType,
 *    interactiveId: string,
 *    type: ../../amp-story-interactive/1.0/amp-story-interactive-abstract.InteractiveType
 * }}
 */
var InteractiveReactData;
exports.InteractiveReactData = InteractiveReactData;

/**
 * @typedef {{
 *    canInsertAutomaticAd: boolean,
 *    canShowBookend: boolean,
 *    canShowAudioUi: boolean,
 *    canShowNavigationOverlayHint: boolean,
 *    canShowPaginationButtons: boolean,
 *    canShowPreviousPageHelp: boolean,
 *    canShowSharingUis: boolean,
 *    canShowSystemLayerButtons: boolean,
 *    accessState: boolean,
 *    adState: boolean,
 *    pageAttachmentState: boolean,
 *    affiliateLinkState: !Element,
 *    bookendState: boolean,
 *    desktopState: boolean,
 *    educationState: boolean,
 *    hasSidebarState: boolean,
 *    infoDialogState: boolean,
 *    interactiveEmbeddedComponentState: !InteractiveComponentDef,
 *    interactiveReactState: !Map<string, !InteractiveReactData>,
 *    mutedState: boolean,
 *    pageAudioState: boolean,
 *    pageHasElementsWithPlaybackState: boolean,
 *    pausedState: boolean,
 *    previewState: boolean,
 *    rtlState: boolean,
 *    shareMenuState: boolean,
 *    sidebarState: boolean,
 *    storyHasAudioState: boolean,
 *    storyHasPlaybackUiState: boolean,
 *    storyHasBackgroundAudioState: boolean,
 *    supportedBrowserState: boolean,
 *    systemUiIsVisibleState: boolean,
 *    uiState: !UIType,
 *    viewportWarningState: boolean,
 *    actionsAllowlist: !Array<{tagOrTarget: string, method: string}>,
 *    consentId: ?string,
 *    currentPageId: string,
 *    currentPageIndex: number,
 *    pageIds: !Array<string>,
 *    newPageAvailableId: string,
 *    pageSize: {width: number, height: number},
 * }}
 */
var State;
exports.State = State;

/** @const @enum {string} */
var StateProperty = {
  // Embed options.
  CAN_INSERT_AUTOMATIC_AD: 'canInsertAutomaticAd',
  CAN_SHOW_BOOKEND: 'canShowBookend',
  CAN_SHOW_AUDIO_UI: 'canShowAudioUi',
  CAN_SHOW_NAVIGATION_OVERLAY_HINT: 'canShowNavigationOverlayHint',
  CAN_SHOW_PAGINATION_BUTTONS: 'canShowPaginationButtons',
  CAN_SHOW_PREVIOUS_PAGE_HELP: 'canShowPreviousPageHelp',
  CAN_SHOW_SHARING_UIS: 'canShowSharingUis',
  CAN_SHOW_SYSTEM_LAYER_BUTTONS: 'canShowSystemLayerButtons',
  // App States.
  ACCESS_STATE: 'accessState',
  // amp-access paywall.
  AD_STATE: 'adState',
  PAGE_ATTACHMENT_STATE: 'pageAttachmentState',
  BOOKEND_STATE: 'bookendState',
  AFFILIATE_LINK_STATE: 'affiliateLinkState',
  DESKTOP_STATE: 'desktopState',
  EDUCATION_STATE: 'educationState',
  HAS_SIDEBAR_STATE: 'hasSidebarState',
  INFO_DIALOG_STATE: 'infoDialogState',
  INTERACTIVE_COMPONENT_STATE: 'interactiveEmbeddedComponentState',
  // State of interactive components (polls, quizzes) on the story.
  INTERACTIVE_REACT_STATE: 'interactiveReactState',
  MUTED_STATE: 'mutedState',
  PAGE_HAS_AUDIO_STATE: 'pageAudioState',
  PAGE_HAS_ELEMENTS_WITH_PLAYBACK_STATE: 'pageHasElementsWithPlaybackState',
  PAUSED_STATE: 'pausedState',
  // Story preview state.
  PREVIEW_STATE: 'previewState',
  RTL_STATE: 'rtlState',
  SHARE_MENU_STATE: 'shareMenuState',
  SIDEBAR_STATE: 'sidebarState',
  SUPPORTED_BROWSER_STATE: 'supportedBrowserState',
  // Any page has audio, or amp-story has a `background-audio` attribute.
  STORY_HAS_AUDIO_STATE: 'storyHasAudioState',
  // amp-story has a `background-audio` attribute.
  STORY_HAS_BACKGROUND_AUDIO_STATE: 'storyHasBackgroundAudioState',
  // Any page has elements with playback.
  STORY_HAS_PLAYBACK_UI_STATE: 'storyHasPlaybackUiState',
  SYSTEM_UI_IS_VISIBLE_STATE: 'systemUiIsVisibleState',
  UI_STATE: 'uiState',
  VIEWPORT_WARNING_STATE: 'viewportWarningState',
  // App data.
  ACTIONS_ALLOWLIST: 'actionsAllowlist',
  CONSENT_ID: 'consentId',
  CURRENT_PAGE_ID: 'currentPageId',
  CURRENT_PAGE_INDEX: 'currentPageIndex',
  ADVANCEMENT_MODE: 'advancementMode',
  NAVIGATION_PATH: 'navigationPath',
  NEW_PAGE_AVAILABLE_ID: 'newPageAvailableId',
  PAGE_IDS: 'pageIds',
  PAGE_SIZE: 'pageSize'
};
exports.StateProperty = StateProperty;

/** @const @enum {string} */
var Action = {
  ADD_INTERACTIVE_REACT: 'addInteractiveReact',
  ADD_TO_ACTIONS_ALLOWLIST: 'addToActionsAllowlist',
  CHANGE_PAGE: 'setCurrentPageId',
  SET_CONSENT_ID: 'setConsentId',
  SET_ADVANCEMENT_MODE: 'setAdvancementMode',
  SET_NAVIGATION_PATH: 'setNavigationPath',
  SET_PAGE_IDS: 'setPageIds',
  TOGGLE_ACCESS: 'toggleAccess',
  TOGGLE_AD: 'toggleAd',
  TOGGLE_AFFILIATE_LINK: 'toggleAffiliateLink',
  TOGGLE_BOOKEND: 'toggleBookend',
  TOGGLE_CAN_SHOW_BOOKEND: 'toggleCanShowBookend',
  TOGGLE_EDUCATION: 'toggleEducation',
  TOGGLE_HAS_SIDEBAR: 'toggleHasSidebar',
  TOGGLE_INFO_DIALOG: 'toggleInfoDialog',
  TOGGLE_INTERACTIVE_COMPONENT: 'toggleInteractiveComponent',
  TOGGLE_MUTED: 'toggleMuted',
  TOGGLE_PAGE_ATTACHMENT_STATE: 'togglePageAttachmentState',
  TOGGLE_PAGE_HAS_AUDIO: 'togglePageHasAudio',
  TOGGLE_PAGE_HAS_ELEMENT_WITH_PLAYBACK: 'togglePageHasElementWithPlayblack',
  TOGGLE_PAUSED: 'togglePaused',
  TOGGLE_RTL: 'toggleRtl',
  TOGGLE_SHARE_MENU: 'toggleShareMenu',
  TOGGLE_SIDEBAR: 'toggleSidebar',
  TOGGLE_SUPPORTED_BROWSER: 'toggleSupportedBrowser',
  TOGGLE_STORY_HAS_AUDIO: 'toggleStoryHasAudio',
  TOGGLE_STORY_HAS_BACKGROUND_AUDIO: 'toggleStoryHasBackgroundAudio',
  TOGGLE_STORY_HAS_PLAYBACK_UI: 'toggleStoryHasPlaybackUi',
  TOGGLE_SYSTEM_UI_IS_VISIBLE: 'toggleSystemUiIsVisible',
  TOGGLE_UI: 'toggleUi',
  TOGGLE_VIEWPORT_WARNING: 'toggleViewportWarning',
  ADD_NEW_PAGE_ID: 'addNewPageId',
  SET_PAGE_SIZE: 'updatePageSize'
};
exports.Action = Action;

/**
 * Functions to compare a data structure from the previous to the new state and
 * detect a mutation, when a simple equality test would not work.
 * @private @const {!Object<string, !function(*, *):boolean>}
 */
var stateComparisonFunctions = (_stateComparisonFunct = {}, _stateComparisonFunct[StateProperty.ACTIONS_ALLOWLIST] = function (old, curr) {
  return old.length !== curr.length;
}, _stateComparisonFunct[StateProperty.INTERACTIVE_COMPONENT_STATE] =
/**
 * @param {InteractiveComponentDef} old
 * @param {InteractiveComponentDef} curr
 */
function (old, curr) {
  return old.element !== curr.element || old.state !== curr.state;
}, _stateComparisonFunct[StateProperty.NAVIGATION_PATH] = function (old, curr) {
  return old.length !== curr.length;
}, _stateComparisonFunct[StateProperty.PAGE_IDS] = function (old, curr) {
  return old.length !== curr.length;
}, _stateComparisonFunct[StateProperty.PAGE_SIZE] = function (old, curr) {
  return old === null || curr === null || old.width !== curr.width || old.height !== curr.height;
}, _stateComparisonFunct[StateProperty.INTERACTIVE_REACT_STATE] = function (old, curr) {
  return !(0, _json.deepEquals)(old, curr, 3);
}, _stateComparisonFunct);

/**
 * Returns the new sate.
 * @param  {!State} state Immutable state
 * @param  {!Action} action
 * @param  {*} data
 * @return {!State} new state
 */
var actions = function actions(state, action, data) {
  var _extends2, _extends3, _extends4, _extends5, _extends6, _extends7, _extends8, _extends9, _extends10, _extends11, _extends12, _extends13, _extends14, _extends15, _extends16, _extends17, _extends18, _extends19, _extends20, _extends21, _extends22, _extends23, _extends24, _extends25, _extends26, _extends27, _extends28, _extends29, _extends30, _extends31, _extends32, _extends33, _extends34, _extends35;

  switch (action) {
    case Action.ADD_INTERACTIVE_REACT:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends3 = {}, _extends3[StateProperty.INTERACTIVE_REACT_STATE] = _extends({}, state[StateProperty.INTERACTIVE_REACT_STATE], (_extends2 = {}, _extends2[data['interactiveId']] = data, _extends2)), _extends3))
      );

    case Action.ADD_NEW_PAGE_ID:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends4 = {}, _extends4[StateProperty.NEW_PAGE_AVAILABLE_ID] = data, _extends4))
      );

    case Action.ADD_TO_ACTIONS_ALLOWLIST:
      var newActionsAllowlist = [].concat(state[StateProperty.ACTIONS_ALLOWLIST], data);
      return (
        /** @type {!State} */
        _extends({}, state, (_extends5 = {}, _extends5[StateProperty.ACTIONS_ALLOWLIST] = newActionsAllowlist, _extends5))
      );
    // Triggers the amp-acess paywall.

    case Action.TOGGLE_ACCESS:
      // Don't change the PAUSED_STATE if ACCESS_STATE is not changed.
      if (state[StateProperty.ACCESS_STATE] === data) {
        return state;
      }

      return (
        /** @type {!State} */
        _extends({}, state, (_extends6 = {}, _extends6[StateProperty.ACCESS_STATE] = !!data, _extends6[StateProperty.PAUSED_STATE] = !!data, _extends6))
      );

    case Action.TOGGLE_PAGE_ATTACHMENT_STATE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends7 = {}, _extends7[StateProperty.PAGE_ATTACHMENT_STATE] = !!data, _extends7))
      );
    // Triggers the ad UI.

    case Action.TOGGLE_AD:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends8 = {}, _extends8[StateProperty.AD_STATE] = !!data, _extends8))
      );
    // Expands or collapses the affiliate link.

    case Action.TOGGLE_AFFILIATE_LINK:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends9 = {}, _extends9[StateProperty.AFFILIATE_LINK_STATE] = data, _extends9))
      );
    // Shows or hides the bookend.

    case Action.TOGGLE_BOOKEND:
      if (!state[StateProperty.CAN_SHOW_BOOKEND]) {
        return state;
      }

      return (
        /** @type {!State} */
        _extends({}, state, (_extends10 = {}, _extends10[StateProperty.BOOKEND_STATE] = !!data, _extends10[StateProperty.PAUSED_STATE] = !!data, _extends10))
      );

    case Action.TOGGLE_CAN_SHOW_BOOKEND:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends11 = {}, _extends11[StateProperty.CAN_SHOW_BOOKEND] = !!data, _extends11))
      );

    case Action.TOGGLE_EDUCATION:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends12 = {}, _extends12[StateProperty.EDUCATION_STATE] = !!data, _extends12))
      );

    case Action.TOGGLE_INTERACTIVE_COMPONENT:
      data =
      /** @type {InteractiveComponentDef} */
      data;
      return (
        /** @type {!State} */
        _extends({}, state, (_extends13 = {}, _extends13[StateProperty.PAUSED_STATE] = data.state === EmbeddedComponentState.EXPANDED || data.state === EmbeddedComponentState.FOCUSED, _extends13[StateProperty.SYSTEM_UI_IS_VISIBLE_STATE] = data.state !== EmbeddedComponentState.EXPANDED || state.uiState === UIType.DESKTOP_PANELS, _extends13[StateProperty.INTERACTIVE_COMPONENT_STATE] = data, _extends13))
      );
    // Shows or hides the info dialog.

    case Action.TOGGLE_INFO_DIALOG:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends14 = {}, _extends14[StateProperty.INFO_DIALOG_STATE] = !!data, _extends14[StateProperty.PAUSED_STATE] = !!data, _extends14))
      );
    // Shows or hides the audio controls.

    case Action.TOGGLE_STORY_HAS_AUDIO:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends15 = {}, _extends15[StateProperty.STORY_HAS_AUDIO_STATE] = !!data, _extends15))
      );

    case Action.TOGGLE_STORY_HAS_BACKGROUND_AUDIO:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends16 = {}, _extends16[StateProperty.STORY_HAS_BACKGROUND_AUDIO_STATE] = !!data, _extends16))
      );
    // Shows or hides the play/pause controls.

    case Action.TOGGLE_STORY_HAS_PLAYBACK_UI:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends17 = {}, _extends17[StateProperty.STORY_HAS_PLAYBACK_UI_STATE] = !!data, _extends17))
      );
    // Mutes or unmutes the story media.

    case Action.TOGGLE_MUTED:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends18 = {}, _extends18[StateProperty.MUTED_STATE] = !!data, _extends18))
      );

    case Action.TOGGLE_PAGE_HAS_AUDIO:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends19 = {}, _extends19[StateProperty.PAGE_HAS_AUDIO_STATE] = !!data, _extends19))
      );

    case Action.TOGGLE_PAGE_HAS_ELEMENT_WITH_PLAYBACK:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends20 = {}, _extends20[StateProperty.PAGE_HAS_ELEMENTS_WITH_PLAYBACK_STATE] = !!data, _extends20))
      );

    case Action.TOGGLE_PAUSED:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends21 = {}, _extends21[StateProperty.PAUSED_STATE] = !!data, _extends21))
      );

    case Action.TOGGLE_RTL:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends22 = {}, _extends22[StateProperty.RTL_STATE] = !!data, _extends22))
      );

    case Action.TOGGLE_SIDEBAR:
      // Don't change the PAUSED_STATE if SIDEBAR_STATE is not changed.
      if (state[StateProperty.SIDEBAR_STATE] === data) {
        return state;
      }

      return (
        /** @type {!State} */
        _extends({}, state, (_extends23 = {}, _extends23[StateProperty.PAUSED_STATE] = !!data, _extends23[StateProperty.SIDEBAR_STATE] = !!data, _extends23))
      );

    case Action.TOGGLE_HAS_SIDEBAR:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends24 = {}, _extends24[StateProperty.HAS_SIDEBAR_STATE] = !!data, _extends24))
      );

    case Action.TOGGLE_SUPPORTED_BROWSER:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends25 = {}, _extends25[StateProperty.SUPPORTED_BROWSER_STATE] = !!data, _extends25))
      );

    case Action.TOGGLE_SHARE_MENU:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends26 = {}, _extends26[StateProperty.PAUSED_STATE] = !!data, _extends26[StateProperty.SHARE_MENU_STATE] = !!data, _extends26))
      );

    case Action.TOGGLE_SYSTEM_UI_IS_VISIBLE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends27 = {}, _extends27[StateProperty.SYSTEM_UI_IS_VISIBLE_STATE] = !!data, _extends27))
      );

    case Action.TOGGLE_UI:
      if (state[StateProperty.UI_STATE] === UIType.VERTICAL && data !== UIType.VERTICAL) {
        (0, _log.dev)().error(TAG, 'Cannot switch away from UIType.VERTICAL');
        return state;
      }

      return (
        /** @type {!State} */
        _extends({}, state, (_extends28 = {}, _extends28[StateProperty.DESKTOP_STATE] = data === UIType.DESKTOP_PANELS, _extends28[StateProperty.UI_STATE] = data, _extends28))
      );

    case Action.TOGGLE_VIEWPORT_WARNING:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends29 = {}, _extends29[StateProperty.VIEWPORT_WARNING_STATE] = !!data, _extends29))
      );

    case Action.SET_CONSENT_ID:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends30 = {}, _extends30[StateProperty.CONSENT_ID] = data, _extends30))
      );

    case Action.CHANGE_PAGE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends31 = {}, _extends31[StateProperty.CURRENT_PAGE_ID] = data.id, _extends31[StateProperty.CURRENT_PAGE_INDEX] = data.index, _extends31))
      );

    case Action.SET_ADVANCEMENT_MODE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends32 = {}, _extends32[StateProperty.ADVANCEMENT_MODE] = data, _extends32))
      );

    case Action.SET_NAVIGATION_PATH:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends33 = {}, _extends33[StateProperty.NAVIGATION_PATH] = data, _extends33))
      );

    case Action.SET_PAGE_IDS:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends34 = {}, _extends34[StateProperty.PAGE_IDS] = data, _extends34))
      );

    case Action.SET_PAGE_SIZE:
      return (
        /** @type {!State} */
        _extends({}, state, (_extends35 = {}, _extends35[StateProperty.PAGE_SIZE] = data, _extends35))
      );

    default:
      (0, _log.dev)().error(TAG, 'Unknown action %s.', action);
      return state;
  }
};

/**
 * Store service.
 */
var AmpStoryStoreService = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function AmpStoryStoreService(win) {
    _classCallCheck(this, AmpStoryStoreService);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {!Object<string, !Observable>} */
    this.listeners_ = {};

    /** @private {!State} */
    this.state_ =
    /** @type {!State} */
    _extends({}, this.getDefaultState_(), this.getEmbedOverrides_());
  }

  /**
   * Retrieves a state property.
   * @param  {string} key Property to retrieve from the state.
   * @return {*}
   */
  _createClass(AmpStoryStoreService, [{
    key: "get",
    value: function get(key) {
      if (!(0, _object.hasOwn)(this.state_, key)) {
        (0, _log.dev)().error(TAG, 'Unknown state %s.', key);
        return;
      }

      return this.state_[key];
    }
    /**
     * Subscribes to a state property mutations.
     * @param  {string} key
     * @param  {!Function} listener
     * @param  {boolean=} callToInitialize Whether the listener should be
     *                                     triggered with current value.
     */

  }, {
    key: "subscribe",
    value: function subscribe(key, listener, callToInitialize) {
      if (callToInitialize === void 0) {
        callToInitialize = false;
      }

      if (!(0, _object.hasOwn)(this.state_, key)) {
        (0, _log.dev)().error(TAG, "Can't subscribe to unknown state %s.", key);
        return;
      }

      if (!this.listeners_[key]) {
        this.listeners_[key] = new _observable.Observable();
      }

      this.listeners_[key].add(listener);

      if (callToInitialize) {
        listener(this.get(key));
      }
    }
    /**
     * Dispatches an action and triggers the listeners for the updated state
     * properties.
     * @param  {!Action} action
     * @param  {*} data
     */

  }, {
    key: "dispatch",
    value: function dispatch(action, data) {
      var _this = this;

      var oldState = _extends({}, this.state_);

      this.state_ = actions(this.state_, action, data);
      var comparisonFn;
      Object.keys(this.listeners_).forEach(function (key) {
        comparisonFn = stateComparisonFunctions[key];

        if (comparisonFn ? comparisonFn(oldState[key], _this.state_[key]) : oldState[key] !== _this.state_[key]) {
          _this.listeners_[key].fire(_this.state_[key]);
        }
      });
    }
    /**
     * Retrieves the default state, that could be overriden by an embed mode.
     * @return {!State}
     * @private
     */

  }, {
    key: "getDefaultState_",
    value: function getDefaultState_() {
      var _ref;

      // Compiler won't resolve the object keys and trigger an error for missing
      // properties, so we have to force the type.
      return _ref = {}, _ref[StateProperty.CAN_INSERT_AUTOMATIC_AD] = true, _ref[StateProperty.CAN_SHOW_BOOKEND] = true, _ref[StateProperty.CAN_SHOW_AUDIO_UI] = true, _ref[StateProperty.CAN_SHOW_NAVIGATION_OVERLAY_HINT] = true, _ref[StateProperty.CAN_SHOW_PREVIOUS_PAGE_HELP] = true, _ref[StateProperty.CAN_SHOW_PAGINATION_BUTTONS] = true, _ref[StateProperty.CAN_SHOW_SHARING_UIS] = true, _ref[StateProperty.CAN_SHOW_SYSTEM_LAYER_BUTTONS] = true, _ref[StateProperty.ACCESS_STATE] = false, _ref[StateProperty.AD_STATE] = false, _ref[StateProperty.AFFILIATE_LINK_STATE] = null, _ref[StateProperty.BOOKEND_STATE] = false, _ref[StateProperty.DESKTOP_STATE] = false, _ref[StateProperty.EDUCATION_STATE] = false, _ref[StateProperty.HAS_SIDEBAR_STATE] = false, _ref[StateProperty.INFO_DIALOG_STATE] = false, _ref[StateProperty.INTERACTIVE_COMPONENT_STATE] = {
        state: EmbeddedComponentState.HIDDEN
      }, _ref[StateProperty.INTERACTIVE_REACT_STATE] = {}, _ref[StateProperty.MUTED_STATE] = true, _ref[StateProperty.PAGE_ATTACHMENT_STATE] = false, _ref[StateProperty.PAGE_HAS_AUDIO_STATE] = false, _ref[StateProperty.PAGE_HAS_ELEMENTS_WITH_PLAYBACK_STATE] = false, _ref[StateProperty.PAUSED_STATE] = false, _ref[StateProperty.RTL_STATE] = false, _ref[StateProperty.SHARE_MENU_STATE] = false, _ref[StateProperty.SIDEBAR_STATE] = false, _ref[StateProperty.SUPPORTED_BROWSER_STATE] = true, _ref[StateProperty.STORY_HAS_AUDIO_STATE] = false, _ref[StateProperty.STORY_HAS_BACKGROUND_AUDIO_STATE] = false, _ref[StateProperty.STORY_HAS_PLAYBACK_UI_STATE] = false, _ref[StateProperty.SYSTEM_UI_IS_VISIBLE_STATE] = true, _ref[StateProperty.UI_STATE] = UIType.MOBILE, _ref[StateProperty.VIEWPORT_WARNING_STATE] = false, _ref[StateProperty.ACTIONS_ALLOWLIST] = [], _ref[StateProperty.CONSENT_ID] = null, _ref[StateProperty.CURRENT_PAGE_ID] = '', _ref[StateProperty.CURRENT_PAGE_INDEX] = 0, _ref[StateProperty.ADVANCEMENT_MODE] = '', _ref[StateProperty.NEW_PAGE_AVAILABLE_ID] = '', _ref[StateProperty.NAVIGATION_PATH] = [], _ref[StateProperty.PAGE_IDS] = [], _ref[StateProperty.PAGE_SIZE] = null, _ref[StateProperty.PREVIEW_STATE] = false, _ref;
    } // @TODO(gmajoulet): These should get their own file if they start growing.

    /**
     * Retrieves the embed mode config, that will override the default state.
     * @return {!Object<StateProperty, *>} Partial state
     * @protected
     */

  }, {
    key: "getEmbedOverrides_",
    value: function getEmbedOverrides_() {
      var _ref2, _ref3, _ref4, _ref5;

      var embedMode = (0, _embedMode.parseEmbedMode)(this.win_.location.hash);

      switch (embedMode) {
        case _embedMode.EmbedMode.NAME_TBD:
          return _ref2 = {}, _ref2[StateProperty.CAN_INSERT_AUTOMATIC_AD] = false, _ref2[StateProperty.CAN_SHOW_BOOKEND] = false, _ref2[StateProperty.CAN_SHOW_NAVIGATION_OVERLAY_HINT] = false, _ref2[StateProperty.CAN_SHOW_PAGINATION_BUTTONS] = false, _ref2[StateProperty.CAN_SHOW_PREVIOUS_PAGE_HELP] = true, _ref2[StateProperty.CAN_SHOW_SYSTEM_LAYER_BUTTONS] = false, _ref2[StateProperty.MUTED_STATE] = false, _ref2;

        case _embedMode.EmbedMode.NO_SHARING:
          return _ref3 = {}, _ref3[StateProperty.CAN_SHOW_SHARING_UIS] = false, _ref3;

        case _embedMode.EmbedMode.PREVIEW:
          return _ref4 = {}, _ref4[StateProperty.PREVIEW_STATE] = true, _ref4[StateProperty.CAN_INSERT_AUTOMATIC_AD] = false, _ref4[StateProperty.CAN_SHOW_BOOKEND] = false, _ref4[StateProperty.CAN_SHOW_NAVIGATION_OVERLAY_HINT] = false, _ref4[StateProperty.CAN_SHOW_PAGINATION_BUTTONS] = false, _ref4[StateProperty.CAN_SHOW_PREVIOUS_PAGE_HELP] = false, _ref4[StateProperty.CAN_SHOW_SYSTEM_LAYER_BUTTONS] = false, _ref4;

        case _embedMode.EmbedMode.NO_SHARING_NOR_AUDIO_UI:
          return _ref5 = {}, _ref5[StateProperty.CAN_SHOW_AUDIO_UI] = false, _ref5[StateProperty.CAN_SHOW_SHARING_UIS] = false, _ref5;

        default:
          return {};
      }
    }
  }]);

  return AmpStoryStoreService;
}();

exports.AmpStoryStoreService = AmpStoryStoreService;

},{"../../../src/json":120,"../../../src/log":123,"../../../src/observable":126,"../../../src/service":130,"../../../src/services":133,"../../../src/utils/object":149,"./embed-mode":75}],54:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.SystemLayer = void 0;

var _ampStoryStoreService = require("./amp-story-store-service");

var _ampStorySystemLayer = require("../../../build/amp-story-system-layer-1.0.css");

var _developmentUi = require("./development-ui");

var _localizedStrings = require("../../../src/localized-strings");

var _progressBar = require("./progress-bar");

var _services = require("../../../src/services");

var _utils = require("./utils");

var _log = require("../../../src/log");

var _object = require("../../../src/utils/object");

var _mode = require("../../../src/mode");

var _dom = require("../../../src/dom");

var _simpleTemplate = require("./simple-template");

var _types = require("../../../src/types");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @private @const {string} */
var AD_SHOWING_ATTRIBUTE = 'ad-showing';

/** @private @const {string} */
var AUDIO_MUTED_ATTRIBUTE = 'muted';

/** @private @const {string} */
var PAUSED_ATTRIBUTE = 'paused';

/** @private @const {string} */
var HAS_INFO_BUTTON_ATTRIBUTE = 'info';

/** @private @const {string} */
var MUTE_CLASS = 'i-amphtml-story-mute-audio-control';

/** @private @const {string} */
var UNMUTE_CLASS = 'i-amphtml-story-unmute-audio-control';

/** @private @const {string} */
var PAUSE_CLASS = 'i-amphtml-story-pause-control';

/** @private @const {string} */
var PLAY_CLASS = 'i-amphtml-story-play-control';

/** @private @const {string} */
var MESSAGE_DISPLAY_CLASS = 'i-amphtml-story-messagedisplay';

/** @private @const {string} */
var CURRENT_PAGE_HAS_AUDIO_ATTRIBUTE = 'i-amphtml-current-page-has-audio';

/** @private @const {string} */
var HAS_SIDEBAR_ATTRIBUTE = 'i-amphtml-story-has-sidebar';

/** @private @const {string} */
var SHARE_CLASS = 'i-amphtml-story-share-control';

/** @private @const {string} */
var INFO_CLASS = 'i-amphtml-story-info-control';

/** @private @const {string} */
var SIDEBAR_CLASS = 'i-amphtml-story-sidebar-control';

/** @private @const {string} */
var HAS_NEW_PAGE_ATTRIBUTE = 'i-amphtml-story-has-new-page';

/** @private @const {number} */
var HIDE_MESSAGE_TIMEOUT_MS = 1500;

/** @private @const {!./simple-template.ElementDef} */
var TEMPLATE = {
  tag: 'aside',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-system-layer i-amphtml-story-system-reset'
  }),
  children: [{
    tag: 'div',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-has-new-page-notification-container'
    }),
    children: [{
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-has-new-page-text-wrapper'
      }),
      children: [{
        tag: 'span',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-has-new-page-circle-icon'
        })
      }, {
        tag: 'div',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-has-new-page-text'
        }),
        localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_HAS_NEW_PAGE_TEXT
      }]
    }]
  }, {
    tag: 'div',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-system-layer-buttons'
    }),
    children: [{
      tag: 'div',
      attrs: (0, _object.dict)({
        'role': 'button',
        'class': INFO_CLASS + ' i-amphtml-story-button'
      }),
      localizedLabelId: _localizedStrings.LocalizedStringId.AMP_STORY_INFO_BUTTON_LABEL
    }, {
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-sound-display'
      }),
      children: [{
        tag: 'div',
        attrs: (0, _object.dict)({
          'role': 'alert',
          'class': 'i-amphtml-message-container'
        }),
        children: [{
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-mute-text'
          }),
          localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_TEXT
        }, {
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-unmute-sound-text'
          }),
          localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT
        }, {
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-unmute-no-sound-text'
          }),
          localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT
        }]
      }, {
        tag: 'button',
        attrs: (0, _object.dict)({
          'class': UNMUTE_CLASS + ' i-amphtml-story-button'
        }),
        localizedLabelId: _localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_UNMUTE_BUTTON_LABEL
      }, {
        tag: 'button',
        attrs: (0, _object.dict)({
          'class': MUTE_CLASS + ' i-amphtml-story-button'
        }),
        localizedLabelId: _localizedStrings.LocalizedStringId.AMP_STORY_AUDIO_MUTE_BUTTON_LABEL
      }]
    }, {
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-paused-display'
      }),
      children: [{
        tag: 'button',
        attrs: (0, _object.dict)({
          'class': PAUSE_CLASS + ' i-amphtml-story-button'
        })
      }, {
        tag: 'button',
        attrs: (0, _object.dict)({
          'class': PLAY_CLASS + ' i-amphtml-story-button'
        })
      }]
    }, {
      tag: 'a',
      attrs: (0, _object.dict)({
        'role': 'button',
        'class': SHARE_CLASS + ' i-amphtml-story-button'
      }),
      localizedLabelId: _localizedStrings.LocalizedStringId.AMP_STORY_SHARE_BUTTON_LABEL
    }, {
      tag: 'button',
      attrs: (0, _object.dict)({
        'class': SIDEBAR_CLASS + ' i-amphtml-story-button'
      }),
      localizedLabelId: _localizedStrings.LocalizedStringId.AMP_STORY_SIDEBAR_BUTTON_LABEL
    }]
  }]
};

/**
 * System Layer (i.e. UI Chrome) for <amp-story>.
 * Chrome contains:
 *   - mute/unmute button
 *   - story progress bar
 *   - bookend close button
 *   - share button
 *   - domain info button
 *   - sidebar
 *   - story updated label (for live stories)
 */
var SystemLayer = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} parentEl
   */
  function SystemLayer(win, parentEl) {
    _classCallCheck(this, SystemLayer);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @protected @const {!Element} */
    this.parentEl_ = parentEl;

    /** @private {boolean} */
    this.isBuilt_ = false;

    /**
     * Root element containing a shadow DOM root.
     * @private {?Element}
     */
    this.root_ = null;

    /**
     * Actual system layer.
     * @private {?Element}
     */
    this.systemLayerEl_ = null;

    /** @private {?Element} */
    this.buttonsContainer_ = null;

    /** @private @const {!ProgressBar} */
    this.progressBar_ = _progressBar.ProgressBar.create(win, this.parentEl_);

    /** @private {!DevelopmentModeLog} */
    this.developerLog_ = _developmentUi.DevelopmentModeLog.create(win);

    /** @private {!DevelopmentModeLogButtonSet} */
    this.developerButtons_ = _developmentUi.DevelopmentModeLogButtonSet.create(win);

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.win_);

    /** @const @private {!../../../src/service/vsync-impl.Vsync} */
    this.vsync_ = _services.Services.vsyncFor(this.win_);

    /** @const @private {!../../../src/service/timer-impl.Timer} */
    this.timer_ = _services.Services.timerFor(this.win_);

    /** @private {?number|?string} */
    this.timeoutId_ = null;
  }

  /**
   * @return {!Element}
   * @param {string} initialPageId
   */
  _createClass(SystemLayer, [{
    key: "build",
    value: function build(initialPageId) {
      var _this = this;

      if (this.isBuilt_) {
        return this.getRoot();
      }

      this.isBuilt_ = true;
      this.root_ = this.win_.document.createElement('div');
      this.root_.classList.add('i-amphtml-system-layer-host');
      this.systemLayerEl_ = (0, _simpleTemplate.renderAsElement)(this.win_.document, TEMPLATE);
      // Make the share button link to the current document to make sure
      // embedded STAMPs always have a back-link to themselves, and to make
      // gestures like right-clicks work.
      this.systemLayerEl_.querySelector('.i-amphtml-story-share-control').href = _services.Services.documentInfoForDoc(this.parentEl_).canonicalUrl;
      (0, _utils.createShadowRootWithStyle)(this.root_, this.systemLayerEl_, _ampStorySystemLayer.CSS);
      this.systemLayerEl_.insertBefore(this.progressBar_.build(initialPageId), this.systemLayerEl_.firstChild);
      this.buttonsContainer_ = this.systemLayerEl_.querySelector('.i-amphtml-story-system-layer-buttons');
      this.buildForDevelopmentMode_();
      this.initializeListeners_();
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CAN_SHOW_SYSTEM_LAYER_BUTTONS, function (canShowButtons) {
        _this.systemLayerEl_.classList.toggle('i-amphtml-story-ui-no-buttons', !canShowButtons);
      }, true
      /* callToInitialize */
      );

      if (_services.Services.platformFor(this.win_).isIos()) {
        this.systemLayerEl_.setAttribute('ios', '');
      }

      var viewer = _services.Services.viewerForDoc(this.win_.document.documentElement);

      if ((0, _utils.shouldShowStoryUrlInfo)(viewer)) {
        this.systemLayerEl_.classList.add('i-amphtml-embedded');
        this.getShadowRoot().setAttribute(HAS_INFO_BUTTON_ATTRIBUTE, '');
      } else {
        this.getShadowRoot().removeAttribute(HAS_INFO_BUTTON_ATTRIBUTE);
      }

      this.getShadowRoot().setAttribute(MESSAGE_DISPLAY_CLASS, 'noshow');
      this.getShadowRoot().setAttribute(HAS_NEW_PAGE_ATTRIBUTE, 'noshow');
      return this.getRoot();
    }
    /**
     * @private
     */

  }, {
    key: "buildForDevelopmentMode_",
    value: function buildForDevelopmentMode_() {
      if (!(0, _mode.getMode)().development) {
        return;
      }

      this.buttonsContainer_.appendChild(this.developerButtons_.build(this.developerLog_.toggle.bind(this.developerLog_)));
      this.getShadowRoot().appendChild(this.developerLog_.build());
    }
    /**
     * @private
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this2 = this;

      // TODO(alanorozco): Listen to tap event properly (i.e. fastclick)
      this.getShadowRoot().addEventListener('click', function (event) {
        var target = (0, _log.dev)().assertElement(event.target);

        if ((0, _dom.matches)(target, "." + MUTE_CLASS + ", ." + MUTE_CLASS + " *")) {
          _this2.onAudioIconClick_(true);
        } else if ((0, _dom.matches)(target, "." + UNMUTE_CLASS + ", ." + UNMUTE_CLASS + " *")) {
          _this2.onAudioIconClick_(false);
        } else if ((0, _dom.matches)(target, "." + PAUSE_CLASS + ", ." + PAUSE_CLASS + " *")) {
          _this2.onPausedClick_(true);
        } else if ((0, _dom.matches)(target, "." + PLAY_CLASS + ", ." + PLAY_CLASS + " *")) {
          _this2.onPausedClick_(false);
        } else if ((0, _dom.matches)(target, "." + SHARE_CLASS + ", ." + SHARE_CLASS + " *")) {
          _this2.onShareClick_(event);
        } else if ((0, _dom.matches)(target, "." + INFO_CLASS + ", ." + INFO_CLASS + " *")) {
          _this2.onInfoClick_();
        } else if ((0, _dom.matches)(target, "." + SIDEBAR_CLASS + ", ." + SIDEBAR_CLASS + " *")) {
          _this2.onSidebarClick_();
        }
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.AD_STATE, function (isAd) {
        _this2.onAdStateUpdate_(isAd);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.BOOKEND_STATE, function (isActive) {
        _this2.onBookendStateUpdate_(isActive);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CAN_SHOW_AUDIO_UI, function (show) {
        _this2.onCanShowAudioUiUpdate_(show);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CAN_SHOW_SHARING_UIS, function (show) {
        _this2.onCanShowSharingUisUpdate_(show);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.STORY_HAS_AUDIO_STATE, function (hasAudio) {
        _this2.onStoryHasAudioStateUpdate_(hasAudio);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.STORY_HAS_PLAYBACK_UI_STATE, function (hasPlaybackUi) {
        _this2.onStoryHasPlaybackUiStateUpdate_(hasPlaybackUi);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.MUTED_STATE, function (isMuted) {
        _this2.onMutedStateUpdate_(isMuted);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.UI_STATE, function (uiState) {
        _this2.onUIStateUpdate_(uiState);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.PAUSED_STATE, function (isPaused) {
        _this2.onPausedStateUpdate_(isPaused);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CURRENT_PAGE_INDEX, function (index) {
        _this2.onPageIndexUpdate_(index);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.RTL_STATE, function (rtlState) {
        _this2.onRtlStateUpdate_(rtlState);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.PAGE_HAS_AUDIO_STATE, function (audio) {
        _this2.onPageHasAudioStateUpdate_(audio);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.PAGE_HAS_ELEMENTS_WITH_PLAYBACK_STATE, function (hasPlaybackUi) {
        _this2.onPageHasElementsWithPlaybackStateUpdate_(hasPlaybackUi);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.HAS_SIDEBAR_STATE, function (hasSidebar) {
        _this2.onHasSidebarStateUpdate_(hasSidebar);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.SYSTEM_UI_IS_VISIBLE_STATE, function (isVisible) {
        _this2.onSystemUiIsVisibleStateUpdate_(isVisible);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.NEW_PAGE_AVAILABLE_ID, function () {
        _this2.onNewPageAvailable_();
      });
    }
    /**
     * @return {!Element}
     */

  }, {
    key: "getRoot",
    value: function getRoot() {
      return (0, _log.dev)().assertElement(this.root_);
    }
    /**
     * @return {!Element}
     */

  }, {
    key: "getShadowRoot",
    value: function getShadowRoot() {
      return (0, _log.dev)().assertElement(this.systemLayerEl_);
    }
    /**
     * Reacts to the ad state updates and updates the UI accordingly.
     * @param {boolean} isAd
     * @private
     */

  }, {
    key: "onAdStateUpdate_",
    value: function onAdStateUpdate_(isAd) {
      // This is not in vsync as we are showing/hiding items in the system layer
      // based upon this attribute, and when wrapped in vsync there is a visual
      // lag after the page change before the icons are updated.
      isAd ? this.getShadowRoot().setAttribute(AD_SHOWING_ATTRIBUTE, '') : this.getShadowRoot().removeAttribute(AD_SHOWING_ATTRIBUTE);
    }
    /**
     * Reacts to the bookend state updates and updates the UI accordingly.
     * @param {boolean} isActive
     * @private
     */

  }, {
    key: "onBookendStateUpdate_",
    value: function onBookendStateUpdate_(isActive) {
      this.getShadowRoot().classList.toggle('i-amphtml-story-bookend-active', isActive);
    }
    /**
     * Checks if the story has a sidebar in order to display the icon representing
     * the opening of the sidebar.
     * @param {boolean} hasSidebar
     * @private
     */

  }, {
    key: "onHasSidebarStateUpdate_",
    value: function onHasSidebarStateUpdate_(hasSidebar) {
      if (hasSidebar) {
        this.getShadowRoot().setAttribute(HAS_SIDEBAR_ATTRIBUTE, '');
      } else {
        this.getShadowRoot().removeAttribute(HAS_SIDEBAR_ATTRIBUTE);
      }
    }
    /**
     * Reacts to updates to whether audio UI may be shown, and updates the UI
     * accordingly.
     * @param {boolean} canShowAudioUi
     * @private
     */

  }, {
    key: "onCanShowAudioUiUpdate_",
    value: function onCanShowAudioUiUpdate_(canShowAudioUi) {
      var _this3 = this;

      this.vsync_.mutate(function () {
        _this3.getShadowRoot().classList.toggle('i-amphtml-story-no-audio-ui', !canShowAudioUi);
      });
    }
    /**
     * Reacts to updates to whether sharing UIs may be shown, and updates the UI
     * accordingly.
     * @param {boolean} canShowSharingUis
     * @private
     */

  }, {
    key: "onCanShowSharingUisUpdate_",
    value: function onCanShowSharingUisUpdate_(canShowSharingUis) {
      var _this4 = this;

      this.vsync_.mutate(function () {
        _this4.getShadowRoot().classList.toggle('i-amphtml-story-no-sharing', !canShowSharingUis);
      });
    }
    /**
     * Reacts to has audio state updates, determining if the story has a global
     * audio track playing, or if any page has audio.
     * @param {boolean} hasAudio
     * @private
     */

  }, {
    key: "onStoryHasAudioStateUpdate_",
    value: function onStoryHasAudioStateUpdate_(hasAudio) {
      var _this5 = this;

      this.vsync_.mutate(function () {
        _this5.getShadowRoot().classList.toggle('i-amphtml-story-has-audio', hasAudio);
      });
    }
    /**
     * Reacts to story having elements with playback.
     * @param {boolean} hasPlaybackUi
     * @private
     */

  }, {
    key: "onStoryHasPlaybackUiStateUpdate_",
    value: function onStoryHasPlaybackUiStateUpdate_(hasPlaybackUi) {
      var _this6 = this;

      this.vsync_.mutate(function () {
        _this6.getShadowRoot().classList.toggle('i-amphtml-story-has-playback-ui', hasPlaybackUi);
      });
    }
    /**
     * Reacts to the presence of audio on a page to determine which audio messages
     * to display.
     * @param {boolean} pageHasAudio
     * @private
     */

  }, {
    key: "onPageHasAudioStateUpdate_",
    value: function onPageHasAudioStateUpdate_(pageHasAudio) {
      var _this7 = this;

      pageHasAudio = pageHasAudio || !!this.storeService_.get(_ampStoryStoreService.StateProperty.STORY_HAS_BACKGROUND_AUDIO_STATE);
      this.vsync_.mutate(function () {
        pageHasAudio ? _this7.getShadowRoot().setAttribute(CURRENT_PAGE_HAS_AUDIO_ATTRIBUTE, '') : _this7.getShadowRoot().removeAttribute(CURRENT_PAGE_HAS_AUDIO_ATTRIBUTE);
      });
    }
    /**
     * Reacts to the presence of elements with playback on the page.
     * @param {boolean} pageHasElementsWithPlayback
     * @private
     */

  }, {
    key: "onPageHasElementsWithPlaybackStateUpdate_",
    value: function onPageHasElementsWithPlaybackStateUpdate_(pageHasElementsWithPlayback) {
      var _this8 = this;

      this.vsync_.mutate(function () {
        (0, _types.toArray)(_this8.getShadowRoot().querySelectorAll('.i-amphtml-paused-display button')).forEach(function (button) {
          button.disabled = !pageHasElementsWithPlayback;
        });
      });
    }
    /**
     * Reacts to muted state updates.
     * @param {boolean} isMuted
     * @private
     */

  }, {
    key: "onMutedStateUpdate_",
    value: function onMutedStateUpdate_(isMuted) {
      var _this9 = this;

      this.vsync_.mutate(function () {
        isMuted ? _this9.getShadowRoot().setAttribute(AUDIO_MUTED_ATTRIBUTE, '') : _this9.getShadowRoot().removeAttribute(AUDIO_MUTED_ATTRIBUTE);
      });
    }
    /**
     * Reacts to paused state updates.
     * @param {boolean} isPaused
     * @private
     */

  }, {
    key: "onPausedStateUpdate_",
    value: function onPausedStateUpdate_(isPaused) {
      var _this10 = this;

      this.vsync_.mutate(function () {
        isPaused ? _this10.getShadowRoot().setAttribute(PAUSED_ATTRIBUTE, '') : _this10.getShadowRoot().removeAttribute(PAUSED_ATTRIBUTE);
      });
    }
    /**
     * Hides message after elapsed time.
     * @param {string} message
     * @private
     */

  }, {
    key: "hideMessageAfterTimeout_",
    value: function hideMessageAfterTimeout_(message) {
      var _this11 = this;

      if (this.timeoutId_) {
        this.timer_.cancel(this.timeoutId_);
      }

      this.timeoutId_ = this.timer_.delay(function () {
        return _this11.hideMessageInternal_(message);
      }, HIDE_MESSAGE_TIMEOUT_MS);
    }
    /**
     * Hides message.
     * @param {string} message
     * @private
     */

  }, {
    key: "hideMessageInternal_",
    value: function hideMessageInternal_(message) {
      var _this12 = this;

      if (!this.isBuilt_) {
        return;
      }

      this.vsync_.mutate(function () {
        _this12.getShadowRoot().setAttribute(message, 'noshow');
      });
    }
    /**
     * Reacts to UI state updates and triggers the expected UI.
     * @param {!UIType} uiState
     * @private
     */

  }, {
    key: "onUIStateUpdate_",
    value: function onUIStateUpdate_(uiState) {
      var _this13 = this;

      this.vsync_.mutate(function () {
        var shadowRoot = _this13.getShadowRoot();

        shadowRoot.classList.remove('i-amphtml-story-desktop-fullbleed');
        shadowRoot.classList.remove('i-amphtml-story-desktop-panels');

        switch (uiState) {
          case _ampStoryStoreService.UIType.DESKTOP_PANELS:
            shadowRoot.classList.add('i-amphtml-story-desktop-panels');
            break;

          case _ampStoryStoreService.UIType.DESKTOP_FULLBLEED:
            shadowRoot.classList.add('i-amphtml-story-desktop-fullbleed');
            break;
        }
      });
    }
    /**
     * Reacts to system UI visibility state updates.
     * @param {boolean} isVisible
     * @private
     */

  }, {
    key: "onSystemUiIsVisibleStateUpdate_",
    value: function onSystemUiIsVisibleStateUpdate_(isVisible) {
      var _this14 = this;

      this.vsync_.mutate(function () {
        _this14.getShadowRoot().classList.toggle('i-amphtml-story-hidden', !isVisible);
      });
    }
    /**
     * Reacts to the active page index changing.
     * @param {number} index
     */

  }, {
    key: "onPageIndexUpdate_",
    value: function onPageIndexUpdate_(index) {
      var _this15 = this;

      this.vsync_.mutate(function () {
        var lastIndex = _this15.storeService_.get(_ampStoryStoreService.StateProperty.PAGE_IDS).length - 1;

        _this15.getShadowRoot().classList.toggle('i-amphtml-first-page-active', index === 0);

        _this15.getShadowRoot().classList.toggle('i-amphtml-last-page-active', index === lastIndex);
      });
    }
    /**
     * Reacts to RTL state updates and triggers the UI for RTL.
     * @param {boolean} rtlState
     * @private
     */

  }, {
    key: "onRtlStateUpdate_",
    value: function onRtlStateUpdate_(rtlState) {
      var _this16 = this;

      this.vsync_.mutate(function () {
        rtlState ? _this16.getShadowRoot().setAttribute('dir', 'rtl') : _this16.getShadowRoot().removeAttribute('dir');
      });
    }
    /**
     * Handles click events on the mute and unmute buttons.
     * @param {boolean} mute Specifies if the audio is being muted or unmuted.
     * @private
     */

  }, {
    key: "onAudioIconClick_",
    value: function onAudioIconClick_(mute) {
      var _this17 = this;

      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_MUTED, mute);
      this.vsync_.mutate(function () {
        _this17.getShadowRoot().setAttribute(MESSAGE_DISPLAY_CLASS, 'show');

        _this17.hideMessageAfterTimeout_(MESSAGE_DISPLAY_CLASS);
      });
    }
    /**
     * Handles click events on the paused and play buttons.
     * @param {boolean} paused Specifies if the story is being paused or not.
     * @private
     */

  }, {
    key: "onPausedClick_",
    value: function onPausedClick_(paused) {
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, paused);
    }
    /**
     * Handles click events on the share button and toggles the share menu.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onShareClick_",
    value: function onShareClick_(event) {
      event.preventDefault();
      var isOpen = this.storeService_.get(_ampStoryStoreService.StateProperty.SHARE_MENU_STATE);
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SHARE_MENU, !isOpen);
    }
    /**
     * Handles click events on the info button and toggles the info dialog.
     * @private
     */

  }, {
    key: "onInfoClick_",
    value: function onInfoClick_() {
      var isOpen = this.storeService_.get(_ampStoryStoreService.StateProperty.INFO_DIALOG_STATE);
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_INFO_DIALOG, !isOpen);
    }
    /**
     * Handles click events on the sidebar button and toggles the sidebar.
     * @private
     */

  }, {
    key: "onSidebarClick_",
    value: function onSidebarClick_() {
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SIDEBAR, true);
    }
    /**
     * Shows the "story updated" label when a new page was added to the story.
     * @private
     */

  }, {
    key: "onNewPageAvailable_",
    value: function onNewPageAvailable_() {
      var _this18 = this;

      this.vsync_.mutate(function () {
        _this18.getShadowRoot().setAttribute(HAS_NEW_PAGE_ATTRIBUTE, 'show');

        _this18.hideMessageAfterTimeout_(HAS_NEW_PAGE_ATTRIBUTE);
      });
    }
    /**
     * @param {string} pageId The id of the page whose progress should be
     *     changed.
     * @param {number} progress A number from 0.0 to 1.0, representing the
     *     progress of the current page.
     * @public
     */

  }, {
    key: "updateProgress",
    value: function updateProgress(pageId, progress) {
      // TODO(newmuis) avoid passing progress logic through system-layer
      this.progressBar_.updateProgress(pageId, progress);
    }
    /**
     * @param {!./logging.AmpStoryLogEntryDef} logEntry
     * @private
     */

  }, {
    key: "logInternal_",
    value: function logInternal_(logEntry) {
      this.developerButtons_.log(logEntry);
      this.developerLog_.log(logEntry);
    }
    /**
     * Logs an array of entries to the developer logs.
     * @param {!Array<!./logging.AmpStoryLogEntryDef>} logEntries
     */

  }, {
    key: "logAll",
    value: function logAll(logEntries) {
      var _this19 = this;

      if (!(0, _mode.getMode)().development) {
        return;
      }

      this.vsync_.mutate(function () {
        logEntries.forEach(function (logEntry) {
          return _this19.logInternal_(logEntry);
        });
      });
    }
    /**
     * Logs a single entry to the developer logs.
     * @param {!./logging.AmpStoryLogEntryDef} logEntry
     */

  }, {
    key: "log",
    value: function log(logEntry) {
      if (!(0, _mode.getMode)().development) {
        return;
      }

      this.logInternal_(logEntry);
    }
    /**
     * Clears any state held by the developer log or buttons.
     */

  }, {
    key: "resetDeveloperLogs",
    value: function resetDeveloperLogs() {
      if (!(0, _mode.getMode)().development) {
        return;
      }

      this.developerButtons_.clear();
      this.developerLog_.clear();
    }
    /**
     * Sets the string providing context for the developer logs window.  This is
     * often the name or ID of the element that all logs are for (e.g. the page).
     * @param {string} contextString
     */

  }, {
    key: "setDeveloperLogContextString",
    value: function setDeveloperLogContextString(contextString) {
      if (!(0, _mode.getMode)().development) {
        return;
      }

      this.developerLog_.setContextString(contextString);
    }
    /**
     * Hides the developer log in the UI.
     */

  }, {
    key: "hideDeveloperLog",
    value: function hideDeveloperLog() {
      if (!(0, _mode.getMode)().development) {
        return;
      }

      this.developerLog_.hide();
    }
  }]);

  return SystemLayer;
}();

exports.SystemLayer = SystemLayer;

},{"../../../build/amp-story-system-layer-1.0.css":8,"../../../src/dom":106,"../../../src/localized-strings":122,"../../../src/log":123,"../../../src/mode":124,"../../../src/services":133,"../../../src/types":139,"../../../src/utils/object":149,"./amp-story-store-service":53,"./development-ui":74,"./progress-bar":87,"./simple-template":89,"./utils":93}],55:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.UnsupportedBrowserLayer = void 0;

var _ampStoryStoreService = require("./amp-story-store-service");

var _ampStoryUnsupportedBrowserLayer = require("../../../build/amp-story-unsupported-browser-layer-1.0.css");

var _localizedStrings = require("../../../src/localized-strings");

var _utils = require("./utils");

var _object = require("./../../../src/utils/object");

var _dom = require("../../../src/dom");

var _simpleTemplate = require("./simple-template");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {string} Class for the continue anyway button */
var CONTINUE_ANYWAY_BUTTON_CLASS = 'i-amphtml-continue-button';

/**
 * Full viewport black layer indicating browser is not supported.
 * @private @const {!./simple-template.ElementDef}
 */
var UNSUPPORTED_BROWSER_LAYER_TEMPLATE = {
  tag: 'div',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-unsupported-browser-overlay'
  }),
  children: [{
    tag: 'div',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-overlay-container'
    }),
    children: [{
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-gear-icon'
      })
    }, {
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-overlay-text'
      }),
      localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT
    }, // The continue button functionality will only be present in the default
    // layer. Publisher provided fallbacks will not provide users with the
    // ability to continue with an unsupported browser
    {
      tag: 'button',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-continue-button'
      }),
      localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL
    }]
  }]
};

/**
 * Unsupported browser layer UI.
 */
var UnsupportedBrowserLayer = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function UnsupportedBrowserLayer(win) {
    _classCallCheck(this, UnsupportedBrowserLayer);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {?Element} */
    this.root_ = null;

    /** @private {?Element} */
    this.element_ = null;

    /** @private {?Element} */
    this.continueButton_ = null;

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.win_);
  }

  /**
   * Builds and appends the component in the story.
   * @return {*} TODO(#23582): Specify return type
   */
  _createClass(UnsupportedBrowserLayer, [{
    key: "build",
    value: function build() {
      var _this = this;

      if (this.root_) {
        return this.root_;
      }

      this.root_ = this.win_.document.createElement('div');
      this.element_ = (0, _simpleTemplate.renderAsElement)(this.win_.document, UNSUPPORTED_BROWSER_LAYER_TEMPLATE);
      (0, _utils.createShadowRootWithStyle)(this.root_, this.element_, _ampStoryUnsupportedBrowserLayer.CSS);
      this.continueButton_ = this.element_.
      /*OK*/
      querySelector("." + CONTINUE_ANYWAY_BUTTON_CLASS);
      this.continueButton_.addEventListener('click', function () {
        _this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SUPPORTED_BROWSER, true);
      });
      return this.root_;
    }
    /**
     * Returns the unsupported browser componenet
     * @return {?Element} The root element of the componenet
     */

  }, {
    key: "get",
    value: function get() {
      if (!this.root_) {
        this.build();
      }

      return this.root_;
    }
    /**
     * Removes the entire layer
     */

  }, {
    key: "removeLayer",
    value: function removeLayer() {
      if (this.root_) {
        (0, _dom.removeElement)(this.root_);
      }
    }
  }]);

  return UnsupportedBrowserLayer;
}();

exports.UnsupportedBrowserLayer = UnsupportedBrowserLayer;

},{"../../../build/amp-story-unsupported-browser-layer-1.0.css":10,"../../../src/dom":106,"../../../src/localized-strings":122,"./../../../src/utils/object":149,"./amp-story-store-service":53,"./simple-template":89,"./utils":93}],56:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryViewerMessagingHandler = void 0;

var _ampStoryStoreService = require("./amp-story-store-service");

var _variableService = require("./variable-service");

var _log = require("../../../src/log");

var _object = require("../../../src/utils/object");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @type {string} */
var TAG = 'amp-story-viewer-messaging-handler';

/** @enum {number} */
var DataSources = {
  STORE_SERVICE: 0,
  VARIABLE_SERVICE: 2
};

/**
 * @typedef {{
 *   dataSource: !DataSources,
 *   property: (!StateProperty|!AnalyticsVariable)
 * }}
 */
var GetStateConfigurationDef;

/** @enum {!GetStateConfigurationDef} */
var GET_STATE_CONFIGURATIONS = {
  'CURRENT_PAGE_ID': {
    dataSource: DataSources.STORE_SERVICE,
    property: _ampStoryStoreService.StateProperty.CURRENT_PAGE_ID
  },
  'EDUCATION_STATE': {
    dataSource: DataSources.STORE_SERVICE,
    property: _ampStoryStoreService.StateProperty.EDUCATION_STATE
  },
  'MUTED_STATE': {
    dataSource: DataSources.STORE_SERVICE,
    property: _ampStoryStoreService.StateProperty.MUTED_STATE
  },
  'PAGE_ATTACHMENT_STATE': {
    dataSource: DataSources.STORE_SERVICE,
    property: _ampStoryStoreService.StateProperty.PAGE_ATTACHMENT_STATE
  },
  'STORY_PROGRESS': {
    dataSource: DataSources.VARIABLE_SERVICE,
    property: _variableService.AnalyticsVariable.STORY_PROGRESS
  }
};

/** @typedef {{action: !Action, isValueValid: function(*):boolean}} */
var SetStateConfigurationDef;

/** @enum {!SetStateConfigurationDef} */
var SET_STATE_CONFIGURATIONS = {
  'MUTED_STATE': {
    action: _ampStoryStoreService.Action.TOGGLE_MUTED,
    isValueValid: function isValueValid(value) {
      return typeof value === 'boolean';
    }
  }
};

/**
 * Viewer messaging handler.
 */
var AmpStoryViewerMessagingHandler = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!../../../src/service/viewer-interface.ViewerInterface} viewer
   */
  function AmpStoryViewerMessagingHandler(win, viewer) {
    _classCallCheck(this, AmpStoryViewerMessagingHandler);

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(win);

    /** @private @const {!./variable-service.AmpStoryVariableService} */
    this.variableService_ = (0, _variableService.getVariableService)(win);

    /** @private @const {!../../../src/service/viewer-interface.ViewerInterface} */
    this.viewer_ = viewer;
  }

  /**
   * @public
   */
  _createClass(AmpStoryViewerMessagingHandler, [{
    key: "startListening",
    value: function startListening() {
      var _this = this;

      this.viewer_.onMessageRespond('getDocumentState', function (data) {
        return _this.onGetDocumentState_(data);
      });
      this.viewer_.onMessage('onDocumentState', function (data) {
        return _this.onOnDocumentState_(data);
      });
      this.viewer_.onMessageRespond('setDocumentState', function (data) {
        return _this.onSetDocumentState_(data);
      });
    }
    /**
     * @param {string} eventType
     * @param {?JsonObject|string|undefined} data
     * @param {boolean=} cancelUnsent
     */

  }, {
    key: "send",
    value: function send(eventType, data, cancelUnsent) {
      if (cancelUnsent === void 0) {
        cancelUnsent = false;
      }

      this.viewer_.sendMessage(eventType, data, cancelUnsent);
    }
    /**
     * Handles 'getDocumentState' viewer messages.
     * @param {!Object=} data
     * @return {!Promise}
     * @private
     */

  }, {
    key: "onGetDocumentState_",
    value: function onGetDocumentState_(data) {
      if (data === void 0) {
        data = {};
      }

      var _data = data,
          state = _data.state;
      var config = GET_STATE_CONFIGURATIONS[state];

      if (!config) {
        return Promise.reject("Invalid 'state' parameter");
      }

      var value;

      switch (config.dataSource) {
        case DataSources.STORE_SERVICE:
          value = this.storeService_.get(config.property);
          break;

        case DataSources.VARIABLE_SERVICE:
          value = this.variableService_.get()[config.property];
          break;

        default:
          (0, _log.dev)().error(TAG, 'Unknown data source %s.', config.dataSource);
          break;
      }

      return Promise.resolve({
        state: state,
        value: value
      });
    }
    /**
     * Handles 'onDocumentState' viewer messages.
     * @param {!Object=} data
     * @private
     */

  }, {
    key: "onOnDocumentState_",
    value: function onOnDocumentState_(data) {
      var _this2 = this;

      if (data === void 0) {
        data = {};
      }

      var _data2 = data,
          state = _data2.state;
      var config = GET_STATE_CONFIGURATIONS[state];

      if (!config) {
        (0, _log.user)().error(TAG, "Invalid 'state' parameter");
        return;
      }

      this.storeService_.subscribe(config.property, function (value) {
        _this2.viewer_.sendMessage('documentStateUpdate', (0, _object.dict)({
          'state': state,
          'value': value
        }));
      });
    }
    /**
     * Handles 'setDocumentState' viewer messages.
     * @param {!Object=} data
     * @return {!Promise<!Object|undefined>}
     * @private
     */

  }, {
    key: "onSetDocumentState_",
    value: function onSetDocumentState_(data) {
      if (data === void 0) {
        data = {};
      }

      var _data3 = data,
          state = _data3.state,
          value = _data3.value;
      var config = SET_STATE_CONFIGURATIONS[state];

      if (!config) {
        return Promise.reject("Invalid 'state' parameter");
      }

      if (!config.isValueValid(value)) {
        return Promise.reject("Invalid 'value' parameter");
      }

      this.storeService_.dispatch(config.action, value);
      return Promise.resolve({
        state: state,
        value: value
      });
    }
  }]);

  return AmpStoryViewerMessagingHandler;
}();

exports.AmpStoryViewerMessagingHandler = AmpStoryViewerMessagingHandler;

},{"../../../src/log":123,"../../../src/utils/object":149,"./amp-story-store-service":53,"./variable-service":94}],57:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.ViewportWarningLayer = void 0;

var _ampStoryViewportWarningLayer = require("../../../build/amp-story-viewport-warning-layer-1.0.css");

var _localizedStrings = require("../../../src/localized-strings");

var _services = require("../../../src/services");

var _ampStoryStoreService = require("./amp-story-store-service");

var _utils = require("./utils");

var _ampStoryLocalizationService = require("./amp-story-localization-service");

var _staticTemplate = require("../../../src/static-template");

var _eventHelper = require("../../../src/event-helper");

var _rateLimit = require("../../../src/utils/rate-limit");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    <div class=\"\n        i-amphtml-story-no-rotation-overlay i-amphtml-story-system-reset\">\n      <div class=\"i-amphtml-overlay-container\">\n        <div class=\"i-amphtml-story-overlay-icon\"></div>\n        <div class=\"i-amphtml-story-overlay-text\"></div>\n      </div>\n    </div>\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/**
 * CSS class indicating the format is landscape.
 * @const {string}
 */
var LANDSCAPE_OVERLAY_CLASS = 'i-amphtml-story-landscape';

/** @const {number} */
var RESIZE_THROTTLE_MS = 300;

/**
 * Viewport warning layer template.
 * @param {!Element} element
 * @return {!Element}
 */
var getTemplate = function getTemplate(element) {
  return (0, _staticTemplate.htmlFor)(element)(_templateObject());
};

/**
 * Viewport warning layer UI.
 */
var ViewportWarningLayer = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} storyElement Element where to append the component
   * @param {number} desktopWidthThreshold Threshold in px.
   * @param {number} desktopHeightThreshold Threshold in px.
   */
  function ViewportWarningLayer(win, storyElement, desktopWidthThreshold, desktopHeightThreshold) {
    _classCallCheck(this, ViewportWarningLayer);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {number} */
    this.desktopHeightThreshold_ = desktopHeightThreshold;

    /** @private {number} */
    this.desktopWidthThreshold_ = desktopWidthThreshold;

    /** @private {boolean} */
    this.isBuilt_ = false;

    /** @private {?../../../src/service/localization.LocalizationService} */
    this.localizationService_ = null;

    /** @private {?Element} */
    this.overlayEl_ = null;

    /** @private @const {!../../../src/service/platform-impl.Platform} */
    this.platform_ = _services.Services.platformFor(this.win_);

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.win_);

    /** @private @const {!Element} */
    this.storyElement_ = storyElement;

    /** @private {?Function} */
    this.unlistenResizeEvents_ = null;

    /** @const @private {!../../../src/service/vsync-impl.Vsync} */
    this.vsync_ = _services.Services.vsyncFor(this.win_);
    this.initializeListeners_();
  }

  /**
   * Builds and appends the component in the story.
   */
  _createClass(ViewportWarningLayer, [{
    key: "build",
    value: function build() {
      var _this = this;

      if (this.isBuilt()) {
        return;
      }

      this.overlayEl_ = this.getViewportWarningOverlayTemplate_();
      this.localizationService_ = (0, _ampStoryLocalizationService.getLocalizationService)(this.storyElement_);
      this.isBuilt_ = true;
      var root = this.win_.document.createElement('div');
      (0, _utils.createShadowRootWithStyle)(root, this.overlayEl_, _ampStoryViewportWarningLayer.CSS);
      // Initializes the UI state now that the component is built.
      this.onUIStateUpdate_(
      /** @type {!UIType} */
      this.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE));
      this.vsync_.mutate(function () {
        _this.storyElement_.insertBefore(root, _this.storyElement_.firstChild);
      });
    }
    /**
     * Whether the element has been built.
     * @return {boolean}
     */

  }, {
    key: "isBuilt",
    value: function isBuilt() {
      return this.isBuilt_;
    }
    /**
     * @private
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this2 = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.UI_STATE, function (uiState) {
        _this2.onUIStateUpdate_(uiState);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.VIEWPORT_WARNING_STATE, function (viewportWarningState) {
        _this2.onViewportWarningStateUpdate_(viewportWarningState);
      }, true
      /** callToInitialize */
      );
    }
    /**
     * Reacts to the viewport warning state update, only on mobile.
     * @param {boolean} viewportWarningState
     * @private
     */

  }, {
    key: "onViewportWarningStateUpdate_",
    value: function onViewportWarningStateUpdate_(viewportWarningState) {
      var _this3 = this;

      var isMobile = this.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) === _ampStoryStoreService.UIType.MOBILE;

      // Adds the landscape class if we are mobile landscape.
      var shouldShowLandscapeOverlay = isMobile && viewportWarningState;

      // Don't build the layer until we need to display it.
      if (!shouldShowLandscapeOverlay && !this.isBuilt()) {
        return;
      }

      this.build();

      // Listen to resize events to update the UI message.
      if (viewportWarningState) {
        var resizeThrottle = (0, _rateLimit.throttle)(this.win_, function () {
          return _this3.onResize_();
        }, RESIZE_THROTTLE_MS);
        this.unlistenResizeEvents_ = (0, _eventHelper.listen)(this.win_, 'resize', resizeThrottle);
      } else if (this.unlistenResizeEvents_) {
        this.unlistenResizeEvents_();
        this.unlistenResizeEvents_ = null;
      }

      this.updateTextContent_();
      this.vsync_.mutate(function () {
        _this3.overlayEl_.classList.toggle(LANDSCAPE_OVERLAY_CLASS, shouldShowLandscapeOverlay);
      });
    }
    /**
     * Reacts to UI state updates.
     * @param {!UIType} uiState
     * @private
     */

  }, {
    key: "onUIStateUpdate_",
    value: function onUIStateUpdate_(uiState) {
      var _this4 = this;

      if (!this.isBuilt()) {
        return;
      }

      this.vsync_.mutate(function () {
        uiState === _ampStoryStoreService.UIType.DESKTOP_PANELS ? _this4.overlayEl_.setAttribute('desktop', '') : _this4.overlayEl_.removeAttribute('desktop');
      });
    }
    /**
     * @private
     */

  }, {
    key: "onResize_",
    value: function onResize_() {
      this.updateTextContent_();
    }
    /**
     * Returns the overlay corresponding to the device currently used.
     * @return {!Element} template
     * @private
     */

  }, {
    key: "getViewportWarningOverlayTemplate_",
    value: function getViewportWarningOverlayTemplate_() {
      var template = getTemplate(this.storyElement_);
      var iconEl = template.querySelector('.i-amphtml-story-overlay-icon');

      if (this.platform_.isIos() || this.platform_.isAndroid()) {
        iconEl.classList.add('i-amphtml-rotate-icon');
        return template;
      }

      iconEl.classList.add('i-amphtml-desktop-size-icon');
      return template;
    }
    /**
     * Updates the UI message displayed to the user.
     * @private
     */

  }, {
    key: "updateTextContent_",
    value: function updateTextContent_() {
      var _this5 = this;

      var textEl = this.overlayEl_.querySelector('.i-amphtml-story-overlay-text');
      var textContent;
      this.vsync_.run({
        measure: function measure() {
          textContent = _this5.getTextContent_();
        },
        mutate: function mutate() {
          if (!textContent) {
            return;
          }

          textEl.textContent = textContent;
        }
      });
    }
    /**
     * Gets the localized message to display, depending on the viewport size. Has
     * to run during a measure phase.
     * @return {?string}
     * @private
     */

  }, {
    key: "getTextContent_",
    value: function getTextContent_() {
      if (this.platform_.isIos() || this.platform_.isAndroid()) {
        return this.localizationService_.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT);
      }

      var viewportHeight = this.win_.
      /*OK*/
      innerHeight;
      var viewportWidth = this.win_.
      /*OK*/
      innerWidth;

      if (viewportHeight < this.desktopHeightThreshold_ && viewportWidth < this.desktopWidthThreshold_) {
        return this.localizationService_.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_SIZE_TEXT);
      }

      if (viewportWidth < this.desktopWidthThreshold_) {
        return this.localizationService_.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT);
      }

      if (viewportHeight < this.desktopHeightThreshold_) {
        return this.localizationService_.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT);
      }

      return null;
    }
  }]);

  return ViewportWarningLayer;
}();

exports.ViewportWarningLayer = ViewportWarningLayer;

},{"../../../build/amp-story-viewport-warning-layer-1.0.css":11,"../../../src/event-helper":111,"../../../src/localized-strings":122,"../../../src/services":133,"../../../src/static-template":135,"../../../src/utils/rate-limit":151,"./amp-story-localization-service":45,"./amp-story-store-service":53,"./utils":93}],58:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStory = void 0;

var _resolvedPromise6 = require("./../../../src/resolved-promise");

var _ampStoryCtaLayer = require("./amp-story-cta-layer");

var _ampStoryGridLayer = require("./amp-story-grid-layer");

var _ampStoryPage = require("./amp-story-page");

var _ampStoryStoreService = require("./amp-story-store-service");

var _actionConstants = require("../../../src/action-constants");

var _pageAdvancement = require("./page-advancement");

var _storyAnalytics = require("./story-analytics");

var _ampEvents = require("../../../src/amp-events");

var _ampStoryAccess = require("./amp-story-access");

var _ampStoryBookend = require("./bookend/amp-story-bookend");

var _ampStoryConsent = require("./amp-story-consent");

var _ampStoryEmbeddedComponent = require("./amp-story-embedded-component");

var _ampStoryHint = require("./amp-story-hint");

var _ampStoryPageAttachment = require("./amp-story-page-attachment");

var _ampStoryRenderService = require("./amp-story-render-service");

var _ampStoryViewerMessagingHandler = require("./amp-story-viewer-messaging-handler");

var _variableService = require("./variable-service");

var _ampStory = require("../../../build/amp-story-1.0.css");

var _commonSignals = require("../../../src/common-signals");

var _events = require("./events");

var _gesture = require("../../../src/gesture");

var _history = require("./history");

var _ampStoryInfoDialog = require("./amp-story-info-dialog");

var _keyCodes = require("../../../src/utils/key-codes");

var _layout = require("../../../src/layout");

var _liveStoryManager = require("./live-story-manager");

var _localizedStrings = require("../../../src/localized-strings");

var _mediaPool = require("./media-pool");

var _paginationButtons = require("./pagination-buttons");

var _services = require("../../../src/services");

var _ampStoryShareMenu = require("./amp-story-share-menu");

var _gestureRecognizers = require("../../../src/gesture-recognizers");

var _ampStorySystemLayer = require("./amp-story-system-layer");

var _ampStoryUnsupportedBrowserLayer = require("./amp-story-unsupported-browser-layer");

var _ampStoryViewportWarningLayer = require("./amp-story-viewport-warning-layer");

var _dom = require("../../../src/dom");

var _style = require("../../../src/style");

var _rateLimit = require("../../../src/utils/rate-limit");

var _log = require("../../../src/log");

var _object = require("../../../src/utils/object");

var _string = require("../../../src/string");

var _css = require("../../../src/css");

var _array = require("../../../src/utils/array");

var _consent = require("../../../src/consent");

var _eventHelper = require("../../../src/event-helper");

var _ampStoryLocalizationService = require("./amp-story-localization-service");

var _ampStoryMediaQueryService = require("./amp-story-media-query-service");

var _mode = require("../../../src/mode");

var _history2 = require("../../../src/history");

var _experiments = require("../../../src/experiments");

var _url = require("../../../src/url");

var _utils = require("./utils");

var _types = require("../../../src/types");

var _audio = require("./audio");

var _ar = _interopRequireDefault(require("./_locales/ar"));

var _de = _interopRequireDefault(require("./_locales/de"));

var _default = _interopRequireDefault(require("./_locales/default"));

var _en = _interopRequireDefault(require("./_locales/en"));

var _enGB = _interopRequireDefault(require("./_locales/en-GB"));

var _es = _interopRequireDefault(require("./_locales/es"));

var _es2 = _interopRequireDefault(require("./_locales/es-419"));

var _fr = _interopRequireDefault(require("./_locales/fr"));

var _hi = _interopRequireDefault(require("./_locales/hi"));

var _id = _interopRequireDefault(require("./_locales/id"));

var _it = _interopRequireDefault(require("./_locales/it"));

var _ja = _interopRequireDefault(require("./_locales/ja"));

var _ko = _interopRequireDefault(require("./_locales/ko"));

var _nl = _interopRequireDefault(require("./_locales/nl"));

var _no = _interopRequireDefault(require("./_locales/no"));

var _ptBR = _interopRequireDefault(require("./_locales/pt-BR"));

var _ptPT = _interopRequireDefault(require("./_locales/pt-PT"));

var _ru = _interopRequireDefault(require("./_locales/ru"));

var _tr = _interopRequireDefault(require("./_locales/tr"));

var _vi = _interopRequireDefault(require("./_locales/vi"));

var _zhCN = _interopRequireDefault(require("./_locales/zh-CN"));

var _zhTW = _interopRequireDefault(require("./_locales/zh-TW"));

var _MAX_MEDIA_ELEMENT_CO;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/** @private @const {number} */
var DESKTOP_WIDTH_THRESHOLD = 1024;

/** @private @const {number} */
var DESKTOP_HEIGHT_THRESHOLD = 550;

/** @private @const {number} */
var MIN_SWIPE_FOR_HINT_OVERLAY_PX = 50;

/** @enum {string} */
var Attributes = {
  AD_SHOWING: 'ad-showing',
  ADVANCE_TO: 'i-amphtml-advance-to',
  AUTO_ADVANCE_AFTER: 'auto-advance-after',
  AUTO_ADVANCE_TO: 'auto-advance-to',
  DESKTOP_POSITION: 'i-amphtml-desktop-position',
  MUTED: 'muted',
  ORIENTATION: 'orientation',
  PUBLIC_ADVANCE_TO: 'advance-to',
  RETURN_TO: 'i-amphtml-return-to',
  STANDALONE: 'standalone',
  SUPPORTS_LANDSCAPE: 'supports-landscape',
  // Attributes that desktop css looks for to decide where pages will be placed
  VISITED: 'i-amphtml-visited' // stacked offscreen to left

};

/**
 * The duration of time (in milliseconds) to wait for a page to be loaded,
 * before the story becomes visible.
 * @const {number}
 */
var PAGE_LOAD_TIMEOUT_MS = 5000;

/**
 * Single page ads may be injected later. If the original story contains 0 media
 * elements the mediaPool will not be able to handle the injected audio/video
 * Therefore we preallocate a minimum here.
 * @const {number}
 */
var MINIMUM_AD_MEDIA_ELEMENTS = 2;

/**
 * CSS class for an amp-story that indicates the initial load for the story has
 * completed.
 * @const {string}
 */
var STORY_LOADED_CLASS_NAME = 'i-amphtml-story-loaded';

/**
 * CSS class for the opacity layer that separates the amp-sidebar and the rest
 * of the story when the amp-sidebar is entering the screen.
 * @const {string}
 */
var OPACITY_MASK_CLASS_NAME = 'i-amphtml-story-opacity-mask';

/**
 * CSS class for sidebars in stories.
 * @const {string}
 */
var SIDEBAR_CLASS_NAME = 'i-amphtml-story-sidebar';

/** @const {!Object<string, number>} */
var MAX_MEDIA_ELEMENT_COUNTS = (_MAX_MEDIA_ELEMENT_CO = {}, _MAX_MEDIA_ELEMENT_CO[_mediaPool.MediaType.AUDIO] = 4, _MAX_MEDIA_ELEMENT_CO[_mediaPool.MediaType.VIDEO] = 8, _MAX_MEDIA_ELEMENT_CO);

/** @type {string} */
var TAG = 'amp-story';

/**
 * Selector for elements that should be hidden when the bookend is open on
 * desktop view.
 * @private @const {string}
 */
var HIDE_ON_BOOKEND_SELECTOR = 'amp-story-page, .i-amphtml-story-system-layer';

/**
 * The default dark gray for chrome supported theme color.
 * @const {string}
 */
var DEFAULT_THEME_COLOR = '#202125';

/**
 * MutationObserverInit options to listen for changes to the `open` attribute.
 */
var SIDEBAR_OBSERVER_OPTIONS = {
  attributes: true,
  attributeFilter: ['open']
};

/**
 * @implements {./media-pool.MediaPoolRoot}
 */
var AmpStory = /*#__PURE__*/function (_AMP$BaseElement) {
  _inherits(AmpStory, _AMP$BaseElement);

  var _super = _createSuper(AmpStory);

  /** @param {!AmpElement} element */
  function AmpStory(element) {
    var _this;

    _classCallCheck(this, AmpStory);

    _this = _super.call(this, element);

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    _this.storeService_ = (0, _ampStoryStoreService.getStoreService)(_this.win);

    // Check if story is RTL.
    if ((0, _dom.isRTL)(_this.win.document)) {
      _this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_RTL, true);
    }

    /** @private {!./story-analytics.StoryAnalyticsService} */
    _this.analyticsService_ = (0, _storyAnalytics.getAnalyticsService)(_this.win, _this.element);

    /** @private @const {!AdvancementConfig} */
    _this.advancement_ = _pageAdvancement.AdvancementConfig.forElement(_this.win, _this.element);

    _this.advancement_.start();

    /** @const @private {!../../../src/service/vsync-impl.Vsync} */
    _this.vsync_ = _this.getVsync();

    /** @private {?AmpStoryBookend} */
    _this.bookend_ = null;

    /** @private @const {!ShareMenu} Preloads and prerenders the share menu. */
    _this.shareMenu_ = new _ampStoryShareMenu.ShareMenu(_this.win, _this.element);

    /** @private @const {!SystemLayer} */
    _this.systemLayer_ = new _ampStorySystemLayer.SystemLayer(_this.win, _this.element);

    /** Instantiate in case there are embedded components. */
    new _ampStoryEmbeddedComponent.AmpStoryEmbeddedComponent(_this.win, _this.element);

    /** @private @const {!UnsupportedBrowserLayer} */
    _this.unsupportedBrowserLayer_ = new _ampStoryUnsupportedBrowserLayer.UnsupportedBrowserLayer(_this.win);

    /** Instantiates the viewport warning layer. */
    new _ampStoryViewportWarningLayer.ViewportWarningLayer(_this.win, _this.element, DESKTOP_WIDTH_THRESHOLD, DESKTOP_HEIGHT_THRESHOLD);

    /** @private {!Array<!./amp-story-page.AmpStoryPage>} */
    _this.pages_ = [];

    /** @private @const {!Array<!./amp-story-page.AmpStoryPage>} */
    _this.adPages_ = [];

    /** @const @private {!./variable-service.AmpStoryVariableService} */
    _this.variableService_ = (0, _variableService.getVariableService)(_this.win);

    /** @private {?./amp-story-page.AmpStoryPage} */
    _this.activePage_ = null;

    /** @private @const */
    _this.desktopMedia_ = _this.win.matchMedia("(min-width: " + DESKTOP_WIDTH_THRESHOLD + "px) and " + ("(min-height: " + DESKTOP_HEIGHT_THRESHOLD + "px)"));

    /** @private @const */
    _this.canRotateToDesktopMedia_ = _this.win.matchMedia("(min-width: " + DESKTOP_HEIGHT_THRESHOLD + "px) and " + ("(min-height: " + DESKTOP_WIDTH_THRESHOLD + "px)"));

    /** @private @const */
    _this.landscapeOrientationMedia_ = _this.win.matchMedia('(orientation: landscape)');

    /** @private {?HTMLMediaElement} */
    _this.backgroundAudioEl_ = null;

    /** @private {?./pagination-buttons.PaginationButtons} */
    _this.paginationButtons_ = null;

    /** @private {!AmpStoryHint} */
    _this.ampStoryHint_ = new _ampStoryHint.AmpStoryHint(_this.win, _this.element);

    /** @private {!MediaPool} */
    _this.mediaPool_ = _mediaPool.MediaPool.for(_assertThisInitialized(_this));

    /** @private {boolean} */
    _this.areAccessAuthorizationsCompleted_ = false;

    /** @private */
    _this.navigateToPageAfterAccess_ = null;

    /** @private @const {!../../../src/service/timer-impl.Timer} */
    _this.timer_ = _services.Services.timerFor(_this.win);

    /** @private @const {!../../../src/service/platform-impl.Platform} */
    _this.platform_ = _services.Services.platformFor(_this.win);

    /** @private @const {!../../../src/service/viewer-interface.ViewerInterface} */
    _this.viewer_ = _services.Services.viewerForDoc(_this.element);

    /** @private @const {?AmpStoryViewerMessagingHandler} */
    _this.viewerMessagingHandler_ = _this.viewer_.isEmbedded() ? new _ampStoryViewerMessagingHandler.AmpStoryViewerMessagingHandler(_this.win, _this.viewer_) : null;

    /**
     * Store the current paused state, to make sure the story does not play on
     * resume if it was previously paused.
     * @private {boolean}
     */
    _this.pausedStateToRestore_ = false;

    /** @private {?Element} */
    _this.sidebar_ = null;

    /** @private {?MutationObserver} */
    _this.sidebarObserver_ = null;

    /** @private {?Element} */
    _this.maskElement_ = null;

    /** @private {?LiveStoryManager} */
    _this.liveStoryManager_ = null;

    /** @private @const {!../../../src/service/localization.LocalizationService} */
    _this.localizationService_ = (0, _ampStoryLocalizationService.getLocalizationService)(_this.element);

    _this.localizationService_.registerLocalizedStringBundle('default', _default.default).registerLocalizedStringBundle('ar', _ar.default).registerLocalizedStringBundle('de', _de.default).registerLocalizedStringBundle('en', _en.default).registerLocalizedStringBundle('en-GB', _enGB.default).registerLocalizedStringBundle('es', _es.default).registerLocalizedStringBundle('es-419', _es2.default).registerLocalizedStringBundle('fr', _fr.default).registerLocalizedStringBundle('hi', _hi.default).registerLocalizedStringBundle('id', _id.default).registerLocalizedStringBundle('it', _it.default).registerLocalizedStringBundle('ja', _ja.default).registerLocalizedStringBundle('ko', _ko.default).registerLocalizedStringBundle('nl', _nl.default).registerLocalizedStringBundle('no', _no.default).registerLocalizedStringBundle('pt-PT', _ptPT.default).registerLocalizedStringBundle('pt-BR', _ptBR.default).registerLocalizedStringBundle('ru', _ru.default).registerLocalizedStringBundle('tr', _tr.default).registerLocalizedStringBundle('vi', _vi.default).registerLocalizedStringBundle('zh-CN', _zhCN.default).registerLocalizedStringBundle('zh-TW', _zhTW.default);

    var enXaPseudoLocaleBundle = (0, _localizedStrings.createPseudoLocale)(_en.default, function (s) {
      return "[" + s + " one two]";
    });

    _this.localizationService_.registerLocalizedStringBundle('en-xa', enXaPseudoLocaleBundle);

    return _this;
  }

  /** @override */
  _createClass(AmpStory, [{
    key: "buildCallback",
    value: function buildCallback() {
      var _this2 = this;

      if (this.isStandalone_()) {
        this.initializeStandaloneStory_();
      }

      // buildCallback already runs in a mutate context. Calling another
      // mutateElement explicitly will force the runtime to remeasure the
      // amp-story element, fixing rendering bugs where the story is inactive
      // (layoutCallback not called) when accessed from any viewer using
      // prerendering, because of a height incorrectly set to 0.
      this.mutateElement(function () {});
      var pageEl = this.element.querySelector('amp-story-page');
      pageEl && pageEl.setAttribute('active', '');
      this.initializeStyles_();
      this.initializeListeners_();
      this.initializeListenersForDev_();
      this.initializePageIds_();
      this.initializeStoryPlayer_();
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_UI, this.getUIType_());

      // Disables the bookend entirely if the story is within a group of stories.
      if (this.viewer_.hasCapability('swipe')) {
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_CAN_SHOW_BOOKEND, false);
      }

      // Removes title in order to prevent incorrect titles appearing on link
      // hover. (See 17654)
      if (!this.platform_.isBot()) {
        this.element.removeAttribute('title');
      }

      // Remove text nodes which would be shown outside of the amp-story
      var textNodes = (0, _dom.childNodes)(this.element, function (node) {
        return node.nodeType === Node.TEXT_NODE;
      });
      textNodes.forEach(function (node) {
        _this2.element.removeChild(node);
      });

      if ((0, _experiments.isExperimentOn)(this.win, 'amp-story-branching')) {
        this.registerAction('goToPage', function (invocation) {
          var args = invocation.args;

          if (!args) {
            return;
          }

          _this2.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.GO_TO_PAGE);

          // If open, closes the sidebar before navigating.
          var promise = _this2.storeService_.get(_ampStoryStoreService.StateProperty.SIDEBAR_STATE) ? _services.Services.historyForDoc(_this2.getAmpDoc()).goBack() : (0, _resolvedPromise6.resolvedPromise)();
          promise.then(function () {
            return _this2.switchTo_(args['id'], _ampStoryPage.NavigationDirection.NEXT);
          });
        });
      }
    }
    /**
     * Pauses the whole story on viewer visibilityState updates, or tab visibility
     * updates.
     * @private
     */

  }, {
    key: "pause_",
    value: function pause_() {
      this.pausedStateToRestore_ = !!this.storeService_.get(_ampStoryStoreService.StateProperty.PAUSED_STATE);
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, true);

      if (!this.storeService_.get(_ampStoryStoreService.StateProperty.MUTED_STATE)) {
        this.pauseBackgroundAudio_();
      }
    }
    /**
     * Resumes the whole story on viewer visibilityState updates, or tab
     * visibility updates.
     * @private
     */

  }, {
    key: "resume_",
    value: function resume_() {
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, this.pausedStateToRestore_);

      if (!this.storeService_.get(_ampStoryStoreService.StateProperty.MUTED_STATE)) {
        this.playBackgroundAudio_();
      }
    }
    /**
     * Note: runs in the buildCallback vsync mutate context.
     * @private
     */

  }, {
    key: "initializeStandaloneStory_",
    value: function initializeStandaloneStory_() {
      var html = this.win.document.documentElement;
      html.classList.add('i-amphtml-story-standalone');
      // Lock body to prevent overflow.
      this.lockBody_();
      // Standalone CSS affects sizing of the entire page.
      this.onResize();
    }
    /** @private */

  }, {
    key: "initializeStyles_",
    value: function initializeStyles_() {
      var mediaQueryEls = this.element.querySelectorAll('media-query');

      if (mediaQueryEls.length) {
        this.initializeMediaQueries_(mediaQueryEls);
      }

      var styleEl = this.win.document.querySelector('style[amp-custom]');

      if (styleEl) {
        this.rewriteStyles_(styleEl);
      }
    }
    /**
     * Registers the media queries
     * @param {!NodeList<!Element>} mediaQueryEls
     * @private
     */

  }, {
    key: "initializeMediaQueries_",
    value: function initializeMediaQueries_(mediaQueryEls) {
      var _this3 = this;

      var service = (0, _ampStoryMediaQueryService.getMediaQueryService)(this.win);

      var onMediaQueryMatch = function onMediaQueryMatch(matches, className) {
        _this3.mutateElement(function () {
          _this3.element.classList.toggle(className, matches);
        });
      };

      (0, _types.toArray)(mediaQueryEls).forEach(function (el) {
        var className = el.getAttribute('class-name');
        var media = el.getAttribute('media');

        if (className && media) {
          service.onMediaQueryMatch(media, function (matches) {
            return onMediaQueryMatch(matches, className);
          });
        }
      });
    }
    /**
     * Initializes page ids by deduplicating them.
     * @private
     */

  }, {
    key: "initializePageIds_",
    value: function initializePageIds_() {
      var pageEls = this.element.querySelectorAll('amp-story-page');
      var pageIds = (0, _types.toArray)(pageEls).map(function (el) {
        return el.id || 'default-page';
      });
      var idsMap = (0, _object.map)();

      for (var i = 0; i < pageIds.length; i++) {
        if (idsMap[pageIds[i]] === undefined) {
          idsMap[pageIds[i]] = 0;
          continue;
        }

        (0, _log.user)().error(TAG, "Duplicate amp-story-page ID " + pageIds[i]);
        var newId = pageIds[i] + "__" + ++idsMap[pageIds[i]];
        pageEls[i].id = newId;
        pageIds[i] = newId;
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_PAGE_IDS, pageIds);
    }
    /**
     * @param {!Element} styleEl
     * @private
     */

  }, {
    key: "rewriteStyles_",
    value: function rewriteStyles_(styleEl) {
      if (!(0, _experiments.isExperimentOn)(this.win, 'amp-story-responsive-units')) {
        return;
      }

      // TODO(#15955): Update this to use CssContext from
      // ../../../extensions/amp-animation/0.1/web-animations.js
      this.mutateElement(function () {
        styleEl.textContent = styleEl.textContent.replace(/(-?[\d.]+)vh/gim, 'calc($1 * var(--story-page-vh))').replace(/(-?[\d.]+)vw/gim, 'calc($1 * var(--story-page-vw))').replace(/(-?[\d.]+)vmin/gim, 'calc($1 * var(--story-page-vmin))').replace(/(-?[\d.]+)vmax/gim, 'calc($1 * var(--story-page-vmax))');
      });
    }
    /**
     * @private
     */

  }, {
    key: "setThemeColor_",
    value: function setThemeColor_() {
      // Don't override the publisher's tag.
      if (this.win.document.querySelector('meta[name=theme-color]')) {
        return;
      }

      // The theme color should be copied from the story's primary accent color
      // if possible, with the fall back being default dark gray.
      var meta = this.win.document.createElement('meta');
      var ampStoryPageEl = this.element.querySelector('amp-story-page');
      meta.name = 'theme-color';
      meta.content = (0, _style.computedStyle)(this.win, this.element).getPropertyValue('--primary-color') || (0, _style.computedStyle)(this.win, (0, _log.dev)().assertElement(ampStoryPageEl)).getPropertyValue('background-color') || DEFAULT_THEME_COLOR;
      this.win.document.head.appendChild(meta);
    }
    /**
     * Builds the system layer DOM.
     * @param {string} initialPageId
     * @private
     */

  }, {
    key: "buildSystemLayer_",
    value: function buildSystemLayer_(initialPageId) {
      this.updateAudioIcon_();
      this.updatePausedIcon_();
      this.element.appendChild(this.systemLayer_.build(initialPageId));
    }
    /** @private */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this4 = this;

      this.element.addEventListener(_events.EventType.NEXT_PAGE, function () {
        _this4.next_();
      });
      this.element.addEventListener(_events.EventType.PREVIOUS_PAGE, function () {
        _this4.previous_();
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.MUTED_STATE, function (isMuted) {
        _this4.onMutedStateUpdate_(isMuted);

        _this4.variableService_.onVariableUpdate(_variableService.AnalyticsVariable.STORY_IS_MUTED, isMuted);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.MUTED_STATE, function (isMuted) {
        // We do not want to trigger an analytics event for the initialization of
        // the muted state.
        _this4.analyticsService_.triggerEvent(isMuted ? _storyAnalytics.StoryAnalyticsEvent.STORY_MUTED : _storyAnalytics.StoryAnalyticsEvent.STORY_UNMUTED);
      }, false
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.SUPPORTED_BROWSER_STATE, function (isBrowserSupported) {
        _this4.onSupportedBrowserStateUpdate_(isBrowserSupported);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.ADVANCEMENT_MODE, function (mode) {
        _this4.variableService_.onVariableUpdate(_variableService.AnalyticsVariable.STORY_ADVANCEMENT_MODE, mode);
      });
      this.element.addEventListener(_events.EventType.SWITCH_PAGE, function (e) {
        if (_this4.storeService_.get(_ampStoryStoreService.StateProperty.BOOKEND_STATE)) {
          // Disallow switching pages while the bookend is active.
          return;
        }

        _this4.switchTo_((0, _eventHelper.getDetail)(e)['targetPageId'], (0, _eventHelper.getDetail)(e)['direction']);

        _this4.ampStoryHint_.hideAllNavigationHint();
      });
      this.element.addEventListener(_events.EventType.PAGE_PROGRESS, function (e) {
        var detail = (0, _eventHelper.getDetail)(e);
        var pageId = detail['pageId'];
        var progress = detail['progress'];

        if (pageId !== _this4.activePage_.element.id) {
          // Ignore progress update events from inactive pages.
          return;
        }

        if (!_this4.activePage_.isAd()) {
          _this4.systemLayer_.updateProgress(pageId, progress);
        }
      });
      this.element.addEventListener(_events.EventType.REPLAY, function () {
        _this4.replay_();
      });
      this.element.addEventListener(_events.EventType.NO_NEXT_PAGE, function () {
        _this4.onNoNextPage_();
      });
      this.element.addEventListener(_events.EventType.NO_PREVIOUS_PAGE, function () {
        _this4.onNoPreviousPage_();
      });
      this.advancement_.addOnTapNavigationListener(function (direction) {
        _this4.performTapNavigation_(direction);
      });
      this.element.addEventListener(_events.EventType.DISPATCH_ACTION, function (e) {
        if (!(0, _mode.getMode)().test) {
          return;
        }

        var action = (0, _eventHelper.getDetail)(e)['action'];
        var data = (0, _eventHelper.getDetail)(e)['data'];

        _this4.storeService_.dispatch(action, data);
      });
      // Actions allowlist could be initialized empty, or with some actions some
      // other components registered.
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.ACTIONS_ALLOWLIST, function (actionsAllowlist) {
        var actions = _services.Services.actionServiceForDoc(_this4.element);

        actions.setAllowlist(actionsAllowlist);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.AD_STATE, function (isAd) {
        _this4.onAdStateUpdate_(isAd);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.BOOKEND_STATE, function (isActive) {
        _this4.onBookendStateUpdate_(isActive);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.PAUSED_STATE, function (isPaused) {
        _this4.onPausedStateUpdate_(isPaused);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.SIDEBAR_STATE, function (sidebarState) {
        _this4.onSidebarStateUpdate_(sidebarState);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.UI_STATE, function (uiState) {
        _this4.onUIStateUpdate_(uiState);
      }, true
      /** callToInitialize */
      );
      this.win.document.addEventListener('keydown', function (e) {
        _this4.onKeyDown_(e);
      }, true);
      this.win.document.addEventListener('contextmenu', function (e) {
        var uiState = _this4.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE);

        if (uiState === _ampStoryStoreService.UIType.MOBILE) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
      this.getAmpDoc().onVisibilityChanged(function () {
        return _this4.onVisibilityChanged_();
      });
      this.win.addEventListener('hashchange', function () {
        var maybePageId = (0, _url.parseQueryString)(_this4.win.location.hash)['page'];

        if (!maybePageId || !_this4.isActualPage_(maybePageId)) {
          return;
        }

        _this4.switchTo_(maybePageId, _ampStoryPage.NavigationDirection.NEXT);

        // Removes the page 'hash' parameter from the URL.
        var href = _this4.win.location.href.replace(new RegExp("page=" + maybePageId + "&?"), '');

        if ((0, _string.endsWith)(href, '#')) {
          href = href.slice(0, -1);
        }

        _this4.win.history.replaceState(_this4.win.history && (0, _history2.getState)(_this4.win.history) || {}
        /** data */
        , _this4.win.document.title
        /** title */
        , href
        /** URL */
        );
      });
      this.getViewport().onResize((0, _rateLimit.debounce)(this.win, function () {
        return _this4.onResize();
      }, 300));
      this.installGestureRecognizers_();
      // TODO(gmajoulet): migrate this to amp-story-viewer-messaging-handler once
      // there is a way to navigate to pages that does not involve using private
      // amp-story methods.
      this.viewer_.onMessage('selectPage', function (data) {
        return _this4.onSelectPage_(data);
      });

      if (this.viewerMessagingHandler_) {
        this.viewerMessagingHandler_.startListening();
      }
    }
    /** @private */

  }, {
    key: "installGestureRecognizers_",
    value: function installGestureRecognizers_() {
      var _this5 = this;

      // If the story is within a viewer that enabled the swipe capability, this
      // disables the navigation education overlay to enable:
      //   - horizontal swipe events to the next story
      //   - vertical swipe events to close the viewer, or open a page attachment
      if (this.viewer_.hasCapability('swipe')) {
        return;
      }

      var element = this.element;

      var gestures = _gesture.Gestures.get(element,
      /* shouldNotPreventDefault */
      true);

      // Shows "tap to navigate" hint when swiping.
      gestures.onGesture(_gestureRecognizers.SwipeXYRecognizer, function (gesture) {
        var _gesture$data = gesture.data,
            deltaX = _gesture$data.deltaX,
            deltaY = _gesture$data.deltaY;

        var embedComponent =
        /** @type {InteractiveComponentDef} */
        _this5.storeService_.get(_ampStoryStoreService.StateProperty.INTERACTIVE_COMPONENT_STATE);

        // TODO(enriqe): Move to a separate file if this keeps growing.
        if (_this5.storeService_.get(_ampStoryStoreService.StateProperty.BOOKEND_STATE) || embedComponent.state !== _ampStoryStoreService.EmbeddedComponentState.HIDDEN || _this5.storeService_.get(_ampStoryStoreService.StateProperty.ACCESS_STATE) || _this5.storeService_.get(_ampStoryStoreService.StateProperty.SIDEBAR_STATE) || !_this5.storeService_.get(_ampStoryStoreService.StateProperty.SYSTEM_UI_IS_VISIBLE_STATE) || !_this5.storeService_.get(_ampStoryStoreService.StateProperty.CAN_SHOW_NAVIGATION_OVERLAY_HINT)) {
          // Cancels the event for this gesture entirely, ensuring the hint won't
          // show even if the user keeps swiping without releasing the touch.
          if (gesture.event && gesture.event.cancelable !== false) {
            gesture.event.preventDefault();
          }

          return;
        }

        if (gesture.event && gesture.event.defaultPrevented || !_this5.isSwipeLargeEnoughForHint_(deltaX, deltaY)) {
          return;
        }

        _this5.ampStoryHint_.showNavigationOverlay();
      });
    }
    /**
     * @param {number} deltaX
     * @param {number} deltaY
     * @return {boolean}
     * @private
     */

  }, {
    key: "isSwipeLargeEnoughForHint_",
    value: function isSwipeLargeEnoughForHint_(deltaX, deltaY) {
      var sideSwipe = Math.abs(deltaX) >= MIN_SWIPE_FOR_HINT_OVERLAY_PX;
      var upSwipe = -1 * deltaY >= MIN_SWIPE_FOR_HINT_OVERLAY_PX;
      return sideSwipe || upSwipe;
    }
    /** @private */

  }, {
    key: "initializeListenersForDev_",
    value: function initializeListenersForDev_() {
      var _this6 = this;

      if (!(0, _mode.getMode)().development) {
        return;
      }

      this.element.addEventListener(_events.EventType.DEV_LOG_ENTRIES_AVAILABLE, function (e) {
        _this6.systemLayer_.logAll(
        /** @type {?} */
        (0, _eventHelper.getDetail)(e));
      });
    }
    /** @private */

  }, {
    key: "lockBody_",
    value: function lockBody_() {
      var document = this.win.document;
      (0, _style.setImportantStyles)(document.documentElement, {
        'overflow': 'hidden'
      });
      (0, _style.setImportantStyles)(document.body, {
        'overflow': 'hidden'
      });
      this.getViewport().resetTouchZoom();
      this.getViewport().disableTouchZoom();
      this.maybeLockScreenOrientation_();
    }
    /** @private */

  }, {
    key: "maybeLockScreenOrientation_",
    value: function maybeLockScreenOrientation_() {
      var screen = this.win.screen;

      if (!screen || !this.canRotateToDesktopMedia_.matches) {
        return;
      }

      var lockOrientation = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation || function (unusedOrientation) {};

      try {
        lockOrientation('portrait');
      } catch (e) {
        (0, _log.dev)().warn(TAG, 'Failed to lock screen orientation:', e.message);
      }
    }
    /** @private */

  }, {
    key: "buildPaginationButtons_",
    value: function buildPaginationButtons_() {
      var _this7 = this;

      if (this.paginationButtons_ || !this.storeService_.get(_ampStoryStoreService.StateProperty.CAN_SHOW_PAGINATION_BUTTONS)) {
        return;
      }

      // TODO(#19768): Avoid passing a private function here.
      this.paginationButtons_ = _paginationButtons.PaginationButtons.create(this, function () {
        return _this7.hasBookend_();
      });
      this.paginationButtons_.attach(this.element);
    }
    /** @visibleForTesting */

  }, {
    key: "buildPaginationButtonsForTesting",
    value: function buildPaginationButtonsForTesting() {
      this.buildPaginationButtons_();
    }
    /** @override */

  }, {
    key: "layoutCallback",
    value: function layoutCallback() {
      if (!AmpStory.isBrowserSupported(this.win) && !this.platform_.isBot()) {
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SUPPORTED_BROWSER, false);
        return (0, _resolvedPromise6.resolvedPromise)();
      }

      return this.layoutStory_();
    }
    /**
     * Renders the layout for the story.
     * @return {!Promise} A promise that is resolved when the story layout is
     *       loaded
     * @private
     */

  }, {
    key: "layoutStory_",
    value: function layoutStory_() {
      var _this8 = this;

      var firstPageEl = (0, _log.user)().assertElement(this.element.querySelector('amp-story-page'), 'Story must have at least one page.');
      var initialPageId = this.getInitialPageId_(firstPageEl);
      this.buildSystemLayer_(initialPageId);
      this.initializeSidebar_();
      this.setThemeColor_();
      var storyLayoutPromise = Promise.all([this.getAmpDoc().whenFirstVisible(), // Pauses execution during prerender.
      this.initializePages_()]).then(function () {
        _this8.handleConsentExtension_();

        _this8.initializeStoryAccess_();

        _this8.pages_.forEach(function (page, index) {
          page.setState(_ampStoryPage.PageState.NOT_ACTIVE);

          _this8.upgradeCtaAnchorTagsForTracking_(page, index);
        });

        _this8.initializeStoryNavigationPath_();
      }).then(function () {
        return _this8.initializeBookend_();
      }).then(function () {
        var bookendInHistory = !!(0, _history.getHistoryState)(_this8.win, _history.HistoryState.BOOKEND_ACTIVE);

        if (bookendInHistory) {
          return _this8.hasBookend_().then(function (hasBookend) {
            if (hasBookend) {
              return _this8.showBookend_();
            }
          });
        }
      }).then(function () {
        return _this8.switchTo_(initialPageId, _ampStoryPage.NavigationDirection.NEXT);
      }).then(function () {
        var shouldReOpenAttachmentForPageId = (0, _history.getHistoryState)(_this8.win, _history.HistoryState.ATTACHMENT_PAGE_ID);

        if (shouldReOpenAttachmentForPageId === _this8.activePage_.element.id) {
          _this8.activePage_.openAttachment(false
          /** shouldAnimate */
          );
        }

        // Preloads and prerenders the share menu.
        _this8.shareMenu_.build();

        var infoDialog = (0, _utils.shouldShowStoryUrlInfo)(_this8.viewer_) ? new _ampStoryInfoDialog.InfoDialog(_this8.win, _this8.element) : null;

        if (infoDialog) {
          infoDialog.build();
        }
      });
      // Do not block the layout callback on the completion of these promises, as
      // that prevents descendents from being laid out (and therefore loaded).
      storyLayoutPromise.then(function () {
        return _this8.whenPagesLoaded_(PAGE_LOAD_TIMEOUT_MS);
      }).then(function () {
        _this8.markStoryAsLoaded_();

        _this8.initializeLiveStory_();
      });
      this.maybeLoadStoryEducation_();

      // Story is being prerendered: resolve the layoutCallback when the first
      // page is built. Other pages will only build if the document becomes
      // visible.
      if (!this.getAmpDoc().hasBeenVisible()) {
        return (0, _dom.whenUpgradedToCustomElement)(firstPageEl).then(function () {
          return firstPageEl.whenBuilt();
        });
      }

      this.buildScreenReaderBackButton_();
      // Will resolve when all pages are built.
      return storyLayoutPromise;
    }
    /**
     * Creates a focusable button for screen readers to navigate back.
     * @private
     */

  }, {
    key: "buildScreenReaderBackButton_",
    value: function buildScreenReaderBackButton_() {
      var _this9 = this;

      var backButton = document.createElement('button');
      var label = this.localizationService_.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_PAGINATION_BUTTON_PREVIOUS_PAGE_LABEL);
      backButton.classList.add('i-amphtml-story-screen-reader-back-button');
      label && backButton.setAttribute('aria-label', label);
      this.mutateElement(function () {
        _this9.element.appendChild(backButton);
      });
      // Append class to hide button if on first page.
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CURRENT_PAGE_INDEX, function (pageIndex) {
        return _this9.mutateElement(function () {
          return backButton.classList.toggle('i-amphtml-story-screen-reader-back-button-hidden', pageIndex === 0 && !_this9.viewer_.hasCapability('swipe'));
        });
      }, true
      /** callToInitialize */
      );
    }
    /**
     * Initialize LiveStoryManager if this is a live story.
     * @private
     */

  }, {
    key: "initializeLiveStory_",
    value: function initializeLiveStory_() {
      var _this10 = this;

      if (this.element.hasAttribute('live-story')) {
        this.liveStoryManager_ = new _liveStoryManager.LiveStoryManager(this);
        this.liveStoryManager_.build();
        this.storeService_.dispatch(_ampStoryStoreService.Action.ADD_TO_ACTIONS_ALLOWLIST, [{
          tagOrTarget: 'AMP-LIVE-LIST',
          method: 'update'
        }]);
        this.element.addEventListener(_ampEvents.AmpEvents.DOM_UPDATE, function () {
          _this10.liveStoryManager_.update();

          _this10.initializePages_().then(function () {
            _this10.preloadPagesByDistance_();

            if (_this10.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) === _ampStoryStoreService.UIType.DESKTOP_PANELS) {
              _this10.setDesktopPositionAttributes_(_this10.activePage_);
            }
          });
        });
      }
    }
    /**
     * Retrieves the initial pageId to begin the story with. In order, the
     * initial page for a story should be either a valid page ID in the URL
     * fragment, the page ID in the history, or the first page of the story.
     * @param {!Element} firstPageEl
     * @return {string}
     * @private
     */

  }, {
    key: "getInitialPageId_",
    value: function getInitialPageId_(firstPageEl) {
      var maybePageId = (0, _url.parseQueryString)(this.win.location.hash)['page'];

      if (maybePageId && this.isActualPage_(maybePageId)) {
        return maybePageId;
      }

      var pages =
      /**  @type {!Array} */
      (0, _history.getHistoryState)(this.win, _history.HistoryState.NAVIGATION_PATH) || [];
      var historyPage = (0, _array.lastItem)(pages);

      if (historyPage && this.isActualPage_(historyPage)) {
        return historyPage;
      }

      return firstPageEl.id;
    }
    /**
     * Checks if the amp-story-page for a given ID exists.
     * Note: the `this.pages_` array might not be defined yet.
     * @param {string} pageId
     * @return {boolean}
     * @private
     */

  }, {
    key: "isActualPage_",
    value: function isActualPage_(pageId) {
      // TODO(gmajoulet): check from the cached pages array if available, and use
      // the querySelector as a fallback.
      return !!this.element.querySelector("#" + (0, _css.escapeCssSelectorIdent)(pageId));
    }
    /**
     * @param {number} timeoutMs The maximum amount of time to wait, in
     *     milliseconds.
     * @return {!Promise} A promise that is resolved when the page is loaded or
     *     the timeout has been exceeded, whichever happens first.
     * @private
     */

  }, {
    key: "whenPagesLoaded_",
    value: function whenPagesLoaded_(timeoutMs) {
      if (timeoutMs === void 0) {
        timeoutMs = 0;
      }

      var pagesToWaitFor = this.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) === _ampStoryStoreService.UIType.DESKTOP_PANELS ? [this.pages_[0], this.pages_[1]] : [this.pages_[0]];
      var storyLoadPromise = Promise.all(pagesToWaitFor.filter(function (page) {
        return !!page;
      }).map(function (page) {
        return page.element.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END);
      }));
      return this.timer_.timeoutPromise(timeoutMs, storyLoadPromise).catch(function () {});
    }
    /** @private */

  }, {
    key: "markStoryAsLoaded_",
    value: function markStoryAsLoaded_() {
      var _this11 = this;

      (0, _events.dispatch)(this.win, this.element, _events.EventType.STORY_LOADED,
      /* payload */
      undefined, {
        bubbles: true
      });
      this.signals().signal(_commonSignals.CommonSignals.INI_LOAD);
      this.mutateElement(function () {
        _this11.element.classList.add(STORY_LOADED_CLASS_NAME);
      });
    }
    /**
     * Handles the story consent extension.
     * @private
     */

  }, {
    key: "handleConsentExtension_",
    value: function handleConsentExtension_() {
      var consentEl = this.element.querySelector('amp-consent');

      if (!consentEl) {
        return;
      }

      this.pauseStoryUntilConsentIsResolved_();
      this.validateConsent_(consentEl);
    }
    /**
     * Pauses the story until the consent is resolved (accepted or rejected).
     * @private
     */

  }, {
    key: "pauseStoryUntilConsentIsResolved_",
    value: function pauseStoryUntilConsentIsResolved_() {
      var _this12 = this;

      var policyId = this.getConsentPolicy() || 'default';
      var consentPromise = (0, _consent.getConsentPolicyState)(this.element, policyId);

      if (!consentPromise) {
        return;
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, true);
      consentPromise.then(function () {
        _this12.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, false);
      });
    }
    /**
     * Ensures publishers using amp-consent use amp-story-consent.
     * @param {!Element} consentEl
     * @private
     */

  }, {
    key: "validateConsent_",
    value: function validateConsent_(consentEl) {
      if (!(0, _dom.childElementByTag)(consentEl, 'amp-story-consent')) {
        (0, _log.user)().error(TAG, 'amp-consent must have an amp-story-consent child');
      }

      var allowedTags = ['SCRIPT', 'AMP-STORY-CONSENT'];
      var toRemoveChildren = (0, _dom.childElements)(consentEl, function (el) {
        return allowedTags.indexOf(el.tagName) === -1;
      });

      if (toRemoveChildren.length === 0) {
        return;
      }

      (0, _log.user)().error(TAG, 'amp-consent only allows tags: %s', allowedTags);
      toRemoveChildren.forEach(function (el) {
        return consentEl.removeChild(el);
      });
    }
    /**
     * @private
     */

  }, {
    key: "initializeStoryAccess_",
    value: function initializeStoryAccess_() {
      var _this13 = this;

      _services.Services.accessServiceForDocOrNull(this.element).then(function (accessService) {
        if (!accessService) {
          return;
        }

        _this13.areAccessAuthorizationsCompleted_ = accessService.areFirstAuthorizationsCompleted();
        accessService.onApplyAuthorizations(function () {
          return _this13.onAccessApplyAuthorizations_();
        });
        var firstPage = _this13.pages_[0].element;

        // First amp-story-page can't be paywall protected.
        // Removes the access attributes, and throws an error during development.
        if (firstPage.hasAttribute('amp-access') || firstPage.hasAttribute('amp-access-hide')) {
          firstPage.removeAttribute('amp-access');
          firstPage.removeAttribute('amp-access-hide');
          (0, _log.user)().error(TAG, 'First amp-story-page cannot have amp-access ' + 'or amp-access-hide attributes');
        }
      });
    }
    /**
     * On amp-access document reauthorization, maybe hide the access UI, and maybe
     * perform navigation.
     * @private
     */

  }, {
    key: "onAccessApplyAuthorizations_",
    value: function onAccessApplyAuthorizations_() {
      this.areAccessAuthorizationsCompleted_ = true;
      var nextPage = this.navigateToPageAfterAccess_;

      // Step out if the next page is still hidden by the access extension.
      if (nextPage && nextPage.element.hasAttribute('amp-access-hide')) {
        return;
      }

      if (nextPage) {
        this.navigateToPageAfterAccess_ = null;
        this.switchTo_(nextPage.element.id, _ampStoryPage.NavigationDirection.NEXT);
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_ACCESS, false);
    }
    /** @override */

  }, {
    key: "isLayoutSupported",
    value: function isLayoutSupported(layout) {
      return layout == _layout.Layout.CONTAINER;
    }
    /** @override */

  }, {
    key: "prerenderAllowed",
    value: function prerenderAllowed() {
      return true;
    }
    /** @private */

  }, {
    key: "initializePages_",
    value: function initializePages_() {
      var _this14 = this;

      var pageImplPromises = Array.prototype.map.call(this.element.querySelectorAll('amp-story-page'), function (pageEl) {
        return pageEl.getImpl();
      });
      return Promise.all(pageImplPromises).then(function (pages) {
        _this14.pages_ = pages;

        if ((0, _experiments.isExperimentOn)(_this14.win, 'amp-story-branching')) {
          _this14.storeService_.dispatch(_ampStoryStoreService.Action.ADD_TO_ACTIONS_ALLOWLIST, [{
            tagOrTarget: 'AMP-STORY',
            method: 'goToPage'
          }]);
        }
      });
    }
    /**
     * Advance to the next screen in the story, if there is one.
     * @param {boolean=} opt_isAutomaticAdvance Whether this navigation was caused
     *     by an automatic advancement after a timeout.
     * @private
     */

  }, {
    key: "next_",
    value: function next_(opt_isAutomaticAdvance) {
      var activePage = (0, _log.devAssert)(this.activePage_, 'No active page set when navigating to next page.');
      activePage.next(opt_isAutomaticAdvance);
    }
    /**
     * Installs amp-viewer-integration script in case story is inside an
     * amp-story-player.
     * @private
     */

  }, {
    key: "initializeStoryPlayer_",
    value: function initializeStoryPlayer_() {
      if (this.viewer_.getParam('storyPlayer') !== 'v0') {
        return;
      }

      _services.Services.extensionsFor(this.win).installExtensionForDoc(this.getAmpDoc(), 'amp-viewer-integration');
    }
    /**
     * Handles EventType.NO_NEXT_PAGE events.
     * @private
     */

  }, {
    key: "onNoNextPage_",
    value: function onNoNextPage_() {
      var _this15 = this;

      if (this.viewer_.hasCapability('swipe') && this.viewerMessagingHandler_) {
        var advancementMode = this.storeService_.get(_ampStoryStoreService.StateProperty.ADVANCEMENT_MODE);
        this.viewerMessagingHandler_.send('selectDocument', (0, _object.dict)({
          'next': true,
          'advancementMode': advancementMode
        }));
        return;
      }

      this.hasBookend_().then(function (hasBookend) {
        if (hasBookend) {
          _this15.showBookend_();
        }
      });
    }
    /**
     * Go back to the previous screen in the story, if there is one.
     * @private
     */

  }, {
    key: "previous_",
    value: function previous_() {
      var activePage = (0, _log.devAssert)(this.activePage_, 'No active page set when navigating to previous page.');
      activePage.previous();
    }
    /**
     * Handles EventType.NO_PREVIOUS_PAGE events.
     * @private
     */

  }, {
    key: "onNoPreviousPage_",
    value: function onNoPreviousPage_() {
      if (this.viewer_.hasCapability('swipe') && this.viewerMessagingHandler_) {
        var advancementMode = this.storeService_.get(_ampStoryStoreService.StateProperty.ADVANCEMENT_MODE);
        this.viewerMessagingHandler_.send('selectDocument', (0, _object.dict)({
          'previous': true,
          'advancementMode': advancementMode
        }));
        return;
      }

      if (this.storeService_.get(_ampStoryStoreService.StateProperty.CAN_SHOW_PREVIOUS_PAGE_HELP)) {
        this.ampStoryHint_.showFirstPageHintOverlay();
      }
    }
    /**
     * @param {number} direction The direction to navigate.
     * @private
     */

  }, {
    key: "performTapNavigation_",
    value: function performTapNavigation_(direction) {
      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.MANUAL_ADVANCE);

      if (this.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) === _ampStoryStoreService.UIType.DESKTOP_PANELS) {
        this.next_();
        return;
      }

      if (direction === _pageAdvancement.TapNavigationDirection.NEXT) {
        this.next_();
      } else if (direction === _pageAdvancement.TapNavigationDirection.PREVIOUS) {
        this.previous_();
      }
    }
    /**
     * Switches to a particular page.
     * @param {string} targetPageId
     * @param {!NavigationDirection} direction
     * @return {!Promise}
     * @private
     */

  }, {
    key: "switchTo_",
    value: function switchTo_(targetPageId, direction) {
      var _this16 = this;

      var targetPage = this.getPageById(targetPageId);
      var pageIndex = this.getPageIndex(targetPage);

      // Step out if trying to navigate to the currently active page.
      if (this.activePage_ && this.activePage_.element.id === targetPageId) {
        return (0, _resolvedPromise6.resolvedPromise)();
      }

      // If the next page might be paywall protected, and the access
      // authorizations did not resolve yet, wait before navigating.
      // TODO(gmajoulet): implement a loading state.
      if (targetPage.element.hasAttribute('amp-access') && !this.areAccessAuthorizationsCompleted_) {
        this.navigateToPageAfterAccess_ = targetPage;
        return (0, _resolvedPromise6.resolvedPromise)();
      }

      // If the next page is paywall protected, display the access UI and wait for
      // the document to be reauthorized.
      if (targetPage.element.hasAttribute('amp-access-hide')) {
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_ACCESS, true);
        this.navigateToPageAfterAccess_ = targetPage;
        return (0, _resolvedPromise6.resolvedPromise)();
      }

      var oldPage = this.activePage_;
      this.activePage_ = targetPage;

      if (!targetPage.isAd()) {
        this.updateNavigationPath_(targetPageId, direction);
      }

      // Each step will run in a requestAnimationFrame, and wait for the next
      // frame before executing the following step.
      var steps = [// First step contains the minimum amount of code to display and play the
      // target page as fast as possible.
      function () {
        oldPage && oldPage.element.removeAttribute('active');

        if (_this16.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) === _ampStoryStoreService.UIType.DESKTOP_PANELS) {
          _this16.setDesktopPositionAttributes_(targetPage);
        }

        // Starts playing the page, if the story is not paused.
        // Note: navigation is prevented when the story is paused, this test
        // covers the case where the story is rendered paused (eg: consent).
        if (!_this16.storeService_.get(_ampStoryStoreService.StateProperty.PAUSED_STATE)) {
          targetPage.setState(_ampStoryPage.PageState.PLAYING);
        } else {
          // Even if the page won't be playing, setting the active attribute
          // ensures it gets visible.
          targetPage.element.setAttribute('active', '');
        }

        _this16.forceRepaintForSafari_();
      }, // Second step does all the operations that impact the UI/UX: media sound,
      // progress bar, ...
      function () {
        if (oldPage) {
          oldPage.setState(_ampStoryPage.PageState.NOT_ACTIVE);
          // Indication to know where to display the page on the desktop
          // ribbon-like animation.
          _this16.getPageIndex(oldPage) < pageIndex ? (0, _utils.setAttributeInMutate)(oldPage, Attributes.VISITED) : (0, _utils.removeAttributeInMutate)(oldPage, Attributes.VISITED);

          if (oldPage.isAd()) {
            _this16.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.ADVANCE_TO_ADS);
          }
        }

        var storePageIndex = pageIndex;

        if (targetPage.isAd()) {
          _this16.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_AD, true);

          (0, _utils.setAttributeInMutate)(_this16, Attributes.AD_SHOWING);
          // Keep current page index when an ad is shown. Otherwise it messes
          // up with the progress variable in the VariableService.
          storePageIndex = _this16.storeService_.get(_ampStoryStoreService.StateProperty.CURRENT_PAGE_INDEX);
        } else {
          _this16.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_AD, false);

          (0, _utils.removeAttributeInMutate)(_this16, Attributes.AD_SHOWING);

          // Start progress bar update for pages that are not ads or auto-
          // advance.
          if (!targetPage.isAutoAdvance()) {
            _this16.systemLayer_.updateProgress(targetPageId, _this16.advancement_.getProgress());
          }
        }

        _this16.storeService_.dispatch(_ampStoryStoreService.Action.CHANGE_PAGE, {
          id: targetPageId,
          index: storePageIndex
        });

        // If first navigation.
        if (!oldPage) {
          _this16.registerAndPreloadBackgroundAudio_();
        }
      }, // Third and last step contains all the actions that can be delayed after
      // the navigation happened, like preloading the following pages, or
      // sending analytics events.
      function () {
        _this16.preloadPagesByDistance_();

        _this16.maybePreloadBookend_();

        _this16.triggerActiveEventForPage_();

        _this16.systemLayer_.resetDeveloperLogs();

        _this16.systemLayer_.setDeveloperLogContextString(_this16.activePage_.element.id);
      }];
      return new Promise(function (resolve) {
        targetPage.beforeVisible().then(function () {
          // Recursively executes one step per frame.
          var unqueueStepInRAF = function unqueueStepInRAF() {
            steps.shift().call(_this16);

            if (!steps.length) {
              return resolve();
            }

            _this16.win.requestAnimationFrame(function () {
              return unqueueStepInRAF();
            });
          };

          unqueueStepInRAF();
        });
      });
    }
    /**
     * Updates the story navigation stack and checks for navigation adherence to
     * the path a user takes.
     * @param {string} targetPageId
     * @param {!NavigationDirection} direction
     * @private
     */

  }, {
    key: "updateNavigationPath_",
    value: function updateNavigationPath_(targetPageId, direction) {
      var navigationPath =
      /** @type {!Array<string>} */
      this.storeService_.get(_ampStoryStoreService.StateProperty.NAVIGATION_PATH);

      if (direction === _ampStoryPage.NavigationDirection.PREVIOUS) {
        navigationPath.pop();
      }

      // Ensures the pageId is not at the top of the stack already, which can
      // happen on initial page load (e.g. reloading a page).
      if (direction === _ampStoryPage.NavigationDirection.NEXT && navigationPath[navigationPath.length - 1] !== targetPageId) {
        navigationPath.push(targetPageId);
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_NAVIGATION_PATH, navigationPath);
      (0, _history.setHistoryState)(this.win, _history.HistoryState.NAVIGATION_PATH, navigationPath);
    }
    /**
     * Clear existing preview attributes, Check to see if there is a next or
     * previous page, set new attributes.
     * @param {?./amp-story-page.AmpStoryPage} targetPage
     * @private
     */

  }, {
    key: "setDesktopPositionAttributes_",
    value: function setDesktopPositionAttributes_(targetPage) {
      var _this17 = this;

      if (!targetPage) {
        return;
      }

      var list = [{
        page: targetPage,
        position: 0
      }];
      var minusOneId = targetPage.getPreviousPageId();

      if (minusOneId) {
        var minusOnePage = this.getPageById(minusOneId);
        list.push({
          page: minusOnePage,
          position: -1
        });
        var minusTwoId = minusOnePage.getPreviousPageId();

        if (minusTwoId) {
          list.push({
            page: this.getPageById(minusTwoId),
            position: -2
          });
        }
      }

      var plusOneId = targetPage.getNextPageId();

      if (plusOneId) {
        var plusOnePage = this.getPageById(plusOneId);
        list.push({
          page: plusOnePage,
          position: 1
        });
        var plusTwoId = plusOnePage.getNextPageId();

        if (plusTwoId) {
          list.push({
            page: this.getPageById(plusTwoId),
            position: 2
          });
        }
      }

      var desktopPositionsToReset;
      this.measureMutateElement(
      /** measurer */
      function () {
        desktopPositionsToReset = (0, _dom.scopedQuerySelectorAll)(_this17.element, "amp-story-page[\n                      " + (0, _css.escapeCssSelectorIdent)(Attributes.DESKTOP_POSITION) + "]");
      },
      /** mutator */
      function () {
        Array.prototype.forEach.call(desktopPositionsToReset, function (el) {
          el.removeAttribute(Attributes.DESKTOP_POSITION);
        });
        list.forEach(function (entry) {
          var page = entry.page,
              position = entry.position;
          page.element.setAttribute(Attributes.DESKTOP_POSITION, position);
        });
      });
    }
    /** @private */

  }, {
    key: "triggerActiveEventForPage_",
    value: function triggerActiveEventForPage_() {
      // TODO(alanorozco): pass event priority once amphtml-story repo is merged
      // with upstream.
      _services.Services.actionServiceForDoc(this.element).trigger(this.activePage_.element, 'active',
      /* event */
      null, _actionConstants.ActionTrust.HIGH);
    }
    /**
     * For some reason, Safari has an issue where sometimes when pages become
     * visible, some descendants are not painted.  This is a hack, where we detect
     * that the browser is Safari and force it to repaint, to avoid this case.
     * See newmuis/amphtml-story#106 for details.
     * @private
     */

  }, {
    key: "forceRepaintForSafari_",
    value: function forceRepaintForSafari_() {
      var _this18 = this;

      if (!this.platform_.isSafari() && !this.platform_.isIos()) {
        return;
      }

      if (this.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) === _ampStoryStoreService.UIType.DESKTOP_PANELS) {
        // Force repaint is only needed when transitioning from invisible to
        // visible
        return;
      }

      this.mutateElement(function () {
        (0, _style.toggle)(_this18.element, false);
        // Reading the height is what forces the repaint.  The conditional exists
        // only to workaround the fact that the closure compiler would otherwise
        // think that only reading the height has no effect.  Since the height is
        // always >= 0, this conditional will always be executed.
        var height = _this18.element.
        /*OK*/
        offsetHeight;

        if (height >= 0) {
          (0, _style.toggle)(_this18.element, true);
        }
      });
    }
    /**
     * Handles all key presses within the story.
     * @param {!Event} e The keydown event.
     * @private
     */

  }, {
    key: "onKeyDown_",
    value: function onKeyDown_(e) {
      if (this.storeService_.get(_ampStoryStoreService.StateProperty.BOOKEND_STATE)) {
        return;
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.MANUAL_ADVANCE);
      var rtlState = this.storeService_.get(_ampStoryStoreService.StateProperty.RTL_STATE);

      switch (e.key) {
        case _keyCodes.Keys.LEFT_ARROW:
          rtlState ? this.next_() : this.previous_();
          break;

        case _keyCodes.Keys.RIGHT_ARROW:
          rtlState ? this.previous_() : this.next_();
          break;
      }
    }
    /**
     * Handle resize events and set the story's desktop state.
     * @visibleForTesting
     */

  }, {
    key: "onResize",
    value: function onResize() {
      var uiState = this.getUIType_();
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_UI, uiState);
      var isLandscape = this.isLandscape_();
      var isLandscapeSupported = this.isLandscapeSupported_();
      this.setOrientationAttribute_(isLandscape, isLandscapeSupported);

      if (uiState !== _ampStoryStoreService.UIType.MOBILE || isLandscapeSupported) {
        // Hides the UI that prevents users from using the LANDSCAPE orientation.
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_VIEWPORT_WARNING, false);
        return;
      }

      // Only called when the desktop media query is not matched and the landscape
      // mode is not enabled.
      this.maybeTriggerViewportWarning_(isLandscape);
    }
    /**
     * Adds an orientation=landscape|portrait attribute.
     * If the story doesn't explicitly support landscape via the opt-in attribute,
     * it is always in a portrait orientation.
     * @param {boolean} isLandscape Whether the viewport is landscape or portrait
     * @param {boolean} isLandscapeSupported Whether the story supports landscape
     * @private
     */

  }, {
    key: "setOrientationAttribute_",
    value: function setOrientationAttribute_(isLandscape, isLandscapeSupported) {
      var _this19 = this;

      // TODO(#20832) base this check on the size of the amp-story-page, once it
      // is stored as a store state.
      this.mutateElement(function () {
        _this19.element.setAttribute(Attributes.ORIENTATION, isLandscapeSupported && isLandscape ? 'landscape' : 'portrait');
      });
    }
    /**
     * Maybe triggers the viewport warning overlay.
     * @param {boolean} isLandscape
     * @private
     */

  }, {
    key: "maybeTriggerViewportWarning_",
    value: function maybeTriggerViewportWarning_(isLandscape) {
      var _this20 = this;

      if (isLandscape === this.storeService_.get(_ampStoryStoreService.StateProperty.VIEWPORT_WARNING_STATE)) {
        return;
      }

      this.mutateElement(function () {
        if (isLandscape) {
          _this20.pausedStateToRestore_ = !!_this20.storeService_.get(_ampStoryStoreService.StateProperty.PAUSED_STATE);

          _this20.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, true);

          _this20.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_VIEWPORT_WARNING, true);
        } else {
          _this20.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, _this20.pausedStateToRestore_);

          _this20.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_VIEWPORT_WARNING, false);
        }
      });
    }
    /**
     * Reacts to the browser tab becoming active/inactive.
     * @private
     */

  }, {
    key: "onVisibilityChanged_",
    value: function onVisibilityChanged_() {
      this.getAmpDoc().isVisible() ? this.resume_() : this.pause_();
    }
    /**
     * Reacts to the ad state updates, and pauses the background-audio when an ad
     * is displayed.
     * @param {boolean} isAd
     * @private
     */

  }, {
    key: "onAdStateUpdate_",
    value: function onAdStateUpdate_(isAd) {
      if (this.storeService_.get(_ampStoryStoreService.StateProperty.MUTED_STATE)) {
        return;
      }

      isAd ? this.pauseBackgroundAudio_() : this.playBackgroundAudio_();
    }
    /**
     * Reacts to UI state updates.
     * @param {!UIType} uiState
     * @private
     */

  }, {
    key: "onUIStateUpdate_",
    value: function onUIStateUpdate_(uiState) {
      var _this21 = this;

      switch (uiState) {
        case _ampStoryStoreService.UIType.MOBILE:
          this.vsync_.mutate(function () {
            _this21.element.removeAttribute('desktop');

            _this21.element.classList.remove('i-amphtml-story-desktop-panels');

            _this21.element.classList.remove('i-amphtml-story-desktop-fullbleed');
          });
          break;

        case _ampStoryStoreService.UIType.DESKTOP_PANELS:
          this.setDesktopPositionAttributes_(this.activePage_);
          this.buildPaginationButtons_();
          this.vsync_.mutate(function () {
            _this21.element.setAttribute('desktop', '');

            _this21.element.classList.add('i-amphtml-story-desktop-panels');

            _this21.element.classList.remove('i-amphtml-story-desktop-fullbleed');
          });
          break;

        case _ampStoryStoreService.UIType.DESKTOP_FULLBLEED:
          this.buildPaginationButtons_();
          this.vsync_.mutate(function () {
            _this21.element.setAttribute('desktop', '');

            _this21.element.classList.add('i-amphtml-story-desktop-fullbleed');

            _this21.element.classList.remove('i-amphtml-story-desktop-panels');
          });
          break;
        // Because of the DOM mutations, switching from this mode to another is
        // not allowed, and prevented within the store service.

        case _ampStoryStoreService.UIType.VERTICAL:
          var pageAttachments = (0, _dom.scopedQuerySelectorAll)(this.element, 'amp-story-page amp-story-page-attachment');
          this.initializeBookend_().then(function () {
            return _this21.showBookend_();
          });
          this.vsync_.mutate(function () {
            _this21.element.setAttribute('i-amphtml-vertical', '');

            (0, _style.setImportantStyles)(_this21.win.document.body, {
              height: 'auto'
            });

            _this21.element.removeAttribute('desktop');

            _this21.element.classList.remove('i-amphtml-story-desktop-fullbleed');

            _this21.element.classList.remove('i-amphtml-story-desktop-panels');

            for (var i = 0; i < pageAttachments.length; i++) {
              _this21.element.insertBefore(pageAttachments[i], // Attachments that are just links are rendered in-line with their
              // story page.
              pageAttachments[i].getAttribute('href') ? pageAttachments[i].parentElement.nextElementSibling : // Other attachments are rendered at the end.
              null);
            }
          });
          this.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END).then(function () {
            _this21.vsync_.mutate(function () {
              _this21.pages_.forEach(function (page) {
                return page.element.setAttribute('active', '');
              });
            });
          });
          break;
      }
    }
    /**
     * Retrieves the UI type that should be used to view the story.
     * @return {!UIType}
     * @private
     */

  }, {
    key: "getUIType_",
    value: function getUIType_() {
      if (this.platform_.isBot()) {
        return _ampStoryStoreService.UIType.VERTICAL;
      }

      if (!this.isDesktop_()) {
        return _ampStoryStoreService.UIType.MOBILE;
      }

      if (this.isLandscapeSupported_()) {
        return _ampStoryStoreService.UIType.DESKTOP_FULLBLEED;
      }

      // Three panels desktop UI (default).
      return _ampStoryStoreService.UIType.DESKTOP_PANELS;
    }
    /**
     * @return {boolean} True if the screen size matches the desktop media query.
     * @private
     */

  }, {
    key: "isDesktop_",
    value: function isDesktop_() {
      return this.desktopMedia_.matches && !this.platform_.isBot();
    }
    /**
     * @return {boolean} True if the screen orientation is landscape.
     * @private
     */

  }, {
    key: "isLandscape_",
    value: function isLandscape_() {
      return this.landscapeOrientationMedia_.matches;
    }
    /**
     * @return {boolean} true if this is a standalone story (i.e. this story is
     *     the only content of the document).
     * @private
     */

  }, {
    key: "isStandalone_",
    value: function isStandalone_() {
      return this.element.hasAttribute(Attributes.STANDALONE);
    }
    /**
     * Whether the story should support landscape orientation: landscape mobile,
     * or full bleed desktop UI.
     * @return {boolean}
     * @private
     */

  }, {
    key: "isLandscapeSupported_",
    value: function isLandscapeSupported_() {
      return this.element.hasAttribute(Attributes.SUPPORTS_LANDSCAPE);
    }
    /**
     * Reacts to paused state updates.
     * @param {boolean} isPaused
     * @private
     */

  }, {
    key: "onPausedStateUpdate_",
    value: function onPausedStateUpdate_(isPaused) {
      if (!this.activePage_) {
        return;
      }

      var pageState = isPaused ? _ampStoryPage.PageState.PAUSED : _ampStoryPage.PageState.PLAYING;
      this.activePage_.setState(pageState);
    }
    /**
     * Reacts to sidebar state updates.
     * @param {boolean} sidebarState
     * @private
     */

  }, {
    key: "onSidebarStateUpdate_",
    value: function onSidebarStateUpdate_(sidebarState) {
      var _this22 = this;

      this.analyticsService_.triggerEvent(sidebarState ? _storyAnalytics.StoryAnalyticsEvent.OPEN : _storyAnalytics.StoryAnalyticsEvent.CLOSE, this.sidebar_);

      var actions = _services.Services.actionServiceForDoc(this.element);

      if (this.win.MutationObserver) {
        if (!this.sidebarObserver_) {
          this.sidebarObserver_ = new this.win.MutationObserver(function () {
            _this22.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SIDEBAR, _this22.sidebar_.hasAttribute('open'));
          });
        }

        if (this.sidebar_ && sidebarState) {
          this.sidebarObserver_.observe(this.sidebar_, SIDEBAR_OBSERVER_OPTIONS);
          this.openOpacityMask_();
          actions.execute(this.sidebar_, 'open',
          /* args */
          null,
          /* source */
          null,
          /* caller */
          null,
          /* event */
          null, _actionConstants.ActionTrust.HIGH);
        } else {
          this.closeOpacityMask_();
          this.sidebarObserver_.disconnect();
        }
      } else if (this.sidebar_ && sidebarState) {
        this.openOpacityMask_();
        actions.execute(this.sidebar_, 'open',
        /* args */
        null,
        /* source */
        null,
        /* caller */
        null,
        /* event */
        null, _actionConstants.ActionTrust.HIGH);
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SIDEBAR, false);
      }
    }
    /**
     * @private
     */

  }, {
    key: "initializeOpacityMask_",
    value: function initializeOpacityMask_() {
      var _this23 = this;

      if (!this.maskElement_) {
        var maskEl = this.win.document.createElement('div');
        maskEl.classList.add(OPACITY_MASK_CLASS_NAME);
        maskEl.addEventListener('click', function () {
          var actions = _services.Services.actionServiceForDoc(_this23.element);

          if (_this23.sidebar_) {
            _this23.closeOpacityMask_();

            actions.execute(_this23.sidebar_, 'close',
            /* args */
            null,
            /* source */
            null,
            /* caller */
            null,
            /* event */
            null, _actionConstants.ActionTrust.HIGH);
          }
        });
        this.maskElement_ = maskEl;
        this.mutateElement(function () {
          _this23.element.appendChild(_this23.maskElement_);

          (0, _style.toggle)((0, _log.dev)().assertElement(_this23.maskElement_),
          /* display */
          false);
        });
      }
    }
    /**
     * @private
     */

  }, {
    key: "openOpacityMask_",
    value: function openOpacityMask_() {
      var _this24 = this;

      this.mutateElement(function () {
        (0, _style.toggle)((0, _log.dev)().assertElement(_this24.maskElement_),
        /* display */
        true);
      });
    }
    /**
     * @private
     */

  }, {
    key: "closeOpacityMask_",
    value: function closeOpacityMask_() {
      var _this25 = this;

      if (this.maskElement_) {
        this.mutateElement(function () {
          (0, _style.toggle)((0, _log.dev)().assertElement(_this25.maskElement_),
          /* display */
          false);
        });
      }
    }
    /**
     * If browser is supported, displays the story. Otherwise, shows either the
     * default unsupported browser layer or the publisher fallback (if provided).
     * @param {boolean} isBrowserSupported
     * @private
     */

  }, {
    key: "onSupportedBrowserStateUpdate_",
    value: function onSupportedBrowserStateUpdate_(isBrowserSupported) {
      var _this26 = this;

      var fallbackEl = this.getFallback();

      if (isBrowserSupported) {
        // Removes the default unsupported browser layer or throws an error
        // if the publisher has provided their own fallback
        if (fallbackEl) {
          (0, _log.dev)().error(TAG, 'No handler to exit unsupported browser state on ' + 'publisher provided fallback.');
        } else {
          this.layoutStory_().then(function () {
            _this26.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, _this26.pausedStateToRestore_);

            _this26.mutateElement(function () {
              _this26.unsupportedBrowserLayer_.removeLayer();
            });
          });
        }
      } else {
        this.pausedStateToRestore_ = !!this.storeService_.get(_ampStoryStoreService.StateProperty.PAUSED_STATE);
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, true);

        // Displays the publisher provided fallback or fallbacks to the default
        // unsupported browser layer.
        if (fallbackEl) {
          this.toggleFallback(true);
        } else {
          this.unsupportedBrowserLayer_.build();
          this.mutateElement(function () {
            _this26.element.appendChild(_this26.unsupportedBrowserLayer_.get());
          });
        }
      }
    }
    /**
     * Shows the bookend overlay.
     * @private
     */

  }, {
    key: "showBookend_",
    value: function showBookend_() {
      var _this27 = this;

      this.buildAndPreloadBookend_().then(function () {
        _this27.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_BOOKEND, true);
      });
    }
    /**
     * Hides the bookend overlay.
     * @private
     */

  }, {
    key: "hideBookend_",
    value: function hideBookend_() {
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_BOOKEND, false);
    }
    /**
     * @param {boolean} isActive
     * @private
     */

  }, {
    key: "onBookendStateUpdate_",
    value: function onBookendStateUpdate_(isActive) {
      this.toggleElementsOnBookend_(
      /* display */
      isActive);
      this.element.classList.toggle('i-amphtml-story-bookend-active', isActive);
    }
    /**
     * Toggles content when bookend is opened/closed.
     * @param {boolean} isActive
     * @private
     */

  }, {
    key: "toggleElementsOnBookend_",
    value: function toggleElementsOnBookend_(isActive) {
      if (this.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) !== _ampStoryStoreService.UIType.DESKTOP_PANELS) {
        return;
      }

      var elements = (0, _dom.scopedQuerySelectorAll)(this.element, HIDE_ON_BOOKEND_SELECTOR);
      Array.prototype.forEach.call(elements, function (el) {
        if (isActive) {
          (0, _style.setImportantStyles)(el, {
            opacity: 0,
            transition: 'opacity 0.1s'
          });
        } else {
          (0, _style.resetStyles)(el, ['opacity', 'transition']);
        }
      });
    }
    /**
     * @return {!Array<!Array<string>>} A 2D array representing lists of pages by
     *     distance.  The outer array index represents the distance from the
     *     active page; the inner array is a list of page IDs at the specified
     *     distance.
     */

  }, {
    key: "getPagesByDistance_",
    value: function getPagesByDistance_() {
      var _this28 = this;

      var distanceMap = this.getPageDistanceMapHelper_(
      /* distance */
      0,
      /* map */
      {}, this.activePage_.element.id);
      // Transpose the map into a 2D array.
      var pagesByDistance = [];
      Object.keys(distanceMap).forEach(function (pageId) {
        var distance = distanceMap[pageId];

        // If on last page, mark first page with distance 1.
        if (pageId === _this28.pages_[0].element.id && _this28.activePage_ === _this28.pages_[_this28.pages_.length - 1] && _this28.pages_.length > 1 && !_this28.viewer_.hasCapability('swipe')) {
          distance = 1;
        }

        if (!pagesByDistance[distance]) {
          pagesByDistance[distance] = [];
        }

        // There may be other 1 skip away pages due to branching.
        if ((0, _experiments.isExperimentOn)(_this28.win, 'amp-story-branching')) {
          var navigationPath = _this28.storeService_.get(_ampStoryStoreService.StateProperty.NAVIGATION_PATH);

          var indexInStack = navigationPath.indexOf(_this28.activePage_.element.id);
          var maybePrev = navigationPath[indexInStack - 1];

          if (indexInStack > 0 && pageId === _this28.activePage_.element.id) {
            if (!pagesByDistance[1]) {
              pagesByDistance[1] = [];
            }

            pagesByDistance[1].push(maybePrev);
          }

          // Do not overwrite, branching distance always takes precedence.
          if (pageId !== maybePrev) {
            pagesByDistance[distance].push(pageId);
          }
        } else {
          pagesByDistance[distance].push(pageId);
        }
      });
      return pagesByDistance;
    }
    /**
     * Creates a map of a page and all of the pages reachable from that page, by
     * distance.
     *
     * @param {number} distance The distance that the page with the specified
     *     pageId is from the active page.
     * @param {!Object<string, number>} map A mapping from pageId to its distance
     *     from the active page.
     * @param {string} pageId The page to be added to the map.
     * @return {!Object<string, number>} A mapping from page ID to the priority of
     *     that page.
     * @private
     */

  }, {
    key: "getPageDistanceMapHelper_",
    value: function getPageDistanceMapHelper_(distance, map, pageId) {
      var _this29 = this;

      if (map[pageId] !== undefined && map[pageId] <= distance) {
        return map;
      }

      map[pageId] = distance;
      var page = this.getPageById(pageId);
      page.getAdjacentPageIds().forEach(function (adjacentPageId) {
        if (map[adjacentPageId] !== undefined && map[adjacentPageId] <= distance) {
          return;
        }

        // TODO(newmuis): Remove the assignment and return, as they're
        // unnecessary.
        map = _this29.getPageDistanceMapHelper_(distance + 1, map, adjacentPageId);
      });
      return map;
    }
    /** @private */

  }, {
    key: "preloadPagesByDistance_",
    value: function preloadPagesByDistance_() {
      var _this30 = this;

      if (this.platform_.isBot()) {
        this.pages_.forEach(function (page) {
          page.setDistance(0);
        });
        return;
      }

      var pagesByDistance = this.getPagesByDistance_();
      this.mutateElement(function () {
        pagesByDistance.forEach(function (pageIds, distance) {
          pageIds.forEach(function (pageId) {
            var page = _this30.getPageById(pageId);

            page.setDistance(distance);
          });
        });
      });
    }
    /**
     * Handles a background-audio attribute set on an <amp-story> tag.
     * @private
     */

  }, {
    key: "registerAndPreloadBackgroundAudio_",
    value: function registerAndPreloadBackgroundAudio_() {
      var _this31 = this;

      var backgroundAudioEl = (0, _audio.upgradeBackgroundAudio)(this.element);

      if (!backgroundAudioEl) {
        return;
      }

      // Once the media pool is ready, registers and preloads the background
      // audio, and then gets the swapped element from the DOM to mute/unmute/play
      // it programmatically later.
      this.activePage_.element.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END).then(function () {
        backgroundAudioEl =
        /** @type {!HTMLMediaElement} */
        backgroundAudioEl;

        _this31.mediaPool_.register(backgroundAudioEl);

        return _this31.mediaPool_.preload(backgroundAudioEl);
      }).then(function () {
        _this31.backgroundAudioEl_ =
        /** @type {!HTMLMediaElement} */
        (0, _dom.childElement)(_this31.element, function (el) {
          return el.tagName.toLowerCase() === 'audio';
        });
      });
    }
    /**
     * Loads amp-story-education if the viewer capability is provided.
     * @private
     */

  }, {
    key: "maybeLoadStoryEducation_",
    value: function maybeLoadStoryEducation_() {
      var _this32 = this;

      if (!this.viewer_.hasCapability('education')) {
        return;
      }

      this.mutateElement(function () {
        _this32.element.appendChild(_this32.win.document.createElement('amp-story-education'));
      });

      _services.Services.extensionsFor(this.win).installExtensionForDoc(this.getAmpDoc(), 'amp-story-education');
    }
    /**
     * Initializes bookend.
     * @return {!Promise}
     * @private
     */

  }, {
    key: "initializeBookend_",
    value: function initializeBookend_() {
      var _this33 = this;

      var bookendEl = this.element.querySelector('amp-story-bookend');

      if (!bookendEl) {
        bookendEl = (0, _dom.createElementWithAttributes)(this.win.document, 'amp-story-bookend', (0, _object.dict)({
          'layout': 'nodisplay'
        }));
        this.element.appendChild(bookendEl);
      }

      return (0, _dom.whenUpgradedToCustomElement)(bookendEl).then(function () {
        return bookendEl.getImpl().then(function (bookendImpl) {
          _this33.bookend_ = bookendImpl;
        });
      });
    }
    /**
     * Preloads the bookend config if on the last page.
     * @private
     */

  }, {
    key: "maybePreloadBookend_",
    value: function maybePreloadBookend_() {
      if (!this.activePage_ || !this.storeService_.get(_ampStoryStoreService.StateProperty.CAN_SHOW_BOOKEND)) {
        return;
      }

      var pageIndex = this.getPageIndex(this.activePage_);

      if (pageIndex + 1 >= this.getPageCount()) {
        this.buildAndPreloadBookend_();
      }
    }
    /**
     * Builds, fetches and sets the bookend publisher configuration.
     * @return {!Promise<?./bookend/bookend-component.BookendDataDef>}
     * @private
     */

  }, {
    key: "buildAndPreloadBookend_",
    value: function buildAndPreloadBookend_() {
      this.bookend_.build();
      return this.bookend_.loadConfigAndMaybeRenderBookend();
    }
    /**
     * @return {!Promise<boolean>}
     * @private
     */

  }, {
    key: "hasBookend_",
    value: function hasBookend_() {
      if (!this.storeService_.get(_ampStoryStoreService.StateProperty.CAN_SHOW_BOOKEND)) {
        return Promise.resolve(false);
      }

      // TODO(newmuis): Change this comment.
      // On mobile there is always a bookend. On desktop, the bookend will only
      // be shown if related articles have been configured.
      if (this.storeService_.get(_ampStoryStoreService.StateProperty.UI_STATE) === _ampStoryStoreService.UIType.MOBILE) {
        return Promise.resolve(true);
      }

      return this.bookend_.loadConfigAndMaybeRenderBookend(false
      /** renderBookend */
      ).then(function (config) {
        return !!(config && config.components && config.components.length > 0);
      });
    }
    /**
     * @param {string} id The ID of the page whose index should be retrieved.
     * @return {number} The index of the page.
     */

  }, {
    key: "getPageIndexById",
    value: function getPageIndexById(id) {
      var pageIndex = (0, _array.findIndex)(this.pages_, function (page) {
        return page.element.id === id;
      });

      if (pageIndex < 0) {
        (0, _log.user)().error(TAG, 'Story refers to page "%s", but no such page exists.', id);
      }

      return pageIndex;
    }
    /**
     * @param {string} id The ID of the page to be retrieved.
     * @return {!./amp-story-page.AmpStoryPage} Retrieves the page with the
     *     specified ID.
     */

  }, {
    key: "getPageById",
    value: function getPageById(id) {
      var pageIndex = this.getPageIndexById(id);
      return (0, _log.devAssert)(this.pages_[pageIndex], 'Page at index %s exists, but is missing from the array.', pageIndex);
    }
    /**
     * @return {number}
     */

  }, {
    key: "getPageCount",
    value: function getPageCount() {
      return this.pages_.length - this.adPages_.length;
    }
    /**
     * @param {!./amp-story-page.AmpStoryPage} desiredPage
     * @return {number} The index of the page.
     */

  }, {
    key: "getPageIndex",
    value: function getPageIndex(desiredPage) {
      return (0, _array.findIndex)(this.pages_, function (page) {
        return page === desiredPage;
      });
    }
    /**
     * Retrieves the page containing the element, or null. A background audio
     * set on the <amp-story> tag would not be contained in a page.
     * @param {!Element} element The element whose containing AmpStoryPage should
     *     be retrieved
     * @return {?./amp-story-page.AmpStoryPage} The AmpStoryPage containing the
     *     specified element, if any.
     */

  }, {
    key: "getPageContainingElement_",
    value: function getPageContainingElement_(element) {
      var pageIndex = (0, _array.findIndex)(this.pages_, function (page) {
        var pageEl = (0, _dom.closest)(element, function (el) {
          return el === page.element;
        });
        return !!pageEl;
      });
      return this.pages_[pageIndex] || null;
    }
    /** @override */

  }, {
    key: "getElementDistance",
    value: function getElementDistance(element) {
      var page = this.getPageContainingElement_(element);

      // An element not contained in a page is likely to be global to the story,
      // like a background audio. Setting the distance to -1 ensures it will not
      // get evicted from the media pool.
      if (!page) {
        return -1;
      }

      return page.getDistance();
    }
    /** @override */

  }, {
    key: "getMaxMediaElementCounts",
    value: function getMaxMediaElementCounts() {
      var _ref;

      var audioMediaElementsCount = this.element.querySelectorAll('amp-audio, [background-audio]').length;
      var videoMediaElementsCount = this.element.querySelectorAll('amp-video').length;

      // The root element (amp-story) might have a background-audio as well.
      if (this.element.hasAttribute('background-audio')) {
        audioMediaElementsCount++;
      }

      return _ref = {}, _ref[_mediaPool.MediaType.AUDIO] = Math.min(audioMediaElementsCount + MINIMUM_AD_MEDIA_ELEMENTS, MAX_MEDIA_ELEMENT_COUNTS[_mediaPool.MediaType.AUDIO]), _ref[_mediaPool.MediaType.VIDEO] = Math.min(videoMediaElementsCount + MINIMUM_AD_MEDIA_ELEMENTS, MAX_MEDIA_ELEMENT_COUNTS[_mediaPool.MediaType.VIDEO]), _ref;
    }
    /** @override */

  }, {
    key: "getElement",
    value: function getElement() {
      return this.element;
    }
    /**
     * Reacts to muted state updates.
     * @param  {boolean} isMuted Whether the story just got muted.
     * @private
     */

  }, {
    key: "onMutedStateUpdate_",
    value: function onMutedStateUpdate_(isMuted) {
      isMuted ? this.mute_() : this.unmute_();
      isMuted ? this.element.setAttribute(Attributes.MUTED, '') : this.element.removeAttribute(Attributes.MUTED);
    }
    /**
     * Mutes the audio for the story.
     * @private
     */

  }, {
    key: "mute_",
    value: function mute_() {
      this.pauseBackgroundAudio_();

      if (this.activePage_) {
        this.activePage_.muteAllMedia();
      }
    }
    /**
     * Pauses the background audio.
     * @private
     */

  }, {
    key: "pauseBackgroundAudio_",
    value: function pauseBackgroundAudio_() {
      if (!this.backgroundAudioEl_) {
        return;
      }

      this.mediaPool_.pause(this.backgroundAudioEl_);
    }
    /**
     * Unmutes the audio for the story.
     * @private
     */

  }, {
    key: "unmute_",
    value: function unmute_() {
      var _this34 = this;

      var unmuteAllMedia = function unmuteAllMedia() {
        _this34.playBackgroundAudio_();

        if (_this34.activePage_) {
          _this34.activePage_.unmuteAllMedia();
        }
      };

      this.mediaPool_.blessAll().then(unmuteAllMedia, unmuteAllMedia);
    }
    /**
     * Unmutes and plays the background audio.
     * @private
     */

  }, {
    key: "playBackgroundAudio_",
    value: function playBackgroundAudio_() {
      if (!this.backgroundAudioEl_) {
        return;
      }

      this.mediaPool_.unmute(this.backgroundAudioEl_);
      this.mediaPool_.play(this.backgroundAudioEl_);
    }
    /**
     * Shows the audio icon if the story has any media elements containing audio,
     * or background audio at the story or page level.
     * @private
     */

  }, {
    key: "updateAudioIcon_",
    value: function updateAudioIcon_() {
      var containsMediaElementWithAudio = !!this.element.querySelector('amp-audio, amp-video:not([noaudio]), [background-audio]');
      var storyHasBackgroundAudio = this.element.hasAttribute('background-audio');
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_STORY_HAS_AUDIO, containsMediaElementWithAudio || storyHasBackgroundAudio);
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_STORY_HAS_BACKGROUND_AUDIO, storyHasBackgroundAudio);
    }
    /**
     * Shows the play/pause icon if there is an element with playback on the story.
     * @private
     */

  }, {
    key: "updatePausedIcon_",
    value: function updatePausedIcon_() {
      var containsElementsWithPlayback = !!(0, _dom.scopedQuerySelector)(this.element, 'amp-story-grid-layer amp-audio, amp-story-grid-layer amp-video, amp-story-page[background-audio], amp-story-page[auto-advance-after]');
      var storyHasBackgroundAudio = this.element.hasAttribute('background-audio');
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_STORY_HAS_PLAYBACK_UI, containsElementsWithPlayback || storyHasBackgroundAudio);
    }
    /**
     * Handles the selectPage viewer event.
     * @param {!JsonObject} data
     * @private
     */

  }, {
    key: "onSelectPage_",
    value: function onSelectPage_(data) {
      if (!data) {
        return;
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.VIEWER_SELECT_PAGE);

      if (data['next']) {
        this.next_();
      } else if (data['previous']) {
        this.previous_();
      }
    }
    /**
     * Checks for the presence of a sidebar. If a sidebar does exist, then an icon
     * permitting for the opening/closing of the sidebar is shown.
     * @private
     */

  }, {
    key: "initializeSidebar_",
    value: function initializeSidebar_() {
      var _this35 = this;

      this.sidebar_ = this.element.querySelector('amp-sidebar');

      if (!this.sidebar_) {
        return;
      }

      this.mutateElement(function () {
        _this35.sidebar_.classList.add(SIDEBAR_CLASS_NAME);
      });
      this.initializeOpacityMask_();
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_HAS_SIDEBAR, !!this.sidebar_);
      var actions = [{
        tagOrTarget: 'AMP-SIDEBAR',
        method: 'open'
      }, {
        tagOrTarget: 'AMP-SIDEBAR',
        method: 'close'
      }, {
        tagOrTarget: 'AMP-SIDEBAR',
        method: 'toggle'
      }];
      this.storeService_.dispatch(_ampStoryStoreService.Action.ADD_TO_ACTIONS_ALLOWLIST, actions);
    }
    /**
     * Checks for the the storyNavigationPath stack in the history.
     * @private
     */

  }, {
    key: "initializeStoryNavigationPath_",
    value: function initializeStoryNavigationPath_() {
      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_NAVIGATION_PATH, (0, _history.getHistoryState)(this.win, _history.HistoryState.NAVIGATION_PATH) || []);
    }
    /** @private */

  }, {
    key: "replay_",
    value: function replay_() {
      var _this36 = this;

      if (this.storeService_.get(_ampStoryStoreService.StateProperty.BOOKEND_STATE)) {
        this.hideBookend_();
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_NAVIGATION_PATH, []);
      var switchPromise = this.switchTo_((0, _log.dev)().assertElement(this.pages_[0].element).id, _ampStoryPage.NavigationDirection.NEXT);

      // Restart page media, advancements, etc (#27742).
      if (this.pages_.length === 1) {
        this.pages_[0].setState(_ampStoryPage.PageState.NOT_ACTIVE);
        this.pages_[0].setState(_ampStoryPage.PageState.PLAYING);
      }

      // Reset all pages so that they are offscreen to right instead of left in
      // desktop view.
      switchPromise.then(function () {
        _this36.pages_.forEach(function (page) {
          return (0, _utils.removeAttributeInMutate)(page, Attributes.VISITED);
        });
      });
    }
    /**
     * @param {!AmpStoryPage} page The page whose CTA anchor tags should be
     *     upgraded.
     * @param {number} pageIndex The index of the page.
     * @private
     */

  }, {
    key: "upgradeCtaAnchorTagsForTracking_",
    value: function upgradeCtaAnchorTagsForTracking_(page, pageIndex) {
      this.mutateElement(function () {
        var pageId = page.element.id;
        var ctaAnchorEls = (0, _dom.scopedQuerySelectorAll)(page.element, 'amp-story-cta-layer a');
        Array.prototype.forEach.call(ctaAnchorEls, function (ctaAnchorEl) {
          ctaAnchorEl.setAttribute('data-vars-story-page-id', pageId);
          ctaAnchorEl.setAttribute('data-vars-story-page-index', pageIndex);
        });
      });
    }
    /**
     * Add page to back of pages_ array
     * @param {!./amp-story-page.AmpStoryPage} page
     */

  }, {
    key: "addPage",
    value: function addPage(page) {
      this.pages_.push(page);

      if (page.isAd()) {
        this.adPages_.push(page);
      }
    }
    /**
     * Insert a new page in navigation flow by changing the attr pointers
     * on amp-story-page elements
     * @param {string} pageBeforeId
     * @param {string} pageToBeInsertedId
     * @return {boolean} was page inserted
     */

  }, {
    key: "insertPage",
    value: function insertPage(pageBeforeId, pageToBeInsertedId) {
      // TODO(ccordry): make sure this method moves to PageManager when
      // implemented
      var pageToBeInserted = this.getPageById(pageToBeInsertedId);
      var pageToBeInsertedEl = pageToBeInserted.element;

      if (pageToBeInserted.isAd() && !this.storeService_.get(_ampStoryStoreService.StateProperty.CAN_INSERT_AUTOMATIC_AD)) {
        (0, _log.dev)().expectedError(TAG, 'Inserting ads automatically is disallowed.');
        return false;
      }

      var pageBefore = this.getPageById(pageBeforeId);
      var pageBeforeEl = pageBefore.element;
      var nextPage = this.getNextPage(pageBefore);

      if (!nextPage) {
        return false;
      }

      var advanceAttr = (0, _experiments.isExperimentOn)(this.win, 'amp-story-branching') ? Attributes.PUBLIC_ADVANCE_TO : Attributes.ADVANCE_TO;
      pageBeforeEl.setAttribute(advanceAttr, pageToBeInsertedId);
      pageBeforeEl.setAttribute(Attributes.AUTO_ADVANCE_TO, pageToBeInsertedId);
      pageToBeInsertedEl.setAttribute(Attributes.RETURN_TO, pageBeforeId);
      var nextPageEl = nextPage.element;
      var nextPageId = nextPageEl.id;

      // For a live story, nextPage is the same as pageToBeInserted. But not for
      // ads since it's inserted between two pages.
      if (nextPageId !== pageToBeInsertedId) {
        pageToBeInsertedEl.setAttribute(advanceAttr, nextPageId);
        pageToBeInsertedEl.setAttribute(Attributes.AUTO_ADVANCE_TO, nextPageId);
        nextPageEl.setAttribute(Attributes.RETURN_TO, pageToBeInsertedId);
      }

      return true;
    }
    /**
     * Get next page object
     * @param {!./amp-story-page.AmpStoryPage} page
     * @return {?./amp-story-page.AmpStoryPage}
     */

  }, {
    key: "getNextPage",
    value: function getNextPage(page) {
      var nextPageId = page.getNextPageId(true
      /*opt_isAutomaticAdvance */
      );

      if (!nextPageId) {
        return null;
      }

      return this.getPageById(nextPageId);
    }
    /**
     * @param {!Window} win
     * @return {boolean} true if the user's browser supports the features needed
     *     for amp-story.
     */

  }], [{
    key: "isBrowserSupported",
    value: function isBrowserSupported(win) {
      return Boolean(win.CSS && win.CSS.supports && win.CSS.supports('display', 'grid') && win.CSS.supports('color', 'var(--test)'));
    }
  }]);

  return AmpStory;
}(AMP.BaseElement);

exports.AmpStory = AmpStory;
AMP.extension('amp-story', '1.0', function (AMP) {
  AMP.registerElement('amp-story', AmpStory, _ampStory.CSS);
  AMP.registerElement('amp-story-access', _ampStoryAccess.AmpStoryAccess);
  AMP.registerElement('amp-story-bookend', _ampStoryBookend.AmpStoryBookend);
  AMP.registerElement('amp-story-consent', _ampStoryConsent.AmpStoryConsent);
  AMP.registerElement('amp-story-cta-layer', _ampStoryCtaLayer.AmpStoryCtaLayer);
  AMP.registerElement('amp-story-grid-layer', _ampStoryGridLayer.AmpStoryGridLayer);
  AMP.registerElement('amp-story-page', _ampStoryPage.AmpStoryPage);
  AMP.registerElement('amp-story-page-attachment', _ampStoryPageAttachment.AmpStoryPageAttachment);
  AMP.registerServiceForDoc('amp-story-render', _ampStoryRenderService.AmpStoryRenderService);
});

},{"../../../build/amp-story-1.0.css":1,"../../../src/action-constants":96,"../../../src/amp-events":97,"../../../src/common-signals":101,"../../../src/consent":104,"../../../src/css":105,"../../../src/dom":106,"../../../src/event-helper":111,"../../../src/experiments":112,"../../../src/gesture":116,"../../../src/gesture-recognizers":115,"../../../src/history":117,"../../../src/layout":121,"../../../src/localized-strings":122,"../../../src/log":123,"../../../src/mode":124,"../../../src/services":133,"../../../src/string":136,"../../../src/style":138,"../../../src/types":139,"../../../src/url":142,"../../../src/utils/array":143,"../../../src/utils/key-codes":147,"../../../src/utils/object":149,"../../../src/utils/rate-limit":151,"./../../../src/resolved-promise":129,"./_locales/ar":13,"./_locales/de":14,"./_locales/default":15,"./_locales/en":17,"./_locales/en-GB":16,"./_locales/es":19,"./_locales/es-419":18,"./_locales/fr":20,"./_locales/hi":21,"./_locales/id":22,"./_locales/it":23,"./_locales/ja":24,"./_locales/ko":25,"./_locales/nl":26,"./_locales/no":27,"./_locales/pt-BR":28,"./_locales/pt-PT":29,"./_locales/ru":30,"./_locales/tr":31,"./_locales/vi":32,"./_locales/zh-CN":33,"./_locales/zh-TW":34,"./amp-story-access":35,"./amp-story-consent":38,"./amp-story-cta-layer":39,"./amp-story-embedded-component":41,"./amp-story-grid-layer":42,"./amp-story-hint":43,"./amp-story-info-dialog":44,"./amp-story-localization-service":45,"./amp-story-media-query-service":46,"./amp-story-page":48,"./amp-story-page-attachment":47,"./amp-story-render-service":49,"./amp-story-share-menu":51,"./amp-story-store-service":53,"./amp-story-system-layer":54,"./amp-story-unsupported-browser-layer":55,"./amp-story-viewer-messaging-handler":56,"./amp-story-viewport-warning-layer":57,"./audio":63,"./bookend/amp-story-bookend":64,"./events":76,"./history":77,"./live-story-manager":79,"./media-pool":83,"./page-advancement":85,"./pagination-buttons":86,"./story-analytics":91,"./utils":93,"./variable-service":94}],59:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.translate2d = translate2d;
exports.rotateAndTranslate = rotateAndTranslate;
exports.whooshIn = whooshIn;
exports.targetFitsWithinPage = targetFitsWithinPage;
exports.calculateTargetScalingFactor = calculateTargetScalingFactor;
exports.scaleAndTranslate = scaleAndTranslate;

var _animationTypes = require("./animation-types");

var _style = require("../../../src/style");

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Common animations utility functions used in the animation
 * presets.
 */

/**
 * Translates the element on the 2d plane according to the given points.
 * @param {number} startX Starting point in the abscissa.
 * @param {number} startY Starting point in the ordinate.
 * @param {number} endX Ending point in the abscissa.
 * @param {number} endY Ending point in the ordinate.
 * @return {WebKeyframesDef} Keyframes that make up the animation.
 */
function translate2d(startX, startY, endX, endY) {
  return [{
    transform: (0, _style.translate)(startX, startY)
  }, {
    transform: (0, _style.translate)(endX, endY)
  }];
}

/**
 * Translates and rotates the element on the 2d plane.
 * @param {number} startX Starting point in the abscissa.
 * @param {number} startY Starting point in the ordinate.
 * @param {number} endX Ending point in the abscissa.
 * @param {number} endY Ending point in the ordinate.
 * @param {number} direction -1 for left, 1 for right
 * @return {WebKeyframesDef} Keyframes that make up the animation.
 */
function rotateAndTranslate(startX, startY, endX, endY, direction) {
  return [{
    transform: (0, _style.translate)(startX, startY) + ' ' + (0, _style.rotate)(direction * 120)
  }, {
    transform: (0, _style.translate)(endX, endY) + ' ' + (0, _style.rotate)(0)
  }];
}

/**
 * Gradually shows and grows the element while translating it on the 2d plane.
 * @param {number} startX Starting point in the abscissa.
 * @param {number} startY Starting point in the ordinate.
 * @param {number} endX Ending point in the abscissa.
 * @param {number} endY Ending point in the ordinate.
 * @return {WebKeyframesDef} Keyframes that make up the animation.
 */
function whooshIn(startX, startY, endX, endY) {
  return [{
    opacity: 0,
    transform: (0, _style.translate)(startX, startY) + ' ' + (0, _style.scale)(0.15)
  }, {
    opacity: 1,
    transform: (0, _style.translate)(endX, endY) + ' ' + (0, _style.scale)(1)
  }];
}

/**
 * Checks if either of the target's dimensions are smaller than or equal to
 * those of the page.
 * @param {StoryAnimationDimsDef} dimensions Dimensions of page and target.
 * @return {boolean}
 * @visibleForTesting
 */
function targetFitsWithinPage(dimensions) {
  return dimensions.targetWidth <= dimensions.pageWidth || dimensions.targetHeight <= dimensions.pageHeight;
}

/**
 * Calculate target scaling factor so that it is at least 25% larger than the
 * page.
 * @param {StoryAnimationDimsDef} dimensions Dimensions of page and target.
 * @return {number}
 */
function calculateTargetScalingFactor(dimensions) {
  if (targetFitsWithinPage(dimensions)) {
    var scalingFactor = 1.25;
    var widthFactor = dimensions.pageWidth > dimensions.targetWidth ? dimensions.pageWidth / dimensions.targetWidth : 1;
    var heightFactor = dimensions.pageHeight > dimensions.targetHeight ? dimensions.pageHeight / dimensions.targetHeight : 1;
    return Math.max(widthFactor, heightFactor) * scalingFactor;
  }

  return 1;
}

/**
 * Scale the image in every frame by a certain factor.
 * @param {WebKeyframesDef} keyframes Keyframes that will be used for the animation.
 * @param {number} scalingFactor Scaling factor at which target will be scaled.
 * @return {WebKeyframesDef}
 */
function enlargeKeyFrames(keyframes, scalingFactor) {
  /** @type {!Array} */
  keyframes.forEach(function (frame) {
    frame['transform'] += ' ' + (0, _style.scale)(scalingFactor);
    frame['transform-origin'] = 'left top';
  });
  return keyframes;
}

/**
 * Translates the element and scales it if necessary.
 * @param {number} startX Starting point in the abscissa.
 * @param {number} startY Starting point in the ordinate.
 * @param {number} endX Ending point in the abscissa.
 * @param {number} endY Ending point in the ordinate.
 * @param {number} scalingFactor Factor by which target will be scaled.
 * @return {WebKeyframesDef} Keyframes that make up the animation.
 */
function scaleAndTranslate(startX, startY, endX, endY, scalingFactor) {
  if (scalingFactor === 1) {
    return translate2d(startX, startY, endX, endY);
  }

  return enlargeKeyFrames(translate2d(startX, startY, endX, endY), scalingFactor);
}

},{"../../../src/style":138,"./animation-types":61}],60:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.setStyleForPreset = setStyleForPreset;
exports.presets = exports.PRESET_OPTION_ATTRIBUTES = void 0;

var _ampStoryGridLayer = require("./amp-story-grid-layer");

var _animationTypes = require("./animation-types");

var _animationPresetsUtils = require("./animation-presets-utils");

var _style = require("../../../src/style");

var _log = require("../../../src/log");

var _ANIMATION_CSS_CLASS_;

/** @const {string} */
var FULL_BLEED_CATEGORY = 'full-bleed';

/** @const {string} */
var FILL_TEMPLATE_LAYOUT = 'fill';

/** @const {number} */
var SCALE_HIGH_DEFAULT = 3;

/** @const {number} */
var SCALE_LOW_DEFAULT = 1;

/** @const {string} */
var SCALE_START_ATTRIBUTE_NAME = 'scale-start';

/** @const {string} */
var SCALE_END_ATTRIBUTE_NAME = 'scale-end';

/** @const {string} */
var TRANSLATE_X_ATTRIBUTE_NAME = 'translate-x';

/** @const {string} */
var TRANSLATE_Y_ATTRIBUTE_NAME = 'translate-y';

/** @const {string} */
var DEFAULT_CURVE = '0.4, 0.4, 0.0, 1';

/** @const {!Array<string>} */
var PRESET_OPTION_ATTRIBUTES = [SCALE_START_ATTRIBUTE_NAME, SCALE_END_ATTRIBUTE_NAME, TRANSLATE_X_ATTRIBUTE_NAME, TRANSLATE_Y_ATTRIBUTE_NAME];
exports.PRESET_OPTION_ATTRIBUTES = PRESET_OPTION_ATTRIBUTES;

/**
 * A list of animations that are full bleed.
 * @private @const {!Array<string>}
 */
var FULL_BLEED_ANIMATION_NAMES = ['pan-up', 'pan-down', 'pan-right', 'pan-left', 'zoom-in', 'zoom-out'];

/**
 * A mapping of animation categories to corresponding CSS class names.
 * @private @const {!Object<string, string>}
 */
var ANIMATION_CSS_CLASS_NAMES = (_ANIMATION_CSS_CLASS_ = {}, _ANIMATION_CSS_CLASS_[FULL_BLEED_CATEGORY] = 'i-amphtml-story-grid-template-with-full-bleed-animation', _ANIMATION_CSS_CLASS_);

/**
 * Perform style-specific operations for presets.
 * @param {!Element} el
 * @param {string} presetName
 */
function setStyleForPreset(el, presetName) {
  // For full bleed animations.
  if (FULL_BLEED_ANIMATION_NAMES.indexOf(presetName) >= 0) {
    var parent = el.parentElement;

    if (parent.classList.contains(_ampStoryGridLayer.GRID_LAYER_TEMPLATE_CLASS_NAMES[FILL_TEMPLATE_LAYOUT])) {
      parent.classList.remove(_ampStoryGridLayer.GRID_LAYER_TEMPLATE_CLASS_NAMES[FILL_TEMPLATE_LAYOUT]);
    }

    parent.classList.add(ANIMATION_CSS_CLASS_NAMES[FULL_BLEED_CATEGORY]);
  }
}

/**
 * First keyframe will always be considered offset: 0 and will be applied to the
 * element as the first frame before animation starts.
 * @type {!Object<string, !StoryAnimationPresetDef>}
 */
var presets = {
  'pulse': {
    duration: 600,
    easing: 'cubic-bezier(0.3, 0.0, 0.0, 1)',
    keyframes: [{
      offset: 0,
      transform: 'scale(1)'
    }, {
      offset: 0.25,
      transform: 'scale(0.95)'
    }, {
      offset: 0.75,
      transform: 'scale(1.05)'
    }, {
      offset: 1,
      transform: 'scale(1)'
    }]
  },
  'fly-in-left': {
    duration: 600,
    easing: "cubic-bezier(0.2, 0.6, 0.0, 1)",
    keyframes: function keyframes(dimensions) {
      var offsetX = -(dimensions.targetX + dimensions.targetWidth);
      return (0, _animationPresetsUtils.translate2d)(offsetX, 0, 0, 0);
    }
  },
  'fly-in-right': {
    duration: 600,
    easing: "cubic-bezier(0.2, 0.6, 0.0, 1)",
    keyframes: function keyframes(dimensions) {
      var offsetX = dimensions.pageWidth - dimensions.targetX;
      return (0, _animationPresetsUtils.translate2d)(offsetX, 0, 0, 0);
    }
  },
  'fly-in-top': {
    duration: 600,
    easing: "cubic-bezier(0.2, 0.6, 0.0, 1)",
    keyframes: function keyframes(dimensions) {
      var offsetY = -(dimensions.targetY + dimensions.targetHeight);
      return (0, _animationPresetsUtils.translate2d)(0, offsetY, 0, 0);
    }
  },
  'fly-in-bottom': {
    duration: 600,
    easing: "cubic-bezier(0.2, 0.6, 0.0, 1)",
    keyframes: function keyframes(dimensions) {
      var offsetY = dimensions.pageHeight - dimensions.targetY;
      return (0, _animationPresetsUtils.translate2d)(0, offsetY, 0, 0);
    }
  },
  'rotate-in-left': {
    duration: 1000,
    easing: "cubic-bezier(" + DEFAULT_CURVE + ")",
    keyframes: function keyframes(dimensions) {
      var offsetX = -(dimensions.targetX + dimensions.targetWidth);
      return (0, _animationPresetsUtils.rotateAndTranslate)(offsetX, 0, 0, 0, -1);
    }
  },
  'rotate-in-right': {
    duration: 1000,
    easing: "cubic-bezier(" + DEFAULT_CURVE + ")",
    keyframes: function keyframes(dimensions) {
      var offsetX = dimensions.pageWidth - dimensions.targetX;
      return (0, _animationPresetsUtils.rotateAndTranslate)(offsetX, 0, 0, 0, 1);
    }
  },
  'fade-in': {
    duration: 600,
    easing: "cubic-bezier(" + DEFAULT_CURVE + ")",
    keyframes: [{
      opacity: 0
    }, {
      opacity: 1
    }]
  },
  'drop': {
    duration: 1600,
    keyframes: function keyframes(dimensions) {
      var maxBounceHeight = Math.max(160, dimensions.targetY + dimensions.targetHeight);
      // addapted from https://easings.net/#easeOutBounce
      return [{
        offset: 0,
        transform: "translateY(" + (0, _style.px)((1 - 0) * -maxBounceHeight) + ")"
      }, {
        offset: 0.35,
        transform: "translateY(" + (0, _style.px)((1 - 0.9801) * -maxBounceHeight) + ")",
        easing: 'cubic-bezier(0,.3,.3,0)'
      }, {
        offset: 0.45,
        transform: "translateY(" + (0, _style.px)((1 - 0.7502) * -maxBounceHeight) + ")",
        easing: 'cubic-bezier(0,.3,.3,0)'
      }, {
        offset: 0.75,
        transform: "translateY(" + (0, _style.px)((1 - 0.9837) * -maxBounceHeight) + ")",
        easing: 'cubic-bezier(0,.3,.3,0)'
      }, {
        offset: 0.82,
        transform: "translateY(" + (0, _style.px)((1 - 0.9375) * -maxBounceHeight) + ")",
        easing: 'cubic-bezier(0,.3,.3,0)'
      }, {
        offset: 0.92,
        transform: "translateY(" + (0, _style.px)((1 - 0.9934) * -maxBounceHeight) + ")",
        easing: 'cubic-bezier(0,.3,.3,0)'
      }, {
        offset: 0.96,
        transform: "translateY(" + (0, _style.px)((1 - 0.9846) * -maxBounceHeight) + ")",
        easing: 'cubic-bezier(0,.3,.3,0)'
      }, {
        offset: 1,
        transform: "translateY(0)",
        easing: 'cubic-bezier(0,.3,.3,1)'
      }];
    }
  },
  'twirl-in': {
    duration: 1000,
    easing: "cubic-bezier(" + DEFAULT_CURVE + ")",
    keyframes: [{
      transform: 'rotate(-540deg) scale(0.1)',
      opacity: 0
    }, {
      transform: 'none',
      opacity: 1
    }]
  },
  'whoosh-in-left': {
    duration: 600,
    easing: "cubic-bezier(" + DEFAULT_CURVE + ")",
    keyframes: function keyframes(dimensions) {
      var offsetX = -(dimensions.targetX + dimensions.targetWidth);
      return (0, _animationPresetsUtils.whooshIn)(offsetX, 0, 0, 0);
    }
  },
  'whoosh-in-right': {
    duration: 600,
    easing: "cubic-bezier(" + DEFAULT_CURVE + ")",
    keyframes: function keyframes(dimensions) {
      var offsetX = dimensions.pageWidth - dimensions.targetX;
      return (0, _animationPresetsUtils.whooshIn)(offsetX, 0, 0, 0);
    }
  },
  'pan-left': {
    duration: 1000,
    easing: 'linear',
    keyframes: function keyframes(dimensions, options) {
      var translateX = options[TRANSLATE_X_ATTRIBUTE_NAME];
      var scalingFactor = (0, _animationPresetsUtils.calculateTargetScalingFactor)(dimensions);
      dimensions.targetWidth *= scalingFactor;
      dimensions.targetHeight *= scalingFactor;
      var offsetX = dimensions.pageWidth - dimensions.targetWidth;
      var offsetY = (dimensions.pageHeight - dimensions.targetHeight) / 2;
      return (0, _animationPresetsUtils.scaleAndTranslate)(offsetX, offsetY, translateX ? offsetX + translateX : 0, offsetY, scalingFactor);
    }
  },
  'pan-right': {
    duration: 1000,
    easing: 'linear',
    keyframes: function keyframes(dimensions, options) {
      var translateX = options[TRANSLATE_X_ATTRIBUTE_NAME];
      var scalingFactor = (0, _animationPresetsUtils.calculateTargetScalingFactor)(dimensions);
      dimensions.targetWidth *= scalingFactor;
      dimensions.targetHeight *= scalingFactor;
      var offsetX = dimensions.pageWidth - dimensions.targetWidth;
      var offsetY = (dimensions.pageHeight - dimensions.targetHeight) / 2;
      return (0, _animationPresetsUtils.scaleAndTranslate)(0, offsetY, -translateX || offsetX, offsetY, scalingFactor);
    }
  },
  'pan-down': {
    duration: 1000,
    easing: 'linear',
    keyframes: function keyframes(dimensions, options) {
      var translateY = options[TRANSLATE_Y_ATTRIBUTE_NAME];
      var scalingFactor = (0, _animationPresetsUtils.calculateTargetScalingFactor)(dimensions);
      dimensions.targetWidth *= scalingFactor;
      dimensions.targetHeight *= scalingFactor;
      var offsetX = -dimensions.targetWidth / 2;
      var offsetY = dimensions.pageHeight - dimensions.targetHeight;
      return (0, _animationPresetsUtils.scaleAndTranslate)(offsetX, 0, offsetX, -translateY || offsetY, scalingFactor);
    }
  },
  'pan-up': {
    duration: 1000,
    easing: 'linear',
    keyframes: function keyframes(dimensions, options) {
      var translateY = options[TRANSLATE_Y_ATTRIBUTE_NAME];
      var scalingFactor = (0, _animationPresetsUtils.calculateTargetScalingFactor)(dimensions);
      dimensions.targetWidth *= scalingFactor;
      dimensions.targetHeight *= scalingFactor;
      var offsetX = -dimensions.targetWidth / 2;
      var offsetY = dimensions.pageHeight - dimensions.targetHeight;
      return (0, _animationPresetsUtils.scaleAndTranslate)(offsetX, offsetY, offsetX, translateY ? offsetY + translateY : 0, scalingFactor);
    }
  },
  'zoom-in': {
    duration: 1000,
    easing: 'linear',
    keyframes: function keyframes(unusedDimensions, options) {
      var scaleStart = options[SCALE_START_ATTRIBUTE_NAME];
      var scaleEnd = options[SCALE_END_ATTRIBUTE_NAME];

      if (scaleStart) {
        (0, _log.userAssert)(scaleEnd > scaleStart, '"scale-end" value must be greater ' + 'than "scale-start" value when using "zoom-in" animation.');
      }

      return [{
        transform: "scale(" + (scaleStart || SCALE_LOW_DEFAULT) + ")"
      }, {
        transform: "scale(" + (scaleEnd || SCALE_HIGH_DEFAULT) + ")"
      }];
    }
  },
  'zoom-out': {
    duration: 1000,
    easing: 'linear',
    keyframes: function keyframes(unusedDimensions, options) {
      var scaleStart = options[SCALE_START_ATTRIBUTE_NAME];
      var scaleEnd = options[SCALE_END_ATTRIBUTE_NAME];

      if (scaleStart) {
        (0, _log.userAssert)(scaleStart > scaleEnd, '"scale-start" value must be ' + 'higher than "scale-end" value when using "zoom-out" animation.');
      }

      return [{
        transform: "scale(" + (scaleStart || SCALE_HIGH_DEFAULT) + ")"
      }, {
        transform: "scale(" + (scaleEnd || SCALE_LOW_DEFAULT) + ")"
      }];
    }
  }
};
exports.presets = presets;

},{"../../../src/log":123,"../../../src/style":138,"./amp-story-grid-layer":42,"./animation-presets-utils":59,"./animation-types":61}],61:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.StoryAnimationConfigDef = exports.StoryAnimationPresetDef = exports.StoryAnimationDimsDef = exports.WebKeyframesCreateFnDef = void 0;

var _webAnimationTypes = require("../../amp-animation/0.1/web-animation-types");

exports.WebAnimationBuilderOptionsDef = _webAnimationTypes.WebAnimationBuilderOptionsDef;
exports.WebAnimationDef = _webAnimationTypes.WebAnimationDef;
exports.WebAnimationPlayState = _webAnimationTypes.WebAnimationPlayState;
exports.WebAnimationSelectorDef = _webAnimationTypes.WebAnimationSelectorDef;
exports.WebAnimationTimingDef = _webAnimationTypes.WebAnimationTimingDef;
exports.WebKeyframesDef = _webAnimationTypes.WebKeyframesDef;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @typedef {function(StoryAnimationDimsDef, Object<string, *>):!WebKeyframesDef} */
var WebKeyframesCreateFnDef;
exports.WebKeyframesCreateFnDef = WebKeyframesCreateFnDef;

/**
 * @typedef {{
 *   pageWidth: number,
 *   pageHeight: number,
 *   targetWidth: number,
 *   targetHeight: number,
 *   targetX: number,
 *   targetY: number,
 * }}
 */
var StoryAnimationDimsDef;
exports.StoryAnimationDimsDef = StoryAnimationDimsDef;

/**
 * @typedef {{
 *   duration: number,
 *   easing: (string|undefined),
 *   keyframes: (!WebKeyframesCreateFnDef|!WebKeyframesDef),
 * }}
 */
var StoryAnimationPresetDef;
exports.StoryAnimationPresetDef = StoryAnimationPresetDef;

/**
 * @typedef {{
 *   source: !Element,
 *   startAfterId: (?string),
 *   preset: (!StoryAnimationPresetDef|undefined),
 *   keyframeOptions: (!Object<string, *>|undefined),
 *   spec: !WebAnimationDef,
 * }}
 *
 * - source: Element that defines this animation. This is either an
 *   <amp-story-animation> element with a JSON spec, or an animated element with
 *   a preset that is the same as the target ([animate-in] elements).
 *
 * - startAfterId: This animation is sequenced after the animation defined by
 *   the element with this id.
 *
 * - preset: Optional, when using [animate-in]
 *
 * - keyframeOptions: These are taken from element attributes and passed to a
 *   preset keyframes() function.
 *
 * - spec: An effect spec defined like in <amp-animation>. If a preset is also
 *   provided, the spec's keyframes property will be resolved with the preset
 *   configuration.
 */
var StoryAnimationConfigDef;
exports.StoryAnimationConfigDef = StoryAnimationConfigDef;

},{"../../amp-animation/0.1/web-animation-types":12}],62:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.hasAnimations = hasAnimations;
exports.AnimationSequence = exports.AnimationManager = exports.AnimationRunner = exports.ANIMATE_IN_ATTRIBUTE_NAME = void 0;

var _resolvedPromise4 = require("./../../../src/resolved-promise");

var _promise = require("../../../src/utils/promise");

var _animationPresets = require("./animation-presets");

var _services = require("../../../src/services");

var _animationTypes = require("./animation-types");

var _style = require("../../../src/style");

var _log = require("../../../src/log");

var _css = require("../../../src/css");

var _json = require("../../../src/json");

var _object = require("../../../src/utils/object");

var _dom = require("../../../src/dom");

var _utils = require("./utils");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TAG = 'AMP-STORY';

/** @const {string} */
var ANIMATE_IN_ATTRIBUTE_NAME = 'animate-in';
exports.ANIMATE_IN_ATTRIBUTE_NAME = ANIMATE_IN_ATTRIBUTE_NAME;

/** @const {string} */
var ANIMATE_IN_DURATION_ATTRIBUTE_NAME = 'animate-in-duration';

/** @const {string} */
var ANIMATE_IN_DELAY_ATTRIBUTE_NAME = 'animate-in-delay';

/** @const {string} */
var ANIMATE_IN_AFTER_ATTRIBUTE_NAME = 'animate-in-after';

/** @const {string} */
var ANIMATE_IN_TIMING_FUNCTION_ATTRIBUTE_NAME = 'animate-in-timing-function';

/** @const {string} */
var ANIMATABLE_ELEMENTS_SELECTOR = "[" + ANIMATE_IN_ATTRIBUTE_NAME + "]";

/** @const {string} */
var DEFAULT_EASING = 'cubic-bezier(0.4, 0.0, 0.2, 1)';

/**
 * @param {!Element} element
 * @return {boolean}
 * TODO(alanorozco): maybe memoize?
 */
function hasAnimations(element) {
  var selector = ANIMATABLE_ELEMENTS_SELECTOR + ",>amp-story-animation";
  return !!(0, _dom.scopedQuerySelector)(element, selector);
}

/** @enum {number} */
var PlaybackActivity = {
  START: 0,
  FINISH: 1
};

/**
 * @param {!Element} root
 * @param {!Element} element
 * @return {?string}
 */
function getSequencingStartAfterId(root, element) {
  if (!element.hasAttribute(ANIMATE_IN_AFTER_ATTRIBUTE_NAME)) {
    return null;
  }

  var dependencyId = element.getAttribute(ANIMATE_IN_AFTER_ATTRIBUTE_NAME);

  if (!root.querySelector("#" + (0, _css.escapeCssSelectorIdent)(dependencyId))) {
    (0, _log.user)().warn(TAG, "The attribute '" + ANIMATE_IN_AFTER_ATTRIBUTE_NAME + "' in tag " + ("'" + element.tagName + "' is set to the invalid value ") + ("'" + dependencyId + "'. No children of parenting 'amp-story-page' ") + ("exist with id " + dependencyId + "."));
    return null;
  }

  return dependencyId;
}

/** Wraps WebAnimationRunner for story page elements. */
var AnimationRunner = /*#__PURE__*/function () {
  /**
   * @param {!Element} page
   * @param {!StoryAnimationConfigDef} config
   * @param {!Promise<!../../amp-animation/0.1/web-animations.Builder>} webAnimationBuilderPromise
   * @param {!../../../src/service/vsync-impl.Vsync} vsync
   * @param {!AnimationSequence} sequence
   */
  function AnimationRunner(page, config, webAnimationBuilderPromise, vsync, sequence) {
    var _this = this;

    _classCallCheck(this, AnimationRunner);

    var source = config.source,
        preset = config.preset,
        startAfterId = config.startAfterId,
        spec = config.spec;

    /** @private @const */
    this.page_ = page;

    /** @private @const */
    this.source_ = source;

    /** @private @const */
    this.vsync_ = vsync;

    /** @private @const {?Element} */
    this.presetTarget_ = !!preset ? (0, _log.dev)().assertElement(spec.target) : null;

    /** @private @const */
    this.sequence_ = sequence;

    /** @private @const {?string} */
    this.startAfterId_ = startAfterId;

    /** @private @const {!Promise<!WebAnimationDef>} */
    this.resolvedSpecPromise_ = this.resolveSpec_(config);

    /**
     * @private @const {!Promise<
     *    !../../amp-animation/0.1/runners/animation-runner.AnimationRunner>}
     */
    this.runnerPromise_ = this.resolvedSpecPromise_.then(function (webAnimDef) {
      return webAnimationBuilderPromise.then(function (builder) {
        return builder.createRunner(webAnimDef);
      });
    });

    /**
     * Evaluated set of CSS properties for first animation frame.
     * @private @const {!Promise<?Object<string, *>>}
     */
    this.firstFrameProps_ = this.resolvedSpecPromise_.then(function (spec) {
      var keyframes = spec.keyframes;

      if (!_this.presetTarget_) {
        // It's only possible to backfill the first frame if we can define it
        // as native CSS. <amp-animation> has CSS extensions and can have
        // keyframes defined in a way that prevents us from doing this.
        //
        // To avoid visual jumps, this depends on the author properly
        // defining their CSS so that the initial visual state matches the
        // initial animation frame.
        return null;
      }

      (0, _log.devAssert)(!keyframes[0].offset, 'First keyframe offset for animation preset should be 0 or undefined');
      return (0, _object.omit)(keyframes[0], ['offset']);
    });

    /** @private {?../../amp-animation/0.1/runners/animation-runner.AnimationRunner} */
    this.runner_ = null;

    /** @private {?PlaybackActivity} */
    this.scheduledActivity_ = null;

    /** @private {?Promise} */
    this.scheduledWait_ = null;

    if (this.presetTarget_) {
      var delay =
      /** @type {!WebAnimationTimingDef} */
      spec.delay;
      (0, _log.userAssert)((0, _log.dev)().assertNumber(delay) >= 0, 'Negative delays are not allowed in amp-story "animate-in" animations.');
    }

    this.runnerPromise_.then(function (runner) {
      return _this.onRunnerReady_(runner);
    });
  }

  /**
   * @param {!Element} page
   * @param {!StoryAnimationConfigDef} config
   * @param {!Promise<!../../amp-animation/0.1/web-animations.Builder>} webAnimationBuilderPromise
   * @param {!../../../src/service/vsync-impl.Vsync} vsync
   * @param {!AnimationSequence} sequence
   * @return {!AnimationRunner}
   */
  _createClass(AnimationRunner, [{
    key: "getDims",

    /**
     * @return {!Promise<!StoryAnimationDimsDef>}
     * @visibleForTesting
     */
    value: function getDims() {
      var _this2 = this;

      return this.vsync_.measurePromise(function () {
        var target = (0, _log.dev)().assertElement(_this2.presetTarget_);
        var targetRect = (0, _utils.unscaledClientRect)(target);
        var pageRect = (0, _utils.unscaledClientRect)(_this2.page_);
        // TODO(alanorozco, https://go.amp.dev/issue/27758):
        // Expose equivalents to <amp-animation>
        // - targetWidth/targetHeight are already available as width()/height()
        // - pageWidth/pageHeight should be exposed as vw/vh
        // - targetX/targetY should be exposed somehow (?)
        //
        // TODO(alanorozco, https://go.amp.dev/issue/27758):
        // After exposing these to <amp-animation> syntax, we
        // can get rid of this entire method (and this async chain!) if we ensure
        // that presets avoid visual jumps either via:
        // a) default styles and/or
        // b) by not using special <amp-animation> syntax in initial keyframe.
        return (
          /** @type {!StoryAnimationDimsDef} */
          {
            pageWidth: pageRect.width,
            pageHeight: pageRect.height,
            targetWidth: targetRect.width,
            targetHeight: targetRect.height,
            targetX: targetRect.left - pageRect.left,
            targetY: targetRect.top - pageRect.top
          }
        );
      });
    }
    /**
     * Evaluates a preset's keyframes function using dimensions.
     * @param {!WebKeyframesDef|!WebKeyframesCreateFnDef} keyframesOrCreateFn
     * @param {!Object<string, *>=} keyframeOptions
     * @return {!Promise<!WebKeyframesDef>}
     * @private
     */

  }, {
    key: "resolvePresetKeyframes_",
    value: function resolvePresetKeyframes_(keyframesOrCreateFn, keyframeOptions) {
      if (typeof keyframesOrCreateFn === 'function') {
        return this.getDims().then(function (dimensions) {
          var fn =
          /** @type {!WebKeyframesCreateFnDef} */
          keyframesOrCreateFn;
          return fn(dimensions, keyframeOptions || {});
        });
      }

      return Promise.resolve(keyframesOrCreateFn);
    }
    /**
     * Resolves an animation spec that may be incomplete, like from an
     * [animate-in] preset.
     * @param {!StoryAnimationConfigDef} config
     * @return {!Promise<!WebAnimationDef>}
     */

  }, {
    key: "resolveSpec_",
    value: function resolveSpec_(config) {
      var keyframeOptions = config.keyframeOptions,
          preset = config.preset,
          spec = config.spec;

      if (!preset) {
        // This is an amp-animation config, so it's already formed how the
        // WebAnimations Builder wants it.
        return Promise.resolve(
        /** @type {!WebAnimationDef} */
        spec);
      }

      // The need for this cast is an unfortunate result of using @mixes in
      // WebAnimationDef. Otherwise Closure will not understand the timing props
      // mixed in from another type.
      var delay =
      /** @type {!WebAnimationTimingDef} */
      spec.delay,
          duration = spec.duration,
          easing = spec.easing;
      var target =
      /** @type {!WebAnimationSelectorDef} */
      spec.target;
      return this.resolvePresetKeyframes_(preset.keyframes, keyframeOptions).then(function (keyframes) {
        return {
          keyframes: keyframes,
          target: target,
          delay: delay,
          duration: duration,
          easing: easing,
          fill: 'forwards'
        };
      });
    }
    /**
     * Applies the first animation frame as CSS props. This is similar to filling
     * the animation backwards, except:
     * - it evaluates before amp-animation is ready to prevent a race and cause
     *   a visual jump before being able to fill the first frame
     * - it allows for sequencing before an animation has started, like with
     *   `animate-in-after`.
     * @return {!Promise<void>}
     */

  }, {
    key: "applyFirstFrame",
    value: function applyFirstFrame() {
      var _this3 = this;

      if (this.hasStarted()) {
        return (0, _resolvedPromise4.resolvedPromise)();
      }

      if (this.runner_) {
        this.runner_.cancel();
      }

      return this.firstFrameProps_.then(function (firstFrameProps) {
        if (!firstFrameProps) {
          // These are only available when they can be evaluated:
          // - delay is not negative
          // - first frame is defined in plain CSS, so it does not use special
          //   <amp-animation> CSS syntax/extensions.
          //
          // We can't guarantee any of these properties when using
          // <amp-story-animation> effects, but we can do it for our own presets.
          return;
        }

        return _this3.vsync_.mutatePromise(function () {
          (0, _style.setStyles)((0, _log.dev)().assertElement(_this3.presetTarget_), (0, _style.assertDoesNotContainDisplay)((0, _log.devAssert)(firstFrameProps)));
        });
      });
    }
    /** Starts or resumes the animation. */

  }, {
    key: "start",
    value: function start() {
      if (this.hasStarted()) {
        return;
      }

      this.playback_(PlaybackActivity.START, this.getStartWaitPromise_());
    }
    /**
     * @return {!Promise}
     * @private
     */

  }, {
    key: "getStartWaitPromise_",
    value: function getStartWaitPromise_() {
      if (this.startAfterId_) {
        return this.sequence_.waitFor(this.startAfterId_);
      }

      return (0, _resolvedPromise4.resolvedPromise)();
    }
    /**
     * @param {!../../amp-animation/0.1/runners/animation-runner.AnimationRunner} runner
     * @private
     */

  }, {
    key: "startWhenReady_",
    value: function startWhenReady_(runner) {
      runner.start();
    }
    /** @return {boolean} */

  }, {
    key: "hasStarted",
    value: function hasStarted() {
      return this.isActivityScheduled_(PlaybackActivity.START) || !!this.runner_ && (0, _log.devAssert)(this.runner_).getPlayState() == _animationTypes.WebAnimationPlayState.RUNNING;
    }
    /** Force-finishes all animations. */

  }, {
    key: "finish",
    value: function finish() {
      if (!this.runner_) {
        this.notifyFinish_();
      }

      this.playback_(PlaybackActivity.FINISH);
    }
    /** Pauses the animation. */

  }, {
    key: "pause",
    value: function pause() {
      // Animation hasn't started yet since it's waiting for a sequenced
      // animation.
      if (this.scheduledWait_ !== null) {
        return;
      }

      if (this.runner_) {
        try {
          this.runner_.pause();
        } catch (e) {// This fails when the animation is finished explicitly
          // (runner.finish()) since this destroys internal players. This is fine.
        }
      }
    }
    /** Resumes the animation. */

  }, {
    key: "resume",
    value: function resume() {
      // Animation hasn't started yet since it's waiting for a sequenced
      // animation.
      if (this.scheduledWait_ !== null) {
        return;
      }

      if (this.runner_) {
        (0, _log.devAssert)(this.runner_).resume();
      }
    }
    /**
     * @param {!../../amp-animation/0.1/runners/animation-runner.AnimationRunner} runner
     * @private
     */

  }, {
    key: "finishWhenReady_",
    value: function finishWhenReady_(runner) {
      if (this.runner_) {
        // Init or no-op if the runner was already running.
        runner.start();
        runner.finish();
      }
    }
    /** Cancels animation. */

  }, {
    key: "cancel",
    value: function cancel() {
      this.scheduledActivity_ = null;
      this.scheduledWait_ = null;

      if (this.runner_) {
        (0, _log.devAssert)(this.runner_).cancel();
      }
    }
    /**
     * @param {!PlaybackActivity} activity
     * @param {!Promise=} opt_wait
     * @private
     */

  }, {
    key: "playback_",
    value: function playback_(activity, opt_wait) {
      var wait = opt_wait || null;
      this.scheduledActivity_ = activity;
      this.scheduledWait_ = wait;

      if (this.runner_) {
        this.playbackWhenReady_(activity, wait);
      }
    }
    /**
     * Executes playback activity if runner is ready.
     * @param {!PlaybackActivity} activity
     * @param {?Promise} wait
     * @private
     */

  }, {
    key: "playbackWhenReady_",
    value: function playbackWhenReady_(activity, wait) {
      var _this4 = this;

      var runner =
      /**
       * @type {!../../amp-animation/0.1/runners/animation-runner.AnimationRunner}
       */
      (0, _log.devAssert)(this.runner_, 'Tried to execute playbackWhenReady_ before runner was resolved.');
      (wait || (0, _resolvedPromise4.resolvedPromise)()).then(function () {
        if (!_this4.isActivityScheduled_(activity)) {
          return;
        }

        _this4.scheduledActivity_ = null;
        _this4.scheduledWait_ = null;

        switch (activity) {
          case PlaybackActivity.START:
            return _this4.startWhenReady_(runner);

          case PlaybackActivity.FINISH:
            return _this4.finishWhenReady_(runner);
        }
      });
    }
    /**
     * Marks runner as ready and executes playback activity if needed.
     * @param {!../../amp-animation/0.1/runners/animation-runner.AnimationRunner} runner
     * @private
     */

  }, {
    key: "onRunnerReady_",
    value: function onRunnerReady_(runner) {
      var _this5 = this;

      this.runner_ = runner;
      runner.onPlayStateChanged(function (state) {
        if (state == _animationTypes.WebAnimationPlayState.FINISHED) {
          _this5.notifyFinish_();
        }
      });

      if (!this.isActivityScheduled_()) {
        return;
      }

      this.playbackWhenReady_(
      /** @type {!PlaybackActivity} */
      this.scheduledActivity_, this.scheduledWait_);
    }
    /**
     * @param {!PlaybackActivity=} opt_activity
     * @return {boolean}
     * @private
     */

  }, {
    key: "isActivityScheduled_",
    value: function isActivityScheduled_(opt_activity) {
      if (!opt_activity) {
        return this.scheduledActivity_ !== null;
      }

      return this.scheduledActivity_ === opt_activity;
    }
    /** @private */

  }, {
    key: "notifyFinish_",
    value: function notifyFinish_() {
      if (this.source_.id) {
        this.sequence_.notifyFinish(this.source_.id);
      }
    }
  }], [{
    key: "create",
    value: function create(page, config, webAnimationBuilderPromise, vsync, sequence) {
      return new AnimationRunner(page, config, webAnimationBuilderPromise, vsync, sequence);
    }
  }]);

  return AnimationRunner;
}();

exports.AnimationRunner = AnimationRunner;

// TODO(alanorozco): Looping animations

/** Manager for animations in story pages. */
var AnimationManager = /*#__PURE__*/function () {
  /**
   * @param {!Element} page
   * @param {!../../../src/service/ampdoc-impl.AmpDoc} ampdoc
   */
  function AnimationManager(page, ampdoc) {
    _classCallCheck(this, AnimationManager);

    /** @private @const */
    this.page_ = page;

    /** @private @const */
    this.ampdoc_ = ampdoc;

    /** @private @const */
    this.vsync_ = _services.Services.vsyncFor(this.ampdoc_.win);

    /** @private @const */
    this.builderPromise_ = this.createAnimationBuilderPromise_();

    /** @private {?Array<!AnimationRunner>} */
    this.runners_ = null;

    /** @private */
    this.sequence_ = AnimationSequence.create();
  }

  /**
   * Decouples constructor so it can be stubbed in tests.
   * @param {!Element} page
   * @param {!../../../src/service/ampdoc-impl.AmpDoc} ampdoc
   * @param {string} unusedBaseUrl
   * @return {!AnimationManager}
   */
  _createClass(AnimationManager, [{
    key: "applyFirstFrame",

    /**
     * Applies first frame to target element before starting animation.
     * @return {!Promise}
     */
    value: function applyFirstFrame() {
      return Promise.all(this.getOrCreateRunners_().map(function (runner) {
        return runner.applyFirstFrame();
      }));
    }
    /** Starts all entrance animations for the page. */

  }, {
    key: "animateIn",
    value: function animateIn() {
      this.getRunners_().forEach(function (runner) {
        return runner.start();
      });
    }
    /** Skips all entrance animations for the page. */

  }, {
    key: "finishAll",
    value: function finishAll() {
      this.getRunners_().forEach(function (runner) {
        return runner.finish();
      });
    }
    /** Cancels all entrance animations for the page. */

  }, {
    key: "cancelAll",
    value: function cancelAll() {
      if (!this.runners_) {
        // nothing to cancel when the first frame has not been applied yet.
        return;
      }

      this.getRunners_().forEach(function (runner) {
        return runner.cancel();
      });
    }
    /** Pauses all animations in the page. */

  }, {
    key: "pauseAll",
    value: function pauseAll() {
      if (!this.runners_) {
        return;
      }

      this.getRunners_().forEach(function (runner) {
        return runner.pause();
      });
    }
    /** Resumes all animations in the page. */

  }, {
    key: "resumeAll",
    value: function resumeAll() {
      if (!this.runners_) {
        return;
      }

      this.getRunners_().forEach(function (runner) {
        return runner.resume();
      });
    }
    /**
     * Determines if there is an animation running.
     * @return {boolean}
     */

  }, {
    key: "hasAnimationStarted",
    value: function hasAnimationStarted() {
      return this.getRunners_().some(function (runner) {
        return runner.hasStarted();
      });
    }
    /**
     * @return {!Array<!AnimationRunner>}
     * @private
     */

  }, {
    key: "getRunners_",
    value: function getRunners_() {
      return (0, _log.devAssert)(this.runners_, 'Executed before applyFirstFrame');
    }
    /**
     * Gets or creates AnimationRunners.
     * These are either from an <amp-story-animation> spec or resolved from
     * presets via animate-in attributes.
     * If a page element contains both kinds of definitions, they'll run
     * concurrently.
     * @return {!Array<!AnimationRunner>}
     * @private
     */

  }, {
    key: "getOrCreateRunners_",
    value: function getOrCreateRunners_() {
      var _this6 = this;

      if (!this.runners_) {
        this.runners_ = Array.prototype.map.call((0, _dom.scopedQuerySelectorAll)(this.page_, ANIMATABLE_ELEMENTS_SELECTOR), function (el) {
          var preset = _this6.getPreset_(el);

          if (!preset) {
            return null;
          }

          return _this6.createRunner_({
            preset: preset,
            source: el,
            startAfterId: getSequencingStartAfterId(_this6.page_, el),
            keyframeOptions: _this6.getKeyframeOptions_(el),
            spec: _this6.partialAnimationSpecFromPreset_(el, preset)
          });
        }).concat(Array.prototype.map.call(this.page_.querySelectorAll('amp-story-animation[trigger=visibility]'), function (el) {
          return _this6.createRunner_({
            source: el,
            startAfterId: getSequencingStartAfterId(_this6.page_, el),
            // Casting since we're getting a JsonObject. This will be
            // validated during preparation phase.
            spec:
            /** @type {!WebAnimationDef} */
            (0, _json.getChildJsonConfig)(el)
          });
        })).filter(function (presetOrNull) {
          return !!presetOrNull;
        });
      }

      return (0, _log.devAssert)(this.runners_);
    }
    /**
     * @param {!StoryAnimationConfigDef} config
     * @return {!AnimationRunner}
     */

  }, {
    key: "createRunner_",
    value: function createRunner_(config) {
      return AnimationRunner.create(this.page_, config, (0, _log.devAssert)(this.builderPromise_), this.vsync_, this.sequence_);
    }
    /**
     * @param {!Element} el
     * @param {!StoryAnimationPresetDef} preset
     * @return {!WebAnimationDef}
     * @private
     */

  }, {
    key: "partialAnimationSpecFromPreset_",
    value: function partialAnimationSpecFromPreset_(el, preset) {
      var animationDef = {
        target: el,
        delay: preset.delay || 0,
        duration: preset.duration || 0,
        easing: preset.easing || DEFAULT_EASING,
        // This field is so that we type this as a WebAnimationDef, but it's
        // replaced when passed to an AnimationRunner.
        keyframes: []
      };

      if (el.hasAttribute(ANIMATE_IN_DURATION_ATTRIBUTE_NAME)) {
        animationDef.duration = (0, _utils.timeStrToMillis)(el.getAttribute(ANIMATE_IN_DURATION_ATTRIBUTE_NAME), animationDef.duration);
      }

      if (el.hasAttribute(ANIMATE_IN_DELAY_ATTRIBUTE_NAME)) {
        animationDef.delay = (0, _utils.timeStrToMillis)(el.getAttribute(ANIMATE_IN_DELAY_ATTRIBUTE_NAME), animationDef.delay);
      }

      if (el.hasAttribute(ANIMATE_IN_TIMING_FUNCTION_ATTRIBUTE_NAME)) {
        animationDef.easing = el.getAttribute(ANIMATE_IN_TIMING_FUNCTION_ATTRIBUTE_NAME);
      }

      return animationDef;
    }
    /**
     * @return {!Promise<!../../amp-animation/0.1/web-animations.Builder>}
     * @private
     */

  }, {
    key: "createAnimationBuilderPromise_",
    value: function createAnimationBuilderPromise_() {
      var _this7 = this;

      return _services.Services.extensionsFor(this.ampdoc_.win).installExtensionForDoc(this.ampdoc_, 'amp-animation').then(function () {
        return _services.Services.webAnimationServiceFor(_this7.page_);
      }).then(function (webAnimationService) {
        return webAnimationService.createBuilder({
          scope: _this7.page_,
          scaleByScope: true
        });
      });
    }
    /**
     * @param {!Element} el
     * @return {?StoryAnimationPresetDef}
     */

  }, {
    key: "getPreset_",
    value: function getPreset_(el) {
      var name = el.getAttribute(ANIMATE_IN_ATTRIBUTE_NAME);

      if (!_animationPresets.presets[name]) {
        (0, _log.user)().warn(TAG, 'Invalid', ANIMATE_IN_ATTRIBUTE_NAME, 'preset', name, 'for element', el);
        return null;
      }

      // TODO(alanorozco): This should be part of a mutate cycle.
      (0, _animationPresets.setStyleForPreset)(el, name);
      return _animationPresets.presets[name];
    }
    /**
     * @param {!Element} el
     * @return {!Object<string, *>}
     * @private
     */

  }, {
    key: "getKeyframeOptions_",
    value: function getKeyframeOptions_(el) {
      var options = {};

      _animationPresets.PRESET_OPTION_ATTRIBUTES.forEach(function (name) {
        if (!el.hasAttribute(name)) {
          return;
        }

        var value = parseFloat(el.getAttribute(name));

        if (isNaN(value) || value <= 0) {
          (0, _log.user)().warn(TAG, name, 'attribute must be a positive number. Found negative or zero in element', el);
          return;
        }

        options[name] = value;
      });

      return options;
    }
  }], [{
    key: "create",
    value: function create(page, ampdoc, unusedBaseUrl) {
      return new AnimationManager(page, ampdoc);
    }
  }]);

  return AnimationManager;
}();

exports.AnimationManager = AnimationManager;

/** Bus for animation sequencing. */
var AnimationSequence = /*#__PURE__*/function () {
  /**
   * @public
   */
  function AnimationSequence() {
    _classCallCheck(this, AnimationSequence);

    /** @private @const {!Object<string, !Promise>} */
    this.subscriptionPromises_ = (0, _object.map)();

    /** @private @const {!Object<string, !Function>} */
    this.subscriptionResolvers_ = (0, _object.map)();
  }

  /**
   * Decouples constructor for testing.
   *
   * @return {!AnimationSequence}
   */
  _createClass(AnimationSequence, [{
    key: "notifyFinish",

    /**
     * Notifies dependent elements that animation has finished.
     * @param {string} id
     */
    value: function notifyFinish(id) {
      if (id in this.subscriptionPromises_) {
        (0, _log.devAssert)(this.subscriptionResolvers_[id])();
        delete this.subscriptionPromises_[id];
      }
    }
    /**
     * Waits for another element to finish animating.
     * @param {string} id
     * @return {!Promise<void>}
     */

  }, {
    key: "waitFor",
    value: function waitFor(id) {
      if (!(id in this.subscriptionPromises_)) {
        var deferred = new _promise.Deferred();
        this.subscriptionPromises_[id] = deferred.promise;
        this.subscriptionResolvers_[id] = deferred.resolve;
      }

      return this.subscriptionPromises_[id];
    }
  }], [{
    key: "create",
    value: function create() {
      return new AnimationSequence();
    }
  }]);

  return AnimationSequence;
}();

exports.AnimationSequence = AnimationSequence;

},{"../../../src/css":105,"../../../src/dom":106,"../../../src/json":120,"../../../src/log":123,"../../../src/services":133,"../../../src/style":138,"../../../src/utils/object":149,"../../../src/utils/promise":150,"./../../../src/resolved-promise":129,"./animation-presets":60,"./animation-types":61,"./utils":93}],63:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.upgradeBackgroundAudio = upgradeBackgroundAudio;

var _services = require("../../../src/services");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @const {string}
 */
var BACKGROUND_AUDIO_ELEMENT_CLASS_NAME = 'i-amphtml-story-background-audio';

/**
 * Adds support for the background-audio property on the specified element.
 * @param {!Element} element The element to upgrade with support for background
 *     audio.
 * @param {boolean=} loop
 * @return {?Element} audioEl
 */
function upgradeBackgroundAudio(element, loop) {
  if (loop === void 0) {
    loop = true;
  }

  if (!element.hasAttribute('background-audio')) {
    return null;
  }

  var audioEl = element.ownerDocument.createElement('audio');

  var audioSrc = _services.Services.urlForDoc(element).assertHttpsUrl(element.getAttribute('background-audio'), element);

  audioEl.setAttribute('src', audioSrc);
  audioEl.setAttribute('preload', 'auto');

  if (loop) {
    audioEl.setAttribute('loop', '');
  }

  audioEl.setAttribute('autoplay', '');
  audioEl.setAttribute('muted', '');
  audioEl.muted = true;
  audioEl.classList.add(BACKGROUND_AUDIO_ELEMENT_CLASS_NAME);
  element.appendChild(audioEl);
  return audioEl;
}

},{"../../../src/services":133}],64:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryBookend = void 0;

var _resolvedPromise2 = require("./../../../../src/resolved-promise");

var _bookendComponentInterface = require("./components/bookend-component-interface");

var _ampStoryStoreService = require("../amp-story-store-service");

var _actionConstants = require("../../../../src/action-constants");

var _variableService = require("../variable-service");

var _bookendComponent = require("./bookend-component");

var _ampStoryBookend = require("../../../../build/amp-story-bookend-1.0.css");

var _ampStoryShare = require("../amp-story-share");

var _ampStoryDraggableDrawer = require("../amp-story-draggable-drawer");

var _events = require("../events");

var _history = require("../history");

var _keyCodes = require("../../../../src/utils/key-codes");

var _localizedStrings = require("../../../../src/localized-strings");

var _services = require("../../../../src/services");

var _storyAnalytics = require("../story-analytics");

var _dom = require("../../../../src/dom");

var _utils = require("../utils");

var _log = require("../../../../src/log");

var _object = require("../../../../src/utils/object");

var _service = require("../../../../src/service");

var _jsonld = require("../jsonld");

var _ampStoryLocalizationService = require("../amp-story-localization-service");

var _ampStoryRequestService = require("../amp-story-request-service");

var _types = require("../../../../src/types");

var _simpleTemplate = require("../simple-template");

var _style = require("../../../../src/style");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// TODO(#14591): Clean when bookend API v0.1 is deprecated.
var BOOKEND_VERSION_1 = 'v1.0';
var BOOKEND_VERSION_0 = 'v0.1';

/**
 * Key for components in bookend config.
 * @private @const {string}
 */
var BOOKEND_VERSION_KEY = 'bookendVersion';

/**
 * Deprecated key for components in bookend config.
 * @private @const {string}
 */
var DEPRECATED_BOOKEND_VERSION_KEY = 'bookend-version';

/**
 * Key used for retargeting event target originating from shadow DOM.
 * @const {string}
 */
var AMP_CUSTOM_LINKER_TARGET = '__AMP_CUSTOM_LINKER_TARGET__';

/**
 * @const {!../simple-template.ElementDef}
 */
var rootTemplate = {
  tag: 'section',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-bookend i-amphtml-story-system-reset'
  }),
  children: [{
    tag: 'div',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-bookend-handle'
    })
  }]
};

/** @const {!../simple-template.ElementDef} */
var REPLAY_ICON_TEMPLATE = {
  tag: 'div',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-bookend-replay-icon'
  })
};

/** @const {string} */
var TAG = 'amp-story-bookend';

/**
 * @param {string} title
 * @param {string} domainName
 * @param {string=} imageUrl
 * @return {!../simple-template.ElementDef}
 */
var buildReplayButtonTemplate = function buildReplayButtonTemplate(title, domainName, imageUrl) {
  if (imageUrl === void 0) {
    imageUrl = undefined;
  }

  return (
    /** @type {!../simple-template.ElementDef} */
    {
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-bookend-replay i-amphtml-story-bookend-top-level'
      }),
      children: [{
        tag: 'div',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-bookend-article-text-content'
        }),
        children: [{
          tag: 'h2',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-bookend-article-heading'
          }),
          unlocalizedString: title
        }, {
          tag: 'div',
          attrs: (0, _object.dict)({
            'class': 'i-amphtml-story-bookend-component-meta'
          }),
          unlocalizedString: domainName
        }]
      }, !imageUrl ? REPLAY_ICON_TEMPLATE : {
        tag: 'div',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-bookend-replay-image',
          'style': "background-image: url(" + imageUrl + ") !important"
        }),
        children: [REPLAY_ICON_TEMPLATE]
      }]
    }
  );
};

/**
 * @param {?string} consentId
 * @return {!../simple-template.ElementDef}
 */
var buildPromptConsentTemplate = function buildPromptConsentTemplate(consentId) {
  return (
    /** @type {!../simple-template.ElementDef} */
    {
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-bookend-consent ' + 'i-amphtml-story-bookend-top-level'
      }),
      children: [{
        tag: 'h3',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-bookend-heading ' + ' i-amphtml-story-bookend-component'
        }),
        localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE
      }, {
        tag: 'h2',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-bookend-consent-button ' + 'i-amphtml-story-bookend-component',
          'on': "tap:" + consentId + ".prompt",
          'role': 'button',
          'aria-label': 'Change data privacy settings'
        }),
        localizedStringId: _localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL
      }]
    }
  );
};

/**
 * Bookend component for <amp-story>.
 * This component has to be built and preloaded before it can be displayed,
 * through the 'build' and 'loadConfig' method. It can then be toggled by
 * dispatching the store TOGGLE_BOOKEND action.
 */
var AmpStoryBookend = /*#__PURE__*/function (_DraggableDrawer) {
  _inherits(AmpStoryBookend, _DraggableDrawer);

  var _super = _createSuper(AmpStoryBookend);

  /**
   * @param {!Element} element
   */
  function AmpStoryBookend(element) {
    var _this;

    _classCallCheck(this, AmpStoryBookend);

    _this = _super.call(this, element);

    /** @private {?./bookend-component.BookendDataDef} */
    _this.config_ = null;

    /** @private {boolean} */
    _this.isBuilt_ = false;

    /** @private {boolean} */
    _this.isBookendRendered_ = false;

    /** @private {?Element} */
    _this.replayButton_ = null;

    /**
     * Actual bookend.
     * @private {?Element}
     */
    _this.bookendEl_ = null;

    /** @private {?Element} */
    _this.shadowHost_ = null;

    /** @private {?ScrollableShareWidget} */
    _this.shareWidget_ = null;

    /** @private {!../story-analytics.StoryAnalyticsService} */
    _this.analyticsService_ = (0, _storyAnalytics.getAnalyticsService)(_this.win, _this.element);

    /** @const @private {!../variable-service.AmpStoryVariableService} */
    _this.variableService_ = (0, _variableService.getVariableService)(_this.win);
    return _this;
  }

  /**
   * @override
   */
  _createClass(AmpStoryBookend, [{
    key: "buildCallback",
    value: function buildCallback() {
      _get(_getPrototypeOf(AmpStoryBookend.prototype), "buildCallback", this).call(this);

      this.headerEl_.classList.add('i-amphtml-story-draggable-drawer-header-bookend');
      this.element.classList.add('i-amphtml-story-draggable-drawer-bookend');
      var handleEl = this.win.document.createElement('div');
      handleEl.classList.add('i-amphtml-story-bookend-handle');
      this.headerEl_.appendChild(handleEl);
    }
    /**
     * @override
     */

  }, {
    key: "layoutCallback",
    value: function layoutCallback() {
      return (0, _resolvedPromise2.resolvedPromise)();
    }
    /**
     * Builds the bookend components and appends it to the provided story.
     */

  }, {
    key: "build",
    value: function build() {
      if (this.isBuilt_) {
        return;
      }

      this.isBuilt_ = true;
      this.bookendEl_ = (0, _simpleTemplate.renderAsElement)(this.win.document, rootTemplate);
      this.shadowHost_ = this.win.document.createElement('div');
      (0, _utils.createShadowRootWithStyle)(this.shadowHost_, this.bookendEl_, _ampStoryBookend.CSS);
      this.contentEl_.appendChild(this.shadowHost_);
      this.replayButton_ = this.buildReplayButton_();
      this.shareWidget_ = _ampStoryShare.ScrollableShareWidget.create(this.win, (0, _log.dev)().assertElement(this.element.parentElement));
      this.bookendEl_.appendChild(this.replayButton_);
      this.bookendEl_.appendChild(this.shareWidget_.build((0, _service.getAmpdoc)(this.win.document)));
      var consentId = this.storeService_.get(_ampStoryStoreService.StateProperty.CONSENT_ID);

      if (consentId) {
        var promptConsentEl = (0, _simpleTemplate.renderAsElement)(this.win.document, buildPromptConsentTemplate(String(consentId)));
        this.bookendEl_.appendChild(promptConsentEl);
      }

      this.initializeListeners_();
      // Removes the [hidden] attribute the runtime sets because of the
      // [layout="nodisplay"].
      (0, _style.toggle)(this.element, true);
    }
    /**
     * @override
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this2 = this;

      _get(_getPrototypeOf(AmpStoryBookend.prototype), "initializeListeners_", this).call(this);

      this.element.addEventListener('click', function (event) {
        return _this2.onOuterShadowClick_(event);
      });
      this.getShadowRoot().addEventListener('click', function (event) {
        _this2.onInnerShadowClick_(event);
      });
      this.replayButton_.addEventListener('click', function (event) {
        return _this2.onReplayButtonClick_(event);
      });
      this.win.addEventListener('keyup', function (event) {
        if (!_this2.isActive_()) {
          return;
        }

        if (event.key == _keyCodes.Keys.ESCAPE) {
          event.preventDefault();

          _this2.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_BOOKEND, false);
        }
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.BOOKEND_STATE, function (isActive) {
        _this2.onBookendStateUpdate_(isActive);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CAN_SHOW_SHARING_UIS, function (show) {
        _this2.onCanShowSharingUisUpdate_(show);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.RTL_STATE, function (rtlState) {
        _this2.onRtlStateUpdate_(rtlState);
      }, true
      /** callToInitialize */
      );
    }
    /**
     * Whether the bookend is displayed.
     * @return {boolean}
     * @private
     */

  }, {
    key: "isActive_",
    value: function isActive_() {
      return !!this.storeService_.get(_ampStoryStoreService.StateProperty.BOOKEND_STATE);
    }
    /**
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onReplayButtonClick_",
    value: function onReplayButtonClick_(event) {
      event.stopPropagation();
      (0, _events.dispatch)(this.win, this.element, _events.EventType.REPLAY,
      /* payload */
      undefined, {
        bubbles: true
      });
    }
    /**
     * @override
     */

  }, {
    key: "close_",
    value: function close_() {
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_BOOKEND, false);
    }
    /**
     * Reacts to bookend state updates.
     * @param {boolean} isActive
     * @private
     */

  }, {
    key: "onBookendStateUpdate_",
    value: function onBookendStateUpdate_(isActive) {
      var shouldAnimate = !(0, _history.getHistoryState)(this.win, _history.HistoryState.BOOKEND_ACTIVE);
      isActive ? this.open(shouldAnimate) : this.closeInternal_();
      this.analyticsService_.triggerEvent(isActive ? _storyAnalytics.StoryAnalyticsEvent.OPEN : _storyAnalytics.StoryAnalyticsEvent.CLOSE, this.element);
      (0, _history.setHistoryState)(this.win, _history.HistoryState.BOOKEND_ACTIVE, isActive);
    }
    /**
     * Reacts to updates to whether sharing UIs may be shown, and updates the UI
     * accordingly.
     * @param {boolean} canShowSharingUis
     * @private
     */

  }, {
    key: "onCanShowSharingUisUpdate_",
    value: function onCanShowSharingUisUpdate_(canShowSharingUis) {
      var _this3 = this;

      this.mutateElement(function () {
        _this3.getShadowRoot().classList.toggle('i-amphtml-story-no-sharing', !canShowSharingUis);
      });
    }
    /**
     * @override
     */

  }, {
    key: "onUIStateUpdate_",
    value: function onUIStateUpdate_(uiState) {
      var _this4 = this;

      _get(_getPrototypeOf(AmpStoryBookend.prototype), "onUIStateUpdate_", this).call(this, uiState);

      this.mutateElement(function () {
        [_ampStoryStoreService.UIType.DESKTOP_FULLBLEED, _ampStoryStoreService.UIType.DESKTOP_PANELS].includes(uiState) ? _this4.getShadowRoot().setAttribute('desktop', '') : _this4.getShadowRoot().removeAttribute('desktop');
      });
    }
    /**
     * Reacts to RTL state updates and triggers the UI for RTL.
     * @param {boolean} rtlState
     * @private
     */

  }, {
    key: "onRtlStateUpdate_",
    value: function onRtlStateUpdate_(rtlState) {
      var _this5 = this;

      this.mutateElement(function () {
        rtlState ? _this5.getShadowRoot().setAttribute('dir', 'rtl') : _this5.getShadowRoot().removeAttribute('dir');
      });
    }
    /**
     * Reads the bookend version from the bookend JSON config.
     * @param {!JsonObject} config
     * @return {?string}
     * @private
     */

  }, {
    key: "readBookendVersion_",
    value: function readBookendVersion_(config) {
      if (config[DEPRECATED_BOOKEND_VERSION_KEY]) {
        (0, _log.user)().warn('AMP-STORY-BOOKEND', '`bookend-version` and ' + '`share-providers` keys in the bookend config are deprecated, please ' + '`bookendVersion` and `shareProviders` keys');
      }

      return config[DEPRECATED_BOOKEND_VERSION_KEY] || config[BOOKEND_VERSION_KEY] || null;
    }
    /**
     * Retrieves the publisher bookend configuration.
     * @return {!Promise<?./bookend-component.BookendDataDef>}
     */

  }, {
    key: "loadConfig",
    value: function loadConfig() {
      var _this6 = this;

      if (this.config_) {
        return Promise.resolve(this.config_);
      }

      var requestService = (0, _ampStoryRequestService.getRequestService)(this.win, (0, _log.dev)().assertElement(this.element.parentElement));
      return requestService.loadBookendConfig().then(function (response) {
        if (!response) {
          return null;
        }

        if (_this6.readBookendVersion_(response) === BOOKEND_VERSION_1) {
          var _this6$config_;

          var components = _bookendComponent.BookendComponent.buildFromJson(response['components'], _this6.element);

          _this6.config_ = (_this6$config_ = {}, _this6$config_[BOOKEND_VERSION_KEY] = BOOKEND_VERSION_1, _this6$config_['components'] = components, _this6$config_['shareProviders'] = response[_ampStoryShare.SHARE_PROVIDERS_KEY] || response[_ampStoryShare.DEPRECATED_SHARE_PROVIDERS_KEY], _this6$config_);
        } else {
          (0, _log.dev)().warn(TAG, "Version " + BOOKEND_VERSION_0 + " of the amp-story" + ("-bookend is deprecated. Use " + BOOKEND_VERSION_1 + " instead."));
        }

        return _this6.config_;
      }).catch(function (e) {
        (0, _log.user)().error(TAG, 'Error fetching bookend configuration', e.message);
        return null;
      });
    }
    /**
     * Retrieves the publisher bookend configuration. Applying the configuration
     * will prerender the bookend DOM, but there are cases where we need it before
     * the component is built. Eg: the desktop share button needs the providers.
     * @param {boolean=} renderBookend  Whether the bookend should be rendered.
     * When set to false it allows the config to be fetched before the component
     * is built, for cases like getting the share providers
     * on desktop.
     * @return {!Promise<?./bookend-component.BookendDataDef>}
     */

  }, {
    key: "loadConfigAndMaybeRenderBookend",
    value: function loadConfigAndMaybeRenderBookend(renderBookend) {
      var _this7 = this;

      if (renderBookend === void 0) {
        renderBookend = true;
      }

      return this.loadConfig().then(function (config) {
        if (renderBookend && !_this7.isBookendRendered_ && config) {
          _this7.renderBookend_(config);
        }

        return config;
      });
    }
    /**
     * Reacts to clicks outside the shadow root.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onOuterShadowClick_",
    value: function onOuterShadowClick_(event) {
      var target = (0, _log.dev)().assertElement(event.target);

      if (this.elementOutsideBookend_(target)) {
        event.stopPropagation();
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_BOOKEND, false);
        return;
      }
    }
    /**
     * Reacts to clicks inside the shadow root.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onInnerShadowClick_",
    value: function onInnerShadowClick_(event) {
      var target = (0, _log.dev)().assertElement(event.target);
      event[AMP_CUSTOM_LINKER_TARGET] = target;
      this.fireAnalyticsEvent_(target);

      if (target.hasAttribute('on')) {
        var actionService = _services.Services.actionServiceForDoc(this.element);

        actionService.trigger(target, 'tap', event, _actionConstants.ActionTrust.HIGH);
      }
    }
    /**
     * Configures analytics variables and fires analytic event.
     * @param {!Element} target
     * @private
     */

  }, {
    key: "fireAnalyticsEvent_",
    value: function fireAnalyticsEvent_(target) {
      var anchorEl = (0, _dom.closestAncestorElementBySelector)(target, 'A');

      if (!anchorEl) {
        return;
      }

      var componentData = anchorEl[_bookendComponentInterface.AMP_STORY_BOOKEND_COMPONENT_DATA];
      this.variableService_.onVariableUpdate(_variableService.AnalyticsVariable.BOOKEND_TARGET_HREF, anchorEl.href);
      this.variableService_.onVariableUpdate(_variableService.AnalyticsVariable.BOOKEND_COMPONENT_TYPE, componentData.type);
      this.variableService_.onVariableUpdate(_variableService.AnalyticsVariable.BOOKEND_COMPONENT_POSITION, componentData.position);
      this.analyticsService_.triggerEvent(_storyAnalytics.StoryAnalyticsEvent.BOOKEND_CLICK);
    }
    /**
     * Returns true if element is outside the bookend.
     * @param {!Element} el
     * @return {boolean}
     * @private
     */

  }, {
    key: "elementOutsideBookend_",
    value: function elementOutsideBookend_(el) {
      var _this8 = this;

      return !(0, _dom.closest)(el, function (el) {
        return el === _this8.shadowHost_;
      });
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isBuilt",
    value: function isBuilt() {
      return this.isBuilt_;
    }
    /** @private */

  }, {
    key: "assertBuilt_",
    value: function assertBuilt_() {
      (0, _log.devAssert)(this.isBuilt(), 'Bookend component needs to be built.');
    }
    /**
     * @param {!./bookend-component.BookendDataDef} bookendConfig
     * @private
     */

  }, {
    key: "renderBookend_",
    value: function renderBookend_(bookendConfig) {
      this.assertBuilt_();
      this.isBookendRendered_ = true;
      this.renderComponents_(bookendConfig.components);
    }
    /**
     * Renders the configurable components of the bookend in the page. It returns
     * a promise to ensure loadConfigAndMaybeRenderBookend renders the components
     * first before proceeding. This is needed for our unit tests.
     * @param {!Array<!../bookend/bookend-component.BookendComponentDef>} components
     * @private
     */

  }, {
    key: "renderComponents_",
    value: function renderComponents_(components) {
      (0, _log.dev)().assertElement(this.bookendEl_, 'Error rendering amp-story-bookend.');

      if (!components.length) {
        return;
      }

      var localizationService = (0, _ampStoryLocalizationService.getLocalizationService)(this.element);

      if (!localizationService) {
        (0, _log.user)().error(TAG, 'Unable to fetch localization service.');
        return;
      }

      var bookendEls = _bookendComponent.BookendComponent.buildElements(components, this.win, localizationService);

      var container = (0, _log.dev)().assertElement(_bookendComponent.BookendComponent.buildContainer(this.getShadowRoot(), this.win.document));
      this.mutateElement(function () {
        return container.appendChild(bookendEls);
      });
    }
    /** @return {!Element} */

  }, {
    key: "getShadowRoot",
    value: function getShadowRoot() {
      this.assertBuilt_();
      return (0, _log.dev)().assertElement(this.bookendEl_);
    }
    /**
     * @return {{
     *   title: string,
     *   domainName: string,
     *   imageUrl: (string|undefined),
     * }}
     * @private
     */

  }, {
    key: "getStoryMetadata_",
    value: function getStoryMetadata_() {
      var jsonLd = (0, _jsonld.getJsonLd)(this.getAmpDoc().getRootNode());

      var urlService = _services.Services.urlForDoc(this.element);

      var _Services$documentInf = _services.Services.documentInfoForDoc(this.getAmpDoc()),
          canonicalUrl = _Services$documentInf.canonicalUrl;

      var _urlService$parse = urlService.parse(canonicalUrl),
          domainName = _urlService$parse.hostname;

      var title = jsonLd && jsonLd['headline'] ? jsonLd['headline'] : (0, _log.user)().assertElement(this.win.document.head.querySelector('title'), 'Please set <title> or structured data (JSON-LD).').textContent;
      var metadata = {
        domainName: domainName,
        title: title
      };
      var image = jsonLd && (0, _types.isArray)(jsonLd['image']) ? jsonLd['image'] : null;

      if (image != null && image.length >= 0) {
        (0, _log.userAssert)(urlService.isProtocolValid(image[0]), "Unsupported protocol for story image URL " + image[0]);
        metadata.imageUrl = image[0];
      }

      return metadata;
    }
    /**
     * @return {!Element}
     * @private
     */

  }, {
    key: "buildReplayButton_",
    value: function buildReplayButton_() {
      var metadata = this.getStoryMetadata_();
      return (0, _simpleTemplate.renderAsElement)(this.win.document, buildReplayButtonTemplate(metadata.title, metadata.domainName, metadata.imageUrl));
    }
  }]);

  return AmpStoryBookend;
}(_ampStoryDraggableDrawer.DraggableDrawer);

exports.AmpStoryBookend = AmpStoryBookend;

},{"../../../../build/amp-story-bookend-1.0.css":2,"../../../../src/action-constants":96,"../../../../src/dom":106,"../../../../src/localized-strings":122,"../../../../src/log":123,"../../../../src/service":130,"../../../../src/services":133,"../../../../src/style":138,"../../../../src/types":139,"../../../../src/utils/key-codes":147,"../../../../src/utils/object":149,"../amp-story-draggable-drawer":40,"../amp-story-localization-service":45,"../amp-story-request-service":50,"../amp-story-share":52,"../amp-story-store-service":53,"../events":76,"../history":77,"../jsonld":78,"../simple-template":89,"../story-analytics":91,"../utils":93,"../variable-service":94,"./../../../../src/resolved-promise":129,"./bookend-component":65,"./components/bookend-component-interface":67}],65:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.BookendComponent = exports.BookendComponentClass = exports.BookendComponentDef = exports.BookendDataDef = exports.TAG = void 0;

var _article = require("./components/article");

var _bookendComponentInterface = require("./components/bookend-component-interface");

var _ctaLink = require("./components/cta-link");

var _heading = require("./components/heading");

var _landscape = require("./components/landscape");

var _localizedStrings = require("../../../../src/localized-strings");

var _portrait = require("./components/portrait");

var _textBox = require("./components/text-box");

var _log = require("../../../../src/log");

var _staticTemplate = require("../../../../src/static-template");

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <div\n        class=\"i-amphtml-story-bookend-component-set\n          i-amphtml-story-bookend-top-level\"\n      ></div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @type {string} */
var TAG = 'amp-story-bookend';
exports.TAG = TAG;

/**
 * @typedef {{
 *   bookendVersion: string,
 *   components: !Array<!BookendComponentDef>,
 *   shareProviders: !Array<(!JsonObject|string|undefined)>,
 * }}
 */
var BookendDataDef;
exports.BookendDataDef = BookendDataDef;

/**
 * @typedef {
 *   (!./components/article.ArticleComponentDef|
 *    !./components/cta-link.CtaLinkDef|
 *    !./components/heading.HeadingComponentDef|
 *    !./components/landscape.LandscapeComponentDef|
 *    !./components/portrait.PortraitComponentDef|
 *    !./components/text-box.TextBoxComponentDef)
 * }
 */
var BookendComponentDef;
exports.BookendComponentDef = BookendComponentDef;

/**
 * @typedef {
 *   (!ArticleComponent|
 *    !CtaLinkComponent|
 *    !HeadingComponent|
 *    !LandscapeComponent|
 *    !PortraitComponent|
 *    !TextBoxComponent)
 * }
 */
var BookendComponentClass;
exports.BookendComponentClass = BookendComponentClass;

/** @private @const {!Object<string, !BookendComponentClass>} */
var builderInstances = {};

/**
 * @param {string} type
 * @param {function(new:BookendComponentClass)} ctor
 * @return {!BookendComponentClass}
 * @restricted
 */
function setBuilderInstance(type, ctor) {
  return builderInstances[type] = builderInstances[type] || new ctor();
}

/**
 * Dispatches the components to their specific builder classes.
 * @param {string} type
 * @return {?BookendComponentClass}
 * @restricted
 */
function componentBuilderInstanceFor(type) {
  switch (type) {
    case _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.SMALL:
      return setBuilderInstance(type, _article.ArticleComponent);

    case _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.CTA_LINK:
      return setBuilderInstance(type, _ctaLink.CtaLinkComponent);

    case _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.HEADING:
      return setBuilderInstance(type, _heading.HeadingComponent);

    case _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.LANDSCAPE:
      return setBuilderInstance(type, _landscape.LandscapeComponent);

    case _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.PORTRAIT:
      return setBuilderInstance(type, _portrait.PortraitComponent);

    case _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.TEXTBOX:
      return setBuilderInstance(type, _textBox.TextBoxComponent);

    default:
      return null;
  }
}

/**
 * Prepend a heading to the related articles section if first component is not a
 * heading already.
 * @param {!Array<BookendComponentDef>} components
 * @param {?../../../../src/service/localization.LocalizationService} localizationService
 * @return {!Array<BookendComponentDef>}
 */
function prependTitle(components, localizationService) {
  if (components[0] && components[0].type == 'heading') {
    return components;
  }

  var title = localizationService.getLocalizedString(_localizedStrings.LocalizedStringId.AMP_STORY_BOOKEND_MORE_TO_READ_LABEL);
  components.unshift({
    'type': 'heading',
    'text': title
  });
  return components;
}

/**
 * Delegator class that dispatches the logic to build different components
 * on the bookend to their corresponding classes.
 */
var BookendComponent = /*#__PURE__*/function () {
  function BookendComponent() {
    _classCallCheck(this, BookendComponent);
  }

  _createClass(BookendComponent, null, [{
    key: "buildFromJson",

    /**
     * Takes components from JSON and delegates them to their corresponding
     * builder class.
     * @param {!Array<BookendComponentDef>} components
     * @param {!Element} el
     * @return {!Array<BookendComponentDef>}
     */
    value: function buildFromJson(components, el) {
      return components.reduce(function (builtComponents, component) {
        var componentBuilder = componentBuilderInstanceFor(component.type);

        if (!componentBuilder) {
          (0, _log.dev)().error(TAG, 'Component type `' + component.type + '` is not supported. Skipping invalid.');
          return builtComponents;
        }

        componentBuilder.assertValidity(component, el);
        builtComponents.push(componentBuilder.build(component, el));
        return builtComponents;
      }, []);
    }
    /**
     * Builds the bookend components elements by choosing the appropriate builder
     * class and appending the elements to the container.
     * @param {!Array<BookendComponentDef>} components
     * @param {!Window} win
     * @param {?../../../../src/service/localization.LocalizationService} localizationService
     * @return {!DocumentFragment}
     */

  }, {
    key: "buildElements",
    value: function buildElements(components, win, localizationService) {
      var fragment = win.document.createDocumentFragment();
      components = prependTitle(components, localizationService);
      components.forEach(function (component, index) {
        var type = component.type;

        if (type && componentBuilderInstanceFor(type)) {
          var el = componentBuilderInstanceFor(type).buildElement(component, win, {
            position: index
          });
          fragment.appendChild(el);
        }
      });
      return fragment;
    }
    /**
     * Builds container for components.
     * @param {!Element} element Bookend container
     * @param {!Document} doc
     * @return {?Element}
     */

  }, {
    key: "buildContainer",
    value: function buildContainer(element, doc) {
      var html = (0, _staticTemplate.htmlFor)(doc);
      var containerTemplate = html(_templateObject());
      element.appendChild(containerTemplate);
      return element.lastElementChild;
    }
  }]);

  return BookendComponent;
}();

exports.BookendComponent = BookendComponent;

},{"../../../../src/localized-strings":122,"../../../../src/log":123,"../../../../src/static-template":135,"./components/article":66,"./components/bookend-component-interface":67,"./components/cta-link":68,"./components/heading":69,"./components/landscape":70,"./components/portrait":71,"./components/text-box":72}],66:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.ArticleComponent = exports.ArticleComponentDef = void 0;

var _bookendComponentInterface = require("./bookend-component-interface");

var _dom = require("../../../../../src/dom");

var _object = require("../../../../../src/utils/object");

var _utils = require("../../utils");

var _url = require("../../../../../src/url");

var _staticTemplate = require("../../../../../src/static-template");

var _log = require("../../../../../src/log");

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n          <div class=\"i-amphtml-story-bookend-article-image\">\n            <img ref=\"image\">\n            </img>\n          </div>"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <a\n        class=\"i-amphtml-story-bookend-article i-amphtml-story-bookend-component\"\n        target=\"_top\"\n      >\n        <div class=\"i-amphtml-story-bookend-article-text-content\">\n          <h2\n            class=\"i-amphtml-story-bookend-article-heading\"\n            ref=\"heading\"\n          ></h2>\n          <div class=\"i-amphtml-story-bookend-component-meta\" ref=\"meta\"></div>\n        </div>\n      </a>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @typedef {{
 *   type: string,
 *   title: string,
 *   url: string,
 *   image: (string|undefined),
 *   domainName: string,
 * }}
 */
var ArticleComponentDef;
exports.ArticleComponentDef = ArticleComponentDef;

/**
 * Builder class for the small article component.
 * @implements {BookendComponentInterface}
 */
var ArticleComponent = /*#__PURE__*/function () {
  function ArticleComponent() {
    _classCallCheck(this, ArticleComponent);
  }

  _createClass(ArticleComponent, [{
    key: "assertValidity",

    /** @override */
    value: function assertValidity(articleJson, element) {
      var requiredFields = ['title', 'url'];
      var hasAllRequiredFields = !requiredFields.some(function (field) {
        return !(field in articleJson);
      });
      (0, _log.userAssert)(hasAllRequiredFields, 'Small article component must contain ' + requiredFields.map(function (field) {
        return '`' + field + '`';
      }).join(', ') + ' fields, skipping invalid.');
      (0, _utils.userAssertValidProtocol)(element, articleJson['url']);
      var image = articleJson['image'];

      if (image) {
        (0, _utils.userAssertValidProtocol)(element, image);
      }
    }
    /** @override */

  }, {
    key: "build",
    value: function build(articleJson, element) {
      var url = articleJson['url'];
      var domainName = (0, _utils.getSourceOriginForElement)(element, url);
      var article = {
        url: url,
        domainName: domainName,
        type: articleJson['type'],
        title: articleJson['title']
      };

      if (articleJson['image']) {
        article.image = articleJson['image'];
      }

      if (articleJson['amphtml']) {
        article.amphtml = articleJson['amphtml'];
      }

      return (
        /** @type {!ArticleComponentDef} */
        article
      );
    }
    /** @override */

  }, {
    key: "buildElement",
    value: function buildElement(articleData, win, data) {
      var html = (0, _staticTemplate.htmlFor)(win.document);
      //TODO(#14657, #14658): Binaries resulting from htmlFor are bloated.
      var el = html(_templateObject());
      (0, _dom.addAttributesToElement)(el, (0, _object.dict)({
        'href': (0, _url.resolveRelativeUrl)(articleData.url, (0, _url.getSourceUrl)(win.location))
      }));
      el[_bookendComponentInterface.AMP_STORY_BOOKEND_COMPONENT_DATA] = {
        position: data.position,
        type: _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.SMALL
      };

      if (articleData['amphtml'] === true) {
        (0, _dom.addAttributesToElement)(el, (0, _object.dict)({
          'rel': 'amphtml'
        }));
      }

      if (articleData.image) {
        var imgEl = html(_templateObject2());

        var _htmlRefs = (0, _staticTemplate.htmlRefs)(imgEl),
            image = _htmlRefs.image;

        (0, _dom.addAttributesToElement)(image, (0, _object.dict)({
          'src': (0, _utils.resolveImgSrc)(win, articleData.image)
        }));
        el.appendChild(imgEl);
      }

      var articleElements = (0, _staticTemplate.htmlRefs)(el);
      var heading = articleElements.heading,
          meta = articleElements.meta;
      heading.textContent = articleData.title;
      meta.textContent = articleData.domainName;
      return el;
    }
  }]);

  return ArticleComponent;
}();

exports.ArticleComponent = ArticleComponent;

},{"../../../../../src/dom":106,"../../../../../src/log":123,"../../../../../src/static-template":135,"../../../../../src/url":142,"../../../../../src/utils/object":149,"../../utils":93,"./bookend-component-interface":67}],67:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.BookendComponentInterface = exports.AMP_STORY_BOOKEND_COMPONENT_DATA = exports.BOOKEND_COMPONENT_TYPES = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @enum {string} */
var BOOKEND_COMPONENT_TYPES = {
  SMALL: 'small',
  CTA_LINK: 'cta-link',
  HEADING: 'heading',
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
  TEXTBOX: 'textbox'
};
exports.BOOKEND_COMPONENT_TYPES = BOOKEND_COMPONENT_TYPES;

/**
 *
 * @const {string}
 */
var AMP_STORY_BOOKEND_COMPONENT_DATA = '__AMP_STORY_BOOKEND_COMPONENT_DATA__';
exports.AMP_STORY_BOOKEND_COMPONENT_DATA = AMP_STORY_BOOKEND_COMPONENT_DATA;

/**
 * Interface implemented by the bookend components.
 * @interface
 */
var BookendComponentInterface = /*#__PURE__*/function () {
  function BookendComponentInterface() {
    _classCallCheck(this, BookendComponentInterface);
  }

  _createClass(BookendComponentInterface, [{
    key: "assertValidity",

    /**
     * Asserts whether the comopnent is valid.
     * @param {../bookend-component.BookendComponentDef} unusedComponentJson
     * @param {!Element} unusedElement
     */
    value: function assertValidity(unusedComponentJson, unusedElement) {}
    /**
     * Builds the component.
     * @param {../bookend-component.BookendComponentDef} unusedComponentJson
     * @param {!Element} unusedElement
     * @return {../bookend-component.BookendComponentDef}
     */

  }, {
    key: "build",
    value: function build(unusedComponentJson, unusedElement) {}
    /**
     * Builds the DOM element for the component.
     * @param {../bookend-component.BookendComponentDef} unusedComponentJson
     * @param {!Window} unusedWin
     * @param {!Object} unusedData
     * @return {!Element}
     */

  }, {
    key: "buildElement",
    value: function buildElement(unusedComponentJson, unusedWin, unusedData) {}
  }]);

  return BookendComponentInterface;
}();

exports.BookendComponentInterface = BookendComponentInterface;

},{}],68:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CtaLinkComponent = exports.CtaLinkDef = void 0;

var _bookendComponentInterface = require("./bookend-component-interface");

var _dom = require("../../../../../src/dom");

var _object = require("../../../../../src/utils/object");

var _url = require("../../../../../src/url");

var _staticTemplate = require("../../../../../src/static-template");

var _types = require("../../../../../src/types");

var _log = require("../../../../../src/log");

var _utils = require("../../utils");

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      <a class=\"i-amphtml-story-bookend-cta-link\" target=\"_top\">\n        <div class=\"i-amphtml-story-bookend-cta-link-text\" ref=\"linkText\"></div>\n      </a>\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <div\n        class=\"i-amphtml-story-bookend-cta-link-wrapper\n          i-amphtml-story-bookend-component\"\n      ></div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @typedef {{
 *   url: string,
 *   text: string,
 * }}
 */
var CtaLinkArrDef;

/**
 * @typedef {{
 *   type: string,
 *   links: !Array<CtaLinkArrDef>,
 * }}
 */
var CtaLinkDef;
exports.CtaLinkDef = CtaLinkDef;

/**
 * Builder class for the call to action link component.
 * @implements {BookendComponentInterface}
 */
var CtaLinkComponent = /*#__PURE__*/function () {
  function CtaLinkComponent() {
    _classCallCheck(this, CtaLinkComponent);
  }

  _createClass(CtaLinkComponent, [{
    key: "assertValidity",

    /**
     * @param {!../bookend-component.BookendComponentDef} ctaLinksJson
     * @override
     * */
    value: function assertValidity(ctaLinksJson, element) {
      var links =
      /** @type {!Array} */
      ctaLinksJson['links'];
      (0, _log.userAssert)(links && (0, _types.isArray)(links) && links.length > 0, 'CTA link component must be an array and contain at least one link ' + 'inside it.');
      links.forEach(function (ctaLink) {
        (0, _log.userAssert)('text' in ctaLink && 'url' in ctaLink, 'Links in CTA link component must contain `text` field and a `url`.');
        (0, _utils.userAssertValidProtocol)(element, ctaLink['url']);
      });
    }
    /**
     * @param {!../bookend-component.BookendComponentDef} ctaLinksJson
     * @param {!Element} unusedElement
     * @return {!CtaLinkDef}
     * @override
     * */

  }, {
    key: "build",
    value: function build(ctaLinksJson, unusedElement) {
      var ctaLinks = {
        type: ctaLinksJson['type'],
        links: ctaLinksJson['links']
      };
      return ctaLinks;
    }
    /** @override */

  }, {
    key: "buildElement",
    value: function buildElement(ctaLinksData, win, data) {
      var html = (0, _staticTemplate.htmlFor)(win.document);
      var container = html(_templateObject());
      var linkSeed = html(_templateObject2());

      /** @type {!Array} */
      ctaLinksData['links'].forEach(function (currentLink) {
        var el = linkSeed.cloneNode(
        /* deep */
        true);
        (0, _dom.addAttributesToElement)(el, (0, _object.dict)({
          'href': (0, _url.resolveRelativeUrl)(currentLink['url'], (0, _url.getSourceUrl)(win.location))
        }));

        if (currentLink['amphtml'] === true) {
          (0, _dom.addAttributesToElement)(el, (0, _object.dict)({
            'rel': 'amphtml'
          }));
        }

        var refs = (0, _staticTemplate.htmlRefs)(el);
        refs['linkText'].textContent = currentLink['text'];
        el[_bookendComponentInterface.AMP_STORY_BOOKEND_COMPONENT_DATA] = {
          position: data.position,
          type: _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.CTA_LINK
        };
        container.appendChild(el);
      });
      linkSeed = null;
      // GC
      return container;
    }
  }]);

  return CtaLinkComponent;
}();

exports.CtaLinkComponent = CtaLinkComponent;

},{"../../../../../src/dom":106,"../../../../../src/log":123,"../../../../../src/static-template":135,"../../../../../src/types":139,"../../../../../src/url":142,"../../../../../src/utils/object":149,"../../utils":93,"./bookend-component-interface":67}],69:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.HeadingComponent = exports.HeadingComponentDef = void 0;

var _bookendComponentInterface = require("./bookend-component-interface");

var _staticTemplate = require("../../../../../src/static-template");

var _log = require("../../../../../src/log");

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <h3\n        class=\"i-amphtml-story-bookend-component\n        i-amphtml-story-bookend-heading\"\n      ></h3>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @typedef {{
 *   type: string,
 *   text: string,
 * }}
 */
var HeadingComponentDef;
exports.HeadingComponentDef = HeadingComponentDef;

/**
 * Builder class for the heading component that sits on top of a given set of
 * components in the bookend.
 * @implements {BookendComponentInterface}
 */
var HeadingComponent = /*#__PURE__*/function () {
  function HeadingComponent() {
    _classCallCheck(this, HeadingComponent);
  }

  _createClass(HeadingComponent, [{
    key: "assertValidity",

    /**
     * @param {!../bookend-component.BookendComponentDef} headingJson
     * @override
     * */
    value: function assertValidity(headingJson) {
      (0, _log.userAssert)('text' in headingJson, 'Heading component must contain `text` field, skipping invalid.');
    }
    /**
     * @param {!../bookend-component.BookendComponentDef} headingJson
     * @return {!HeadingComponentDef}
     * @override
     * */

  }, {
    key: "build",
    value: function build(headingJson) {
      return {
        type: headingJson['type'],
        text: headingJson['text']
      };
    }
    /** @override */

  }, {
    key: "buildElement",
    value: function buildElement(headingData, win, data) {
      var html = (0, _staticTemplate.htmlFor)(win.document);
      var template = html(_templateObject());
      template[_bookendComponentInterface.AMP_STORY_BOOKEND_COMPONENT_DATA] = {
        position: data.position,
        type: _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.HEADING
      };
      template.textContent = headingData.text;
      return template;
    }
  }]);

  return HeadingComponent;
}();

exports.HeadingComponent = HeadingComponent;

},{"../../../../../src/log":123,"../../../../../src/static-template":135,"./bookend-component-interface":67}],70:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.LandscapeComponent = exports.LandscapeComponentDef = void 0;

var _bookendComponentInterface = require("./bookend-component-interface");

var _dom = require("../../../../../src/dom");

var _object = require("../../../../../src/utils/object");

var _utils = require("../../utils");

var _url = require("../../../../../src/url");

var _staticTemplate = require("../../../../../src/static-template");

var _log = require("../../../../../src/log");

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        <a class=\"i-amphtml-story-bookend-landscape\n            i-amphtml-story-bookend-component\" target=\"_top\">\n          <h2 class=\"i-amphtml-story-bookend-component-category\"\n            ref=\"category\"></h2>\n          <h2 class=\"i-amphtml-story-bookend-article-heading\"\n            ref=\"title\"></h2>\n          <div class=\"i-amphtml-story-bookend-landscape-image\">\n            <img ref=\"image\"></img>\n          </div>\n          <div class=\"i-amphtml-story-bookend-component-meta\"\n            ref=\"meta\"></div>\n        </a>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @typedef {{
 *   type: string,
 *   category: string,
 *   title: string,
 *   url: string,
 *   domainName: string,
 *   image: string,
 * }}
 */
var LandscapeComponentDef;
exports.LandscapeComponentDef = LandscapeComponentDef;

/**
 * @struct @typedef {{
 *   category: !Element,
 *   title: !Element,
 *   image: !Element,
 *   meta: !Element,
 *   domainName: string,
 * }}
 */
var landscapeElementsDef;

/**
 * Builder class for the landscape component.
 * @implements {BookendComponentInterface}
 */
var LandscapeComponent = /*#__PURE__*/function () {
  function LandscapeComponent() {
    _classCallCheck(this, LandscapeComponent);
  }

  _createClass(LandscapeComponent, [{
    key: "assertValidity",

    /** @override */
    value: function assertValidity(landscapeJson, element) {
      var requiredFields = ['title', 'image', 'url'];
      var hasAllRequiredFields = !requiredFields.some(function (field) {
        return !(field in landscapeJson);
      });
      (0, _log.userAssert)(hasAllRequiredFields, 'Landscape component must contain ' + requiredFields.map(function (field) {
        return '`' + field + '`';
      }).join(', ') + ' fields, skipping invalid.');
      (0, _utils.userAssertValidProtocol)(element, landscapeJson['url']);
      (0, _utils.userAssertValidProtocol)(element, landscapeJson['image']);
    }
    /** @override */

  }, {
    key: "build",
    value: function build(landscapeJson, element) {
      var url = landscapeJson['url'];
      var domainName = (0, _utils.getSourceOriginForElement)(element, url);
      var landscape = {
        url: url,
        domainName: domainName,
        type: landscapeJson['type'],
        title: landscapeJson['title'],
        category: landscapeJson['category'],
        image: landscapeJson['image']
      };

      if (landscapeJson['amphtml']) {
        landscape.amphtml = landscapeJson['amphtml'];
      }

      return landscape;
    }
    /** @override */

  }, {
    key: "buildElement",
    value: function buildElement(landscapeData, win, data) {
      landscapeData =
      /** @type {LandscapeComponentDef} */
      landscapeData;
      var html = (0, _staticTemplate.htmlFor)(win.document);
      var el = html(_templateObject());
      (0, _dom.addAttributesToElement)(el, (0, _object.dict)({
        'href': (0, _url.resolveRelativeUrl)(landscapeData.url, (0, _url.getSourceUrl)(win.location))
      }));
      el[_bookendComponentInterface.AMP_STORY_BOOKEND_COMPONENT_DATA] = {
        position: data.position,
        type: _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.LANDSCAPE
      };

      if (landscapeData['amphtml'] === true) {
        (0, _dom.addAttributesToElement)(el, (0, _object.dict)({
          'rel': 'amphtml'
        }));
      }

      var landscapeEls = (0, _staticTemplate.htmlRefs)(el);
      var category =
      /** @type {!landscapeElementsDef} */
      landscapeEls.category,
          title = landscapeEls.title,
          image = landscapeEls.image,
          meta = landscapeEls.meta;
      category.textContent = landscapeData.category;
      title.textContent = landscapeData.title;
      (0, _dom.addAttributesToElement)(image, (0, _object.dict)({
        'src': (0, _utils.resolveImgSrc)(win, landscapeData.image)
      }));
      meta.textContent = landscapeData.domainName;
      return el;
    }
  }]);

  return LandscapeComponent;
}();

exports.LandscapeComponent = LandscapeComponent;

},{"../../../../../src/dom":106,"../../../../../src/log":123,"../../../../../src/static-template":135,"../../../../../src/url":142,"../../../../../src/utils/object":149,"../../utils":93,"./bookend-component-interface":67}],71:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.PortraitComponent = exports.PortraitComponentDef = void 0;

var _bookendComponentInterface = require("./bookend-component-interface");

var _dom = require("../../../../../src/dom");

var _object = require("../../../../../src/utils/object");

var _utils = require("../../utils");

var _url = require("../../../../../src/url");

var _staticTemplate = require("../../../../../src/static-template");

var _log = require("../../../../../src/log");

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        <a class=\"i-amphtml-story-bookend-portrait i-amphtml-story-bookend-component\" target=\"_top\">\n          <h2 class=\"i-amphtml-story-bookend-component-category\"\n            ref=\"category\"></h2>\n          <h2 class=\"i-amphtml-story-bookend-article-heading\"\n            ref=\"title\"></h2>\n          <div class=\"i-amphtml-story-bookend-portrait-image\">\n            <img ref=\"image\"></img>\n          </div>\n          <div class=\"i-amphtml-story-bookend-component-meta\"\n            ref=\"meta\"></div>\n        </a>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @typedef {{
 *   type: string,
 *   category: string,
 *   title: string,
 *   url: string,
 *   domainName: string,
 *   image: string,
 * }}
 */
var PortraitComponentDef;
exports.PortraitComponentDef = PortraitComponentDef;

/**
 * @struct @typedef {{
 *   category: !Element,
 *   title: !Element,
 *   image: !Element,
 *   meta: !Element,
 *   domainName: string
 * }}
 */
var portraitElementsDef;

/**
 * Builder class for the portrait component.
 * @implements {BookendComponentInterface}
 */
var PortraitComponent = /*#__PURE__*/function () {
  function PortraitComponent() {
    _classCallCheck(this, PortraitComponent);
  }

  _createClass(PortraitComponent, [{
    key: "assertValidity",

    /** @override */
    value: function assertValidity(portraitJson, element) {
      var requiredFields = ['title', 'image', 'url'];
      var hasAllRequiredFields = !requiredFields.some(function (field) {
        return !(field in portraitJson);
      });
      (0, _log.userAssert)(hasAllRequiredFields, 'Portrait component must contain ' + requiredFields.map(function (field) {
        return '`' + field + '`';
      }).join(', ') + ' fields, skipping invalid.');
      (0, _utils.userAssertValidProtocol)(element, portraitJson['url']);
      (0, _utils.userAssertValidProtocol)(element, portraitJson['image']);
    }
    /** @override */

  }, {
    key: "build",
    value: function build(portraitJson, element) {
      var url = portraitJson['url'];
      var domainName = (0, _utils.getSourceOriginForElement)(element, url);
      var portrait = {
        url: url,
        domainName: domainName,
        type: portraitJson['type'],
        category: portraitJson['category'],
        title: portraitJson['title'],
        image: portraitJson['image']
      };

      if (portraitJson['amphtml']) {
        portrait.amphtml = portraitJson['amphtml'];
      }

      return portrait;
    }
    /** @override */

  }, {
    key: "buildElement",
    value: function buildElement(portraitData, win, data) {
      portraitData =
      /** @type {PortraitComponentDef} */
      portraitData;
      var html = (0, _staticTemplate.htmlFor)(win.document);
      var el = html(_templateObject());
      (0, _dom.addAttributesToElement)(el, (0, _object.dict)({
        'href': (0, _url.resolveRelativeUrl)(portraitData.url, (0, _url.getSourceUrl)(win.location))
      }));
      el[_bookendComponentInterface.AMP_STORY_BOOKEND_COMPONENT_DATA] = {
        position: data.position,
        type: _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.PORTRAIT
      };

      if (portraitData['amphtml'] === true) {
        (0, _dom.addAttributesToElement)(el, (0, _object.dict)({
          'rel': 'amphtml'
        }));
      }

      var _htmlRefs =
      /** @type {!portraitElementsDef} */
      (0, _staticTemplate.htmlRefs)(el),
          category = _htmlRefs.category,
          title = _htmlRefs.title,
          image = _htmlRefs.image,
          meta = _htmlRefs.meta;

      category.textContent = portraitData.category;
      title.textContent = portraitData.title;
      (0, _dom.addAttributesToElement)(image, (0, _object.dict)({
        'src': (0, _utils.resolveImgSrc)(win, portraitData.image)
      }));
      meta.textContent = portraitData.domainName;
      return el;
    }
  }]);

  return PortraitComponent;
}();

exports.PortraitComponent = PortraitComponent;

},{"../../../../../src/dom":106,"../../../../../src/log":123,"../../../../../src/static-template":135,"../../../../../src/url":142,"../../../../../src/utils/object":149,"../../utils":93,"./bookend-component-interface":67}],72:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.TextBoxComponent = exports.TextBoxComponentDef = void 0;

var _bookendComponentInterface = require("./bookend-component-interface");

var _staticTemplate = require("../../../../../src/static-template");

var _types = require("../../../../../src/types");

var _log = require("../../../../../src/log");

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose([" <h3 class=\"i-amphtml-story-bookend-text\"></h3> "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <div\n        class=\"i-amphtml-story-bookend-textbox\n          i-amphtml-story-bookend-component\"\n      ></div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @typedef {{
 *   type: string,
 *   text: string
 * }}
 */
var TextBoxComponentDef;
exports.TextBoxComponentDef = TextBoxComponentDef;

/**
 * Builder class for the textbox bookend component.
 * @implements {BookendComponentInterface}
 */
var TextBoxComponent = /*#__PURE__*/function () {
  function TextBoxComponent() {
    _classCallCheck(this, TextBoxComponent);
  }

  _createClass(TextBoxComponent, [{
    key: "assertValidity",

    /**
     * @param {!../bookend-component.BookendComponentDef} textboxJson
     * @override
     * */
    value: function assertValidity(textboxJson) {
      (0, _log.userAssert)('text' in textboxJson && (0, _types.isArray)(textboxJson['text']) && textboxJson['text'].length > 0, 'Textbox component must contain ' + '`text` array and at least one element inside it, ' + 'skipping invalid.');
    }
    /**
     * @param {!../bookend-component.BookendComponentDef} textboxJson
     * @return {!TextBoxComponentDef}
     * @override
     * */

  }, {
    key: "build",
    value: function build(textboxJson) {
      var type = textboxJson.type,
          text = textboxJson.text;
      return {
        type: type,
        text: text
      };
    }
    /** @override */

  }, {
    key: "buildElement",
    value: function buildElement(textboxData, win, data) {
      var html = (0, _staticTemplate.htmlFor)(win.document);
      var container = html(_templateObject());
      container[_bookendComponentInterface.AMP_STORY_BOOKEND_COMPONENT_DATA] = {
        position: data.position,
        type: _bookendComponentInterface.BOOKEND_COMPONENT_TYPES.TEXTBOX
      };
      var textSeed = html(_templateObject2());

      /** @type {!Array} */
      textboxData['text'].forEach(function (currentLine) {
        var el = textSeed.cloneNode(
        /* deep */
        true);
        el.textContent = currentLine;
        container.appendChild(el);
      });
      textSeed = null;
      return container;
    }
  }]);

  return TextBoxComponent;
}();

exports.TextBoxComponent = TextBoxComponent;

},{"../../../../../src/log":123,"../../../../../src/static-template":135,"../../../../../src/types":139,"./bookend-component-interface":67}],73:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.BLANK_VIDEO_SRC = exports.BLANK_AUDIO_SRC = void 0;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BLANK_AUDIO_SRC = 'data:audio/wav;base64,UklGRjIAAABXQVZFZm10IBA' + 'AAAABAAEAIlYAAESsAAACABAAZGF0YRAAAAAAAAAAAAAAAAAAAAAAAA==';
exports.BLANK_AUDIO_SRC = BLANK_AUDIO_SRC;
var BLANK_VIDEO_SRC = 'data:video/mp4;base64,AAAAHGZ0eXBNNFYgAAACAG' + 'lzb21pc28yYXZjMQAAAAhmcmVlAAAGF21kYXTeBAAAbGliZmFhYyAxLjI4AABCAJMgBDIARw' + 'AAArEGBf//rdxF6b3m2Ui3lizYINkj7u94MjY0IC0gY29yZSAxNDIgcjIgOTU2YzhkOCAtIE' + 'guMjY0L01QRUctNCBBVkMgY29kZWMgLSBDb3B5bGVmdCAyMDAzLTIwMTQgLSBodHRwOi8vd3' + 'd3LnZpZGVvbGFuLm9yZy94MjY0Lmh0bWwgLSBvcHRpb25zOiBjYWJhYz0wIHJlZj0zIGRlYm' + 'xvY2s9MTowOjAgYW5hbHlzZT0weDE6MHgxMTEgbWU9aGV4IHN1Ym1lPTcgcHN5PTEgcHN5X3' + 'JkPTEuMDA6MC4wMCBtaXhlZF9yZWY9MSBtZV9yYW5nZT0xNiBjaHJvbWFfbWU9MSB0cmVsbG' + 'lzPTEgOHg4ZGN0PTAgY3FtPTAgZGVhZHpvbmU9MjEsMTEgZmFzdF9wc2tpcD0xIGNocm9tYV' + '9xcF9vZmZzZXQ9LTIgdGhyZWFkcz02IGxvb2thaGVhZF90aHJlYWRzPTEgc2xpY2VkX3Rocm' + 'VhZHM9MCBucj0wIGRlY2ltYXRlPTEgaW50ZXJsYWNlZD0wIGJsdXJheV9jb21wYXQ9MCBjb2' + '5zdHJhaW5lZF9pbnRyYT0wIGJmcmFtZXM9MCB3ZWlnaHRwPTAga2V5aW50PTI1MCBrZXlpbn' + 'RfbWluPTI1IHNjZW5lY3V0PTQwIGludHJhX3JlZnJlc2g9MCByY19sb29rYWhlYWQ9NDAgcm' + 'M9Y3JmIG1idHJlZT0xIGNyZj0yMy4wIHFjb21wPTAuNjAgcXBtaW49MCBxcG1heD02OSBxcH' + 'N0ZXA9NCB2YnZfbWF4cmF0ZT03NjggdmJ2X2J1ZnNpemU9MzAwMCBjcmZfbWF4PTAuMCBuYW' + 'xfaHJkPW5vbmUgZmlsbGVyPTAgaXBfcmF0aW89MS40MCBhcT0xOjEuMDAAgAAAAFZliIQL8m' + 'KAAKvMnJycnJycnJycnXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX' + 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXiEASZACGQAjgCEASZACGQAjgAAAAAdBmjgX4G' + 'SAIQBJkAIZACOAAAAAB0GaVAX4GSAhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZpgL8DJIQBJkA' + 'IZACOAIQBJkAIZACOAAAAABkGagC/AySEASZACGQAjgAAAAAZBmqAvwMkhAEmQAhkAI4AhAE' + 'mQAhkAI4AAAAAGQZrAL8DJIQBJkAIZACOAAAAABkGa4C/AySEASZACGQAjgCEASZACGQAjgA' + 'AAAAZBmwAvwMkhAEmQAhkAI4AAAAAGQZsgL8DJIQBJkAIZACOAIQBJkAIZACOAAAAABkGbQC' + '/AySEASZACGQAjgCEASZACGQAjgAAAAAZBm2AvwMkhAEmQAhkAI4AAAAAGQZuAL8DJIQBJkA' + 'IZACOAIQBJkAIZACOAAAAABkGboC/AySEASZACGQAjgAAAAAZBm8AvwMkhAEmQAhkAI4AhAE' + 'mQAhkAI4AAAAAGQZvgL8DJIQBJkAIZACOAAAAABkGaAC/AySEASZACGQAjgCEASZACGQAjgA' + 'AAAAZBmiAvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZpAL8DJIQBJkAIZACOAAAAABkGaYC' + '/AySEASZACGQAjgCEASZACGQAjgAAAAAZBmoAvwMkhAEmQAhkAI4AAAAAGQZqgL8DJIQBJkA' + 'IZACOAIQBJkAIZACOAAAAABkGawC/AySEASZACGQAjgAAAAAZBmuAvwMkhAEmQAhkAI4AhAE' + 'mQAhkAI4AAAAAGQZsAL8DJIQBJkAIZACOAAAAABkGbIC/AySEASZACGQAjgCEASZACGQAjgA' + 'AAAAZBm0AvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZtgL8DJIQBJkAIZACOAAAAABkGbgC' + 'vAySEASZACGQAjgCEASZACGQAjgAAAAAZBm6AnwMkhAEmQAhkAI4AhAEmQAhkAI4AhAEmQAh' + 'kAI4AhAEmQAhkAI4AAAAhubW9vdgAAAGxtdmhkAAAAAAAAAAAAAAAAAAAD6AAABDcAAQAAAQ' + 'AAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAwAAAzB0cmFrAAAAXHRraGQAAAADAAAAAAAAAAAAAAABAA' + 'AAAAAAA+kAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAA' + 'BAAAAAALAAAACQAAAAAAAkZWR0cwAAABxlbHN0AAAAAAAAAAEAAAPpAAAAAAABAAAAAAKobW' + 'RpYQAAACBtZGhkAAAAAAAAAAAAAAAAAAB1MAAAdU5VxAAAAAAALWhkbHIAAAAAAAAAAHZpZG' + 'UAAAAAAAAAAAAAAABWaWRlb0hhbmRsZXIAAAACU21pbmYAAAAUdm1oZAAAAAEAAAAAAAAAAA' + 'AAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAhNzdGJsAAAAr3N0c2QAAA' + 'AAAAAAAQAAAJ9hdmMxAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAALAAkABIAAAASAAAAAAAAA' + 'ABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGP//AAAALWF2Y0MBQsAN/+EAFW' + 'dCwA3ZAsTsBEAAAPpAADqYA8UKkgEABWjLg8sgAAAAHHV1aWRraEDyXyRPxbo5pRvPAyPzAA' + 'AAAAAAABhzdHRzAAAAAAAAAAEAAAAeAAAD6QAAABRzdHNzAAAAAAAAAAEAAAABAAAAHHN0c2' + 'MAAAAAAAAAAQAAAAEAAAABAAAAAQAAAIxzdHN6AAAAAAAAAAAAAAAeAAADDwAAAAsAAAALAA' + 'AACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAA' + 'oAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAA' + 'AAiHN0Y28AAAAAAAAAHgAAAEYAAANnAAADewAAA5gAAAO0AAADxwAAA+MAAAP2AAAEEgAABC' + 'UAAARBAAAEXQAABHAAAASMAAAEnwAABLsAAATOAAAE6gAABQYAAAUZAAAFNQAABUgAAAVkAA' + 'AFdwAABZMAAAWmAAAFwgAABd4AAAXxAAAGDQAABGh0cmFrAAAAXHRraGQAAAADAAAAAAAAAA' + 'AAAAACAAAAAAAABDcAAAAAAAAAAAAAAAEBAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAA' + 'AAAAAAAABAAAAAAAAAAAAAAAAAAAAkZWR0cwAAABxlbHN0AAAAAAAAAAEAAAQkAAADcAABAA' + 'AAAAPgbWRpYQAAACBtZGhkAAAAAAAAAAAAAAAAAAC7gAAAykBVxAAAAAAALWhkbHIAAAAAAA' + 'AAAHNvdW4AAAAAAAAAAAAAAABTb3VuZEhhbmRsZXIAAAADi21pbmYAAAAQc21oZAAAAAAAAA' + 'AAAAAAJGRpbmYAAAAcZHJlZgAAAAAAAAABAAAADHVybCAAAAABAAADT3N0YmwAAABnc3RzZA' + 'AAAAAAAAABAAAAV21wNGEAAAAAAAAAAQAAAAAAAAAAAAIAEAAAAAC7gAAAAAAAM2VzZHMAAA' + 'AAA4CAgCIAAgAEgICAFEAVBbjYAAu4AAAADcoFgICAAhGQBoCAgAECAAAAIHN0dHMAAAAAAA' + 'AAAgAAADIAAAQAAAAAAQAAAkAAAAFUc3RzYwAAAAAAAAAbAAAAAQAAAAEAAAABAAAAAgAAAA' + 'IAAAABAAAAAwAAAAEAAAABAAAABAAAAAIAAAABAAAABgAAAAEAAAABAAAABwAAAAIAAAABAA' + 'AACAAAAAEAAAABAAAACQAAAAIAAAABAAAACgAAAAEAAAABAAAACwAAAAIAAAABAAAADQAAAA' + 'EAAAABAAAADgAAAAIAAAABAAAADwAAAAEAAAABAAAAEAAAAAIAAAABAAAAEQAAAAEAAAABAA' + 'AAEgAAAAIAAAABAAAAFAAAAAEAAAABAAAAFQAAAAIAAAABAAAAFgAAAAEAAAABAAAAFwAAAA' + 'IAAAABAAAAGAAAAAEAAAABAAAAGQAAAAIAAAABAAAAGgAAAAEAAAABAAAAGwAAAAIAAAABAA' + 'AAHQAAAAEAAAABAAAAHgAAAAIAAAABAAAAHwAAAAQAAAABAAAA4HN0c3oAAAAAAAAAAAAAAD' + 'MAAAAaAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAA' + 'AACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAA' + 'kAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAA' + 'AACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAACMc3RjbwAAAA' + 'AAAAAfAAAALAAAA1UAAANyAAADhgAAA6IAAAO+AAAD0QAAA+0AAAQAAAAEHAAABC8AAARLAA' + 'AEZwAABHoAAASWAAAEqQAABMUAAATYAAAE9AAABRAAAAUjAAAFPwAABVIAAAVuAAAFgQAABZ' + '0AAAWwAAAFzAAABegAAAX7AAAGFwAAAGJ1ZHRhAAAAWm1ldGEAAAAAAAAAIWhkbHIAAAAAAA' + 'AAAG1kaXJhcHBsAAAAAAAAAAAAAAAALWlsc3QAAAAlqXRvbwAAAB1kYXRhAAAAAQAAAABMYX' + 'ZmNTUuMzMuMTAw';
exports.BLANK_VIDEO_SRC = BLANK_VIDEO_SRC;

},{}],74:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.DevelopmentModeLog = exports.DevelopmentModeLogButtonSet = void 0;

var _log = require("../../../src/log");

var _services = require("../../../src/services");

var _types = require("../../../src/types");

var _dom = require("../../../src/dom");

var _style = require("../../../src/style");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @param {!../../../src/service/vsync-impl.Vsync} vsync
 * @param {!Element} el
 * @param {boolean} isHidden
 */
function toggleHiddenAttribute(vsync, el, isHidden) {
  vsync.mutate(function () {
    (0, _style.toggle)(el, !isHidden);
  });
}

/**
 * @param {!Window} win
 * @param {string|!Array<string>} classNameOrList
 * @param {function(Event)} handler
 * @return {!Element}
 */
function createButton(win, classNameOrList, handler) {
  var button = win.document.createElement('div');
  button.setAttribute('role', 'button');

  if ((0, _types.isArray)(classNameOrList)) {
    classNameOrList.forEach(function (className) {
      return button.classList.add(className);
    });
  } else {
    button.classList.add(
    /** @type {string} */
    classNameOrList);
  }

  button.classList.add('i-amphtml-story-button');
  button.addEventListener('click', handler);
  return button;
}

/**
 * Development mode logs buttons.
 */
var DevelopmentModeLogButtonSet = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function DevelopmentModeLogButtonSet(win) {
    _classCallCheck(this, DevelopmentModeLogButtonSet);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {?Element} */
    this.root_ = null;

    /** @private {?Element} */
    this.errorButton_ = null;

    /** @private {?Element} */
    this.warningButton_ = null;

    /** @private {?Element} */
    this.successButton_ = null;
  }

  /**
   * @param {!Window} win
   * @return {!DevelopmentModeLogButtonSet}
   */
  _createClass(DevelopmentModeLogButtonSet, [{
    key: "build",

    /**
     * Builds the developer log button set element.
     * @param {function()} logButtonActionFn A callback function to be invoked when
     *     the log buttons are clicked.
     * @return {?Element}
     */
    value: function build(logButtonActionFn) {
      this.errorButton_ = createButton(this.win_, ['i-amphtml-story-error-button', 'i-amphtml-story-dev-logs-button'], function () {
        return logButtonActionFn();
      });
      this.warningButton_ = createButton(this.win_, ['i-amphtml-story-warning-button', 'i-amphtml-story-dev-logs-button'], function () {
        return logButtonActionFn();
      });
      this.successButton_ = createButton(this.win_, ['i-amphtml-story-success-button', 'i-amphtml-story-dev-logs-button'], function () {
        return logButtonActionFn();
      });
      this.root_ = this.win_.document.createElement('div');
      this.root_.appendChild(this.errorButton_);
      this.root_.appendChild(this.warningButton_);
      this.root_.appendChild(this.successButton_);
      return this.root_;
    }
    /**
     * Gets the button associated to a given log entry.
     * @param {!./logging.AmpStoryLogEntryDef} logEntry The log entry for which
     *     the associated button shouldbe retrieved.
     * @return {?Element} The button associated to the specified log entry, if one
     *     exists.
     * @private
     */

  }, {
    key: "getButtonForLogEntry_",
    value: function getButtonForLogEntry_(logEntry) {
      if (logEntry.conforms) {
        return this.successButton_;
      }

      switch (logEntry.level) {
        case _log.LogLevel.ERROR:
          return this.errorButton_;

        case _log.LogLevel.WARN:
          return this.warningButton_;

        default:
          return null;
      }
    }
    /**
     * Logs an individual entry into the developer log.
     * @param {!./logging.AmpStoryLogEntryDef} logEntry The entry to log.
     */

  }, {
    key: "log",
    value: function log(logEntry) {
      var button = this.getButtonForLogEntry_(logEntry);

      if (!button) {
        return;
      }

      var oldCount = parseInt(button.getAttribute('data-count') || 0, 10);
      button.setAttribute('data-count', oldCount + 1);
    }
    /**
     * Clears any error state held by the buttons.
     */

  }, {
    key: "clear",
    value: function clear() {
      this.errorButton_.setAttribute('data-count', 0);
      this.warningButton_.setAttribute('data-count', 0);
      this.successButton_.setAttribute('data-count', 0);
    }
  }], [{
    key: "create",
    value: function create(win) {
      return new DevelopmentModeLogButtonSet(win);
    }
  }]);

  return DevelopmentModeLogButtonSet;
}();

exports.DevelopmentModeLogButtonSet = DevelopmentModeLogButtonSet;

/**
 * Development mode log for <amp-story>.
 */
var DevelopmentModeLog = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function DevelopmentModeLog(win) {
    _classCallCheck(this, DevelopmentModeLog);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {?Element} */
    this.root_ = null;

    /** @private {?Element} */
    this.entriesEl_ = null;

    /** @private {?Element} */
    this.contextStringEl_ = null;
  }

  /**
   * @param {!Window} win
   * @return {!DevelopmentModeLog}
   */
  _createClass(DevelopmentModeLog, [{
    key: "build",

    /**
     * Builds the developer log element.
     * @return {?Element}
     */
    value: function build() {
      var _this = this;

      this.contextStringEl_ = this.win_.document.createElement('span');
      this.contextStringEl_.classList.add('i-amphtml-story-developer-log-context');
      var titleEl = this.win_.document.createElement('div');
      titleEl.textContent = 'Developer logs for page ';
      titleEl.appendChild(this.contextStringEl_);
      var closeDeveloperLogEl = createButton(this.win_, 'i-amphtml-story-developer-log-close', function () {
        return _this.hide();
      });
      var headerEl = this.win_.document.createElement('div');
      headerEl.classList.add('i-amphtml-story-developer-log-header');
      headerEl.appendChild(titleEl);
      headerEl.appendChild(closeDeveloperLogEl);
      this.entriesEl_ = this.win_.document.createElement('ul');
      this.entriesEl_.classList.add('i-amphtml-story-developer-log-entries');
      this.root_ = this.win_.document.createElement('div');
      this.root_.classList.add('i-amphtml-story-developer-log');
      (0, _style.toggle)(this.root_, false);
      this.root_.appendChild(headerEl);
      this.root_.appendChild(this.entriesEl_);
      this.clear();
      return this.root_;
    }
    /**
     * @param {!LogLevel} logLevel
     * @return {?string} The CSS class to be applied to the log entry, given the
     *     specified log level, or null if no class should be added.
     * @private
     */

  }, {
    key: "getCssLogLevelClass_",
    value: function getCssLogLevelClass_(logLevel) {
      switch (logLevel) {
        case _log.LogLevel.WARN:
          return 'i-amphtml-story-developer-log-entry-warning';

        case _log.LogLevel.ERROR:
          return 'i-amphtml-story-developer-log-entry-error';

        default:
          return null;
      }
    }
    /**
     * @param {boolean} conforms Whether the log entry is for an element that
     *     conforms to a best practice.
     * @return {?string} The CSS class to be applied to the log entry, given the
     *     element's conformance to a best practice, or null if no class should be
     *     added.
     * @private
     */

  }, {
    key: "getCssConformanceClass_",
    value: function getCssConformanceClass_(conforms) {
      if (conforms) {
        return 'i-amphtml-story-developer-log-entry-success';
      }

      return null;
    }
    /**
     * @param {!./logging.AmpStoryLogEntryDef} logEntry The entry to be logged.
     */

  }, {
    key: "log",
    value: function log(logEntry) {
      var logLevelClass = this.getCssLogLevelClass_(logEntry.level);
      var conformanceClass = this.getCssConformanceClass_(logEntry.conforms);
      var logEntryUi = this.win_.document.createElement('li');
      logEntryUi.classList.add('i-amphtml-story-developer-log-entry');

      if (logLevelClass) {
        logEntryUi.classList.add(logLevelClass);
      }

      if (conformanceClass) {
        logEntryUi.classList.add(conformanceClass);
      }

      logEntryUi.textContent = logEntry.message;
      this.entriesEl_.appendChild(logEntryUi);
    }
    /**
     * Clears all entries from the developer logs.
     */

  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      _services.Services.vsyncFor(this.win_).mutate(function () {
        (0, _dom.removeChildren)((0, _log.dev)().assertElement(_this2.entriesEl_));
      });
    }
    /**
     * Sets the string providing context for the developer logs window.  This is
     * often the name or ID of the element that all logs are for (e.g. the page).
     * @param {string} contextString
     */

  }, {
    key: "setContextString",
    value: function setContextString(contextString) {
      this.contextStringEl_.textContent = contextString;
    }
    /**
     * Toggles the visibility of the developer log.
     */

  }, {
    key: "toggle",
    value: function toggle() {
      var newHiddenState = !this.root_.hasAttribute('hidden');
      toggleHiddenAttribute(_services.Services.vsyncFor(this.win_), (0, _log.dev)().assertElement(this.root_), newHiddenState);
    }
    /**
     * Hides the developer log in the UI.
     */

  }, {
    key: "hide",
    value: function hide() {
      toggleHiddenAttribute(_services.Services.vsyncFor(this.win_), (0, _log.dev)().assertElement(this.root_),
      /* isHidden */
      true);
    }
  }], [{
    key: "create",
    value: function create(win) {
      return new DevelopmentModeLog(win);
    }
  }]);

  return DevelopmentModeLog;
}();

exports.DevelopmentModeLog = DevelopmentModeLog;

},{"../../../src/dom":106,"../../../src/log":123,"../../../src/services":133,"../../../src/style":138,"../../../src/types":139}],75:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.parseEmbedMode = parseEmbedMode;
exports.EmbedModeParam = exports.EmbedMode = void 0;

var _types = require("../../../src/types");

var _url = require("../../../src/url");

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Embed mode for AMP story.  See ../embed-modes.md for details.
 * @enum {number}
 */
var EmbedMode = {
  /**
   * Default mode.
   */
  NOT_EMBEDDED: 0,

  /**
   * TBD embed mode.
   *
   * This differs from the NOT_EMBEDDED embed mode in the following ways:
   * - Hides bookend
   * - Hides all system layer buttons
   * - Disables swipe-based user education
   * - Disallows ads
   * - Unmutes audio in the story by default
   */
  NAME_TBD: 1,

  /**
   * This mode is intended for embedders that natively handle sharing the story,
   * thereby rendering the sharing functionality within the amp-story extension
   * redundant.
   *
   * This differs from the NOT_EMBEDDED embed mode in the following ways:
   * - Removes share icon from system layer
   * - Removes sharing section from bookend
   * - TODO(#14923): Removes the link information from embedded UIs.
   */
  NO_SHARING: 2,

  /**
   * This mode is intended for a preview of the story.
   *
   * This differs from the NOT_EMBEDDED embed mode in the following ways:
   * - Auto-advances pages by a given duration.
   * - Hides bookend
   * - Hides all system layer buttons
   * - Disables swipe-based user education
   * - Disallows ads
   */
  PREVIEW: 3,

  /**
   * This mode is intended for embedders that natively handle the audio and
   * sharing experiences, through native controls and viewer communication.
   *
   * This differs from the NOT_EMBEDDED embed mode in the following ways:
   * - Removes share icon from system layer
   * - Removes sharing section from bookend
   * - Removes audio icon from system layer
   */
  NO_SHARING_NOR_AUDIO_UI: 4
};
exports.EmbedMode = EmbedMode;

/**
 * Parameter to retrieve the embed mode from the location hash.
 * @type {string}
 */
var EmbedModeParam = 'embedMode';
exports.EmbedModeParam = EmbedModeParam;

/**
 * @param {string} str
 * @return {!EmbedMode}
 * @package
 */
function parseEmbedMode(str) {
  var params = (0, _url.parseQueryString)(str);
  var unsanitizedEmbedMode = params[EmbedModeParam];
  var embedModeIndex = parseInt(unsanitizedEmbedMode, 10);
  return (0, _types.isEnumValue)(EmbedMode, embedModeIndex) ?
  /** @type {!EmbedMode} */
  embedModeIndex : EmbedMode.NOT_EMBEDDED;
}

},{"../../../src/types":139,"../../../src/url":142}],76:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.dispatch = dispatch;
exports.EventType = void 0;

var _eventHelper = require("../../../src/event-helper");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @const {!Object<string, string>} */
var EventType = {
  // Triggered when the user mutes the story
  MUTE: 'ampstory:mute',
  // Triggered when the user unmutes the story
  UNMUTE: 'ampstory:unmute',
  // Triggered when the story should switch to a specified page
  SWITCH_PAGE: 'ampstory:switchpage',
  // Triggered when the story should switch to the previous page
  PREVIOUS_PAGE: 'ampstory:previouspage',
  // Triggered when the story should switch to the next page
  NEXT_PAGE: 'ampstory:nextpage',
  // Triggered when a page updates its progress
  PAGE_PROGRESS: 'ampstory:pageprogress',
  // Triggered when the story should be replayed
  REPLAY: 'ampstory:replay',
  // DEVELOPMENT MODE ONLY: Triggered when a story page has log entries (e.g.
  // warnings or errors).
  DEV_LOG_ENTRIES_AVAILABLE: 'ampstory:devlogentriesavailable',
  // Triggered when user clicks on end 75% of the last page
  NO_NEXT_PAGE: 'ampstory:nonextpage',
  // Triggered when user clicks on start 25% of the first page
  NO_PREVIOUS_PAGE: 'ampstory:nopreviouspage',
  // Triggered when a story has loaded at least its initial set of pages.
  STORY_LOADED: 'ampstory:load',
  // Triggered when a page has loaded at least one frame of all of its media.
  PAGE_LOADED: 'ampstory:pageload',
  // Dispatches an action to the amp-story store service. Only works under test.
  DISPATCH_ACTION: 'ampstory:dispatchaction'
};
exports.EventType = EventType;

/**
 * @param {!Window} win
 * @param {!EventTarget} source
 * @param {string} eventName
 * @param {!JsonObject=} payload
 * @param {!CustomEventInit=} eventInit
 */
function dispatch(win, source, eventName, payload, eventInit) {
  if (payload === void 0) {
    payload = undefined;
  }

  if (eventInit === void 0) {
    eventInit = undefined;
  }

  var event = (0, _eventHelper.createCustomEvent)(win, eventName, payload, eventInit);
  source.dispatchEvent(event);
}

},{"../../../src/event-helper":111}],77:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.setHistoryState = setHistoryState;
exports.getHistoryState = getHistoryState;
exports.HistoryState = exports.LOCAL_STORAGE_KEY = void 0;

var _object = require("../../../src/utils/object");

var _history = require("../../../src/history");

var _json = require("../../../src/json");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var EXPIRATION_DURATION_MILLIS = 10 * 60 * 1000;
// 10 Minutes
var CREATION_TIME = 'time';
var STATE = 'state';

/** @visibleForTesting */
var LOCAL_STORAGE_KEY = 'amp-story-state';
exports.LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEY;

/** @enum {string} */
var HistoryState = {
  ATTACHMENT_PAGE_ID: 'ampStoryAttachmentPageId',
  BOOKEND_ACTIVE: 'ampStoryBookendActive',
  NAVIGATION_PATH: 'ampStoryNavigationPath'
};
exports.HistoryState = HistoryState;

/**
 * Updates the value for a given state in the window history.
 * Also persists state in localStorage for 10 minutes, so that state is
 * persisted if Stories are shown within viewers that may recycle
 * iframes or webviews.
 * @param {!Window} win
 * @param {string} stateName
 * @param {string|boolean|Array<string>|null} value
 */
function setHistoryState(win, stateName, value) {
  var _extends2;

  var history = win.history;
  var state = (0, _history.getState)(history) || {};

  var newHistory = _extends({}, state, (_extends2 = {}, _extends2[stateName] = value, _extends2));

  history.replaceState(newHistory, '');
  setLocalStorageState(win, newHistory);
}

/**
 * Returns the value of a given state of the window history or localStorage.
 * See `setHistoryState` for an explanation of the use of localStorage.
 * @param {!Window} win
 * @param {string} stateName
 * @return {string|boolean|Array<string>|null}
 */
function getHistoryState(win, stateName) {
  var history = win.history;
  var state = (0, _history.getState)(history);

  // We do get an early state but without a navigation path. In that case we
  // prefer localStorage.
  if (!state || !state[stateName]) {
    state = getLocalStorageState(win);
  }

  if (state) {
    return (
      /** @type {string|boolean|Array<string>|null} */
      state[stateName] || null
    );
  }

  return null;
}

/**
 * Get history state from localStorage.
 * @param {!Window} win
 * @return {*}
 */
function getLocalStorageState(win) {
  // We definitely don't want to restore state from localStorage if the URL
  // is explicit about it.
  var hash = win.location.hash;

  if (hash.indexOf('page=') != -1 || hash.indexOf('ignoreLocalStorageHistory') != -1) {
    return undefined;
  }

  var container = getLocalStorageStateContainer(win);
  var holder = container && container[getDocumentKey(win)];
  return holder && holder[STATE];
}

/**
 * Set history state in localStorage.
 * State is keyed off of the URL-minus fragment of the Story.
 * @param {!Window} win
 * @param {*} state
 */
function setLocalStorageState(win, state) {
  var _container$getDocumen;

  var container = getLocalStorageStateContainer(win);
  container[getDocumentKey(win)] = (_container$getDocumen = {}, _container$getDocumen[STATE] = state, _container$getDocumen[CREATION_TIME] = Date.now(), _container$getDocumen);
  writeLocalStorage(win, container);
}

/**
 * Gets a dictionary of all history states on the current origin.
 * If an entry is expired, removes it from the set and writes the new
 * set back to storage.
 * @param {!Window} win
 * @return {!JsonObject}
 */
function getLocalStorageStateContainer(win) {
  var container = readLocalStorage(win);

  if (!container) {
    return (0, _object.dict)();
  }

  var now = Date.now();
  var expired = false;
  Object.keys(container).forEach(function (href) {
    var item = container[href];

    if (now > item[CREATION_TIME] + EXPIRATION_DURATION_MILLIS) {
      delete container[href];
      expired = true;
    }
  });

  if (expired) {
    writeLocalStorage(win, container);
  }

  return container;
}

/**
 * Returns the key under which we store state for the current document.
 * @param {!Window} win
 * @return {string}
 */
function getDocumentKey(win) {
  return win.location.href.replace(/\#.*/, '');
}

/**
 * @param {!Window} win
 * @return {?JsonObject}
 */
function readLocalStorage(win) {
  try {
    return (0, _json.parseJson)(win.localStorage.getItem(LOCAL_STORAGE_KEY));
  } catch (e) {
    return null;
  }
}

/**
 * @param {!Window} win
 * @param {JsonObject} container
 */
function writeLocalStorage(win, container) {
  try {
    win.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(container));
  } catch (e) {}
}

},{"../../../src/history":117,"../../../src/json":120,"../../../src/utils/object":149}],78:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getJsonLd = getJsonLd;

var _dom = require("../../../src/dom");

var _json = require("../../../src/json");

var _log = require("../../../src/log");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TAG = 'getJsonLd';

/**
 * @param {!Node} root
 * @return {?JsonObject}
 */
function getJsonLd(root) {
  var scriptTag = root.querySelector('script[type="application/ld+json"]');

  if (!scriptTag || !(0, _dom.isJsonLdScriptTag)(scriptTag)) {
    return null;
  }

  return (0, _json.tryParseJson)(scriptTag.textContent, function (e) {
    (0, _log.user)().error(TAG, 'Failed to parse ld+json. Is it valid JSON?', e);
  }) || null;
}

},{"../../../src/dom":106,"../../../src/json":120,"../../../src/log":123}],79:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.LiveStoryManager = void 0;

var _ampStoryStoreService = require("./amp-story-store-service");

var _commonSignals = require("../../../src/common-signals");

var _services = require("../../../src/services");

var _dom = require("../../../src/dom");

var _object = require("../../../src/utils/object");

var _log = require("../../../src/log");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Property used for storing id of custom slot. This custom slot can be used to
 * replace the default "items" and "update" slot.
 * @const {string}
 */
var AMP_LIVE_LIST_CUSTOM_SLOT_ID = 'AMP_LIVE_LIST_CUSTOM_SLOT_ID';

var LiveStoryManager = /*#__PURE__*/function () {
  /**
   * @param {!./amp-story.AmpStory} ampStory
   */
  function LiveStoryManager(ampStory) {
    _classCallCheck(this, LiveStoryManager);

    /** @private @const {!./amp-story.AmpStory} */
    this.ampStory_ = ampStory;

    /** @private @const {!../../../src/service/ampdoc-impl.AmpDoc} */
    this.ampdoc_ = this.ampStory_.getAmpDoc();

    /** @private @const {!Element} */
    this.storyEl_ = ampStory.element;

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.ampStory_.win);
  }

  /**
   * Initializes an amp-live-list component with the story-specific
   * configuration and appends it to the DOM.
   */
  _createClass(LiveStoryManager, [{
    key: "build",
    value: function build() {
      var _this = this;

      var liveListEl = (0, _dom.createElementWithAttributes)(this.ampStory_.win.document, 'amp-live-list', (0, _object.dict)({
        'id': 'i-amphtml-' + this.storyEl_.id + '-dynamic-list',
        'data-poll-interval': this.storyEl_.getAttribute('data-poll-interval') || 15000,
        'sort': 'ascending',
        'disable-scrolling': '',
        'disable-pagination': '',
        'auto-insert': ''
      }));
      liveListEl[AMP_LIVE_LIST_CUSTOM_SLOT_ID] = (0, _log.userAssert)(this.storyEl_.id, 'amp-story must contain id to use the live story functionality');
      this.ampStory_.element.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END).then(function () {
        _services.Services.extensionsFor(_this.ampdoc_.win).installExtensionForDoc(_this.ampdoc_, 'amp-live-list');

        _this.storyEl_.insertBefore(liveListEl, _this.storyEl_.firstElementChild);
      });
    }
    /**
     * Updates the client amp-story with the changes from the server document.
     */

  }, {
    key: "update",
    value: function update() {
      var lastNewPageEl = (0, _dom.lastChildElement)(this.storyEl_, function (page) {
        return page.classList.contains('amp-live-list-item-new');
      });
      var storyPages = this.storyEl_.querySelectorAll('amp-story-page');
      var pageIds = Array.prototype.map.call(storyPages, function (el) {
        return el.id;
      });
      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_PAGE_IDS, pageIds);
      this.storeService_.dispatch(_ampStoryStoreService.Action.ADD_NEW_PAGE_ID, lastNewPageEl.id);
    }
  }]);

  return LiveStoryManager;
}();

exports.LiveStoryManager = LiveStoryManager;

},{"../../../src/common-signals":101,"../../../src/dom":106,"../../../src/log":123,"../../../src/services":133,"../../../src/utils/object":149,"./amp-story-store-service":53}],80:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.LoadingSpinner = void 0;

var _log = require("../../../src/log");

var _object = require("./../../../src/utils/object");

var _simpleTemplate = require("./simple-template");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {string} */
var SPINNER_ACTIVE_ATTRIBUTE = 'active';

/** @private @const {!./simple-template.ElementDef} */
var SPINNER = {
  tag: 'div',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-spinner',
    'aria-hidden': 'true',
    'aria-label': 'Loading video'
  }),
  children: [{
    tag: 'div',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-spinner-container'
    }),
    children: [{
      tag: 'div',
      attrs: (0, _object.dict)({
        'class': 'i-amphtml-story-spinner-layer'
      }),
      children: [{
        tag: 'div',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-spinner-circle-clipper left'
        })
      }, {
        tag: 'div',
        attrs: (0, _object.dict)({
          'class': 'i-amphtml-story-spinner-circle-clipper right'
        })
      }]
    }]
  }]
};

/**
 * Loading spinner UI element.
 */
var LoadingSpinner = /*#__PURE__*/function () {
  /**
   * @param {!Document} doc
   */
  function LoadingSpinner(doc) {
    _classCallCheck(this, LoadingSpinner);

    /** @private @const {!Document} */
    this.doc_ = doc;

    /** @public {?Element} */
    this.root_ = null;

    /** @private {boolean} */
    this.isActive_ = false;
  }

  /**
   * @return {!Element}
   */
  _createClass(LoadingSpinner, [{
    key: "build",
    value: function build() {
      if (this.root_) {
        return this.root_;
      }

      this.root_ = (0, _simpleTemplate.renderAsElement)(this.doc_, SPINNER);
      return this.getRoot();
    }
    /** @return {!Element} */

  }, {
    key: "getRoot",
    value: function getRoot() {
      return (0, _log.dev)().assertElement(this.root_);
    }
    /** @param {boolean} isActive */

  }, {
    key: "toggle",
    value: function toggle(isActive) {
      if (isActive === this.isActive_) {
        return;
      }

      if (isActive) {
        this.root_.setAttribute(SPINNER_ACTIVE_ATTRIBUTE, '');
        this.root_.setAttribute('aria-hidden', 'false');
      } else {
        this.root_.removeAttribute(SPINNER_ACTIVE_ATTRIBUTE);
        this.root_.setAttribute('aria-hidden', 'true');
      }

      this.isActive_ = isActive;
    }
  }]);

  return LoadingSpinner;
}();

exports.LoadingSpinner = LoadingSpinner;

},{"../../../src/log":123,"./../../../src/utils/object":149,"./simple-template":89}],81:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getLogEntries = getLogEntries;
exports.AmpStoryLogEntryDef = void 0;

var _log = require("../../../src/log");

var _dom = require("../../../src/dom");

var _promise = require("../../../src/utils/promise");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @typedef {function(!Element): (boolean|!Promise<boolean>)} */
var ElementPredicate_1_0_Def;
// eslint-disable-line google-camelcase/google-camelcase

/**
 * A log type is an abstract rule or best practice that should be followed when
 * constructing a story.  This is internal to this file, which handles finding
 * specific instances of these log types, and returning them as log entries.
 *
 * message: (required) The message shown to developers in development mode if
 *     the best practice is not followed.
 * level: (required) The log level at which this entry should be logged.
 * moreInfo: (optional) A URL to a page containing additional documentation on
 *     the best practice.
 * selector: (optional) A selector to be queried on the currently-active page,
 *     and whose results will be subject to the best practice (given that they
 *     also match the precondition).  If unspecified, the amp-story-page itself
 *     is assumed to be subject to the best practice.
 * precondition: (optional) A predicate that takes an element and returns true
 *     if the specified element should be subject to the best practice.  If
 *     unspecified, all elements that match the selector are subject to the best
 *     practice.
 * predicate: (optional) A predicate that takes an element and returns true if
 *     the element follows the best practice, or false otherwise.  If
 *     unspecified, all elements are assumed not to follow the best practice.
 *
 * @typedef {{
 *   message: string,
 *   level: !LogLevel,
 *   moreInfo: (string|undefined),
 *   selector: (string|undefined),
 *   precondition: (!ElementPredicate_1_0_Def|undefined),
 *   predicate: (!ElementPredicate_1_0_Def|undefined),
 * }}
 */
var AmpStoryLogType_1_0_Def;
// eslint-disable-line google-camelcase/google-camelcase

/**
 * A log entry is a more concrete version of a rule or best practice; it refers
 * to whether a specific element on a specific page of a specific story conforms
 * to a given best practice.
 *
 * @typedef {{
 *   element: !Element,
 *   rootElement: !Element,
 *   message: string,
 *   level: !LogLevel,
 *   conforms: boolean,
 *   moreInfo: (string|undefined),
 * }}
 */
var AmpStoryLogEntryDef;
exports.AmpStoryLogEntryDef = AmpStoryLogEntryDef;

/** @private @const {string} */
var AMPPROJECT_DOCS = 'https://www.ampproject.org/docs';

/**
 * @param {!HTMLMediaElement} el
 * @return {!Promise<Image>}
 */
function getPosterFromVideo(el) {
  return new Promise(function (resolve, reject) {
    var poster = new Image();

    poster.onload = function () {
      return resolve(poster);
    };

    poster.onerror = reject;
    poster.src = el.getAttribute('poster');
  });
}

/** @enum {!AmpStoryLogType_1_0_Def} */
var LogType = {
  /** Errors */
  VIDEOS_POSTER_SPECIFIED: {
    message: 'Videos should specify a poster image.',
    moreInfo: AMPPROJECT_DOCS + '/reference/components/amp-video#poster',
    selector: 'video:not([poster])',
    level: _log.LogLevel.ERROR
  },

  /** Warnings */
  IMAGES_MAX_720P_OR_SRCSET: {
    message: 'Images should not be larger than 720p.  If you wish to use' + ' images that are larger than 720p, you should specify a srcset.',
    moreInfo: AMPPROJECT_DOCS + '/guides/responsive/art_direction#srcset',
    selector: 'img:not([srcset])',
    predicate: function predicate(el) {
      return el.naturalWidth <= 720 && el.naturalHeight <= 1280;
    },
    level: _log.LogLevel.WARN
  },
  IMAGES_PORTRAIT: {
    message: 'Full-bleed images should be in portrait orientation.',
    selector: 'amp-story-grid-layer[template="fill"] > amp-img > img',
    predicate: function predicate(el) {
      return el.naturalWidth < el.naturalHeight;
    },
    level: _log.LogLevel.WARN
  },
  VIDEOS_MAX_720P: {
    message: 'Videos should not be larger than 720p.',
    selector: 'video',
    predicate: function predicate(el) {
      return el.videoWidth <= 720 && el.videoHeight <= 1280;
    },
    level: _log.LogLevel.WARN
  },
  VIDEOS_PORTRAIT: {
    message: 'Full-bleed videos should be in portrait orientation.',
    selector: 'amp-story-grid-layer[template="fill"] > amp-video > video',
    predicate: function predicate(el) {
      return el.videoWidth < el.videoHeight;
    },
    level: _log.LogLevel.WARN
  },
  VIDEO_POSTER_MAX_720P: {
    message: 'Video poster images should not be larger than 720p.',
    selector: 'video[poster]',
    predicate: function predicate(el) {
      return getPosterFromVideo(el).then(function (poster) {
        return poster.naturalWidth <= 720 && poster.naturalHeight <= 1280;
      });
    },
    level: _log.LogLevel.WARN
  },
  VIDEO_POSTER_POTRAIT: {
    message: 'Poster images for full-bleed videos should be in portrait ' + 'orientation.',
    selector: 'amp-story-grid-layer[template="fill"] > amp-video > video[poster]',
    predicate: function predicate(el) {
      return getPosterFromVideo(el).then(function (poster) {
        return poster.naturalWidth < poster.naturalHeight;
      });
    },
    level: _log.LogLevel.WARN
  }
};

/**
 * Gets the log type associated with the specified key.
 * @param {string} logTypeKey
 * @return {!AmpStoryLogType_1_0_Def}
 */
function getLogType(logTypeKey) {
  var logType = LogType[logTypeKey];
  (0, _log.devAssert)(logType, "There is no log type \"" + logTypeKey + "\".");
  (0, _log.devAssert)(logType.message, "Log type \"" + logTypeKey + "\" has no associated message.");
  (0, _log.devAssert)(logType.level, "Log type \"" + logTypeKey + "\" has no associated log level.");
  return logType;
}

/**
 * @param {!Element} rootElement
 * @param {!AmpStoryLogType_1_0_Def} logType
 * @param {!Element} element
 * @return {!Promise<!AmpStoryLogEntryDef>}
 */
function getLogEntry(rootElement, logType, element) {
  var predicate = logType.predicate || function (unusedEl) {
    return false;
  };

  return (0, _promise.tryResolve)(function () {
    return predicate(element);
  }).then(function (conforms) {
    return new Promise(function (resolve) {
      resolve({
        rootElement: rootElement,
        element: element,
        conforms: conforms,
        level: logType.level,
        message: logType.message,
        moreInfo: logType.moreInfo
      });
    });
  });
}

/**
 * @param {!Element} rootElement
 * @param {!AmpStoryLogType_1_0_Def} logType
 * @return {!Array<!Promise<!AmpStoryLogEntryDef>>}
 */
function getLogEntriesForType(rootElement, logType) {
  var precondition = logType.precondition || function (unusedEl) {
    return true;
  };

  var elements = logType.selector ? [].slice.call((0, _dom.scopedQuerySelectorAll)(rootElement, logType.selector)) : [rootElement];
  return elements.filter(precondition).map(getLogEntry.bind(
  /** thisArg */
  null, rootElement, logType));
}

/**
 * @param {!AmpStoryLogEntryDef} logEntryA
 * @param {!AmpStoryLogEntryDef} logEntryB
 * @return {number}
 */
function logEntryCompareFn(logEntryA, logEntryB) {
  if (logEntryA.conforms == logEntryB.conforms) {
    // For entries within that are all conformant or all non-conformant, sort by
    // log level, with most severe entries first and least severe entries last.
    return logEntryA.level <= logEntryB.level ? -1 : 1;
  } else {
    // false < true, so non-conformant issues go before conformant ones.
    return logEntryA.conforms < logEntryB.conforms ? -1 : 1;
  }
}

/**
 * Gets a promise which yields a list of log entries for the specified element.
 * @param {!Element} rootElement
 * @return {!Promise<!Array<!AmpStoryLogEntryDef>>}
 */
function getLogEntries(rootElement) {
  var logEntryPromises = Object.keys(LogType).reduce(function (entries, key) {
    var logType = getLogType(key);
    var newEntries = getLogEntriesForType(rootElement, logType);
    return entries.concat(newEntries);
  }, []);
  return Promise.all(logEntryPromises).then(function (logEntries) {
    return logEntries.sort(logEntryCompareFn);
  });
}

},{"../../../src/dom":106,"../../../src/log":123,"../../../src/utils/promise":150}],82:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.MediaPerformanceMetricsService = exports.getMediaPerformanceMetricsService = void 0;

var _eventHelper = require("../../../src/event-helper");

var _services = require("../../../src/services");

var _enums = require("../../../src/enums");

var _log = require("../../../src/log");

var _css = require("../../../src/css");

var _dom = require("../../../src/dom");

var _object = require("../../../src/utils/object");

var _service = require("../../../src/service");

var _config = require("../../../src/config");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Media status.
 * @enum
 */
var Status = {
  ERRORED: 0,
  PAUSED: 1,
  PLAYING: 2,
  WAITING: 3
};

/**
 * Cache serving status.
 * @enum
 */
var CacheState = {
  ORIGIN: 0,
  // Served from origin.
  ORIGIN_CACHE_MISS: 1,
  // Served from origin even though cache URL was present.
  CACHE: 2 // Served from cache.

};

/**
 * @typedef {{
 *   start: number,
 *   playing: number,
 *   waiting: number,
 * }}
 */
var TimeStampsDef;

/**
 * @typedef {{
 *   error: ?number,
 *   jointLatency: number,
 *   rebuffers: number,
 *   rebufferTime: number,
 *   watchTime: number
 * }}
 */
var MetricsDef;

/**
 * @typedef {{
 *   media: !HTMLMediaElement,
 *   status: number,
 *   unlisteners: !Array<!UnlistenDef>,
 *   timeStamps: !TimeStampsDef,
 *   metrics: !MetricsDef
 * }}
 */
var MediaEntryDef;

/** @type {string} */
var ID_PROPERTY = '__AMP_MEDIA_PERFORMANCE_METRICS_ID';

/** @type {number} */
var MINIMUM_TIME_THRESHOLD_MS = 1000;

/** @type {number} */
var REBUFFER_THRESHOLD_MS = 250;

/** @type {string} */
var TAG = 'media-performance-metrics';

/**
 * Util function to retrieve the media performance metrics service. Ensures we
 * can retrieve the service synchronously from the amp-story codebase without
 * running into race conditions.
 * @param  {!Window} win
 * @return {!MediaPerformanceMetricsService}
 */
var getMediaPerformanceMetricsService = function getMediaPerformanceMetricsService(win) {
  var service = _services.Services.mediaPerformanceMetricsService(win);

  if (!service) {
    service = new MediaPerformanceMetricsService(win);
    (0, _service.registerServiceBuilder)(win, 'media-performance-metrics', function () {
      return service;
    });
  }

  return service;
};

exports.getMediaPerformanceMetricsService = getMediaPerformanceMetricsService;

/**
 * Media performance metrics service.
 * @final
 */
var MediaPerformanceMetricsService = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function MediaPerformanceMetricsService(win) {
    _classCallCheck(this, MediaPerformanceMetricsService);

    /** @private {number} */
    this.mediaId_ = 1;
    // TODO(gmajoulet): switch to WeakMap once the AMPHTML project allows them.

    /** @private @const {!Object<number, !MediaEntryDef>} */
    this.mediaMap_ = (0, _object.map)();

    /** @private @const {!../../../src/service/performance-impl.Performance} */
    this.performanceService_ = _services.Services.performanceFor(win);

    /** @private @const {!../../../src/service/url-impl.Url} */
    this.urlService_ = _services.Services.urlForDoc(win.document.body);
  }

  /**
   * Identifies if the viewer is able to track performance. If the document is
   * not embedded, there is no messaging channel, so no performance tracking is
   * needed since there is nobody to forward the events.
   * @return {boolean}
   */
  _createClass(MediaPerformanceMetricsService, [{
    key: "isPerformanceTrackingOn",
    value: function isPerformanceTrackingOn() {
      return this.performanceService_.isPerformanceTrackingOn();
    }
    /**
     * Starts recording performance metrics for a a given HTMLMediaElement. This
     * method has to be called right before trying to play the media. This allows
     * to reliably record joint latency (time to play), as well initial buffering.
     * @param {!HTMLMediaElement} media
     */

  }, {
    key: "startMeasuring",
    value: function startMeasuring(media) {
      // Media must start paused in order to determine the joint latency, and
      // initial buffering, if any.
      if (!media.paused) {
        (0, _log.dev)().expectedError(TAG, 'media must start paused');
        return;
      }

      var unlisteners = this.listen_(media);
      var mediaEntry = this.getNewMediaEntry_(media, unlisteners);
      this.setMediaEntry_(media, mediaEntry);

      // Checks if the media already errored (eg: could have failed the source
      // selection).
      if (media.error || media[_eventHelper.MEDIA_LOAD_FAILURE_SRC_PROPERTY] === media.currentSrc) {
        mediaEntry.metrics.error = media.error ? media.error.code : 0;
        mediaEntry.status = Status.ERRORED;
      }
    }
    /**
     * Stops recording, computes, and sends performance metrics collected for the
     * given media element.
     * @param {!HTMLMediaElement} media
     * @param {boolean=} sendMetrics
     */

  }, {
    key: "stopMeasuring",
    value: function stopMeasuring(media, sendMetrics) {
      if (sendMetrics === void 0) {
        sendMetrics = true;
      }

      var mediaEntry = this.getMediaEntry_(media);

      if (!mediaEntry) {
        return;
      }

      mediaEntry.unlisteners.forEach(function (unlisten) {
        return unlisten();
      });
      this.deleteMediaEntry_(media);

      switch (mediaEntry.status) {
        case Status.PLAYING:
          this.addWatchTime_(mediaEntry);
          break;

        case Status.WAITING:
          this.addRebuffer_(mediaEntry);
          break;
      }

      if (sendMetrics) {
        this.sendMetrics_(mediaEntry);
      }
    }
    /**
     * @param {!MediaEntryDef} mediaEntry
     * @private
     */

  }, {
    key: "sendMetrics_",
    value: function sendMetrics_(mediaEntry) {
      var media = mediaEntry.media,
          metrics = mediaEntry.metrics;
      var videoCacheState;

      if (this.urlService_.isProxyOrigin(media.currentSrc)) {
        videoCacheState = CacheState.CACHE;
      } else {
        // Media is served from origin. Checks if there was a cached source.
        var _this$urlService_$par = this.urlService_.parse(_config.urls.cdn),
            hostname = _this$urlService_$par.hostname;

        videoCacheState = media.querySelector("[src*=\"" + (0, _css.escapeCssSelectorIdent)(hostname) + "\"]") ? CacheState.ORIGIN_CACHE_MISS : CacheState.ORIGIN;
      }

      this.performanceService_.tickDelta(_enums.TickLabel.VIDEO_CACHE_STATE, videoCacheState);

      // If the media errored.
      if (metrics.error !== null) {
        this.performanceService_.tickDelta(_enums.TickLabel.VIDEO_ERROR, metrics.error || 0);
        this.performanceService_.flush();
        return;
      }

      // If the user was on the video for less than one second, ignore the metrics
      // (eg: users tapping through a story, or scrolling through content).
      if (!metrics.jointLatency && Date.now() - mediaEntry.timeStamps.start < MINIMUM_TIME_THRESHOLD_MS) {
        return;
      }

      // If the playback did not start.
      if (!metrics.jointLatency) {
        this.performanceService_.tickDelta(_enums.TickLabel.VIDEO_ERROR, 5
        /* Custom error code */
        );
        this.performanceService_.flush();
        return;
      }

      var rebufferRate = Math.round(metrics.rebufferTime / (metrics.rebufferTime + metrics.watchTime) * 100);
      this.performanceService_.tickDelta(_enums.TickLabel.VIDEO_JOINT_LATENCY, metrics.jointLatency);
      this.performanceService_.tickDelta(_enums.TickLabel.VIDEO_WATCH_TIME, metrics.watchTime);
      this.performanceService_.tickDelta(_enums.TickLabel.VIDEO_REBUFFERS, metrics.rebuffers);
      this.performanceService_.tickDelta(_enums.TickLabel.VIDEO_REBUFFER_RATE, rebufferRate);

      if (metrics.rebuffers) {
        this.performanceService_.tickDelta(_enums.TickLabel.VIDEO_MEAN_TIME_BETWEEN_REBUFFER, Math.round(metrics.watchTime / metrics.rebuffers));
      }

      this.performanceService_.flush();
    }
    /**
     * @param {!HTMLMediaElement} media
     * @return {!MediaEntryDef}
     * @private
     */

  }, {
    key: "getMediaEntry_",
    value: function getMediaEntry_(media) {
      return this.mediaMap_[media[ID_PROPERTY]];
    }
    /**
     * @param {!HTMLMediaElement} media
     * @param {!MediaEntryDef} mediaEntry
     * @private
     */

  }, {
    key: "setMediaEntry_",
    value: function setMediaEntry_(media, mediaEntry) {
      media[ID_PROPERTY] = media[ID_PROPERTY] || this.mediaId_++;
      this.mediaMap_[media[ID_PROPERTY]] = mediaEntry;
    }
    /**
     * @param {!HTMLMediaElement} media
     * @private
     */

  }, {
    key: "deleteMediaEntry_",
    value: function deleteMediaEntry_(media) {
      delete this.mediaMap_[media[ID_PROPERTY]];
    }
    /**
     * @param {!HTMLMediaElement} media
     * @param {!Array<!UnlistenDef>} unlisteners
     * @return {!MediaEntryDef}
     * @private
     */

  }, {
    key: "getNewMediaEntry_",
    value: function getNewMediaEntry_(media, unlisteners) {
      return {
        media: media,
        status: Status.PAUSED,
        unlisteners: unlisteners,
        timeStamps: {
          start: Date.now(),
          playing: 0,
          waiting: 0
        },
        metrics: {
          error: null,
          jointLatency: 0,
          meanTimeBetweenRebuffers: 0,
          rebuffers: 0,
          rebufferTime: 0,
          watchTime: 0
        }
      };
    }
    /**
     * Increments the watch time with the duration from the last `playing` event.
     * @param {!MediaEntryDef} mediaEntry
     * @private
     */

  }, {
    key: "addWatchTime_",
    value: function addWatchTime_(mediaEntry) {
      mediaEntry.metrics.watchTime += Date.now() - mediaEntry.timeStamps.playing;
    }
    /**
     * Increments the rebuffer time with the duration from the last `waiting`
     * event, and increments the rebuffers count.
     * @param {!MediaEntryDef} mediaEntry
     * @private
     */

  }, {
    key: "addRebuffer_",
    value: function addRebuffer_(mediaEntry) {
      var rebufferTime = Date.now() - mediaEntry.timeStamps.waiting;

      if (rebufferTime > REBUFFER_THRESHOLD_MS) {
        mediaEntry.metrics.rebuffers++;
        mediaEntry.metrics.rebufferTime += rebufferTime;
      }
    }
    /**
     * @param {!HTMLMediaElement} media
     * @return {!Array<!UnlistenDef>}
     * @private
     */

  }, {
    key: "listen_",
    value: function listen_(media) {
      var unlisteners = [(0, _eventHelper.listen)(media, 'ended', this.onPauseOrEnded_.bind(this)), (0, _eventHelper.listen)(media, 'pause', this.onPauseOrEnded_.bind(this)), (0, _eventHelper.listen)(media, 'playing', this.onPlaying_.bind(this)), (0, _eventHelper.listen)(media, 'waiting', this.onWaiting_.bind(this))];
      // If the media element has no `src`, it will try to load the sources in
      // document order. If the last source errors, then the media element
      // loading errored.
      var errorTarget = media;

      if (!media.hasAttribute('src')) {
        errorTarget = (0, _dom.lastChildElement)(media, function (child) {
          return child.tagName === 'SOURCE';
        });
      }

      unlisteners.push((0, _eventHelper.listen)(errorTarget || media, 'error', this.onError_.bind(this)));
      return unlisteners;
    }
    /**
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onError_",
    value: function onError_(event) {
      // Media error target could be either HTMLMediaElement or HTMLSourceElement.
      var media = event.target.tagName === 'SOURCE' ? event.target.parent : event.target;
      var mediaEntry = this.getMediaEntry_(
      /** @type {!HTMLMediaElement} */
      media);
      mediaEntry.metrics.error = media.error ? media.error.code : 0;
      mediaEntry.status = Status.ERRORED;
    }
    /**
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onPauseOrEnded_",
    value: function onPauseOrEnded_(event) {
      var mediaEntry = this.getMediaEntry_(
      /** @type {!HTMLMediaElement} */
      event.target);

      if (mediaEntry.status === Status.PLAYING) {
        this.addWatchTime_(mediaEntry);
      }

      mediaEntry.status = Status.PAUSED;
    }
    /**
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onPlaying_",
    value: function onPlaying_(event) {
      var mediaEntry = this.getMediaEntry_(
      /** @type {!HTMLMediaElement} */
      event.target);
      var timeStamps = mediaEntry.timeStamps,
          metrics = mediaEntry.metrics;

      if (!metrics.jointLatency) {
        metrics.jointLatency = Date.now() - timeStamps.start;
      }

      if (mediaEntry.status === Status.WAITING) {
        this.addRebuffer_(mediaEntry);
      }

      timeStamps.playing = Date.now();
      mediaEntry.status = Status.PLAYING;
    }
    /**
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onWaiting_",
    value: function onWaiting_(event) {
      var mediaEntry = this.getMediaEntry_(
      /** @type {!HTMLMediaElement} */
      event.target);
      var timeStamps = mediaEntry.timeStamps;

      if (mediaEntry.status === Status.PLAYING) {
        this.addWatchTime_(mediaEntry);
      }

      timeStamps.waiting = Date.now();
      mediaEntry.status = Status.WAITING;
    }
  }]);

  return MediaPerformanceMetricsService;
}();

exports.MediaPerformanceMetricsService = MediaPerformanceMetricsService;

},{"../../../src/config":102,"../../../src/css":105,"../../../src/dom":106,"../../../src/enums":108,"../../../src/event-helper":111,"../../../src/log":123,"../../../src/service":130,"../../../src/services":133,"../../../src/utils/object":149}],83:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.MediaPoolRoot = exports.MediaPool = exports.REPLACED_MEDIA_PROPERTY_NAME = exports.ElementDistanceFnDef = exports.DomElementDef = exports.PlaceholderElementDef = exports.MediaType = void 0;

var _resolvedPromise14 = require("./../../../src/resolved-promise");

var _defaultMedia = require("./default-media");

var _mediaTasks = require("./media-tasks");

var _eventHelper = require("../../../src/event-helper");

var _services = require("../../../src/services");

var _sources = require("./sources");

var _utils = require("./utils");

var _log = require("../../../src/log");

var _array = require("../../../src/utils/array");

var _dom = require("../../../src/dom");

var _experiments = require("../../../src/experiments");

var _types = require("../../../src/types");

var _videoInterface = require("../../../src/video-interface");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const @enum {string} */
var MediaType = {
  UNSUPPORTED: 'unsupported',
  AUDIO: 'audio',
  VIDEO: 'video'
};
exports.MediaType = MediaType;

/** @const @enum {string} */
var MediaElementOrigin = {
  PLACEHOLDER: 'placeholder',
  POOL: 'pool'
};

/**
 * A marker type to indicate an element that originated in the document that is
 * being swapped for an element from the pool.
 * @typedef {!Element}
 */
var PlaceholderElementDef;
exports.PlaceholderElementDef = PlaceholderElementDef;

/**
 * A marker type to indicate an element that originated from the pool itself.
 * @typedef {!HTMLMediaElement}
 */
var PoolBoundElementDef;

/**
 * An element pulled from the DOM.  It is yet to be resolved into a
 * PlaceholderElement or a PoolBoundElement.
 * @typedef {!PlaceholderElementDef|!PoolBoundElementDef}
 */
var DomElementDef;
exports.DomElementDef = DomElementDef;

/**
 * Represents the distance of an element from the current place in the document.
 * @typedef {function(!DomElementDef): number}
 */
var ElementDistanceFnDef;
exports.ElementDistanceFnDef = ElementDistanceFnDef;

/**
 * Represents a task to be executed on a media element.
 * @typedef {function(!PoolBoundElementDef, *): !Promise}
 */
var ElementTask_1_0_Def;
// eslint-disable-line google-camelcase/google-camelcase

/**
 * @const {string}
 */
var PLACEHOLDER_ELEMENT_ID_PREFIX = 'i-amphtml-placeholder-media-';

/**
 * @const {string}
 */
var POOL_ELEMENT_ID_PREFIX = 'i-amphtml-pool-media-';

/**
 * @const {string}
 */
var POOL_MEDIA_ELEMENT_PROPERTY_NAME = '__AMP_MEDIA_POOL_ID__';

/**
 * @const {string}
 */
var ELEMENT_TASK_QUEUE_PROPERTY_NAME = '__AMP_MEDIA_ELEMENT_TASKS__';

/**
 * @const {string}
 */
var MEDIA_ELEMENT_ORIGIN_PROPERTY_NAME = '__AMP_MEDIA_ELEMENT_ORIGIN__';

/**
 * The name for a string attribute that represents the ID of a media element
 * that the element containing this attribute replaced.
 * @const {string}
 */
var REPLACED_MEDIA_PROPERTY_NAME = 'replaced-media';
exports.REPLACED_MEDIA_PROPERTY_NAME = REPLACED_MEDIA_PROPERTY_NAME;

/**
 * @type {!Object<string, !MediaPool>}
 */
var instances = {};

/**
 * @type {number}
 */
var nextInstanceId = 0;

/**
 * 🍹 MediaPool
 * Keeps a pool of N media elements to be shared across components.
 */
var MediaPool = /*#__PURE__*/function () {
  /**
   * @param {!Window} win The window object.
   * @param {!Object<!MediaType, number>} maxCounts The maximum amount of each
   *     media element that can be allocated by the pool.
   * @param {!ElementDistanceFnDef} distanceFn A function that, given an
   *     element, returns the distance of that element from the current position
   *     in the document.  The definition of "distance" can be implementation-
   *     dependant, as long as it is consistent between invocations.
   */
  function MediaPool(win, maxCounts, distanceFn) {
    var _this$defaultSources_,
        _this = this,
        _this$mediaFactory_;

    _classCallCheck(this, MediaPool);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private @const {!../../../src/service/timer-impl.Timer} */
    this.timer_ = _services.Services.timerFor(win);

    /**
     * The function used to retrieve the distance between an element and the
     * current position in the document.
     * @private @const {!ElementDistanceFnDef}
     */
    this.distanceFn_ = distanceFn;

    /**
     * Holds all of the pool-bound media elements that have been allocated.
     * @const {!Object<!MediaType, !Array<!PoolBoundElementDef>>}
     * @visibleForTesting
     */
    this.allocated = {};

    /**
     * Holds all of the pool-bound media elements that have not been allocated.
     * @const {!Object<!MediaType, !Array<!PoolBoundElementDef>>}
     * @visibleForTesting
     */
    this.unallocated = {};

    /**
     * Maps a media element's ID to the object containing its sources.
     * @private @const {!Object<string, !Sources>}
     */
    this.sources_ = {};

    /**
     * Maps a media element's ID to the element.  This is necessary, as elements
     * are kept in memory when they are swapped out of the DOM.
     * @private @const {!Object<string, !PlaceholderElementDef>}
     */
    this.placeholderEls_ = {};

    /**
     * Counter used to produce unique IDs for placeholder media elements.
     * @private {number}
     */
    this.placeholderIdCounter_ = 0;

    /**
     * Whether the media elements in this MediaPool instance have been "blessed"
     * for unmuted playback without user gesture.
     * @private {boolean}
     */
    this.blessed_ = false;

    /**
     * The default source to use for pool-created audio sources,
     * @private @const {!Object<!MediaType, string>}
     */
    this.defaultSources_ = (_this$defaultSources_ = {}, _this$defaultSources_[MediaType.AUDIO] = (0, _experiments.isExperimentOn)(win, 'disable-amp-story-default-media') ? '' : _defaultMedia.BLANK_AUDIO_SRC, _this$defaultSources_[MediaType.VIDEO] = (0, _experiments.isExperimentOn)(win, 'disable-amp-story-default-media') ? '' : _defaultMedia.BLANK_VIDEO_SRC, _this$defaultSources_);

    /** @private {?Array<!AmpElement>} */
    this.ampElementsToBless_ = null;

    /** @const {!Object<string, (function(): !PoolBoundElementDef)>} */
    this.mediaFactory_ = (_this$mediaFactory_ = {}, _this$mediaFactory_[MediaType.AUDIO] = function () {
      var audioEl = _this.win_.document.createElement('audio');

      audioEl.setAttribute('muted', '');
      audioEl.muted = true;
      audioEl.classList.add('i-amphtml-pool-media');
      audioEl.classList.add('i-amphtml-pool-audio');
      return audioEl;
    }, _this$mediaFactory_[MediaType.VIDEO] = function () {
      var videoEl = _this.win_.document.createElement('video');

      videoEl.setAttribute('muted', '');
      videoEl.muted = true;
      videoEl.setAttribute('playsinline', '');
      videoEl.classList.add('i-amphtml-pool-media');
      videoEl.classList.add('i-amphtml-pool-video');
      return videoEl;
    }, _this$mediaFactory_);
    this.initializeMediaPool_(maxCounts);
  }

  /**
   * Fills the media pool by creating the maximum number of media elements for
   * each of the types of media elements.  We need to create these eagerly so
   * that all media elements exist by the time that blessAll() is invoked,
   * thereby "blessing" all media elements for playback without user gesture.
   * @param {!Object<!MediaType, number>} maxCounts The maximum amount of each
   *     media element that can be allocated by the pool.
   * @private
   */
  _createClass(MediaPool, [{
    key: "initializeMediaPool_",
    value: function initializeMediaPool_(maxCounts) {
      var _this2 = this;

      var poolIdCounter = 0;
      this.forEachMediaType_(function (key) {
        var type = MediaType[key];
        var count = maxCounts[type] || 0;

        if (count <= 0) {
          return;
        }

        var ctor = (0, _log.devAssert)(_this2.mediaFactory_[type], "Factory for media type `" + type + "` unset.");
        // Cloning nodes is faster than building them.
        // Construct a seed media element as a small optimization.
        var mediaElSeed = ctor.call(_this2);
        _this2.allocated[type] = [];
        _this2.unallocated[type] = [];

        // Reverse-looping is generally faster and Closure would usually make
        // this optimization automatically. However, it skips it due to a
        // comparison with the itervar below, so we have to roll it by hand.
        for (var i = count; i > 0; i--) {
          // Use seed element at end of set to prevent wasting it.
          var mediaEl =
          /** @type {!PoolBoundElementDef} */
          i == 1 ? mediaElSeed : mediaElSeed.cloneNode(
          /* deep */
          true);
          mediaEl.addEventListener('error', _this2.onMediaError_, {
            capture: true
          });

          var sources = _this2.getDefaultSource_(type);

          mediaEl.id = POOL_ELEMENT_ID_PREFIX + poolIdCounter++;
          // In Firefox, cloneNode() does not properly copy the muted property
          // that was set in the seed. We need to set it again here.
          mediaEl.muted = true;
          mediaEl[MEDIA_ELEMENT_ORIGIN_PROPERTY_NAME] = MediaElementOrigin.POOL;

          _this2.enqueueMediaElementTask_(mediaEl, new _mediaTasks.UpdateSourcesTask(_this2.win_, sources));

          // TODO(newmuis): Check the 'error' field to see if MEDIA_ERR_DECODE
          // is returned.  If so, we should adjust the pool size/distribution
          // between media types.
          _this2.unallocated[type].push(mediaEl);
        }
      });
    }
    /**
     * Handles HTMLMediaElement and children HTMLSourceElement error events. Marks
     * the media as errored, as there is no other way to check if the load failed
     * when the media is using HTMLSourceElements.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onMediaError_",
    value: function onMediaError_(event) {
      var target = (0, _log.dev)().assertElement(event.target);

      if (!(0, _dom.matches)(target, 'source:last-of-type, video[src]')) {
        return;
      }

      var media = target.tagName === 'SOURCE' ? target.parentElement : target;
      media[_eventHelper.MEDIA_LOAD_FAILURE_SRC_PROPERTY] = media.currentSrc || true;
    }
    /**
     * @param {!MediaType} mediaType The media type whose source should be
     *     retrieved.
     * @return {!Sources} The default source for the specified type of media.
     */

  }, {
    key: "getDefaultSource_",
    value: function getDefaultSource_(mediaType) {
      var sourceStr = this.defaultSources_[mediaType];

      if (sourceStr === undefined) {
        (0, _log.dev)().error('AMP-STORY', "No default media for type " + mediaType + ".");
        return new _sources.Sources();
      }

      return new _sources.Sources(sourceStr);
    }
    /**
     * Comparison function that compares the distance of each element from the
     * current position in the document.
     * @param {!PoolBoundElementDef} mediaA The first element to compare.
     * @param {!PoolBoundElementDef} mediaB The second element to compare.
     * @return {number}
     * @private
     */

  }, {
    key: "compareMediaDistances_",
    value: function compareMediaDistances_(mediaA, mediaB) {
      var distanceA = this.distanceFn_(mediaA);
      var distanceB = this.distanceFn_(mediaB);
      return distanceA < distanceB ? -1 : 1;
    }
    /**
     * @return {string} A unique ID.
     * @private
     */

  }, {
    key: "createPlaceholderElementId_",
    value: function createPlaceholderElementId_() {
      return PLACEHOLDER_ELEMENT_ID_PREFIX + this.placeholderIdCounter_++;
    }
    /**
     * @param {!DomElementDef} mediaElement
     * @return {boolean}
     * @private
     */

  }, {
    key: "isPoolMediaElement_",
    value: function isPoolMediaElement_(mediaElement) {
      return mediaElement[MEDIA_ELEMENT_ORIGIN_PROPERTY_NAME] === MediaElementOrigin.POOL;
    }
    /**
     * Gets the media type from a given element.
     * @param {!PoolBoundElementDef|!PlaceholderElementDef} mediaElement The
     *     element whose media type should be retrieved.
     * @return {!MediaType}
     * @private
     */

  }, {
    key: "getMediaType_",
    value: function getMediaType_(mediaElement) {
      var tagName = mediaElement.tagName.toLowerCase();

      switch (tagName) {
        case 'audio':
          return MediaType.AUDIO;

        case 'video':
          return MediaType.VIDEO;

        default:
          return MediaType.UNSUPPORTED;
      }
    }
    /**
     * Reserves an element of the specified type by removing it from the set of
     * unallocated elements and returning it.
     * @param {!MediaType} mediaType The type of media element to reserve.
     * @return {?PoolBoundElementDef} The reserved element, if one exists.
     * @private
     */

  }, {
    key: "reserveUnallocatedMediaElement_",
    value: function reserveUnallocatedMediaElement_(mediaType) {
      return this.unallocated[mediaType].pop();
    }
    /**
     * Retrieves the media element from the pool that matches the specified
     * element, if one exists.
     * @param {!MediaType} mediaType The type of media element to get.
     * @param {!DomElementDef} domMediaEl The element whose matching media
     *     element should be retrieved.
     * @return {?PoolBoundElementDef} The media element in the pool that
     *     represents the specified media element
     */

  }, {
    key: "getMatchingMediaElementFromPool_",
    value: function getMatchingMediaElementFromPool_(mediaType, domMediaEl) {
      if (this.isAllocatedMediaElement_(mediaType, domMediaEl)) {
        // The media element in the DOM was already from the pool.
        return (
          /** @type {!PoolBoundElementDef} */
          domMediaEl
        );
      }

      var allocatedEls = this.allocated[mediaType];
      var index = (0, _array.findIndex)(allocatedEls, function (poolMediaEl) {
        return poolMediaEl[REPLACED_MEDIA_PROPERTY_NAME] === domMediaEl.id;
      });
      return allocatedEls[index];
    }
    /**
     * Allocates the specified media element of the specified type.
     * @param {!MediaType} mediaType The type of media element to allocate.
     * @param {!PoolBoundElementDef} poolMediaEl The element to be allocated.
     * @private
     */

  }, {
    key: "allocateMediaElement_",
    value: function allocateMediaElement_(mediaType, poolMediaEl) {
      this.allocated[mediaType].push(poolMediaEl);
      var unallocatedEls = this.unallocated[mediaType];
      var indexToRemove = unallocatedEls.indexOf(poolMediaEl);

      if (indexToRemove >= 0) {
        unallocatedEls.splice(indexToRemove, 1);
      }
    }
    /**
     * Deallocates and returns the media element of the specified type furthest
     * from the current position in the document.
     * @param {!MediaType} mediaType The type of media element to deallocate.
     * @param {!PlaceholderElementDef=} opt_elToAllocate If specified, the element
     *     that is trying to be allocated, such that another element must be
     *     evicted.
     * @return {?PoolBoundElementDef} The deallocated element, if one exists.
     * @private
     */

  }, {
    key: "deallocateMediaElement_",
    value: function deallocateMediaElement_(mediaType, opt_elToAllocate) {
      var _this3 = this;

      var allocatedEls = this.allocated[mediaType];
      // Sort the allocated media elements by distance to ensure that we are
      // evicting the media element that is furthest from the current place in the
      // document.
      allocatedEls.sort(function (a, b) {
        return _this3.compareMediaDistances_(a, b);
      });

      // Do not deallocate any media elements if the element being loaded or
      // played is further than the farthest allocated element.
      if (opt_elToAllocate) {
        var furthestEl = allocatedEls[allocatedEls.length - 1];

        if (!furthestEl || this.distanceFn_(furthestEl) < this.distanceFn_(opt_elToAllocate)) {
          return null;
        }
      }

      // De-allocate a media element.
      var poolMediaEl = allocatedEls.pop();
      this.unallocated[mediaType].push(poolMediaEl);
      return poolMediaEl;
    }
    /**
     * Forcibly deallocates a specific media element, regardless of its distance
     * from the current position in the document.
     * @param {!PoolBoundElementDef} poolMediaEl The element to be deallocated.
     * @return {!Promise} A promise that is resolved when the specified media
     *     element has been successfully deallocated.
     */

  }, {
    key: "forceDeallocateMediaElement_",
    value: function forceDeallocateMediaElement_(poolMediaEl) {
      var _this4 = this;

      var mediaType = this.getMediaType_(poolMediaEl);
      var allocatedEls = this.allocated[mediaType];
      var removeFromDom = (0, _dom.isConnectedNode)(poolMediaEl) ? this.swapPoolMediaElementOutOfDom_(poolMediaEl) : (0, _resolvedPromise14.resolvedPromise)();
      return removeFromDom.then(function () {
        var index = allocatedEls.indexOf(poolMediaEl);
        (0, _log.devAssert)(index >= 0, 'Cannot deallocate unallocated media element.');
        allocatedEls.splice(index, 1);

        _this4.unallocated[mediaType].push(poolMediaEl);
      });
    }
    /**
     * Evicts an element of the specified type, replaces it in the DOM with the
     * original media element, and returns it.
     * @param {!MediaType} mediaType The type of media element to evict.
     * @param {!PlaceholderElementDef=} opt_elToAllocate If specified, the element
     *     that is trying to be allocated, such that another element must be
     *     evicted.
     * @return {?PoolBoundElementDef} A media element of the specified type.
     * @private
     */

  }, {
    key: "evictMediaElement_",
    value: function evictMediaElement_(mediaType, opt_elToAllocate) {
      var poolMediaEl = this.deallocateMediaElement_(mediaType, opt_elToAllocate);

      if (!poolMediaEl) {
        return null;
      }

      this.swapPoolMediaElementOutOfDom_(poolMediaEl);
      return poolMediaEl;
    }
    /**
     * @param {!MediaType} mediaType The media type to check.
     * @param {!DomElementDef} domMediaEl The element to check.
     * @return {boolean} true, if the specified element has already been allocated
     *     as the specified type of media element.
     * @private
     */

  }, {
    key: "isAllocatedMediaElement_",
    value: function isAllocatedMediaElement_(mediaType, domMediaEl) {
      // Since we don't know whether or not the specified domMediaEl is a
      // placeholder or originated from the pool, we coerce it to a pool-bound
      // element, to check against the allocated list of pool-bound elements.
      var poolMediaEl =
      /** @type {!PoolBoundElementDef} */
      domMediaEl;
      return this.allocated[mediaType].indexOf(poolMediaEl) >= 0;
    }
    /**
     * Replaces a media element that was originally in the DOM with a media
     * element from the pool.
     * @param {!PlaceholderElementDef} placeholderEl The placeholder element
     *     originating from the DOM.
     * @param {!PoolBoundElementDef} poolMediaEl The media element originating
     *     from the pool.
     * @param {!Sources} sources The sources for the media element.
     * @return {!Promise} A promise that is resolved when the media element has
     *     been successfully swapped into the DOM.
     * @private
     */

  }, {
    key: "swapPoolMediaElementIntoDom_",
    value: function swapPoolMediaElementIntoDom_(placeholderEl, poolMediaEl, sources) {
      var _this5 = this;

      var ampMediaForPoolEl = (0, _utils.ampMediaElementFor)(poolMediaEl);
      var ampMediaForDomEl = (0, _utils.ampMediaElementFor)(placeholderEl);
      poolMediaEl[REPLACED_MEDIA_PROPERTY_NAME] = placeholderEl.id;
      return this.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.SwapIntoDomTask(placeholderEl)).then(function () {
        _this5.maybeResetAmpMedia_(ampMediaForPoolEl);

        _this5.maybeResetAmpMedia_(ampMediaForDomEl);

        _this5.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.UpdateSourcesTask(_this5.win_, sources));

        _this5.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.LoadTask());
      }, function () {
        _this5.forceDeallocateMediaElement_(poolMediaEl);
      });
    }
    /**
     * @param {?Element} componentEl
     * @private
     */

  }, {
    key: "maybeResetAmpMedia_",
    value: function maybeResetAmpMedia_(componentEl) {
      if (!componentEl) {
        return;
      }

      if (componentEl.tagName.toLowerCase() == 'amp-audio') {
        // TODO(alanorozco): Implement reset for amp-audio
        return;
      }

      componentEl.getImpl().then(function (impl) {
        if (impl.resetOnDomChange) {
          impl.resetOnDomChange();
        }
      });
    }
    /**
     * @param {!PoolBoundElementDef} poolMediaEl The element whose source should
     *     be reset.
     * @return {!Promise} A promise that is resolved when the pool media element
     *     has been reset.
     */

  }, {
    key: "resetPoolMediaElementSource_",
    value: function resetPoolMediaElementSource_(poolMediaEl) {
      var mediaType = this.getMediaType_(poolMediaEl);
      var defaultSources = this.getDefaultSource_(mediaType);
      return this.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.UpdateSourcesTask(this.win_, defaultSources));
    }
    /**
     * Removes a pool media element from the DOM and replaces it with the video
     * that it originally replaced.
     * @param {!PoolBoundElementDef} poolMediaEl The pool media element to remove
     *     from the DOM.
     * @return {!Promise} A promise that is resolved when the media element has
     *     been successfully swapped out of the DOM.
     * @private
     */

  }, {
    key: "swapPoolMediaElementOutOfDom_",
    value: function swapPoolMediaElementOutOfDom_(poolMediaEl) {
      var placeholderElId = poolMediaEl[REPLACED_MEDIA_PROPERTY_NAME];
      var placeholderEl =
      /** @type {!PlaceholderElementDef} */
      (0, _log.dev)().assertElement(this.placeholderEls_[placeholderElId], "No media element " + placeholderElId + " to put back into DOM after" + 'eviction.');
      poolMediaEl[REPLACED_MEDIA_PROPERTY_NAME] = null;
      var swapOutOfDom = this.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.SwapOutOfDomTask(placeholderEl));
      this.resetPoolMediaElementSource_(poolMediaEl);
      return swapOutOfDom;
    }
    /**
     * @param {function(string)} callbackFn
     * @private
     */

  }, {
    key: "forEachMediaType_",
    value: function forEachMediaType_(callbackFn) {
      Object.keys(MediaType).forEach(callbackFn.bind(this));
    }
    /**
     * Invokes a function for all media managed by the media pool.
     * @param {function(!PoolBoundElementDef)} callbackFn The function to be
     *     invoked.
     * @private
     */

  }, {
    key: "forEachMediaElement_",
    value: function forEachMediaElement_(callbackFn) {
      var _this6 = this;

      [this.allocated, this.unallocated].forEach(function (mediaSet) {
        _this6.forEachMediaType_(function (key) {
          var type = MediaType[key];
          var els =
          /** @type {!Array} */
          mediaSet[type];

          if (!els) {
            return;
          }

          els.forEach(callbackFn.bind(_this6));
        });
      });
    }
    /**
     * Preloads the content of the specified media element in the DOM and returns
     * a media element that can be used in its stead for playback.
     * @param {!DomElementDef} domMediaEl The media element, found in the
     *     DOM, whose content should be loaded.
     * @return {Promise<!PoolBoundElementDef|undefined>} A media element from the pool that
     *     can be used to replace the specified element.
     */

  }, {
    key: "loadInternal_",
    value: function loadInternal_(domMediaEl) {
      if (!(0, _dom.isConnectedNode)(domMediaEl)) {
        // Don't handle nodes that aren't even in the document.
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      var mediaType = this.getMediaType_(domMediaEl);
      var existingPoolMediaEl = this.getMatchingMediaElementFromPool_(mediaType, domMediaEl);

      if (existingPoolMediaEl) {
        // The element being loaded already has an allocated media element.
        return Promise.resolve(
        /** @type {!PoolBoundElementDef} */
        existingPoolMediaEl);
      }

      // Since this is not an existing pool media element, we can be certain that
      // it is a placeholder element.
      var placeholderEl =
      /** @type {!PlaceholderElementDef} */
      domMediaEl;
      var sources = this.sources_[placeholderEl.id];
      (0, _log.devAssert)(sources instanceof _sources.Sources, 'Cannot play unregistered element.');
      var poolMediaEl = this.reserveUnallocatedMediaElement_(mediaType) || this.evictMediaElement_(mediaType, placeholderEl);

      if (!poolMediaEl) {
        // If there is no space in the pool to allocate a new element, and no
        // element can be evicted, do not return any element.
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      this.allocateMediaElement_(mediaType, poolMediaEl);
      return this.swapPoolMediaElementIntoDom_(placeholderEl, poolMediaEl, sources).then(function () {
        return poolMediaEl;
      });
    }
    /**
     * "Blesses" the specified media element for future playback without a user
     * gesture.  In order for this to bless the media element, this function must
     * be invoked in response to a user gesture.
     * @param {!PoolBoundElementDef} poolMediaEl The media element to bless.
     * @return {!Promise} A promise that is resolved when blessing the media
     *     element is complete.
     */

  }, {
    key: "bless_",
    value: function bless_(poolMediaEl) {
      if (poolMediaEl[_mediaTasks.ELEMENT_BLESSED_PROPERTY_NAME]) {
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      return this.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.BlessTask());
    }
    /**
     * Registers the specified element to be usable by the media pool.  Elements
     * should be registered as early as possible, in order to prevent them from
     * being played while not managed by the media pool.  If the media element is
     * already registered, this is a no-op.  Registering elements from within the
     * pool is not allowed, and will also be a no-op.
     * @param {!DomElementDef} domMediaEl The media element to be
     *     registered.
     * @return {!Promise} A promise that is resolved when the element has been
     *     successfully registered, or rejected otherwise.
     */

  }, {
    key: "register",
    value: function register(domMediaEl) {
      var parent = domMediaEl.parentNode;

      if (parent && parent.signals) {
        this.trackAmpElementToBless_(
        /** @type {!AmpElement} */
        parent);
      }

      if (this.isPoolMediaElement_(domMediaEl)) {
        // This media element originated from the media pool.
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      // Since this is not an existing pool media element, we can be certain that
      // it is a placeholder element.
      var placeholderEl =
      /** @type {!PlaceholderElementDef} */
      domMediaEl;
      placeholderEl[MEDIA_ELEMENT_ORIGIN_PROPERTY_NAME] = MediaElementOrigin.PLACEHOLDER;
      var id = placeholderEl.id || this.createPlaceholderElementId_();

      if (this.sources_[id] && this.placeholderEls_[id]) {
        // This media element is already registered.
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      // This media element has not yet been registered.
      placeholderEl.id = id;

      var sources = _sources.Sources.removeFrom(this.win_, placeholderEl);

      this.sources_[id] = sources;
      this.placeholderEls_[id] = placeholderEl;

      if (placeholderEl instanceof HTMLMediaElement) {
        placeholderEl.muted = true;
        placeholderEl.setAttribute('muted', '');
        placeholderEl.pause();
      }

      return (0, _resolvedPromise14.resolvedPromise)();
    }
    /**
     * @param {!AmpElement} element
     * @private
     */

  }, {
    key: "trackAmpElementToBless_",
    value: function trackAmpElementToBless_(element) {
      this.ampElementsToBless_ = this.ampElementsToBless_ || [];
      this.ampElementsToBless_.push(element);
    }
    /**
     * Preloads the content of the specified media element in the DOM.
     * @param {!DomElementDef} domMediaEl The media element, found in the
     *     DOM, whose content should be loaded.
     * @return {!Promise} A promise that is resolved when the specified media
     *     element has successfully started preloading.
     */

  }, {
    key: "preload",
    value: function preload(domMediaEl) {
      // Empty then() invocation hides the value yielded by the loadInternal_
      // promise, so that we do not leak the pool media element outside of the
      // scope of the media pool.
      return this.loadInternal_(domMediaEl).then();
    }
    /**
     * Plays the specified media element in the DOM by replacing it with a media
     * element from the pool and playing that.
     * @param {!DomElementDef} domMediaEl The media element to be played.
     * @return {!Promise} A promise that is resolved when the specified media
     *     element has been successfully played.
     */

  }, {
    key: "play",
    value: function play(domMediaEl) {
      var _this7 = this;

      return this.loadInternal_(domMediaEl).then(function (poolMediaEl) {
        if (!poolMediaEl) {
          return (0, _resolvedPromise14.resolvedPromise)();
        }

        return _this7.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.PlayTask());
      });
    }
    /**
     * Pauses the specified media element in the DOM.
     * @param {!DomElementDef} domMediaEl The media element to be paused.
     * @param {boolean=} rewindToBeginning Whether to rewind the currentTime
     *     of media items to the beginning.
     * @return {!Promise} A promise that is resolved when the specified media
     *     element has been successfully paused.
     */

  }, {
    key: "pause",
    value: function pause(domMediaEl, rewindToBeginning) {
      var _this8 = this;

      if (rewindToBeginning === void 0) {
        rewindToBeginning = false;
      }

      var mediaType = this.getMediaType_(domMediaEl);
      var poolMediaEl = this.getMatchingMediaElementFromPool_(mediaType, domMediaEl);

      if (!poolMediaEl) {
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      return this.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.PauseTask()).then(function () {
        if (rewindToBeginning) {
          _this8.enqueueMediaElementTask_(
          /** @type {!PoolBoundElementDef} */
          poolMediaEl, new _mediaTasks.SetCurrentTimeTask({
            currentTime: 0
          }));
        }
      });
    }
    /**
     * Rewinds a specified media element in the DOM to 0.
     * @param {!DomElementDef} domMediaEl The media element to be rewound.
     * @return {!Promise} A promise that is resolved when the
     *     specified media element has been successfully rewound.
     */

  }, {
    key: "rewindToBeginning",
    value: function rewindToBeginning(domMediaEl) {
      return this.setCurrentTime(domMediaEl, 0
      /** currentTime */
      );
    }
    /**
     * Sets currentTime for a specified media element in the DOM.
     * @param {!DomElementDef} domMediaEl The media element.
     * @param {number} currentTime The time to seek to, in seconds.
     * @return {!Promise} A promise that is resolved when the
     *     specified media element has been successfully set to the given time.
     */

  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(domMediaEl, currentTime) {
      var mediaType = this.getMediaType_(domMediaEl);
      var poolMediaEl = this.getMatchingMediaElementFromPool_(mediaType, domMediaEl);

      if (!poolMediaEl) {
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      return this.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.SetCurrentTimeTask({
        currentTime: currentTime
      }));
    }
    /**
     * Mutes the specified media element in the DOM.
     * @param {!DomElementDef} domMediaEl The media element to be muted.
     * @return {!Promise} A promise that is resolved when the specified media
     *     element has been successfully muted.
     */

  }, {
    key: "mute",
    value: function mute(domMediaEl) {
      var mediaType = this.getMediaType_(domMediaEl);
      var poolMediaEl = this.getMatchingMediaElementFromPool_(mediaType, domMediaEl);

      if (!poolMediaEl) {
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      return this.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.MuteTask());
    }
    /**
     * Unmutes the specified media element in the DOM.
     * @param {!DomElementDef} domMediaEl The media element to be unmuted.
     * @return {!Promise} A promise that is resolved when the specified media
     *     element has been successfully paused.
     */

  }, {
    key: "unmute",
    value: function unmute(domMediaEl) {
      var mediaType = this.getMediaType_(domMediaEl);
      var poolMediaEl = this.getMatchingMediaElementFromPool_(mediaType, domMediaEl);

      if (!poolMediaEl) {
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      return this.enqueueMediaElementTask_(poolMediaEl, new _mediaTasks.UnmuteTask());
    }
    /**
     * "Blesses" all media elements in the media pool for future playback without
     * a user gesture.  In order for this to bless the media elements, this
     * function must be invoked in response to a user gesture.
     * @return {!Promise} A promise that is resolved when all media elements in
     *     the pool are blessed.
     */

  }, {
    key: "blessAll",
    value: function blessAll() {
      var _this9 = this;

      if (this.blessed_) {
        return (0, _resolvedPromise14.resolvedPromise)();
      }

      var blessPromises = [];
      (this.ampElementsToBless_ || []).forEach(_videoInterface.userInteractedWith);
      this.ampElementsToBless_ = null;
      // GC
      this.forEachMediaElement_(function (mediaEl) {
        blessPromises.push(_this9.bless_(mediaEl));
      });
      return Promise.all(blessPromises).then(function () {
        _this9.blessed_ = true;
      }, function (reason) {
        (0, _log.dev)().expectedError('AMP-STORY', 'Blessing all media failed: ', reason);
      });
    }
    /**
     * @param {!PoolBoundElementDef} mediaEl The element whose task queue should
     *     be executed.
     * @private
     */

  }, {
    key: "executeNextMediaElementTask_",
    value: function executeNextMediaElementTask_(mediaEl) {
      var _this10 = this;

      var queue = mediaEl[ELEMENT_TASK_QUEUE_PROPERTY_NAME];

      if (queue.length === 0) {
        return;
      }

      var task = queue[0];

      var executionFn = function executionFn() {
        task.execute(mediaEl).catch(function (reason) {
          return (0, _log.dev)().error('AMP-STORY', reason);
        }).then(function () {
          // Run regardless of success or failure of task execution.
          queue.shift();

          _this10.executeNextMediaElementTask_(mediaEl);
        });
      };

      if (task.requiresSynchronousExecution()) {
        executionFn.call(this);
      } else {
        this.timer_.delay(executionFn.bind(this), 0);
      }
    }
    /**
     * @param {!PoolBoundElementDef} mediaEl The element for which the specified
     *     task should be executed.
     * @param {!./media-tasks.MediaTask} task The task to be executed.
     * @return {!Promise} A promise that is resolved when the specified task is
     *     completed.
     * @private
     */

  }, {
    key: "enqueueMediaElementTask_",
    value: function enqueueMediaElementTask_(mediaEl, task) {
      if (!mediaEl[ELEMENT_TASK_QUEUE_PROPERTY_NAME]) {
        mediaEl[ELEMENT_TASK_QUEUE_PROPERTY_NAME] = [];
      }

      var queue = mediaEl[ELEMENT_TASK_QUEUE_PROPERTY_NAME];
      var isQueueRunning = queue.length !== 0;
      queue.push(task);

      if (!isQueueRunning) {
        this.executeNextMediaElementTask_(mediaEl);
      }

      return task.whenComplete();
    }
    /**
     * @param {!MediaPoolRoot} root
     * @return {!MediaPool}
     */

  }], [{
    key: "for",
    value: function _for(root) {
      var element = root.getElement();
      var existingId = element[POOL_MEDIA_ELEMENT_PROPERTY_NAME];
      var hasInstanceAllocated = existingId && instances[existingId];

      if (hasInstanceAllocated) {
        return instances[existingId];
      }

      var newId = String(nextInstanceId++);
      element[POOL_MEDIA_ELEMENT_PROPERTY_NAME] = newId;
      instances[newId] = new MediaPool((0, _types.toWin)(root.getElement().ownerDocument.defaultView), root.getMaxMediaElementCounts(), function (element) {
        return root.getElementDistance(element);
      });
      return instances[newId];
    }
  }]);

  return MediaPool;
}();

exports.MediaPool = MediaPool;

/**
 * Defines a common interface for elements that contain a MediaPool.
 *
 * @interface
 */
var MediaPoolRoot = /*#__PURE__*/function () {
  function MediaPoolRoot() {
    _classCallCheck(this, MediaPoolRoot);
  }

  _createClass(MediaPoolRoot, [{
    key: "getElement",

    /**
     * @return {!Element} The root element of this media pool.
     */
    value: function getElement() {}
    /**
     * @param {!Element} unusedElement The element whose distance should be
     *    retrieved.
     * @return {number} A numerical distance representing how far the specified
     *     element is from the user's current position in the document.  The
     *     absolute magnitude of this number is irrelevant; the relative magnitude
     *     is used to determine which media elements should be evicted (elements
     *     furthest from the user's current position in the document are evicted
     *     from the MediaPool first).
     */

  }, {
    key: "getElementDistance",
    value: function getElementDistance(unusedElement) {}
    /**
     * @return {!Object<!MediaType, number>} The maximum amount of each media
     *     type to allow within this element.
     */

  }, {
    key: "getMaxMediaElementCounts",
    value: function getMaxMediaElementCounts() {}
  }]);

  return MediaPoolRoot;
}();

exports.MediaPoolRoot = MediaPoolRoot;

},{"../../../src/dom":106,"../../../src/event-helper":111,"../../../src/experiments":112,"../../../src/log":123,"../../../src/services":133,"../../../src/types":139,"../../../src/utils/array":143,"../../../src/video-interface":153,"./../../../src/resolved-promise":129,"./default-media":73,"./media-tasks":84,"./sources":90,"./utils":93}],84:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.SwapOutOfDomTask = exports.SwapIntoDomTask = exports.UpdateSourcesTask = exports.BlessTask = exports.LoadTask = exports.SetCurrentTimeTask = exports.MuteTask = exports.UnmuteTask = exports.PauseTask = exports.PlayTask = exports.MediaTask = exports.ELEMENT_BLESSED_PROPERTY_NAME = void 0;

var _resolvedPromise13 = require("./../../../src/resolved-promise");

var _promise = require("../../../src/utils/promise");

var _sources = require("./sources");

var _dom = require("../../../src/dom");

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The name for a boolean property on an element indicating whether that element
 * has already been "blessed".
 * @const {string}
 */
var ELEMENT_BLESSED_PROPERTY_NAME = '__AMP_MEDIA_IS_BLESSED__';
exports.ELEMENT_BLESSED_PROPERTY_NAME = ELEMENT_BLESSED_PROPERTY_NAME;

/**
 * CSS class names that should not be removed from an element when swapping it
 * into/out of the DOM.
 * @const {!Array<string>}
 */
var PROTECTED_CSS_CLASS_NAMES = ['i-amphtml-pool-media', 'i-amphtml-pool-audio', 'i-amphtml-pool-video'];

/**
 * Attribute names that should not be removed from an element when swapping it
 * into/out of the DOM.
 * @const {!Array<string>}
 */
var PROTECTED_ATTRIBUTES = ['id', 'src', 'class', 'autoplay'];

/**
 * Determines whether a CSS class name is allowed to be removed or copied from
 * media elements.
 * @param {string} cssClassName The CSS class name name to check.
 * @return {boolean} true, if the specified CSS class name is allowed to be
 *     removed or copied from media elements; false otherwise.
 * @private
 */
function isProtectedCssClassName(cssClassName) {
  return PROTECTED_CSS_CLASS_NAMES.indexOf(cssClassName) >= 0;
}

/**
 * Determines whether an attribute is allowed to be removed or copied from
 * media elements.
 * @param {string} attributeName The attribute name to check.
 * @return {boolean} true, if the specified attribute is allowed to be removed
 *     or copied from media elements; false otherwise.
 * @private
 */
function isProtectedAttributeName(attributeName) {
  return PROTECTED_ATTRIBUTES.indexOf(attributeName) >= 0;
}

/**
 * Copies all unprotected CSS classes from fromEl to toEl.
 * @param {!Element} fromEl The element from which CSS classes should
 *     be copied.
 * @param {!Element} toEl The element to which CSS classes should be
 *     copied.
 * @private
 */
function copyCssClasses(fromEl, toEl) {
  // Remove all of the unprotected CSS classes from the toEl.
  for (var i = toEl.classList.length - 1; i >= 0; i--) {
    var cssClass = toEl.classList.item(i);

    if (!isProtectedCssClassName(cssClass)) {
      toEl.classList.remove(cssClass);
    }
  }

  // Copy all of the unprotected CSS classes from the fromEl to the toEl.
  for (var _i = 0; _i < fromEl.classList.length; _i++) {
    var _cssClass = fromEl.classList.item(_i);

    if (!isProtectedCssClassName(_cssClass)) {
      toEl.classList.add(_cssClass);
    }
  }
}

/**
 * Copies all unprotected attributes from fromEl to toEl.
 * @param {!Element} fromEl The element from which attributes should
 *     be copied.
 * @param {!Element} toEl The element to which attributes should be
 *     copied.
 * @private
 */
function copyAttributes(fromEl, toEl) {
  var fromAttributes = fromEl.attributes;
  var toAttributes = toEl.attributes;

  // Remove all of the unprotected attributes from the toEl.
  for (var i = toAttributes.length - 1; i >= 0; i--) {
    var attributeName = toAttributes[i].name;

    if (!isProtectedAttributeName(attributeName)) {
      toEl.removeAttribute(attributeName);
    }
  }

  // Copy all of the unprotected attributes from the fromEl to the toEl.
  for (var _i2 = 0; _i2 < fromAttributes.length; _i2++) {
    var _fromAttributes$_i = fromAttributes[_i2],
        _attributeName = _fromAttributes$_i.name,
        attributeValue = _fromAttributes$_i.value;

    if (!isProtectedAttributeName(_attributeName)) {
      toEl.setAttribute(_attributeName, attributeValue);
    }
  }
}

/**
 * Base class for tasks executed in order on HTMLMediaElements.
 */
var MediaTask = /*#__PURE__*/function () {
  /**
   * @param {string} name
   * @param {!Object=} options
   */
  function MediaTask(name, options) {
    if (options === void 0) {
      options = {};
    }

    _classCallCheck(this, MediaTask);

    /** @private @const {string} */
    this.name_ = name;
    var deferred = new _promise.Deferred();

    /** @private @const {!Promise} */
    this.completionPromise_ = deferred.promise;

    /** @protected @const {!Object} */
    this.options = options;

    /** @private {?function()} */
    this.resolve_ = deferred.resolve;

    /** @private {?function(*)} */
    this.reject_ = deferred.reject;
  }

  /**
   * @return {string} The name of this task.
   */
  _createClass(MediaTask, [{
    key: "getName",
    value: function getName() {
      return this.name_;
    }
    /**
     * @return {!Promise<*>} A promise that is resolved when the task has
     *     completed execution.
     */

  }, {
    key: "whenComplete",
    value: function whenComplete() {
      return this.completionPromise_;
    }
    /**
     * @param {!HTMLMediaElement} mediaEl The element on which this task should be
     *     executed.
     * @return {!Promise} A promise that is resolved when the task has completed
     *     execution.
     */

  }, {
    key: "execute",
    value: function execute(mediaEl) {
      return this.executeInternal(mediaEl).then(this.resolve_, this.reject_);
    }
    /**
     * @param {!HTMLMediaElement} unusedMediaEl The element on which this task
     *     should be executed.
     * @return {*} TODO(#23582): Specify return type
     * @protected
     */

  }, {
    key: "executeInternal",
    value: function executeInternal(unusedMediaEl) {
      return (0, _resolvedPromise13.resolvedPromise)();
    }
    /**
     * @return {boolean} true, if this task must be executed synchronously, e.g.
     *    if it requires a user gesture.
     */

  }, {
    key: "requiresSynchronousExecution",
    value: function requiresSynchronousExecution() {
      return false;
    }
    /**
     * @param {*} reason The reason for failing the task.
     * @protected
     */

  }, {
    key: "failTask",
    value: function failTask(reason) {
      this.reject_(reason);
    }
  }]);

  return MediaTask;
}();

exports.MediaTask = MediaTask;

/**
 * Plays the specified media element.
 */
var PlayTask = /*#__PURE__*/function (_MediaTask) {
  _inherits(PlayTask, _MediaTask);

  var _super = _createSuper(PlayTask);

  /**
   * @public
   */
  function PlayTask() {
    _classCallCheck(this, PlayTask);

    return _super.call(this, 'play');
  }

  /** @override */
  _createClass(PlayTask, [{
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      if (!mediaEl.paused) {
        // We do not want to invoke play() if the media element is already
        // playing, as this can interrupt playback in some browsers.
        return (0, _resolvedPromise13.resolvedPromise)();
      }

      // The play() invocation is wrapped in a Promise.resolve(...) due to the
      // fact that some browsers return a promise from media elements' play()
      // function, while others return a boolean.
      return (0, _promise.tryResolve)(function () {
        return mediaEl.play();
      });
    }
  }]);

  return PlayTask;
}(MediaTask);

exports.PlayTask = PlayTask;

/**
 * Pauses the specified media element.
 */
var PauseTask = /*#__PURE__*/function (_MediaTask2) {
  _inherits(PauseTask, _MediaTask2);

  var _super2 = _createSuper(PauseTask);

  /**
   * @public
   */
  function PauseTask() {
    _classCallCheck(this, PauseTask);

    return _super2.call(this, 'pause');
  }

  /** @override */
  _createClass(PauseTask, [{
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      mediaEl.pause();
      return (0, _resolvedPromise13.resolvedPromise)();
    }
  }]);

  return PauseTask;
}(MediaTask);

exports.PauseTask = PauseTask;

/**
 * Unmutes the specified media element.
 */
var UnmuteTask = /*#__PURE__*/function (_MediaTask3) {
  _inherits(UnmuteTask, _MediaTask3);

  var _super3 = _createSuper(UnmuteTask);

  /**
   * @public
   */
  function UnmuteTask() {
    _classCallCheck(this, UnmuteTask);

    return _super3.call(this, 'unmute');
  }

  /** @override */
  _createClass(UnmuteTask, [{
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      mediaEl.muted = false;
      mediaEl.removeAttribute('muted');
      return (0, _resolvedPromise13.resolvedPromise)();
    }
  }]);

  return UnmuteTask;
}(MediaTask);

exports.UnmuteTask = UnmuteTask;

/**
 * Mutes the specified media element.
 */
var MuteTask = /*#__PURE__*/function (_MediaTask4) {
  _inherits(MuteTask, _MediaTask4);

  var _super4 = _createSuper(MuteTask);

  /**
   * @public
   */
  function MuteTask() {
    _classCallCheck(this, MuteTask);

    return _super4.call(this, 'mute');
  }

  /** @override */
  _createClass(MuteTask, [{
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      mediaEl.muted = true;
      mediaEl.setAttribute('muted', '');
      return (0, _resolvedPromise13.resolvedPromise)();
    }
  }]);

  return MuteTask;
}(MediaTask);

exports.MuteTask = MuteTask;

/**
 * Seeks the specified media element to the provided time, in seconds.
 */
var SetCurrentTimeTask = /*#__PURE__*/function (_MediaTask5) {
  _inherits(SetCurrentTimeTask, _MediaTask5);

  var _super5 = _createSuper(SetCurrentTimeTask);

  /**
   * @param {!Object=} options
   */
  function SetCurrentTimeTask(options) {
    if (options === void 0) {
      options = {
        currentTime: 0
      };
    }

    _classCallCheck(this, SetCurrentTimeTask);

    return _super5.call(this, 'setCurrentTime', options);
  }

  /** @override */
  _createClass(SetCurrentTimeTask, [{
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      mediaEl.currentTime = this.options.currentTime;
      return (0, _resolvedPromise13.resolvedPromise)();
    }
  }]);

  return SetCurrentTimeTask;
}(MediaTask);

exports.SetCurrentTimeTask = SetCurrentTimeTask;

/**
 * Loads the specified media element.
 */
var LoadTask = /*#__PURE__*/function (_MediaTask6) {
  _inherits(LoadTask, _MediaTask6);

  var _super6 = _createSuper(LoadTask);

  /**
   * @public
   */
  function LoadTask() {
    _classCallCheck(this, LoadTask);

    return _super6.call(this, 'load');
  }

  /** @override */
  _createClass(LoadTask, [{
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      mediaEl.load();
      return (0, _resolvedPromise13.resolvedPromise)();
    }
  }]);

  return LoadTask;
}(MediaTask);

exports.LoadTask = LoadTask;

/**
 * "Blesses" the specified media element for future playback without a user
 * gesture.  In order for this to bless the media element, this function must
 * be invoked in response to a user gesture.
 */
var BlessTask = /*#__PURE__*/function (_MediaTask7) {
  _inherits(BlessTask, _MediaTask7);

  var _super7 = _createSuper(BlessTask);

  /**
   * @public
   */
  function BlessTask() {
    _classCallCheck(this, BlessTask);

    return _super7.call(this, 'bless');
  }

  /** @override */
  _createClass(BlessTask, [{
    key: "requiresSynchronousExecution",
    value: function requiresSynchronousExecution() {
      return true;
    }
    /** @override */

  }, {
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      var isMuted = mediaEl.muted;
      mediaEl.muted = false;

      if (isMuted) {
        mediaEl.muted = true;
      }

      return (0, _resolvedPromise13.resolvedPromise)();
    }
  }]);

  return BlessTask;
}(MediaTask);

exports.BlessTask = BlessTask;

/**
 * Updates the sources of the specified media element.
 */
var UpdateSourcesTask = /*#__PURE__*/function (_MediaTask8) {
  _inherits(UpdateSourcesTask, _MediaTask8);

  var _super8 = _createSuper(UpdateSourcesTask);

  /**
   * @param {!Window} win
   * @param {!Sources} newSources The sources to which the media element should
   *     be updated.
   */
  function UpdateSourcesTask(win, newSources) {
    var _this;

    _classCallCheck(this, UpdateSourcesTask);

    _this = _super8.call(this, 'update-src');

    /** @private {!Window} */
    _this.win_ = win;

    /** @private @const {!Sources} */
    _this.newSources_ = newSources;
    return _this;
  }

  /** @override */
  _createClass(UpdateSourcesTask, [{
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      _sources.Sources.removeFrom(this.win_, mediaEl);

      this.newSources_.applyToElement(this.win_, mediaEl);
      return (0, _resolvedPromise13.resolvedPromise)();
    }
  }]);

  return UpdateSourcesTask;
}(MediaTask);

exports.UpdateSourcesTask = UpdateSourcesTask;

/**
 * Swaps a media element into the DOM, in the place of a placeholder element.
 */
var SwapIntoDomTask = /*#__PURE__*/function (_MediaTask9) {
  _inherits(SwapIntoDomTask, _MediaTask9);

  var _super9 = _createSuper(SwapIntoDomTask);

  /**
   * @param {!Element} placeholderEl The element to be replaced by the media
   *     element on which this task is executed.
   */
  function SwapIntoDomTask(placeholderEl) {
    var _this2;

    _classCallCheck(this, SwapIntoDomTask);

    _this2 = _super9.call(this, 'swap-into-dom');

    /** @private @const {!Element} */
    _this2.placeholderEl_ = placeholderEl;
    return _this2;
  }

  /** @override */
  _createClass(SwapIntoDomTask, [{
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      if (!(0, _dom.isConnectedNode)(this.placeholderEl_)) {
        this.failTask('Cannot swap media for element that is not in DOM.');
        return (0, _resolvedPromise13.resolvedPromise)();
      }

      copyCssClasses(this.placeholderEl_, mediaEl);
      copyAttributes(this.placeholderEl_, mediaEl);
      this.placeholderEl_.parentElement.replaceChild(mediaEl, this.placeholderEl_);
      return (0, _resolvedPromise13.resolvedPromise)();
    }
    /** @override */

  }, {
    key: "requiresSynchronousExecution",
    value: function requiresSynchronousExecution() {
      return true;
    }
  }]);

  return SwapIntoDomTask;
}(MediaTask);

exports.SwapIntoDomTask = SwapIntoDomTask;

/**
 * Swaps a media element out the DOM, replacing it with a placeholder element.
 */
var SwapOutOfDomTask = /*#__PURE__*/function (_MediaTask10) {
  _inherits(SwapOutOfDomTask, _MediaTask10);

  var _super10 = _createSuper(SwapOutOfDomTask);

  /**
   * @param {!Element} placeholderEl The element to replace the media element on
   *     which this task is executed.
   */
  function SwapOutOfDomTask(placeholderEl) {
    var _this3;

    _classCallCheck(this, SwapOutOfDomTask);

    _this3 = _super10.call(this, 'swap-out-of-dom');

    /** @private @const {!Element} */
    _this3.placeholderEl_ = placeholderEl;
    return _this3;
  }

  /** @override */
  _createClass(SwapOutOfDomTask, [{
    key: "executeInternal",
    value: function executeInternal(mediaEl) {
      copyCssClasses(mediaEl, this.placeholderEl_);
      copyAttributes(mediaEl, this.placeholderEl_);
      mediaEl.parentElement.replaceChild(this.placeholderEl_, mediaEl);
      return (0, _resolvedPromise13.resolvedPromise)();
    }
    /** @override */

  }, {
    key: "requiresSynchronousExecution",
    value: function requiresSynchronousExecution() {
      return true;
    }
  }]);

  return SwapOutOfDomTask;
}(MediaTask);

exports.SwapOutOfDomTask = SwapOutOfDomTask;

},{"../../../src/dom":106,"../../../src/utils/promise":150,"./../../../src/resolved-promise":129,"./sources":90}],85:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.MediaBasedAdvancement = exports.TimeBasedAdvancement = exports.ManualAdvancement = exports.AdvancementConfig = exports.TapNavigationDirection = exports.POLL_INTERVAL_MS = void 0;

var _resolvedPromise2 = require("./../../../src/resolved-promise");

var _ampStoryAffiliateLink = require("./amp-story-affiliate-link");

var _ampStoryStoreService = require("./amp-story-store-service");

var _storyAnalytics = require("./story-analytics");

var _services = require("../../../src/services");

var _actionImpl = require("../../../src/service/action-impl");

var _videoInterface = require("../../../src/video-interface");

var _dom = require("../../../src/dom");

var _log = require("../../../src/log");

var _css = require("../../../src/css");

var _service = require("../../../src/service");

var _utils = require("./utils");

var _ampStoryEmbeddedComponent = require("./amp-story-embedded-component");

var _eventHelper = require("../../../src/event-helper");

var _string = require("../../../src/string");

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @private @const {number} */
var HOLD_TOUCH_THRESHOLD_MS = 500;

/** @private @const {number} */
var NEXT_SCREEN_AREA_RATIO = 0.75;

/** @private @const {number} */
var PREVIOUS_SCREEN_AREA_RATIO = 0.25;

/** @private @const {number} */
var TOP_REGION = 0.8;

/**
 * Protected edges of the screen in pixels. When tapped on these areas, we will
 * always perform navigation. Even if a clickable element is there.
 * @const {number}
 * @private
 */
var PROTECTED_SCREEN_EDGE_PX = 48;
var INTERACTIVE_EMBEDDED_COMPONENTS_SELECTORS = Object.values((0, _ampStoryEmbeddedComponent.interactiveElementsSelectors)()).join(',');

/** @const {number} */
var POLL_INTERVAL_MS = 300;
exports.POLL_INTERVAL_MS = POLL_INTERVAL_MS;

/** @const @enum */
var TapNavigationDirection = {
  'NEXT': 1,
  'PREVIOUS': 2
};
exports.TapNavigationDirection = TapNavigationDirection;

/**
 * Base class for the AdvancementConfig.  By default, does nothing other than
 * tracking its internal state when started/stopped, and listeners will never be
 * invoked.
 */
var AdvancementConfig = /*#__PURE__*/function () {
  /**
   * @public
   */
  function AdvancementConfig() {
    _classCallCheck(this, AdvancementConfig);

    /** @private @const {!Array<function(number)>} */
    this.progressListeners_ = [];

    /** @private @const {!Array<function()>} */
    this.advanceListeners_ = [];

    /** @private @const {!Array<function()>} */
    this.previousListeners_ = [];

    /** @private @const {!Array<function(number)>} */
    this.tapNavigationListeners_ = [];

    /** @private {boolean} */
    this.isRunning_ = false;
  }

  /**
   * @param {function(number)} progressListener A function that handles when the
   *     progress of the current page has been updated.  It accepts a number
   *     between 0.0 and 1.0 as its only argument, that represents the current
   *     progress.
   */
  _createClass(AdvancementConfig, [{
    key: "addProgressListener",
    value: function addProgressListener(progressListener) {
      this.progressListeners_.push(progressListener);
    }
    /**
     * @param {function()} advanceListener A function that handles when a
     *     page should be advanced.
     */

  }, {
    key: "addAdvanceListener",
    value: function addAdvanceListener(advanceListener) {
      this.advanceListeners_.push(advanceListener);
    }
    /**
     * @param {function()} previousListener A function that handles when a
     *     page should go back to the previous page.
     */

  }, {
    key: "addPreviousListener",
    value: function addPreviousListener(previousListener) {
      this.previousListeners_.push(previousListener);
    }
    /**
     * @param {function(number)} onTapNavigationListener A function that handles when a
     * navigation listener to be fired.
     */

  }, {
    key: "addOnTapNavigationListener",
    value: function addOnTapNavigationListener(onTapNavigationListener) {
      this.tapNavigationListeners_.push(onTapNavigationListener);
    }
    /**
     * Invoked when the advancement configuration should begin taking effect.
     */

  }, {
    key: "start",
    value: function start() {
      this.isRunning_ = true;
    }
    /**
     * Invoked when the advancement configuration should cease taking effect.
     * @param {boolean=} unusedCanResume
     */

  }, {
    key: "stop",
    value: function stop(unusedCanResume) {
      this.isRunning_ = false;
    }
    /**
     * Returns whether the advancement configuration will automatically advance
     * @return {boolean}
     */

  }, {
    key: "isAutoAdvance",
    value: function isAutoAdvance() {
      return false;
    }
    /**
     * @return {boolean}
     * @protected
     */

  }, {
    key: "isRunning",
    value: function isRunning() {
      return this.isRunning_;
    }
    /**
     * @return {number}
     */

  }, {
    key: "getProgress",
    value: function getProgress() {
      return 1;
    }
    /** @protected */

  }, {
    key: "onProgressUpdate",
    value: function onProgressUpdate() {
      var progress = this.getProgress();
      this.progressListeners_.forEach(function (progressListener) {
        progressListener(progress);
      });
    }
    /** @protected */

  }, {
    key: "onAdvance",
    value: function onAdvance() {
      this.advanceListeners_.forEach(function (advanceListener) {
        advanceListener();
      });
    }
    /** @protected */

  }, {
    key: "onPrevious",
    value: function onPrevious() {
      this.previousListeners_.forEach(function (previousListener) {
        previousListener();
      });
    }
    /**
     * @param {number} navigationDirection Direction of navigation
     * @protected
     */

  }, {
    key: "onTapNavigation",
    value: function onTapNavigation(navigationDirection) {
      this.tapNavigationListeners_.forEach(function (navigationListener) {
        navigationListener(navigationDirection);
      });
    }
    /**
     * Provides an AdvancementConfig object for the specified amp-story or
     * amp-story-page.
     * @param {!Window} win
     * @param {!Element} element
     * @return {!AdvancementConfig|!ManualAdvancement|!TimeBasedAdvancement|!MediaBasedAdvancement}
     */

  }], [{
    key: "forElement",
    value: function forElement(win, element) {
      var manualAdvancement = ManualAdvancement.fromElement(win, element);

      if (manualAdvancement) {
        return manualAdvancement;
      }

      var autoAdvanceStr = element.getAttribute('auto-advance-after');

      if (autoAdvanceStr) {
        var timeBasedAdvancement = TimeBasedAdvancement.fromAutoAdvanceString(autoAdvanceStr, win, element);

        if (timeBasedAdvancement) {
          return timeBasedAdvancement;
        }

        var mediaBasedAdvancement = MediaBasedAdvancement.fromAutoAdvanceString(autoAdvanceStr, win, element);

        if (mediaBasedAdvancement) {
          return mediaBasedAdvancement;
        }
      }

      return new AdvancementConfig();
    }
  }]);

  return AdvancementConfig;
}();

exports.AdvancementConfig = AdvancementConfig;

/**
 * Always provides a progress of 1.0.  Advances when the user taps the
 * corresponding section, depending on language settings.
 */
var ManualAdvancement = /*#__PURE__*/function (_AdvancementConfig) {
  _inherits(ManualAdvancement, _AdvancementConfig);

  var _super = _createSuper(ManualAdvancement);

  /**
   * @param {!Window} win The Window object.
   * @param {!Element} element The element that, when clicked, can cause
   *     advancing to the next page or going back to the previous.
   */
  function ManualAdvancement(win, element) {
    var _this;

    _classCallCheck(this, ManualAdvancement);

    _this = _super.call(this);

    /** @private @const {!Element} */
    _this.element_ = element;

    /** @private {number|string|null} */
    _this.timeoutId_ = null;

    /** @private @const {!../../../src/service/timer-impl.Timer} */
    _this.timer_ = _services.Services.timerFor(win);

    /** @private {?number} Last touchstart event's timestamp */
    _this.touchstartTimestamp_ = null;

    /** @private {boolean} Saving the paused state before pressing */
    _this.pausedState_ = false;

    /** @private {!../../../src/service/ampdoc-impl.AmpDoc} */
    _this.ampdoc_ = (0, _service.getAmpdoc)(win.document);

    _this.startListening_();

    if (element.ownerDocument.defaultView) {
      /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
      _this.storeService_ = (0, _ampStoryStoreService.getStoreService)(element.ownerDocument.defaultView);
    }

    var rtlState = _this.storeService_.get(_ampStoryStoreService.StateProperty.RTL_STATE);

    _this.sections_ = {
      // Width and navigation direction of each section depend on whether the
      // document is RTL or LTR.
      left: {
        widthRatio: rtlState ? NEXT_SCREEN_AREA_RATIO : PREVIOUS_SCREEN_AREA_RATIO,
        direction: rtlState ? TapNavigationDirection.NEXT : TapNavigationDirection.PREVIOUS
      },
      right: {
        widthRatio: rtlState ? PREVIOUS_SCREEN_AREA_RATIO : NEXT_SCREEN_AREA_RATIO,
        direction: rtlState ? TapNavigationDirection.PREVIOUS : TapNavigationDirection.NEXT
      }
    };
    return _this;
  }

  /** @override */
  _createClass(ManualAdvancement, [{
    key: "getProgress",
    value: function getProgress() {
      return 1.0;
    }
    /**
     * Binds the event listeners.
     * @private
     */

  }, {
    key: "startListening_",
    value: function startListening_() {
      var _this2 = this;

      this.element_.addEventListener('touchstart', this.onTouchstart_.bind(this), true);
      this.element_.addEventListener('touchend', this.onTouchend_.bind(this), true);
      this.element_.addEventListener('click', this.maybePerformNavigation_.bind(this), true);
      this.ampdoc_.onVisibilityChanged(function () {
        _this2.ampdoc_.isVisible() ? _this2.processTouchend_() : null;
      });
    }
    /**
     * @override
     */

  }, {
    key: "isAutoAdvance",
    value: function isAutoAdvance() {
      return false;
    }
    /**
     * TouchEvent touchstart events handler.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onTouchstart_",
    value: function onTouchstart_(event) {
      var _this3 = this;

      // Don't start the paused state if the event should not be handled by this
      // class. Also ignores any subsequent touchstart that would happen before
      // touchend was fired, since it'd reset the touchstartTimestamp (ie: user
      // touches the screen with a second finger).
      if (this.touchstartTimestamp_ || !this.shouldHandleEvent_(event)) {
        return;
      }

      this.touchstartTimestamp_ = Date.now();
      this.pausedState_ =
      /** @type {boolean} */
      this.storeService_.get(_ampStoryStoreService.StateProperty.PAUSED_STATE);
      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, true);
      this.timeoutId_ = this.timer_.delay(function () {
        _this3.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SYSTEM_UI_IS_VISIBLE, false);
      }, HOLD_TOUCH_THRESHOLD_MS);
    }
    /**
     * TouchEvent touchend events handler.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onTouchend_",
    value: function onTouchend_(event) {
      // Ignores the event if there's still a user's finger holding the screen.
      var touchesCount = (event.touches || []).length;

      if (!this.touchstartTimestamp_ || touchesCount > 0) {
        return;
      }

      // Cancels the navigation if user paused the story for over 500ms. Calling
      // preventDefault on the touchend event ensures the click/tap event won't
      // fire.
      if (Date.now() - this.touchstartTimestamp_ > HOLD_TOUCH_THRESHOLD_MS) {
        event.preventDefault();
      }

      this.processTouchend_();
    }
    /**
     * Logic triggered by touchend events.
     * @private
     */

  }, {
    key: "processTouchend_",
    value: function processTouchend_() {
      if (!this.touchstartTimestamp_) {
        return;
      }

      this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_PAUSED, this.pausedState_);
      this.touchstartTimestamp_ = null;
      this.timer_.cancel(this.timeoutId_);
      this.timeoutId_ = null;

      if (!this.storeService_.get(_ampStoryStoreService.StateProperty.SYSTEM_UI_IS_VISIBLE_STATE) &&
      /** @type {InteractiveComponentDef} */
      this.storeService_.get(_ampStoryStoreService.StateProperty.INTERACTIVE_COMPONENT_STATE).state !== _ampStoryStoreService.EmbeddedComponentState.EXPANDED) {
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_SYSTEM_UI_IS_VISIBLE, true);
      }
    }
    /**
     * Determines whether a click should be used for navigation.  Navigate should
     * occur unless the click is on the system layer, or on an element that
     * defines on="tap:..."
     * @param {!Event} event 'click' event.
     * @return {boolean} true, if the click should be used for navigation.
     * @private
     */

  }, {
    key: "isNavigationalClick_",
    value: function isNavigationalClick_(event) {
      return !(0, _dom.closest)((0, _log.dev)().assertElement(event.target), function (el) {
        return (0, _utils.hasTapAction)(el);
      },
      /* opt_stopAt */
      this.element_);
    }
    /**
     * We want clicks on certain elements to be exempted from normal page
     * navigation
     * @param {!Event} event
     * @return {boolean}
     * @private
     */

  }, {
    key: "isProtectedTarget_",
    value: function isProtectedTarget_(event) {
      return !!(0, _dom.closest)((0, _log.dev)().assertElement(event.target), function (el) {
        var elementRole = el.getAttribute('role');

        if (elementRole) {
          return !!_actionImpl.TAPPABLE_ARIA_ROLES[elementRole.toLowerCase()];
        }

        return false;
      },
      /* opt_stopAt */
      this.element_);
    }
    /**
     * Checks if the event should be handled by ManualAdvancement, or should
     * follow its capture phase.
     * @param {!Event} event
     * @return {boolean}
     * @private
     */

  }, {
    key: "shouldHandleEvent_",
    value: function shouldHandleEvent_(event) {
      var _this4 = this;

      var shouldHandleEvent = false;
      var tagName;
      (0, _dom.closest)((0, _log.dev)().assertElement(event.target), function (el) {
        tagName = el.tagName.toLowerCase();

        if (tagName === 'amp-story-page-attachment') {
          shouldHandleEvent = false;
          return true;
        }

        if ((0, _string.startsWith)(tagName, 'amp-story-interactive-') && !_this4.isInScreenSideEdge_(event, _this4.element_.getLayoutBox())) {
          shouldHandleEvent = false;
          return true;
        }

        if (tagName === 'amp-story-page') {
          shouldHandleEvent = true;
          return true;
        }

        if (el.classList.contains('i-amphtml-story-screen-reader-back-button')) {
          shouldHandleEvent = true;
          return true;
        }

        return false;
      },
      /* opt_stopAt */
      this.element_);
      return shouldHandleEvent;
    }
    /**
     * For an element to trigger a tooltip it has to be descendant of
     * amp-story-page but not of amp-story-cta-layer or amp-story-page-attachment.
     * @param {!Event} event
     * @param {!ClientRect} pageRect
     * @return {boolean}
     * @private
     */

  }, {
    key: "canShowTooltip_",
    value: function canShowTooltip_(event, pageRect) {
      var valid = true;
      var tagName;
      // We have a `pointer-events: none` set to all children of <a> tags inside
      // of amp-story-grid-layer, which acts as a click shield, making sure we
      // handle the click before navigation (see amp-story.css). It also ensures
      // we always get the <a> to be the target, even if it has children (e.g.
      // <span>).
      var target = (0, _log.dev)().assertElement(event.target);

      if (this.isInScreenSideEdge_(event, pageRect)) {
        event.preventDefault();
        return false;
      }

      if (target.getAttribute('show-tooltip') === 'auto' && this.isInScreenBottom_(target, pageRect)) {
        target.setAttribute('target', '_blank');
        target.setAttribute('role', 'link');
        return false;
      }

      return !!(0, _dom.closest)(target, function (el) {
        tagName = el.tagName.toLowerCase();

        if (tagName === 'amp-story-cta-layer' || tagName === 'amp-story-page-attachment') {
          valid = false;
          return false;
        }

        return tagName === 'amp-story-page' && valid;
      },
      /* opt_stopAt */
      this.element_);
    }
    /**
     * Checks if element is inside of the bottom region of the screen.
     * @param {!Element} target
     * @param {!ClientRect} pageRect
     * @return {boolean}
     * @private
     */

  }, {
    key: "isInScreenBottom_",
    value: function isInScreenBottom_(target, pageRect) {
      var targetRect = target.
      /*OK*/
      getBoundingClientRect();
      return targetRect.top - pageRect.top >= pageRect.height * TOP_REGION;
    }
    /**
     * Checks if click was inside of one of the side edges of the screen.
     * @param {!Event} event
     * @param {!ClientRect} pageRect
     * @return {boolean}
     * @private
     */

  }, {
    key: "isInScreenSideEdge_",
    value: function isInScreenSideEdge_(event, pageRect) {
      return event.clientX <= PROTECTED_SCREEN_EDGE_PX || event.clientX >= pageRect.width - PROTECTED_SCREEN_EDGE_PX;
    }
    /**
     * Checks if click should be handled by the embedded component logic rather
     * than by navigation.
     * @param {!Event} event
     * @param {!ClientRect} pageRect
     * @return {boolean}
     * @private
     */

  }, {
    key: "isHandledByEmbeddedComponent_",
    value: function isHandledByEmbeddedComponent_(event, pageRect) {
      var target = (0, _log.dev)().assertElement(event.target);
      var stored =
      /** @type {InteractiveComponentDef} */
      this.storeService_.get(_ampStoryStoreService.StateProperty.INTERACTIVE_COMPONENT_STATE);
      var inExpandedMode = stored.state === _ampStoryStoreService.EmbeddedComponentState.EXPANDED;
      return inExpandedMode || (0, _dom.matches)(target, INTERACTIVE_EMBEDDED_COMPONENTS_SELECTORS) && this.canShowTooltip_(event, pageRect);
    }
    /**
     * Check if click should be handled by the affiliate link logic.
     * @param {!Element} target
     * @private
     * @return {boolean}
     */

  }, {
    key: "isHandledByAffiliateLink_",
    value: function isHandledByAffiliateLink_(target) {
      var clickedOnLink = (0, _dom.matches)(target, _ampStoryAffiliateLink.AFFILIATE_LINK_SELECTOR);

      // do not handle if clicking on expanded affiliate link
      if (clickedOnLink && target.hasAttribute('expanded')) {
        return false;
      }

      var expandedElement = this.storeService_.get(_ampStoryStoreService.StateProperty.AFFILIATE_LINK_STATE);
      return expandedElement != null || clickedOnLink;
    }
    /**
     * Performs a system navigation if it is determined that the specified event
     * was a click intended for navigation.
     * @param {!Event} event 'click' event
     * @private
     */

  }, {
    key: "maybePerformNavigation_",
    value: function maybePerformNavigation_(event) {
      var target = (0, _log.dev)().assertElement(event.target);
      var pageRect = this.element_.getLayoutBox();

      if (this.isHandledByEmbeddedComponent_(event, pageRect)) {
        event.stopPropagation();
        event.preventDefault();
        var embedComponent =
        /** @type {InteractiveComponentDef} */
        this.storeService_.get(_ampStoryStoreService.StateProperty.INTERACTIVE_COMPONENT_STATE);
        this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_INTERACTIVE_COMPONENT, {
          element: target,
          state: embedComponent.state || _ampStoryStoreService.EmbeddedComponentState.FOCUSED,
          clientX: event.clientX,
          clientY: event.clientY
        });
        return;
      }

      if (this.isHandledByAffiliateLink_(target)) {
        event.preventDefault();
        event.stopPropagation();
        var clickedOnLink = (0, _dom.matches)(target, _ampStoryAffiliateLink.AFFILIATE_LINK_SELECTOR);

        if (clickedOnLink) {
          this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_AFFILIATE_LINK, target);
        } else {
          this.storeService_.dispatch(_ampStoryStoreService.Action.TOGGLE_AFFILIATE_LINK, null);
        }

        return;
      }

      if (!this.isRunning() || !this.isNavigationalClick_(event) || this.isProtectedTarget_(event) || !this.shouldHandleEvent_(event)) {
        // If the system doesn't need to handle this click, then we can simply
        // return and let the event propagate as it would have otherwise.
        return;
      }

      event.stopPropagation();
      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.MANUAL_ADVANCE);
      // Using `left` as a fallback since Safari returns a ClientRect in some
      // cases.
      var offsetLeft = 'x' in pageRect ? pageRect.x : pageRect.left;
      var page = {
        // Offset starting left of the page.
        offset: offsetLeft,
        width: pageRect.width,
        clickEventX: event.pageX
      };
      this.onTapNavigation(this.getTapDirection_(page));
    }
    /**
     * Decides what direction to navigate depending on which
     * section of the page was there a click. The navigation direction of each
     * individual section has been previously defined depending on the language
     * settings.
     * @param {!Object} page
     * @return {number}
     * @private
     */

  }, {
    key: "getTapDirection_",
    value: function getTapDirection_(page) {
      var _this$sections_ = this.sections_,
          left = _this$sections_.left,
          right = _this$sections_.right;

      if (page.clickEventX <= page.offset + left.widthRatio * page.width) {
        return left.direction;
      }

      return right.direction;
    }
    /**
     * Gets an instance of ManualAdvancement based on the HTML tag of the element.
     * @param {!Window} win
     * @param {!Element} element
     * @return {?AdvancementConfig} An AdvancementConfig, only if the element is
     *                              an amp-story tag.
     */

  }], [{
    key: "fromElement",
    value: function fromElement(win, element) {
      if (element.tagName.toLowerCase() !== 'amp-story') {
        return null;
      }

      return new ManualAdvancement(win, element);
    }
  }]);

  return ManualAdvancement;
}(AdvancementConfig);

exports.ManualAdvancement = ManualAdvancement;

/**
 * Provides progress and advancement based on a fixed duration of time,
 * specified in either seconds or milliseconds.
 */
var TimeBasedAdvancement = /*#__PURE__*/function (_AdvancementConfig2) {
  _inherits(TimeBasedAdvancement, _AdvancementConfig2);

  var _super2 = _createSuper(TimeBasedAdvancement);

  /**
   * @param {!Window} win The Window object.
   * @param {number} delayMs The duration to wait before advancing.
   * @param {!Element} element
   */
  function TimeBasedAdvancement(win, delayMs, element) {
    var _this5;

    _classCallCheck(this, TimeBasedAdvancement);

    _this5 = _super2.call(this);

    /** @private @const {!../../../src/service/timer-impl.Timer} */
    _this5.timer_ = _services.Services.timerFor(win);

    /** @private @const {number} */
    _this5.delayMs_ = delayMs;

    /** @private {?number} */
    _this5.remainingDelayMs_ = null;

    /** @private {?number} */
    _this5.startTimeMs_ = null;

    /** @private {number|string|null} */
    _this5.timeoutId_ = null;

    if (element.ownerDocument.defaultView) {
      /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
      _this5.storeService_ = (0, _ampStoryStoreService.getStoreService)(element.ownerDocument.defaultView);
    }

    return _this5;
  }

  /**
   * @return {number} The current timestamp, in milliseconds.
   * @private
   */
  _createClass(TimeBasedAdvancement, [{
    key: "getCurrentTimestampMs_",
    value: function getCurrentTimestampMs_() {
      return Date.now();
    }
    /** @override */

  }, {
    key: "start",
    value: function start() {
      var _this6 = this;

      _get(_getPrototypeOf(TimeBasedAdvancement.prototype), "start", this).call(this);

      if (this.remainingDelayMs_) {
        this.startTimeMs_ = this.getCurrentTimestampMs_() - (this.delayMs_ - this.remainingDelayMs_);
      } else {
        this.startTimeMs_ = this.getCurrentTimestampMs_();
      }

      this.timeoutId_ = this.timer_.delay(function () {
        return _this6.onAdvance();
      }, this.remainingDelayMs_ || this.delayMs_);
      this.onProgressUpdate();
      this.timer_.poll(POLL_INTERVAL_MS, function () {
        _this6.onProgressUpdate();

        return !_this6.isRunning();
      });
    }
    /** @override */

  }, {
    key: "stop",
    value: function stop(canResume) {
      if (canResume === void 0) {
        canResume = false;
      }

      _get(_getPrototypeOf(TimeBasedAdvancement.prototype), "stop", this).call(this);

      if (this.timeoutId_ !== null) {
        this.timer_.cancel(this.timeoutId_);
      }

      // Store the remaining time if the advancement can be resume, ie: if it is
      // paused.
      this.remainingDelayMs_ = canResume ? this.startTimeMs_ + this.delayMs_ - this.getCurrentTimestampMs_() : null;
    }
    /**
     * @override
     */

  }, {
    key: "isAutoAdvance",
    value: function isAutoAdvance() {
      return true;
    }
    /** @override */

  }, {
    key: "getProgress",
    value: function getProgress() {
      if (this.startTimeMs_ === null) {
        return 0;
      }

      var progress = (this.getCurrentTimestampMs_() - this.startTimeMs_) / this.delayMs_;
      return Math.min(Math.max(progress, 0), 1);
    }
    /** @override */

  }, {
    key: "onAdvance",
    value: function onAdvance() {
      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.AUTO_ADVANCE_TIME);

      _get(_getPrototypeOf(TimeBasedAdvancement.prototype), "onAdvance", this).call(this);
    }
    /**
     * Gets an instance of TimeBasedAdvancement based on the value of the
     * auto-advance string (from the 'auto-advance-after' attribute on the page).
     * @param {string} autoAdvanceStr The value of the auto-advance-after
     *     attribute.
     * @param {!Window} win
     * @param {!Element} element
     * @return {?AdvancementConfig} An AdvancementConfig, if time-based
     *     auto-advance is supported for the specified auto-advance string; null
     *     otherwise.
     */

  }], [{
    key: "fromAutoAdvanceString",
    value: function fromAutoAdvanceString(autoAdvanceStr, win, element) {
      if (!autoAdvanceStr) {
        return null;
      }

      var delayMs = (0, _utils.timeStrToMillis)(autoAdvanceStr);

      if (delayMs === undefined || isNaN(delayMs)) {
        return null;
      }

      return new TimeBasedAdvancement(win, Number(delayMs), element);
    }
  }]);

  return TimeBasedAdvancement;
}(AdvancementConfig);

exports.TimeBasedAdvancement = TimeBasedAdvancement;

/**
 * Provides progress and advances pages based on the completion percentage of
 * playback of an HTMLMediaElement or a video that implements the AMP
 * video-interface.
 *
 * These are combined into a single AdvancementConfig implementation because we
 * may not know at build time whether a video implements the AMP
 * video-interface, since that is dependent on the amp-video buildCallback
 * having been executed before the amp-story-page buildCallback, which is not
 * guaranteed.
 */
var MediaBasedAdvancement = /*#__PURE__*/function (_AdvancementConfig3) {
  _inherits(MediaBasedAdvancement, _AdvancementConfig3);

  var _super3 = _createSuper(MediaBasedAdvancement);

  /**
   * @param {!Window} win
   * @param {!Element} element
   */
  function MediaBasedAdvancement(win, element) {
    var _this7;

    _classCallCheck(this, MediaBasedAdvancement);

    _this7 = _super3.call(this);

    /** @private @const {!../../../src/service/timer-impl.Timer} */
    _this7.timer_ = _services.Services.timerFor(win);

    /** @private {!Element} */
    _this7.element_ = element;

    /** @private {?Element} */
    _this7.mediaElement_ = null;

    /** @private {!Array<!UnlistenDef>} */
    _this7.unlistenFns_ = [];

    /** @protected {?UnlistenDef} */
    _this7.unlistenEndedFn_ = null;

    /** @protected {?UnlistenDef} */
    _this7.unlistenTimeupdateFn_ = null;

    /** @private {?../../../src/video-interface.VideoInterface} */
    _this7.video_ = null;

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    _this7.storeService_ = (0, _ampStoryStoreService.getStoreService)(win);
    return _this7;
  }

  /**
   * Determines whether the element for auto advancement implements the video
   * interface.
   * @return {boolean} true, if the specified element implements the video
   *     interface.
   * @private
   */
  _createClass(MediaBasedAdvancement, [{
    key: "isVideoInterfaceVideo_",
    value: function isVideoInterfaceVideo_() {
      return this.element_.classList.contains('i-amphtml-video-interface');
    }
    /**
     * Gets an HTMLMediaElement from an element that wraps it.
     * @return {?Element} The underlying HTMLMediaElement, if one exists.
     * @private
     */

  }, {
    key: "getMediaElement_",
    value: function getMediaElement_() {
      var tagName = this.element_.tagName.toLowerCase();

      if (this.element_ instanceof HTMLMediaElement) {
        return this.element_;
      } else if (this.element_.hasAttribute('background-audio') && tagName === 'amp-story-page') {
        return this.element_.querySelector('.i-amphtml-story-background-audio');
      } else if (tagName === 'amp-audio') {
        return this.element_.querySelector('audio');
      }

      return null;
    }
    /** @override */

  }, {
    key: "start",
    value: function start() {
      var _this8 = this;

      _get(_getPrototypeOf(MediaBasedAdvancement.prototype), "start", this).call(this);

      // Prevents race condition when checking for video interface classname.
      (this.element_.whenBuilt ? this.element_.whenBuilt() : (0, _resolvedPromise2.resolvedPromise)()).then(function () {
        return _this8.startWhenBuilt_();
      });
    }
    /** @private */

  }, {
    key: "startWhenBuilt_",
    value: function startWhenBuilt_() {
      if (this.isVideoInterfaceVideo_()) {
        this.startVideoInterfaceElement_();
        return;
      }

      if (!this.mediaElement_) {
        this.mediaElement_ = this.getMediaElement_();
      }

      if (this.mediaElement_) {
        this.startHtmlMediaElement_();
        return;
      }

      (0, _log.user)().error('AMP-STORY-PAGE', "Element with ID " + this.element_.id + " is not a media element " + 'supported for automatic advancement.');
    }
    /** @private */

  }, {
    key: "startHtmlMediaElement_",
    value: function startHtmlMediaElement_() {
      var _this9 = this;

      var mediaElement = (0, _log.dev)().assertElement(this.mediaElement_, 'Media element was unspecified.');
      // Removes [loop] attribute if specified, so the 'ended' event can trigger.
      this.mediaElement_.removeAttribute('loop');
      this.unlistenFns_.push((0, _eventHelper.listenOnce)(mediaElement, 'ended', function () {
        return _this9.onAdvance();
      }));
      this.onProgressUpdate();
      this.timer_.poll(POLL_INTERVAL_MS, function () {
        _this9.onProgressUpdate();

        return !_this9.isRunning();
      });
    }
    /** @private */

  }, {
    key: "startVideoInterfaceElement_",
    value: function startVideoInterfaceElement_() {
      var _this10 = this;

      this.element_.getImpl().then(function (video) {
        _this10.video_ = video;
      });
      // Removes [loop] attribute if specified, so the 'ended' event can trigger.
      this.element_.querySelector('video').removeAttribute('loop');
      this.unlistenFns_.push((0, _eventHelper.listenOnce)(this.element_, _videoInterface.VideoEvents.ENDED, function () {
        return _this10.onAdvance();
      }, {
        capture: true
      }));
      this.onProgressUpdate();
      this.timer_.poll(POLL_INTERVAL_MS, function () {
        _this10.onProgressUpdate();

        return !_this10.isRunning();
      });
    }
    /** @override */

  }, {
    key: "stop",
    value: function stop() {
      _get(_getPrototypeOf(MediaBasedAdvancement.prototype), "stop", this).call(this);

      this.unlistenFns_.forEach(function (fn) {
        return fn();
      });
    }
    /**
     * @override
     */

  }, {
    key: "isAutoAdvance",
    value: function isAutoAdvance() {
      return true;
    }
    /** @override */

  }, {
    key: "getProgress",
    value: function getProgress() {
      if (this.isVideoInterfaceVideo_()) {
        if (this.video_ && this.video_.getDuration()) {
          return this.video_.getCurrentTime() / this.video_.getDuration();
        }

        return 0;
      }

      if (this.mediaElement_ && this.mediaElement_.duration) {
        return this.mediaElement_.currentTime / this.mediaElement_.duration;
      }

      return _get(_getPrototypeOf(MediaBasedAdvancement.prototype), "getProgress", this).call(this);
    }
    /** @override */

  }, {
    key: "onAdvance",
    value: function onAdvance() {
      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.AUTO_ADVANCE_MEDIA);

      _get(_getPrototypeOf(MediaBasedAdvancement.prototype), "onAdvance", this).call(this);
    }
    /**
     * Gets an instance of MediaBasedAdvancement based on the value of the
     * auto-advance string (from the 'auto-advance-after' attribute on the page).
     * @param {string} autoAdvanceStr The value of the auto-advance-after
     *     attribute.
     * @param {!Window} win
     * @param {!Element} pageEl
     * @return {?AdvancementConfig} An AdvancementConfig, if media-element-based
     *     auto-advance is supported for the specified auto-advance string; null
     *     otherwise.
     */

  }], [{
    key: "fromAutoAdvanceString",
    value: function fromAutoAdvanceString(autoAdvanceStr, win, pageEl) {
      try {
        // amp-video, amp-audio, as well as amp-story-page with a background audio
        // are eligible for media based auto advance.
        var element = pageEl.querySelector("amp-video[data-id=" + (0, _css.escapeCssSelectorIdent)(autoAdvanceStr) + "],\n          amp-video#" + (0, _css.escapeCssSelectorIdent)(autoAdvanceStr) + ",\n          amp-audio[data-id=" + (0, _css.escapeCssSelectorIdent)(autoAdvanceStr) + "],\n          amp-audio#" + (0, _css.escapeCssSelectorIdent)(autoAdvanceStr));

        if ((0, _dom.matches)(pageEl, "amp-story-page[background-audio]#" + (0, _css.escapeCssSelectorIdent)(autoAdvanceStr))) {
          element = pageEl;
        }

        if (!element) {
          if (autoAdvanceStr) {
            (0, _log.user)().warn('AMP-STORY-PAGE', "Element with ID " + pageEl.id + " has no media element " + 'supported for automatic advancement.');
          }

          return null;
        }

        return new MediaBasedAdvancement(win, element);
      } catch (e) {
        return null;
      }
    }
  }]);

  return MediaBasedAdvancement;
}(AdvancementConfig);

exports.MediaBasedAdvancement = MediaBasedAdvancement;

},{"../../../src/css":105,"../../../src/dom":106,"../../../src/event-helper":111,"../../../src/log":123,"../../../src/service":130,"../../../src/service/action-impl":131,"../../../src/services":133,"../../../src/string":136,"../../../src/video-interface":153,"./../../../src/resolved-promise":129,"./amp-story-affiliate-link":36,"./amp-story-embedded-component":41,"./amp-story-store-service":53,"./story-analytics":91,"./utils":93}],86:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.PaginationButtons = void 0;

var _ampStoryStoreService = require("./amp-story-store-service");

var _storyAnalytics = require("./story-analytics");

var _commonSignals = require("../../../src/common-signals");

var _events = require("./events");

var _log = require("../../../src/log");

var _object = require("./../../../src/utils/object");

var _simpleTemplate = require("./simple-template");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @struct @typedef {{className: string, triggers: (string|undefined)}} */
var ButtonState_1_0_Def;
// eslint-disable-line google-camelcase/google-camelcase

/** @const {!Object<string, !ButtonState_1_0_Def>} */
var BackButtonStates = {
  CLOSE_BOOKEND: {
    className: 'i-amphtml-story-back-close-bookend',
    action: _ampStoryStoreService.Action.TOGGLE_BOOKEND,
    data: false,
    label: 'Close bookend'
  },
  HIDDEN: {
    className: 'i-amphtml-story-button-hidden'
  },
  PREVIOUS_PAGE: {
    className: 'i-amphtml-story-back-prev',
    triggers: _events.EventType.PREVIOUS_PAGE,
    label: 'Previous page'
  }
};

/** @const {!Object<string, !ButtonState_1_0_Def>} */
var ForwardButtonStates = {
  HIDDEN: {
    className: 'i-amphtml-story-button-hidden'
  },
  NEXT_PAGE: {
    className: 'i-amphtml-story-fwd-next',
    triggers: _events.EventType.NEXT_PAGE,
    // TODO: Here and other labels: i18n.
    label: 'Next page'
  },
  REPLAY: {
    className: 'i-amphtml-story-fwd-replay',
    triggers: _events.EventType.REPLAY,
    label: 'Replay'
  },
  SHOW_BOOKEND: {
    className: 'i-amphtml-story-fwd-more',
    action: _ampStoryStoreService.Action.TOGGLE_BOOKEND,
    data: true,
    label: 'Show bookend'
  }
};

/** @private @const {!./simple-template.ElementDef} */
var BUTTON = {
  tag: 'div',
  attrs: (0, _object.dict)({
    'class': 'i-amphtml-story-button-container'
  }),
  children: [{
    tag: 'button',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-button-move'
    })
  }, {
    tag: 'div',
    attrs: (0, _object.dict)({
      'class': 'i-amphtml-story-page-sentinel'
    })
  }]
};

/**
 * @param {!Element} hoverEl
 * @param {!Element} targetEl
 * @param {string} className
 */
function setClassOnHover(hoverEl, targetEl, className) {
  hoverEl.addEventListener('mouseenter', function () {
    targetEl.classList.add(className);
  });
  hoverEl.addEventListener('mouseleave', function () {
    targetEl.classList.remove(className);
  });
}

/**
 * Desktop navigation buttons.
 */
var PaginationButton = /*#__PURE__*/function () {
  /**
   * @param {!Document} doc
   * @param {!ButtonState_1_0_Def} initialState
   * @param {!./amp-story-store-service.AmpStoryStoreService} storeService
   * @param {!Window} win
   */
  function PaginationButton(doc, initialState, storeService, win) {
    var _this = this;

    _classCallCheck(this, PaginationButton);

    /** @private {!ButtonState_1_0_Def} */
    this.state_ = initialState;

    /** @public @const {!Element} */
    this.element = (0, _simpleTemplate.renderAsElement)(doc, BUTTON);

    /** @public @const {!Element} */
    this.button_ = (0, _log.devAssert)(this.element.querySelector('button'), 'Expect to find a button');
    this.element.classList.add(initialState.className);
    this.button_.setAttribute('aria-label', initialState.label);
    this.element.addEventListener('click', function (e) {
      return _this.onClick_(e);
    });

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = storeService;

    /** @private @const {!Window} */
    this.win_ = win;
  }

  /** @param {!ButtonState_1_0_Def} state */
  _createClass(PaginationButton, [{
    key: "updateState",
    value: function updateState(state) {
      if (state === this.state_) {
        return;
      }

      this.element.classList.remove(this.state_.className);
      this.element.classList.add(state.className);
      this.button_.setAttribute('aria-label', state.label);
      this.state_ = state;
    }
    /**
     * @return {!ButtonState_1_0_Def}
     */

  }, {
    key: "getState",
    value: function getState() {
      return this.state_;
    }
    /**
     * @param {!Event} e
     * @private
     */

  }, {
    key: "onClick_",
    value: function onClick_(e) {
      e.preventDefault();
      this.storeService_.dispatch(_ampStoryStoreService.Action.SET_ADVANCEMENT_MODE, _storyAnalytics.AdvancementMode.MANUAL_ADVANCE);

      if (this.state_.triggers) {
        (0, _events.dispatch)(this.win_, this.element, (0, _log.devAssert)(this.state_.triggers),
        /* payload */
        undefined, {
          bubbles: true
        });
        return;
      }

      if (this.state_.action) {
        this.storeService_.dispatch(this.state_.action, this.state_.data);
        return;
      }
    }
  }]);

  return PaginationButton;
}();

/** Pagination buttons layer. */
var PaginationButtons = /*#__PURE__*/function () {
  /**
   * @param {!./amp-story.AmpStory} ampStory
   * @param {function():Promise<boolean>} hasBookend
   */
  function PaginationButtons(ampStory, hasBookend) {
    _classCallCheck(this, PaginationButtons);

    /** @private @const {!./amp-story.AmpStory} */
    this.ampStory_ = ampStory;
    var win = this.ampStory_.win;
    var doc = win.document;
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(win);

    /** @private @const {!PaginationButton} */
    this.forwardButton_ = new PaginationButton(doc, ForwardButtonStates.NEXT_PAGE, this.storeService_, win);

    /** @private @const {!PaginationButton} */
    this.backButton_ = new PaginationButton(doc, BackButtonStates.HIDDEN, this.storeService_, win);
    this.forwardButton_.element.classList.add('next-container');
    this.backButton_.element.classList.add('prev-container');

    /** @private {?ButtonState_1_0_Def} */
    this.backButtonStateToRestore_ = null;

    /** @private {?ButtonState_1_0_Def} */
    this.forwardButtonStateToRestore_ = null;

    /** @private {function():Promise<boolean>} */
    this.hasBookend_ = hasBookend;
    this.initializeListeners_();
  }

  /**
   * @param {!./amp-story.AmpStory} ampStory
   * @param {function():Promise<boolean>} hasBookend
   * @return {!PaginationButtons}
   */
  _createClass(PaginationButtons, [{
    key: "attach",

    /** @param {!Element} element */
    value: function attach(element) {
      setClassOnHover(this.forwardButton_.element, element, 'i-amphtml-story-next-hover');
      setClassOnHover(this.backButton_.element, element, 'i-amphtml-story-prev-hover');
      element.appendChild(this.forwardButton_.element);
      element.appendChild(this.backButton_.element);
    }
    /**
     * @private
     */

  }, {
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this2 = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.BOOKEND_STATE, function (isActive) {
        _this2.onBookendStateUpdate_(isActive);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CURRENT_PAGE_INDEX, function (pageIndex) {
        _this2.onCurrentPageIndexUpdate_(pageIndex);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.PAGE_IDS, function () {
        // Since onCurrentPageIndexUpdate_ uses this.hasBookend_, and the bookend
        // isn't initialized until after the story is laid out, we wait for the
        // story to be laid out before calling this function.
        _this2.ampStory_.element.signals().whenSignal(_commonSignals.CommonSignals.LOAD_END).then(function () {
          var currentPageIndex = Number(_this2.storeService_.get(_ampStoryStoreService.StateProperty.CURRENT_PAGE_INDEX));

          _this2.onCurrentPageIndexUpdate_(currentPageIndex);
        });
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.SYSTEM_UI_IS_VISIBLE_STATE, function (isVisible) {
        _this2.onSystemUiIsVisibleStateUpdate_(isVisible);
      });
    }
    /**
     * @param {boolean} isActive
     * @private
     */

  }, {
    key: "onBookendStateUpdate_",
    value: function onBookendStateUpdate_(isActive) {
      if (isActive) {
        this.backButton_.updateState(BackButtonStates.CLOSE_BOOKEND);
        this.forwardButton_.updateState(ForwardButtonStates.REPLAY);
      } else {
        this.backButton_.updateState(BackButtonStates.PREVIOUS_PAGE);
        this.forwardButton_.updateState(ForwardButtonStates.SHOW_BOOKEND);
      }
    }
    /**
     * @param {number} pageIndex
     * @private
     */

  }, {
    key: "onCurrentPageIndexUpdate_",
    value: function onCurrentPageIndexUpdate_(pageIndex) {
      var _this3 = this;

      var totalPages = this.storeService_.get(_ampStoryStoreService.StateProperty.PAGE_IDS).length;
      var bookendActive = this.storeService_.get(_ampStoryStoreService.StateProperty.BOOKEND_STATE);

      if (pageIndex === 0) {
        this.backButton_.updateState(BackButtonStates.HIDDEN);
      }

      if (pageIndex > 0 && !bookendActive) {
        this.backButton_.updateState(BackButtonStates.PREVIOUS_PAGE);
      }

      if (pageIndex < totalPages - 1) {
        this.forwardButton_.updateState(ForwardButtonStates.NEXT_PAGE);
      }

      if (pageIndex === totalPages - 1 && !bookendActive) {
        this.forwardButton_.updateState(ForwardButtonStates.SHOW_BOOKEND);
      }

      if (pageIndex === totalPages - 1) {
        this.hasBookend_().then(function (hasBookend) {
          if (!hasBookend) {
            _this3.forwardButton_.updateState(ForwardButtonStates.REPLAY);
          }
        });
      }
    }
    /**
     * Reacts to system UI visibility state updates.
     * @param {boolean} isVisible
     * @private
     */

  }, {
    key: "onSystemUiIsVisibleStateUpdate_",
    value: function onSystemUiIsVisibleStateUpdate_(isVisible) {
      if (isVisible) {
        this.backButton_.updateState(
        /** @type {!ButtonState_1_0_Def} */
        (0, _log.devAssert)(this.backButtonStateToRestore_));
        this.forwardButton_.updateState(
        /** @type {!ButtonState_1_0_Def} */
        (0, _log.devAssert)(this.forwardButtonStateToRestore_));
      } else {
        this.backButtonStateToRestore_ = this.backButton_.getState();
        this.backButton_.updateState(BackButtonStates.HIDDEN);
        this.forwardButtonStateToRestore_ = this.forwardButton_.getState();
        this.forwardButton_.updateState(ForwardButtonStates.HIDDEN);
      }
    }
  }], [{
    key: "create",
    value: function create(ampStory, hasBookend) {
      return new PaginationButtons(ampStory, hasBookend);
    }
  }]);

  return PaginationButtons;
}();

exports.PaginationButtons = PaginationButtons;

},{"../../../src/common-signals":101,"../../../src/log":123,"./../../../src/utils/object":149,"./amp-story-store-service":53,"./events":76,"./simple-template":89,"./story-analytics":91}],87:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.ProgressBar = void 0;

var _resolvedPromise2 = require("./../../../src/resolved-promise");

var _events = require("./events");

var _pageAdvancement = require("./page-advancement");

var _services = require("../../../src/services");

var _ampStoryStoreService = require("./amp-story-store-service");

var _rateLimit = require("../../../src/utils/rate-limit");

var _log = require("../../../src/log");

var _css = require("../../../src/css");

var _object = require("../../../src/utils/object");

var _dom = require("../../../src/dom");

var _style = require("../../../src/style");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Transition used to show the progress of a media. Has to be linear so the
 * animation is smooth and constant.
 * @const {string}
 */
var TRANSITION_LINEAR = "transform " + _pageAdvancement.POLL_INTERVAL_MS + "ms linear";

/**
 * Transition used to fully fill or unfill a progress bar item.
 * @const {string}
 */
var TRANSITION_EASE = 'transform 200ms ease';

/**
 * Size in pixels of a segment ellipse.
 * @type {number}
 */
var ELLIPSE_WIDTH_PX = 2;

/**
 * Size in pixels of the total side margins of a segment.
 * @const {number}
 */
var SEGMENTS_MARGIN_PX = 4;

/**
 * Maximum number of segments that can be shown at a time before collapsing
 * into ellipsis.
 * @type {number}
 */
var MAX_SEGMENTS = 20;

/**
 * Number of segments we introduce to the bar as we pass an overflow point
 * (when user reaches ellipsis).
 * @const {number}
 */
var SEGMENT_INCREMENT = 5;

/**
 * Progress bar for <amp-story>.
 */
var ProgressBar = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} storyEl
   */
  function ProgressBar(win, storyEl) {
    _classCallCheck(this, ProgressBar);

    /** @private @const {!Window} */
    this.win_ = win;

    /** @private {boolean} */
    this.isBuilt_ = false;

    /** @private {?Element} */
    this.root_ = null;

    /** @private {number} */
    this.segmentCount_ = 0;

    /** @private {number} */
    this.activeSegmentIndex_ = 0;

    /** @private {number} */
    this.activeSegmentProgress_ = 1;

    /** @private {!../../../src/service/ampdoc-impl.AmpDoc} */
    this.ampdoc_ = _services.Services.ampdocServiceFor(this.win_).getSingleDoc();

    /** @private @const {!../../../src/service/mutator-interface.MutatorInterface} */
    this.mutator_ = _services.Services.mutatorForDoc(this.ampdoc_);

    /** @private {!Object<string, number>} */
    this.segmentIdMap_ = (0, _object.map)();

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(this.win_);

    /** @private {string} */
    this.activeSegmentId_ = '';

    /** @private {!Array<!Element>} */
    this.segments_ = [];

    /** @private {!Promise} */
    this.segmentsAddedPromise_ = (0, _resolvedPromise2.resolvedPromise)();

    /**
     * First expanded segment after ellipsis (if any) for stories with segments
     * > MAX_SEGMENTS.
     * @private {number}
     */
    this.firstExpandedSegmentIndex_ = 0;

    /** @private {!Element} */
    this.storyEl_ = storyEl;
  }

  /**
   * @param {!Window} win
   * @param {!Element} storyEl
   * @return {!ProgressBar}
   */
  _createClass(ProgressBar, [{
    key: "build",

    /**
     * Builds the progress bar.
     * @param {string} initialSegmentId
     * @return {!Element}
     */
    value: function build(initialSegmentId) {
      var _this = this;

      if (this.isBuilt_) {
        return this.getRoot();
      }

      this.root_ = this.win_.document.createElement('ol');
      this.root_.setAttribute('aria-hidden', true);
      this.root_.classList.add('i-amphtml-story-progress-bar');
      this.storyEl_.addEventListener(_events.EventType.REPLAY, function () {
        _this.replay_();
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.PAGE_IDS, function (pageIds) {
        if (_this.isBuilt_) {
          _this.clear_();
        }

        _this.segmentsAddedPromise_ = _this.mutator_.mutateElement(_this.getRoot(), function () {
          /** @type {!Array} */
          pageIds.forEach(function (id) {
            if (!(id in _this.segmentIdMap_)) {
              _this.addSegment_(id);
            }
          });
        });

        if (_this.isBuilt_) {
          _this.updateProgress(_this.activeSegmentId_, _this.activeSegmentProgress_, true
          /** updateAllSegments */
          );
        }
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.RTL_STATE, function (rtlState) {
        _this.onRtlStateUpdate_(rtlState);
      }, true
      /** callToInitialize */
      );
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.UI_STATE, function (uiState) {
        _this.onUIStateUpdate_(uiState);
      }, true
      /** callToInitialize */
      );

      _services.Services.viewportForDoc(this.ampdoc_).onResize((0, _rateLimit.debounce)(this.win_, function () {
        return _this.onResize_();
      }, 300));

      this.segmentsAddedPromise_.then(function () {
        if (_this.segmentCount_ > MAX_SEGMENTS) {
          _this.getInitialFirstExpandedSegmentIndex_(_this.segmentIdMap_[initialSegmentId]);

          _this.render_(false
          /** shouldAnimate */
          );
        }

        _this.getRoot().classList.toggle('i-amphtml-progress-bar-overflow', _this.segmentCount_ > MAX_SEGMENTS);
      });
      this.isBuilt_ = true;
      return this.getRoot();
    }
    /**
     * Reacts to story replay.
     * @private
     */

  }, {
    key: "replay_",
    value: function replay_() {
      if (this.segmentCount_ > MAX_SEGMENTS) {
        this.firstExpandedSegmentIndex_ = 0;
        this.render_(false
        /** shouldAnimate */
        );
      }
    }
    /**
     * Renders the segments by setting their corresponding scaleX and translate.
     * @param {boolean} shouldAnimate
     * @private
     */

  }, {
    key: "render_",
    value: function render_(shouldAnimate) {
      var _this2 = this;

      if (shouldAnimate === void 0) {
        shouldAnimate = true;
      }

      this.getSegmentWidth_().then(function (segmentWidth) {
        var translateX = -(_this2.firstExpandedSegmentIndex_ - _this2.getPrevEllipsisCount_()) * (ELLIPSE_WIDTH_PX + SEGMENTS_MARGIN_PX);

        _this2.mutator_.mutateElement(_this2.getRoot(), function () {
          _this2.getRoot().classList.toggle('i-amphtml-animate-progress', shouldAnimate);

          for (var index = 0; index < _this2.segmentCount_; index++) {
            var width = index >= _this2.firstExpandedSegmentIndex_ && index < _this2.firstExpandedSegmentIndex_ + MAX_SEGMENTS ? segmentWidth : ELLIPSE_WIDTH_PX;

            _this2.transform_(_this2.segments_[index], translateX, width);

            translateX += width + SEGMENTS_MARGIN_PX;
          }
        });
      });
    }
    /**
     * Applies transform to a segment.
     * @param {!Element} segment
     * @param {number} translateX
     * @param {number} width
     * @private
     */

  }, {
    key: "transform_",
    value: function transform_(segment, translateX, width) {
      if (this.storeService_.get(_ampStoryStoreService.StateProperty.RTL_STATE)) {
        translateX *= -1;
      }

      // Do not remove translateZ(0.00001px) as it prevents an iOS repaint issue.
      // http://mir.aculo.us/2011/12/07/the-case-of-the-disappearing-element/
      segment.setAttribute('style', "transform: translate3d(" + translateX + "px, 0px, 0.00001px) scaleX(" + width / ELLIPSE_WIDTH_PX + ");");
    }
    /**
     * Gets the individual segment width.
     * @return {!Promise<number>}
     * @private
     */

  }, {
    key: "getSegmentWidth_",
    value: function getSegmentWidth_() {
      var _this3 = this;

      var nextEllipsisCount = this.getNextEllipsisCount_();
      var prevEllipsisCount = this.getPrevEllipsisCount_();
      var totalEllipsisWidth = (nextEllipsisCount + prevEllipsisCount) * (ELLIPSE_WIDTH_PX + SEGMENTS_MARGIN_PX);
      return this.getBarWidth_().then(function (barWidth) {
        var totalSegmentsWidth = barWidth - totalEllipsisWidth;
        return totalSegmentsWidth / Math.min(_this3.segmentCount_, MAX_SEGMENTS) - SEGMENTS_MARGIN_PX;
      });
    }
    /**
     * Gets width of the progress bar.
     * @return {!Promise<number>}
     * @private
     */

  }, {
    key: "getBarWidth_",
    value: function getBarWidth_() {
      var _this4 = this;

      return this.mutator_.measureElement(function () {
        return _this4.getRoot().
        /*OK*/
        getBoundingClientRect().width;
      });
    }
    /**
     * Gets the number of ellipsis that should appear to the "next" position of
     * the expanded segments.
     * @return {number}
     * @private
     */

  }, {
    key: "getNextEllipsisCount_",
    value: function getNextEllipsisCount_() {
      var nextPagesCount = this.segmentCount_ - (this.firstExpandedSegmentIndex_ + MAX_SEGMENTS);
      return nextPagesCount > 3 ? 3 : Math.max(nextPagesCount, 0);
    }
    /**
     * Gets the number of ellipsis that should appear to the "previous" position
     * of the expanded segments.
     * @return {number}
     * @private
     */

  }, {
    key: "getPrevEllipsisCount_",
    value: function getPrevEllipsisCount_() {
      return Math.min(3, this.firstExpandedSegmentIndex_);
    }
    /**
     * Checks if an index is past the MAX_SEGMENTS limit and updates the progress
     * bar accordingly.
     * @private
     */

  }, {
    key: "checkIndexForOverflow_",
    value: function checkIndexForOverflow_() {
      // Touching an ellipse on the "next" position of the expanded segments.
      if (this.activeSegmentIndex_ >= this.firstExpandedSegmentIndex_ + MAX_SEGMENTS) {
        var nextLimit = this.firstExpandedSegmentIndex_ + MAX_SEGMENTS + SEGMENT_INCREMENT - 1;
        this.firstExpandedSegmentIndex_ += nextLimit < this.segmentCount_ ? SEGMENT_INCREMENT : this.segmentCount_ - (this.firstExpandedSegmentIndex_ + MAX_SEGMENTS);
        this.render_();
      } else // Touching an ellipse on the "previous" position of the expanded segments.
        if (this.activeSegmentIndex_ < this.firstExpandedSegmentIndex_) {
          this.firstExpandedSegmentIndex_ -= this.firstExpandedSegmentIndex_ - SEGMENT_INCREMENT < 0 ? this.firstExpandedSegmentIndex_ : SEGMENT_INCREMENT;
          this.render_();
        }
    }
    /**
     * Reacts to RTL state updates and triggers the UI for RTL.
     * @param {boolean} rtlState
     * @private
     */

  }, {
    key: "onRtlStateUpdate_",
    value: function onRtlStateUpdate_(rtlState) {
      var _this5 = this;

      this.mutator_.mutateElement(this.getRoot(), function () {
        rtlState ? _this5.getRoot().setAttribute('dir', 'rtl') : _this5.getRoot().removeAttribute('dir');
      });
    }
    /**
     * Handles resize events.
     * @private
     */

  }, {
    key: "onResize_",
    value: function onResize_() {
      // We need to take into account both conditionals since we could've switched
      // from a screen that had an overflow to one that doesn't and viceversa.
      if (this.getRoot().classList.contains('i-amphtml-progress-bar-overflow') || this.segmentCount_ > MAX_SEGMENTS) {
        this.getInitialFirstExpandedSegmentIndex_(this.activeSegmentIndex_);
        this.render_(false
        /** shouldAnimate */
        );
      }
    }
    /**
     * Reacts to UI state updates.
     * @param {!UIType} uiState
     * @private
     */

  }, {
    key: "onUIStateUpdate_",
    value: function onUIStateUpdate_(uiState) {
      switch (uiState) {
        case _ampStoryStoreService.UIType.DESKTOP_FULLBLEED:
          MAX_SEGMENTS = 70;
          ELLIPSE_WIDTH_PX = 3;
          break;

        case _ampStoryStoreService.UIType.MOBILE:
          MAX_SEGMENTS = 20;
          ELLIPSE_WIDTH_PX = 2;
          break;

        case _ampStoryStoreService.UIType.DESKTOP_PANELS:
          MAX_SEGMENTS = 20;
          ELLIPSE_WIDTH_PX = 3;
          break;

        default:
          MAX_SEGMENTS = 20;
      }
    }
    /**
     * Builds a new segment element and appends it to the progress bar.
     *
     * @private
     */

  }, {
    key: "buildSegmentEl_",
    value: function buildSegmentEl_() {
      var segmentProgressBar = this.win_.document.createElement('li');
      segmentProgressBar.classList.add('i-amphtml-story-page-progress-bar');
      var segmentProgressValue = this.win_.document.createElement('div');
      segmentProgressValue.classList.add('i-amphtml-story-page-progress-value');
      segmentProgressBar.appendChild(segmentProgressValue);
      this.getRoot().appendChild(segmentProgressBar);
      this.segments_.push(segmentProgressBar);
    }
    /**
     * Clears the progress bar.
     */

  }, {
    key: "clear_",
    value: function clear_() {
      (0, _dom.removeChildren)((0, _log.devAssert)(this.root_));
      this.segmentIdMap_ = (0, _object.map)();
      this.segmentCount_ = 0;
    }
    /**
     * Adds a segment to the progress bar.
     *
     * @param {string} id The id of the segment.
     * @private
     */

  }, {
    key: "addSegment_",
    value: function addSegment_(id) {
      this.segmentIdMap_[id] = this.segmentCount_++;
      this.buildSegmentEl_();
    }
    /**
     * Gets the root element of the progress bar.
     *
     * @return {!Element}
     */

  }, {
    key: "getRoot",
    value: function getRoot() {
      return (0, _log.dev)().assertElement(this.root_);
    }
    /**
     * Validates that segment id exists.
     *
     * @param {string} segmentId The index to assert validity
     * @private
     */

  }, {
    key: "assertValidSegmentId_",
    value: function assertValidSegmentId_(segmentId) {
      (0, _log.devAssert)((0, _object.hasOwn)(this.segmentIdMap_, segmentId), 'Invalid segment-id passed to progress-bar');
    }
    /**
     * Updates a segment with its corresponding progress.
     *
     * @param {string} segmentId the id of the segment whos progress to change.
     * @param {number} progress A number from 0.0 to 1.0, representing the
     *     progress of the current segment.
     * @param {boolean} updateAllSegments Updates all of the segments.
     */

  }, {
    key: "updateProgress",
    value: function updateProgress(segmentId, progress, updateAllSegments) {
      var _this6 = this;

      if (updateAllSegments === void 0) {
        updateAllSegments = false;
      }

      this.segmentsAddedPromise_.then(function () {
        _this6.assertValidSegmentId_(segmentId);

        var segmentIndex = _this6.segmentIdMap_[segmentId];

        _this6.updateProgressByIndex_(segmentIndex, progress);

        // If updating progress for a new segment, update all the other progress
        // bar segments.
        if (_this6.activeSegmentIndex_ !== segmentIndex || updateAllSegments) {
          _this6.updateSegments_(segmentIndex, progress, _this6.activeSegmentIndex_, _this6.activeSegmentProgress_);
        }

        _this6.activeSegmentProgress_ = progress;
        _this6.activeSegmentIndex_ = segmentIndex;
        _this6.activeSegmentId_ = segmentId;

        if (_this6.segmentCount_ > MAX_SEGMENTS) {
          _this6.checkIndexForOverflow_();
        }
      });
    }
    /**
     * Snap the firstExpandedSegmentIndex_ to its most appropiate place, depending
     * where on the story the user is (could be in the middle of the story).
     * @param {number} segmentIndex
     * @private
     */

  }, {
    key: "getInitialFirstExpandedSegmentIndex_",
    value: function getInitialFirstExpandedSegmentIndex_(segmentIndex) {
      if (segmentIndex > MAX_SEGMENTS && segmentIndex + MAX_SEGMENTS < this.segmentCount_) {
        this.firstExpandedSegmentIndex_ = segmentIndex - segmentIndex % MAX_SEGMENTS;
      } else if (segmentIndex > MAX_SEGMENTS) {
        this.firstExpandedSegmentIndex_ = this.segmentCount_ - MAX_SEGMENTS;
      } else {
        this.firstExpandedSegmentIndex_ = 0;
      }
    }
    /**
     * Updates all the progress bar segments, and decides whether the update has
     * to be animated.
     *
     * @param {number} activeSegmentIndex
     * @param {number} activeSegmentProgress
     * @param {number} prevSegmentIndex
     * @param {number} prevSegmentProgress
     * @private
     */

  }, {
    key: "updateSegments_",
    value: function updateSegments_(activeSegmentIndex, activeSegmentProgress, prevSegmentIndex, prevSegmentProgress) {
      var shouldAnimatePreviousSegment = false;

      // Animating the transition from one full segment to another, which is the
      // most common case.
      if (prevSegmentProgress === 1 && activeSegmentProgress === 1) {
        shouldAnimatePreviousSegment = true;
      }

      // When navigating forward, animate the previous segment only if the
      // following one does not get fully filled.
      if (activeSegmentIndex > prevSegmentIndex && activeSegmentProgress !== 1) {
        shouldAnimatePreviousSegment = true;
      }

      // When navigating backward, animate the previous segment only if the
      // following one gets fully filled.
      if (prevSegmentIndex > activeSegmentIndex && activeSegmentProgress === 1) {
        shouldAnimatePreviousSegment = true;
      }

      for (var i = 0; i < this.segmentCount_; i++) {
        // Active segment already gets updated through update progress events
        // dispatched by its amp-story-page.
        if (i === activeSegmentIndex) {
          continue;
        }

        var progress = i < activeSegmentIndex ? 1 : 0;
        // Only animate the segment corresponding to the previous page, if needed.
        var withTransition = shouldAnimatePreviousSegment ? i === prevSegmentIndex : false;
        this.updateProgressByIndex_(i, progress, withTransition);
      }
    }
    /**
     * Updates styles to show progress to a corresponding segment.
     *
     * @param {number} segmentIndex The index of the progress bar segment whose progress should be
     *     changed.
     * @param {number} progress A number from 0.0 to 1.0, representing the
     *     progress of the current segment.
     * @param {boolean=} withTransition
     * @public
     */

  }, {
    key: "updateProgressByIndex_",
    value: function updateProgressByIndex_(segmentIndex, progress, withTransition) {
      if (withTransition === void 0) {
        withTransition = true;
      }

      // Offset the index by 1, since nth-child indices start at 1 while
      // JavaScript indices start at 0.
      var nthChildIndex = segmentIndex + 1;
      var progressEl = (0, _dom.scopedQuerySelector)(this.getRoot(), ".i-amphtml-story-page-progress-bar:nth-child(" + (0, _css.escapeCssSelectorNth)(nthChildIndex) + ") .i-amphtml-story-page-progress-value");
      this.mutator_.mutateElement((0, _log.devAssert)(progressEl), function () {
        var transition = 'none';

        if (withTransition) {
          // Using an eased transition only if filling the bar to 0 or 1.
          transition = progress === 1 || progress === 0 ? TRANSITION_EASE : TRANSITION_LINEAR;
        }

        (0, _style.setImportantStyles)((0, _log.devAssert)(progressEl), {
          'transform': (0, _style.scale)(progress + ",1"),
          'transition': transition
        });
      });
    }
  }], [{
    key: "create",
    value: function create(win, storyEl) {
      return new ProgressBar(win, storyEl);
    }
  }]);

  return ProgressBar;
}();

exports.ProgressBar = ProgressBar;

},{"../../../src/css":105,"../../../src/dom":106,"../../../src/log":123,"../../../src/services":133,"../../../src/style":138,"../../../src/utils/object":149,"../../../src/utils/rate-limit":151,"./../../../src/resolved-promise":129,"./amp-story-store-service":53,"./events":76,"./page-advancement":85}],88:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.renderPageDescription = renderPageDescription;
exports.extractTextContent = extractTextContent;

var _resolvedPromise2 = require("./../../../src/resolved-promise");

var _services = require("../../../src/services");

var _dom = require("../../../src/dom");

var _log = require("../../../src/log");

var _object = require("../../../src/utils/object");

var _string = require("../../../src/string");

/**
 * Copyright 2020 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Renders the page description, and videos title/alt attributes in the page.
 * @param {!./amp-story-page.AmpStoryPage} page
 * @param {!Array<?Element>} videos
 */
function renderPageDescription(page, videos) {
  var descriptionElId = "i-amphtml-story-" + page.element.id + "-description";
  var descriptionEl = (0, _dom.createElementWithAttributes)(page.win.document, 'div', (0, _object.dict)({
    'class': 'i-amphtml-story-page-description',
    'id': descriptionElId
  }));

  var append = function append(el) {
    page.mutateElement(function () {
      descriptionEl.appendChild(el);

      // Add descriptionEl to actual page if that hasn't happened yet.
      if (descriptionEl.parentNode) {
        return;
      }

      page.element.parentElement.insertBefore(descriptionEl, page.element.nextElementSibling);

      if (!page.element.getAttribute('aria-labelledby')) {
        page.element.setAttribute('aria-labelledby', descriptionElId);
      }
    });
  };

  var addTagToDescriptionEl = function addTagToDescriptionEl(tagName, text) {
    if (!text) {
      return;
    }

    var el = page.win.document.createElement(tagName);
    el.
    /* OK */
    textContent = text;
    append(el);
  };

  addTagToDescriptionEl('h2', page.element.getAttribute('title'));
  videos.forEach(function (videoEl) {
    addTagToDescriptionEl('p', videoEl.getAttribute('alt'));
    addTagToDescriptionEl('p', videoEl.getAttribute('title'));
    addTagToDescriptionEl('p', videoEl.getAttribute('aria-label'));
    fetchCaptions(page, videoEl).then(function (text) {
      addTagToDescriptionEl('p', text);
    });
  });
}

/**
 * Fetches captions for a video if available and returns them as plain
 * text.
 * @param {!./amp-story-page.AmpStoryPage} page
 * @param {!Element} videoEl
 * @return {!Promise<string|undefined>}
 */
function fetchCaptions(page, videoEl) {
  // Prefer the default track, otherwise pick the first.
  // Could be extended to prefer the language of the doc.
  var track = videoEl.querySelector('track[default]') || videoEl.querySelector('track');

  if (!track || !track.src) {
    return (0, _resolvedPromise2.resolvedPromise)();
  }

  return _services.Services.xhrFor(page.win).fetchText(track.src, {
    mode: 'cors'
  }).then(function (response) {
    if (!response.ok) {
      return;
    }

    return response.text().then(extractTextContent);
  });
}

/**
 * Extract the text content from a captions file.
 * @param {string} text
 * @return {string}
 * @visibleForTesting
 */
function extractTextContent(text) {
  text = text.trim();

  if ((0, _string.startsWith)(text, 'WEBVTT')) {
    return extractTextContentWebVtt(text);
  }

  if ((0, _string.includes)(text, 'http://www.w3.org/ns/ttml')) {
    return extractTextContentTtml(text);
  }

  return '';
}

/**
 * Extract the text content from a TTML file.
 * https://www.w3.org/TR/2018/REC-ttml2-20181108/
 * @param {string} text
 * @return {string}
 */
function extractTextContentTtml(text) {
  try {
    var doc = new DOMParser().parseFromString(text, 'text/xml');
    return doc.querySelector('body').textContent.replace(/[\s\n\r]+/g, ' ').trim();
  } catch (e) {
    (0, _log.dev)().error('TTML', e.message);
  }

  return '';
}

/**
 * Extract the text content from a WebVTT file.
 * https://www.w3.org/TR/webvtt1/
 * @param {string} text
 * @return {string}
 */
function extractTextContentWebVtt(text) {
  var queue = /^\d\d\:\d\d/;
  var seenQueue = false;
  text = text.split(/[\n\r]+/).filter(function (line) {
    var isQueue = queue.test(line);
    seenQueue = seenQueue || isQueue;

    // Filter queues and everything before.
    if (!seenQueue || isQueue) {
      return false;
    }

    // Filter comments.
    return !/^NOTE\s+/.test(line);
  }).map(function (line) {
    return line // Strip multiline indicators.
    .replace(/^- /, '');
  }).join(' ');
  // Super loose HTML parsing to get HTML entity parsing and removal
  // of WebVTT elements.
  var div = document.createElement('div');
  div.
  /* element is never added to DOM */
  innerHTML = text;
  return div.textContent;
}

},{"../../../src/dom":106,"../../../src/log":123,"../../../src/services":133,"../../../src/string":136,"../../../src/utils/object":149,"./../../../src/resolved-promise":129}],89:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.renderSimpleTemplate = renderSimpleTemplate;
exports.renderAsElement = renderAsElement;
exports.ElementDef = void 0;

var _localizedStrings = require("../../../src/localized-strings");

var _dom = require("../../../src/dom");

var _log = require("../../../src/log");

var _ampStoryLocalizationService = require("./amp-story-localization-service");

var _object = require("../../../src/utils/object");

var _types = require("../../../src/types");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-line no-unused-vars

/**
 * @typedef {{
 *   tag: string,
 *   attrs: (!JsonObject|undefined),
 *   localizedStringId: (!LocalizedStringId|undefined),
 *   unlocalizedString: (string|undefined),
 *   localizedLabelId: (!LocalizedStringId|undefined),
 *   children: (!Array<!ElementDef>|undefined),
 * }}
 */
var ElementDef;
exports.ElementDef = ElementDef;

/**
 * @param {!Document} doc
 * @param {!ElementDef|!Array<!ElementDef>} elementsDef
 * @return {!Node}
 */
function renderSimpleTemplate(doc, elementsDef) {
  if ((0, _types.isArray)(elementsDef)) {
    return renderMulti(doc,
    /** @type {!Array<!ElementDef>} */
    elementsDef);
  }

  return renderSingle(doc,
  /** @type {!ElementDef} */
  elementsDef);
}

/**
 * @param {!Document} doc
 * @param {!ElementDef} elementDef
 * @return {!Element}
 */
function renderAsElement(doc, elementDef) {
  return renderSingle(doc, elementDef);
}

/**
 * @param {!Document} doc
 * @param {!Array<!ElementDef>} elementsDef
 * @return {!Node}
 */
function renderMulti(doc, elementsDef) {
  var fragment = doc.createDocumentFragment();
  elementsDef.forEach(function (elementDef) {
    return fragment.appendChild(renderSingle(doc, elementDef));
  });
  return fragment;
}

/**
 * @param {!Document} doc
 * @param {!ElementDef} elementDef
 * @return {!Element}
 */
function renderSingle(doc, elementDef) {
  var el = (0, _object.hasOwn)(elementDef, 'attrs') ? (0, _dom.createElementWithAttributes)(doc, elementDef.tag,
  /** @type {!JsonObject} */
  elementDef.attrs) : doc.createElement(elementDef.tag);
  var hasLocalizedTextContent = (0, _object.hasOwn)(elementDef, 'localizedStringId');
  var hasLocalizedLabel = (0, _object.hasOwn)(elementDef, 'localizedLabelId');

  if (hasLocalizedTextContent || hasLocalizedLabel) {
    var localizationService = (0, _ampStoryLocalizationService.getLocalizationService)((0, _log.devAssert)(doc.body));
    (0, _log.devAssert)(localizationService, 'Could not retrieve LocalizationService.');

    if (hasLocalizedTextContent) {
      el.textContent = localizationService.getLocalizedString(
      /** @type {!LocalizedStringId} */
      elementDef.localizedStringId);
    }

    if (hasLocalizedLabel) {
      var labelString = localizationService.getLocalizedString(
      /** @type {!LocalizedStringId} */
      elementDef.localizedLabelId);

      if (labelString) {
        el.setAttribute('aria-label', labelString);
      }
    }
  }

  if ((0, _object.hasOwn)(elementDef, 'unlocalizedString')) {
    el.textContent = elementDef.unlocalizedString;
  }

  if ((0, _object.hasOwn)(elementDef, 'children')) {
    el.appendChild(renderMulti(doc,
    /** @type {!Array<!ElementDef>} */
    elementDef.children));
  }

  return el;
}

},{"../../../src/dom":106,"../../../src/localized-strings":122,"../../../src/log":123,"../../../src/types":139,"../../../src/utils/object":149,"./amp-story-localization-service":45}],90:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Sources = void 0;

var _utils = require("./utils");

var _dom = require("../../../src/dom");

var _types = require("../../../src/types");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Class handling HTMLMediaElements sources.
 */
var Sources = /*#__PURE__*/function () {
  /**
   * @param {?string=} srcAttr The 'src' attribute of the media element.
   * @param {!Array<!Element>=} srcEls Any child <source> tags of the
   *     media element.
   * @param {!Array<!Element>=} trackEls Any child <track> tags of the
   *     media element.
   */
  function Sources(srcAttr, srcEls, trackEls) {
    if (srcAttr === void 0) {
      srcAttr = null;
    }

    if (srcEls === void 0) {
      srcEls = [];
    }

    if (trackEls === void 0) {
      trackEls = [];
    }

    _classCallCheck(this, Sources);

    /** @private @const {?string} */
    this.srcAttr_ = srcAttr;

    /** @private @const {!Array<!Element>} */
    this.srcEls_ = srcEls;

    /** @private @const {!Array<!Element>} */
    this.trackEls_ = trackEls;
  }

  /**
   * Applies track tags to a specified element. This is done in a separate
   * method from the source tags, because we must wait for "loadedmetadata"
   * video event before doing this.
   * @param {!HTMLMediaElement} element The element to adopt the text tracks
   *     represented by this object.
   * @private
   */
  _createClass(Sources, [{
    key: "applyTracksToElement_",
    value: function applyTracksToElement_(element) {
      Array.prototype.forEach.call(this.trackEls_, function (trackEl) {
        var track = document.createElement('track');
        track.id = trackEl.id;
        track.kind = trackEl.kind;
        track.label = trackEl.label;
        track.srclang = trackEl.srclang;
        track.default = trackEl.default;
        track.src = trackEl.src;
        track.addEventListener('load', function () {
          track.mode = 'showing';
          element.textTracks[0].mode = 'showing';
        });
        element.appendChild(track);
      });
    }
    /**
     * Applies the src attribute and source tags to a specified element.
     * @param {!Window} win
     * @param {!HTMLMediaElement} element The element to adopt the sources
     *     represented by this object.
     */

  }, {
    key: "applyToElement",
    value: function applyToElement(win, element) {
      var _this = this;

      Sources.removeFrom(win, element);

      if (!this.srcAttr_) {
        element.removeAttribute('src');
      } else {
        element.setAttribute('src', this.srcAttr_);
      }

      Array.prototype.forEach.call(this.srcEls_, function (srcEl) {
        return element.appendChild(srcEl);
      });

      if (element.changedSources) {
        element.changedSources();
      }

      if (this.trackEls_.length > 0) {
        // Wait for "loadedmetadata" before adding tracks.
        // Firefox adds tracks, but does not toggle them on unless video metadata
        // is loaded first.
        if (element.readyState >= 1
        /* HAVE_METADATA */
        ) {
            this.applyTracksToElement_(element);
          } else {
          var addTracksHandler = function addTracksHandler() {
            element.removeEventListener('loadedmetadata', addTracksHandler);

            _this.applyTracksToElement_(element);
          };

          element.addEventListener('loadedmetadata', addTracksHandler);
        }
      }
    }
    /**
     * Removes and returns the sources from a specified element.
     * @param {!Window} win
     * @param {!Element} element The element whose sources should be removed and
     *     returned.
     * @return {!Sources} An object representing the sources of the specified
     *     element.
     */

  }], [{
    key: "removeFrom",
    value: function removeFrom(win, element) {
      var elementToUse = (0, _utils.ampMediaElementFor)(element) || element;
      var srcEl = null;

      // If the src attribute is specified, create a source element from it as it
      // prevents race conditions between amp-story and amp-video propagating or
      // removing attributes from amp-video/video elements.
      if (elementToUse.hasAttribute('src')) {
        srcEl = Sources.createSourceElement(win, elementToUse);
        elementToUse.removeAttribute('src');
      }

      var srcEls = (0, _types.toArray)(elementToUse.querySelectorAll('source'));
      srcEls.forEach(function (srcEl) {
        return (0, _dom.removeElement)(srcEl);
      });
      var trackEls = (0, _types.toArray)(elementToUse.querySelectorAll('track'));
      trackEls.forEach(function (trackEl) {
        return (0, _dom.removeElement)(trackEl);
      });
      // If the src attribute is present, browsers will follow it and ignore the
      // HTMLSourceElements. To ensure this behavior, drop the sources if the src
      // was specified.
      // cf: https://html.spec.whatwg.org/#concept-media-load-algorithm
      var sourcesToUse = srcEl ? [srcEl] : srcEls;
      return new Sources(null
      /** srcAttr */
      , sourcesToUse, trackEls);
    }
    /**
     * Creates a HTMLSourceElement from the element src attribute.
     * @param {!Window} win
     * @param {!Element} element
     * @return {!Element}
     */

  }, {
    key: "createSourceElement",
    value: function createSourceElement(win, element) {
      var srcEl = win.document.createElement('source');
      var srcAttr = element.getAttribute('src');
      srcEl.setAttribute('src', srcAttr);
      var origSrcAttr = element.getAttribute('amp-orig-src');

      if (origSrcAttr) {
        srcEl.setAttribute('amp-orig-src', origSrcAttr);
      }

      var typeAttr = element.getAttribute('type');

      if (typeAttr) {
        srcEl.setAttribute('type', typeAttr);
      }

      return srcEl;
    }
  }]);

  return Sources;
}();

exports.Sources = Sources;

},{"../../../src/dom":106,"../../../src/types":139,"./utils":93}],91:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.StoryAnalyticsService = exports.getAnalyticsService = exports.AdvancementMode = exports.StoryAnalyticsEvent = exports.ANALYTICS_TAG_NAME = void 0;

var _services = require("../../../src/services");

var _ampStoryStoreService = require("./amp-story-store-service");

var _dom = require("../../../src/dom");

var _variableService = require("./variable-service");

var _object = require("../../../src/utils/object");

var _service = require("../../../src/service");

var _analytics = require("../../../src/analytics");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {string} */
var ANALYTICS_TAG_NAME = '__AMP_ANALYTICS_TAG_NAME__';
exports.ANALYTICS_TAG_NAME = ANALYTICS_TAG_NAME;

/** @enum {string} */
var StoryAnalyticsEvent = {
  BOOKEND_CLICK: 'story-bookend-click',
  BOOKEND_ENTER: 'story-bookend-enter',
  BOOKEND_EXIT: 'story-bookend-exit',
  CLICK_THROUGH: 'story-click-through',
  FOCUS: 'story-focus',
  LAST_PAGE_VISIBLE: 'story-last-page-visible',
  OPEN: 'story-open',
  CLOSE: 'story-close',
  PAGE_ATTACHMENT_ENTER: 'story-page-attachment-enter',
  PAGE_ATTACHMENT_EXIT: 'story-page-attachment-exit',
  PAGE_VISIBLE: 'story-page-visible',
  INTERACTIVE: 'story-interactive',
  STORY_MUTED: 'story-audio-muted',
  STORY_UNMUTED: 'story-audio-unmuted'
};
exports.StoryAnalyticsEvent = StoryAnalyticsEvent;

/**
 * @enum {string}
 * Note: auto advance advancements should always be prefixed with "autoAdvance".
 */
var AdvancementMode = {
  GO_TO_PAGE: 'goToPageAction',
  AUTO_ADVANCE_TIME: 'autoAdvanceTime',
  AUTO_ADVANCE_MEDIA: 'autoAdvanceMedia',
  MANUAL_ADVANCE: 'manualAdvance',
  ADVANCE_TO_ADS: 'manualAdvanceFromAd',
  VIEWER_SELECT_PAGE: 'viewerSelectPage'
};
exports.AdvancementMode = AdvancementMode;

/** @typedef {!Object<string, !PageEventCountDef>} */
var EventsPerPageDef;

/** @typedef {!Object<string, number>} */
var PageEventCountDef;

/**
 * Util function to retrieve the analytics service. Ensures we can retrieve the
 * service synchronously from the amp-story codebase without running into race
 * conditions.
 * @param {!Window} win
 * @param {!Element} el
 * @return {!StoryAnalyticsService}
 */
var getAnalyticsService = function getAnalyticsService(win, el) {
  var service = _services.Services.storyAnalyticsService(win);

  if (!service) {
    service = new StoryAnalyticsService(win, el);
    (0, _service.registerServiceBuilder)(win, 'story-analytics', function () {
      return service;
    });
  }

  return service;
};

exports.getAnalyticsService = getAnalyticsService;

/**
 * Intermediate handler for amp-story specific analytics.
 */
var StoryAnalyticsService = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @param {!Element} element
   */
  function StoryAnalyticsService(win, element) {
    _classCallCheck(this, StoryAnalyticsService);

    /** @protected @const {!Window} */
    this.win_ = win;

    /** @private @const {!Element} */
    this.element_ = element;

    /** @const @private {!./variable-service.AmpStoryVariableService} */
    this.variableService_ = (0, _variableService.getVariableService)(win);

    /** @private {EventsPerPageDef} */
    this.pageEventsMap_ = (0, _object.map)();

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(win);
    this.initializeListeners_();
  }

  /** @private */
  _createClass(StoryAnalyticsService, [{
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.BOOKEND_STATE, function (isActive) {
        _this.triggerEvent(isActive ? StoryAnalyticsEvent.BOOKEND_ENTER : StoryAnalyticsEvent.BOOKEND_EXIT);
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CURRENT_PAGE_ID, function (pageId) {
        if (!pageId) {
          return;
        }

        _this.triggerEvent(StoryAnalyticsEvent.PAGE_VISIBLE);

        var pageIds = _this.storeService_.get(_ampStoryStoreService.StateProperty.PAGE_IDS);

        var pageIndex = _this.storeService_.get(_ampStoryStoreService.StateProperty.CURRENT_PAGE_INDEX);

        if (pageIndex === pageIds.length - 1) {
          _this.triggerEvent(StoryAnalyticsEvent.LAST_PAGE_VISIBLE);
        }
      }, true
      /* callToInitialize */
      );
    }
    /**
     * @param {!StoryAnalyticsEvent} eventType
     * @param {Element=} element
     */

  }, {
    key: "triggerEvent",
    value: function triggerEvent(eventType, element) {
      if (element === void 0) {
        element = null;
      }

      this.incrementPageEventCount_(eventType);
      (0, _analytics.triggerAnalyticsEvent)(this.element_, eventType, this.updateDetails(eventType, element));
    }
    /**
     * Updates event details.
     * @param {!StoryAnalyticsEvent} eventType
     * @param {Element=} element
     * @visibleForTesting
     * @return {!JsonObject}}
     */

  }, {
    key: "updateDetails",
    value: function updateDetails(eventType, element) {
      if (element === void 0) {
        element = null;
      }

      var details = {};
      var vars = this.variableService_.get();
      var pageId = vars['storyPageId'];

      if (this.pageEventsMap_[pageId][eventType] > 1) {
        details.repeated = true;
      }

      if (element) {
        details.tagName = element[ANALYTICS_TAG_NAME] || element.tagName.toLowerCase();
        Object.assign(vars, (0, _dom.getDataParamsFromAttributes)(element,
        /* computeParamNameFunc */
        undefined, /^vars(.+)/));
      }

      return (
        /** @type {!JsonObject} */
        _extends({
          eventDetails: details
        }, vars)
      );
    }
    /**
     * Keeps count of number of events emitted by page for an event type.
     * @param {!StoryAnalyticsEvent} eventType
     * @private
     */

  }, {
    key: "incrementPageEventCount_",
    value: function incrementPageEventCount_(eventType) {
      var vars = this.variableService_.get();
      var pageId = vars['storyPageId'];
      this.pageEventsMap_[pageId] = this.pageEventsMap_[pageId] || {};
      this.pageEventsMap_[pageId][eventType] = this.pageEventsMap_[pageId][eventType] || 0;
      this.pageEventsMap_[pageId][eventType]++;
    }
  }]);

  return StoryAnalyticsService;
}();

exports.StoryAnalyticsService = StoryAnalyticsService;

},{"../../../src/analytics":99,"../../../src/dom":106,"../../../src/service":130,"../../../src/services":133,"../../../src/utils/object":149,"./amp-story-store-service":53,"./variable-service":94}],92:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Toast = void 0;

var _services = require("../../../src/services");

var _dom = require("../../../src/dom");

var _types = require("../../../src/types");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @private @const {string} */
var TOAST_CLASSNAME = 'i-amphtml-story-toast';

/**
 * The 'alert' role assertively announces toast content to screen readers.
 * @private @const {string}
 * */
var TOAST_ROLE = 'alert';

/**
 * Should be higher than total animation time.
 * @private @const {number}
 */
var TOAST_VISIBLE_TIME_MS = 2600;

/**
 * UI notifications service, displaying a message to the user for a limited
 * amount of time.
 */
var Toast = /*#__PURE__*/function () {
  function Toast() {
    _classCallCheck(this, Toast);
  }

  _createClass(Toast, null, [{
    key: "show",

    /**
     * @param {!Element} storyEl
     * @param {!Node|string} childNodeOrText
     */
    value: function show(storyEl, childNodeOrText) {
      var win = (0, _types.toWin)(storyEl.ownerDocument.defaultView);
      var toast = (0, _dom.createElementWithAttributes)(win.document, 'div',
      /** @type {!JsonObject} */
      {
        'class': TOAST_CLASSNAME,
        'role': TOAST_ROLE
      });

      if (typeof childNodeOrText == 'string') {
        toast.textContent = childNodeOrText;
      } else {
        toast.appendChild(childNodeOrText);
      }

      storyEl.appendChild(toast);

      _services.Services.timerFor(win).delay(function () {
        return (0, _dom.removeElement)(toast);
      }, TOAST_VISIBLE_TIME_MS);
    }
  }]);

  return Toast;
}();

exports.Toast = Toast;

},{"../../../src/dom":106,"../../../src/services":133,"../../../src/types":139}],93:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.timeStrToMillis = timeStrToMillis;
exports.hasTapAction = hasTapAction;
exports.unscaledClientRect = unscaledClientRect;
exports.ampMediaElementFor = ampMediaElementFor;
exports.createShadowRootWithStyle = createShadowRootWithStyle;
exports.getRGBFromCssColorValue = getRGBFromCssColorValue;
exports.getTextColorForRGB = getTextColorForRGB;
exports.setAttributeInMutate = setAttributeInMutate;
exports.removeAttributeInMutate = removeAttributeInMutate;
exports.userAssertValidProtocol = userAssertValidProtocol;
exports.getSourceOriginForElement = getSourceOriginForElement;
exports.resolveImgSrc = resolveImgSrc;
exports.shouldShowStoryUrlInfo = shouldShowStoryUrlInfo;
exports.setTextBackgroundColor = setTextBackgroundColor;

var _services = require("../../../src/services");

var _dom = require("../../../src/dom");

var _shadowEmbed = require("../../../src/shadow-embed");

var _mode = require("../../../src/mode");

var _url = require("../../../src/url");

var _style = require("../../../src/style");

var _log = require("../../../src/log");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns millis as number if given a string(e.g. 1s, 200ms etc)
 * @param {string} time
 * @param {number=} fallbackMs Used when `time` is not a valid time string.
 * @return {number|undefined}
 */
function timeStrToMillis(time, fallbackMs) {
  if (fallbackMs === void 0) {
    fallbackMs = NaN;
  }

  var match = time.toLowerCase().match(/^([0-9\.]+)\s*(s|ms)$/);
  var num = match ? match[1] : undefined;
  var units = match ? match[2] : undefined;

  if (!match || match.length !== 3 || units !== 's' && units !== 'ms') {
    return fallbackMs;
  }

  return Math.round((units == 's' ? 1000 : 1) * parseFloat(num));
}

/**
 * Determines whether the specified element has an action for its on="tap:..."
 * handler.
 * @param {!Element} el
 * @return {boolean}
 */
function hasTapAction(el) {
  // There are better ways to determine this, but they're all bound to action
  // service race conditions. This is good enough for our use case.
  return el.hasAttribute('on') && !!el.getAttribute('on').match(/(^|;)\s*tap\s*:/);
}

/**
 * Calculates a client rect without applying scaling transformations.
 * Note: must be run in a vsync measure context.
 * @param {!Element} el
 * @return {!ClientRect}
 */
function unscaledClientRect(el) {
  var _el$getBoundingClient = el.
  /*OK*/
  getBoundingClientRect(),
      width = _el$getBoundingClient.width,
      height = _el$getBoundingClient.height,
      left = _el$getBoundingClient.left,
      top = _el$getBoundingClient.top;

  var scaleFactorX = width == 0 ? 1 : width / el.
  /*OK*/
  offsetWidth;
  var scaleFactorY = height == 0 ? 1 : height / el.
  /*OK*/
  offsetHeight;
  return (
    /** @type {!ClientRect} */
    {
      left: left / scaleFactorX,
      top: top / scaleFactorY,
      width: width / scaleFactorX,
      height: height / scaleFactorY
    }
  );
}

/**
 * Finds an amp-video/amp-audio ancestor.
 * @param {!Element} el
 * @return {?AmpElement}
 */
function ampMediaElementFor(el) {
  return (0, _dom.closestAncestorElementBySelector)(el, 'amp-video, amp-audio');
}

/**
 * Creates a shadow root for the provided container, and appends the element
 * along with its CSS.
 * @param  {!Element} container
 * @param  {!Element} element
 * @param  {string} css
 */
function createShadowRootWithStyle(container, element, css) {
  var style = self.document.createElement('style');
  style.
  /*OK*/
  textContent = css;
  var containerToUse = (0, _mode.getMode)().test ? container : (0, _shadowEmbed.createShadowRoot)(container);
  containerToUse.appendChild(style);
  containerToUse.appendChild(element);
}

/**
 * Parses the resolved CSS color property, that is always in the form of
 * `rgba(0, 0, 0, 1)` or `rgb(0, 0, 0)`, that can be retrieved using
 * `getComputedStyle`.
 * Returns an object containing the R, G, and B 8bit numbers.
 * @param  {string} cssValue
 * @return {!Object<string, number>}
 */
function getRGBFromCssColorValue(cssValue) {
  var regexPattern = /rgba?\((\d{1,3}), (\d{1,3}), (\d{1,3})/;

  if (!cssValue.match(regexPattern)) {
    (0, _log.user)().error('UTILS', 'getRGBFromCssColorValue expects a parameter in ' + ("the form of 'rgba(0, 0, 0, 1)' or 'rgb(0, 0, 0)' but got " + cssValue));
    // Returns a fallback value, to fail 'gracefully' in case a browser we don't
    // know about gave an unexpected value.
    return {
      r: 0,
      g: 0,
      b: 0
    };
  }

  var matches = regexPattern.exec(cssValue);
  return {
    r: Number(matches[1]),
    g: Number(matches[2]),
    b: Number(matches[3])
  };
}

/**
 * Returns the color, either black or white, that has the best contrast ratio
 * against the provided RGB 8bit values.
 * @param  {!Object<string, number>} rgb  ie: {r: 0, g: 0, b: 0}
 * @return {string} '#fff' or '#000'
 */
function getTextColorForRGB(rgb) {
  var r = rgb.r,
      g = rgb.g,
      b = rgb.b;

  // Calculates the relative luminance L.
  // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
  var getLinearRGBValue = function getLinearRGBValue(x) {
    // 8bit to sRGB.
    x /= 255;
    // Converts the gamma-compressed RGB values to linear RGB.
    return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  };

  var linearR = getLinearRGBValue(r);
  var linearG = getLinearRGBValue(g);
  var linearB = getLinearRGBValue(b);
  var L = 0.2126 * linearR + 0.7152 * linearG + 0.0722 * linearB;
  // Determines which one of the white and black text have a better contrast
  // ratio against the used background color.
  // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
  // @TODO(gmajoulet): Improve the text color for high contrast ratio.
  // 1 is L for #FFF, and 0 is L for #000.
  // (1 + 0.05) / (L + 0.05) > (L + 0.05) / (0 + 0.05) toggles for L = 0.179.
  return L > 0.179 ? '#000' : '#FFF';
}

/**
 * Sets given attribute to the given element in next `mutate` phase.
 * @param {!AMP.BaseElement} elementImpl
 * @param {string} name
 * @param {string=} opt_value
 */
function setAttributeInMutate(elementImpl, name, opt_value) {
  var value = opt_value || '';
  elementImpl.mutateElement(function () {
    elementImpl.element.setAttribute(name, value);
  });
}

/**
 * Removes given attribute from the given element in next `mutate` phase.
 * @param {!AMP.BaseElement} elementImpl
 * @param {string} name
 */
function removeAttributeInMutate(elementImpl, name) {
  elementImpl.mutateElement(function () {
    elementImpl.element.removeAttribute(name);
  });
}

/**
 * @param {!Element} element
 * @param {string|!Location} url
 */
function userAssertValidProtocol(element, url) {
  (0, _log.userAssert)(_services.Services.urlForDoc(element).isProtocolValid(url), 'Unsupported protocol for URL %s', url);
}

/**
 * Gets the origin url for elements that display a url. It
 * trims the protocol prefix and returns only the hostname of the origin.
 * @param {!Element} element
 * @param {string} url
 * @return {string}
 */
function getSourceOriginForElement(element, url) {
  var domainName;

  try {
    domainName = (0, _url.getSourceOrigin)(_services.Services.urlForDoc(element).parse(url));
    // Remove protocol prefix.
    domainName = _services.Services.urlForDoc(element).parse(domainName).hostname;
  } catch (e) {
    // Unknown path prefix in url.
    domainName = _services.Services.urlForDoc(element).parse(url).hostname;
  }

  return domainName;
}

/**
 * Resolves an image url and optimizes it if served from the cache.
 * @param {!Window} win
 * @param {string} url
 * @return {string}
 */
function resolveImgSrc(win, url) {
  var urlSrc = (0, _url.resolveRelativeUrl)(url, win.location);

  if ((0, _url.isProxyOrigin)(win.location.href)) {
    // TODO(Enriqe): add extra params for resized image, for example:
    // (/ii/w${width}/s)
    urlSrc = urlSrc.replace('/c/s/', '/i/s/');
  }

  return urlSrc;
}

/**
 * Whether a Story should show the URL info dialog.
 * @param {!../../../src/service/viewer-interface.ViewerInterface} viewer
 * @return {boolean}
 */
function shouldShowStoryUrlInfo(viewer) {
  var showStoryUrlInfo = viewer.getParam('showStoryUrlInfo');
  return showStoryUrlInfo ? showStoryUrlInfo !== '0' : viewer.isEmbedded();
}

/**
 * The attribute name for text background color
 * @private @const {string}
 */
var TEXT_BACKGROUND_COLOR_ATTRIBUTE_NAME = 'data-text-background-color';

/**
 * The selector for text background color
 * @private @const {string}
 */
var TEXT_BACKGROUND_COLOR_SELECTOR = "[" + TEXT_BACKGROUND_COLOR_ATTRIBUTE_NAME + "]";

/**
 * Styles text with a background color based on the value of
 * the data-text-background-color attribute
 * @param {!Element} element
 */
function setTextBackgroundColor(element) {
  var elementsToUpgradeStyles = (0, _dom.scopedQuerySelectorAll)(element, TEXT_BACKGROUND_COLOR_SELECTOR);
  Array.prototype.forEach.call(elementsToUpgradeStyles, function (el) {
    var color = el.getAttribute(TEXT_BACKGROUND_COLOR_ATTRIBUTE_NAME);
    (0, _style.setStyle)(el, 'background-color', color);
  });
}

},{"../../../src/dom":106,"../../../src/log":123,"../../../src/mode":124,"../../../src/services":133,"../../../src/shadow-embed":134,"../../../src/style":138,"../../../src/url":142}],94:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpStoryVariableService = exports.getVariableService = exports.AnalyticsVariable = exports.StoryVariableDef = void 0;

var _services = require("../../../src/services");

var _ampStoryStoreService = require("./amp-story-store-service");

var _object = require("../../../src/utils/object");

var _service = require("../../../src/service");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @typedef {!JsonObject}
 */
var StoryVariableDef;
exports.StoryVariableDef = StoryVariableDef;

/** @enum {string} */
var AnalyticsVariable = {
  BOOKEND_COMPONENT_POSITION: 'storyBookendComponentPosition',
  BOOKEND_COMPONENT_TYPE: 'storyBookendComponentType',
  BOOKEND_TARGET_HREF: 'storyBookendTargetHref',
  STORY_INTERACTIVE_ID: 'storyInteractiveId',
  STORY_INTERACTIVE_RESPONSE: 'storyInteractiveResponse',
  STORY_INTERACTIVE_TYPE: 'storyInteractiveType',
  STORY_PAGE_ID: 'storyPageId',
  STORY_PAGE_INDEX: 'storyPageIndex',
  STORY_PAGE_COUNT: 'storyPageCount',
  STORY_IS_MUTED: 'storyIsMuted',
  STORY_PROGRESS: 'storyProgress',
  STORY_PREVIOUS_PAGE_ID: 'storyPreviousPageId',
  STORY_ADVANCEMENT_MODE: 'storyAdvancementMode'
};
exports.AnalyticsVariable = AnalyticsVariable;

/**
 * Util function to retrieve the variable service. Ensures we can retrieve the
 * service synchronously from the amp-story codebase without running into race
 * conditions.
 * @param {!Window} win
 * @return {!AmpStoryVariableService}
 */
var getVariableService = function getVariableService(win) {
  var service = _services.Services.storyVariableService(win);

  if (!service) {
    service = new AmpStoryVariableService(win);
    (0, _service.registerServiceBuilder)(win, 'story-variable', function () {
      return service;
    });
  }

  return service;
};

exports.getVariableService = getVariableService;

/**
 * Variable service for amp-story.
 * Used for URL replacement service. See usage in src/url-replacements-impl.
 */
var AmpStoryVariableService = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   * @public
   */
  function AmpStoryVariableService(win) {
    var _dict;

    _classCallCheck(this, AmpStoryVariableService);

    /** @private {!StoryVariableDef} */
    this.variables_ = (0, _object.dict)((_dict = {}, _dict[AnalyticsVariable.BOOKEND_COMPONENT_POSITION] = null, _dict[AnalyticsVariable.BOOKEND_COMPONENT_TYPE] = null, _dict[AnalyticsVariable.BOOKEND_TARGET_HREF] = null, _dict[AnalyticsVariable.STORY_INTERACTIVE_ID] = null, _dict[AnalyticsVariable.STORY_INTERACTIVE_RESPONSE] = null, _dict[AnalyticsVariable.STORY_INTERACTIVE_TYPE] = null, _dict[AnalyticsVariable.STORY_PAGE_INDEX] = null, _dict[AnalyticsVariable.STORY_PAGE_ID] = null, _dict[AnalyticsVariable.STORY_PAGE_COUNT] = null, _dict[AnalyticsVariable.STORY_PROGRESS] = null, _dict[AnalyticsVariable.STORY_IS_MUTED] = null, _dict[AnalyticsVariable.STORY_PREVIOUS_PAGE_ID] = null, _dict[AnalyticsVariable.STORY_ADVANCEMENT_MODE] = null, _dict));

    /** @private @const {!./amp-story-store-service.AmpStoryStoreService} */
    this.storeService_ = (0, _ampStoryStoreService.getStoreService)(win);
    this.initializeListeners_();
  }

  /** @private */
  _createClass(AmpStoryVariableService, [{
    key: "initializeListeners_",
    value: function initializeListeners_() {
      var _this = this;

      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.PAGE_IDS, function (pageIds) {
        _this.variables_[AnalyticsVariable.STORY_PAGE_COUNT] = pageIds.length;
      });
      this.storeService_.subscribe(_ampStoryStoreService.StateProperty.CURRENT_PAGE_ID, function (pageId) {
        if (!pageId) {
          return;
        }

        _this.variables_[AnalyticsVariable.STORY_PREVIOUS_PAGE_ID] = _this.variables_[AnalyticsVariable.STORY_PAGE_ID];
        _this.variables_[AnalyticsVariable.STORY_PAGE_ID] = pageId;

        var pageIndex =
        /** @type {number} */
        _this.storeService_.get(_ampStoryStoreService.StateProperty.CURRENT_PAGE_INDEX);

        _this.variables_[AnalyticsVariable.STORY_PAGE_INDEX] = pageIndex;

        var numberOfPages = _this.storeService_.get(_ampStoryStoreService.StateProperty.PAGE_IDS).length;

        if (numberOfPages > 0) {
          _this.variables_[AnalyticsVariable.STORY_PROGRESS] = pageIndex / numberOfPages;
        }
      }, true
      /* callToInitialize */
      );
    }
    /**
     * Updates a variable with a new value
     * @param {string} name
     * @param {*} update
     */

  }, {
    key: "onVariableUpdate",
    value: function onVariableUpdate(name, update) {
      this.variables_[name] = update;
    }
    /**
     * @return {!StoryVariableDef}
     */

  }, {
    key: "get",
    value: function get() {
      // TODO(newmius): You should probably Object.freeze this in development.
      return this.variables_;
    }
  }]);

  return AmpStoryVariableService;
}();

exports.AmpStoryVariableService = AmpStoryVariableService;

},{"../../../src/service":130,"../../../src/services":133,"../../../src/utils/object":149,"./amp-story-store-service":53}],95:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.listen = listen;
exports.serializeMessage = serializeMessage;
exports.deserializeMessage = deserializeMessage;
exports.isAmpMessage = isAmpMessage;
exports.IframeTransportEvent = exports.MessageType = exports.CONSTANTS = void 0;

var _log = require("./log");

var _object = require("./utils/object");

var _eventHelperListen = require("./event-helper-listen");

var _json = require("./json");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @const */
var AMP_MESSAGE_PREFIX = 'amp-';
var CONSTANTS = {
  responseTypeSuffix: '-result',
  messageIdFieldName: 'messageId',
  payloadFieldName: 'payload',
  contentFieldName: 'content'
};
exports.CONSTANTS = CONSTANTS;

/** @enum {string} */
var MessageType = {
  // For amp-ad
  SEND_EMBED_STATE: 'send-embed-state',
  EMBED_STATE: 'embed-state',
  SEND_EMBED_CONTEXT: 'send-embed-context',
  EMBED_CONTEXT: 'embed-context',
  SEND_INTERSECTIONS: 'send-intersections',
  INTERSECTION: 'intersection',
  EMBED_SIZE: 'embed-size',
  EMBED_SIZE_CHANGED: 'embed-size-changed',
  EMBED_SIZE_DENIED: 'embed-size-denied',
  NO_CONTENT: 'no-content',
  GET_HTML: 'get-html',
  GET_CONSENT_STATE: 'get-consent-state',
  // For the frame to be placed in full overlay mode for lightboxes
  FULL_OVERLAY_FRAME: 'full-overlay-frame',
  FULL_OVERLAY_FRAME_RESPONSE: 'full-overlay-frame-response',
  CANCEL_FULL_OVERLAY_FRAME: 'cancel-full-overlay-frame',
  CANCEL_FULL_OVERLAY_FRAME_RESPONSE: 'cancel-full-overlay-frame-response',
  // For amp-inabox
  SEND_POSITIONS: 'send-positions',
  POSITION: 'position',
  // For amp-analytics' iframe-transport
  SEND_IFRAME_TRANSPORT_EVENTS: 'send-iframe-transport-events',
  IFRAME_TRANSPORT_EVENTS: 'iframe-transport-events',
  IFRAME_TRANSPORT_RESPONSE: 'iframe-transport-response',
  // For user-error-in-iframe
  USER_ERROR_IN_IFRAME: 'user-error-in-iframe'
};
exports.MessageType = MessageType;

/**
 * Listens for the specified event on the element.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function listen(element, eventType, listener, opt_evtListenerOpts) {
  return (0, _eventHelperListen.internalListenImplementation)(element, eventType, listener, opt_evtListenerOpts);
}

/**
 * Serialize an AMP post message. Output looks like:
 * 'amp-011481323099490{"type":"position","sentinel":"12345","foo":"bar"}'
 * @param {string} type
 * @param {string} sentinel
 * @param {JsonObject=} data
 * @param {?string=} rtvVersion
 * @return {string}
 */
function serializeMessage(type, sentinel, data, rtvVersion) {
  if (data === void 0) {
    data = (0, _object.dict)();
  }

  if (rtvVersion === void 0) {
    rtvVersion = null;
  }

  // TODO: consider wrap the data in a "data" field. { type, sentinal, data }
  var message = data;
  message['type'] = type;
  message['sentinel'] = sentinel;
  return AMP_MESSAGE_PREFIX + (rtvVersion || '') + JSON.stringify(message);
}

/**
 * Deserialize an AMP post message.
 * Returns null if it's not valid AMP message format.
 *
 * @param {*} message
 * @return {?JsonObject|undefined}
 */
function deserializeMessage(message) {
  if (!isAmpMessage(message)) {
    return null;
  }

  var startPos = message.indexOf('{');
  (0, _log.devAssert)(startPos != -1, 'JSON missing in %s', message);

  try {
    return (0, _json.parseJson)(message.substr(startPos));
  } catch (e) {
    (0, _log.dev)().error('MESSAGING', 'Failed to parse message: ' + message, e);
    return null;
  }
}

/**
 *  Returns true if message looks like it is an AMP postMessage
 *  @param {*} message
 *  @return {boolean}
 */
function isAmpMessage(message) {
  return typeof message == 'string' && message.indexOf(AMP_MESSAGE_PREFIX) == 0 && message.indexOf('{') != -1;
}

/** @typedef {{creativeId: string, message: string}} */
var IframeTransportEvent;
exports.IframeTransportEvent = IframeTransportEvent;

},{"./event-helper-listen":110,"./json":120,"./log":123,"./utils/object":149}],96:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.actionTrustToString = actionTrustToString;
exports.ActionTrust = exports.DEFAULT_ACTION = exports.RAW_OBJECT_ARGS_KEY = void 0;

var _log = require("./log");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Key string in an action arguments map for an unparsed object literal string.
 *
 * E.g. for the action in <p on="tap:AMP.setState({foo: 'bar'})",
 * then `args[RAW_OBJECT_ARGS_KEY]` is the string "{foo: 'bar'}".
 *
 * The action service delegates parsing of object literals to the corresponding
 * extension (in the example above, amp-bind).
 *
 * @see ./service/action-impl.ActionInfoDef
 * @const {string}
 */
var RAW_OBJECT_ARGS_KEY = '__AMP_OBJECT_STRING__';
exports.RAW_OBJECT_ARGS_KEY = RAW_OBJECT_ARGS_KEY;

/**
 * Identifier for an element's default action.
 *
 * @const {string}
 */
var DEFAULT_ACTION = 'activate';
exports.DEFAULT_ACTION = DEFAULT_ACTION;

/**
 * Corresponds to degree of user intent, i.e. events triggered with strong
 * user intent have high trust.
 *
 * @enum {number}
 */
var ActionTrust = {
  /**
   * Events that are triggered without a user gesture, or triggered by a user
   * gesture with weak intent (e.g. scroll) are "low trust".
   *
   * Actions that have low impact on the page's visual state should require
   * "low trust" (e.g. pausing a video).
   */
  LOW: 1,

  /**
   * Events that are triggered nearly immediately (up to a few seconds) after
   * a user gesture with strong intent (e.g. tap or swipe) are "default trust".
   *
   * Actions that can modify the page's visual state (e.g. content jumping)
   * should require "default trust". This is the default required trust level
   * for actions.
   */
  DEFAULT: 2,

  /**
   * Events that are triggered immediately after a user gesture with
   * strong intent (e.g. tap or swipe) are "high trust".
   *
   * There are no actions yet that require high trust.
   */
  HIGH: 3
};
exports.ActionTrust = ActionTrust;

/**
 * @param {!ActionTrust} actionTrust
 * @return {string}
 */
function actionTrustToString(actionTrust) {
  switch (actionTrust) {
    case ActionTrust.LOW:
      return 'low';

    case ActionTrust.HIGH:
      return 'high';

    default:
      (0, _log.devAssert)(actionTrust === ActionTrust.DEFAULT);
      return 'default';
  }
}

},{"./log":123}],97:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.AmpEvents = void 0;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Common AMP events.
 * @enum {string}
 */
var AmpEvents = {
  DOM_UPDATE: 'amp:dom-update',
  FORM_DIRTINESS_CHANGE: 'amp:form-dirtiness-change',
  FORM_VALUE_CHANGE: 'amp:form-value-change',
  VISIBILITY_CHANGE: 'amp:visibilitychange',
  // https://github.com/ampproject/amphtml/blob/master/ads/README.md#page-visibility
  // The following codes are only used for testing.
  // TODO(choumx): Move these to a separate enum so they can be DCE'd.
  ATTACHED: 'amp:attached',
  STUBBED: 'amp:stubbed',
  LOAD_START: 'amp:load-start',
  LOAD_END: 'amp:load-end',
  ERROR: 'amp:error',
  SIZE_CHANGED: 'amp:size-changed',
  UNLOAD: 'amp:unload'
};
exports.AmpEvents = AmpEvents;

},{}],98:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.toggleAmpdocFieForTesting = toggleAmpdocFieForTesting;
exports.isInAmpdocFieExperiment = isInAmpdocFieExperiment;
exports.EXPERIMENT_INFO_LIST = void 0;

var _experiments = require("./experiments");

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(#22733): Remove this file once "ampdoc-fie" is cleaned up.
var EXPERIMENT_ID = 'ampdoc-fie';

/**
 * @const {{experiment: string, control: string, branch: string}}
 */
var EXPERIMENT = {
  branch: EXPERIMENT_ID,
  control: '21066823',
  experiment: '21066824'
};

/**
 * @const {!Array<!./experiments.ExperimentInfo>}
 */
var EXPERIMENT_INFO_LIST = [{
  experimentId: EXPERIMENT_ID,
  isTrafficEligible: function isTrafficEligible() {
    return true;
  },
  branches: [EXPERIMENT.control, EXPERIMENT.experiment]
}];
exports.EXPERIMENT_INFO_LIST = EXPERIMENT_INFO_LIST;

/**
 * @param {!Window} win
 * @param {boolean} on
 * @visibleForTesting
 */
function toggleAmpdocFieForTesting(win, on) {
  (0, _experiments.forceExperimentBranch)(win, EXPERIMENT_ID, on ? EXPERIMENT.experiment : null);
}

/**
 * @param {!Window} win
 * @return {boolean}
 */
function isInAmpdocFieExperiment(win) {
  if (!(0, _experiments.isExperimentOn)(win, 'ampdoc-fie')) {
    return false;
  }

  (0, _experiments.randomlySelectUnsetExperiments)(win, EXPERIMENT_INFO_LIST);
  return (0, _experiments.getExperimentBranch)(win, EXPERIMENT_ID) === EXPERIMENT.experiment;
}

},{"./experiments":112}],99:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.triggerAnalyticsEvent = triggerAnalyticsEvent;

var _services = require("./services");

var _object = require("./utils/object");

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Helper method to trigger analytics event if amp-analytics is available.
 * TODO: Do not expose this function
 * @param {!Element} target
 * @param {string} eventType
 * @param {!JsonObject} vars A map of vars and their values.
 * @param {boolean} enableDataVars A boolean to indicate if data-vars-*
 * attribute value from target element should be included.
 */
function triggerAnalyticsEvent(target, eventType, vars, enableDataVars) {
  if (vars === void 0) {
    vars = (0, _object.dict)();
  }

  if (enableDataVars === void 0) {
    enableDataVars = true;
  }

  _services.Services.analyticsForDocOrNull(target).then(function (analytics) {
    if (!analytics) {
      return;
    }

    analytics.triggerEventForTarget(target, eventType, vars, enableDataVars);
  });
}

},{"./services":133,"./utils/object":149}],100:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.copyTextToClipboard = copyTextToClipboard;
exports.isCopyingToClipboardSupported = isCopyingToClipboardSupported;

var _dom = require("./dom");

var _style = require("./style");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param {!Window} win
 * @param {string} text
 * @return {boolean}
 */
function copyTextToClipboard(win, text) {
  var copySuccessful = false;
  var doc = win.document;
  var textarea = doc.createElement('textarea');
  (0, _style.setStyles)(textarea, {
    'position': 'fixed',
    'top': 0,
    'left': 0,
    'width': '50px',
    'height': '50px',
    'padding': 0,
    'border': 'none',
    'outline': 'none',
    'background': 'transparent'
  });
  textarea.value = text;
  textarea.readOnly = true;
  textarea.contentEditable = true;
  doc.body.appendChild(textarea);
  win.getSelection().removeAllRanges();
  textarea.
  /*OK*/
  focus();
  textarea.setSelectionRange(0, text.length);

  try {
    copySuccessful = doc.execCommand('copy');
  } catch (e) {// 🤷
  }

  (0, _dom.removeElement)(textarea);
  return copySuccessful;
}

/**
 * @param {!Document} doc
 * @return {boolean}
 */
function isCopyingToClipboardSupported(doc) {
  return doc.queryCommandSupported('copy');
}

},{"./dom":106,"./style":138}],101:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CommonSignals = void 0;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Commonly used signals across different elements and documents.
 * @enum {string}
 */
var CommonSignals = {
  /**
   * The element has been upgraded from ElementStub to its real implementation.
   */
  UPGRADED: 'upgraded',

  /**
   * The element has been built.
   */
  BUILT: 'built',

  /**
   * The element has started loading.
   * LOAD_START triggers at the start of the layoutCallback.
   */
  LOAD_START: 'load-start',

  /**
   * Rendering has been confirmed to have been started.
   * It is a signal to indicate meaningful display (e.g. text could be displayed
   * CSS is correctly installed/applied).
   *
   * Elements can optionally implement RENDER_START signal. (e.g. ad, shadowdoc)
   * if it want to define its own meaningful display time and toggle visibility.
   *
   * Simpler elements's RENDER_START can be equal to the start of the
   * buildCallback
   */
  RENDER_START: 'render-start',

  /**
   * The element has been loaded.
   * LOAD_END triggers at the end of the layoutCallback.
   *
   */
  LOAD_END: 'load-end',

  /**
   * The initial contents of an element/document/embed have been loaded.
   * INI_LOAD is an optional signal, implemented by ads, story, and elements
   * that consist of other resources.
   * It instructs that all critical resources has been loaded, and can be used
   * for more accurate visibility measurement.
   * When an element doesn't consist multiple child resources, LOAD_END signal
   * can be used to indicate resource load completion.
   * Note: Based on the implementation, INI_LOAD can trigger before or after
   * LOAD_END.
   */
  INI_LOAD: 'ini-load',

  /**
   * The element has been unlaid out.
   */
  UNLOAD: 'unload'
};
exports.CommonSignals = CommonSignals;

},{}],102:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.config = exports.urls = void 0;

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Allows for runtime configuration. Internally, the runtime should
 * use the src/config.js module for various constants. We can use the
 * AMP_CONFIG global to translate user-defined configurations to this
 * module.
 * @type {!Object<string, string>}
 */
var env = self.AMP_CONFIG || {};
var thirdPartyFrameRegex = (typeof env['thirdPartyFrameRegex'] == 'string' ? new RegExp(env['thirdPartyFrameRegex']) : env['thirdPartyFrameRegex']) || /^d-\d+\.ampproject\.net$/;
var cdnProxyRegex = (typeof env['cdnProxyRegex'] == 'string' ? new RegExp(env['cdnProxyRegex']) : env['cdnProxyRegex']) || /^https:\/\/([a-zA-Z0-9_-]+\.)?cdn\.ampproject\.org$/;

/**
 * Check for a custom URL definition in special <meta> tags. Note that this does
 * not allow for distinct custom URLs in AmpDocShadow instances. The shell is
 * allowed to define one set of custom URLs via AMP_CONFIG (recommended) or by
 * including <meta> tags in the shell <head>. Those custom URLs then apply to
 * all AMP documents loaded in the shell.
 * @param {string} name
 * @return {?string}
 * @private
 */
function getMetaUrl(name) {
  // Avoid exceptions in unit tests
  if (!self.document || !self.document.head) {
    return null;
  }

  // Disallow on proxy origins
  if (self.location && cdnProxyRegex.test(self.location.origin)) {
    return null;
  }

  var metaEl = self.document.head.
  /*OK*/
  querySelector("meta[name=\"" + name + "\"]");
  return metaEl && metaEl.getAttribute('content') || null;
}

/** @type {!Object<string, string|boolean|RegExp|Array<RegExp>>} */
var urls = {
  thirdParty: env['thirdPartyUrl'] || 'https://3p.ampproject.net',
  thirdPartyFrameHost: env['thirdPartyFrameHost'] || 'ampproject.net',
  thirdPartyFrameRegex: thirdPartyFrameRegex,
  cdn: env['cdnUrl'] || getMetaUrl('runtime-host') || 'https://cdn.ampproject.org',

  /* Note that cdnProxyRegex is only ever checked against origins
   * (proto://host[:port]) so does not need to consider path
   */
  cdnProxyRegex: cdnProxyRegex,
  localhostRegex: /^https?:\/\/localhost(:\d+)?$/,
  errorReporting: env['errorReportingUrl'] || 'https://us-central1-amp-error-reporting.cloudfunctions.net/r',
  betaErrorReporting: env['betaErrorReportingUrl'] || 'https://us-central1-amp-error-reporting.cloudfunctions.net/r-beta',
  localDev: env['localDev'] || false,

  /**
   * These domains are trusted with more sensitive viewer operations such as
   * propagating the referrer. If you believe your domain should be here,
   * file the issue on GitHub to discuss. The process will be similar
   * (but somewhat more stringent) to the one described in the [3p/README.md](
   * https://github.com/ampproject/amphtml/blob/master/3p/README.md)
   *
   * {!Array<!RegExp>}
   */
  trustedViewerHosts: [/(^|\.)google\.(com?|[a-z]{2}|com?\.[a-z]{2}|cat)$/, /(^|\.)gmail\.(com|dev)$/],
  // Optional fallback API if amp-geo is left unpatched
  geoApi: env['geoApiUrl'] || getMetaUrl('amp-geo-api')
};
exports.urls = urls;
var config = {
  urls: urls
};
exports.config = config;

},{}],103:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.CONSENT_STRING_TYPE = exports.CONSENT_POLICY_STATE = void 0;

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// This file will be imported by 3P scripts.

/**
 * Possible consent policy state to proceed with.
 * @enum {number}
 */
var CONSENT_POLICY_STATE = {
  // Enum value has external dependency. Please do not change existing value.
  // If new values are added, please notify the AMP for Ads team to assure
  // correct Real Time Config behavior is maintained for Fast Fetch.
  SUFFICIENT: 1,
  INSUFFICIENT: 2,
  UNKNOWN_NOT_REQUIRED: 3,
  UNKNOWN: 4
};
exports.CONSENT_POLICY_STATE = CONSENT_POLICY_STATE;

/**
 * Defines valid consent string types passed
 * in by consent iframe metadata.
 * @enum {number}
 */
var CONSENT_STRING_TYPE = {
  // Enum value has external dependency for metadata collection.
  // It is up to the vendor to interpret an undefined CONSENT_STRING_TYPE.
  TCF_V1: 1,
  TCF_V2: 2,
  US_PRIVACY_STRING: 3
};
exports.CONSENT_STRING_TYPE = CONSENT_STRING_TYPE;

},{}],104:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getConsentPolicyState = getConsentPolicyState;
exports.getConsentPolicySharedData = getConsentPolicySharedData;
exports.getConsentPolicyInfo = getConsentPolicyInfo;
exports.getConsentMetadata = getConsentMetadata;
exports.shouldBlockOnConsentByMeta = shouldBlockOnConsentByMeta;

var _consentState = require("./consent-state");

var _services = require("./services");

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a promise that resolve when all consent state the policy wait
 * for resolve. Or if consent service is not available.
 * @param {!Element|!ShadowRoot} element
 * @param {string=} policyId
 * @return {!Promise<?CONSENT_POLICY_STATE>}
 */
function getConsentPolicyState(element, policyId) {
  if (policyId === void 0) {
    policyId = 'default';
  }

  return _services.Services.consentPolicyServiceForDocOrNull(element).then(function (consentPolicy) {
    if (!consentPolicy) {
      return null;
    }

    return consentPolicy.whenPolicyResolved(
    /** @type {string} */
    policyId);
  });
}

/**
 * Returns a promise that resolves to a sharedData retrieved from consent
 * remote endpoint.
 * @param {!Element|!ShadowRoot} element
 * @param {string} policyId
 * @return {!Promise<?Object>}
 */
function getConsentPolicySharedData(element, policyId) {
  return _services.Services.consentPolicyServiceForDocOrNull(element).then(function (consentPolicy) {
    if (!consentPolicy) {
      return null;
    }

    return consentPolicy.getMergedSharedData(
    /** @type {string} */
    policyId);
  });
}

/**
 * @param {!Element|!ShadowRoot} element
 * @param {string} policyId
 * @return {!Promise<string>}
 */
function getConsentPolicyInfo(element, policyId) {
  // Return the stored consent string.
  return _services.Services.consentPolicyServiceForDocOrNull(element).then(function (consentPolicy) {
    if (!consentPolicy) {
      return null;
    }

    return consentPolicy.getConsentStringInfo(
    /** @type {string} */
    policyId);
  });
}

/**
 * @param {!Element|!ShadowRoot} element
 * @param {string} policyId
 * @return {!Promise<?Object|undefined>}
 */
function getConsentMetadata(element, policyId) {
  // Return the stored consent metadata.
  return _services.Services.consentPolicyServiceForDocOrNull(element).then(function (consentPolicy) {
    if (!consentPolicy) {
      return null;
    }

    return consentPolicy.getConsentMetadataInfo(
    /** @type {string} */
    policyId);
  });
}

/**
 * Determine if an element needs to be blocked by consent based on meta tags.
 * @param {*} element
 * @return {boolean}
 */
function shouldBlockOnConsentByMeta(element) {
  var ampdoc = element.getAmpDoc();
  var content = ampdoc.getMetaByName('amp-consent-blocking');

  if (!content) {
    return false;
  }

  // Handles whitespace
  content = content.toUpperCase().replace(/\s+/g, '');
  var contents =
  /** @type {Array<string>} */
  content.split(',');
  return contents.includes(element.tagName);
}

},{"./consent-state":103,"./services":133}],105:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.assertIsName = assertIsName;
exports.setScopeSelectorSupportedForTesting = setScopeSelectorSupportedForTesting;
exports.isScopeSelectorSupported = isScopeSelectorSupported;
exports.prependSelectorsWith = prependSelectorsWith;
exports.escapeCssSelectorIdent = escapeCssSelectorIdent;
exports.escapeCssSelectorNth = escapeCssSelectorNth;

var _cssEscape = require("../third_party/css-escape/css-escape");

var _log = require("./log");

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Asserts that name is just an alphanumeric word, and does not contain
 * advanced CSS selector features like attributes, psuedo-classes, class names,
 * nor ids.
 * @param {string} name
 */
function assertIsName(name) {
  (0, _log.devAssert)(/^[\w-]+$/.test(name));
}

/**
 * @type {boolean|undefined}
 */
var scopeSelectorSupported;

/**
 * @param {boolean|undefined} val
 * @visibleForTesting
 */
function setScopeSelectorSupportedForTesting(val) {
  scopeSelectorSupported = val;
}

/**
 * Test that the :scope selector is supported and behaves correctly.
 * @param {!Element} el
 * @return {boolean}
 */
function isScopeSelectorSupported(el) {
  if (scopeSelectorSupported !== undefined) {
    return scopeSelectorSupported;
  }

  return scopeSelectorSupported = testScopeSelector(el);
}

/**
 * Test that the :scope selector is supported and behaves correctly.
 * @param {!Element} el
 * @return {boolean}
 */
function testScopeSelector(el) {
  try {
    var doc = el.ownerDocument;
    var testElement = doc.createElement('div');
    var testChild = doc.createElement('div');
    testElement.appendChild(testChild);
    // NOTE(cvializ, #12383): Firefox's implementation is incomplete,
    // therefore we test actual functionality of`:scope` as well.
    return testElement.
    /*OK*/
    querySelector(':scope div') === testChild;
  } catch (e) {
    return false;
  }
}

/**
 * Prefixes a selector for ancestor selection. Splits in subselectors and
 * applies prefix to each.
 *
 * e.g.
 * ```
 *   prependSelectorsWith('div', '.i-amphtml-scoped');
 *   // => '.i-amphtml-scoped div'
 *   prependSelectorsWith('div, ul', ':scope');
 *   // => ':scope div, :scope ul'
 *   prependSelectorsWith('div, ul', 'article >');
 *   // => 'article > div, article > ul'
 * ```
 *
 * @param {string} selector
 * @param {string} distribute
 * @return {string}
 */
function prependSelectorsWith(selector, distribute) {
  return selector.replace(/^|,/g, "$&" + distribute + " ");
}

/**
 * Escapes an ident (ID or a class name) to be used as a CSS selector.
 *
 * See https://drafts.csswg.org/cssom/#serialize-an-identifier.
 *
 * @param {string} ident
 * @return {string}
 */
function escapeCssSelectorIdent(ident) {
  if (false) {
    return CSS.escape(ident);
  }

  return (0, _cssEscape.cssEscape)(ident);
}

/**
 * Escapes an ident in a way that can be used by :nth-child() psuedo-class.
 *
 * See https://github.com/w3c/csswg-drafts/issues/2306.
 *
 * @param {string|number} ident
 * @return {string}
 */
function escapeCssSelectorNth(ident) {
  var escaped = String(ident);
  // Ensure it doesn't close the nth-child psuedo class.
  (0, _log.devAssert)(escaped.indexOf(')') === -1);
  return escaped;
}

},{"../third_party/css-escape/css-escape":155,"./log":123}],106:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.waitForChild = waitForChild;
exports.waitForChildPromise = waitForChildPromise;
exports.waitForBodyOpen = waitForBodyOpen;
exports.waitForBodyOpenPromise = waitForBodyOpenPromise;
exports.removeElement = removeElement;
exports.removeChildren = removeChildren;
exports.copyChildren = copyChildren;
exports.insertAfterOrAtStart = insertAfterOrAtStart;
exports.insertAtStart = insertAtStart;
exports.addAttributesToElement = addAttributesToElement;
exports.createElementWithAttributes = createElementWithAttributes;
exports.isConnectedNode = isConnectedNode;
exports.rootNodeFor = rootNodeFor;
exports.isShadowRoot = isShadowRoot;
exports.closest = closest;
exports.closestNode = closestNode;
exports.closestAncestorElementBySelector = closestAncestorElementBySelector;
exports.ancestorElements = ancestorElements;
exports.ancestorElementsByTag = ancestorElementsByTag;
exports.childElement = childElement;
exports.childElements = childElements;
exports.lastChildElement = lastChildElement;
exports.childNodes = childNodes;
exports.childElementByAttr = childElementByAttr;
exports.lastChildElementByAttr = lastChildElementByAttr;
exports.childElementsByAttr = childElementsByAttr;
exports.childElementByTag = childElementByTag;
exports.childElementsByTag = childElementsByTag;
exports.matches = matches;
exports.elementByTag = elementByTag;
exports.scopedQuerySelector = scopedQuerySelector;
exports.scopedQuerySelectorAll = scopedQuerySelectorAll;
exports.getDataParamsFromAttributes = getDataParamsFromAttributes;
exports.hasNextNodeInDocumentOrder = hasNextNodeInDocumentOrder;
exports.templateContentClone = templateContentClone;
exports.iterateCursor = iterateCursor;
exports.openWindowDialog = openWindowDialog;
exports.isJsonScriptTag = isJsonScriptTag;
exports.isJsonLdScriptTag = isJsonLdScriptTag;
exports.isRTL = isRTL;
exports.escapeHtml = escapeHtml;
exports.tryFocus = tryFocus;
exports.isIframed = isIframed;
exports.isAmpElement = isAmpElement;
exports.whenUpgradedToCustomElement = whenUpgradedToCustomElement;
exports.fullscreenEnter = fullscreenEnter;
exports.fullscreenExit = fullscreenExit;
exports.isFullscreenElement = isFullscreenElement;
exports.isEnabled = isEnabled;
exports.domOrderComparator = domOrderComparator;
exports.toggleAttribute = toggleAttribute;
exports.getVerticalScrollbarWidth = getVerticalScrollbarWidth;
exports.UPGRADE_TO_CUSTOMELEMENT_RESOLVER = exports.UPGRADE_TO_CUSTOMELEMENT_PROMISE = void 0;

var _promise = require("./utils/promise");

var _css = require("./css");

var _log = require("./log");

var _object = require("./utils/object");

var _string = require("./string");

var _types = require("./types");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var HTML_ESCAPE_CHARS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};
var HTML_ESCAPE_REGEX = /(&|<|>|"|'|`)/g;

/** @const {string} */
var UPGRADE_TO_CUSTOMELEMENT_PROMISE = '__AMP_UPG_PRM';
exports.UPGRADE_TO_CUSTOMELEMENT_PROMISE = UPGRADE_TO_CUSTOMELEMENT_PROMISE;

/** @const {string} */
var UPGRADE_TO_CUSTOMELEMENT_RESOLVER = '__AMP_UPG_RES';
exports.UPGRADE_TO_CUSTOMELEMENT_RESOLVER = UPGRADE_TO_CUSTOMELEMENT_RESOLVER;

/**
 * Waits until the child element is constructed. Once the child is found, the
 * callback is executed.
 * @param {!Element} parent
 * @param {function(!Element):boolean} checkFunc
 * @param {function()} callback
 */
function waitForChild(parent, checkFunc, callback) {
  if (checkFunc(parent)) {
    callback();
    return;
  }

  /** @const {!Window} */
  var win = (0, _types.toWin)(parent.ownerDocument.defaultView);

  if (win.MutationObserver) {
    /** @const {MutationObserver} */
    var observer = new win.MutationObserver(function () {
      if (checkFunc(parent)) {
        observer.disconnect();
        callback();
      }
    });
    observer.observe(parent, {
      childList: true
    });
  } else {
    /** @const {number} */
    var interval = win.setInterval(function () {
      if (checkFunc(parent)) {
        win.clearInterval(interval);
        callback();
      }
    },
    /* milliseconds */
    5);
  }
}

/**
 * Waits until the child element is constructed. Once the child is found, the
 * promise is resolved.
 * @param {!Element} parent
 * @param {function(!Element):boolean} checkFunc
 * @return {!Promise}
 */
function waitForChildPromise(parent, checkFunc) {
  return new Promise(function (resolve) {
    waitForChild(parent, checkFunc, resolve);
  });
}

/**
 * Waits for document's body to be available and ready.
 * @param {!Document} doc
 * @param {function()} callback
 */
function waitForBodyOpen(doc, callback) {
  waitForChild(doc.documentElement, function () {
    return !!doc.body;
  }, callback);
}

/**
 * Waits for document's body to be available.
 * @param {!Document} doc
 * @return {!Promise}
 */
function waitForBodyOpenPromise(doc) {
  return new Promise(function (resolve) {
    return waitForBodyOpen(doc, resolve);
  });
}

/**
 * Removes the element.
 * @param {!Element} element
 */
function removeElement(element) {
  if (element.parentElement) {
    element.parentElement.removeChild(element);
  }
}

/**
 * Removes all child nodes of the specified element.
 * @param {!Element|!DocumentFragment} parent
 */
function removeChildren(parent) {
  while (parent.firstChild) {
    parent.removeChild(parent.firstChild);
  }
}

/**
 * Copies all children nodes of element "from" to element "to". Child nodes
 * are deeply cloned. Notice, that this method should be used with care and
 * preferably on smaller subtrees.
 * @param {!Element} from
 * @param {!Element|!DocumentFragment} to
 */
function copyChildren(from, to) {
  var frag = to.ownerDocument.createDocumentFragment();

  for (var n = from.firstChild; n; n = n.nextSibling) {
    frag.appendChild(n.cloneNode(true));
  }

  to.appendChild(frag);
}

/**
 * Insert the element in the root after the element named after or
 * if that is null at the beginning.
 * @param {!Element|!ShadowRoot} root
 * @param {!Element} element
 * @param {?Node=} after
 */
function insertAfterOrAtStart(root, element, after) {
  if (after === void 0) {
    after = null;
  }

  if (!after) {
    insertAtStart(root, element);
    return;
  }

  var before = after.nextSibling;
  root.insertBefore(element, before);
}

/**
 * Insert the element in the root after the element named after or
 * if that is null at the beginning.
 * @param {!Element|!ShadowRoot} root
 * @param {!Element} element
 */
function insertAtStart(root, element) {
  root.insertBefore(element, root.firstChild);
}

/**
 * Add attributes to an element.
 * @param {!Element} element
 * @param {!JsonObject<string, string>} attributes
 * @return {!Element} created element
 */
function addAttributesToElement(element, attributes) {
  for (var attr in attributes) {
    element.setAttribute(attr, attributes[attr]);
  }

  return element;
}

/**
 * Create a new element on document with specified tagName and attributes.
 * @param {!Document} doc
 * @param {string} tagName
 * @param {!JsonObject<string, string>} attributes
 * @return {!Element} created element
 */
function createElementWithAttributes(doc, tagName, attributes) {
  var element = doc.createElement(tagName);
  return addAttributesToElement(element, attributes);
}

/**
 * Returns true if node is connected (attached).
 * @param {!Node} node
 * @return {boolean}
 * @see https://dom.spec.whatwg.org/#connected
 */
function isConnectedNode(node) {
  var connected = node.isConnected;

  if (connected !== undefined) {
    return connected;
  }

  // "An element is connected if its shadow-including root is a document."
  var n = node;

  do {
    n = rootNodeFor(n);

    if (n.host) {
      n = n.host;
    } else {
      break;
    }
  } while (true);

  return n.nodeType === Node.DOCUMENT_NODE;
}

/**
 * Returns the root for a given node. Does not cross shadow DOM boundary.
 * @param {!Node} node
 * @return {!Node}
 */
function rootNodeFor(node) {
  if (Node.prototype.getRootNode) {
    // Type checker says `getRootNode` may return null.
    return node.getRootNode() || node;
  }

  var n;

  // Check isShadowRoot() is only needed for the polyfill case.
  for (n = node; !!n.parentNode && !isShadowRoot(n); n = n.parentNode) {}

  return n;
}

/**
 * Determines if value is actually a `ShadowRoot` node.
 * @param {*} value
 * @return {boolean}
 */
function isShadowRoot(value) {
  // TODO(#22733): remove in preference to dom's `rootNodeFor`.
  if (!value) {
    return false;
  }

  // Node.nodeType == DOCUMENT_FRAGMENT to speed up the tests. Unfortunately,
  // nodeType of DOCUMENT_FRAGMENT is used currently for ShadowRoot nodes.
  if (value.tagName == 'I-AMPHTML-SHADOW-ROOT') {
    return true;
  }

  return value.nodeType ==
  /* DOCUMENT_FRAGMENT */
  11 && Object.prototype.toString.call(value) === '[object ShadowRoot]';
}

/**
 * Finds the closest element that satisfies the callback from this element
 * up the DOM subtree.
 * @param {!Element} element
 * @param {function(!Element):boolean} callback
 * @param {Element=} opt_stopAt optional elemnt to stop the search at.
 * @return {?Element}
 */
function closest(element, callback, opt_stopAt) {
  for (var el = element; el && el !== opt_stopAt; el = el.parentElement) {
    if (callback(el)) {
      return el;
    }
  }

  return null;
}

/**
 * Finds the closest node that satisfies the callback from this node
 * up the DOM subtree.
 * @param {!Node} node
 * @param {function(!Node):boolean} callback
 * @return {?Node}
 */
function closestNode(node, callback) {
  for (var n = node; n; n = n.parentNode) {
    if (callback(n)) {
      return n;
    }
  }

  return null;
}

/**
 * Finds the closest ancestor element with the specified selector from this
 * element.
 * @param {!Element} element
 * @param {string} selector
 * @return {?Element} closest ancestor if found.
 */
function closestAncestorElementBySelector(element, selector) {
  if (element.closest) {
    return element.closest(selector);
  }

  return closest(element, function (el) {
    return matches(el, selector);
  });
}

/**
 * Finds all ancestor elements that satisfy predicate.
 * @param {!Element} child
 * @param {function(!Element):boolean} predicate
 * @return {!Array<!Element>}
 */
function ancestorElements(child, predicate) {
  var ancestors = [];

  for (var ancestor = child.parentElement; ancestor; ancestor = ancestor.parentElement) {
    if (predicate(ancestor)) {
      ancestors.push(ancestor);
    }
  }

  return ancestors;
}

/**
 * Finds all ancestor elements that has the specified tag name.
 * @param {!Element} child
 * @param {string} tagName
 * @return {!Array<!Element>}
 */
function ancestorElementsByTag(child, tagName) {
  (0, _css.assertIsName)(tagName);
  tagName = tagName.toUpperCase();
  return ancestorElements(child, function (el) {
    return el.tagName == tagName;
  });
}

/**
 * Finds the first child element that satisfies the callback.
 * @param {!Element} parent
 * @param {function(!Element):boolean} callback
 * @return {?Element}
 */
function childElement(parent, callback) {
  for (var child = parent.firstElementChild; child; child = child.nextElementSibling) {
    if (callback(child)) {
      return child;
    }
  }

  return null;
}

/**
 * Finds all child elements that satisfy the callback.
 * @param {!Element} parent
 * @param {function(!Element):boolean} callback
 * @return {!Array<!Element>}
 */
function childElements(parent, callback) {
  var children = [];

  for (var child = parent.firstElementChild; child; child = child.nextElementSibling) {
    if (callback(child)) {
      children.push(child);
    }
  }

  return children;
}

/**
 * Finds the last child element that satisfies the callback.
 * @param {!Element} parent
 * @param {function(!Element):boolean} callback
 * @return {?Element}
 */
function lastChildElement(parent, callback) {
  for (var child = parent.lastElementChild; child; child = child.previousElementSibling) {
    if (callback(child)) {
      return child;
    }
  }

  return null;
}

/**
 * Finds all child nodes that satisfy the callback.
 * These nodes can include Text, Comment and other child nodes.
 * @param {!Node} parent
 * @param {function(!Node):boolean} callback
 * @return {!Array<!Node>}
 */
function childNodes(parent, callback) {
  var nodes = [];

  for (var child = parent.firstChild; child; child = child.nextSibling) {
    if (callback(child)) {
      nodes.push(child);
    }
  }

  return nodes;
}

/**
 * Finds the first child element that has the specified attribute.
 * @param {!Element} parent
 * @param {string} attr
 * @return {?Element}
 */
function childElementByAttr(parent, attr) {
  (0, _css.assertIsName)(attr);
  return (
    /*OK*/
    scopedQuerySelector(parent, "> [" + attr + "]")
  );
}

/**
 * Finds the last child element that has the specified attribute.
 * @param {!Element} parent
 * @param {string} attr
 * @return {?Element}
 */
function lastChildElementByAttr(parent, attr) {
  (0, _css.assertIsName)(attr);
  return lastChildElement(parent, function (el) {
    return el.hasAttribute(attr);
  });
}

/**
 * Finds all child elements that has the specified attribute.
 * @param {!Element} parent
 * @param {string} attr
 * @return {!NodeList<!Element>}
 */
function childElementsByAttr(parent, attr) {
  (0, _css.assertIsName)(attr);
  return (
    /*OK*/
    scopedQuerySelectorAll(parent, "> [" + attr + "]")
  );
}

/**
 * Finds the first child element that has the specified tag name.
 * @param {!Element} parent
 * @param {string} tagName
 * @return {?Element}
 */
function childElementByTag(parent, tagName) {
  (0, _css.assertIsName)(tagName);
  return (
    /*OK*/
    scopedQuerySelector(parent, "> " + tagName)
  );
}

/**
 * Finds all child elements with the specified tag name.
 * @param {!Element} parent
 * @param {string} tagName
 * @return {!NodeList<!Element>}
 */
function childElementsByTag(parent, tagName) {
  (0, _css.assertIsName)(tagName);
  return (
    /*OK*/
    scopedQuerySelectorAll(parent, "> " + tagName)
  );
}

/**
 * Checks if the given element matches the selector
 * @param  {!Element} el The element to verify
 * @param  {string} selector The selector to check against
 * @return {boolean} True if the element matched the selector. False otherwise.
 */
function matches(el, selector) {
  var matcher = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector;

  if (matcher) {
    return matcher.call(el, selector);
  }

  return false;
}

/**
 * Finds the first descendant element with the specified name.
 * @param {!Element|!Document|!ShadowRoot} element
 * @param {string} tagName
 * @return {?Element}
 */
function elementByTag(element, tagName) {
  (0, _css.assertIsName)(tagName);
  return element.
  /*OK*/
  querySelector(tagName);
}

/**
 * Finds all elements that matche `selector`, scoped inside `root`
 * for user-agents that do not support native scoping.
 *
 * This method isn't required for modern builds, can be removed.
 *
 * @param {!Element} root
 * @param {string} selector
 * @return {!NodeList<!Element>}
 */
function scopedQuerySelectionFallback(root, selector) {
  var unique = 'i-amphtml-scoped';
  root.classList.add(unique);
  var scopedSelector = (0, _css.prependSelectorsWith)(selector, "." + unique);
  var elements = root.
  /*OK*/
  querySelectorAll(scopedSelector);
  root.classList.remove(unique);
  return elements;
}

/**
 * Finds the first element that matches `selector`, scoped inside `root`.
 * Note: in IE, this causes a quick mutation of the element's class list.
 * @param {!Element} root
 * @param {string} selector
 * @return {?Element}
 */
function scopedQuerySelector(root, selector) {
  if ((0, _css.isScopeSelectorSupported)(root)) {
    return root.
    /*OK*/
    querySelector((0, _css.prependSelectorsWith)(selector, ':scope'));
  }

  // Only IE.
  var fallbackResult = scopedQuerySelectionFallback(root, selector);
  return fallbackResult[0] === undefined ? null : fallbackResult[0];
}

/**
 * Finds every element that matches `selector`, scoped inside `root`.
 * Note: in IE, this causes a quick mutation of the element's class list.
 * @param {!Element} root
 * @param {string} selector
 * @return {!NodeList<!Element>}
 */
function scopedQuerySelectorAll(root, selector) {
  if ((0, _css.isScopeSelectorSupported)(root)) {
    return root.
    /*OK*/
    querySelectorAll((0, _css.prependSelectorsWith)(selector, ':scope'));
  }

  // Only IE.
  return scopedQuerySelectionFallback(root, selector);
}

/**
 * Returns element data-param- attributes as url parameters key-value pairs.
 * e.g. data-param-some-attr=value -> {someAttr: value}.
 * @param {!Element} element
 * @param {function(string):string=} opt_computeParamNameFunc to compute the
 *    parameter name, get passed the camel-case parameter name.
 * @param {!RegExp=} opt_paramPattern Regex pattern to match data attributes.
 * @return {!JsonObject}
 */
function getDataParamsFromAttributes(element, opt_computeParamNameFunc, opt_paramPattern) {
  var computeParamNameFunc = opt_computeParamNameFunc || function (key) {
    return key;
  };

  var dataset = element.dataset;
  var params = (0, _object.dict)();
  var paramPattern = opt_paramPattern ? opt_paramPattern : /^param(.+)/;

  for (var key in dataset) {
    var _matches = key.match(paramPattern);

    if (_matches) {
      var param = _matches[1][0].toLowerCase() + _matches[1].substr(1);

      params[computeParamNameFunc(param)] = dataset[key];
    }
  }

  return params;
}

/**
 * Whether the element have a next node in the document order.
 * This means either:
 *  a. The element itself has a nextSibling.
 *  b. Any of the element ancestors has a nextSibling.
 * @param {!Element} element
 * @param {?Node} opt_stopNode
 * @return {boolean}
 */
function hasNextNodeInDocumentOrder(element, opt_stopNode) {
  var currentElement = element;

  do {
    if (currentElement.nextSibling) {
      return true;
    }
  } while ((currentElement = currentElement.parentNode) && currentElement != opt_stopNode);

  return false;
}

/**
 * Returns a clone of the content of a template element.
 *
 * Polyfill to replace .content access for browsers that do not support
 * HTMLTemplateElements natively.
 *
 * @param {!HTMLTemplateElement|!Element} template
 * @return {!DocumentFragment}
 */
function templateContentClone(template) {
  if ('content' in template) {
    return template.content.cloneNode(true);
  } else {
    var content = template.ownerDocument.createDocumentFragment();
    copyChildren(template, content);
    return content;
  }
}

/**
 * Iterate over an array-like.
 * Test cases: https://jsbench.github.io/#f638cacc866a1b2d6e517e6cfa900d6b
 * @param {!IArrayLike<T>} iterable
 * @param {function(T, number)} cb
 * @template T
 */
function iterateCursor(iterable, cb) {
  var length = iterable.length;

  for (var i = 0; i < length; i++) {
    cb(iterable[i], i);
  }
}

/**
 * This method wraps around window's open method. It first tries to execute
 * `open` call with the provided target and if it fails, it retries the call
 * with the `_top` target. This is necessary given that in some embedding
 * scenarios, such as iOS' WKWebView, navigation to `_blank` and other targets
 * is blocked by default.
 *
 * @param {!Window} win
 * @param {string} url
 * @param {string} target
 * @param {string=} opt_features
 * @return {?Window}
 */
function openWindowDialog(win, url, target, opt_features) {
  // Try first with the specified target. If we're inside the WKWebView or
  // a similar environments, this method is expected to fail by default for
  // all targets except `_top`.
  var res;

  try {
    res = win.open(url, target, opt_features);
  } catch (e) {
    (0, _log.dev)().error('DOM', 'Failed to open url on target: ', target, e);
  }

  // Then try with `_top` target.
  if (!res && target != '_top' && !(0, _string.includes)(opt_features || '', 'noopener')) {
    res = win.open(url, '_top');
  }

  return res;
}

/**
 * Whether the element is a script tag with application/json type.
 * @param {!Element} element
 * @return {boolean}
 */
function isJsonScriptTag(element) {
  return element.tagName == 'SCRIPT' && element.hasAttribute('type') && element.getAttribute('type').toUpperCase() == 'APPLICATION/JSON';
}

/**
 * Whether the element is a script tag with application/json type.
 * @param {!Element} element
 * @return {boolean}
 */
function isJsonLdScriptTag(element) {
  return element.tagName == 'SCRIPT' && element.getAttribute('type').toUpperCase() == 'APPLICATION/LD+JSON';
}

/**
 * Whether the page's direction is right to left or not.
 * @param {!Document} doc
 * @return {boolean}
 */
function isRTL(doc) {
  var dir = doc.body.getAttribute('dir') || doc.documentElement.getAttribute('dir') || 'ltr';
  return dir == 'rtl';
}

/**
 * Escapes `<`, `>` and other HTML charcaters with their escaped forms.
 * @param {string} text
 * @return {string}
 */
function escapeHtml(text) {
  if (!text) {
    return text;
  }

  return text.replace(HTML_ESCAPE_REGEX, escapeHtmlChar);
}

/**
 * @param {string} c
 * @return {string}
 */
function escapeHtmlChar(c) {
  return HTML_ESCAPE_CHARS[c];
}

/**
 * Tries to focus on the given element; fails silently if browser throws an
 * exception.
 * @param {!Element} element
 */
function tryFocus(element) {
  try {
    element.
    /*OK*/
    focus();
  } catch (e) {// IE <= 7 may throw exceptions when focusing on hidden items.
  }
}

/**
 * Whether the given window is in an iframe or not.
 * @param {!Window} win
 * @return {boolean}
 */
function isIframed(win) {
  return win.parent && win.parent != win;
}

/**
 * Determines if this element is an AMP element
 * @param {!Element} element
 * @return {boolean}
 */
function isAmpElement(element) {
  var tag = element.tagName;
  // Use prefix to recognize AMP element. This is necessary because stub
  // may not be attached yet.
  return (0, _string.startsWith)(tag, 'AMP-') && // Some "amp-*" elements are not really AMP elements. :smh:
  !(tag == 'AMP-STICKY-AD-TOP-PADDING' || tag == 'AMP-BODY');
}

/**
 * Return a promise that resolve when an AMP element upgrade from HTMLElement
 * to CustomElement
 * @param {!Element} element
 * @return {!Promise<!Element>}
 */
function whenUpgradedToCustomElement(element) {
  (0, _log.devAssert)(isAmpElement(element), 'element is not AmpElement');

  if (element.createdCallback) {
    // Element already is CustomElement;
    return Promise.resolve(element);
  }

  // If Element is still HTMLElement, wait for it to upgrade to customElement
  // Note: use pure string to avoid obfuscation between versions.
  if (!element[UPGRADE_TO_CUSTOMELEMENT_PROMISE]) {
    var deferred = new _promise.Deferred();
    element[UPGRADE_TO_CUSTOMELEMENT_PROMISE] = deferred.promise;
    element[UPGRADE_TO_CUSTOMELEMENT_RESOLVER] = deferred.resolve;
  }

  return element[UPGRADE_TO_CUSTOMELEMENT_PROMISE];
}

/**
 * Replacement for `Element.requestFullscreen()` method.
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullscreen
 * @param {!Element} element
 */
function fullscreenEnter(element) {
  var requestFs = element.requestFullscreen || element.requestFullScreen || element.webkitRequestFullscreen || element.webkitEnterFullscreen || element.msRequestFullscreen || element.mozRequestFullScreen;

  if (requestFs) {
    requestFs.call(element);
  }
}

/**
 * Replacement for `Document.exitFullscreen()` method.
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/exitFullscreen
 * @param {!Element} element
 */
function fullscreenExit(element) {
  var elementBoundExit = element.cancelFullScreen || element.exitFullscreen || element.webkitExitFullscreen || element.webkitCancelFullScreen || element.mozCancelFullScreen || element.msExitFullscreen;

  if (elementBoundExit) {
    elementBoundExit.call(element);
    return;
  }

  var ownerDocument = element.ownerDocument;

  if (!ownerDocument) {
    return;
  }

  var docBoundExit = ownerDocument.cancelFullScreen || ownerDocument.exitFullscreen || ownerDocument.webkitExitFullscreen || ownerDocument.webkitCancelFullScreen || ownerDocument.mozCancelFullScreen || ownerDocument.msExitFullscreen;

  if (docBoundExit) {
    docBoundExit.call(ownerDocument);
  }
}

/**
 * Replacement for `Document.fullscreenElement`.
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/fullscreenElement
 * @param {!Element} element
 * @return {boolean}
 */
function isFullscreenElement(element) {
  var webkitDisplayingFullscreen = element.webkitDisplayingFullscreen;

  if (webkitDisplayingFullscreen !== undefined) {
    return webkitDisplayingFullscreen;
  }

  var ownerDocument = element.ownerDocument;

  if (!ownerDocument) {
    return false;
  }

  var fullscreenElement = ownerDocument.fullscreenElement || ownerDocument.webkitFullscreenElement || ownerDocument.mozFullScreenElement || ownerDocument.webkitCurrentFullScreenElement;
  return fullscreenElement == element;
}

/**
 * Returns true if node is not disabled.
 *
 * IE8 can return false positives, see {@link matches}.
 * @param {!Element} element
 * @return {boolean}
 * @see https://www.w3.org/TR/html5/forms.html#concept-fe-disabled
 */
function isEnabled(element) {
  return !(element.disabled || matches(element, ':disabled'));
}

/**
 * A sorting comparator that sorts elements in DOM tree order.
 * A first sibling is sorted to be before its nextSibling.
 * A parent node is sorted to be before a child.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
 *
 * @param {!Element} element1
 * @param {!Element} element2
 * @return {number}
 */
function domOrderComparator(element1, element2) {
  if (element1 === element2) {
    return 0;
  }

  var pos = element1.compareDocumentPosition(element2);
  var precedingOrContains = Node.DOCUMENT_POSITION_PRECEDING | Node.DOCUMENT_POSITION_CONTAINS;

  // if fe2 is preceding or contains fe1 then, fe1 is after fe2
  if (pos & precedingOrContains) {
    return 1;
  }

  // if fe2 is following or contained by fe1, then fe1 is before fe2
  return -1;
}

/**
 * Like `Element.prototype.toggleAttribute`. This either toggles an attribute
 * on by adding an attribute with an empty value, or toggles it off by removing
 * the attribute. This does not mutate the element if the new state matches
 * the existing state.
 * @param {!Element} element An element to toggle the attribute for.
 * @param {string} name The name of the attribute.
 * @param {boolean=} forced Whether the attribute should be forced on/off. If
 *    not specified, it will be toggled from the current state.
 * @return {boolean} Whether or not the element now has the attribute.
 */
function toggleAttribute(element, name, forced) {
  var hasAttribute = element.hasAttribute(name);
  var enabled = forced !== undefined ? forced : !hasAttribute;

  if (enabled !== hasAttribute) {
    if (enabled) {
      element.setAttribute(name, '');
    } else {
      element.removeAttribute(name);
    }
  }

  return enabled;
}

/**
 * @param {!Window} win
 * @return {number} The width of the vertical scrollbar, in pixels.
 */
function getVerticalScrollbarWidth(win) {
  var documentElement = win.document.documentElement;
  var windowWidth = win.
  /*OK*/
  innerWidth;
  var documentWidth = documentElement.
  /*OK*/
  clientWidth;
  return windowWidth - documentWidth;
}

},{"./css":105,"./log":123,"./string":136,"./types":139,"./utils/object":149,"./utils/promise":150}],107:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getElementService = getElementService;
exports.getElementServiceIfAvailable = getElementServiceIfAvailable;
exports.getElementServiceForDoc = getElementServiceForDoc;
exports.getElementServiceIfAvailableForDoc = getElementServiceIfAvailableForDoc;
exports.getElementServiceIfAvailableForDocInEmbedScope = getElementServiceIfAvailableForDocInEmbedScope;
exports.extensionScriptsInNode = extensionScriptsInNode;
exports.isExtensionScriptInNode = isExtensionScriptInNode;

var _resolvedPromise2 = require("./resolved-promise");

var dom = _interopRequireWildcard(require("./dom"));

var _service = require("./service");

var _types = require("./types");

var _log = require("./log");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a promise for a service for the given id and window. Also expects an
 * element that has the actual implementation. The promise resolves when the
 * implementation loaded. Users should typically wrap this as a special purpose
 * function (e.g. Services.viewportForDoc(...)) for type safety and because the
 * factory should not be passed around.
 * @param {!Window} win
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an element,
 *     not the extension.
 * @return {!Promise<*>}
 */
function getElementService(win, id, extension, opt_element) {
  return getElementServiceIfAvailable(win, id, extension, opt_element).then(function (service) {
    return assertService(service, id, extension);
  });
}

/**
 * Same as getElementService but produces null if the given element is not
 * actually available on the current page.
 * @param {!Window} win
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an
 *     element, not the extension.
 * @return {!Promise<?Object>}
 */
function getElementServiceIfAvailable(win, id, extension, opt_element) {
  var s = (0, _service.getServicePromiseOrNull)(win, id);

  if (s) {
    return (
      /** @type {!Promise<?Object>} */
      s
    );
  }

  return getElementServicePromiseOrNull(win, id, extension, opt_element);
}

/**
 * @param {!Window} win
 * @param {string} elementName Name of an extended custom element.
 * @return {boolean} Whether this element is scheduled to be loaded.
 */
function isElementScheduled(win, elementName) {
  // Set in custom-element.js
  if (!win.__AMP_EXTENDED_ELEMENTS) {
    return false;
  }

  return !!win.__AMP_EXTENDED_ELEMENTS[elementName];
}

/**
 * Returns a promise for a service for the given id and window. Also expects an
 * element that has the actual implementation. The promise resolves when the
 * implementation loaded. Users should typically wrap this as a special purpose
 * function (e.g. Services.viewportForDoc(...)) for type safety and because the
 * factory should not be passed around.
 * @param {!Element|!ShadowRoot} element
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an element,
 *     not the extension.
 * @return {!Promise<*>}
 */
function getElementServiceForDoc(element, id, extension, opt_element) {
  return getElementServiceIfAvailableForDoc(element, id, extension, opt_element).then(function (service) {
    return assertService(service, id, extension);
  });
}

/**
 * Same as getElementService but produces null if the given element is not
 * actually available on the current page.
 * @param {!Element|!ShadowRoot} element
 * @param {string} id of the service.
 * @param {string} extension Name of the custom extension that provides the
 *     implementation of this service.
 * @param {boolean=} opt_element Whether this service is provided by an
 *     element, not the extension.
 * @return {!Promise<?Object>}
 */
function getElementServiceIfAvailableForDoc(element, id, extension, opt_element) {
  var s = (0, _service.getServicePromiseOrNullForDoc)(element, id);

  if (s) {
    return (
      /** @type {!Promise<?Object>} */
      s
    );
  }

  var ampdoc = (0, _service.getAmpdoc)(element);
  return ampdoc.waitForBodyOpen().then(function () {
    return waitForExtensionIfPresent(ampdoc.win, extension, ampdoc.win.document.head);
  }).then(function () {
    // If this service is provided by an element, then we can't depend on
    // the service (they may not use the element).
    if (opt_element) {
      return (0, _service.getServicePromiseOrNullForDoc)(element, id);
    } else if (isElementScheduled(ampdoc.win, extension)) {
      return (0, _service.getServicePromiseForDoc)(element, id);
    }

    return null;
  });
}

/**
 * Returns a promise for service for the given id in the embed scope of
 * a given element, if it exists. Falls back to ampdoc scope if the element
 * is not embedded.
 *
 * @param {!Element|!ShadowRoot} element
 * @param {string} id of the service.
 * @param {string} extension Name of the custom element that provides
 *     the implementation of this service.
 * @return {!Promise<?Object>}
 */
function getElementServiceIfAvailableForDocInEmbedScope(element, id, extension) {
  var s = (0, _service.getExistingServiceForDocInEmbedScope)(element, id);

  if (s) {
    return (
      /** @type {!Promise<?Object>} */
      Promise.resolve(s)
    );
  }

  var win = (0, _types.toWin)(element.ownerDocument.defaultView);
  var topWin = (0, _service.getTopWindow)(win);

  // In embeds, doc services are stored on the embed window.
  if (win !== topWin) {
    return getElementServicePromiseOrNull(win, id, extension);
  } else {
    // Only fallback to element's ampdoc (top-level) if not embedded.
    return getElementServiceIfAvailableForDoc(element, id, extension);
  }
}

/**
 * Throws user error if `service` is null.
 * @param {Object} service
 * @param {string} id
 * @param {string} extension
 * @return {!Object}
 * @private
 * @closurePrimitive {asserts.matchesReturn}
 */
function assertService(service, id, extension) {
  return (
    /** @type {!Object} */
    (0, _log.userAssert)(service, 'Service %s was requested to be provided through %s, ' + 'but %s is not loaded in the current page. To fix this ' + 'problem load the JavaScript file for %s in this page.', id, extension, extension, extension)
  );
}

/**
 * Get list of all the extension JS files.
 * @param {HTMLHeadElement|Element|ShadowRoot} head
 * @return {!Array<string>}
 */
function extensionScriptsInNode(head) {
  // ampdoc.getHeadNode() can return null.
  if (!head) {
    return [];
  }

  var scripts = {};
  // Note: Some extensions don't have [custom-element] or [custom-template]
  // e.g. amp-viewer-integration.
  var list = head.querySelectorAll('script[custom-element],script[custom-template]');

  for (var i = 0; i < list.length; i++) {
    var script = list[i];
    var name = script.getAttribute('custom-element') || script.getAttribute('custom-template');
    scripts[name] = true;
  }

  return Object.keys(scripts);
}

/**
 * Waits for body to be present then verifies that an extension script is
 * present in head for installation.
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc
 * @param {string} extensionId
 * @return {!Promise<boolean>}
 */
function isExtensionScriptInNode(ampdoc, extensionId) {
  return ampdoc.waitForBodyOpen().then(function () {
    return extensionScriptInNode(ampdoc.getHeadNode(), extensionId);
  });
}

/**
 * Verifies that an extension script is present in head for
 * installation.
 * @param {HTMLHeadElement|Element|ShadowRoot} head
 * @param {string} extensionId
 * @return {boolean}
 * @private
 */
function extensionScriptInNode(head, extensionId) {
  return extensionScriptsInNode(head).includes(extensionId);
}

/**
 * Waits for an extension if its script is present
 * @param {!Window} win
 * @param {string} extension
 * @param {HTMLHeadElement|Element|ShadowRoot} head
 * @return {!Promise}
 * @private
 */
function waitForExtensionIfPresent(win, extension, head) {
  /**
   * If there is an extension script wait for it to load before trying
   * to get the service. Prevents a race condition when everything but
   * the extensions is in cache. If there is no script then it's either
   * not present, or the service was defined by a test. In those cases
   * we don't wait around for an extension that does not exist.
   */
  // TODO(jpettitt) investigate registerExtension to short circuit
  // the dom call in extensionScriptsInNode()
  if (!extensionScriptInNode(head, extension)) {
    return (0, _resolvedPromise2.resolvedPromise)();
  }

  var extensions = (0, _service.getService)(win, 'extensions');
  return (
    /** @type {!Promise<?Object>} */
    extensions.waitForExtension(win, extension)
  );
}

/**
 * Returns the promise for service with `id` on the given window if available.
 * Otherwise, resolves with null (service was not registered).
 * @param {!Window} win
 * @param {string} id
 * @param {string} extension
 * @param {boolean=} opt_element
 * @return {!Promise<Object>}
 * @private
 */
function getElementServicePromiseOrNull(win, id, extension, opt_element) {
  return dom.waitForBodyOpenPromise(win.document).then(function () {
    return waitForExtensionIfPresent(win, extension, win.document.head);
  }).then(function () {
    // If this service is provided by an element, then we can't depend on
    // the service (they may not use the element).
    if (opt_element) {
      return (0, _service.getServicePromiseOrNull)(win, id);
    } else if (isElementScheduled(win, extension)) {
      return (0, _service.getServicePromise)(win, id);
    }

    return null;
  });
}

},{"./dom":106,"./log":123,"./resolved-promise":129,"./service":130,"./types":139}],108:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.TickLabel = exports.AMPDOC_SINGLETON_NAME = void 0;

/**
 * Copyright 2020 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Registred singleton on AMP doc.
 * @enum {number}
 */
var AMPDOC_SINGLETON_NAME = {
  TRACKING_IFRAME: 1,
  LINKER: 2
};
exports.AMPDOC_SINGLETON_NAME = AMPDOC_SINGLETON_NAME;

/**
 * Enum for tick labels (used by Performance service)
 * @enum {string}
 */
var TickLabel = {
  ACCESS_AUTHORIZATION: 'aaa',
  ACCESS_AUTHORIZATION_VISIBLE: 'aaav',
  ADS_LAYOUT_DELAY: 'adld',
  BAD_FRAMES: 'bf',
  BATTERY_DROP: 'bd',
  CONTENT_LAYOUT_DELAY: 'cld',
  CUMULATIVE_LAYOUT_SHIFT: 'cls',
  CUMULATIVE_LAYOUT_SHIFT_2: 'cls-2',
  DOCUMENT_READY: 'dr',
  END_INSTALL_STYLES: 'e_is',
  FIRST_CONTENTFUL_PAINT: 'fcp',
  FIRST_CONTENTFUL_PAINT_VISIBLE: 'fcpv',
  FIRST_PAINT: 'fp',
  FIRST_INPUT_DELAY: 'fid',
  FIRST_INPUT_DELAY_POLYFILL: 'fid-polyfill',
  FIRST_VIEWPORT_READY: 'pc',
  GOOD_FRAME_PROBABILITY: 'gfp',
  INSTALL_STYLES: 'is',
  LARGEST_CONTENTFUL_PAINT_VISIBLE: 'lcpv',
  LARGEST_CONTENTFUL_PAINT_LOAD: 'lcpl',
  LARGEST_CONTENTFUL_PAINT_RENDER: 'lcpr',
  LONG_TASKS_CHILD: 'ltc',
  LONG_TASKS_SELF: 'lts',
  MAKE_BODY_VISIBLE: 'mbv',
  MESSAGING_READY: 'msr',
  ON_FIRST_VISIBLE: 'ofv',
  ON_LOAD: 'ol',
  SLOW_ELEMENT_RATIO: 'ser',
  TIME_ORIGIN: 'timeOrigin',
  VIDEO_CACHE_STATE: 'vcs',
  VIDEO_ERROR: 'verr',
  VIDEO_JOINT_LATENCY: 'vjl',
  VIDEO_MEAN_TIME_BETWEEN_REBUFFER: 'vmtbrb',
  VIDEO_REBUFFERS: 'vrb',
  VIDEO_REBUFFER_RATE: 'vrbr',
  VIDEO_WATCH_TIME: 'vwt'
};
exports.TickLabel = TickLabel;

},{}],109:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.reportErrorForWin = reportErrorForWin;
exports.reportError = reportError;
exports.cancellation = cancellation;
exports.isCancellation = isCancellation;
exports.blockedByConsentError = blockedByConsentError;
exports.isBlockedByConsent = isBlockedByConsent;
exports.installErrorReporting = installErrorReporting;
exports.reportErrorToServerOrViewer = reportErrorToServerOrViewer;
exports.maybeReportErrorToViewer = maybeReportErrorToViewer;
exports.errorReportingDataForViewer = errorReportingDataForViewer;
exports.getErrorReportData = getErrorReportData;
exports.detectNonAmpJs = detectNonAmpJs;
exports.resetAccumulatedErrorMessagesForTesting = resetAccumulatedErrorMessagesForTesting;
exports.detectJsEngineFromStack = detectJsEngineFromStack;
exports.reportErrorToAnalytics = reportErrorToAnalytics;

var _resolvedPromise2 = require("./resolved-promise");

var _ampEvents = require("./amp-events");

var _services = require("./services");

var _log = require("./log");

var _object = require("./utils/object");

var _experiments = require("./experiments");

var _exponentialBackoff = require("./exponential-backoff");

var _mode = require("./mode");

var _eventHelper = require("./event-helper");

var _url = require("./url");

var _styleInstaller = require("./style-installer");

var _string = require("./string");

var _analytics = require("./analytics");

var _config = require("./config");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @const {string}
 */
var CANCELLED = 'CANCELLED';

/**
 * @const {string}
 */
var BLOCK_BY_CONSENT = 'BLOCK_BY_CONSENT';

/**
 * @const {string}
 */
var ABORTED = 'AbortError';

/**
 * The threshold for errors throttled because nothing can be done about
 * them, but we'd still like to report the rough number.
 * @const {number}
 */
var NON_ACTIONABLE_ERROR_THROTTLE_THRESHOLD = 0.001;

/**
 * The threshold for errors throttled because nothing can be done about
 * them, but we'd still like to report the rough number.
 * @const {number}
 */
var USER_ERROR_THROTTLE_THRESHOLD = 0.1;

/**
 * Chance to post to the new error reporting endpoint.
 * @const {number}
 */
var BETA_ERROR_REPORT_URL_FREQ = 0.1;

/**
 * Collects error messages, so they can be included in subsequent reports.
 * That allows identifying errors that might be caused by previous errors.
 */
var accumulatedErrorMessages = self.__AMP_ERRORS || [];
// Use a true global, to avoid multi-module inclusion issues.
self.__AMP_ERRORS = accumulatedErrorMessages;

/**
 * Pushes element into array, keeping at most the most recent limit elements
 *
 * @param {!Array<T>} array
 * @param {T} element
 * @param {number} limit
 * @template T
 */
function pushLimit(array, element, limit) {
  if (array.length >= limit) {
    array.splice(0, array.length - limit + 1);
  }

  array.push(element);
}

/**
 * A wrapper around our exponentialBackoff, to lazy initialize it to avoid an
 * un-DCE'able side-effect.
 * @param {function()} work the function to execute after backoff
 * @return {number} the setTimeout id
 */
var _reportingBackoff = function reportingBackoff(work) {
  // Set reportingBackoff as the lazy-created function. JS Vooodoooo.
  _reportingBackoff = (0, _exponentialBackoff.exponentialBackoff)(1.5);
  return _reportingBackoff(work);
};

/**
 * Attempts to stringify a value, falling back to String.
 * @param {*} value
 * @return {string}
 */
function tryJsonStringify(value) {
  try {
    // Cast is fine, because we really don't care here. Just trying.
    return JSON.stringify(
    /** @type {!JsonObject} */
    value);
  } catch (e) {
    return String(value);
  }
}

/**
 * The true JS engine, as detected by inspecting an Error stack. This should be
 * used with the userAgent to tell definitely. I.e., Chrome on iOS is really a
 * Safari JS engine.
 */
var detectedJsEngine;

/**
 * @param {!Window} win
 * @param {*} error
 * @param {!Element=} opt_associatedElement
 */
function reportErrorForWin(win, error, opt_associatedElement) {
  reportError(error, opt_associatedElement);

  if (error && !!win && (0, _log.isUserErrorMessage)(error.message) && !(0, _log.isUserErrorEmbed)(error.message)) {
    reportErrorToAnalytics(
    /** @type {!Error} */
    error, win);
  }
}

/**
 * Reports an error. If the error has an "associatedElement" property
 * the element is marked with the `i-amphtml-element-error` and displays
 * the message itself. The message is always send to the console.
 * If the error has a "messageArray" property, that array is logged.
 * This way one gets the native fidelity of the console for things like
 * elements instead of stringification.
 * @param {*} error
 * @param {!Element=} opt_associatedElement
 * @return {!Error}
 */
function reportError(error, opt_associatedElement) {
  try {
    // Convert error to the expected type.
    var isValidError;

    if (error) {
      if (error.message !== undefined) {
        error = (0, _log.duplicateErrorIfNecessary)(
        /** @type {!Error} */
        error);
        isValidError = true;
      } else {
        var origError = error;
        error = new Error(tryJsonStringify(origError));
        error.origError = origError;
      }
    } else {
      error = new Error('Unknown error');
    }

    // Report if error is not an expected type.
    if (!isValidError && (0, _mode.getMode)().localDev && !(0, _mode.getMode)().test) {
      setTimeout(function () {
        var rethrow = new Error('_reported_ Error reported incorrectly: ' + error);
        throw rethrow;
      });
    }

    if (error.reported) {
      return (
        /** @type {!Error} */
        error
      );
    }

    error.reported = true;
    // Update element.
    var element = opt_associatedElement || error.associatedElement;

    if (element && element.classList) {
      element.classList.add('i-amphtml-error');

      if ((0, _mode.getMode)().development) {
        element.classList.add('i-amphtml-element-error');
        element.setAttribute('error-message', error.message);
      }
    }

    // Report to console.
    if (self.console) {
      var output = console.error || console.log;

      if (error.messageArray) {
        output.apply(console, error.messageArray);
      } else {
        if (element) {
          output.call(console, error.message, element);
        } else if (!(0, _mode.getMode)().minified) {
          output.call(console, error.stack);
        } else {
          output.call(console, error.message);
        }
      }
    }

    if (element && element.dispatchCustomEventForTesting) {
      element.dispatchCustomEventForTesting(_ampEvents.AmpEvents.ERROR, error.message);
    }

    // 'call' to make linter happy. And .call to make compiler happy
    // that expects some @this.
    onError['call'](self, undefined, undefined, undefined, undefined, error);
  } catch (errorReportingError) {
    setTimeout(function () {
      throw errorReportingError;
    });
  }

  return (
    /** @type {!Error} */
    error
  );
}

/**
 * Returns an error for a cancellation of a promise.
 * @return {!Error}
 */
function cancellation() {
  return new Error(CANCELLED);
}

/**
 * @param {*} errorOrMessage
 * @return {boolean}
 */
function isCancellation(errorOrMessage) {
  if (!errorOrMessage) {
    return false;
  }

  if (typeof errorOrMessage == 'string') {
    return (0, _string.startsWith)(errorOrMessage, CANCELLED);
  }

  if (typeof errorOrMessage.message == 'string') {
    return (0, _string.startsWith)(errorOrMessage.message, CANCELLED);
  }

  return false;
}

/**
 * Returns an error for component blocked by consent
 * @return {!Error}
 */
function blockedByConsentError() {
  return new Error(BLOCK_BY_CONSENT);
}

/**
 * @param {*} errorOrMessage
 * @return {boolean}
 */
function isBlockedByConsent(errorOrMessage) {
  if (!errorOrMessage) {
    return false;
  }

  if (typeof errorOrMessage == 'string') {
    return (0, _string.startsWith)(errorOrMessage, BLOCK_BY_CONSENT);
  }

  if (typeof errorOrMessage.message == 'string') {
    return (0, _string.startsWith)(errorOrMessage.message, BLOCK_BY_CONSENT);
  }

  return false;
}

/**
 * Install handling of global unhandled exceptions.
 * @param {!Window} win
 */
function installErrorReporting(win) {
  win.onerror =
  /** @type {!Function} */
  onError;
  win.addEventListener('unhandledrejection', function (event) {
    if (event.reason && (event.reason.message === CANCELLED || event.reason.message === BLOCK_BY_CONSENT || event.reason.message === ABORTED)) {
      event.preventDefault();
      return;
    }

    reportError(event.reason || new Error('rejected promise ' + event));
  });
}

/**
 * Signature designed, so it can work with window.onerror
 * @param {string|undefined} message
 * @param {string|undefined} filename
 * @param {string|undefined} line
 * @param {string|undefined} col
 * @param {*|undefined} error
 * @this {!Window|undefined}
 */
function onError(message, filename, line, col, error) {
  var _this = this;

  // Make an attempt to unhide the body but don't if the error is actually expected.
  if (this && this.document && (!error || !error.expected)) {
    (0, _styleInstaller.makeBodyVisibleRecovery)(this.document);
  }

  if ((0, _mode.getMode)().localDev || (0, _mode.getMode)().development || (0, _mode.getMode)().test) {
    return;
  }

  var hasNonAmpJs = false;

  try {
    hasNonAmpJs = detectNonAmpJs(self);
  } catch (ignore) {// Ignore errors during error report generation.
  }

  if (hasNonAmpJs && Math.random() > 0.01) {
    // Only report 1% of errors on pages with non-AMP JS.
    // These errors can almost never be acted upon, but spikes such as
    // due to buggy browser extensions may be helpful to notify authors.
    return;
  }

  var data = getErrorReportData(message, filename, line, col, error, hasNonAmpJs);

  if (data) {
    _reportingBackoff(function () {
      try {
        return reportErrorToServerOrViewer(_this,
        /** @type {!JsonObject} */
        data).catch(function () {// catch async errors to avoid recursive errors.
        });
      } catch (e) {// catch async errors to avoid recursive errors.
      }
    });
  }
}

/**
 * Determines the error reporting endpoint which should be used.
 * If changing this URL, keep `/spec/amp-errors.md` in sync.
 * @return {string} error reporting endpoint URL.
 */
function chooseReportingUrl_() {
  return Math.random() < BETA_ERROR_REPORT_URL_FREQ ? _config.urls.betaErrorReporting : _config.urls.errorReporting;
}

/**
 * Passes the given error data to either server or viewer.
 * @param {!Window} win
 * @param {!JsonObject} data Data from `getErrorReportData`.
 * @return {Promise<undefined>}
 */
function reportErrorToServerOrViewer(win, data) {
  // Report the error to viewer if it has the capability. The data passed
  // to the viewer is exactly the same as the data passed to the server
  // below.
  // Throttle reports from Stable by 90%.
  if (data['pt'] && Math.random() < 0.9) {
    return (0, _resolvedPromise2.resolvedPromise)();
  }

  return maybeReportErrorToViewer(win, data).then(function (reportedErrorToViewer) {
    if (!reportedErrorToViewer) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', chooseReportingUrl_(), true);
      xhr.send(JSON.stringify(data));
    }
  });
}

/**
 * Passes the given error data to the viewer if the following criteria is met:
 * - The viewer is a trusted viewer
 * - The viewer has the `errorReporter` capability
 * - The AMP doc is in single doc mode
 * - The AMP doc is opted-in for error interception (`<html>` tag has the
 *   `report-errors-to-viewer` attribute)
 *
 * @param {!Window} win
 * @param {!JsonObject} data Data from `getErrorReportData`.
 * @return {!Promise<boolean>} `Promise<True>` if the error was sent to the
 *     viewer, `Promise<False>` otherwise.
 * @visibleForTesting
 */
function maybeReportErrorToViewer(win, data) {
  var ampdocService = _services.Services.ampdocServiceFor(win);

  if (!ampdocService.isSingleDoc()) {
    return Promise.resolve(false);
  }

  var ampdocSingle = ampdocService.getSingleDoc();
  var htmlElement = ampdocSingle.getRootNode().documentElement;
  var docOptedIn = htmlElement.hasAttribute('report-errors-to-viewer');

  if (!docOptedIn) {
    return Promise.resolve(false);
  }

  var viewer = _services.Services.viewerForDoc(ampdocSingle);

  if (!viewer.hasCapability('errorReporter')) {
    return Promise.resolve(false);
  }

  return viewer.isTrustedViewer().then(function (viewerTrusted) {
    if (!viewerTrusted) {
      return false;
    }

    viewer.sendMessage('error', errorReportingDataForViewer(data));
    return true;
  });
}

/**
 * Strips down the error reporting data to a minimal set
 * to be sent to the viewer.
 * @param {!JsonObject} errorReportData
 * @return {!JsonObject}
 * @visibleForTesting
 */
function errorReportingDataForViewer(errorReportData) {
  return (0, _object.dict)({
    'm': errorReportData['m'],
    // message
    'a': errorReportData['a'],
    // isUserError
    's': errorReportData['s'],
    // error stack
    'el': errorReportData['el'],
    // tagName
    'ex': errorReportData['ex'],
    // expected error?
    'v': errorReportData['v'],
    // runtime
    'pt': errorReportData['pt'],
    // is pre-throttled
    'jse': errorReportData['jse'] // detectedJsEngine

  });
}

/**
 * @param {string|undefined}  message
 * @param {*|undefined} error
 * @return {string}
 */
function buildErrorMessage_(message, error) {
  if (error) {
    if (error.message) {
      message = error.message;
    } else {
      // This should never be a string, but sometimes it is.
      message = String(error);
    }
  }

  if (!message) {
    message = 'Unknown error';
  }

  return message;
}

/**
 * Signature designed, so it can work with window.onerror
 * @param {string|undefined} message
 * @param {string|undefined} filename
 * @param {string|undefined} line
 * @param {string|undefined} col
 * @param {*|undefined} error
 * @param {boolean} hasNonAmpJs
 * @return {!JsonObject|undefined} The data to post
 * visibleForTesting
 */
function getErrorReportData(message, filename, line, col, error, hasNonAmpJs) {
  message = buildErrorMessage_(message, error);
  // An "expected" error is still an error, i.e. some features are disabled
  // or not functioning fully because of it. However, it's an expected
  // error. E.g. as is the case with some browser API missing (storage).
  // Thus, the error can be classified differently by log aggregators.
  // The main goal is to monitor that an "expected" error doesn't deteriorate
  // over time. It's impossible to completely eliminate it.
  var expected = !!(error && error.expected);

  if (/_reported_/.test(message)) {
    return;
  }

  if (message == CANCELLED) {
    return;
  }

  var detachedWindow = !(self && self.window);
  var throttleBase = Math.random();

  // We throttle load errors and generic "Script error." errors
  // that have no information and thus cannot be acted upon.
  if ((0, _eventHelper.isLoadErrorMessage)(message) || // See https://github.com/ampproject/amphtml/issues/7353
  // for context.
  message == 'Script error.' || // Window has become detached, really anything can happen
  // at this point.
  detachedWindow) {
    expected = true;

    if (throttleBase > NON_ACTIONABLE_ERROR_THROTTLE_THRESHOLD) {
      return;
    }
  }

  var isUserError = (0, _log.isUserErrorMessage)(message);

  // Only report a subset of user errors.
  if (isUserError && throttleBase > USER_ERROR_THROTTLE_THRESHOLD) {
    return;
  }

  // This is the App Engine app in
  // https://github.com/ampproject/error-tracker
  // It stores error reports via https://cloud.google.com/error-reporting/
  // for analyzing production issues.
  var data =
  /** @type {!JsonObject} */
  Object.create(null);
  data['v'] = (0, _mode.getMode)().rtvVersion;
  data['noAmp'] = hasNonAmpJs ? '1' : '0';
  data['m'] = message.replace(_log.USER_ERROR_SENTINEL, '');
  data['a'] = isUserError ? '1' : '0';
  // Errors are tagged with "ex" ("expected") label to allow loggers to
  // classify these errors as benchmarks and not exceptions.
  data['ex'] = expected ? '1' : '0';
  data['dw'] = detachedWindow ? '1' : '0';
  var runtime = '1p';

  if (false) {
    runtime = 'esm';
    data['esm'] = '1';
  } else if (self.context && self.context.location) {
    data['3p'] = '1';
    runtime = '3p';
  } else if ((0, _mode.getMode)().runtime) {
    runtime = (0, _mode.getMode)().runtime;
  }

  data['rt'] = runtime;

  // Add our a4a id if we are inabox
  if (runtime === 'inabox') {
    data['adid'] = (0, _mode.getMode)().a4aId;
  }

  // TODO(erwinm): Remove ca when all systems read `bt` instead of `ca` to
  // identify js binary type.
  data['ca'] = (0, _experiments.isCanary)(self) ? '1' : '0';
  // Pass binary type.
  data['bt'] = (0, _experiments.getBinaryType)(self);

  if (self.location.ancestorOrigins && self.location.ancestorOrigins[0]) {
    data['or'] = self.location.ancestorOrigins[0];
  }

  if (self.viewerState) {
    data['vs'] = self.viewerState;
  }

  // Is embedded?
  if (self.parent && self.parent != self) {
    data['iem'] = '1';
  }

  if (self.AMP && self.AMP.viewer) {
    var resolvedViewerUrl = self.AMP.viewer.getResolvedViewerUrl();
    var messagingOrigin = self.AMP.viewer.maybeGetMessagingOrigin();

    if (resolvedViewerUrl) {
      data['rvu'] = resolvedViewerUrl;
    }

    if (messagingOrigin) {
      data['mso'] = messagingOrigin;
    }
  }

  if (!detectedJsEngine) {
    detectedJsEngine = detectJsEngineFromStack();
  }

  data['jse'] = detectedJsEngine;
  var exps = [];
  var experiments = (0, _experiments.experimentTogglesOrNull)(self);

  for (var exp in experiments) {
    var on = experiments[exp];
    exps.push(exp + "=" + (on ? '1' : '0'));
  }

  data['exps'] = exps.join(',');

  if (error) {
    var tagName = error.associatedElement ? error.associatedElement.tagName : 'u';
    // Unknown
    data['el'] = tagName;

    if (error.args) {
      data['args'] = JSON.stringify(error.args);
    }

    if (!isUserError && !error.ignoreStack && error.stack) {
      data['s'] = error.stack;
    }

    // TODO(jridgewell, #18574); Make sure error is always an object.
    if (error.message) {
      error.message += ' _reported_';
    }
  } else {
    data['f'] = filename || '';
    data['l'] = line || '';
    data['c'] = col || '';
  }

  data['r'] = self.document ? self.document.referrer : '';
  data['ae'] = accumulatedErrorMessages.join(',');
  data['fr'] = self.location.originalHash || self.location.hash;

  // TODO(https://github.com/ampproject/error-tracker/issues/129): Remove once
  // all clients are serving a version with pre-throttling.
  if (data['bt'] === 'production') {
    // Setting this field allows the error reporting service to know that this
    // error has already been pre-throttled for Stable, so it doesn't need to
    // throttle again.
    data['pt'] = '1';
  }

  pushLimit(accumulatedErrorMessages, message, 25);
  return data;
}

/**
 * Returns true if it appears like there is non-AMP JS on the
 * current page.
 * @param {!Window} win
 * @return {boolean}
 * @visibleForTesting
 */
function detectNonAmpJs(win) {
  if (!win.document) {
    return false;
  }

  var scripts = win.document.querySelectorAll('script[src]');

  for (var i = 0; i < scripts.length; i++) {
    if (!(0, _url.isProxyOrigin)(scripts[i].src.toLowerCase())) {
      return true;
    }
  }

  return false;
}

/**
 * Resets accumulated error messages for testing
 */
function resetAccumulatedErrorMessagesForTesting() {
  accumulatedErrorMessages = [];
}

/**
 * Does a series of checks on the stack of an thrown error to determine the
 * JS engine that is currently running. This gives a bit more information than
 * just the UserAgent, since browsers often allow overriding it to "emulate"
 * mobile.
 * @return {string}
 * @visibleForTesting
 */
function detectJsEngineFromStack() {
  /** @constructor */
  function Fn() {}

  Fn.prototype.t = function () {
    throw new Error('message');
  };

  var object = new Fn();

  try {
    object.t();
  } catch (e) {
    var stack = e.stack;

    // Safari 12 and under only mentions the method name.
    if ((0, _string.startsWith)(stack, 't@')) {
      return 'Safari';
    }

    // Firefox mentions "prototype".
    if (stack.indexOf('.prototype.t@') > -1) {
      return 'Firefox';
    }

    // IE looks like Chrome, but includes a context for the base stack line.
    // Explicitly, we're looking for something like:
    // "    at Global code (https://example.com/app.js:1:200)" or
    // "    at Anonymous function (https://example.com/app.js:1:200)"
    // vs Chrome which has:
    // "    at https://example.com/app.js:1:200"
    var last = stack.split('\n').pop();

    if (/\bat .* \(/i.test(last)) {
      return 'IE';
    }

    // Finally, chrome includes the error message in the stack.
    if ((0, _string.startsWith)(stack, 'Error: message')) {
      return 'Chrome';
    }
  }

  return 'unknown';
}

/**
 * @param {!Error} error
 * @param {!Window} win
 */
function reportErrorToAnalytics(error, win) {
  // Currently this can only be executed in a single-doc mode. Otherwise,
  // it's not clear which ampdoc the event would belong too.
  if (_services.Services.ampdocServiceFor(win).isSingleDoc()) {
    var vars = (0, _object.dict)({
      'errorName': error.name,
      'errorMessage': error.message
    });
    (0, _analytics.triggerAnalyticsEvent)(getRootElement_(win), 'user-error', vars,
    /** enableDataVars */
    false);
  }
}

/**
 * @param {!Window} win
 * @return {!Element}
 * @private
 */
function getRootElement_(win) {
  var root = _services.Services.ampdocServiceFor(win).getSingleDoc().getRootNode();

  return (0, _log.dev)().assertElement(root.documentElement || root.body || root);
}

},{"./amp-events":97,"./analytics":99,"./config":102,"./event-helper":111,"./experiments":112,"./exponential-backoff":113,"./log":123,"./mode":124,"./resolved-promise":129,"./services":133,"./string":136,"./style-installer":137,"./url":142,"./utils/object":149}],110:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.internalListenImplementation = internalListenImplementation;
exports.detectEvtListenerOptsSupport = detectEvtListenerOptsSupport;
exports.resetEvtListenerOptsSupportForTesting = resetEvtListenerOptsSupportForTesting;
exports.supportsPassiveEventListener = supportsPassiveEventListener;
exports.resetPassiveSupportedForTesting = resetPassiveSupportedForTesting;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Whether addEventListener supports options or only takes capture as a boolean
 * @type {boolean|undefined}
 * @visibleForTesting
 */
var optsSupported;

/**
 * Whether addEventListener supports options or only takes passive as a boolean
 * @type {boolean|undefined}
 */
var passiveSupported;

/**
 * Listens for the specified event on the element.
 *
 * Do not use this directly. This method is implemented as a shared
 * dependency. Use `listen()` in either `event-helper` or `3p-frame-messaging`,
 * depending on your use case.
 *
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function internalListenImplementation(element, eventType, listener, opt_evtListenerOpts) {
  var localElement = element;
  var localListener = listener;

  /**
   * @type {?Function}
   */
  var wrapped;

  wrapped = function wrapped(event) {
    try {
      return localListener(event);
    } catch (e) {
      // __AMP_REPORT_ERROR is installed globally per window in the entry point.
      self.__AMP_REPORT_ERROR(e);

      throw e;
    }
  };

  var optsSupported = detectEvtListenerOptsSupport();
  var capture = false;

  if (opt_evtListenerOpts) {
    capture = opt_evtListenerOpts.capture;
  }

  localElement.addEventListener(eventType, wrapped, optsSupported ? opt_evtListenerOpts : capture);
  return function () {
    if (localElement) {
      localElement.removeEventListener(eventType, wrapped, optsSupported ? opt_evtListenerOpts : capture);
    }

    // Ensure these are GC'd
    localListener = null;
    localElement = null;
    wrapped = null;
  };
}

/**
 * Tests whether the browser supports options as an argument of addEventListener
 * or not.
 *
 * @return {boolean}
 */
function detectEvtListenerOptsSupport() {
  // Only run the test once
  if (optsSupported !== undefined) {
    return optsSupported;
  }

  optsSupported = false;

  try {
    // Test whether browser supports EventListenerOptions or not
    var options = {
      get capture() {
        optsSupported = true;
      }

    };
    self.addEventListener('test-options', null, options);
    self.removeEventListener('test-options', null, options);
  } catch (err) {// EventListenerOptions are not supported
  }

  return optsSupported;
}

/**
 * Resets the test for whether addEventListener supports options or not.
 */
function resetEvtListenerOptsSupportForTesting() {
  optsSupported = undefined;
}

/**
 * Return boolean. if listener option is supported, return `true`.
 * if not supported, return `false`
 * @param {!Window} win
 * @return {boolean}
 */
function supportsPassiveEventListener(win) {
  if (passiveSupported !== undefined) {
    return passiveSupported;
  }

  passiveSupported = false;

  try {
    var options = {
      get passive() {
        // This function will be called when the browser
        // attempts to access the passive property.
        passiveSupported = true;
        return false;
      }

    };
    win.addEventListener('test-options', null, options);
    win.removeEventListener('test-options', null, options);
  } catch (err) {// EventListenerOptions are not supported
  }

  return passiveSupported;
}

/**
 * Resets the test for whether addEventListener supports passive options or not.
 */
function resetPassiveSupportedForTesting() {
  passiveSupported = undefined;
}

},{}],111:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.createCustomEvent = createCustomEvent;
exports.listen = listen;
exports.getData = getData;
exports.getDetail = getDetail;
exports.listenOnce = listenOnce;
exports.listenOncePromise = listenOncePromise;
exports.isLoaded = isLoaded;
exports.loadPromise = loadPromise;
exports.isLoadErrorMessage = isLoadErrorMessage;
exports.MEDIA_LOAD_FAILURE_SRC_PROPERTY = void 0;

var _eventHelperListen = require("./event-helper-listen");

var _dom = require("./dom");

var _log = require("./log");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** @const {string}  */
var LOAD_FAILURE_PREFIX = 'Failed to load:';

/** @const {string} */
var MEDIA_LOAD_FAILURE_SRC_PROPERTY = '__AMP_MEDIA_LOAD_FAILURE_SRC';
exports.MEDIA_LOAD_FAILURE_SRC_PROPERTY = MEDIA_LOAD_FAILURE_SRC_PROPERTY;

/**
 * Returns a CustomEvent with a given type and detail; supports fallback for IE.
 * @param {!Window} win
 * @param {string} type
 * @param {!JsonObject|string|undefined|null} detail
 * @param {EventInit=} opt_eventInit
 * @return {!Event}
 */
function createCustomEvent(win, type, detail, opt_eventInit) {
  var eventInit =
  /** @type {!CustomEventInit} */
  {
    detail: detail
  };
  Object.assign(eventInit, opt_eventInit);

  // win.CustomEvent is a function on Edge, Chrome, FF, Safari but
  // is an object on IE 11.
  if (typeof win.CustomEvent == 'function') {
    return new win.CustomEvent(type, eventInit);
  } else {
    // Deprecated fallback for IE.
    var e = win.document.createEvent('CustomEvent');
    e.initCustomEvent(type, !!eventInit.bubbles, !!eventInit.cancelable, detail);
    return e;
  }
}

/**
 * Listens for the specified event on the element.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function listen(element, eventType, listener, opt_evtListenerOpts) {
  return (0, _eventHelperListen.internalListenImplementation)(element, eventType, listener, opt_evtListenerOpts);
}

/**
 * Returns the data property of an event with the correct type.
 * @param {!Event|{data: !JsonObject}} event
 * @return {?JsonObject|string|undefined}
 */
function getData(event) {
  return (
    /** @type {?JsonObject|string|undefined} */
    event.data
  );
}

/**
 * Returns the detail property of an event with the correct type.
 * @param {!Event|{detail: !JsonObject}} event
 * @return {?JsonObject|string|undefined}
 */
function getDetail(event) {
  return (
    /** @type {?JsonObject|string|undefined} */
    event.detail
  );
}

/**
 * Listens for the specified event on the element and removes the listener
 * as soon as event has been received.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {function(!Event)} listener
 * @param {Object=} opt_evtListenerOpts
 * @return {!UnlistenDef}
 */
function listenOnce(element, eventType, listener, opt_evtListenerOpts) {
  var localListener = listener;
  var unlisten = (0, _eventHelperListen.internalListenImplementation)(element, eventType, function (event) {
    try {
      localListener(event);
    } finally {
      // Ensure listener is GC'd
      localListener = null;
      unlisten();
    }
  }, opt_evtListenerOpts);
  return unlisten;
}

/**
 * Returns  a promise that will resolve as soon as the specified event has
 * fired on the element.
 * @param {!EventTarget} element
 * @param {string} eventType
 * @param {Object=} opt_evtListenerOpts
 * @param {function(!UnlistenDef)=} opt_cancel An optional function that, when
 *     provided, will be called with the unlistener. This gives the caller
 *     access to the unlistener, so it may be called manually when necessary.
 * @return {!Promise<!Event>}
 */
function listenOncePromise(element, eventType, opt_evtListenerOpts, opt_cancel) {
  var unlisten;
  var eventPromise = new Promise(function (resolve) {
    unlisten = listenOnce(element, eventType, resolve, opt_evtListenerOpts);
  });
  eventPromise.then(unlisten, unlisten);

  if (opt_cancel) {
    opt_cancel(unlisten);
  }

  return eventPromise;
}

/**
 * Whether the specified element/window has been loaded already.
 * @param {!Element|!Window} eleOrWindow
 * @return {boolean}
 */
function isLoaded(eleOrWindow) {
  return !!(eleOrWindow.complete || eleOrWindow.readyState == 'complete' || isHTMLMediaElement(eleOrWindow) && eleOrWindow.readyState > 0 || // If the passed in thing is a Window, infer loaded state from
  //
  eleOrWindow.document && eleOrWindow.document.readyState == 'complete');
}

/**
 * Returns a promise that will resolve or fail based on the eleOrWindow's 'load'
 * and 'error' events. Optionally this method takes a timeout, which will reject
 * the promise if the resource has not loaded by then.
 * @param {T} eleOrWindow Supports both Elements and as a special case Windows.
 * @return {!Promise<T>}
 * @template T
 */
function loadPromise(eleOrWindow) {
  var unlistenLoad;
  var unlistenError;

  if (isLoaded(eleOrWindow)) {
    return Promise.resolve(eleOrWindow);
  }

  var isMediaElement = isHTMLMediaElement(eleOrWindow);

  if (isMediaElement && eleOrWindow[MEDIA_LOAD_FAILURE_SRC_PROPERTY] === eleOrWindow.currentSrc) {
    return Promise.reject(eleOrWindow);
  }

  var loadingPromise = new Promise(function (resolve, reject) {
    // Listen once since IE 5/6/7 fire the onload event continuously for
    // animated GIFs.
    if (isMediaElement) {
      // The following event can be triggered by the media or one of its
      // sources. Using capture is required as the media events do not bubble.
      unlistenLoad = listenOnce(eleOrWindow, 'loadedmetadata', resolve, {
        capture: true
      });
    } else {
      unlistenLoad = listenOnce(eleOrWindow, 'load', resolve);
    }

    // Don't unlisten on error for Windows.
    if (!eleOrWindow.tagName) {
      return;
    }

    var errorTarget = eleOrWindow;

    // If the media element has no `src`, it will try to load the sources in
    // document order. If the last source errors, then the media element
    // loading errored.
    if (isMediaElement && !eleOrWindow.hasAttribute('src')) {
      errorTarget = (0, _dom.lastChildElement)(eleOrWindow, function (child) {
        return child.tagName === 'SOURCE';
      });

      if (!errorTarget) {
        return reject(new Error('Media has no source.'));
      }
    }

    unlistenError = listenOnce(errorTarget, 'error', reject);
  });
  return loadingPromise.then(function () {
    if (unlistenError) {
      unlistenError();
    }

    return eleOrWindow;
  }, function () {
    if (unlistenLoad) {
      unlistenLoad();
    }

    failedToLoad(eleOrWindow);
  });
}

/**
 * Emit error on load failure.
 * @param {!Element|!Window} eleOrWindow Supports both Elements and as a special
 *     case Windows.
 */
function failedToLoad(eleOrWindow) {
  // Mark the element as errored since some elements - like HTMLMediaElement
  // using HTMLSourceElement - do not provide any synchronous way to verify if
  // they already errored, even though the error event was already dispatched.
  if (isHTMLMediaElement(eleOrWindow)) {
    eleOrWindow[MEDIA_LOAD_FAILURE_SRC_PROPERTY] = eleOrWindow.currentSrc || true;
  }

  // Report failed loads as user errors so that they automatically go
  // into the "document error" bucket.
  var target = eleOrWindow;

  if (target && target.src) {
    target = target.src;
  }

  throw (0, _log.user)().createError(LOAD_FAILURE_PREFIX, target);
}

/**
 * Returns true if the parameter is a HTMLMediaElement.
 * @param {!Element|!Window} eleOrWindow
 * @return {boolean}
 */
function isHTMLMediaElement(eleOrWindow) {
  return eleOrWindow.tagName === 'AUDIO' || eleOrWindow.tagName === 'VIDEO';
}

/**
 * Returns true if this error message is was created for a load error.
 * @param {string} message An error message
 * @return {boolean}
 */
function isLoadErrorMessage(message) {
  return message.indexOf(LOAD_FAILURE_PREFIX) != -1;
}

},{"./dom":106,"./event-helper-listen":110,"./log":123}],112:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isCanary = isCanary;
exports.getBinaryType = getBinaryType;
exports.isExperimentOn = isExperimentOn;
exports.toggleExperiment = toggleExperiment;
exports.experimentToggles = experimentToggles;
exports.experimentTogglesOrNull = experimentTogglesOrNull;
exports.getExperimentTogglesForTesting = getExperimentTogglesForTesting;
exports.resetExperimentTogglesForTesting = resetExperimentTogglesForTesting;
exports.randomlySelectUnsetExperiments = randomlySelectUnsetExperiments;
exports.getExperimentBranch = getExperimentBranch;
exports.getActiveExperimentBranches = getActiveExperimentBranches;
exports.forceExperimentBranch = forceExperimentBranch;
exports.RANDOM_NUMBER_GENERATORS = exports.ExperimentInfo = void 0;

var _log = require("./log");

var _mode = require("./mode");

var _service = require("./service");

var _object = require("./utils/object");

var _url = require("./url");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @const {string} */
var TAG = 'EXPERIMENTS';

/** @const {string} */
var LOCAL_STORAGE_KEY = 'amp-experiment-toggles';

/** @const {string} */
var TOGGLES_WINDOW_PROPERTY = '__AMP__EXPERIMENT_TOGGLES';

/**
 * @typedef {{
 *   experimentId: string,
 *   isTrafficEligible: function(!Window):boolean,
 *   branches: !Array<string>
 * }}
 */
var ExperimentInfo;
exports.ExperimentInfo = ExperimentInfo;

/**
 * Whether we are in canary.
 * @param {!Window} win
 * @return {boolean}
 */
function isCanary(win) {
  return !!(win.AMP_CONFIG && win.AMP_CONFIG.canary);
}

/**
 * Returns binary type, e.g., canary, production, control, or rc.
 * @param {!Window} win
 * @return {string}
 */
function getBinaryType(win) {
  return win.AMP_CONFIG && win.AMP_CONFIG.type ? win.AMP_CONFIG.type : 'unknown';
}

/**
 * Whether the specified experiment is on or off.
 * @param {!Window} win
 * @param {string} experimentId
 * @return {boolean}
 */
function isExperimentOn(win, experimentId) {
  var toggles = experimentToggles(win);
  return !!toggles[experimentId];
}

/**
 * Toggles the experiment on or off. Returns the actual value of the experiment
 * after toggling is done.
 * @param {!Window} win
 * @param {string} experimentId
 * @param {boolean=} opt_on
 * @param {boolean=} opt_transientExperiment  Whether to toggle the
 *     experiment state "transiently" (i.e., for this page load only) or
 *     durably (by saving the experiment IDs after toggling).
 *     Default: false (save durably).
 * @return {boolean} New state for experimentId.
 */
function toggleExperiment(win, experimentId, opt_on, opt_transientExperiment) {
  var currentlyOn = isExperimentOn(win,
  /*OK*/
  experimentId);
  var on = !!(opt_on !== undefined ? opt_on : !currentlyOn);

  if (on != currentlyOn) {
    var toggles = experimentToggles(win);
    toggles[experimentId] = on;

    if (!opt_transientExperiment) {
      var storedToggles = getExperimentToggles(win);
      storedToggles[experimentId] = on;
      saveExperimentToggles(win, storedToggles);

      // Avoid affecting tests that spy/stub warn().
      if (!(0, _mode.getMode)().test) {
        (0, _log.user)().warn(TAG, '"%s" experiment %s for the domain "%s". See: https://amp.dev/documentation/guides-and-tutorials/learn/experimental', experimentId, on ? 'enabled' : 'disabled', win.location.hostname);
      }
    }
  }

  return on;
}

/**
 * Calculate whether the experiment is on or off based off of its default value,
 * stored overriden value, or the global config frequency given.
 * @param {!Window} win
 * @return {!Object<string, boolean>}
 */
function experimentToggles(win) {
  if (win[TOGGLES_WINDOW_PROPERTY]) {
    return win[TOGGLES_WINDOW_PROPERTY];
  }

  win[TOGGLES_WINDOW_PROPERTY] = Object.create(null);
  var toggles = win[TOGGLES_WINDOW_PROPERTY];

  // Read the default config of this build.
  if (win.AMP_CONFIG) {
    for (var experimentId in win.AMP_CONFIG) {
      var frequency = win.AMP_CONFIG[experimentId];

      if (typeof frequency === 'number' && frequency >= 0 && frequency <= 1) {
        toggles[experimentId] = Math.random() < frequency;
      }
    }
  }

  // Read document level override from meta tag.
  if (win.AMP_CONFIG && Array.isArray(win.AMP_CONFIG['allow-doc-opt-in']) && win.AMP_CONFIG['allow-doc-opt-in'].length > 0) {
    var allowed = win.AMP_CONFIG['allow-doc-opt-in'];
    var meta = win.document.head.querySelector('meta[name="amp-experiments-opt-in"]');

    if (meta) {
      var optedInExperiments = meta.getAttribute('content').split(',');

      for (var i = 0; i < optedInExperiments.length; i++) {
        if (allowed.indexOf(optedInExperiments[i]) != -1) {
          toggles[optedInExperiments[i]] = true;
        }
      }
    }
  }

  Object.assign(toggles, getExperimentToggles(win));

  if (win.AMP_CONFIG && Array.isArray(win.AMP_CONFIG['allow-url-opt-in']) && win.AMP_CONFIG['allow-url-opt-in'].length > 0) {
    var _allowed = win.AMP_CONFIG['allow-url-opt-in'];
    var hash = win.location.originalHash || win.location.hash;
    var params = (0, _url.parseQueryString)(hash);

    for (var _i = 0; _i < _allowed.length; _i++) {
      var param = params["e-" + _allowed[_i]];

      if (param == '1') {
        toggles[_allowed[_i]] = true;
      }

      if (param == '0') {
        toggles[_allowed[_i]] = false;
      }
    }
  }

  return toggles;
}

/**
 * Returns the cached experiments toggles, or null if they have not been
 * computed yet.
 * @param {!Window} win
 * @return {Object<string, boolean>}
 */
function experimentTogglesOrNull(win) {
  return win[TOGGLES_WINDOW_PROPERTY] || null;
}

/**
 * Returns a set of experiment IDs currently on.
 * @param {!Window} win
 * @return {!Object<string, boolean>}
 */
function getExperimentToggles(win) {
  var experimentsString = '';

  try {
    if ('localStorage' in win) {
      experimentsString = win.localStorage.getItem(LOCAL_STORAGE_KEY);
    }
  } catch (e) {
    (0, _log.dev)().warn(TAG, 'Failed to retrieve experiments from localStorage.');
  }

  var tokens = experimentsString ? experimentsString.split(/\s*,\s*/g) : [];
  var toggles = Object.create(null);

  for (var i = 0; i < tokens.length; i++) {
    if (tokens[i].length == 0) {
      continue;
    }

    if (tokens[i][0] == '-') {
      toggles[tokens[i].substr(1)] = false;
    } else {
      toggles[tokens[i]] = true;
    }
  }

  return toggles;
}

/**
 * Saves a set of experiment IDs currently on.
 * @param {!Window} win
 * @param {!Object<string, boolean>} toggles
 */
function saveExperimentToggles(win, toggles) {
  var experimentIds = [];

  for (var experiment in toggles) {
    experimentIds.push((toggles[experiment] === false ? '-' : '') + experiment);
  }

  try {
    if ('localStorage' in win) {
      win.localStorage.setItem(LOCAL_STORAGE_KEY, experimentIds.join(','));
    }
  } catch (e) {
    (0, _log.user)().error(TAG, 'Failed to save experiments to localStorage.');
  }
}

/**
 * See getExperimentToggles().
 * @param {!Window} win
 * @return {!Object<string, boolean>}
 * @visibleForTesting
 */
function getExperimentTogglesForTesting(win) {
  return getExperimentToggles(win);
}

/**
 * Resets the experimentsToggle cache for testing purposes.
 * @param {!Window} win
 * @visibleForTesting
 */
function resetExperimentTogglesForTesting(win) {
  saveExperimentToggles(win, {});
  win[TOGGLES_WINDOW_PROPERTY] = null;
}

/**
 * In some browser implementations of Math.random(), sequential calls of
 * Math.random() are correlated and can cause a bias.  In particular,
 * if the previous random() call was < 0.001 (as it will be if we select
 * into an experiment), the next value could be less than 0.5 more than
 * 50.7% of the time.  This provides an implementation that roots down into
 * the crypto API, when available, to produce less biased samples.
 *
 * @return {number} Pseudo-random floating-point value on the range [0, 1).
 */
function slowButAccuratePrng() {
  // TODO(tdrl): Implement.
  return Math.random();
}

/**
 * Container for alternate random number generator implementations.  This
 * allows us to set an "accurate" PRNG for branch selection, but to mock it
 * out easily in tests.
 *
 * @visibleForTesting
 * @const {!{accuratePrng: function():number}}
 */
var RANDOM_NUMBER_GENERATORS = {
  accuratePrng: slowButAccuratePrng
};
exports.RANDOM_NUMBER_GENERATORS = RANDOM_NUMBER_GENERATORS;

/**
 * Selects, uniformly at random, a single item from the array.
 * @param {!Array<string>} arr Object to select from.
 * @return {?string} Single item from arr or null if arr was empty.
 */
function selectRandomItem(arr) {
  var rn = RANDOM_NUMBER_GENERATORS.accuratePrng();
  return (0, _log.dev)().assertString(arr[Math.floor(rn * arr.length)]) || null;
}

/**
 * Selects which page-level experiment branches are enabled. If a given
 * experiment name is already set (including to the null / no branches selected
 * state), this won't alter its state.
 *
 * Check whether a given experiment is set using isExperimentOn(win,
 * experimentName) and, if it is on, look for which branch is selected in
 * win.__AMP_EXPERIMENT_BRANCHES[experimentName].
 *
 * @param {!Window} win Window context on which to save experiment
 *     selection state.
 * @param {!Array<!ExperimentInfo>} experiments  Set of experiments to
 *     configure for this page load.
 * @return {!Object<string, string>} Map of experiment names to selected
 *     branches.
 */
function randomlySelectUnsetExperiments(win, experiments) {
  win.__AMP_EXPERIMENT_BRANCHES = win.__AMP_EXPERIMENT_BRANCHES || {};
  var selectedExperiments = {};

  for (var i = 0; i < experiments.length; i++) {
    var experiment = experiments[i];
    var experimentName = experiment.experimentId;

    if ((0, _object.hasOwn)(win.__AMP_EXPERIMENT_BRANCHES, experimentName)) {
      selectedExperiments[experimentName] = win.__AMP_EXPERIMENT_BRANCHES[experimentName];
      continue;
    }

    if (!experiment.isTrafficEligible || !experiment.isTrafficEligible(win)) {
      win.__AMP_EXPERIMENT_BRANCHES[experimentName] = null;
      continue;
    }

    // If we're in the experiment, but we haven't already forced a specific
    // experiment branch (e.g., via a test setup), then randomize the branch
    // choice.
    if (!win.__AMP_EXPERIMENT_BRANCHES[experimentName] && isExperimentOn(win,
    /*OK*/
    experimentName)) {
      win.__AMP_EXPERIMENT_BRANCHES[experimentName] = selectRandomItem(experiment.branches);
      selectedExperiments[experimentName] = win.__AMP_EXPERIMENT_BRANCHES[experimentName];
    }
  }

  return selectedExperiments;
}

/**
 * Returns the experiment branch enabled for the given experiment ID.
 * For example, 'control' or 'experiment'.
 *
 * @param {!Window} win Window context to check for experiment state.
 * @param {string} experimentName Name of the experiment to check.
 * @return {?string} Active experiment branch ID for experimentName (possibly
 *     null if experimentName has been tested but no branch was enabled).
 */
function getExperimentBranch(win, experimentName) {
  return win.__AMP_EXPERIMENT_BRANCHES ? win.__AMP_EXPERIMENT_BRANCHES[experimentName] : null;
}

/**
 * Returns an object containing all active experiment branches on the
 * top Window.
 *
 * @param {!Window} win Window context to check for experiment state.
 * @return {!Object} contains all experiment branches and their ids.
 */
function getActiveExperimentBranches(win) {
  var topWin = (0, _service.getTopWindow)(win);

  if (!topWin.__AMP_EXPERIMENT_BRANCHES) {
    topWin.__AMP_EXPERIMENT_BRANCHES = {};
  }

  return _extends({}, topWin.__AMP_EXPERIMENT_BRANCHES);
}

/**
 * Force enable (or disable) a specific branch of a given experiment name.
 * Disables the experiment name altogether if branchId is falseish.
 *
 * @param {!Window} win Window context to check for experiment state.
 * @param {string} experimentName Name of the experiment to check.
 * @param {?string} branchId ID of branch to force or null to disable
 *     altogether.
 * @visibleForTesting
 */
function forceExperimentBranch(win, experimentName, branchId) {
  win.__AMP_EXPERIMENT_BRANCHES = win.__AMP_EXPERIMENT_BRANCHES || {};
  toggleExperiment(win, experimentName, !!branchId, true);
  win.__AMP_EXPERIMENT_BRANCHES[experimentName] = branchId;
}

},{"./log":123,"./mode":124,"./service":130,"./url":142,"./utils/object":149}],113:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.exponentialBackoff = exponentialBackoff;
exports.exponentialBackoffClock = exponentialBackoffClock;
exports.getJitter = getJitter;

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param {number=} opt_base Exponential base. Defaults to 2.
 * @return {function(function()): number} Function that when invoked will
 *     call the passed in function. On every invocation the next
 *     invocation of the passed in function will be exponentially
 *     later. Returned function returns timeout id.
 */
function exponentialBackoff(opt_base) {
  var getTimeout = exponentialBackoffClock(opt_base);
  return function (work) {
    return setTimeout(work, getTimeout());
  };
}

/**
 * @param {number=} opt_base Exponential base. Defaults to 2.
 * @return {function(): number} Function that when invoked will return
 *    a number that exponentially grows per invocation.
 */
function exponentialBackoffClock(opt_base) {
  var base = opt_base || 2;
  var count = 0;
  return function () {
    var wait = Math.pow(base, count++);
    wait += getJitter(wait);
    return wait * 1000;
  };
}

/**
 * Add jitter to avoid the thundering herd. This can e.g. happen when
 * we poll a backend and it fails for everyone at the same time.
 * We add up to 30% (default) longer or shorter than the given time.
 *
 * @param {number} wait the amount if base milliseconds
 * @param {number=} opt_perc the min/max percentage to add or sutract
 * @return {number}
 */
function getJitter(wait, opt_perc) {
  opt_perc = opt_perc || 0.3;
  var jitter = wait * opt_perc * Math.random();

  if (Math.random() > 0.5) {
    jitter *= -1;
  }

  return jitter;
}

},{}],114:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isAmp4Email = isAmp4Email;
exports.isAmphtml = isAmphtml;

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Checks that the document is of an AMP format type.
 * @param {!Array<string>} formats
 * @param {!Document} doc
 * @return {boolean}
 */
function isAmpFormatType(formats, doc) {
  var html = doc.documentElement;
  var isFormatType = formats.some(function (format) {
    return html.hasAttribute(format);
  });
  return isFormatType;
}

/**
 * @param {!Document} doc
 * @return {boolean}
 */
function isAmp4Email(doc) {
  return isAmpFormatType(['⚡4email', 'amp4email'], doc);
}

/**
 * @param {!Document} doc
 * @return {boolean}
 */
function isAmphtml(doc) {
  return isAmpFormatType(['⚡', 'amp'], doc);
}

},{}],115:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.PinchRecognizer = exports.PinchDef = exports.TapzoomRecognizer = exports.SwipeYRecognizer = exports.SwipeXRecognizer = exports.SwipeXYRecognizer = exports.SwipeDef = exports.DoubletapRecognizer = exports.DoubletapDef = exports.TapRecognizer = exports.TapDef = void 0;

var _gesture = require("./gesture");

var _motion = require("./motion");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DOUBLETAP_DELAY = 200;

/**
 * A "tap" gesture.
 * @typedef {{
 *   clientX: number,
 *   clientY: number
 * }}
 */
var TapDef;
exports.TapDef = TapDef;

/**
 * Recognizes "tap" gestures.
 * @extends {GestureRecognizer<TapDef>}
 */
var TapRecognizer = /*#__PURE__*/function (_GestureRecognizer) {
  _inherits(TapRecognizer, _GestureRecognizer);

  var _super = _createSuper(TapRecognizer);

  /**
   * @param {!./gesture.Gestures} manager
   */
  function TapRecognizer(manager) {
    var _this;

    _classCallCheck(this, TapRecognizer);

    _this = _super.call(this, 'tap', manager);

    /** @private {number} */
    _this.startX_ = 0;

    /** @private {number} */
    _this.startY_ = 0;

    /** @private {number} */
    _this.lastX_ = 0;

    /** @private {number} */
    _this.lastY_ = 0;

    /** @private {?EventTarget} */
    _this.target_ = null;
    return _this;
  }

  /** @override */
  _createClass(TapRecognizer, [{
    key: "onTouchStart",
    value: function onTouchStart(e) {
      var touches = e.touches;
      this.target_ = e.target;

      if (touches && touches.length == 1) {
        this.startX_ = touches[0].clientX;
        this.startY_ = touches[0].clientY;
        return true;
      } else {
        return false;
      }
    }
    /** @override */

  }, {
    key: "onTouchMove",
    value: function onTouchMove(e) {
      var touches = e.changedTouches || e.touches;

      if (touches && touches.length == 1) {
        this.lastX_ = touches[0].clientX;
        this.lastY_ = touches[0].clientY;
        var dx = Math.abs(this.lastX_ - this.startX_) >= 8;
        var dy = Math.abs(this.lastY_ - this.startY_) >= 8;

        if (dx || dy) {
          return false;
        }
      }

      return true;
    }
    /** @override */

  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(unusedE) {
      this.signalReady(0);
    }
    /** @override */

  }, {
    key: "acceptStart",
    value: function acceptStart() {
      this.signalEmit({
        clientX: this.lastX_,
        clientY: this.lastY_,
        target: this.target_
      }, null);
      this.signalEnd();
    }
  }]);

  return TapRecognizer;
}(_gesture.GestureRecognizer);

exports.TapRecognizer = TapRecognizer;

/**
 * A "doubletap" gesture.
 * @typedef {{
 *   clientX: number,
 *   clientY: number
 * }}
 */
var DoubletapDef;
exports.DoubletapDef = DoubletapDef;

/**
 * Recognizes a "doubletap" gesture. This gesture will block a single "tap"
 * for about 200ms while it's expecting the second "tap".
 * @extends {GestureRecognizer<DoubletapDef>}
 */
var DoubletapRecognizer = /*#__PURE__*/function (_GestureRecognizer2) {
  _inherits(DoubletapRecognizer, _GestureRecognizer2);

  var _super2 = _createSuper(DoubletapRecognizer);

  /**
   * @param {!./gesture.Gestures} manager
   */
  function DoubletapRecognizer(manager) {
    var _this2;

    _classCallCheck(this, DoubletapRecognizer);

    _this2 = _super2.call(this, 'doubletap', manager);

    /** @private {number} */
    _this2.startX_ = 0;

    /** @private {number} */
    _this2.startY_ = 0;

    /** @private {number} */
    _this2.lastX_ = 0;

    /** @private {number} */
    _this2.lastY_ = 0;

    /** @private {number} */
    _this2.tapCount_ = 0;

    /** @private {?Event} */
    _this2.event_ = null;
    return _this2;
  }

  /** @override */
  _createClass(DoubletapRecognizer, [{
    key: "onTouchStart",
    value: function onTouchStart(e) {
      if (this.tapCount_ > 1) {
        return false;
      }

      var touches = e.touches;

      if (touches && touches.length == 1) {
        this.startX_ = touches[0].clientX;
        this.startY_ = touches[0].clientY;
        this.lastX_ = touches[0].clientX;
        this.lastY_ = touches[0].clientY;
        return true;
      } else {
        return false;
      }
    }
    /** @override */

  }, {
    key: "onTouchMove",
    value: function onTouchMove(e) {
      var touches = e.touches;

      if (touches && touches.length == 1) {
        this.lastX_ = touches[0].clientX;
        this.lastY_ = touches[0].clientY;
        var dx = Math.abs(this.lastX_ - this.startX_) >= 8;
        var dy = Math.abs(this.lastY_ - this.startY_) >= 8;

        if (dx || dy) {
          this.acceptCancel();
          return false;
        }

        return true;
      } else {
        return false;
      }
    }
    /** @override */

  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(e) {
      this.tapCount_++;

      if (this.tapCount_ < 2) {
        this.signalPending(DOUBLETAP_DELAY);
      } else {
        this.event_ = e;
        this.signalReady(0);
      }
    }
    /** @override */

  }, {
    key: "acceptStart",
    value: function acceptStart() {
      this.tapCount_ = 0;
      this.signalEmit({
        clientX: this.lastX_,
        clientY: this.lastY_
      }, this.event_);
      this.signalEnd();
    }
    /** @override */

  }, {
    key: "acceptCancel",
    value: function acceptCancel() {
      this.tapCount_ = 0;
    }
  }]);

  return DoubletapRecognizer;
}(_gesture.GestureRecognizer);

exports.DoubletapRecognizer = DoubletapRecognizer;

/**
 * A "swipe-xy", "swipe-x" or "swipe-y" gesture. A number of these gestures
 * may be emitted for a single touch series.
 * @typedef {{
 *   first: boolean,
 *   last: boolean,
 *   deltaX: number,
 *   deltaY: number,
 *   velocityX: number,
 *   velocityY: number
 * }}
 */
var SwipeDef;
exports.SwipeDef = SwipeDef;

/**
 * Recognizes swipe gestures. This gesture will yield about 10ms to other
 * gestures.
 * @extends {GestureRecognizer<SwipeDef>}
 */
var SwipeRecognizer = /*#__PURE__*/function (_GestureRecognizer3) {
  _inherits(SwipeRecognizer, _GestureRecognizer3);

  var _super3 = _createSuper(SwipeRecognizer);

  /**
   * @param {string} type
   * @param {!./gesture.Gestures} manager
   * @param {boolean} horiz
   * @param {boolean} vert
   */
  function SwipeRecognizer(type, manager, horiz, vert) {
    var _this3;

    _classCallCheck(this, SwipeRecognizer);

    _this3 = _super3.call(this, type, manager);

    /** @private {boolean} */
    _this3.horiz_ = horiz;

    /** @private {boolean} */
    _this3.vert_ = vert;

    /** @private {boolean} */
    _this3.eventing_ = false;

    /** @private {number} */
    _this3.startX_ = 0;

    /** @private {number} */
    _this3.startY_ = 0;

    /** @private {number} */
    _this3.lastX_ = 0;

    /** @private {number} */
    _this3.lastY_ = 0;

    /** @private {number} */
    _this3.prevX_ = 0;

    /** @private {number} */
    _this3.prevY_ = 0;

    /** @private {time} */
    _this3.startTime_ = 0;

    /** @private {time} */
    _this3.lastTime_ = 0;

    /** @private {time} */
    _this3.prevTime_ = 0;

    /** @private {number} */
    _this3.velocityX_ = 0;

    /** @private {number} */
    _this3.velocityY_ = 0;
    return _this3;
  }

  /** @override */
  _createClass(SwipeRecognizer, [{
    key: "onTouchStart",
    value: function onTouchStart(e) {
      var touches = e.touches;

      // If already eventing, ignore additional touches
      if (this.eventing_ && touches && touches.length > 1) {
        return true;
      }

      if (touches && touches.length == 1) {
        this.startTime_ = Date.now();
        this.startX_ = touches[0].clientX;
        this.startY_ = touches[0].clientY;
        return true;
      } else {
        return false;
      }
    }
    /** @override */

  }, {
    key: "onTouchMove",
    value: function onTouchMove(e) {
      var touches = e.touches;

      if (touches && touches.length >= 1) {
        var _touches$ = touches[0],
            x = _touches$.clientX,
            y = _touches$.clientY;
        this.lastX_ = x;
        this.lastY_ = y;

        if (this.eventing_) {
          // If already eventing, always emit new coordinates
          this.emit_(false, false, e);
        } else {
          // Figure out whether or not we should start eventing
          var dx = Math.abs(x - this.startX_);
          var dy = Math.abs(y - this.startY_);

          // Swipe is penalized slightly since it's one of the least demanding
          // gesture, thus -10 in signalReady.
          if (this.horiz_ && this.vert_) {
            if (dx >= 8 || dy >= 8) {
              this.signalReady(-10);
            }
          } else if (this.horiz_) {
            if (dx >= 8 && dx > dy) {
              this.signalReady(-10);
            } else if (dy >= 8) {
              return false;
            }
          } else if (this.vert_) {
            if (dy >= 8 && dy > dx) {
              this.signalReady(-10);
            } else if (dx >= 8) {
              return false;
            }
          } else {
            return false;
          }
        }

        return true;
      } else {
        return false;
      }
    }
    /** @override */

  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(e) {
      var touches = e.touches;

      // Number of current touches on the page
      if (touches && touches.length == 0) {
        this.end_(e);
      }
    }
    /** @override */

  }, {
    key: "acceptStart",
    value: function acceptStart() {
      this.eventing_ = true;
      // Reset start coordinates to where the gesture began to avoid visible
      // jump, but preserve them as "prev" coordinates to calculate the right
      // velocity.
      this.prevX_ = this.startX_;
      this.prevY_ = this.startY_;
      this.prevTime_ = this.startTime_;
      this.startX_ = this.lastX_;
      this.startY_ = this.lastY_;
      this.emit_(true, false, null);
    }
    /** @override */

  }, {
    key: "acceptCancel",
    value: function acceptCancel() {
      this.eventing_ = false;
    }
    /**
     * @param {boolean} first
     * @param {boolean} last
     * @param {?Event} event
     * @private
     */

  }, {
    key: "emit_",
    value: function emit_(first, last, event) {
      this.lastTime_ = Date.now();
      var deltaTime = this.lastTime_ - this.prevTime_;

      // It's often that `touchend` arrives on the next frame. These should
      // be ignored to avoid a significant velocity downgrade.
      if (!last && deltaTime > 4 || last && deltaTime > 16) {
        var velocityX = (0, _motion.calcVelocity)(this.lastX_ - this.prevX_, deltaTime, this.velocityX_);
        var velocityY = (0, _motion.calcVelocity)(this.lastY_ - this.prevY_, deltaTime, this.velocityY_);

        // On iOS, the touchend will always have the same x/y position as the
        // last touchmove, so we want to make sure we do not remove the velocity.
        // The touchend event with zero velocity can occur within a couple of
        // frames of the last touchmove.
        if (!last || deltaTime > 32 || velocityX != 0 || velocityY != 0) {
          this.velocityX_ = Math.abs(velocityX) > 1e-4 ? velocityX : 0;
          this.velocityY_ = Math.abs(velocityY) > 1e-4 ? velocityY : 0;
        }

        this.prevX_ = this.lastX_;
        this.prevY_ = this.lastY_;
        this.prevTime_ = this.lastTime_;
      }

      this.signalEmit({
        first: first,
        last: last,
        time: this.lastTime_,
        deltaX: this.lastX_ - this.startX_,
        deltaY: this.lastY_ - this.startY_,
        startX: this.startX_,
        startY: this.startY_,
        lastX: this.lastX_,
        lastY: this.lastY_,
        velocityX: this.velocityX_,
        velocityY: this.velocityY_
      }, event);
    }
    /**
     * @param {?Event} event
     * @private
     */

  }, {
    key: "end_",
    value: function end_(event) {
      if (this.eventing_) {
        this.eventing_ = false;
        this.emit_(false, true, event);
        this.signalEnd();
      }
    }
  }]);

  return SwipeRecognizer;
}(_gesture.GestureRecognizer);

/**
 * Recognizes "swipe-xy" gesture. Yields about 10ms to other gestures.
 */
var SwipeXYRecognizer = /*#__PURE__*/function (_SwipeRecognizer) {
  _inherits(SwipeXYRecognizer, _SwipeRecognizer);

  var _super4 = _createSuper(SwipeXYRecognizer);

  /**
   * @param {!./gesture.Gestures} manager
   */
  function SwipeXYRecognizer(manager) {
    _classCallCheck(this, SwipeXYRecognizer);

    return _super4.call(this, 'swipe-xy', manager, true, true);
  }

  return SwipeXYRecognizer;
}(SwipeRecognizer);

exports.SwipeXYRecognizer = SwipeXYRecognizer;

/**
 * Recognizes "swipe-x" gesture. Yields about 10ms to other gestures.
 */
var SwipeXRecognizer = /*#__PURE__*/function (_SwipeRecognizer2) {
  _inherits(SwipeXRecognizer, _SwipeRecognizer2);

  var _super5 = _createSuper(SwipeXRecognizer);

  /**
   * @param {!./gesture.Gestures} manager
   */
  function SwipeXRecognizer(manager) {
    _classCallCheck(this, SwipeXRecognizer);

    return _super5.call(this, 'swipe-x', manager, true, false);
  }

  return SwipeXRecognizer;
}(SwipeRecognizer);

exports.SwipeXRecognizer = SwipeXRecognizer;

/**
 * Recognizes "swipe-y" gesture. Yields about 10ms to other gestures.
 */
var SwipeYRecognizer = /*#__PURE__*/function (_SwipeRecognizer3) {
  _inherits(SwipeYRecognizer, _SwipeRecognizer3);

  var _super6 = _createSuper(SwipeYRecognizer);

  /**
   * @param {!./gesture.Gestures} manager
   */
  function SwipeYRecognizer(manager) {
    _classCallCheck(this, SwipeYRecognizer);

    return _super6.call(this, 'swipe-y', manager, false, true);
  }

  return SwipeYRecognizer;
}(SwipeRecognizer);

exports.SwipeYRecognizer = SwipeYRecognizer;

/**
 * A "tapzoom" gesture. It has a center, delta off the center center and
 * the velocity of moving away from the center.
 * @typedef {{
 *   first: boolean,
 *   last: boolean,
 *   centerClientX: number,
 *   centerClientY: number,
 *   deltaX: number,
 *   deltaY: number,
 *   velocityX: number,
 *   velocityY: number
 * }}
 */
var TapzoomDef;

/**
 * Recognizes a "tapzoom" gesture. This gesture will block other gestures
 * for about 400ms after first "tap" while it's expecting swipe.
 * @extends {GestureRecognizer<TapzoomDef>}
 */
var TapzoomRecognizer = /*#__PURE__*/function (_GestureRecognizer4) {
  _inherits(TapzoomRecognizer, _GestureRecognizer4);

  var _super7 = _createSuper(TapzoomRecognizer);

  /**
   * @param {!./gesture.Gestures} manager
   */
  function TapzoomRecognizer(manager) {
    var _this4;

    _classCallCheck(this, TapzoomRecognizer);

    _this4 = _super7.call(this, 'tapzoom', manager);

    /** @private {boolean} */
    _this4.eventing_ = false;

    /** @private {number} */
    _this4.startX_ = 0;

    /** @private {number} */
    _this4.startY_ = 0;

    /** @private {number} */
    _this4.lastX_ = 0;

    /** @private {number} */
    _this4.lastY_ = 0;

    /** @private {number} */
    _this4.tapCount_ = 0;

    /** @private {number} */
    _this4.prevX_ = 0;

    /** @private {number} */
    _this4.prevY_ = 0;

    /** @private {time} */
    _this4.lastTime_ = 0;

    /** @private {time} */
    _this4.prevTime_ = 0;

    /** @private {number} */
    _this4.velocityX_ = 0;

    /** @private {number} */
    _this4.velocityY_ = 0;
    return _this4;
  }

  /** @override */
  _createClass(TapzoomRecognizer, [{
    key: "onTouchStart",
    value: function onTouchStart(e) {
      if (this.eventing_) {
        return false;
      }

      var touches = e.touches;

      if (touches && touches.length == 1) {
        this.startX_ = touches[0].clientX;
        this.startY_ = touches[0].clientY;
        return true;
      } else {
        return false;
      }
    }
    /** @override */

  }, {
    key: "onTouchMove",
    value: function onTouchMove(e) {
      var touches = e.touches;

      if (touches && touches.length == 1) {
        this.lastX_ = touches[0].clientX;
        this.lastY_ = touches[0].clientY;

        if (this.eventing_) {
          this.emit_(false, false, e);
        } else {
          var dx = Math.abs(this.lastX_ - this.startX_) >= 8;
          var dy = Math.abs(this.lastY_ - this.startY_) >= 8;

          if (dx || dy) {
            if (this.tapCount_ == 0) {
              this.acceptCancel();
              return false;
            } else {
              this.signalReady(0);
            }
          }
        }

        return true;
      } else {
        return false;
      }
    }
    /** @override */

  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(e) {
      if (this.eventing_) {
        this.end_(e);
        return;
      }

      this.tapCount_++;

      if (this.tapCount_ == 1) {
        this.signalPending(400);
        return;
      }

      this.acceptCancel();
    }
    /** @override */

  }, {
    key: "acceptStart",
    value: function acceptStart() {
      this.tapCount_ = 0;
      this.eventing_ = true;
      this.emit_(true, false, null);
    }
    /** @override */

  }, {
    key: "acceptCancel",
    value: function acceptCancel() {
      this.tapCount_ = 0;
      this.eventing_ = false;
    }
    /**
     * @param {boolean} first
     * @param {boolean} last
     * @param {?Event} event
     * @private
     */

  }, {
    key: "emit_",
    value: function emit_(first, last, event) {
      this.lastTime_ = Date.now();

      if (first) {
        this.velocityX_ = this.velocityY_ = 0;
      } else if (this.lastTime_ - this.prevTime_ > 2) {
        this.velocityX_ = (0, _motion.calcVelocity)(this.lastX_ - this.prevX_, this.lastTime_ - this.prevTime_, this.velocityX_);
        this.velocityY_ = (0, _motion.calcVelocity)(this.lastY_ - this.prevY_, this.lastTime_ - this.prevTime_, this.velocityY_);
      }

      this.prevX_ = this.lastX_;
      this.prevY_ = this.lastY_;
      this.prevTime_ = this.lastTime_;
      this.signalEmit({
        first: first,
        last: last,
        centerClientX: this.startX_,
        centerClientY: this.startY_,
        deltaX: this.lastX_ - this.startX_,
        deltaY: this.lastY_ - this.startY_,
        velocityX: this.velocityX_,
        velocityY: this.velocityY_
      }, event);
    }
    /**
     * @param {?Event} event
     * @private
     */

  }, {
    key: "end_",
    value: function end_(event) {
      if (this.eventing_) {
        this.eventing_ = false;
        this.emit_(false, true, event);
        this.signalEnd();
      }
    }
  }]);

  return TapzoomRecognizer;
}(_gesture.GestureRecognizer);

exports.TapzoomRecognizer = TapzoomRecognizer;

/**
 * A "pinch" gesture. It has a center, delta off the center center and
 * the velocity of moving away from the center. "dir" component of `1`
 * indicates that it's a expand motion and `-1` indicates pinch motion.
 * @typedef {{
 *   first: boolean,
 *   last: boolean,
 *   centerClientX: number,
 *   centerClientY: number,
 *   dir: number,
 *   deltaX: number,
 *   deltaY: number,
 *   velocityX: number,
 *   velocityY: number
 * }}
 */
var PinchDef;
exports.PinchDef = PinchDef;

/**
 * Threshold in pixels for how much two touches move away from
 * each other before we recognize the gesture as a pinch.
 */
var PINCH_ACCEPT_THRESHOLD = 4;

/**
 * Threshold in pixels for how much two touches move in the same
 * direction before we reject the gesture as a pinch.
 */
var PINCH_REJECT_THRESHOLD = 10;

/**
 * Recognizes a "pinch" gesture.
 * @extends {GestureRecognizer<PinchDef>}
 */
var PinchRecognizer = /*#__PURE__*/function (_GestureRecognizer5) {
  _inherits(PinchRecognizer, _GestureRecognizer5);

  var _super8 = _createSuper(PinchRecognizer);

  /**
   * @param {!./gesture.Gestures} manager
   */
  function PinchRecognizer(manager) {
    var _this5;

    _classCallCheck(this, PinchRecognizer);

    _this5 = _super8.call(this, 'pinch', manager);

    /** @private {boolean} */
    _this5.eventing_ = false;

    /** @private {number} */
    _this5.startX1_ = 0;

    /** @private {number} */
    _this5.startY1_ = 0;

    /** @private {number} */
    _this5.startX2_ = 0;

    /** @private {number} */
    _this5.startY2_ = 0;

    /** @private {number} */
    _this5.lastX1_ = 0;

    /** @private {number} */
    _this5.lastY1_ = 0;

    /** @private {number} */
    _this5.lastX2_ = 0;

    /** @private {number} */
    _this5.lastY2_ = 0;

    /** @private {number} */
    _this5.prevDeltaX_ = 0;

    /** @private {number} */
    _this5.prevDeltaY_ = 0;

    /** @private {number} */
    _this5.centerClientX_ = 0;

    /** @private {number} */
    _this5.centerClientY_ = 0;

    /** @private {time} */
    _this5.startTime_ = 0;

    /** @private {time} */
    _this5.lastTime_ = 0;

    /** @private {time} */
    _this5.prevTime_ = 0;

    /** @private {number} */
    _this5.velocityX_ = 0;

    /** @private {number} */
    _this5.velocityY_ = 0;
    return _this5;
  }

  /** @override */
  _createClass(PinchRecognizer, [{
    key: "onTouchStart",
    value: function onTouchStart(e) {
      var touches = e.touches;

      if (!touches) {
        return false;
      }

      // Pinch touches are not always simultaneous, continue to listen
      // for second touch.
      if (touches.length == 1) {
        return true;
      }

      // If already in the middle of a pinch event, ignore additional touches.
      if (this.eventing_ && touches.length > 2) {
        return true;
      }

      if (touches.length == 2) {
        this.startTime_ = Date.now();
        this.startX1_ = touches[0].clientX;
        this.startY1_ = touches[0].clientY;
        this.startX2_ = touches[1].clientX;
        this.startY2_ = touches[1].clientY;
        return true;
      } else {
        return false;
      }
    }
    /** @override */

  }, {
    key: "onTouchMove",
    value: function onTouchMove(e) {
      var touches = e.touches;

      if (!touches || touches.length == 0) {
        return false;
      }

      // Pinch touches are not always simultaneous, continue to listen
      // for second touch.
      if (touches.length == 1) {
        return true;
      }

      // Have 2+ touches
      this.lastX1_ = touches[0].clientX;
      this.lastY1_ = touches[0].clientY;
      this.lastX2_ = touches[1].clientX;
      this.lastY2_ = touches[1].clientY;

      // If eventing, always emit gesture with new coordinates
      if (this.eventing_) {
        this.emit_(false, false, e);
        return true;
      }

      // Gesture is 2+ touch but direction indicates not a pinch
      if (this.isPinchRejected_()) {
        return false;
      }

      if (this.isPinchReady_()) {
        this.signalReady(0);
      }

      // Pinch gesture detected but threshold not reached, continue listening
      return true;
    }
    /**
     * @return {boolean}
     * @private
     */

  }, {
    key: "isPinchReady_",
    value: function isPinchReady_() {
      var dx1 = this.lastX1_ - this.startX1_;
      var dy1 = this.lastY1_ - this.startY1_;
      var dx2 = this.lastX2_ - this.startX2_;
      var dy2 = this.lastY2_ - this.startY2_;
      var pinchDirectionCorrect = dx1 * dx2 <= 0 && dy1 * dy2 <= 0;
      var xPinchRecognized = Math.abs(dx1 - dx2) >= PINCH_ACCEPT_THRESHOLD;
      var yPinchRecognized = Math.abs(dy1 - dy2) >= PINCH_ACCEPT_THRESHOLD;
      return pinchDirectionCorrect && (xPinchRecognized || yPinchRecognized);
    }
    /**
     * @return {boolean}
     * @private
     */

  }, {
    key: "isPinchRejected_",
    value: function isPinchRejected_() {
      var dx1 = this.lastX1_ - this.startX1_;
      var dy1 = this.lastY1_ - this.startY1_;
      var dx2 = this.lastX2_ - this.startX2_;
      var dy2 = this.lastY2_ - this.startY2_;
      var pinchDirectionIncorrect = dx1 * dx2 > 0 || dy1 * dy2 > 0;
      var xPinchRejected = Math.abs(dx1 + dx2) >= PINCH_REJECT_THRESHOLD;
      var yPinchRejected = Math.abs(dy1 + dy2) >= PINCH_REJECT_THRESHOLD;
      return pinchDirectionIncorrect && (xPinchRejected || yPinchRejected);
    }
    /** @override */

  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(e) {
      // Pinch requires at least two touches on the page
      var touches = e.touches;

      if (touches && touches.length < 2) {
        this.end_(e);
      }
    }
    /** @override */

  }, {
    key: "acceptStart",
    value: function acceptStart() {
      this.eventing_ = true;
      this.prevTime_ = this.startTime_;
      this.prevDeltaX_ = 0;
      this.prevDeltaY_ = 0;
      this.centerClientX_ = (this.startX1_ + this.startX2_) * 0.5;
      this.centerClientY_ = (this.startY1_ + this.startY2_) * 0.5;
      this.emit_(true, false, null);
    }
    /** @override */

  }, {
    key: "acceptCancel",
    value: function acceptCancel() {
      this.eventing_ = false;
    }
    /**
     * @param {boolean} first
     * @param {boolean} last
     * @param {?Event} event
     * @private
     */

  }, {
    key: "emit_",
    value: function emit_(first, last, event) {
      this.lastTime_ = Date.now();
      var deltaTime = this.lastTime_ - this.prevTime_;
      var deltaX = this.deltaX_();
      var deltaY = this.deltaY_();

      // It's often that `touchend` arrives on the next frame. These should
      // be ignored to avoid a significant velocity downgrade.
      if (!last && deltaTime > 4 || last && deltaTime > 16) {
        this.velocityX_ = (0, _motion.calcVelocity)(deltaX - this.prevDeltaX_, deltaTime, this.velocityX_);
        this.velocityY_ = (0, _motion.calcVelocity)(deltaY - this.prevDeltaY_, deltaTime, this.velocityY_);
        this.velocityX_ = Math.abs(this.velocityX_) > 1e-4 ? this.velocityX_ : 0;
        this.velocityY_ = Math.abs(this.velocityY_) > 1e-4 ? this.velocityY_ : 0;
        this.prevDeltaX_ = deltaX;
        this.prevDeltaY_ = deltaY;
        this.prevTime_ = this.lastTime_;
      }

      var startSq = this.sqDist_(this.startX1_, this.startX2_, this.startY1_, this.startY2_);
      var lastSq = this.sqDist_(this.lastX1_, this.lastX2_, this.lastY1_, this.lastY2_);
      this.signalEmit({
        first: first,
        last: last,
        time: this.lastTime_,
        centerClientX: this.centerClientX_,
        centerClientY: this.centerClientY_,
        dir: Math.sign(lastSq - startSq),
        deltaX: deltaX * 0.5,
        deltaY: deltaY * 0.5,
        velocityX: this.velocityX_ * 0.5,
        velocityY: this.velocityY_ * 0.5
      }, event);
    }
    /**
     * @param {?Event} event
     * @private
     */

  }, {
    key: "end_",
    value: function end_(event) {
      if (this.eventing_) {
        this.eventing_ = false;
        this.emit_(false, true, event);
        this.signalEnd();
      }
    }
    /**
     * @param {number} x1
     * @param {number} x2
     * @param {number} y1
     * @param {number} y2
     * @return {number}
     * @private
     */

  }, {
    key: "sqDist_",
    value: function sqDist_(x1, x2, y1, y2) {
      return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
    }
    /**
     * @return {number}
     * @private
     */

  }, {
    key: "deltaX_",
    value: function deltaX_() {
      return Math.abs(this.lastX1_ - this.startX1_ - (this.lastX2_ - this.startX2_));
    }
    /**
     * @return {number}
     * @private
     */

  }, {
    key: "deltaY_",
    value: function deltaY_() {
      return Math.abs(this.lastY1_ - this.startY1_ - (this.lastY2_ - this.startY2_));
    }
  }]);

  return PinchRecognizer;
}(_gesture.GestureRecognizer);

exports.PinchRecognizer = PinchRecognizer;

},{"./gesture":116,"./motion":125}],116:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.GestureRecognizer = exports.Gestures = exports.Gesture = void 0;

var _observable = require("./observable");

var _pass = require("./pass");

var _log = require("./log");

var _array = require("./utils/array");

var _eventHelperListen = require("./event-helper-listen");

var _types = require("./types");

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PROP_ = '__AMP_Gestures';

/**
 * A gesture object contains the type and data of the gesture such as
 * a tap or a double-tap or a swipe. See {@link GestureRecognizer} for
 * more details.
 * @struct
 * @const
 * @template DATA
 */
var Gesture =
/**
 * @param {string} type The gesture's string type.
 * @param {DATA} data The data of the gesture.
 * @param {time} time The time that the gesture has been emitted.
 * @param {?Event} event An optional browser event that resulted in the
 *   gesture.
 */
function Gesture(type, data, time, event) {
  _classCallCheck(this, Gesture);

  /** @const {string} */
  this.type = type;

  /** @const {DATA} */
  this.data = data;

  /** @const {number} */
  this.time = time;

  /** @const {?Event} */
  this.event = event;
};

exports.Gesture = Gesture;

/**
 * Gestures object manages all gestures on a particular element. It listens
 * to all pointer events and delegates them to individual gesture recognizers.
 * When a recognizer has recognized a gesture and ready to start emitting it
 * it requests permission to do so from this class which resolves conflicts
 * between competing recognizers to decide which gesture should go forward.
 */
var Gestures = /*#__PURE__*/function () {
  _createClass(Gestures, null, [{
    key: "get",

    /**
     * Creates if not yet created and returns the shared Gestures instance for
     * the specified element.
     * @param {!Element} element
     * @param {boolean=} opt_shouldNotPreventDefault
     * @param {boolean=} opt_shouldStopPropagation
     * @return {!Gestures}
     */
    value: function get(element, opt_shouldNotPreventDefault, opt_shouldStopPropagation) {
      if (opt_shouldNotPreventDefault === void 0) {
        opt_shouldNotPreventDefault = false;
      }

      if (opt_shouldStopPropagation === void 0) {
        opt_shouldStopPropagation = false;
      }

      var res = element[PROP_];

      if (!res) {
        res = new Gestures(element, opt_shouldNotPreventDefault, opt_shouldStopPropagation);
        element[PROP_] = res;
      }

      return res;
    }
    /**
     * @param {!Element} element
     * @param {boolean} shouldNotPreventDefault
     * @param {boolean} shouldStopPropagation
     */

  }]);

  function Gestures(element, shouldNotPreventDefault, shouldStopPropagation) {
    _classCallCheck(this, Gestures);

    /** @private {!Element} */
    this.element_ = element;

    /** @private {!Array<!GestureRecognizer>} */
    this.recognizers_ = [];

    /** @private {!Array<boolean>} */
    this.tracking_ = [];

    /** @private {!Array<time>} */
    this.ready_ = [];

    /** @private {!Array<time>} */
    this.pending_ = [];

    /** @private {?GestureRecognizer} */
    this.eventing_ = null;

    /** @private {boolean} */
    this.shouldNotPreventDefault_ = shouldNotPreventDefault;

    /** @private {boolean} */
    this.shouldStopPropagation_ = shouldStopPropagation;

    /**
     * This variable indicates that the eventing has stopped on this
     * event cycle.
     * @private {boolean}
     */
    this.wasEventing_ = false;

    /** @private {!Pass} */
    this.pass_ = new _pass.Pass((0, _types.toWin)(element.ownerDocument.defaultView), this.doPass_.bind(this));

    /** @private {!Observable} */
    this.pointerDownObservable_ = new _observable.Observable();

    /**
     * Observers for each type of registered gesture types.
     * @private {!Object<string, !Observable<!Gesture>>}
     */
    this.overservers_ = Object.create(null);

    /** @private @const {function(!Event)} */
    this.boundOnTouchStart_ = this.onTouchStart_.bind(this);

    /** @private @const {function(!Event)} */
    this.boundOnTouchEnd_ = this.onTouchEnd_.bind(this);

    /** @private @const {function(!Event)} */
    this.boundOnTouchMove_ = this.onTouchMove_.bind(this);

    /** @private @const {function(!Event)} */
    this.boundOnTouchCancel_ = this.onTouchCancel_.bind(this);
    var win = element.ownerDocument.defaultView;
    var passiveSupported = (0, _eventHelperListen.supportsPassiveEventListener)((0, _types.toWin)(win));
    this.element_.addEventListener('touchstart', this.boundOnTouchStart_, passiveSupported ? {
      passive: true
    } : false);
    this.element_.addEventListener('touchend', this.boundOnTouchEnd_);
    this.element_.addEventListener('touchmove', this.boundOnTouchMove_, passiveSupported ? {
      passive: true
    } : false);
    this.element_.addEventListener('touchcancel', this.boundOnTouchCancel_);

    /** @private {boolean} */
    this.passAfterEvent_ = false;
  }

  /**
   * Unsubscribes from all pointer events and removes the shared cache instance.
   */
  _createClass(Gestures, [{
    key: "cleanup",
    value: function cleanup() {
      this.element_.removeEventListener('touchstart', this.boundOnTouchStart_);
      this.element_.removeEventListener('touchend', this.boundOnTouchEnd_);
      this.element_.removeEventListener('touchmove', this.boundOnTouchMove_);
      this.element_.removeEventListener('touchcancel', this.boundOnTouchCancel_);
      delete this.element_[PROP_];
      this.pass_.cancel();
    }
    /**
     * Subscribes to a gesture emitted by the specified recognizer. For a first
     * gesture handler registered in this method the recognizer is installed
     * and from that point on it participates in the event processing.
     *
     * @param {function(new:GestureRecognizer, !Gestures)} recognizerConstr
     * @param {function(!Gesture)} handler
     * @return {!UnlistenDef}
     * @template DATA
     */

  }, {
    key: "onGesture",
    value: function onGesture(recognizerConstr, handler) {
      var recognizer = new recognizerConstr(this);
      var type = recognizer.getType();
      var overserver = this.overservers_[type];

      if (!overserver) {
        this.recognizers_.push(recognizer);
        overserver = new _observable.Observable();
        this.overservers_[type] = overserver;
      }

      return overserver.add(handler);
    }
    /**
     * Unsubscribes all handlers from the given gesture recognizer. Returns
     * true if anything was done. Returns false if there were no handlers
     * registered on the given gesture recognizer in first place.
     *
     * @param {function(new:GestureRecognizer, !Gestures)} recognizerConstr
     * @return {boolean}
     */

  }, {
    key: "removeGesture",
    value: function removeGesture(recognizerConstr) {
      var type = new recognizerConstr(this).getType();
      var overserver = this.overservers_[type];

      if (overserver) {
        overserver.removeAll();
        var index = (0, _array.findIndex)(this.recognizers_, function (e) {
          return e.getType() == type;
        });

        if (index < 0) {
          return false;
        }

        // Remove the recognizer as well as all associated tracking state
        this.recognizers_.splice(index, 1);
        this.ready_.splice(index, 1);
        this.pending_.splice(index, 1);
        this.tracking_.splice(index, 1);
        delete this.overservers_[type];
        return true;
      } else {
        return false;
      }
    }
    /**
     * Subscribes to pointer down events, such as "touchstart" or "mousedown".
     * @param {!Function} handler
     * @return {!UnlistenDef}
     */

  }, {
    key: "onPointerDown",
    value: function onPointerDown(handler) {
      return this.pointerDownObservable_.add(handler);
    }
    /**
     * Handles all "touchstart" events and dispatches them to the tracking
     * recognizers.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onTouchStart_",
    value: function onTouchStart_(event) {
      var now = Date.now();
      this.wasEventing_ = false;
      this.pointerDownObservable_.fire(event);

      for (var i = 0; i < this.recognizers_.length; i++) {
        if (this.ready_[i]) {
          // If the recognizer is in the "ready" state, it won't receive
          // any more touch series until it's allowed to emit.
          continue;
        }

        if (this.pending_[i] && this.pending_[i] < now) {
          // Pending state expired. Reset.
          this.stopTracking_(i);
        }

        if (this.recognizers_[i].onTouchStart(event)) {
          // When a recognizer is interested in the touch series it returns "true"
          // from its onTouchStart method. For this recognizer we start tracking
          // the whole series of touch events from touchstart to touchend. Other
          // recognizers will not receive them unless they return "true" from
          // onTouchStart.
          this.startTracking_(i);
        }
      }

      this.afterEvent_(event);
    }
    /**
     * Handles all "touchmove" events and dispatches them to the tracking
     * recognizers.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onTouchMove_",
    value: function onTouchMove_(event) {
      var now = Date.now();

      for (var i = 0; i < this.recognizers_.length; i++) {
        if (!this.tracking_[i]) {
          // The whole touch series are ignored for non-tracking recognizers.
          continue;
        }

        if (this.pending_[i] && this.pending_[i] < now) {
          // Pending state expired. Reset.
          this.stopTracking_(i);
          continue;
        }

        if (!this.recognizers_[i].onTouchMove(event)) {
          // Recognizer lost interest in the series. Reset.
          this.stopTracking_(i);
        }
      }

      this.afterEvent_(event);
    }
    /**
     * Handles all "touchend" events and dispatches them to the tracking
     * recognizers.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onTouchEnd_",
    value: function onTouchEnd_(event) {
      var now = Date.now();

      for (var i = 0; i < this.recognizers_.length; i++) {
        if (!this.tracking_[i]) {
          // The whole touch series are ignored for non-tracking recognizers.
          continue;
        }

        if (this.pending_[i] && this.pending_[i] < now) {
          // Pending state expired. Reset.
          this.stopTracking_(i);
          continue;
        }

        this.recognizers_[i].onTouchEnd(event);
        var isReady = !this.pending_[i];
        var isExpired = this.pending_[i] < now;
        var isEventing = this.eventing_ == this.recognizers_[i];

        if (!isEventing && (isReady || isExpired)) {
          this.stopTracking_(i);
        }
      }

      this.afterEvent_(event);
    }
    /**
     * Handles all "touchcancel" events. Cancels all tracking/emitting
     * recognizers.
     * @param {!Event} event
     * @private
     */

  }, {
    key: "onTouchCancel_",
    value: function onTouchCancel_(event) {
      for (var i = 0; i < this.recognizers_.length; i++) {
        this.cancelEventing_(i);
      }

      this.afterEvent_(event);
    }
    /**
     * Callback for a gesture recognizer to communicate that it's ready to
     * start emitting gestures. Gestures instance may or may not allow the
     * recognizer to proceed.
     * @param {!GestureRecognizer} recognizer
     * @param {number} offset
     * @private
     * @restricted
     * @visibleForTesting
     */

  }, {
    key: "signalReady_",
    value: function signalReady_(recognizer, offset) {
      // Somebody got here first.
      if (this.eventing_) {
        recognizer.acceptCancel();
        return;
      }

      // Set the recognizer as ready and wait for the pass to
      // make the decision.
      var now = Date.now();

      for (var i = 0; i < this.recognizers_.length; i++) {
        if (this.recognizers_[i] == recognizer) {
          this.ready_[i] = now + offset;
          this.pending_[i] = 0;
        }
      }

      this.passAfterEvent_ = true;
    }
    /**
     * Callback for a gesture recognizer to communicate that it's close to
     * start emitting gestures, but needs more time to see more events. Once
     * this time expires the recognizer should either signal readiness or it
     * will be canceled.
     * @param {!GestureRecognizer} recognizer
     * @param {number} timeLeft
     * @private
     * @restricted
     * @visibleForTesting
     */

  }, {
    key: "signalPending_",
    value: function signalPending_(recognizer, timeLeft) {
      // Somebody got here first.
      if (this.eventing_) {
        recognizer.acceptCancel();
        return;
      }

      var now = Date.now();

      for (var i = 0; i < this.recognizers_.length; i++) {
        if (this.recognizers_[i] == recognizer) {
          this.pending_[i] = now + timeLeft;
        }
      }
    }
    /**
     * Callback for a gesture recognizer to communicate that it's done
     * emitting gestures.
     * @param {!GestureRecognizer} recognizer
     * @private
     * @restricted
     * @visibleForTesting
     */

  }, {
    key: "signalEnd_",
    value: function signalEnd_(recognizer) {
      if (this.eventing_ == recognizer) {
        this.eventing_ = null;
        this.wasEventing_ = true;
      }
    }
    /**
     * Callback for a gesture emit the gesture. Only the currently emitting
     * recognizer is allowed to emit gestures.
     * @param {!GestureRecognizer} recognizer
     * @param {*} data
     * @param {?Event} event
     * @private
     * @restricted
     * @visibleForTesting
     */

  }, {
    key: "signalEmit_",
    value: function signalEmit_(recognizer, data, event) {
      (0, _log.devAssert)(this.eventing_ == recognizer, 'Recognizer is not currently allowed: %s', recognizer.getType());
      var overserver = this.overservers_[recognizer.getType()];

      if (overserver) {
        overserver.fire(new Gesture(recognizer.getType(), data, Date.now(), event));
      }
    }
    /**
     * @param {!Event} event
     * @private
     */

  }, {
    key: "afterEvent_",
    value: function afterEvent_(event) {
      var cancelEvent = !!this.eventing_ || this.wasEventing_;
      this.wasEventing_ = false;

      if (!cancelEvent) {
        var now = Date.now();

        for (var i = 0; i < this.recognizers_.length; i++) {
          if (this.ready_[i] || this.pending_[i] && this.pending_[i] >= now) {
            cancelEvent = true;
            break;
          }
        }
      }

      if (cancelEvent) {
        event.stopPropagation();

        if (!this.shouldNotPreventDefault_) {
          event.preventDefault();
        }
      } else if (this.shouldStopPropagation_) {
        event.stopPropagation();
      }

      if (this.passAfterEvent_) {
        this.passAfterEvent_ = false;
        this.doPass_();
      }
    }
    /**
     * The pass that decides which recognizers can start emitting and which
     * are canceled.
     * @private
     */

  }, {
    key: "doPass_",
    value: function doPass_() {
      var now = Date.now();
      // The "most ready" recognizer is the youngest in the "ready" set.
      // Otherwise we wouldn't wait for it at all.
      var readyIndex = -1;

      for (var i = 0; i < this.recognizers_.length; i++) {
        if (!this.ready_[i]) {
          if (this.pending_[i] && this.pending_[i] < now) {
            // Pending state expired. Reset.
            this.stopTracking_(i);
          }

          continue;
        }

        if (readyIndex == -1 || this.ready_[i] > this.ready_[readyIndex]) {
          readyIndex = i;
        }
      }

      if (readyIndex == -1) {
        // Nothing to do.
        return;
      }

      // Look for conflicts.
      var waitTime = 0;

      for (var _i = 0; _i < this.recognizers_.length; _i++) {
        if (this.ready_[_i] || !this.tracking_[_i]) {
          continue;
        }

        waitTime = Math.max(waitTime, this.pending_[_i] - now);
      }

      if (waitTime < 2) {
        // We waited long enough.
        this.startEventing_(readyIndex);
        return;
      }

      // Some conflicts: have to wait to see who wins.
      this.pass_.schedule(waitTime);
    }
    /**
     * This recognizer is given "go ahead" and all others are canceled.
     * @param {number} index
     * @private
     */

  }, {
    key: "startEventing_",
    value: function startEventing_(index) {
      var recognizer = this.recognizers_[index];

      for (var i = 0; i < this.recognizers_.length; i++) {
        if (i != index) {
          this.cancelEventing_(i);
        }
      }

      this.ready_[index] = 0;
      this.pending_[index] = 0;
      this.eventing_ = recognizer;
      recognizer.acceptStart();
    }
    /**
     * @param {number} index
     * @private
     */

  }, {
    key: "startTracking_",
    value: function startTracking_(index) {
      this.tracking_[index] = true;
      this.pending_[index] = 0;
    }
    /**
     * @param {number} index
     * @private
     */

  }, {
    key: "stopTracking_",
    value: function stopTracking_(index) {
      this.tracking_[index] = false;
      this.pending_[index] = 0;

      if (!this.ready_[index]) {
        this.recognizers_[index].acceptCancel();
      }
    }
    /**
     * @param {number} index
     * @private
     */

  }, {
    key: "cancelEventing_",
    value: function cancelEventing_(index) {
      this.ready_[index] = 0;
      this.stopTracking_(index);
    }
  }]);

  return Gestures;
}();

exports.Gestures = Gestures;

/**
 * The gesture recognizer receives the pointer events from Gestures instance.
 * Based on these events, it can "recognize" the gesture it's responsible for,
 * request to start emitting and emit gestures. Gestures instances manages
 * several competing recognizers and decides which ones get to emit gestures
 * and which do not.
 *
 * The recognizer can be in several main states:
 * 1. Tracking state. In this state the recognizer is receiving the series of
 *    touch events from touchstart to touchend. To get into this state the
 *    recognizer has to return "true" from the {@link onTouchStart}.
 * 2. Pending state (optional). The recognizer matched part of the gesture,
 *    but needs more time to get track more events. It requests more time
 *    by calling {@link signalPending}, By the end of this time the recognizer
 *    has either matched the gesture or has been canceled.
 * 3. Ready state. The recognizer matched the whole gesture and ready to start
 *    emitting. It communicates to the Gestures this readiness by calling
 *    {@link signalReady}.
 * 5. Emitting state. If Gestures decides to go ahead with this recognizer, it
 *    will call {@link acceptStart} method. Otherwise, it will call
 *    {@link acceptCancel} method. Once in the emitting state, the recognizer
 *    can emit any number of events by calling {@link signalEmit}.
 * 6. Complete state. Once done, the recognizer can call {@link signalEnd} to
 *    communicate that it's done.
 *
 * @template DATA
 */
var GestureRecognizer = /*#__PURE__*/function () {
  /**
   * @param {string} type
   * @param {!Gestures} manager
   */
  function GestureRecognizer(type, manager) {
    _classCallCheck(this, GestureRecognizer);

    /** @private @const {string} */
    this.type_ = type;

    /** @private @const {!Gestures} */
    this.manager_ = manager;
  }

  /**
   * Returns the type of the gesture emitted by the instance of this class.
   * It has to be unique in the scope of the Gestures instance.
   * @return {string}
   */
  _createClass(GestureRecognizer, [{
    key: "getType",
    value: function getType() {
      return this.type_;
    }
    /**
     * The recognizer can call this method to communicate that it's ready to
     * start emitting the gesture. Optionally it can pass a zero, positive or
     * negative offset - a time on how much the gesture should be penalized or
     * given advantage in conflict resolution. The recognizer at this point is
     * in the "ready" state.
     * @param {time} offset
     */

  }, {
    key: "signalReady",
    value: function signalReady(offset) {
      this.manager_.signalReady_(this, offset);
    }
    /**
     * The recognizer can call this method to communicate that it needs more
     * time (timeLeft) to match the gesture. By the end of this time the
     * recognizer has to either transit to the ready state using
     * {@link signalReady} or it will be canceled. The recognizer is in the
     * "pending" state.
     * @param {time} timeLeft
     */

  }, {
    key: "signalPending",
    value: function signalPending(timeLeft) {
      this.manager_.signalPending_(this, timeLeft);
    }
    /**
     * The recognizer can call this method to communicate that it's done
     * emitting the gestures. It will return to the waiting state. Recognizer
     * can only call this method if it has previously received the
     * {@link acceptStart} call.
     */

  }, {
    key: "signalEnd",
    value: function signalEnd() {
      this.manager_.signalEnd_(this);
    }
    /**
     * The recognizer can call this method to emit the gestures while in the
     * "emitting" state. Recognizer can only call this method if it has
     * previously received the {@link acceptStart} call.
     * @param {DATA} data
     * @param {?Event} event
     */

  }, {
    key: "signalEmit",
    value: function signalEmit(data, event) {
      this.manager_.signalEmit_(this, data, event);
    }
    /**
     * The Gestures instance calls this method to allow the recognizer to start
     * emitting the gestures. At this point the recognizer is in the "emitting"
     * state. It will be in this state until it calls {@link signalEnd} or
     * the {@link acceptCancel} is called by the Gestures instance.
     */

  }, {
    key: "acceptStart",
    value: function acceptStart() {}
    /**
     * The Gestures instance calls this method to reset the recognizer. At this
     * point the recognizer is in the initial waiting state.
     */

  }, {
    key: "acceptCancel",
    value: function acceptCancel() {}
    /**
     * The Gestures instance calls this method for each "touchstart" event. If
     * the recognizer wants to receive other touch events in the series, it has
     * to return "true".
     * @param {!Event} unusedEvent
     * @return {boolean}
     */

  }, {
    key: "onTouchStart",
    value: function onTouchStart(unusedEvent) {
      return false;
    }
    /**
     * The Gestures instance calls this method for each "touchmove" event. If
     * the recognizer wants to continue receiving touch events in the series,
     * it has to return "true".
     * @param {!Event} unusedEvent
     * @return {boolean}
     */

  }, {
    key: "onTouchMove",
    value: function onTouchMove(unusedEvent) {
      return false;
    }
    /**
     * The Gestures instance calls this method for the "touchend" event.
     * Somewhere within this touch series the recognizer has to call
     * {@link signalReady} or {@link signalPending} or it will be reset for the
     * next touch series.
     * @param {!Event} unusedEvent
     */

  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(unusedEvent) {}
  }]);

  return GestureRecognizer;
}();

exports.GestureRecognizer = GestureRecognizer;

},{"./event-helper-listen":110,"./log":123,"./observable":126,"./pass":127,"./types":139,"./utils/array":143}],117:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getState = getState;

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Gets state from History.
 * But IE11 throws if there is no state.
 *
 * @param {!History} history
 * @return {*}
 */
function getState(history) {
  try {
    return history.state;
  } catch (e) {
    return null;
  }
}

},{}],118:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.listenFor = listenFor;
exports.listenForOncePromise = listenForOncePromise;
exports.postMessage = postMessage;
exports.postMessageToWindows = postMessageToWindows;
exports.parseIfNeeded = parseIfNeeded;
exports.looksLikeTrackingIframe = looksLikeTrackingIframe;
exports.isAdLike = isAdLike;
exports.disableScrollingOnIframe = disableScrollingOnIframe;
exports.canInspectWindow = canInspectWindow;
exports.getFriendlyIframeEmbedOptional = getFriendlyIframeEmbedOptional;
exports.isInFie = isInFie;
exports.makePausable = makePausable;
exports.isPausable = isPausable;
exports.setPaused = setPaused;
exports.FIE_EMBED_PROP = exports.SubscriptionApi = void 0;

var _dom = require("./dom");

var _pFrameMessaging = require("./3p-frame-messaging");

var _log = require("./log");

var _object = require("./utils/object");

var _eventHelper = require("./event-helper");

var _url = require("./url");

var _array = require("./utils/array");

var _style = require("./style");

var _json = require("./json");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sentinel used to force unlistening after a iframe is detached.
 * @type {string}
 */
var UNLISTEN_SENTINEL = 'unlisten';

/**
 * The iframe feature policy that forces the iframe to pause when it's not
 * display.
 * See https://github.com/dtapuska/iframe-freeze.
 */
var EXECUTION_WHILE_NOT_RENDERED = 'execution-while-not-rendered';

/**
 * @typedef {{
 *   frame: !Element,
 *   events: !Object<string, !Array<function(!JsonObject)>>
 * }}
 */
var WindowEventsDef;

/**
 * Returns a mapping from a URL's origin to an array of windows and their
 * listenFor listeners.
 * @param {?Window} parentWin the window that created the iframe
 * @param {boolean=} opt_create create the mapping if it does not exist
 * @return {?Object<string, !Array<!WindowEventsDef>>}
 */
function getListenFors(parentWin, opt_create) {
  var listeningFors = parentWin.listeningFors;

  if (!listeningFors && opt_create) {
    listeningFors = parentWin.listeningFors = Object.create(null);
  }

  return listeningFors || null;
}

/**
 * Returns an array of WindowEventsDef that have had any listenFor listeners
 * registered for this sentinel.
 * @param {?Window} parentWin the window that created the iframe
 * @param {string} sentinel the sentinel of the message
 * @param {boolean=} opt_create create the array if it does not exist
 * @return {?Array<!WindowEventsDef>}
 */
function getListenForSentinel(parentWin, sentinel, opt_create) {
  var listeningFors = getListenFors(parentWin, opt_create);

  if (!listeningFors) {
    return listeningFors;
  }

  var listenSentinel = listeningFors[sentinel];

  if (!listenSentinel && opt_create) {
    listenSentinel = listeningFors[sentinel] = [];
  }

  return listenSentinel || null;
}

/**
 * Returns an mapping of event names to listenFor listeners.
 * @param {?Window} parentWin the window that created the iframe
 * @param {!Element} iframe the iframe element who's context will trigger the
 *     event
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 * @return {?Object<string, !Array<function(!JsonObject, !Window, string, !MessageEvent)>>}
 */
function getOrCreateListenForEvents(parentWin, iframe, opt_is3P) {
  var sentinel = getSentinel_(iframe, opt_is3P);
  var listenSentinel = getListenForSentinel(parentWin, sentinel, true);
  var windowEvents;

  for (var i = 0; i < listenSentinel.length; i++) {
    var we = listenSentinel[i];

    if (we.frame === iframe) {
      windowEvents = we;
      break;
    }
  }

  if (!windowEvents) {
    windowEvents = {
      frame: iframe,
      events: Object.create(null)
    };
    listenSentinel.push(windowEvents);
  }

  return windowEvents.events;
}

/**
 * Returns an mapping of event names to listenFor listeners.
 * @param {?Window} parentWin the window that created the iframe
 * @param {string} sentinel the sentinel of the message
 * @param {string} origin the source window's origin
 * @param {?Window} triggerWin the window that triggered the event
 * @return {?Object<string, !Array<function(!JsonObject, !Window, string, !MessageEvent)>>}
 */
function getListenForEvents(parentWin, sentinel, origin, triggerWin) {
  var listenSentinel = getListenForSentinel(parentWin, sentinel);

  if (!listenSentinel) {
    return listenSentinel;
  }

  // Find the entry for the frame.
  // TODO(@nekodo): Add a WeakMap<Window, WindowEventsDef> cache to
  //     speed up this process.
  var windowEvents;

  for (var i = 0; i < listenSentinel.length; i++) {
    var we = listenSentinel[i];
    var contentWindow = we.frame.contentWindow;

    if (!contentWindow) {
      setTimeout(dropListenSentinel, 0, listenSentinel);
    } else if (triggerWin == contentWindow || isDescendantWindow(contentWindow, triggerWin)) {
      // 3p code path, we may accept messages from nested frames.
      windowEvents = we;
      break;
    }
  }

  return windowEvents ? windowEvents.events : null;
}

/**
 * Checks whether one window is a descendant of another by climbing
 * the parent chain.
 * @param {?Window} ancestor potential ancestor window
 * @param {?Window} descendant potential descendant window
 * @return {boolean}
 */
function isDescendantWindow(ancestor, descendant) {
  for (var win = descendant; win && win != win.parent; win = win.parent) {
    if (win == ancestor) {
      return true;
    }
  }

  return false;
}

/**
 * Removes any listenFors registed on listenSentinel that do not have
 * a contentWindow (the frame was removed from the DOM tree).
 * @param {!Array<!WindowEventsDef>} listenSentinel
 */
function dropListenSentinel(listenSentinel) {
  var noopData = (0, _object.dict)({
    'sentinel': UNLISTEN_SENTINEL
  });

  for (var i = listenSentinel.length - 1; i >= 0; i--) {
    var windowEvents = listenSentinel[i];

    if (!windowEvents.frame.contentWindow) {
      listenSentinel.splice(i, 1);
      var events = windowEvents.events;

      for (var name in events) {
        // Splice here, so that each unlisten does not shift the array
        events[name].splice(0, Infinity).forEach(function (event) {
          event(noopData);
        });
      }
    }
  }
}

/**
 * Registers the global listenFor event listener if it has yet to be.
 * @param {?Window} parentWin
 */
function registerGlobalListenerIfNeeded(parentWin) {
  if (parentWin.listeningFors) {
    return;
  }

  var listenForListener = function listenForListener(event) {
    if (!(0, _eventHelper.getData)(event)) {
      return;
    }

    var data = parseIfNeeded((0, _eventHelper.getData)(event));

    if (!data || !data['sentinel']) {
      return;
    }

    var listenForEvents = getListenForEvents(parentWin, data['sentinel'], event.origin, event.source);

    if (!listenForEvents) {
      return;
    }

    var listeners = listenForEvents[data['type']];

    if (!listeners) {
      return;
    }

    // We slice to avoid issues with adding another listener or unlistening
    // during iteration. We could move to a Doubly Linked List with
    // backtracking, but that's overly complicated.
    listeners = listeners.slice();

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener(data, event.source, event.origin, event);
    }
  };

  parentWin.addEventListener('message', listenForListener);
}

/**
 * Allows listening for message from the iframe. Returns an unlisten
 * function to remove the listener.
 *
 * @param {?Element} iframe
 * @param {string} typeOfMessage
 * @param {?function(!JsonObject, !Window, string, !MessageEvent)} callback Called when a
 *     message of this type arrives for this iframe.
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 * @param {boolean=} opt_includingNestedWindows set to true if messages from
 *     nested frames should also be accepted.
 * @param {boolean=} opt_allowOpaqueOrigin set to true if messages from
       opaque origins (origin == null) are allowed.
 * @return {!UnlistenDef}
 */
function listenFor(iframe, typeOfMessage, callback, opt_is3P, opt_includingNestedWindows, opt_allowOpaqueOrigin) {
  (0, _log.devAssert)(iframe.src, 'only iframes with src supported');
  (0, _log.devAssert)(!iframe.parentNode, 'cannot register events on an attached ' + 'iframe. It will cause hair-pulling bugs like #2942');
  (0, _log.devAssert)(callback);
  var parentWin = iframe.ownerDocument.defaultView;
  registerGlobalListenerIfNeeded(parentWin);
  var listenForEvents = getOrCreateListenForEvents(parentWin, iframe, opt_is3P);
  var iframeOrigin = (0, _url.parseUrlDeprecated)(iframe.src).origin;
  var events = listenForEvents[typeOfMessage] || (listenForEvents[typeOfMessage] = []);
  var unlisten;

  var listener = function listener(data, source, origin, event) {
    var sentinel = data['sentinel'];

    // Exclude messages that don't satisfy amp sentinel rules.
    if (sentinel == 'amp') {
      // For `amp` sentinel, nested windows are not allowed
      if (source != iframe.contentWindow) {
        return;
      }

      // For `amp` sentinel origin must match unless opaque origin is allowed
      var isOpaqueAndAllowed = origin == 'null' && opt_allowOpaqueOrigin;

      if (iframeOrigin != origin && !isOpaqueAndAllowed) {
        return;
      }
    }

    // Exclude nested frames if necessary.
    // Note that the source was already verified to be either the contentWindow
    // of the iframe itself or a descendant window within it.
    if (!opt_includingNestedWindows && source != iframe.contentWindow) {
      return;
    }

    if (data.sentinel == UNLISTEN_SENTINEL) {
      unlisten();
      return;
    }

    callback(data, source, origin, event);
  };

  events.push(listener);
  return unlisten = function unlisten() {
    if (listener) {
      var index = events.indexOf(listener);

      if (index > -1) {
        events.splice(index, 1);
      }

      // Make sure references to the unlisten function do not keep
      // alive too much.
      listener = null;
      events = null;
      callback = null;
    }
  };
}

/**
 * Returns a promise that resolves when one of given messages has been observed
 * for the first time. And remove listener for all other messages.
 * @param {!Element} iframe
 * @param {string|!Array<string>} typeOfMessages
 * @param {boolean=} opt_is3P
 * @return {!Promise<!{data: !JsonObject, source: !Window, origin: string, event: !MessageEvent}>}
 */
function listenForOncePromise(iframe, typeOfMessages, opt_is3P) {
  var unlistenList = [];

  if (typeof typeOfMessages == 'string') {
    typeOfMessages = [typeOfMessages];
  }

  return new Promise(function (resolve) {
    for (var i = 0; i < typeOfMessages.length; i++) {
      var message = typeOfMessages[i];
      var unlisten = listenFor(iframe, message, function (data, source, origin, event) {
        for (var _i = 0; _i < unlistenList.length; _i++) {
          unlistenList[_i]();
        }

        resolve({
          data: data,
          source: source,
          origin: origin,
          event: event
        });
      }, opt_is3P);
      unlistenList.push(unlisten);
    }
  });
}

/**
 * Posts a message to the iframe.
 * @param {!Element} iframe The iframe.
 * @param {string} type Type of the message.
 * @param {!JsonObject} object Message payload.
 * @param {string} targetOrigin origin of the target.
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 */
function postMessage(iframe, type, object, targetOrigin, opt_is3P) {
  postMessageToWindows(iframe, [{
    win: iframe.contentWindow,
    origin: targetOrigin
  }], type, object, opt_is3P);
}

/**
 * Posts an identical message to multiple target windows with the same
 * sentinel.
 * The message is serialized only once.
 * @param {!Element} iframe The iframe.
 * @param {!Array<{win: !Window, origin: string}>} targets to send the message
 *     to, pairs of window and its origin.
 * @param {string} type Type of the message.
 * @param {!JsonObject} object Message payload.
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 */
function postMessageToWindows(iframe, targets, type, object, opt_is3P) {
  if (!iframe.contentWindow) {
    return;
  }

  object['type'] = type;
  object['sentinel'] = getSentinel_(iframe, opt_is3P);
  var payload = object;

  if (opt_is3P) {
    // Serialize ourselves because that is much faster in Chrome.
    payload = 'amp-' + JSON.stringify(object);
  }

  for (var i = 0; i < targets.length; i++) {
    var target = targets[i];
    target.win.
    /*OK*/
    postMessage(payload, target.origin);
  }
}

/**
 * Gets the sentinel string.
 * @param {!Element} iframe The iframe.
 * @param {boolean=} opt_is3P set to true if the iframe is 3p.
 * @return {string} Sentinel string.
 * @private
 */
function getSentinel_(iframe, opt_is3P) {
  return opt_is3P ? iframe.getAttribute('data-amp-3p-sentinel') : 'amp';
}

/**
 * JSON parses event.data if it needs to be
 * @param {*} data
 * @return {?JsonObject} object message
 * @private
 * @visibleForTesting
 */
function parseIfNeeded(data) {
  if (typeof data == 'string') {
    if (data.charAt(0) == '{') {
      data = (0, _json.tryParseJson)(data, function (e) {
        (0, _log.dev)().warn('IFRAME-HELPER', 'Postmessage could not be parsed. ' + 'Is it in a valid JSON format?', e);
      }) || null;
    } else if ((0, _pFrameMessaging.isAmpMessage)(data)) {
      data = (0, _pFrameMessaging.deserializeMessage)(data);
    } else {
      data = null;
    }
  }

  return (
    /** @type {?JsonObject} */
    data
  );
}

/**
 * Manages a postMessage API for an iframe with a subscription message and
 * a way to broadcast messages to all subscribed windows, which
 * in turn must all be descendants of the contentWindow of the iframe.
 */
var SubscriptionApi = /*#__PURE__*/function () {
  /**
   * @param {!Element} iframe The iframe.
   * @param {string} type Type of the subscription message.
   * @param {boolean} is3p set to true if the iframe is 3p.
   * @param {function(!JsonObject, !Window, string)} requestCallback Callback
   *     invoked whenever a new window subscribes.
   */
  function SubscriptionApi(iframe, type, is3p, requestCallback) {
    var _this = this;

    _classCallCheck(this, SubscriptionApi);

    /** @private @const {!Element} */
    this.iframe_ = iframe;

    /** @private @const {boolean} */
    this.is3p_ = is3p;

    /** @private @const {!Array<{win: !Window, origin: string}>} */
    this.clientWindows_ = [];

    /** @private @const {!UnlistenDef} */
    this.unlisten_ = listenFor(this.iframe_, type, function (data, source, origin) {
      // This message might be from any window within the iframe, we need
      // to keep track of which windows want to be sent updates.
      if (!_this.clientWindows_.some(function (entry) {
        return entry.win == source;
      })) {
        _this.clientWindows_.push({
          win: source,
          origin: origin
        });
      }

      requestCallback(data, source, origin);
    }, this.is3p_, // For 3P frames we also allow nested frames within them to subscribe..
    this.is3p_
    /* opt_includingNestedWindows */
    );
  }

  /**
   * Sends a message to all subscribed windows.
   * @param {string} type Type of the message.
   * @param {!JsonObject} data Message payload.
   */
  _createClass(SubscriptionApi, [{
    key: "send",
    value: function send(type, data) {
      // Remove clients that have been removed from the DOM.
      (0, _array.remove)(this.clientWindows_, function (client) {
        return !client.win.parent;
      });
      postMessageToWindows(this.iframe_, this.clientWindows_, type, data, this.is3p_);
    }
    /**
     * Destroys iframe.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.unlisten_();
      this.clientWindows_.length = 0;
    }
  }]);

  return SubscriptionApi;
}();

exports.SubscriptionApi = SubscriptionApi;

/**
 * @param {!Element} element
 * @return {boolean}
 */
function looksLikeTrackingIframe(element) {
  var box = element.getLayoutBox();

  // This heuristic is subject to change.
  if (box.width > 10 || box.height > 10) {
    return false;
  }

  // Iframe is not tracking iframe if open with user interaction
  return !(0, _dom.closestAncestorElementBySelector)(element, '.i-amphtml-overlay');
}

// Most common ad sizes
// Array of [width, height] pairs.
var adSizes = [[300, 250], [320, 50], [300, 50], [320, 100]];

/**
 * Guess whether this element might be an ad.
 * @param {!Element} element An amp-iframe element.
 * @return {boolean}
 * @visibleForTesting
 */
function isAdLike(element) {
  var box = element.getLayoutBox();
  var height = box.height,
      width = box.width;

  for (var i = 0; i < adSizes.length; i++) {
    var refWidth = adSizes[i][0];
    var refHeight = adSizes[i][1];

    if (refHeight > height) {
      continue;
    }

    if (refWidth > width) {
      continue;
    }

    // Fuzzy matching to account for padding.
    if (height - refHeight <= 20 && width - refWidth <= 20) {
      return true;
    }
  }

  return false;
}

/**
 * @param {!Element} iframe
 * @return {!Element}
 */
function disableScrollingOnIframe(iframe) {
  (0, _dom.addAttributesToElement)(iframe, (0, _object.dict)({
    'scrolling': 'no'
  }));
  // This shouldn't work, but it does on Firefox.
  // https://stackoverflow.com/a/15494969
  (0, _style.setStyle)(iframe, 'overflow', 'hidden');
  return iframe;
}

/**
 * Returns true if win's properties can be accessed and win is defined.
 * This functioned is used to determine if a window is cross-domained
 * from the perspective of the current window.
 * @param {!Window} win
 * @return {boolean}
 */
function canInspectWindow(win) {
  // TODO: this is not reliable.  The compiler assumes that property reads are
  // side-effect free.  The recommended fix is to use goog.reflect.sinkValue
  // but since we're not using the closure library I'm not sure how to do this.
  // See https://github.com/google/closure-compiler/issues/3156
  try {
    // win['test'] could be truthy but not true the compiler shouldn't be able
    // to optimize this check away.
    return !!win.location.href && (win['test'] || true);
  } catch (unusedErr) {
    // eslint-disable-line no-unused-vars
    return false;
  }
}

/** @const {string} */
var FIE_EMBED_PROP = '__AMP_EMBED__';
exports.FIE_EMBED_PROP = FIE_EMBED_PROP;

/**
 * Returns the embed created using `installFriendlyIframeEmbed` or `null`.
 * Caution: This will only return the FIE after the iframe has 'loaded'. If you
 * are checking before this signal you may be in a race condition that returns
 * null.
 * @param {!HTMLIFrameElement} iframe
 * @return {?./friendly-iframe-embed.FriendlyIframeEmbed}
 */
function getFriendlyIframeEmbedOptional(iframe) {
  return (
    /** @type {?./friendly-iframe-embed.FriendlyIframeEmbed} */
    iframe[FIE_EMBED_PROP]
  );
}

/**
 * @param {!Element} element
 * @return {boolean}
 */
function isInFie(element) {
  return element.classList.contains('i-amphtml-fie') || !!(0, _dom.closestAncestorElementBySelector)(element, '.i-amphtml-fie');
}

/**
 * @param {!HTMLIFrameElement} iframe
 */
function makePausable(iframe) {
  var oldAllow = (iframe.getAttribute('allow') || '').trim();
  iframe.setAttribute('allow', EXECUTION_WHILE_NOT_RENDERED + " 'none';" + oldAllow);
}

/**
 * @param {!HTMLIFrameElement} iframe
 * @return {boolean}
 */
function isPausable(iframe) {
  return !!iframe.featurePolicy && iframe.featurePolicy.features().indexOf(EXECUTION_WHILE_NOT_RENDERED) != -1 && !iframe.featurePolicy.allowsFeature(EXECUTION_WHILE_NOT_RENDERED);
}

/**
 * @param {!HTMLIFrameElement} iframe
 * @param {boolean} paused
 */
function setPaused(iframe, paused) {
  (0, _style.toggle)(iframe, !paused);
}

},{"./3p-frame-messaging":95,"./dom":106,"./event-helper":111,"./json":120,"./log":123,"./style":138,"./url":142,"./utils/array":143,"./utils/object":149}],119:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.internalRuntimeVersion = internalRuntimeVersion;

/**
 * Copyright 2019 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns the internal AMP runtime version. Note that this is not the RTV,
 * which is a prefix and the runtime version.
 *
 * The call sites for this function are replaced with a compile time constant
 * string.
 *
 * @return {string}
 */
function internalRuntimeVersion() {
  return '$internalRuntimeVersion$';
}

},{}],120:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.recreateNonProtoObject = recreateNonProtoObject;
exports.getValueForExpr = getValueForExpr;
exports.parseJson = parseJson;
exports.tryParseJson = tryParseJson;
exports.getChildJsonConfig = getChildJsonConfig;
exports.deepEquals = deepEquals;
exports.jsonConfiguration = jsonConfiguration;
exports.jsonLiteral = jsonLiteral;
exports.includeJsonLiteral = includeJsonLiteral;

var _dom = require("./dom");

var _types = require("./types");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview This module declares JSON types as defined in the
 * {@link http://json.org/}.
 */
// NOTE Type are changed to {*} because of
// https://github.com/google/closure-compiler/issues/1999

/**
 * JSON scalar. It's either string, number or boolean.
 * @typedef {*} should be string|number|boolean|null
 */
var JSONScalarDef;

/**
 * JSON object. It's a map with string keys and JSON values.
 * @typedef {*} should be !Object<string, ?JSONValueDef>
 */
var JSONObjectDef;

/**
 * JSON array. It's an array with JSON values.
 * @typedef {*} should be !Array<?JSONValueDef>
 */
var JSONArrayDef;

/**
 * JSON value. It's either a scalar, an object or an array.
 * @typedef {*} should be !JSONScalarDef|!JSONObjectDef|!JSONArrayDef
 */
var JSONValueDef;

/**
 * Recreates objects with prototype-less copies.
 * @param {!JsonObject} obj
 * @return {!JsonObject}
 */
function recreateNonProtoObject(obj) {
  var copy = Object.create(null);

  for (var k in obj) {
    if (!hasOwnProperty(obj, k)) {
      continue;
    }

    var v = obj[k];
    copy[k] = (0, _types.isObject)(v) ? recreateNonProtoObject(v) : v;
  }

  return (
    /** @type {!JsonObject} */
    copy
  );
}

/**
 * Returns a value from an object for a field-based expression. The expression
 * is a simple nested dot-notation of fields, such as `field1.field2`. If any
 * field in a chain does not exist or is not an object or array, the returned
 * value will be `undefined`.
 *
 * @param {!JsonObject} obj
 * @param {string} expr
 * @return {*}
 */
function getValueForExpr(obj, expr) {
  // The `.` indicates "the object itself".
  if (expr == '.') {
    return obj;
  }

  // Otherwise, navigate via properties.
  var parts = expr.split('.');
  var value = obj;

  for (var i = 0; i < parts.length; i++) {
    var part = parts[i];

    if (part && value && value[part] !== undefined && hasOwnProperty(value, part)) {
      value = value[part];
      continue;
    }

    value = undefined;
    break;
  }

  return value;
}

/**
 * Simple wrapper around JSON.parse that casts the return value
 * to JsonObject.
 * Create a new wrapper if an array return value is desired.
 * @param {*} json JSON string to parse
 * @return {?JsonObject} May be extend to parse arrays.
 */
function parseJson(json) {
  return (
    /** @type {?JsonObject} */
    JSON.parse(
    /** @type {string} */
    json)
  );
}

/**
 * Parses the given `json` string without throwing an exception if not valid.
 * Returns `undefined` if parsing fails.
 * Returns the `Object` corresponding to the JSON string when parsing succeeds.
 * @param {*} json JSON string to parse
 * @param {function(!Error)=} opt_onFailed Optional function that will be called
 *     with the error if parsing fails.
 * @return {?JsonObject} May be extend to parse arrays.
 */
function tryParseJson(json, opt_onFailed) {
  try {
    return parseJson(json);
  } catch (e) {
    if (opt_onFailed) {
      opt_onFailed(e);
    }

    return null;
  }
}

/**
 * Helper method to get the json config from an element <script> tag
 * @param {!Element} element
 * @return {?JsonObject}
 * @throws {!Error} If element does not have exactly one <script> child
 * with type="application/json", or if the <script> contents are not valid JSON.
 */
function getChildJsonConfig(element) {
  var scripts = (0, _dom.childElementsByTag)(element, 'script');
  var n = scripts.length;

  if (n !== 1) {
    throw new Error("Found " + scripts.length + " <script> children. Expected 1.");
  }

  var script = scripts[0];

  if (!(0, _dom.isJsonScriptTag)(script)) {
    throw new Error('<script> child must have type="application/json"');
  }

  try {
    return parseJson(script.textContent);
  } catch (unusedError) {
    throw new Error('Failed to parse <script> contents. Is it valid JSON?');
  }
}

/**
 * Deeply checks strict equality of items in nested arrays and objects.
 *
 * @param {JSONValueDef} a
 * @param {JSONValueDef} b
 * @param {number} depth The maximum depth. Must be finite.
 * @return {boolean}
 * @throws {Error} If depth argument is not finite.
 */
function deepEquals(a, b, depth) {
  if (depth === void 0) {
    depth = 5;
  }

  if (!isFinite(depth) || depth < 0) {
    throw new Error('Invalid depth: ' + depth);
  }

  if (a === b) {
    return true;
  }

  /** @type {!Array<{a: JSONValueDef, b: JSONValueDef, depth: number}>} */
  var queue = [{
    a: a,
    b: b,
    depth: depth
  }];

  while (queue.length > 0) {
    var _queue$shift = queue.shift(),
        _a = _queue$shift.a,
        _b = _queue$shift.b,
        _depth = _queue$shift.depth;

    // Only check deep equality if depth > 0.
    if (_depth > 0) {
      if (typeof _a !== typeof _b) {
        return false;
      } else if (Array.isArray(_a) && Array.isArray(_b)) {
        if (_a.length !== _b.length) {
          return false;
        }

        for (var i = 0; i < _a.length; i++) {
          queue.push({
            a: _a[i],
            b: _b[i],
            depth: _depth - 1
          });
        }

        continue;
      } else if (_a && _b && typeof _a === 'object' && typeof _b === 'object') {
        var keysA = Object.keys(
        /** @type {!Object} */
        _a);
        var keysB = Object.keys(
        /** @type {!Object} */
        _b);

        if (keysA.length !== keysB.length) {
          return false;
        }

        for (var _i = 0; _i < keysA.length; _i++) {
          var k = keysA[_i];
          queue.push({
            a: _a[k],
            b: _b[k],
            depth: _depth - 1
          });
        }

        continue;
      }
    }

    // If we get here, then depth == 0 or (a, b) are primitives.
    if (_a !== _b) {
      return false;
    }
  }

  return true;
}

/**
 * @param {*} obj
 * @param {string} key
 * @return {boolean}
 */
function hasOwnProperty(obj, key) {
  if (obj == null || typeof obj != 'object') {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(
  /** @type {!Object} */
  obj, key);
}

/**
 * This helper function handles configurations specified in a JSON format.
 *
 * It allows the configuration is to be written in plain JS (which has better
 * dev ergonomics like comments and trailing commas), and allows the
 * configuration to be transformed into an efficient JSON-parsed representation
 * in the dist build. See https://v8.dev/blog/cost-of-javascript-2019#json
 *
 * @param {!Object} obj
 * @return {!JsonObject}
 */
function jsonConfiguration(obj) {
  return (
    /** @type {!JsonObject} */
    obj
  );
}

/**
 * This converts an Object into a suitable type to be used in `includeJsonLiteral`.
 * This doesn't actually do any conversion, it only changes the closure type.
 *
 * @param {!Object|!Array|string|number|boolean|null} value
 * @return {!InternalJsonLiteralTypeDef}
 */
function jsonLiteral(value) {
  return (
    /** @type {!InternalJsonLiteralTypeDef} */
    value
  );
}

/**
 * Allows inclusion of a variable (that's wrapped in a jsonLiteral
 * call) to be included inside a jsonConfiguration.
 *
 * @param {!InternalJsonLiteralTypeDef} value
 * @return {*}
 */
function includeJsonLiteral(value) {
  return value;
}

},{"./dom":106,"./types":139}],121:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.parseLayout = parseLayout;
exports.getLayoutClass = getLayoutClass;
exports.isLayoutSizeDefined = isLayoutSizeDefined;
exports.isLayoutSizeFixed = isLayoutSizeFixed;
exports.isInternalElement = isInternalElement;
exports.parseLength = parseLength;
exports.assertLength = assertLength;
exports.assertLengthOrPercent = assertLengthOrPercent;
exports.getLengthUnits = getLengthUnits;
exports.getLengthNumeral = getLengthNumeral;
exports.hasNaturalDimensions = hasNaturalDimensions;
exports.getNaturalDimensions = getNaturalDimensions;
exports.isLoadingAllowed = isLoadingAllowed;
exports.isIframeVideoPlayerComponent = isIframeVideoPlayerComponent;
exports.applyStaticLayout = applyStaticLayout;
exports.LOADING_ELEMENTS_ = exports.naturalDimensions_ = exports.LengthDef = exports.LayoutPriority = exports.Layout = void 0;

var _log = require("./log");

var _staticTemplate = require("./static-template");

var _types = require("./types");

var _style = require("./style");

var _string = require("./string");

var _img = require("./utils/img");

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      <i-amphtml-sizer class=\"i-amphtml-sizer\" slot=\"i-amphtml-svc\">\n        <img alt=\"\" role=\"presentation\" aria-hidden=\"true\"\n             class=\"i-amphtml-intrinsic-sizer\" />\n      </i-amphtml-sizer>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

/**
 * @enum {string}
 */
var Layout = {
  NODISPLAY: 'nodisplay',
  FIXED: 'fixed',
  FIXED_HEIGHT: 'fixed-height',
  RESPONSIVE: 'responsive',
  CONTAINER: 'container',
  FILL: 'fill',
  FLEX_ITEM: 'flex-item',
  FLUID: 'fluid',
  INTRINSIC: 'intrinsic'
};
exports.Layout = Layout;

/**
 * Layout priorities to use with BaseElement#getLayoutPriority() and
 * BaseElement#updateLayoutPriority().
 * @enum {number}
 */
var LayoutPriority = {
  CONTENT: 0,
  METADATA: 1,
  ADS: 2,
  BACKGROUND: 3
};
exports.LayoutPriority = LayoutPriority;

/**
 * CSS Length type. E.g. "1px" or "20vh".
 * @typedef {string}
 */
var LengthDef;
exports.LengthDef = LengthDef;

/**
 * @typedef {{
 *   width: string,
 *   height: string
 * }}
 */
var DimensionsDef;

/**
 * The set of elements with natural dimensions, that is, elements
 * which have a known dimension either based on their value specified here,
 * or, if the value is null, a dimension specific to the browser.
 * `hasNaturalDimensions` checks for membership in this set.
 * `getNaturalDimensions` determines the dimensions for an element in the
 *    set and caches it.
 * @type {!Object<string, ?DimensionsDef>}
 * @private  Visible for testing only!
 */
var naturalDimensions_ = {
  'AMP-PIXEL': {
    width: '0px',
    height: '0px'
  },
  'AMP-ANALYTICS': {
    width: '1px',
    height: '1px'
  },
  // TODO(dvoytenko): audio should have width:auto.
  'AMP-AUDIO': null,
  'AMP-SOCIAL-SHARE': {
    width: '60px',
    height: '44px'
  }
};
exports.naturalDimensions_ = naturalDimensions_;

/**
 * Elements that the progress can be shown for. This set has to be externalized
 * since the element's implementation may not be downloaded yet.
 * This list does not include video players which are found via regex later.
 * @enum {boolean}
 * @private  Visible for testing only!
 */
var LOADING_ELEMENTS_ = {
  'AMP-AD': true,
  'AMP-ANIM': true,
  'AMP-EMBED': true,
  'AMP-FACEBOOK': true,
  'AMP-FACEBOOK-COMMENTS': true,
  'AMP-FACEBOOK-PAGE': true,
  'AMP-GOOGLE-DOCUMENT-EMBED': true,
  'AMP-IFRAME': true,
  'AMP-IMG': true,
  'AMP-INSTAGRAM': true,
  'AMP-LIST': true,
  'AMP-PINTEREST': true,
  'AMP-PLAYBUZZ': true,
  'AMP-TWITTER': true
};
exports.LOADING_ELEMENTS_ = LOADING_ELEMENTS_;

/**
 * All video player components must either have a) "video" or b) "player" in
 * their name. A few components don't follow this convention for historical
 * reasons, so they are listed individually.
 * @private @const {!RegExp}
 */
var videoPlayerTagNameRe = /^amp\-(video|.+player)|AMP-BRIGHTCOVE|AMP-DAILYMOTION|AMP-YOUTUBE|AMP-VIMEO|AMP-IMA-VIDEO/i;

/**
 * @param {string} s
 * @return {Layout|undefined} Returns undefined in case of failure to parse
 *   the layout string.
 */
function parseLayout(s) {
  for (var k in Layout) {
    if (Layout[k] == s) {
      return Layout[k];
    }
  }

  return undefined;
}

/**
 * @param {!Layout} layout
 * @return {string}
 */
function getLayoutClass(layout) {
  return 'i-amphtml-layout-' + layout;
}

/**
 * Whether an element with this layout inherently defines the size.
 * @param {!Layout} layout
 * @return {boolean}
 */
function isLayoutSizeDefined(layout) {
  return layout == Layout.FIXED || layout == Layout.FIXED_HEIGHT || layout == Layout.RESPONSIVE || layout == Layout.FILL || layout == Layout.FLEX_ITEM || layout == Layout.FLUID || layout == Layout.INTRINSIC;
}

/**
 * Whether an element with this layout has a fixed dimension.
 * @param {!Layout} layout
 * @return {boolean}
 */
function isLayoutSizeFixed(layout) {
  return layout == Layout.FIXED || layout == Layout.FIXED_HEIGHT;
}

/**
 * Whether the tag is an internal (service) AMP tag.
 * @param {!Node|string} tag
 * @return {boolean}
 */
function isInternalElement(tag) {
  var tagName = typeof tag == 'string' ? tag : tag.tagName;
  return tagName && (0, _string.startsWith)(tagName.toLowerCase(), 'i-');
}

/**
 * Parses the CSS length value. If no units specified, the assumed value is
 * "px". Returns undefined in case of parsing error.
 * @param {string|undefined|null} s
 * @return {!LengthDef|undefined}
 */
function parseLength(s) {
  if (typeof s == 'number') {
    return s + 'px';
  }

  if (!s) {
    return undefined;
  }

  if (!/^\d+(\.\d+)?(px|em|rem|vh|vw|vmin|vmax|cm|mm|q|in|pc|pt)?$/.test(s)) {
    return undefined;
  }

  if (/^\d+(\.\d+)?$/.test(s)) {
    return s + 'px';
  }

  return s;
}

/**
 * Asserts that the supplied value is a non-percent CSS Length value.
 * @param {!LengthDef|string|null|undefined} length
 * @return {!LengthDef}
 * @closurePrimitive {asserts.matchesReturn}
 */
function assertLength(length) {
  (0, _log.userAssert)(/^\d+(\.\d+)?(px|em|rem|vh|vw|vmin|vmax|cm|mm|q|in|pc|pt)$/.test(length), 'Invalid length value: %s', length);
  return (
    /** @type {!LengthDef} */
    length
  );
}

/**
 * Asserts that the supplied value is a CSS Length value
 * (including percent unit).
 * @param {!LengthDef|string} length
 * @return {!LengthDef}
 * @closurePrimitive {asserts.matchesReturn}
 */
function assertLengthOrPercent(length) {
  (0, _log.userAssert)(/^\d+(\.\d+)?(px|em|rem|vh|vw|vmin|vmax|%)$/.test(length), 'Invalid length or percent value: %s', length);
  return length;
}

/**
 * Returns units from the CSS length value.
 * @param {!LengthDef|string|null|undefined} length
 * @return {string}
 */
function getLengthUnits(length) {
  assertLength(length);
  var m = (0, _log.userAssert)(/[a-z]+/i.exec(length), 'Failed to read units from %s', length);
  return m[0];
}

/**
 * Returns the numeric value of a CSS length value.
 * @param {!LengthDef|string|null|undefined} length
 * @return {number|undefined}
 */
function getLengthNumeral(length) {
  var res = parseFloat(length);
  return (0, _types.isFiniteNumber)(res) ? res : undefined;
}

/**
 * Determines whether the tagName is a known element that has natural dimensions
 * in our runtime or the browser.
 * @param {string} tagName The element tag name.
 * @return {boolean}
 */
function hasNaturalDimensions(tagName) {
  tagName = tagName.toUpperCase();
  return naturalDimensions_[tagName] !== undefined;
}

/**
 * Determines the default dimensions for an element which could vary across
 * different browser implementations, like <audio> for instance.
 * This operation can only be completed for an element allowlisted by
 * `hasNaturalDimensions`.
 * @param {!Element} element
 * @return {DimensionsDef}
 */
function getNaturalDimensions(element) {
  var tagName = element.tagName.toUpperCase();
  (0, _log.devAssert)(naturalDimensions_[tagName] !== undefined);

  if (!naturalDimensions_[tagName]) {
    var doc = element.ownerDocument;
    var naturalTagName = tagName.replace(/^AMP\-/, '');
    var temp = doc.createElement(naturalTagName);
    // For audio, should no-op elsewhere.
    temp.controls = true;
    (0, _style.setStyles)(temp, {
      position: 'absolute',
      visibility: 'hidden'
    });
    doc.body.appendChild(temp);
    naturalDimensions_[tagName] = {
      width: (temp.
      /*OK*/
      offsetWidth || 1) + 'px',
      height: (temp.
      /*OK*/
      offsetHeight || 1) + 'px'
    };
    doc.body.removeChild(temp);
  }

  return (
    /** @type {DimensionsDef} */
    naturalDimensions_[tagName]
  );
}

/**
 * Whether the loading can be shown for the specified element. This set has
 * to be externalized since the element's implementation may not be
 * downloaded yet.
 * @param {!Element} element
 * @return {boolean}
 */
function isLoadingAllowed(element) {
  var tagName = element.tagName.toUpperCase();
  return LOADING_ELEMENTS_[tagName] || isIframeVideoPlayerComponent(tagName);
}

/**
 * All video player components must either have a) "video" or b) "player" in
 * their name. A few components don't follow this convention for historical
 * reasons, so they're present in the LOADING_ELEMENTS_ allowlist.
 * @param {string} tagName
 * @return {boolean}
 */
function isIframeVideoPlayerComponent(tagName) {
  if (tagName == 'AMP-VIDEO') {
    return false;
  }

  return videoPlayerTagNameRe.test(tagName);
}

/**
 * Applies layout to the element. Visible for testing only.
 *
 * \   \  /  \  /   / /   \     |   _  \     |  \ |  | |  | |  \ |  |  / _____|
 *  \   \/    \/   / /  ^  \    |  |_)  |    |   \|  | |  | |   \|  | |  |  __
 *   \            / /  /_\  \   |      /     |  . `  | |  | |  . `  | |  | |_ |
 *    \    /\    / /  _____  \  |  |\  \----.|  |\   | |  | |  |\   | |  |__| |
 *     \__/  \__/ /__/     \__\ | _| `._____||__| \__| |__| |__| \__|  \______|
 *
 * The equivalent of this method is used for server-side rendering (SSR) and
 * any changes made to it must be made in coordination with caches that
 * implement SSR. For more information on SSR see bit.ly/amp-ssr.
 *
 * @param {!Element} element
 * @param {boolean} fixIeIntrinsic
 * @return {!Layout}
 */
function applyStaticLayout(element, fixIeIntrinsic) {
  if (fixIeIntrinsic === void 0) {
    fixIeIntrinsic = false;
  }

  // Check if the layout has already been done by server-side rendering or
  // client-side rendering and the element was cloned. The document may be
  // visible to the user if the boilerplate was removed so please take care in
  // making changes here.
  var completedLayoutAttr = element.getAttribute('i-amphtml-layout');

  if (completedLayoutAttr) {
    var _layout =
    /** @type {!Layout} */
    (0, _log.devAssert)(parseLayout(completedLayoutAttr));

    if ((_layout == Layout.RESPONSIVE || _layout == Layout.INTRINSIC) && element.firstElementChild) {
      // Find sizer, but assume that it might not have been parsed yet.
      element.sizerElement = element.querySelector('i-amphtml-sizer') || undefined;

      if (element.sizerElement) {
        element.sizerElement.setAttribute('slot', 'i-amphtml-svc');
      }
    } else if (_layout == Layout.NODISPLAY) {
      (0, _style.toggle)(element, false);
      // TODO(jridgewell): Temporary hack while SSR still adds an inline
      // `display: none`
      element['style']['display'] = '';
    }

    return _layout;
  }

  // If the layout was already done by server-side rendering (SSR), then the
  // code below will not run. Any changes below will necessitate a change to SSR
  // and must be coordinated with caches that implement SSR. See bit.ly/amp-ssr.
  // Parse layout from the element.
  var layoutAttr = element.getAttribute('layout');
  var widthAttr = element.getAttribute('width');
  var heightAttr = element.getAttribute('height');
  var sizesAttr = element.getAttribute('sizes');
  var heightsAttr = element.getAttribute('heights');
  // Input layout attributes.
  var inputLayout = layoutAttr ? parseLayout(layoutAttr) : null;
  (0, _log.userAssert)(inputLayout !== undefined, 'Invalid "layout" value: %s, %s', layoutAttr, element);

  /** @const {string|null|undefined} */
  var inputWidth = widthAttr && widthAttr != 'auto' ? parseLength(widthAttr) : widthAttr;
  (0, _log.userAssert)(inputWidth !== undefined, 'Invalid "width" value: %s, %s', widthAttr, element);

  /** @const {string|null|undefined} */
  var inputHeight = heightAttr && heightAttr != 'fluid' ? parseLength(heightAttr) : heightAttr;
  (0, _log.userAssert)(inputHeight !== undefined, 'Invalid "height" value: %s, %s', heightAttr, element);
  // Effective layout attributes. These are effectively constants.
  var width;
  var height;
  var layout;

  // Calculate effective width and height.
  if ((!inputLayout || inputLayout == Layout.FIXED || inputLayout == Layout.FIXED_HEIGHT) && (!inputWidth || !inputHeight) && hasNaturalDimensions(element.tagName)) {
    // Default width and height: handle elements that do not specify a
    // width/height and are defined to have natural browser dimensions.
    var dimensions = getNaturalDimensions(element);
    width = inputWidth || inputLayout == Layout.FIXED_HEIGHT ? inputWidth : dimensions.width;
    height = inputHeight || dimensions.height;
  } else {
    width = inputWidth;
    height = inputHeight;
  }

  // Calculate effective layout.
  if (inputLayout) {
    layout = inputLayout;
  } else if (!width && !height) {
    layout = Layout.CONTAINER;
  } else if (height == 'fluid') {
    layout = Layout.FLUID;
  } else if (height && (!width || width == 'auto')) {
    layout = Layout.FIXED_HEIGHT;
  } else if (height && width && (sizesAttr || heightsAttr)) {
    layout = Layout.RESPONSIVE;
  } else {
    layout = Layout.FIXED;
  }

  // Verify layout attributes.
  if (layout == Layout.FIXED || layout == Layout.FIXED_HEIGHT || layout == Layout.RESPONSIVE || layout == Layout.INTRINSIC) {
    (0, _log.userAssert)(height, 'The "height" attribute is missing: %s', element);
  }

  if (layout == Layout.FIXED_HEIGHT) {
    (0, _log.userAssert)(!width || width == 'auto', 'The "width" attribute must be missing or "auto": %s', element);
  }

  if (layout == Layout.FIXED || layout == Layout.RESPONSIVE || layout == Layout.INTRINSIC) {
    (0, _log.userAssert)(width && width != 'auto', 'The "width" attribute must be present and not "auto": %s', element);
  }

  if (layout == Layout.RESPONSIVE || layout == Layout.INTRINSIC) {
    (0, _log.userAssert)(getLengthUnits(width) == getLengthUnits(height), 'Length units should be the same for "width" and "height": %s, %s, %s', widthAttr, heightAttr, element);
  } else {
    (0, _log.userAssert)(heightsAttr === null, '"heights" attribute must be missing: %s', element);
  }

  // Apply UI.
  element.classList.add(getLayoutClass(layout));

  if (isLayoutSizeDefined(layout)) {
    element.classList.add('i-amphtml-layout-size-defined');
  }

  if (layout == Layout.NODISPLAY) {
    // CSS defines layout=nodisplay automatically with `display:none`. Thus
    // no additional styling is needed.
    (0, _style.toggle)(element, false);
    // TODO(jridgewell): Temporary hack while SSR still adds an inline
    // `display: none`
    element['style']['display'] = '';
  } else if (layout == Layout.FIXED) {
    (0, _style.setStyles)(element, {
      width: (0, _log.dev)().assertString(width),
      height: (0, _log.dev)().assertString(height)
    });
  } else if (layout == Layout.FIXED_HEIGHT) {
    (0, _style.setStyle)(element, 'height', (0, _log.dev)().assertString(height));
  } else if (layout == Layout.RESPONSIVE) {
    var sizer = element.ownerDocument.createElement('i-amphtml-sizer');
    sizer.setAttribute('slot', 'i-amphtml-svc');
    (0, _style.setStyles)(sizer, {
      paddingTop: getLengthNumeral(height) / getLengthNumeral(width) * 100 + '%'
    });
    element.insertBefore(sizer, element.firstChild);
    element.sizerElement = sizer;
  } else if (layout == Layout.INTRINSIC) {
    // Intrinsic uses an svg inside the sizer element rather than the padding
    // trick Note a naked svg won't work becasue other thing expect the
    // i-amphtml-sizer element
    var _sizer = (0, _staticTemplate.htmlFor)(element)(_templateObject());

    var intrinsicSizer = _sizer.firstElementChild;
    intrinsicSizer.setAttribute('src', !false && fixIeIntrinsic && element.ownerDocument ? (0, _img.transparentPng)(element.ownerDocument, (0, _log.dev)().assertNumber(getLengthNumeral(width)), (0, _log.dev)().assertNumber(getLengthNumeral(height))) : "data:image/svg+xml;charset=utf-8,<svg height=\"" + height + "\" width=\"" + width + "\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\"/>");
    element.insertBefore(_sizer, element.firstChild);
    element.sizerElement = _sizer;
  } else if (layout == Layout.FILL) {// Do nothing.
  } else if (layout == Layout.CONTAINER) {// Do nothing. Elements themselves will check whether the supplied
    // layout value is acceptable. In particular container is only OK
    // sometimes.
  } else if (layout == Layout.FLEX_ITEM) {
    // Set height and width to a flex item if they exist.
    // The size set to a flex item could be overridden by `display: flex` later.
    if (width) {
      (0, _style.setStyle)(element, 'width', width);
    }

    if (height) {
      (0, _style.setStyle)(element, 'height', height);
    }
  } else if (layout == Layout.FLUID) {
    element.classList.add('i-amphtml-layout-awaiting-size');

    if (width) {
      (0, _style.setStyle)(element, 'width', width);
    }

    (0, _style.setStyle)(element, 'height', 0);
  }

  // Mark the element as having completed static layout, in case it is cloned
  // in the future.
  element.setAttribute('i-amphtml-layout', layout);
  return layout;
}

},{"./log":123,"./static-template":135,"./string":136,"./style":138,"./types":139,"./utils/img":146}],122:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.createPseudoLocale = createPseudoLocale;
exports.LocalizedStringBundleDef = exports.LocalizedStringDef = exports.LocalizedStringId = void 0;

var _json = require("./json");

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * A unique identifier for each localized string.  Localized string IDs should:
 *
 *   - Maintain alphabetical order, by component
 *   - Be prefixed with the name of the extension that uses the string
 *     (e.g. "AMP_STORY_"), or with "AMP_" if they are general
 *   - NOT be reused; to deprecate an ID, comment it out and prefix its key with
 *     the string "DEPRECATED_"
 *
 * Next ID: 83
 *
 * @const @enum {string}
 */
var LocalizedStringId = {
  // amp-story
  AMP_STORY_AUDIO_MUTE_BUTTON_LABEL: '66',
  AMP_STORY_AUDIO_MUTE_BUTTON_TEXT: '31',
  AMP_STORY_AUDIO_UNMUTE_BUTTON_LABEL: '67',
  AMP_STORY_AUDIO_UNMUTE_NO_SOUND_TEXT: '33',
  AMP_STORY_AUDIO_UNMUTE_SOUND_TEXT: '32',
  AMP_STORY_BOOKEND_MORE_TO_READ_LABEL: '30',
  AMP_STORY_BOOKEND_PRIVACY_SETTINGS_TITLE: '29',
  AMP_STORY_BOOKEND_PRIVACY_SETTINGS_BUTTON_LABEL: '28',
  AMP_STORY_CONSENT_ACCEPT_BUTTON_LABEL: '22',
  AMP_STORY_CONSENT_DECLINE_BUTTON_LABEL: '23',
  AMP_STORY_CONTINUE_ANYWAY_BUTTON_LABEL: '27',
  AMP_STORY_DOMAIN_DIALOG_HEADING_LABEL: '25',
  AMP_STORY_DOMAIN_DIALOG_HEADING_LINK: '26',
  AMP_STORY_EDUCATION_NAVIGATION_SWIPE_PROGRESS: '78',
  AMP_STORY_EDUCATION_NAVIGATION_SWIPE_INSTRUCTIONS: '79',
  AMP_STORY_EDUCATION_NAVIGATION_SWIPE_DISMISS: '80',
  AMP_STORY_EDUCATION_NAVIGATION_TAP_PROGRESS: '75',
  AMP_STORY_EDUCATION_NAVIGATION_TAP_PROGRESS_SINGLE: '81',
  AMP_STORY_EDUCATION_NAVIGATION_TAP_INSTRUCTIONS: '76',
  AMP_STORY_EDUCATION_NAVIGATION_TAP_DISMISS: '77',
  AMP_STORY_HAS_NEW_PAGE_TEXT: '64',
  AMP_STORY_HINT_UI_NEXT_LABEL: '2',
  AMP_STORY_HINT_UI_PREVIOUS_LABEL: '3',
  AMP_STORY_INFO_BUTTON_LABEL: '68',
  AMP_STORY_PAGE_ATTACHMENT_OPEN_LABEL: '35',
  AMP_STORY_PAGINATION_BUTTON_PREVIOUS_PAGE_LABEL: '82',
  AMP_STORY_PAGE_ERROR_VIDEO: '65',
  AMP_STORY_PAGE_PLAY_VIDEO: '34',
  AMP_STORY_QUIZ_ANSWER_CHOICE_A: '71',
  AMP_STORY_QUIZ_ANSWER_CHOICE_B: '72',
  AMP_STORY_QUIZ_ANSWER_CHOICE_C: '73',
  AMP_STORY_QUIZ_ANSWER_CHOICE_D: '74',
  AMP_STORY_SHARE_BUTTON_LABEL: '69',
  AMP_STORY_SHARING_CLIPBOARD_FAILURE_TEXT: '4',
  AMP_STORY_SHARING_CLIPBOARD_SUCCESS_TEXT: '5',
  AMP_STORY_SHARING_PAGE_LABEL: '62',
  AMP_STORY_SHARING_PROVIDER_NAME_EMAIL: '6',
  AMP_STORY_SHARING_PROVIDER_NAME_FACEBOOK: '7',
  AMP_STORY_SHARING_PROVIDER_NAME_GOOGLE_PLUS: '8',
  AMP_STORY_SHARING_PROVIDER_NAME_LINE: '63',
  AMP_STORY_SHARING_PROVIDER_NAME_LINK: '9',
  AMP_STORY_SHARING_PROVIDER_NAME_LINKEDIN: '10',
  AMP_STORY_SHARING_PROVIDER_NAME_PINTEREST: '11',
  AMP_STORY_SHARING_PROVIDER_NAME_SMS: '12',
  AMP_STORY_SHARING_PROVIDER_NAME_SYSTEM: '13',
  AMP_STORY_SHARING_PROVIDER_NAME_TUMBLR: '14',
  AMP_STORY_SHARING_PROVIDER_NAME_TWITTER: '15',
  AMP_STORY_SHARING_PROVIDER_NAME_WHATSAPP: '16',
  AMP_STORY_SIDEBAR_BUTTON_LABEL: '70',
  AMP_STORY_TOOLTIP_EXPAND_TWEET: '36',
  AMP_STORY_WARNING_DESKTOP_HEIGHT_SIZE_TEXT: '37',
  AMP_STORY_WARNING_DESKTOP_SIZE_TEXT: '18',
  AMP_STORY_WARNING_DESKTOP_WIDTH_SIZE_TEXT: '38',
  AMP_STORY_WARNING_EXPERIMENT_DISABLED_TEXT: '19',
  AMP_STORY_WARNING_LANDSCAPE_ORIENTATION_TEXT: '20',
  AMP_STORY_WARNING_UNSUPPORTED_BROWSER_TEXT: '21',
  // amp-story-auto-ads
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_APPLY_NOW: '39',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_BOOK_NOW: '40',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_BUY_TICKETS: '41',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_DOWNLOAD: '42',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_EXPLORE: '43',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_GET_NOW: '44',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_INSTALL: '45',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_LEARN_MORE: '46',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_LISTEN: '47',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_MORE: '48',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_OPEN_APP: '49',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_ORDER_NOW: '50',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_PLAY: '51',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_READ: '52',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SHOP: '53',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SHOW: '54',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SHOWTIMES: '55',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SIGN_UP: '56',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_SUBSCRIBE: '57',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_USE_APP: '58',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_VIEW: '59',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_WATCH: '60',
  AMP_STORY_AUTO_ADS_BUTTON_LABEL_WATCH_EPISODE: '61',
  // TODO(#14357): Comment these out once amp-story:0.1 no longer depends on
  // them.
  DEPRECATED_AMP_STORY_EXPERIMENT_ENABLE_BUTTON_LABEL: '0',
  DEPRECATED_AMP_STORY_EXPERIMENT_ENABLED_TEXT: '1',
  DEPRECATED_AMP_STORY_CONSENT_DISMISS_DIALOG_BUTTON_LABEL: '24',
  DEPRECATED_AMP_STORY_SYSTEM_LAYER_SHARE_WIDGET_LABEL: '17'
};
exports.LocalizedStringId = LocalizedStringId;

/**
 * @typedef {{
 *   string: string,
 *   description: string,
 * }}
 */
var LocalizedStringDef;
exports.LocalizedStringDef = LocalizedStringDef;

/**
 * @typedef {!Object<!LocalizedStringId, !LocalizedStringDef>}
 */
var LocalizedStringBundleDef;
exports.LocalizedStringBundleDef = LocalizedStringBundleDef;

/**
 * Creates a deep copy of the specified LocalizedStringBundle.
 * @param {!LocalizedStringBundleDef} localizedStringBundle
 * @return {!LocalizedStringBundleDef}
 */
function cloneLocalizedStringBundle(localizedStringBundle) {
  return (
    /** @type {!LocalizedStringBundleDef} */
    (0, _json.parseJson)(JSON.stringify(
    /** @type {!JsonObject} */
    localizedStringBundle))
  );
}

/**
 * Creates a pseudo locale by applying string transformations (specified by the
 * localizationFn) to an existing string bundle, without modifying the original.
 * @param {!LocalizedStringBundleDef} localizedStringBundle The localized
 *     string bundle to be transformed.
 * @param {function(string): string} localizationFn The transformation to be
 *     applied to each string in the bundle.
 * @return {!LocalizedStringBundleDef} The new strings.
 */
function createPseudoLocale(localizedStringBundle, localizationFn) {
  /** @type {!LocalizedStringBundleDef} */
  var pseudoLocaleStringBundle = cloneLocalizedStringBundle(localizedStringBundle);
  Object.keys(pseudoLocaleStringBundle).forEach(function (localizedStringIdAsStr) {
    var localizedStringId =
    /** @type {!LocalizedStringId} */
    localizedStringIdAsStr;
    pseudoLocaleStringBundle[localizedStringId].string = localizationFn(localizedStringBundle[localizedStringId].string);
    pseudoLocaleStringBundle[localizedStringId].fallback = localizationFn(localizedStringBundle[localizedStringId].fallback);
  });
  return pseudoLocaleStringBundle;
}

},{"./json":120}],123:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isUserErrorMessage = isUserErrorMessage;
exports.stripUserError = stripUserError;
exports.isUserErrorEmbed = isUserErrorEmbed;
exports.setReportError = setReportError;
exports.overrideLogLevel = overrideLogLevel;
exports.duplicateErrorIfNecessary = duplicateErrorIfNecessary;
exports.createErrorVargs = createErrorVargs;
exports.rethrowAsync = rethrowAsync;
exports.initLogConstructor = initLogConstructor;
exports.resetLogConstructorForTesting = resetLogConstructorForTesting;
exports.user = user;
exports.dev = dev;
exports.isFromEmbed = isFromEmbed;
exports.devAssert = devAssert;
exports.userAssert = userAssert;
exports.Log = exports.LogLevel = exports.USER_ERROR_EMBED_SENTINEL = exports.USER_ERROR_SENTINEL = void 0;

var _mode = require("./mode");

var _internalVersion = require("./internal-version");

var _types = require("./types");

var _function = require("./utils/function");

var _config = require("./config");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var noop = function noop() {};

/**
 * Triple zero width space.
 *
 * This is added to user error messages, so that we can later identify
 * them, when the only thing that we have is the message. This is the
 * case in many browsers when the global exception handler is invoked.
 *
 * @const {string}
 */
var USER_ERROR_SENTINEL = "\u200B\u200B\u200B";
exports.USER_ERROR_SENTINEL = USER_ERROR_SENTINEL;

/**
 * Four zero width space.
 *
 * @const {string}
 */
var USER_ERROR_EMBED_SENTINEL = "\u200B\u200B\u200B\u200B";
exports.USER_ERROR_EMBED_SENTINEL = USER_ERROR_EMBED_SENTINEL;

/**
 * @param {string} message
 * @return {boolean} Whether this message was a user error.
 */
function isUserErrorMessage(message) {
  return message.indexOf(USER_ERROR_SENTINEL) >= 0;
}

/**
 * @param {string} message
 * @return {string} The new message without USER_ERROR_SENTINEL
 */
function stripUserError(message) {
  return message.replace(USER_ERROR_SENTINEL, '');
}

/**
 * @param {string} message
 * @return {boolean} Whether this message was a a user error from an iframe embed.
 */
function isUserErrorEmbed(message) {
  return message.indexOf(USER_ERROR_EMBED_SENTINEL) >= 0;
}

/**
 * @enum {number}
 */
var LogLevel = {
  OFF: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  FINE: 4
};
exports.LogLevel = LogLevel;

/**
 * Sets reportError function. Called from error.js to break cyclic
 * dependency.
 * @param {function(*, !Element=)|undefined} fn
 */
function setReportError(fn) {
  self.__AMP_REPORT_ERROR = fn;
}

/**
 * @type {!LogLevel|undefined}
 * @private
 */
var levelOverride_ = undefined;

/**
 * @param {!LogLevel} level
 */
function overrideLogLevel(level) {
  levelOverride_ = level;
}

/**
 * Prefixes `internalRuntimeVersion` with the `01` channel signifier (for prod.) for
 * extracted message URLs.
 * (Specific channel is irrelevant: message tables are invariant on internal version.)
 * @return {string}
 */
var messageUrlRtv = function messageUrlRtv() {
  return "01" + (0, _internalVersion.internalRuntimeVersion)();
};

/**
 * Gets a URL to display a message on amp.dev.
 * @param {string} id
 * @param {!Array} interpolatedParts
 * @return {string}
 */
var externalMessageUrl = function externalMessageUrl(id, interpolatedParts) {
  return interpolatedParts.reduce(function (prefix, arg) {
    return prefix + "&s[]=" + messageArgToEncodedComponent(arg);
  }, "https://log.amp.dev/?v=" + messageUrlRtv() + "&id=" + encodeURIComponent(id));
};

/**
 * URL to simple log messages table JSON file, which contains an Object<string, string>
 * which maps message id to full message template.
 * @return {string}
 */
var externalMessagesSimpleTableUrl = function externalMessagesSimpleTableUrl() {
  return _config.urls.cdn + "/rtv/" + messageUrlRtv() + "/log-messages.simple.json";
};

/**
 * @param {*} arg
 * @return {string}
 */
var messageArgToEncodedComponent = function messageArgToEncodedComponent(arg) {
  return encodeURIComponent(String(elementStringOrPassthru(arg)));
};

/**
 * Logging class. Use of sentinel string instead of a boolean to check user/dev
 * errors because errors could be rethrown by some native code as a new error,
 * and only a message would survive. Also, some browser don’t support a 5th
 * error object argument in window.onerror. List of supporting browser can be
 * found here:
 * https://blog.sentry.io/2016/01/04/client-javascript-reporting-window-onerror.html
 * @final
 * @private Visible for testing only.
 */
var Log = /*#__PURE__*/function () {
  /**
   * opt_suffix will be appended to error message to identify the type of the
   * error message. We can't rely on the error object to pass along the type
   * because some browsers do not have this param in its window.onerror API.
   * See:
   * https://blog.sentry.io/2016/01/04/client-javascript-reporting-window-onerror.html
   *
   * @param {!Window} win
   * @param {function(number, boolean):!LogLevel} levelFunc
   * @param {string=} opt_suffix
   */
  function Log(win, levelFunc, opt_suffix) {
    var _this = this;

    if (opt_suffix === void 0) {
      opt_suffix = '';
    }

    _classCallCheck(this, Log);

    /**
     * In tests we use the main test window instead of the iframe where
     * the tests runs because only the former is relayed to the console.
     * @const {!Window}
     */
    this.win = (0, _mode.getMode)().test && win.__AMP_TEST_IFRAME ? win.parent : win;

    /** @private @const {function(number, boolean):!LogLevel} */
    this.levelFunc_ = levelFunc;

    /** @private @const {!LogLevel} */
    this.level_ = this.defaultLevel_();

    /** @private @const {string} */
    this.suffix_ = opt_suffix;

    /** @private {?JsonObject} */
    this.messages_ = null;
    this.fetchExternalMessagesOnce_ = (0, _function.once)(function () {
      win.fetch(externalMessagesSimpleTableUrl()).then(function (response) {
        return response.json();
      }, noop).then(function (opt_messages) {
        if (opt_messages) {
          _this.messages_ =
          /** @type {!JsonObject} */
          opt_messages;
        }
      });
    });
  }

  /**
   * @return {!LogLevel}
   * @private
   */
  _createClass(Log, [{
    key: "getLevel_",
    value: function getLevel_() {
      return levelOverride_ !== undefined ? levelOverride_ : this.level_;
    }
    /**
     * @return {!LogLevel}
     * @private
     */

  }, {
    key: "defaultLevel_",
    value: function defaultLevel_() {
      // No console - can't enable logging.
      if (!this.win.console || !this.win.console.log) {
        return LogLevel.OFF;
      }

      // Logging has been explicitly disabled.
      if ((0, _mode.getMode)().log == '0') {
        return LogLevel.OFF;
      }

      // Logging is enabled for tests directly.
      if ((0, _mode.getMode)().test && this.win.ENABLE_LOG) {
        return LogLevel.FINE;
      }

      // LocalDev by default allows INFO level, unless overriden by `#log`.
      if ((0, _mode.getMode)().localDev && !(0, _mode.getMode)().log) {
        return LogLevel.INFO;
      }

      return this.defaultLevelWithFunc_();
    }
    /**
     * @return {!LogLevel}
     * @private
     */

  }, {
    key: "defaultLevelWithFunc_",
    value: function defaultLevelWithFunc_() {
      // Delegate to the specific resolver.
      return this.levelFunc_(parseInt((0, _mode.getMode)().log, 10), (0, _mode.getMode)().development);
    }
    /**
     * @param {string} tag
     * @param {string} level
     * @param {!Array} messages
     */

  }, {
    key: "msg_",
    value: function msg_(tag, level, messages) {
      if (this.getLevel_() != LogLevel.OFF) {
        var fn = this.win.console.log;

        if (level == 'ERROR') {
          fn = this.win.console.error || fn;
        } else if (level == 'INFO') {
          fn = this.win.console.info || fn;
        } else if (level == 'WARN') {
          fn = this.win.console.warn || fn;
        }

        var args = this.maybeExpandMessageArgs_(messages);
        // Prefix console message with "[tag]".
        var prefix = "[" + tag + "]";

        if (typeof args[0] === 'string') {
          // Prepend string to avoid breaking string substitutions e.g. %s.
          args[0] = prefix + ' ' + args[0];
        } else {
          args.unshift(prefix);
        }

        fn.apply(this.win.console, args);
      }
    }
    /**
     * Whether the logging is enabled.
     * @return {boolean}
     */

  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.getLevel_() != LogLevel.OFF;
    }
    /**
     * Reports a fine-grained message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "fine",
    value: function fine(tag, var_args) {
      if (this.getLevel_() >= LogLevel.FINE) {
        this.msg_(tag, 'FINE', Array.prototype.slice.call(arguments, 1));
      }
    }
    /**
     * Reports a informational message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "info",
    value: function info(tag, var_args) {
      if (this.getLevel_() >= LogLevel.INFO) {
        this.msg_(tag, 'INFO', Array.prototype.slice.call(arguments, 1));
      }
    }
    /**
     * Reports a warning message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "warn",
    value: function warn(tag, var_args) {
      if (this.getLevel_() >= LogLevel.WARN) {
        this.msg_(tag, 'WARN', Array.prototype.slice.call(arguments, 1));
      }
    }
    /**
     * Reports an error message. If the logging is disabled, the error is rethrown
     * asynchronously.
     * @param {string} tag
     * @param {...*} var_args
     * @return {!Error|undefined}
     * @private
     */

  }, {
    key: "error_",
    value: function error_(tag, var_args) {
      if (this.getLevel_() >= LogLevel.ERROR) {
        this.msg_(tag, 'ERROR', Array.prototype.slice.call(arguments, 1));
      } else {
        var error = createErrorVargs.apply(null, Array.prototype.slice.call(arguments, 1));
        this.prepareError_(error);
        return error;
      }
    }
    /**
     * Reports an error message.
     * @param {string} tag
     * @param {...*} var_args
     */

  }, {
    key: "error",
    value: function error(tag, var_args) {
      var error = this.error_.apply(this, arguments);

      if (error) {
        error.name = tag || error.name;

        // __AMP_REPORT_ERROR is installed globally per window in the entry point.
        self.__AMP_REPORT_ERROR(error);
      }
    }
    /**
     * Reports an error message and marks with an expected property. If the
     * logging is disabled, the error is rethrown asynchronously.
     * @param {string} unusedTag
     * @param {...*} var_args
     */

  }, {
    key: "expectedError",
    value: function expectedError(unusedTag, var_args) {
      var error = this.error_.apply(this, arguments);

      if (error) {
        error.expected = true;

        // __AMP_REPORT_ERROR is installed globally per window in the entry point.
        self.__AMP_REPORT_ERROR(error);
      }
    }
    /**
     * Creates an error object.
     * @param {...*} var_args
     * @return {!Error}
     */

  }, {
    key: "createError",
    value: function createError(var_args) {
      var error = createErrorVargs.apply(null, arguments);
      this.prepareError_(error);
      return error;
    }
    /**
     * Creates an error object with its expected property set to true.
     * @param {...*} var_args
     * @return {!Error}
     */

  }, {
    key: "createExpectedError",
    value: function createExpectedError(var_args) {
      var error = createErrorVargs.apply(null, arguments);
      this.prepareError_(error);
      error.expected = true;
      return error;
    }
    /**
     * Throws an error if the first argument isn't trueish.
     *
     * Supports argument substitution into the message via %s placeholders.
     *
     * Throws an error object that has two extra properties:
     * - associatedElement: This is the first element provided in the var args.
     *   It can be used for improved display of error messages.
     * - messageArray: The elements of the substituted message as non-stringified
     *   elements in an array. When e.g. passed to console.error this yields
     *   native displays of things like HTML elements.
     *
     * @param {T} shouldBeTrueish The value to assert. The assert fails if it does
     *     not evaluate to true.
     * @param {!Array|string=} opt_message The assertion message
     * @param {...*} var_args Arguments substituted into %s in the message.
     * @return {T} The value of shouldBeTrueish.
     * @throws {!Error} When `value` is falsey.
     * @template T
     * @closurePrimitive {asserts.truthy}
     */

  }, {
    key: "assert",
    value: function assert(shouldBeTrueish, opt_message, var_args) {
      var firstElement;

      if ((0, _types.isArray)(opt_message)) {
        return this.assert.apply(this, [shouldBeTrueish].concat(this.expandMessageArgs_(
        /** @type {!Array} */
        opt_message)));
      }

      if (!shouldBeTrueish) {
        var message = opt_message || 'Assertion failed';
        var splitMessage = message.split('%s');
        var first = splitMessage.shift();
        var formatted = first;
        var messageArray = [];
        var i = 2;
        pushIfNonEmpty(messageArray, first);

        while (splitMessage.length > 0) {
          var nextConstant = splitMessage.shift();
          var val = arguments[i++];

          if (val && val.tagName) {
            firstElement = val;
          }

          messageArray.push(val);
          pushIfNonEmpty(messageArray, nextConstant.trim());
          formatted += stringOrElementString(val) + nextConstant;
        }

        var e = new Error(formatted);
        e.fromAssert = true;
        e.associatedElement = firstElement;
        e.messageArray = messageArray;
        this.prepareError_(e);

        // __AMP_REPORT_ERROR is installed globally per window in the entry point.
        self.__AMP_REPORT_ERROR(e);

        throw e;
      }

      return shouldBeTrueish;
    }
    /**
     * Throws an error if the first argument isn't an Element
     *
     * Otherwise see `assert` for usage
     *
     * @param {*} shouldBeElement
     * @param {!Array|string=} opt_message The assertion message
     * @return {!Element} The value of shouldBeTrueish.
     * @template T
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertElement",
    value: function assertElement(shouldBeElement, opt_message) {
      var shouldBeTrueish = shouldBeElement && shouldBeElement.nodeType == 1;
      this.assertType_(shouldBeElement, shouldBeTrueish, 'Element expected', opt_message);
      return (
        /** @type {!Element} */
        shouldBeElement
      );
    }
    /**
     * Throws an error if the first argument isn't a string. The string can
     * be empty.
     *
     * For more details see `assert`.
     *
     * @param {*} shouldBeString
     * @param {!Array|string=} opt_message The assertion message
     * @return {string} The string value. Can be an empty string.
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertString",
    value: function assertString(shouldBeString, opt_message) {
      this.assertType_(shouldBeString, typeof shouldBeString == 'string', 'String expected', opt_message);
      return (
        /** @type {string} */
        shouldBeString
      );
    }
    /**
     * Throws an error if the first argument isn't a number. The allowed values
     * include `0` and `NaN`.
     *
     * For more details see `assert`.
     *
     * @param {*} shouldBeNumber
     * @param {!Array|string=} opt_message The assertion message
     * @return {number} The number value. The allowed values include `0`
     *   and `NaN`.
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertNumber",
    value: function assertNumber(shouldBeNumber, opt_message) {
      this.assertType_(shouldBeNumber, typeof shouldBeNumber == 'number', 'Number expected', opt_message);
      return (
        /** @type {number} */
        shouldBeNumber
      );
    }
    /**
     * Throws an error if the first argument is not an array.
     * The array can be empty.
     *
     * @param {*} shouldBeArray
     * @param {!Array|string=} opt_message The assertion message
     * @return {!Array} The array value
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertArray",
    value: function assertArray(shouldBeArray, opt_message) {
      this.assertType_(shouldBeArray, (0, _types.isArray)(shouldBeArray), 'Array expected', opt_message);
      return (
        /** @type {!Array} */
        shouldBeArray
      );
    }
    /**
     * Throws an error if the first argument isn't a boolean.
     *
     * For more details see `assert`.
     *
     * @param {*} shouldBeBoolean
     * @param {!Array|string=} opt_message The assertion message
     * @return {boolean} The boolean value.
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertBoolean",
    value: function assertBoolean(shouldBeBoolean, opt_message) {
      this.assertType_(shouldBeBoolean, !!shouldBeBoolean === shouldBeBoolean, 'Boolean expected', opt_message);
      return (
        /** @type {boolean} */
        shouldBeBoolean
      );
    }
    /**
     * Asserts and returns the enum value. If the enum doesn't contain such a
     * value, the error is thrown.
     *
     * @param {!Object<T>} enumObj
     * @param {string} s
     * @param {string=} opt_enumName
     * @return {T}
     * @template T
     * @closurePrimitive {asserts.matchesReturn}
     */

  }, {
    key: "assertEnumValue",
    value: function assertEnumValue(enumObj, s, opt_enumName) {
      if ((0, _types.isEnumValue)(enumObj, s)) {
        return s;
      }

      this.assert(false, 'Unknown %s value: "%s"', opt_enumName || 'enum', s);
    }
    /**
     * @param {!Error} error
     * @private
     */

  }, {
    key: "prepareError_",
    value: function prepareError_(error) {
      error = duplicateErrorIfNecessary(error);

      if (this.suffix_) {
        if (!error.message) {
          error.message = this.suffix_;
        } else if (error.message.indexOf(this.suffix_) == -1) {
          error.message += this.suffix_;
        }
      } else if (isUserErrorMessage(error.message)) {
        error.message = error.message.replace(USER_ERROR_SENTINEL, '');
      }
    }
    /**
     * @param {!Array} args
     * @return {!Array}
     * @private
     */

  }, {
    key: "maybeExpandMessageArgs_",
    value: function maybeExpandMessageArgs_(args) {
      if ((0, _types.isArray)(args[0])) {
        return this.expandMessageArgs_(
        /** @type {!Array} */
        args[0]);
      }

      return args;
    }
    /**
     * Either redirects a pair of (errorId, ...args) to a URL where the full
     * message is displayed, or displays it from a fetched table.
     *
     * This method is used by the output of the `transform-log-methods` babel
     * plugin. It should not be used directly. Use the (*error|assert*|info|warn)
     * methods instead.
     *
     * @param {!Array} parts
     * @return {!Array}
     * @private
     */

  }, {
    key: "expandMessageArgs_",
    value: function expandMessageArgs_(parts) {
      // First value should exist.
      var id = parts.shift();

      // Best effort fetch of message template table.
      // Since this is async, the first few logs might be indirected to a URL even
      // if in development mode. Message table is ~small so this should be a short
      // gap.
      if ((0, _mode.getMode)(this.win).development) {
        this.fetchExternalMessagesOnce_();
      }

      if (this.messages_ && id in this.messages_) {
        return [this.messages_[id]].concat(parts);
      }

      return ["More info at " + externalMessageUrl(id, parts)];
    }
    /**
     * Asserts types, backbone of `assertNumber`, `assertString`, etc.
     *
     * It understands array-based "id"-contracted messages.
     *
     * Otherwise creates a sprintf syntax string containing the optional message or the
     * default. An interpolation token is added at the end to include the `subject`.
     * @param {*} subject
     * @param {*} assertion
     * @param {string} defaultMessage
     * @param {!Array|string=} opt_message
     * @private
     */

  }, {
    key: "assertType_",
    value: function assertType_(subject, assertion, defaultMessage, opt_message) {
      if ((0, _types.isArray)(opt_message)) {
        this.assert(assertion, opt_message.concat(subject));
      } else {
        this.assert(assertion, (opt_message || defaultMessage) + ": %s", subject);
      }
    }
  }]);

  return Log;
}();

exports.Log = Log;

/**
 * @param {string|!Element} val
 * @return {string}
 */
var stringOrElementString = function stringOrElementString(val) {
  return (
    /** @type {string} */
    elementStringOrPassthru(val)
  );
};

/**
 * @param {*} val
 * @return {*}
 */
function elementStringOrPassthru(val) {
  // Do check equivalent to `val instanceof Element` without cross-window bug
  if (val && val.nodeType == 1) {
    return val.tagName.toLowerCase() + (val.id ? '#' + val.id : '');
  }

  return val;
}

/**
 * @param {!Array} array
 * @param {*} val
 */
function pushIfNonEmpty(array, val) {
  if (val != '') {
    array.push(val);
  }
}

/**
 * Some exceptions (DOMException, namely) have read-only message.
 * @param {!Error} error
 * @return {!Error};
 */
function duplicateErrorIfNecessary(error) {
  var messageProperty = Object.getOwnPropertyDescriptor(error, 'message');

  if (messageProperty && messageProperty.writable) {
    return error;
  }

  var message = error.message,
      stack = error.stack;
  var e = new Error(message);

  // Copy all the extraneous things we attach.
  for (var prop in error) {
    e[prop] = error[prop];
  }

  // Ensure these are copied.
  e.stack = stack;
  return e;
}

/**
 * @param {...*} var_args
 * @return {!Error}
 * @visibleForTesting
 */
function createErrorVargs(var_args) {
  var error = null;
  var message = '';

  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];

    if (arg instanceof Error && !error) {
      error = duplicateErrorIfNecessary(arg);
    } else {
      if (message) {
        message += ' ';
      }

      message += arg;
    }
  }

  if (!error) {
    error = new Error(message);
  } else if (message) {
    error.message = message + ': ' + error.message;
  }

  return error;
}

/**
 * Rethrows the error without terminating the current context. This preserves
 * whether the original error designation is a user error or a dev error.
 * @param {...*} var_args
 */
function rethrowAsync(var_args) {
  var error = createErrorVargs.apply(null, arguments);
  setTimeout(function () {
    // reportError is installed globally per window in the entry point.
    self.__AMP_REPORT_ERROR(error);

    throw error;
  });
}

/**
 * Cache for logs. We do not use a Service since the service module depends
 * on Log and closure literally can't even.
 * @type {{user: ?Log, dev: ?Log, userForEmbed: ?Log}}
 */
self.__AMP_LOG = self.__AMP_LOG || {
  user: null,
  dev: null,
  userForEmbed: null
};
var logs = self.__AMP_LOG;

/**
 * Eventually holds a constructor for Log objects. Lazily initialized, so we
 * can avoid ever referencing the real constructor except in JS binaries
 * that actually want to include the implementation.
 * @type {?typeof Log}
 */
var logConstructor = null;

/**
 * Initializes log constructor.
 */
function initLogConstructor() {
  logConstructor = Log;
  // Initialize instances for use. If a binary (an extension for example) that
  // does not call `initLogConstructor` invokes `dev()` or `user()` earlier than
  // the binary that does call `initLogConstructor` (amp.js), the extension will
  // throw an error as that extension will never be able to initialize the log
  // instances and we also don't want it to call `initLogConstructor` either
  // (since that will cause the Log implementation to be bundled into that
  // binary). So we must initialize the instances eagerly so that they are ready
  // for use (stored globally) after the main binary calls `initLogConstructor`.
  dev();
  user();
}

/**
 * Resets log constructor for testing.
 */
function resetLogConstructorForTesting() {
  logConstructor = null;
}

/**
 * Publisher level log.
 *
 * Enabled in the following conditions:
 *  1. Not disabled using `#log=0`.
 *  2. Development mode is enabled via `#development=1` or logging is explicitly
 *     enabled via `#log=D` where D >= 1.
 *  3. AMP.setLogLevel(D) is called, where D >= 1.
 *
 * @param {!Element=} opt_element
 * @return {!Log}
 */
function user(opt_element) {
  if (!logs.user) {
    logs.user = getUserLogger(USER_ERROR_SENTINEL);
  }

  if (!isFromEmbed(logs.user.win, opt_element)) {
    return logs.user;
  } else {
    if (logs.userForEmbed) {
      return logs.userForEmbed;
    }

    return logs.userForEmbed = getUserLogger(USER_ERROR_EMBED_SENTINEL);
  }
}

/**
 * Getter for user logger
 * @param {string=} suffix
 * @return {!Log}
 */
function getUserLogger(suffix) {
  if (!logConstructor) {
    throw new Error('failed to call initLogConstructor');
  }

  return new logConstructor(self, function (logNum, development) {
    if (development || logNum >= 1) {
      return LogLevel.FINE;
    }

    return LogLevel.WARN;
  }, suffix);
}

/**
 * AMP development log. Calls to `devLog().assert` and `dev.fine` are stripped
 * in the PROD binary. However, `devLog().assert` result is preserved in either
 * case.
 *
 * Enabled in the following conditions:
 *  1. Not disabled using `#log=0`.
 *  2. Logging is explicitly enabled via `#log=D`, where D >= 2.
 *  3. AMP.setLogLevel(D) is called, where D >= 2.
 *
 * @return {!Log}
 */
function dev() {
  if (logs.dev) {
    return logs.dev;
  }

  if (!logConstructor) {
    throw new Error('failed to call initLogConstructor');
  }

  return logs.dev = new logConstructor(self, function (logNum) {
    if (logNum >= 3) {
      return LogLevel.FINE;
    }

    if (logNum >= 2) {
      return LogLevel.INFO;
    }

    return LogLevel.OFF;
  });
}

/**
 * @param {!Window} win
 * @param {!Element=} opt_element
 * @return {boolean} isEmbed
 */
function isFromEmbed(win, opt_element) {
  if (!opt_element) {
    return false;
  }

  return opt_element.ownerDocument.defaultView != win;
}

/**
 * Throws an error if the first argument isn't trueish.
 *
 * Supports argument substitution into the message via %s placeholders.
 *
 * Throws an error object that has two extra properties:
 * - associatedElement: This is the first element provided in the var args.
 *   It can be used for improved display of error messages.
 * - messageArray: The elements of the substituted message as non-stringified
 *   elements in an array. When e.g. passed to console.error this yields
 *   native displays of things like HTML elements.
 *
 * @param {T} shouldBeTrueish The value to assert. The assert fails if it does
 *     not evaluate to true.
 * @param {!Array|string=} opt_message The assertion message
 * @param {*=} opt_1 Optional argument (Var arg as individual params for better
 * @param {*=} opt_2 Optional argument inlining)
 * @param {*=} opt_3 Optional argument
 * @param {*=} opt_4 Optional argument
 * @param {*=} opt_5 Optional argument
 * @param {*=} opt_6 Optional argument
 * @param {*=} opt_7 Optional argument
 * @param {*=} opt_8 Optional argument
 * @param {*=} opt_9 Optional argument
 * @return {T} The value of shouldBeTrueish.
 * @throws {!Error} When `shouldBeTrueish` is falsey.
 * @template T
 * @closurePrimitive {asserts.truthy}
 */
function devAssert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9) {
  if ((0, _mode.getMode)().minified) {
    return shouldBeTrueish;
  }

  return dev().
  /*Orig call*/
  assert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9);
}

/**
 * Throws an error if the first argument isn't trueish.
 *
 * Supports argument substitution into the message via %s placeholders.
 *
 * Throws an error object that has two extra properties:
 * - associatedElement: This is the first element provided in the var args.
 *   It can be used for improved display of error messages.
 * - messageArray: The elements of the substituted message as non-stringified
 *   elements in an array. When e.g. passed to console.error this yields
 *   native displays of things like HTML elements.
 *
 * @param {T} shouldBeTrueish The value to assert. The assert fails if it does
 *     not evaluate to true.
 * @param {!Array|string=} opt_message The assertion message
 * @param {*=} opt_1 Optional argument (Var arg as individual params for better
 * @param {*=} opt_2 Optional argument inlining)
 * @param {*=} opt_3 Optional argument
 * @param {*=} opt_4 Optional argument
 * @param {*=} opt_5 Optional argument
 * @param {*=} opt_6 Optional argument
 * @param {*=} opt_7 Optional argument
 * @param {*=} opt_8 Optional argument
 * @param {*=} opt_9 Optional argument
 * @return {T} The value of shouldBeTrueish.
 * @throws {!Error} When `shouldBeTrueish` is falsey.
 * @template T
 * @closurePrimitive {asserts.truthy}
 */
function userAssert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9) {
  return user().
  /*Orig call*/
  assert(shouldBeTrueish, opt_message, opt_1, opt_2, opt_3, opt_4, opt_5, opt_6, opt_7, opt_8, opt_9);
}

},{"./config":102,"./internal-version":119,"./mode":124,"./types":139,"./utils/function":145}],124:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getMode = getMode;
exports.getRtvVersionForTesting = getRtvVersionForTesting;
exports.resetRtvVersionForTesting = resetRtvVersionForTesting;
exports.ModeDef = void 0;

var _internalVersion = require("./internal-version");

var _urlParseQueryString = require("./url-parse-query-string");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @typedef {{
 *   localDev: boolean,
 *   development: boolean,
 *   minified: boolean,
 *   lite: boolean,
 *   test: boolean,
 *   log: (string|undefined),
 *   version: string,
 *   rtvVersion: string,
 *   runtime: (null|string|undefined),
 *   a4aId: (null|string|undefined),
 *   esm: (boolean|undefined)
 * }}
 */
var ModeDef;
exports.ModeDef = ModeDef;

/**
 * `rtvVersion` is the prefixed version we serve off of the cdn.
 * The prefix denotes canary(00) or prod(01) or an experiment version ( > 01).
 * @type {string}
 */
var rtvVersion = '';

/**
 * Provides info about the current app.
 * @param {?Window=} opt_win
 * @return {!ModeDef}
 */
function getMode(opt_win) {
  var win = opt_win || self;

  if (win.__AMP_MODE) {
    return win.__AMP_MODE;
  }

  return win.__AMP_MODE = getMode_(win);
}

/**
 * Provides info about the current app.
 * @param {!Window} win
 * @return {!ModeDef}
 */
function getMode_(win) {
  // TODO(erwinmombay): simplify the logic here
  var AMP_CONFIG = self.AMP_CONFIG || {};
  // Magic constants that are replaced by closure compiler.
  // IS_MINIFIED is always replaced with true when closure compiler is used
  // while IS_DEV is only replaced when `gulp dist` is called without the
  // --fortesting flag.
  var IS_DEV = true;
  var IS_MINIFIED = false;
  var runningTests = IS_DEV && !!(AMP_CONFIG.test || win.__AMP_TEST || win.__karma__);
  var isLocalDev = IS_DEV && (!!AMP_CONFIG.localDev || runningTests);
  var hashQuery = (0, _urlParseQueryString.parseQueryString_)( // location.originalHash is set by the viewer when it removes the fragment
  // from the URL.
  win.location.originalHash || win.location.hash);
  var searchQuery = (0, _urlParseQueryString.parseQueryString_)(win.location.search);

  if (!rtvVersion) {
    rtvVersion = getRtvVersion(win);
  }

  // The `minified`, `test` and `localDev` properties are replaced
  // as boolean literals when we run `gulp dist` without the `--fortesting`
  // flags. This improved DCE on the production file we deploy as the code
  // paths for localhost/testing/development are eliminated.
  return {
    localDev: isLocalDev,
    // Triggers validation or enable pub level logging. Validation can be
    // bypassed via #validate=0.
    // Note that AMP_DEV_MODE flag is used for testing purposes.
    // Use Array.indexOf instead of Array.includes because of #24219
    development: !!(['1', 'actions', 'amp', 'amp4ads', 'amp4email'].indexOf(hashQuery['development']) >= 0 || win.AMP_DEV_MODE),
    examiner: hashQuery['development'] == '2',
    esm: false,
    // amp-geo override
    geoOverride: hashQuery['amp-geo'],
    minified: IS_MINIFIED,
    // Whether document is in an amp-lite viewer. It signal that the user
    // would prefer to use less bandwidth.
    lite: searchQuery['amp_lite'] != undefined,
    test: runningTests,
    log: hashQuery['log'],
    version: (0, _internalVersion.internalRuntimeVersion)(),
    rtvVersion: rtvVersion
  };
}

/**
 * Retrieve the `rtvVersion` which will have a numeric prefix
 * denoting canary/prod/experiment (unless `isLocalDev` is true).
 *
 * @param {!Window} win
 * @return {string}
 */
function getRtvVersion(win) {
  if (win.AMP_CONFIG && win.AMP_CONFIG.v) {
    return win.AMP_CONFIG.v;
  }

  // Currently `internalRuntimeVersion` and thus `mode.version` contain only
  // major version. The full version however must also carry the minor version.
  // We will default to production default `01` minor version for now.
  // TODO(erwinmombay): decide whether internalRuntimeVersion should contain
  // minor version.
  return "01" + (0, _internalVersion.internalRuntimeVersion)();
}

/**
 * @param {!Window} win
 * @return {string}
 * @visibleForTesting
 */
function getRtvVersionForTesting(win) {
  return getRtvVersion(win);
}

/** @visibleForTesting */
function resetRtvVersionForTesting() {
  rtvVersion = '';
}

},{"./internal-version":119,"./url-parse-query-string":140}],125:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.calcVelocity = calcVelocity;
exports.continueMotion = continueMotion;
exports.Motion = void 0;

var _promise = require("./utils/promise");

var _services = require("./services");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {function()} */
var NOOP_CALLBACK_ = function NOOP_CALLBACK_() {};

/** @const {number} */
var MIN_VELOCITY_ = 0.02;

/** @const {number} */
var FRAME_CONST_ = 16.67;

/** @const {number} */
var EXP_FRAME_CONST_ = Math.round(-FRAME_CONST_ / Math.log(0.95));

/**
 * Depreciation factor of 1/100 of a millisecond. This is how much previous
 * velocity is depreciated when calculating the new velocity.
 * @const {number}
 */
var VELOCITY_DEPR_FACTOR_ = FRAME_CONST_ * 2;

/**
 * Calculates velocity for an object traveling the distance deltaV in the
 * time deltaTime given the previous velocity prevVelocity. The calculation
 * assumes a basic informational depreciation of previous velocity.
 * @param {number} deltaV
 * @param {time} deltaTime
 * @param {number} prevVelocity
 * @return {number}
 */
function calcVelocity(deltaV, deltaTime, prevVelocity) {
  if (deltaTime < 1) {
    deltaTime = 1;
  }

  // Calculate speed and speed depreciation.
  var speed = deltaV / deltaTime;
  // Depreciation is simply an informational quality. It basically means:
  // we can't ignore the velocity we knew recently, but we'd only consider
  // it proportionally to how long ago we've seen it. Currently, this
  // depreciation factor is 1/100 of a millisecond. New average velocity is
  // calculated by weighing toward the new velocity and away from old
  // velocity based on the depreciation.
  var depr = 0.5 + Math.min(deltaTime / VELOCITY_DEPR_FACTOR_, 0.5);
  return speed * depr + prevVelocity * (1 - depr);
}

/**
 * Returns a motion process that will yield when the velocity has run down to
 * zerp. For each iteration, the velocity is depreciated and the coordinates
 * are advanced from start X/Y to the destination according to velocity
 * vectors. For each such iteration the callback is called with the new x and y.
 * @param {!Node} contextNode
 * @param {number} startX Start X coordinate.
 * @param {number} startY Start Y coordinate.
 * @param {number} veloX Starting X velocity.
 * @param {number} veloY Starting Y velocity.
 * @param {function(number, number):boolean} callback The callback for each
 *   step of the deceleration motion.
 * @param {!./service/vsync-impl.Vsync=} opt_vsync Mostly for testing only.
 * @return {!Motion}
 */
function continueMotion(contextNode, startX, startY, veloX, veloY, callback, opt_vsync) {
  return new Motion(contextNode, startX, startY, veloX, veloY, callback, opt_vsync).start();
}

/**
 * Motion process that allows tracking and monitoring of the running motion.
 * Most importantly it exposes methods "then" and "thenAlways" that have the
 * semantics of a Promise and signal when the motion has completed or failed.
 * Additionally, it exposes the method "halt" which allows to stop/reset the
 * motion.
 * @implements {IThenable}
 */
var Motion = /*#__PURE__*/function () {
  /**
   * @param {!Node} contextNode Context node.
   * @param {number} startX Start X coordinate.
   * @param {number} startY Start Y coordinate.
   * @param {number} veloX Starting X velocity.
   * @param {number} veloY Starting Y velocity.
   * @param {function(number, number):boolean} callback The callback for each
   *   step of the deceleration motion.
   * @param {!./service/vsync-impl.Vsync=} opt_vsync
   */
  function Motion(contextNode, startX, startY, veloX, veloY, callback, opt_vsync) {
    _classCallCheck(this, Motion);

    /** @private @const {!./service/vsync-impl.Vsync} */
    this.vsync_ = opt_vsync || _services.Services.vsyncFor(self);

    /** @private @const {!Node} */
    this.contextNode_ = contextNode;

    /** @private @const */
    this.callback_ = callback;

    /** @private {number} */
    this.lastX_ = startX;

    /** @private {number} */
    this.lastY_ = startY;

    /** @private {number} */
    this.maxVelocityX_ = veloX;

    /** @private {number} */
    this.maxVelocityY_ = veloY;

    /** @private {number} */
    this.velocityX_ = 0;

    /** @private {number} */
    this.velocityY_ = 0;
    var deferred = new _promise.Deferred();

    /** @private {!Promise} */
    this.promise_ = deferred.promise;

    /** @private {!Function} */
    this.resolve_ = deferred.resolve;

    /** @private {!Function} */
    this.reject_ = deferred.reject;

    /** @private {boolean} */
    this.continuing_ = false;
  }

  /** */
  _createClass(Motion, [{
    key: "start",
    value: function start() {
      this.continuing_ = true;

      if (Math.abs(this.maxVelocityX_) <= MIN_VELOCITY_ && Math.abs(this.maxVelocityY_) <= MIN_VELOCITY_) {
        this.fireMove_();
        this.completeContinue_(true);
      } else {
        this.runContinuing_();
      }

      return this;
    }
    /**
     * Halts the motion. The motion promise will be rejected since the motion
     * has been interrupted.
     */

  }, {
    key: "halt",
    value: function halt() {
      if (this.continuing_) {
        this.completeContinue_(false);
      }
    }
    /**
     * Chains to the motion's promise that will resolve when the motion has
     * completed or will reject if motion has failed or was interrupted.
     * @override
     */

  }, {
    key: "then",
    value: function then(opt_resolve, opt_reject) {
      if (!opt_resolve && !opt_reject) {
        return this.promise_;
      }

      return this.promise_.then(opt_resolve, opt_reject);
    }
    /**
     * Callback for regardless whether the motion succeeds or fails.
     * @param {function()=} opt_callback
     * @return {!Promise}
     */

  }, {
    key: "thenAlways",
    value: function thenAlways(opt_callback) {
      var callback = opt_callback || NOOP_CALLBACK_;
      return (
        /** @type {!Promise} */
        this.then(callback, callback)
      );
    }
    /**
     * @return {!Promise}
     * @private
     */

  }, {
    key: "runContinuing_",
    value: function runContinuing_() {
      this.velocityX_ = this.maxVelocityX_;
      this.velocityY_ = this.maxVelocityY_;
      var boundStep = this.stepContinue_.bind(this);
      var boundComplete = this.completeContinue_.bind(this, true);
      return this.vsync_.runAnimMutateSeries(this.contextNode_, boundStep, 5000).then(boundComplete, boundComplete);
    }
    /**
     * Returns "true" to continue and "false" to stop motion process.
     * @param {time} timeSinceStart
     * @param {time} timeSincePrev
     * @return {boolean}
     * @private
     */

  }, {
    key: "stepContinue_",
    value: function stepContinue_(timeSinceStart, timeSincePrev) {
      if (!this.continuing_) {
        return false;
      }

      this.lastX_ += timeSincePrev * this.velocityX_;
      this.lastY_ += timeSincePrev * this.velocityY_;

      if (!this.fireMove_()) {
        return false;
      }

      var decel = Math.exp(-timeSinceStart / EXP_FRAME_CONST_);
      this.velocityX_ = this.maxVelocityX_ * decel;
      this.velocityY_ = this.maxVelocityY_ * decel;
      return Math.abs(this.velocityX_) > MIN_VELOCITY_ || Math.abs(this.velocityY_) > MIN_VELOCITY_;
    }
    /**
     * @param {boolean} success
     * @private
     */

  }, {
    key: "completeContinue_",
    value: function completeContinue_(success) {
      if (!this.continuing_) {
        return;
      }

      this.continuing_ = false;
      this.fireMove_();

      if (success) {
        this.resolve_();
      } else {
        this.reject_();
      }
    }
    /** @private */

  }, {
    key: "fireMove_",
    value: function fireMove_() {
      return this.callback_(this.lastX_, this.lastY_);
    }
  }]);

  return Motion;
}();

exports.Motion = Motion;

},{"./services":133,"./utils/promise":150}],126:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * This class helps to manage observers. Observers can be added, removed or
 * fired through and instance of this class.
 * @template TYPE
 */
var Observable = /*#__PURE__*/function () {
  /**
   * Creates an instance of Observable.
   */
  function Observable() {
    _classCallCheck(this, Observable);

    /** @type {?Array<function(TYPE)>} */
    this.handlers_ = null;
  }

  /**
   * Adds the observer to this instance.
   * @param {function(TYPE)} handler Observer's handler.
   * @return {!UnlistenDef}
   */
  _createClass(Observable, [{
    key: "add",
    value: function add(handler) {
      var _this = this;

      if (!this.handlers_) {
        this.handlers_ = [];
      }

      this.handlers_.push(handler);
      return function () {
        _this.remove(handler);
      };
    }
    /**
     * Removes the observer from this instance.
     * @param {function(TYPE)} handler Observer's instance.
     */

  }, {
    key: "remove",
    value: function remove(handler) {
      if (!this.handlers_) {
        return;
      }

      var index = this.handlers_.indexOf(handler);

      if (index > -1) {
        this.handlers_.splice(index, 1);
      }
    }
    /**
     * Removes all observers.
     */

  }, {
    key: "removeAll",
    value: function removeAll() {
      if (!this.handlers_) {
        return;
      }

      this.handlers_.length = 0;
    }
    /**
     * Fires an event. All observers are called.
     * @param {TYPE=} opt_event
     */

  }, {
    key: "fire",
    value: function fire(opt_event) {
      if (!this.handlers_) {
        return;
      }

      var handlers = this.handlers_;

      for (var i = 0; i < handlers.length; i++) {
        var handler = handlers[i];
        handler(opt_event);
      }
    }
    /**
     * Returns number of handlers. Mostly needed for tests.
     * @return {number}
     */

  }, {
    key: "getHandlerCount",
    value: function getHandlerCount() {
      if (!this.handlers_) {
        return 0;
      }

      return this.handlers_.length;
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;

},{}],127:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Pass = void 0;

var _services = require("./services");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Pass class helps to manage single-pass process. A pass is scheduled using
 * delay method. Only one pass can be pending at a time. If no pass is pending
 * the process is considered to be "idle".
 */
var Pass = /*#__PURE__*/function () {
  /**
   * Creates a new Pass instance.
   * @param {!Window} win
   * @param {function()} handler Handler to be executed when pass is triggered.
   * @param {number=} opt_defaultDelay Default delay to be used when schedule
   *   is called without one.
   */
  function Pass(win, handler, opt_defaultDelay) {
    var _this = this;

    _classCallCheck(this, Pass);

    this.timer_ = _services.Services.timerFor(win);

    /** @private @const {function()} */
    this.handler_ = handler;

    /** @private @const {number} */
    this.defaultDelay_ = opt_defaultDelay || 0;

    /** @private {number|string} */
    this.scheduled_ = -1;

    /** @private {number} */
    this.nextTime_ = 0;

    /** @private {boolean} */
    this.running_ = false;

    /**
     * @private
     * @const {function()}
     */
    this.boundPass_ = function () {
      _this.pass_();
    };
  }

  /**
   * Whether or not a pass is currently pending.
   * @return {boolean}
   */
  _createClass(Pass, [{
    key: "isPending",
    value: function isPending() {
      return this.scheduled_ != -1;
    }
    /**
     * Tries to schedule a new pass optionally with specified delay. If the new
     * requested pass is requested before the pending pass, the pending pass is
     * canceled. If the new pass is requested after the pending pass, the newly
     * requested pass is ignored.
     *
     * Returns {@code true} if the pass has been scheduled and {@code false} if
     * ignored.
     *
     * @param {number=} opt_delay Delay to schedule the pass. If not specified
     *   the default delay is used, falling back to 0.
     * @return {boolean}
     */

  }, {
    key: "schedule",
    value: function schedule(opt_delay) {
      var delay = opt_delay || this.defaultDelay_;

      if (this.running_ && delay < 10) {
        // If we get called recursively, wait at least 10ms for the next
        // execution.
        delay = 10;
      }

      var nextTime = Date.now() + delay;

      // Schedule anew if nothing is scheduled currently or if the new time is
      // sooner then previously requested.
      if (!this.isPending() || nextTime - this.nextTime_ < -10) {
        this.cancel();
        this.nextTime_ = nextTime;
        this.scheduled_ = this.timer_.delay(this.boundPass_, delay);
        return true;
      }

      return false;
    }
    /**
     *
     */

  }, {
    key: "pass_",
    value: function pass_() {
      this.scheduled_ = -1;
      this.nextTime_ = 0;
      this.running_ = true;
      this.handler_();
      this.running_ = false;
    }
    /**
     * Cancels the pending pass if any.
     */

  }, {
    key: "cancel",
    value: function cancel() {
      if (this.isPending()) {
        this.timer_.cancel(this.scheduled_);
        this.scheduled_ = -1;
      }
    }
  }]);

  return Pass;
}();

exports.Pass = Pass;

},{"./services":133}],128:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.waitForServices = waitForServices;
exports.hasRenderDelayingServices = hasRenderDelayingServices;
exports.isRenderDelayingService = isRenderDelayingService;
exports.includedServices = includedServices;
exports.RenderDelayingService = void 0;

var _services = require("./services");

var _log = require("./log");

var _service = require("./service");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * A map of services that delay rendering. The key is the name of the service
 * and the value is a DOM query which is used to check if the service is needed
 * in the current document.
 * Do not add a service unless absolutely necessary.
 *
 * \   \  /  \  /   / /   \     |   _  \     |  \ |  | |  | |  \ |  |  / _____|
 *  \   \/    \/   / /  ^  \    |  |_)  |    |   \|  | |  | |   \|  | |  |  __
 *   \            / /  /_\  \   |      /     |  . `  | |  | |  . `  | |  | |_ |
 *    \    /\    / /  _____  \  |  |\  \----.|  |\   | |  | |  |\   | |  |__| |
 *     \__/  \__/ /__/     \__\ | _| `._____||__| \__| |__| |__| \__|  \______|
 *
 * The equivalent of this list is used for server-side rendering (SSR) and any
 * changes made to it must be made in coordination with caches that implement
 * SSR. For more information on SSR see bit.ly/amp-ssr.
 *
 * @const {!Object<string, string>}
 */
var SERVICES = {
  'amp-dynamic-css-classes': '[custom-element=amp-dynamic-css-classes]',
  'variant': 'amp-experiment',
  'amp-story-render': 'amp-story[standalone]'
};

/**
 * Base class for render delaying services.
 * This should be extended to ensure the service
 * is properly handled
 *
 * @interface
 */
var RenderDelayingService = /*#__PURE__*/function () {
  function RenderDelayingService() {
    _classCallCheck(this, RenderDelayingService);
  }

  _createClass(RenderDelayingService, [{
    key: "whenReady",

    /**
     * Function to return a promise for when
     * it is finished delaying render, and is ready.
     * NOTE: This should simply return Promise.resolve,
     * if your service does not need to perform any logic
     * after being registered.
     * @return {!Promise}
     */
    value: function whenReady() {}
  }]);

  return RenderDelayingService;
}();

exports.RenderDelayingService = RenderDelayingService;

/**
 * Maximum milliseconds to wait for all extensions to load before erroring.
 * @const
 */
var LOAD_TIMEOUT = 3000;

/**
 * Detects any render delaying services that are required on the page, and
 * returns a promise with a timeout.
 * @param {!Window} win
 * @return {!Promise<!Array<*>>} resolves to an Array that has the same length
 *     as the detected render delaying services
 */
function waitForServices(win) {
  var promises = includedServices(win).map(function (serviceId) {
    var serviceReadyPromise = (0, _service.getServicePromise)(win, serviceId).then(function (service) {
      if (service && isRenderDelayingService(service)) {
        return service.whenReady().then(function () {
          return service;
        });
      }

      return service;
    });
    return _services.Services.timerFor(win).timeoutPromise(LOAD_TIMEOUT, serviceReadyPromise, "Render timeout waiting for service " + serviceId + " to be ready.");
  });
  return Promise.all(promises);
}

/**
 * Returns true if the page has a render delaying service.
 * @param {!Window} win
 * @return {boolean}
 */
function hasRenderDelayingServices(win) {
  return includedServices(win).length > 0;
}

/**
 * Function to determine if the passed
 * Object is a Render Delaying Service
 * @param {!Object} service
 * @return {boolean}
 */
function isRenderDelayingService(service) {
  var maybeRenderDelayingService =
  /** @type {!RenderDelayingService}*/
  service;
  return typeof maybeRenderDelayingService.whenReady == 'function';
}

/**
 * Detects which, if any, render-delaying extensions are included on the page.
 * @param {!Window} win
 * @return {!Array<string>}
 */
function includedServices(win) {
  /** @const {!Document} */
  var doc = win.document;
  (0, _log.devAssert)(doc.body);
  return Object.keys(SERVICES).filter(function (service) {
    return doc.querySelector(SERVICES[service]);
  });
}

},{"./log":123,"./service":130,"./services":133}],129:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.resolvedPromise = resolvedPromise;

/**
 * Copyright 2020 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var resolved;

/**
 * Returns a cached resolved promise.
 * Use this instead of directly calling Promise.resolve().
 * @return {!Promise<undefined>}
 */
function resolvedPromise() {
  if (resolved) {
    return resolved;
  }

  // It's important that we call with `undefined` here, to prevent a transform
  // recursion. If we didn't pass an arg, then the transformer would replace
  // this callsite with a call to `resolvedPromise()`.
  resolved = Promise.resolve(undefined);
  return resolved;
}

},{}],130:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getExistingServiceForDocInEmbedScope = getExistingServiceForDocInEmbedScope;
exports.installServiceInEmbedScope = installServiceInEmbedScope;
exports.registerServiceBuilder = registerServiceBuilder;
exports.registerServiceBuilderForDoc = registerServiceBuilderForDoc;
exports.rejectServicePromiseForDoc = rejectServicePromiseForDoc;
exports.getService = getService;
exports.getServicePromise = getServicePromise;
exports.getExistingServiceOrNull = getExistingServiceOrNull;
exports.getServicePromiseOrNull = getServicePromiseOrNull;
exports.getServiceForDoc = getServiceForDoc;
exports.getServicePromiseForDoc = getServicePromiseForDoc;
exports.getServicePromiseOrNullForDoc = getServicePromiseOrNullForDoc;
exports.setParentWindow = setParentWindow;
exports.getParentWindow = getParentWindow;
exports.getTopWindow = getTopWindow;
exports.getParentWindowFrameElement = getParentWindowFrameElement;
exports.getAmpdoc = getAmpdoc;
exports.isDisposable = isDisposable;
exports.assertDisposable = assertDisposable;
exports.disposeServicesForDoc = disposeServicesForDoc;
exports.disposeServicesForEmbed = disposeServicesForEmbed;
exports.installServiceInEmbedIfEmbeddable = installServiceInEmbedIfEmbeddable;
exports.adoptServiceForEmbedDoc = adoptServiceForEmbedDoc;
exports.resetServiceForTesting = resetServiceForTesting;
exports.EmbeddableService = exports.Disposable = void 0;

var _promise = require("./utils/promise");

var _log = require("./log");

var _ampdocFie = require("./ampdoc-fie");

var _types = require("./types");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Holds info about a service.
 * - obj: Actual service implementation when available.
 * - promise: Promise for the obj.
 * - resolve: Function to resolve the promise with the object.
 * - context: Argument for ctor, either a window or an ampdoc.
 * - ctor: Function that constructs and returns the service.
 * @typedef {{
 *   obj: (?Object),
 *   promise: (?Promise),
 *   resolve: (?function(!Object)),
 *   reject: (?function((*))),
 *   context: (?Window|?./service/ampdoc-impl.AmpDoc),
 *   ctor: (?function(new:Object, !Window)|
 *          ?function(new:Object, !./service/ampdoc-impl.AmpDoc)),
 * }}
 */
var ServiceHolderDef;

/**
 * This interface provides a `dispose` method that will be called by
 * runtime when a service needs to be disposed of.
 * @interface
 */
var Disposable = /*#__PURE__*/function () {
  function Disposable() {
    _classCallCheck(this, Disposable);
  }

  _createClass(Disposable, [{
    key: "dispose",

    /**
     * Instructs the service to release any resources it might be holding. Can
     * be called only once in the lifecycle of a service.
     */
    value: function dispose() {}
  }]);

  return Disposable;
}();

exports.Disposable = Disposable;

/**
 * Services must implement this interface to be embeddable in FIEs.
 * @interface
 */
var EmbeddableService = /*#__PURE__*/function () {
  function EmbeddableService() {
    _classCallCheck(this, EmbeddableService);
  }

  _createClass(EmbeddableService, null, [{
    key: "installInEmbedWindow",

    /**
     * Installs a new instance of the service in the given FIE window.
     * @param {!Window} unusedEmbedWin
     * @param {!./service/ampdoc-impl.AmpDoc} unusedAmpDoc
     */
    value: function installInEmbedWindow(unusedEmbedWin, unusedAmpDoc) {}
  }]);

  return EmbeddableService;
}();

exports.EmbeddableService = EmbeddableService;

/**
 * Returns a service with the given id. Assumes that it has been constructed
 * already.
 *
 * @param {!Element|!ShadowRoot} element
 * @param {string} id
 * @return {?Object}
 */
function getExistingServiceForDocInEmbedScope(element, id) {
  // TODO(#22733): completely remove this method once ampdoc-fie launches.
  var document = element.ownerDocument;
  var win = (0, _types.toWin)(document.defaultView);
  var topWin = getTopWindow(win);
  // First, try to resolve via local embed window (if applicable).
  var isEmbed = win != topWin;
  var ampdocFieExperimentOn = (0, _ampdocFie.isInAmpdocFieExperiment)(topWin);

  if (isEmbed && !ampdocFieExperimentOn) {
    if (isServiceRegistered(win, id)) {
      return getServiceInternal(win, id);
    }

    // Fallback from FIE to parent is intentionally unsupported for safety.
    return null;
  } else {
    // Resolve via the element's ampdoc.
    return getServiceForDocOrNullInternal(element, id);
  }
}

/**
 * Installs a service override on amp-doc level.
 * @param {!Window} embedWin
 * @param {string} id
 * @param {!Object} service The service.
 */
function installServiceInEmbedScope(embedWin, id, service) {
  var topWin = getTopWindow(embedWin);
  (0, _log.devAssert)(embedWin != topWin, 'Service override can only be installed in embed window: %s', id);
  (0, _log.devAssert)(!isServiceRegistered(embedWin, id), 'Service override has already been installed: %s', id);
  var ampdocFieExperimentOn = (0, _ampdocFie.isInAmpdocFieExperiment)(topWin);

  if (ampdocFieExperimentOn) {
    var ampdoc = getAmpdoc(embedWin.document);
    registerServiceInternal(getAmpdocServiceHolder(ampdoc), ampdoc, id, function () {
      return service;
    },
    /* override */
    true);
  } else {
    registerServiceInternal(embedWin, embedWin, id, function () {
      return service;
    });
    getServiceInternal(embedWin, id);
  }
}

/**
 * Registers a service given a class to be used as implementation.
 * @param {!Window} win
 * @param {string} id of the service.
 * @param {function(new:Object, !Window)} constructor
 * @param {boolean=} opt_instantiate Whether to immediately create the service
 */
function registerServiceBuilder(win, id, constructor, opt_instantiate) {
  win = getTopWindow(win);
  registerServiceInternal(win, win, id, constructor);

  if (opt_instantiate) {
    getServiceInternal(win, id);
  }
}

/**
 * Returns a service and registers it given a class to be used as
 * implementation.
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @param {string} id of the service.
 * @param {function(new:Object, !./service/ampdoc-impl.AmpDoc)} constructor
 * @param {boolean=} opt_instantiate Whether to immediately create the service
 */
function registerServiceBuilderForDoc(nodeOrDoc, id, constructor, opt_instantiate) {
  var ampdoc = getAmpdoc(nodeOrDoc);
  var holder = getAmpdocServiceHolder(ampdoc);
  registerServiceInternal(holder, ampdoc, id, constructor);

  if (opt_instantiate) {
    getServiceInternal(holder, id);
  }
}

/**
 * Reject a service promise.
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @param {string} id
 * @param {*} error
 */
function rejectServicePromiseForDoc(nodeOrDoc, id, error) {
  var ampdoc = getAmpdoc(nodeOrDoc);
  var holder = getAmpdocServiceHolder(ampdoc);
  rejectServicePromiseInternal(holder, id, error);
}

/**
 * Returns a service for the given id and window (a per-window singleton). Users
 * should typically wrap this as a special purpose function (e.g.
 * `Services.vsyncFor(win)`) for type safety and because the factory should not
 * be passed around.
 * @param {!Window} win
 * @param {string} id of the service.
 * @template T
 * @return {T}
 */
function getService(win, id) {
  win = getTopWindow(win);
  return getServiceInternal(win, id);
}

/**
 * Returns a promise for a service for the given id and window. Also expects an
 * element that has the actual implementation. The promise resolves when the
 * implementation loaded. Users should typically wrap this as a special purpose
 * function (e.g. `Services.vsyncFor(win)`) for type safety and because the
 * factory should not be passed around.
 * @param {!Window} win
 * @param {string} id of the service.
 * @return {!Promise<!Object>}
 */
function getServicePromise(win, id) {
  return getServicePromiseInternal(win, id);
}

/**
 * Returns a service or null with the given id.
 * @param {!Window} win
 * @param {string} id
 * @return {?Object} The service.
 */
function getExistingServiceOrNull(win, id) {
  win = getTopWindow(win);

  if (isServiceRegistered(win, id)) {
    return getServiceInternal(win, id);
  } else {
    return null;
  }
}

/**
 * Like getServicePromise but returns null if the service was never registered.
 * @param {!Window} win
 * @param {string} id
 * @return {?Promise<!Object>}
 */
function getServicePromiseOrNull(win, id) {
  return getServicePromiseOrNullInternal(win, id);
}

/**
 * Returns a service for the given id and ampdoc (a per-ampdoc singleton).
 * Expects service `id` to be registered.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {T}
 * @template T
 */
function getServiceForDoc(elementOrAmpDoc, id) {
  var ampdoc = getAmpdoc(elementOrAmpDoc);
  var holder = getAmpdocServiceHolder(ampdoc);
  return getServiceInternal(holder, id);
}

/**
 * Returns a service for the given id and ampdoc (a per-ampdoc singleton).
 * If service `id` is not registered, returns null.
 * @param {!Element|!ShadowRoot} element
 * @param {string} id
 * @return {?Object}
 */
function getServiceForDocOrNullInternal(element, id) {
  var ampdoc = getAmpdoc(element);
  var holder = getAmpdocServiceHolder(ampdoc);

  if (isServiceRegistered(holder, id)) {
    return getServiceInternal(holder, id);
  } else {
    return null;
  }
}

/**
 * Returns a promise for a service for the given id and ampdoc. Also expects
 * a service that has the actual implementation. The promise resolves when
 * the implementation loaded.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {!Promise<!Object>}
 */
function getServicePromiseForDoc(elementOrAmpDoc, id) {
  return getServicePromiseInternal(getAmpdocServiceHolder(elementOrAmpDoc), id);
}

/**
 * Like getServicePromiseForDoc but returns null if the service was never
 * registered for this ampdoc.
 * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
 * @param {string} id
 * @return {?Promise<!Object>}
 */
function getServicePromiseOrNullForDoc(elementOrAmpDoc, id) {
  return getServicePromiseOrNullInternal(getAmpdocServiceHolder(elementOrAmpDoc), id);
}

/**
 * Set the parent and top windows on a child window (friendly iframe).
 * @param {!Window} win
 * @param {!Window} parentWin
 */
function setParentWindow(win, parentWin) {
  win.__AMP_PARENT = parentWin;
  win.__AMP_TOP = getTopWindow(parentWin);
}

/**
 * Returns the parent window for a child window (friendly iframe).
 * @param {!Window} win
 * @return {!Window}
 */
function getParentWindow(win) {
  return win.__AMP_PARENT || win;
}

/**
 * Returns the top window where AMP Runtime is installed for a child window
 * (friendly iframe).
 * @param {!Window} win
 * @return {!Window}
 */
function getTopWindow(win) {
  return win.__AMP_TOP || (win.__AMP_TOP = win);
}

/**
 * Returns the parent "friendly" iframe if the node belongs to a child window.
 * @param {!Node} node
 * @param {!Window=} opt_topWin
 * @return {?HTMLIFrameElement}
 */
function getParentWindowFrameElement(node, opt_topWin) {
  var childWin = (node.ownerDocument || node).defaultView;
  var topWin = opt_topWin || getTopWindow(childWin);

  if (childWin && childWin != topWin && getTopWindow(childWin) == topWin) {
    try {
      return (
        /** @type {?HTMLIFrameElement} */
        childWin.frameElement
      );
    } catch (e) {// Ignore the error.
    }
  }

  return null;
}

/**
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @return {!./service/ampdoc-impl.AmpDoc}
 */
function getAmpdoc(nodeOrDoc) {
  if (nodeOrDoc.nodeType) {
    var win = (0, _types.toWin)(
    /** @type {!Document} */
    (nodeOrDoc.ownerDocument || nodeOrDoc).defaultView);
    return getAmpdocService(win).getAmpDoc(
    /** @type {!Node} */
    nodeOrDoc);
  }

  return (
    /** @type {!./service/ampdoc-impl.AmpDoc} */
    nodeOrDoc
  );
}

/**
 * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrDoc
 * @return {!./service/ampdoc-impl.AmpDoc|!Window}
 */
function getAmpdocServiceHolder(nodeOrDoc) {
  var ampdoc = getAmpdoc(nodeOrDoc);
  return ampdoc.isSingleDoc() ? ampdoc.win : ampdoc;
}

/**
 * This is essentially a duplicate of `ampdoc.js`, but necessary to avoid
 * circular dependencies.
 * @param {!Window} win
 * @return {!./service/ampdoc-impl.AmpDocService}
 */
function getAmpdocService(win) {
  return (
    /** @type {!./service/ampdoc-impl.AmpDocService} */
    getService(win, 'ampdoc')
  );
}

/**
 * Get service `id` from `holder`. Assumes the service
 * has already been registered.
 * @param {!Object} holder Object holding the service instance.
 * @param {string} id of the service.
 * @return {Object}
 * @template T
 */
function getServiceInternal(holder, id) {
  (0, _log.devAssert)(isServiceRegistered(holder, id), "Expected service " + id + " to be registered");
  var services = getServices(holder);
  var s = services[id];

  if (!s.obj) {
    (0, _log.devAssert)(s.ctor, "Service " + id + " registered without ctor nor impl.");
    (0, _log.devAssert)(s.context, "Service " + id + " registered without context.");
    s.obj = new s.ctor(s.context);
    (0, _log.devAssert)(s.obj, "Service " + id + " constructed to null.");
    s.ctor = null;
    s.context = null;

    // The service may have been requested already, in which case we have a
    // pending promise we need to fulfill.
    if (s.resolve) {
      s.resolve(s.obj);
    }
  }

  return s.obj;
}

/**
 * @param {!Object} holder Object holding the service instance.
 * @param {!Window|!./service/ampdoc-impl.AmpDoc} context Win or AmpDoc.
 * @param {string} id of the service.
 * @param {?function(new:Object, !Window)|?function(new:Object, !./service/ampdoc-impl.AmpDoc)} ctor Constructor function to new the service. Called with context.
 * @param {boolean=} opt_override
 */
function registerServiceInternal(holder, context, id, ctor, opt_override) {
  var services = getServices(holder);
  var s = services[id];

  if (!s) {
    s = services[id] = {
      obj: null,
      promise: null,
      resolve: null,
      reject: null,
      context: null,
      ctor: null
    };
  }

  if (!opt_override && (s.ctor || s.obj)) {
    // Service already registered.
    return;
  }

  s.ctor = ctor;
  s.context = context;

  // The service may have been requested already, in which case there is a
  // pending promise that needs to fulfilled.
  if (s.resolve) {
    // getServiceInternal will resolve the promise.
    getServiceInternal(holder, id);
  }
}

/**
 * @param {!Object} holder
 * @param {string} id of the service.
 * @return {!Promise<!Object>}
 */
function getServicePromiseInternal(holder, id) {
  var cached = getServicePromiseOrNullInternal(holder, id);

  if (cached) {
    return cached;
  }

  // Service is not registered.
  // TODO(@cramforce): Add a check that if the element is eventually registered
  // that the service is actually provided and this promise resolves.
  var services = getServices(holder);
  services[id] = emptyServiceHolderWithPromise();
  return (
    /** @type {!Promise<!Object>} */
    services[id].promise
  );
}

/**
 * @param {!Object} holder
 * @param {string} id of the service.
 * @param {*} error
 */
function rejectServicePromiseInternal(holder, id, error) {
  var services = getServices(holder);
  var s = services[id];

  if (s) {
    if (s.reject) {
      s.reject(error);
    }

    return;
  }

  services[id] = emptyServiceHolderWithPromise();
  services[id].reject(error);
}

/**
 * Returns a promise for service `id` if the service has been registered
 * on `holder`.
 * @param {!Object} holder
 * @param {string} id of the service.
 * @return {?Promise<!Object>}
 */
function getServicePromiseOrNullInternal(holder, id) {
  var services = getServices(holder);
  var s = services[id];

  if (s) {
    if (s.promise) {
      return s.promise;
    } else {
      // Instantiate service if not already instantiated.
      getServiceInternal(holder, id);
      return s.promise = Promise.resolve(
      /** @type {!Object} */
      s.obj);
    }
  }

  return null;
}

/**
 * Returns the object that holds the services registered in a holder.
 * @param {!Object} holder
 * @return {!Object<string,!ServiceHolderDef>}
 */
function getServices(holder) {
  var services = holder.__AMP_SERVICES;

  if (!services) {
    services = holder.__AMP_SERVICES = {};
  }

  return services;
}

/**
 * Whether the specified service implements `Disposable` interface.
 * @param {!Object} service
 * @return {boolean}
 */
function isDisposable(service) {
  return typeof service.dispose == 'function';
}

/**
 * Asserts that the specified service implements `Disposable` interface and
 * typecasts the instance to `Disposable`.
 * @param {!Object} service
 * @return {!Disposable}
 */
function assertDisposable(service) {
  (0, _log.devAssert)(isDisposable(service), 'required to implement Disposable');
  return (
    /** @type {!Disposable} */
    service
  );
}

/**
 * Disposes all disposable (implements `Disposable` interface) services in
 * ampdoc scope.
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc
 */
function disposeServicesForDoc(ampdoc) {
  disposeServicesInternal(ampdoc);
}

/**
 * Disposes all disposable (implements `Disposable` interface) services in
 * embed scope.
 * @param {!Window} embedWin
 */
function disposeServicesForEmbed(embedWin) {
  disposeServicesInternal(embedWin);
}

/**
 * @param {!Object} holder Object holding the service instances.
 */
function disposeServicesInternal(holder) {
  // TODO(dvoytenko): Consider marking holder as destroyed for later-arriving
  // service to be canceled automatically.
  var services = getServices(holder);

  var _loop = function _loop(id) {
    if (!Object.prototype.hasOwnProperty.call(services, id)) {
      return "continue";
    }

    var serviceHolder = services[id];

    if (serviceHolder.obj) {
      disposeServiceInternal(id, serviceHolder.obj);
    } else if (serviceHolder.promise) {
      serviceHolder.promise.then(function (instance) {
        return disposeServiceInternal(id, instance);
      });
    }
  };

  for (var id in services) {
    var _ret = _loop(id);

    if (_ret === "continue") continue;
  }
}

/**
 * @param {string} id
 * @param {!Object} service
 */
function disposeServiceInternal(id, service) {
  if (!isDisposable(service)) {
    return;
  }

  try {
    assertDisposable(service).dispose();
  } catch (e) {
    // Ensure that a failure to dispose a service does not disrupt other
    // services.
    (0, _log.dev)().error('SERVICE', 'failed to dispose service', id, e);
  }
}

/**
 * Adopts an embeddable (implements `EmbeddableService` interface) service
 * in embed scope.
 * @param {!Window} embedWin
 * @param {function(new:Object, !./service/ampdoc-impl.AmpDoc)} serviceClass
 * @suppress {missingProperties}
 * @return {boolean}
 */
function installServiceInEmbedIfEmbeddable(embedWin, serviceClass) {
  var isEmbeddableService = typeof serviceClass.installInEmbedWindow === 'function';

  if (!isEmbeddableService) {
    return false;
  }

  var frameElement = (0, _log.dev)().assertElement(embedWin.frameElement, 'frameElement not found for embed');
  var ampdoc = getAmpdoc(frameElement);
  serviceClass.installInEmbedWindow(embedWin, ampdoc);
  return true;
}

/**
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc
 * @param {string} id
 */
function adoptServiceForEmbedDoc(ampdoc, id) {
  var service = getServiceInternal(getAmpdocServiceHolder((0, _log.devAssert)(ampdoc.getParent())), id);
  registerServiceInternal(getAmpdocServiceHolder(ampdoc), ampdoc, id, function () {
    return service;
  });
}

/**
 * Resets a single service, so it gets recreated on next getService invocation.
 * @param {!Object} holder
 * @param {string} id of the service.
 */
function resetServiceForTesting(holder, id) {
  if (holder.__AMP_SERVICES) {
    holder.__AMP_SERVICES[id] = null;
  }
}

/**
 * @param {!Object} holder Object holding the service instance.
 * @param {string} id of the service.
 * @return {boolean}
 */
function isServiceRegistered(holder, id) {
  var service = holder.__AMP_SERVICES && holder.__AMP_SERVICES[id];
  // All registered services must have an implementation or a constructor.
  return !!(service && (service.ctor || service.obj));
}

/** @return {!ServiceHolderDef} */
function emptyServiceHolderWithPromise() {
  var deferred = new _promise.Deferred();
  var promise = deferred.promise,
      resolve = deferred.resolve,
      reject = deferred.reject;
  promise.catch(function () {});
  // avoid uncaught exception when service gets rejected
  return {
    obj: null,
    promise: promise,
    resolve: resolve,
    reject: reject,
    context: null,
    ctor: null
  };
}

},{"./ampdoc-fie":98,"./log":123,"./types":139,"./utils/promise":150}],131:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.parseActionMap = parseActionMap;
exports.dereferenceArgsVariables = dereferenceArgsVariables;
exports.installActionServiceForDoc = installActionServiceForDoc;
exports.DeferredEvent = exports.ActionService = exports.ActionInvocation = exports.ActionEventDef = exports.ActionInfoDef = exports.TAPPABLE_ARIA_ROLES = void 0;

var _actionConstants = require("../action-constants");

var _keyCodes = require("../utils/key-codes");

var _services = require("../services");

var _rateLimit = require("../utils/rate-limit");

var _log = require("../log");

var _object = require("../utils/object");

var _eventHelper = require("../event-helper");

var _mode = require("../mode");

var _json = require("../json");

var _service = require("../service");

var _format = require("../format");

var _types = require("../types");

var _dom = require("../dom");

var _error = require("../error");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {string} */
var TAG_ = 'Action';

/** @const {string} */
var ACTION_MAP_ = '__AMP_ACTION_MAP__' + Math.random();

/** @const {string} */
var ACTION_QUEUE_ = '__AMP_ACTION_QUEUE__';

/** @const {string} */
var ACTION_HANDLER_ = '__AMP_ACTION_HANDLER__';

/** @const {number} */
var DEFAULT_DEBOUNCE_WAIT = 300;
// ms

/** @const {number} */
var DEFAULT_THROTTLE_INTERVAL = 100;
// ms

/** @const {!Object<string,!Array<string>>} */
var NON_AMP_ELEMENTS_ACTIONS_ = {
  'form': ['submit', 'clear']
};
var DEFAULT_EMAIL_ALLOWLIST = [{
  tagOrTarget: 'AMP',
  method: 'setState'
}, {
  tagOrTarget: '*',
  method: 'focus'
}, {
  tagOrTarget: '*',
  method: 'hide'
}, {
  tagOrTarget: '*',
  method: 'show'
}, {
  tagOrTarget: '*',
  method: 'toggleClass'
}, {
  tagOrTarget: '*',
  method: 'toggleVisibility'
}];

/**
 * Interactable widgets which should trigger tap events when the user clicks
 * or activates via the keyboard. Not all are here, e.g. progressbar, tabpanel,
 * since they are text inputs, readonly, or composite widgets that shouldn't
 * need to trigger tap events from spacebar or enter on their own.
 * See https://www.w3.org/TR/wai-aria-1.1/#widget_roles
 * @const {!Object<boolean>}
 */
var TAPPABLE_ARIA_ROLES = {
  'button': true,
  'checkbox': true,
  'link': true,
  'listbox': true,
  'menuitem': true,
  'menuitemcheckbox': true,
  'menuitemradio': true,
  'option': true,
  'radio': true,
  'scrollbar': true,
  'slider': true,
  'spinbutton': true,
  'switch': true,
  'tab': true,
  'treeitem': true
};
exports.TAPPABLE_ARIA_ROLES = TAPPABLE_ARIA_ROLES;

/**
 * An expression arg value, e.g. `foo.bar` in `e:t.m(arg=foo.bar)`.
 * @typedef {{expression: string}}
 */
var ActionInfoArgExpressionDef;

/**
 * An arg value.
 * @typedef {(boolean|number|string|ActionInfoArgExpressionDef)}
 */
var ActionInfoArgValueDef;

/**
 * Map of arg names to their values, e.g. {arg: 123} in `e:t.m(arg=123)`.
 * @typedef {Object<string, ActionInfoArgValueDef>}
 */
var ActionInfoArgsDef;

/**
 * @typedef {{
 *   event: string,
 *   target: string,
 *   method: string,
 *   args: ?ActionInfoArgsDef,
 *   str: string
 * }}
 */
var ActionInfoDef;
exports.ActionInfoDef = ActionInfoDef;

/**
 * Function called when an action is invoked.
 *
 * Optionally, takes this action's position within all actions triggered by
 * the same event, as well as said action array, as params.
 *
 * If the action is chainable, returns a Promise which resolves when the
 * action is complete. Otherwise, returns null.
 *
 * @typedef {function(!ActionInvocation, number=, !Array<!ActionInfoDef>=):?Promise}
 */
var ActionHandlerDef;

/**
 * @typedef {Event|DeferredEvent}
 */
var ActionEventDef;
exports.ActionEventDef = ActionEventDef;

/**
 * The structure that contains all details of the action method invocation.
 * @struct @const @package For type.
 */
var ActionInvocation = /*#__PURE__*/function () {
  /**
   * For example:
   *
   *   <div id="div" on="tap:myForm.submit(foo=bar)">
   *     <button id="btn">Submit</button>
   *   </div>
   *
   * `node` is #myForm.
   * `method` is "submit".
   * `args` is {'foo': 'bar'}.
   * `source` is #btn.
   * `caller` is #div.
   * `event` is a "click" Event object.
   * `actionEventType` is "tap".
   * `trust` depends on whether this action was a result of a user gesture.
   * `tagOrTarget` is "amp-form".
   * `sequenceId` is a pseudo-UUID.
   *
   * @param {!Node} node Element whose action is being invoked.
   * @param {string} method Name of the action being invoked.
   * @param {?JsonObject} args Named action arguments.
   * @param {?Element} source Element that generated the `event`.
   * @param {?Element} caller Element containing the on="..." action handler.
   * @param {?ActionEventDef} event The event object that triggered this action.
   * @param {!ActionTrust} trust The trust level of this invocation's trigger.
   * @param {?string} actionEventType The AMP event name that triggered this.
   * @param {?string} tagOrTarget The global target name or the element tagName.
   * @param {number} sequenceId An identifier for this action's sequence (all
   *   actions triggered by one event e.g. "tap:form1.submit, form2.submit").
   */
  function ActionInvocation(node, method, args, source, caller, event, trust, actionEventType, tagOrTarget, sequenceId) {
    if (actionEventType === void 0) {
      actionEventType = '?';
    }

    if (tagOrTarget === void 0) {
      tagOrTarget = null;
    }

    if (sequenceId === void 0) {
      sequenceId = Math.random();
    }

    _classCallCheck(this, ActionInvocation);

    /** @type {!Node} */
    this.node = node;

    /** @const {string} */
    this.method = method;

    /** @const {?JsonObject} */
    this.args = args;

    /** @const {?Element} */
    this.source = source;

    /** @const {?Element} */
    this.caller = caller;

    /** @const {?ActionEventDef} */
    this.event = event;

    /** @const {!ActionTrust} */
    this.trust = trust;

    /** @const {?string} */
    this.actionEventType = actionEventType;

    /** @const {string} */
    this.tagOrTarget = tagOrTarget || node.tagName;

    /** @const {number} */
    this.sequenceId = sequenceId;
  }

  /**
   * Returns true if the trigger event has a trust equal to or greater than
   * `minimumTrust`. Otherwise, logs a user error and returns false.
   * @param {ActionTrust} minimumTrust
   * @return {boolean}
   */
  _createClass(ActionInvocation, [{
    key: "satisfiesTrust",
    value: function satisfiesTrust(minimumTrust) {
      // Sanity check.
      if (!(0, _types.isFiniteNumber)(this.trust)) {
        (0, _log.dev)().error(TAG_, "Invalid trust for '" + this.method + "': " + this.trust);
        return false;
      }

      if (this.trust < minimumTrust) {
        var t = (0, _actionConstants.actionTrustToString)(this.trust);
        (0, _log.user)().error(TAG_, "\"" + this.actionEventType + "\" event with \"" + t + "\" trust is not allowed to " + ("invoke \"" + this.tagOrTarget.toLowerCase() + "." + this.method + "\"."));
        return false;
      }

      return true;
    }
  }]);

  return ActionInvocation;
}();

exports.ActionInvocation = ActionInvocation;

/**
 * TODO(dvoytenko): consider splitting this class into two:
 * 1. A class that has a method "trigger(element, eventType, data)" and
 *    simply can search target in DOM and trigger methods on it.
 * 2. A class that configures event recognizers and rules and then
 *    simply calls action.trigger.
 * @implements {../service.EmbeddableService}
 */
var ActionService = /*#__PURE__*/function () {
  /**
   * @param {!./ampdoc-impl.AmpDoc} ampdoc
   * @param {(!Document|!ShadowRoot)=} opt_root
   */
  function ActionService(ampdoc, opt_root) {
    _classCallCheck(this, ActionService);

    /** @const {!./ampdoc-impl.AmpDoc} */
    this.ampdoc = ampdoc;

    /** @const {!Document|!ShadowRoot} */
    this.root_ = opt_root || ampdoc.getRootNode();

    /** @const {boolean} */
    this.isEmail_ = this.ampdoc.isSingleDoc() && (0, _format.isAmp4Email)(
    /** @type {!Document} */
    this.root_);

    /**
     * Optional allowlist of actions, e.g.:
     *
     *     [{tagOrTarget: 'AMP', method: 'navigateTo'},
     *      {tagOrTarget: 'AMP-FORM', method: 'submit'},
     *      {tagOrTarget: '*', method: 'show'}]
     *
     * If not null, any actions that are not in the allowlist will be ignored
     * and throw a user error at invocation time. Note that `tagOrTarget` is
     * always the canonical uppercased form (same as
     * `Element.prototype.tagName`). If `tagOrTarget` is the wildcard '*', then
     * the allowlisted method is allowed on any tag or target.
     *
     * For AMP4Email format documents, allowed actions are autogenerated.
     * @private {?Array<{tagOrTarget: string, method: string}>}
     */
    this.allowlist_ = this.isEmail_ ? DEFAULT_EMAIL_ALLOWLIST : null;

    /** @const @private {!Object<string, ActionHandlerDef>} */
    this.globalTargets_ = (0, _object.map)();

    /**
     * @const @private {!Object<string, {handler: ActionHandlerDef, minTrust: ActionTrust}>}
     */
    this.globalMethodHandlers_ = (0, _object.map)();
    // Add core events.
    this.addEvent('tap');
    this.addEvent('submit');
    this.addEvent('change');
    this.addEvent('input-debounced');
    this.addEvent('input-throttled');
    this.addEvent('valid');
    this.addEvent('invalid');
  }

  /**
   * @param {!Window} embedWin
   * @param {!./ampdoc-impl.AmpDoc} ampdoc
   * @nocollapse
   */
  _createClass(ActionService, [{
    key: "addEvent",

    /**
     * @param {string} name
     * TODO(dvoytenko): switch to a system where the event recognizers are
     * registered with Action instead, e.g. "doubletap", "tap to zoom".
     */
    value: function addEvent(name) {
      var _this = this;

      if (name == 'tap') {
        // TODO(dvoytenko): if needed, also configure touch-based tap, e.g. for
        // fast-click.
        this.root_.addEventListener('click', function (event) {
          if (!event.defaultPrevented) {
            var element = (0, _log.dev)().assertElement(event.target);

            _this.trigger(element, name, event, _actionConstants.ActionTrust.HIGH);
          }
        });
        this.root_.addEventListener('keydown', function (event) {
          var key = event.key,
              target = event.target;
          var element = (0, _log.dev)().assertElement(target);

          if (key == _keyCodes.Keys.ENTER || key == _keyCodes.Keys.SPACE) {
            var role = element.getAttribute('role');
            var isTapEventRole = role && (0, _object.hasOwn)(TAPPABLE_ARIA_ROLES, role.toLowerCase());

            if (!event.defaultPrevented && isTapEventRole) {
              var hasAction = _this.trigger(element, name, event, _actionConstants.ActionTrust.HIGH);

              // Only if the element has an action do we prevent the default.
              // In the absence of an action, e.g. on="[event].method", we do not
              // want to stop default behavior.
              if (hasAction) {
                event.preventDefault();
              }
            }
          }
        });
      } else if (name == 'submit') {
        this.root_.addEventListener(name, function (event) {
          var element = (0, _log.dev)().assertElement(event.target);

          // For get requests, the delegating to the viewer needs to happen
          // before this.
          _this.trigger(element, name, event, _actionConstants.ActionTrust.HIGH);
        });
      } else if (name == 'change') {
        this.root_.addEventListener(name, function (event) {
          var element = (0, _log.dev)().assertElement(event.target);

          _this.addTargetPropertiesAsDetail_(event);

          _this.trigger(element, name, event, _actionConstants.ActionTrust.HIGH);
        });
      } else if (name == 'input-debounced') {
        var debouncedInput = (0, _rateLimit.debounce)(this.ampdoc.win, function (event) {
          var target = (0, _log.dev)().assertElement(event.target);

          _this.trigger(target, name,
          /** @type {!ActionEventDef} */
          event, _actionConstants.ActionTrust.HIGH);
        }, DEFAULT_DEBOUNCE_WAIT);
        this.root_.addEventListener('input', function (event) {
          // Create a DeferredEvent to avoid races where the browser cleans up
          // the event object before the async debounced function is called.
          var deferredEvent = new DeferredEvent(event);

          _this.addTargetPropertiesAsDetail_(deferredEvent);

          debouncedInput(deferredEvent);
        });
      } else if (name == 'input-throttled') {
        var throttledInput = (0, _rateLimit.throttle)(this.ampdoc.win, function (event) {
          var target = (0, _log.dev)().assertElement(event.target);

          _this.trigger(target, name,
          /** @type {!ActionEventDef} */
          event, _actionConstants.ActionTrust.HIGH);
        }, DEFAULT_THROTTLE_INTERVAL);
        this.root_.addEventListener('input', function (event) {
          var deferredEvent = new DeferredEvent(event);

          _this.addTargetPropertiesAsDetail_(deferredEvent);

          throttledInput(deferredEvent);
        });
      } else if (name == 'valid' || name == 'invalid') {
        this.root_.addEventListener(name, function (event) {
          var element = (0, _log.dev)().assertElement(event.target);

          _this.trigger(element, name, event, _actionConstants.ActionTrust.HIGH);
        });
      }
    }
    /**
     * Registers the action target that will receive all designated actions.
     * @param {string} name
     * @param {ActionHandlerDef} handler
     */

  }, {
    key: "addGlobalTarget",
    value: function addGlobalTarget(name, handler) {
      this.globalTargets_[name] = handler;
    }
    /**
     * Registers the action handler for a common method.
     * @param {string} name
     * @param {ActionHandlerDef} handler
     * @param {ActionTrust} minTrust
     */

  }, {
    key: "addGlobalMethodHandler",
    value: function addGlobalMethodHandler(name, handler, minTrust) {
      if (minTrust === void 0) {
        minTrust = _actionConstants.ActionTrust.DEFAULT;
      }

      this.globalMethodHandlers_[name] = {
        handler: handler,
        minTrust: minTrust
      };
    }
    /**
     * Triggers the specified event on the target element.
     * @param {!Element} target
     * @param {string} eventType
     * @param {?ActionEventDef} event
     * @param {!ActionTrust} trust
     * @param {?JsonObject=} opt_args
     * @return {boolean} true if the target has an action.
     */

  }, {
    key: "trigger",
    value: function trigger(target, eventType, event, trust, opt_args) {
      return this.action_(target, eventType, event, trust, opt_args);
    }
    /**
     * Triggers execution of the method on a target/method.
     * @param {!Element} target
     * @param {string} method
     * @param {?JsonObject} args
     * @param {?Element} source
     * @param {?Element} caller
     * @param {?ActionEventDef} event
     * @param {ActionTrust} trust
     */

  }, {
    key: "execute",
    value: function execute(target, method, args, source, caller, event, trust) {
      var invocation = new ActionInvocation(target, method, args, source, caller, event, trust);
      this.invoke_(invocation);
    }
    /**
     * Installs action handler for the specified element. The action handler is
     * responsible for checking invocation trust.
     *
     * For AMP elements, use base-element.registerAction() instead.
     *
     * @param {!Element} target
     * @param {ActionHandlerDef} handler
     */

  }, {
    key: "installActionHandler",
    value: function installActionHandler(target, handler) {
      // TODO(dvoytenko, #7063): switch back to `target.id` with form proxy.
      var targetId = target.getAttribute('id') || '';
      (0, _log.devAssert)(isAmpTagName(targetId) || target.tagName.toLowerCase() in NON_AMP_ELEMENTS_ACTIONS_, 'AMP or special element expected: %s', target.tagName + '#' + targetId);

      if (target[ACTION_HANDLER_]) {
        (0, _log.dev)().error(TAG_, "Action handler already installed for " + target);
        return;
      }

      target[ACTION_HANDLER_] = handler;

      /** @const {Array<!ActionInvocation>} */
      var queuedInvocations = target[ACTION_QUEUE_];

      if ((0, _types.isArray)(queuedInvocations)) {
        // Invoke and clear all queued invocations now handler is installed.
        _services.Services.timerFor((0, _types.toWin)(target.ownerDocument.defaultView)).delay(function () {
          // TODO(dvoytenko, #1260): dedupe actions.
          queuedInvocations.forEach(function (invocation) {
            try {
              handler(invocation);
            } catch (e) {
              (0, _log.dev)().error(TAG_, 'Action execution failed:', invocation, e);
            }
          });
          target[ACTION_QUEUE_].length = 0;
        }, 1);
      }
    }
    /**
     * Checks if the given element has registered a particular action type.
     * @param {!Element} element
     * @param {string} actionEventType
     * @param {!Element=} opt_stopAt
     * @return {boolean}
     */

  }, {
    key: "hasAction",
    value: function hasAction(element, actionEventType, opt_stopAt) {
      return !!this.findAction_(element, actionEventType, opt_stopAt);
    }
    /**
     * Checks if the given element's registered action resolves to at least one
     * existing element by id or a global target (e.g. "AMP").
     * @param {!Element} element
     * @param {string} actionEventType
     * @param {!Element=} opt_stopAt
     * @return {boolean}
     */

  }, {
    key: "hasResolvableAction",
    value: function hasResolvableAction(element, actionEventType, opt_stopAt) {
      var _this2 = this;

      var action = this.findAction_(element, actionEventType, opt_stopAt);

      if (!action) {
        return false;
      }

      return action.actionInfos.some(function (action) {
        var target = action.target;
        return !!_this2.getActionNode_(target);
      });
    }
    /**
     * Checks if the given element's registered action resolves to at least one
     * existing element by id or a global target (e.g. "AMP").
     * @param {!Element} element
     * @param {string} actionEventType
     * @param {!Element} targetElement
     * @param {!Element=} opt_stopAt
     * @return {boolean}
     */

  }, {
    key: "hasResolvableActionForTarget",
    value: function hasResolvableActionForTarget(element, actionEventType, targetElement, opt_stopAt) {
      var _this3 = this;

      var action = this.findAction_(element, actionEventType, opt_stopAt);

      if (!action) {
        return false;
      }

      return action.actionInfos.some(function (actionInfo) {
        var target = actionInfo.target;
        return _this3.getActionNode_(target) == targetElement;
      });
    }
    /**
     * For global targets e.g. "AMP", returns the document root. Otherwise,
     * `target` is an element id and the corresponding element is returned.
     * @param {string} target
     * @return {?Document|?Element|?ShadowRoot}
     * @private
     */

  }, {
    key: "getActionNode_",
    value: function getActionNode_(target) {
      return this.globalTargets_[target] ? this.root_ : this.root_.getElementById(target);
    }
    /**
     * Sets the action allowlist. Can be used to clear it.
     * @param {!Array<{tagOrTarget: string, method: string}>} allowlist
     */

  }, {
    key: "setAllowlist",
    value: function setAllowlist(allowlist) {
      (0, _log.devAssert)(allowlist.every(function (v) {
        return v.tagOrTarget && v.method;
      }), 'Action allowlist entries should be of shape { tagOrTarget: string, method: string }');
      this.allowlist_ = allowlist;
    }
    /**
     * Adds an action to the allowlist.
     * @param {string} tagOrTarget The tag or target to allowlist, e.g.
     *     'AMP-LIST', '*'.
     * @param {string|Array<string>} methods The method(s) to allowlist, e.g. 'show', 'hide'.
     * @param {Array<string>=} opt_forFormat
     */

  }, {
    key: "addToAllowlist",
    value: function addToAllowlist(tagOrTarget, methods, opt_forFormat) {
      var _this4 = this;

      // TODO(wg-runtime): When it becomes possible to getFormat(),
      // we can store `format_` instead of `isEmail_` and check
      // (opt_forFormat && !opt_forFormat.includes(this.format_))
      if (opt_forFormat && opt_forFormat.includes('email') !== this.isEmail_) {
        return;
      }

      if (!this.allowlist_) {
        this.allowlist_ = [];
      }

      if (!(0, _types.isArray)(methods)) {
        methods = [methods];
      }

      methods.forEach(function (method) {
        if (_this4.allowlist_.some(function (v) {
          return v.tagOrTarget == tagOrTarget && v.method == method;
        })) {
          return;
        }

        _this4.allowlist_.push({
          tagOrTarget: tagOrTarget,
          method: method
        });
      });
    }
    /**
     * @param {!Element} source
     * @param {string} actionEventType
     * @param {?ActionEventDef} event
     * @param {!ActionTrust} trust
     * @param {?JsonObject=} opt_args
     * @return {boolean} True if the element has an action.
     * @private
     */

  }, {
    key: "action_",
    value: function action_(source, actionEventType, event, trust, opt_args) {
      var _this5 = this;

      var action = this.findAction_(source, actionEventType);

      if (!action) {
        return false;
      }

      // Use a pseudo-UUID to uniquely identify this sequence of actions.
      // A sequence is all actions triggered by a single event.
      var sequenceId = Math.random();
      // Invoke actions serially, where each action waits for its predecessor
      // to complete. `currentPromise` is the i'th promise in the chain.

      /** @type {?Promise} */
      var currentPromise = null;
      action.actionInfos.forEach(function (actionInfo) {
        var target = actionInfo.target,
            args = actionInfo.args,
            method = actionInfo.method,
            str = actionInfo.str;
        var dereferencedArgs = dereferenceArgsVariables(args, event, opt_args);

        var invokeAction = function invokeAction() {
          var node = _this5.getActionNode_(target);

          if (!node) {
            _this5.error_("Target \"" + target + "\" not found for action [" + str + "].");

            return;
          }

          var invocation = new ActionInvocation(node, method, dereferencedArgs, source, action.node, event, trust, actionEventType, node.tagName || target, sequenceId);
          return _this5.invoke_(invocation);
        };

        // Wait for the previous action, if any.
        currentPromise = currentPromise ? currentPromise.then(invokeAction) : invokeAction();
      });
      return action.actionInfos.length >= 1;
    }
    /**
     * @param {string} message
     * @param {?Element=} opt_element
     * @private
     */

  }, {
    key: "error_",
    value: function error_(message, opt_element) {
      if (opt_element) {
        // reportError() supports displaying the element in dev console.
        var e = (0, _log.user)().createError("[" + TAG_ + "] " + message);
        (0, _error.reportError)(e, opt_element);
        throw e;
      } else {
        (0, _log.user)().error(TAG_, message);
      }
    }
    /**
     * @param {!ActionInvocation} invocation
     * @return {?Promise}
     * @private
     */

  }, {
    key: "invoke_",
    value: function invoke_(invocation) {
      var method = invocation.method,
          tagOrTarget = invocation.tagOrTarget;

      // Check that this action is allowlisted (if a allowlist is set).
      if (this.allowlist_) {
        if (!isActionAllowlisted(invocation, this.allowlist_)) {
          this.error_("\"" + tagOrTarget + "." + method + "\" is not allowlisted " + JSON.stringify(this.allowlist_) + ".");
          return null;
        }
      }

      // Handle global targets e.g. "AMP".
      var globalTarget = this.globalTargets_[tagOrTarget];

      if (globalTarget) {
        return globalTarget(invocation);
      }

      // Subsequent handlers assume that invocation target is an Element.
      var node = (0, _log.dev)().assertElement(invocation.node);
      // Handle global actions e.g. "<any-element-id>.toggle".
      var globalMethod = this.globalMethodHandlers_[method];

      if (globalMethod && invocation.satisfiesTrust(globalMethod.minTrust)) {
        return globalMethod.handler(invocation);
      }

      // Handle element-specific actions.
      var lowerTagName = node.tagName.toLowerCase();

      if (isAmpTagName(lowerTagName)) {
        if (node.enqueAction) {
          node.enqueAction(invocation);
        } else {
          this.error_("Unrecognized AMP element \"" + lowerTagName + "\".", node);
        }

        return null;
      }

      // Special non-AMP elements with AMP ID or known supported actions.
      var nonAmpActions = NON_AMP_ELEMENTS_ACTIONS_[lowerTagName];
      // TODO(dvoytenko, #7063): switch back to `target.id` with form proxy.
      var targetId = node.getAttribute('id') || '';

      if (isAmpTagName(targetId) || nonAmpActions && nonAmpActions.indexOf(method) > -1) {
        var handler = node[ACTION_HANDLER_];

        if (handler) {
          handler(invocation);
        } else {
          node[ACTION_QUEUE_] = node[ACTION_QUEUE_] || [];
          node[ACTION_QUEUE_].push(invocation);
        }

        return null;
      }

      // Unsupported method.
      this.error_("Target (" + tagOrTarget + ") doesn't support \"" + method + "\" action.", invocation.caller);
      return null;
    }
    /**
     * @param {!Element} target
     * @param {string} actionEventType
     * @param {!Element=} opt_stopAt
     * @return {?{node: !Element, actionInfos: !Array<!ActionInfoDef>}}
     */

  }, {
    key: "findAction_",
    value: function findAction_(target, actionEventType, opt_stopAt) {
      // Go from target up the DOM tree and find the applicable action.
      var n = target;

      while (n) {
        if (opt_stopAt && n == opt_stopAt) {
          return null;
        }

        var actionInfos = this.matchActionInfos_(n, actionEventType);

        if (actionInfos && (0, _dom.isEnabled)(n)) {
          return {
            node: n,
            actionInfos: (0, _log.devAssert)(actionInfos)
          };
        }

        n = n.parentElement;
      }

      return null;
    }
    /**
     * @param {!Element} node
     * @param {string} actionEventType
     * @return {?Array<!ActionInfoDef>}
     */

  }, {
    key: "matchActionInfos_",
    value: function matchActionInfos_(node, actionEventType) {
      var actionMap = this.getActionMap_(node, actionEventType);

      if (!actionMap) {
        return null;
      }

      return actionMap[actionEventType] || null;
    }
    /**
     * @param {!Element} node
     * @param {string} actionEventType
     * @return {?Object<string, !Array<!ActionInfoDef>>}
     */

  }, {
    key: "getActionMap_",
    value: function getActionMap_(node, actionEventType) {
      var actionMap = node[ACTION_MAP_];

      if (actionMap === undefined) {
        actionMap = null;

        if (node.hasAttribute('on')) {
          var action = node.getAttribute('on');
          actionMap = parseActionMap(action, node);
          node[ACTION_MAP_] = actionMap;
        } else if (node.hasAttribute('execute')) {
          var _action = node.getAttribute('execute');

          actionMap = parseActionMap(actionEventType + ":" + _action, node);
          node[ACTION_MAP_] = actionMap;
        }
      }

      return actionMap;
    }
    /**
     * Resets a node's actions with those defined in the given actions string.
     * @param {!Element} node
     * @param {string} actionsStr
     */

  }, {
    key: "setActions",
    value: function setActions(node, actionsStr) {
      node.setAttribute('on', actionsStr);
      // Clear cache.
      delete node[ACTION_MAP_];
    }
    /**
     * Given a browser 'change' or 'input' event, add `detail` property to it
     * containing allowlisted properties of the target element. Noop if `detail`
     * is readonly.
     * @param {!ActionEventDef} event
     * @private
     */

  }, {
    key: "addTargetPropertiesAsDetail_",
    value: function addTargetPropertiesAsDetail_(event) {
      var detail =
      /** @type {!JsonObject} */
      (0, _object.map)();
      var target = event.target;

      if (target.value !== undefined) {
        detail['value'] = target.value;
      }

      // Check tagName instead since `valueAsNumber` isn't supported on IE.
      if (target.tagName == 'INPUT') {
        // Probably supported natively but convert anyways for consistency.
        detail['valueAsNumber'] = Number(target.value);
      }

      if (target.checked !== undefined) {
        detail['checked'] = target.checked;
      }

      if (target.min !== undefined || target.max !== undefined) {
        detail['min'] = target.min;
        detail['max'] = target.max;
      }

      if (target.files) {
        detail['files'] = (0, _types.toArray)(target.files).map(function (file) {
          return {
            'name': file.name,
            'size': file.size,
            'type': file.type
          };
        });
      }

      if (Object.keys(detail).length > 0) {
        try {
          event.detail = detail;
        } catch (_unused) {}
      }
    }
  }], [{
    key: "installInEmbedWindow",
    value: function installInEmbedWindow(embedWin, ampdoc) {
      (0, _service.installServiceInEmbedScope)(embedWin, 'action', new ActionService(ampdoc, embedWin.document));
    }
  }]);

  return ActionService;
}();

exports.ActionService = ActionService;

/**
 * @param {string} lowercaseTagName
 * @return {boolean}
 * @private
 */
function isAmpTagName(lowercaseTagName) {
  return lowercaseTagName.substring(0, 4) === 'amp-';
}

/**
 * Returns `true` if the given action invocation is allowlisted in the given
 * allowlist. Default actions' alias, 'activate', are automatically
 * allowlisted if their corresponding registered alias is allowlisted.
 * @param {!ActionInvocation} invocation
 * @param {!Array<{tagOrTarget: string, method: string}>} allowlist
 * @return {boolean}
 * @private
 */
function isActionAllowlisted(invocation, allowlist) {
  var method = invocation.method;
  var node = invocation.node,
      tagOrTarget = invocation.tagOrTarget;

  // Use alias if default action is invoked.
  if (method === _actionConstants.DEFAULT_ACTION && typeof node.getDefaultActionAlias == 'function') {
    method = node.getDefaultActionAlias();
  }

  var lcMethod = method.toLowerCase();
  var lcTagOrTarget = tagOrTarget.toLowerCase();
  return allowlist.some(function (w) {
    if (w.tagOrTarget.toLowerCase() === lcTagOrTarget || w.tagOrTarget === '*') {
      if (w.method.toLowerCase() === lcMethod) {
        return true;
      }
    }

    return false;
  });
}

/**
 * A clone of an event object with its function properties replaced.
 * This is useful e.g. for event objects that need to be passed to an async
 * context, but the browser might have cleaned up the original event object.
 * This clone replaces functions with error throws since they won't behave
 * normally after the original object has been destroyed.
 * @private visible for testing
 */
var DeferredEvent =
/**
 * @param {!Event} event
 */
function DeferredEvent(event) {
  _classCallCheck(this, DeferredEvent);

  /** @type {?Object} */
  this.detail = null;
  cloneWithoutFunctions(event, this);
};

exports.DeferredEvent = DeferredEvent;

/**
 * Clones an object and replaces its function properties with throws.
 * @param {!T} original
 * @param {!T=} opt_dest
 * @return {!T}
 * @template T
 * @private
 */
function cloneWithoutFunctions(original, opt_dest) {
  var clone = opt_dest || (0, _object.map)();

  for (var prop in original) {
    var value = original[prop];

    if (typeof value === 'function') {
      clone[prop] = notImplemented;
    } else {
      clone[prop] = original[prop];
    }
  }

  return clone;
}

/** @private */
function notImplemented() {
  (0, _log.devAssert)(null, 'Deferred events cannot access native event functions.');
}

/**
 * @param {string} action
 * @param {!Element} context
 * @return {?Object<string, !Array<!ActionInfoDef>>}
 * @private Visible for testing only.
 */
function parseActionMap(action, context) {
  var assertAction = assertActionForParser.bind(null, action, context);
  var assertToken = assertTokenForParser.bind(null, action, context);
  var actionMap = null;
  var toks = new ParserTokenizer(action);
  var tok;
  var peek;

  do {
    tok = toks.next();

    if (tok.type == TokenType.EOF || tok.type == TokenType.SEPARATOR && tok.value == ';') {// Expected, ignore.
    } else if (tok.type == TokenType.LITERAL || tok.type == TokenType.ID) {
      // Format: event:target.method
      // Event: "event:"
      var event = tok.value;
      // Target: ":target." separator
      assertToken(toks.next(), [TokenType.SEPARATOR], ':');
      var actions = [];

      // Handlers for event.
      do {
        var target = assertToken(toks.next(), [TokenType.LITERAL, TokenType.ID]).value;
        // Method: ".method". Method is optional.
        var method = _actionConstants.DEFAULT_ACTION;
        var args = null;
        peek = toks.peek();

        if (peek.type == TokenType.SEPARATOR && peek.value == '.') {
          toks.next();
          // Skip '.'
          method = assertToken(toks.next(), [TokenType.LITERAL, TokenType.ID]).value || method;
          // Optionally, there may be arguments: "(key = value, key = value)".
          peek = toks.peek();

          if (peek.type == TokenType.SEPARATOR && peek.value == '(') {
            toks.next();
            // Skip '('
            args = tokenizeMethodArguments(toks, assertToken, assertAction);
          }
        }

        actions.push({
          event: event,
          target: target,
          method: method,
          args: args && (0, _mode.getMode)().test && Object.freeze ? Object.freeze(args) : args,
          str: action
        });
        peek = toks.peek();
      } while (peek.type == TokenType.SEPARATOR && peek.value == ',' && toks.next());

      // skip "," when found
      if (!actionMap) {
        actionMap = (0, _object.map)();
      }

      actionMap[event] = actions;
    } else {
      // Unexpected token.
      assertAction(false, "; unexpected token [" + (tok.value || '') + "]");
    }
  } while (tok.type != TokenType.EOF);

  return actionMap;
}

/**
 * Tokenizes and returns method arguments, e.g. target.method(arguments).
 * @param {!ParserTokenizer} toks
 * @param {!Function} assertToken
 * @param {!Function} assertAction
 * @return {?ActionInfoArgsDef}
 * @private
 */
function tokenizeMethodArguments(toks, assertToken, assertAction) {
  var peek = toks.peek();
  var tok;
  var args = null;

  // Object literal. Format: {...}
  if (peek.type == TokenType.OBJECT) {
    // Don't parse object literals. Tokenize as a single expression
    // fragment and delegate to specific action handler.
    args = (0, _object.map)();

    var _toks$next = toks.next(),
        value = _toks$next.value;

    args[_actionConstants.RAW_OBJECT_ARGS_KEY] = value;
    assertToken(toks.next(), [TokenType.SEPARATOR], ')');
  } else {
    // Key-value pairs. Format: key = value, ....
    do {
      tok = toks.next();
      var _tok = tok,
          type = _tok.type,
          _value = _tok.value;

      if (type == TokenType.SEPARATOR && (_value == ',' || _value == ')')) {// Expected: ignore.
      } else if (type == TokenType.LITERAL || type == TokenType.ID) {
        // Key: "key = "
        assertToken(toks.next(), [TokenType.SEPARATOR], '=');
        // Value is either a literal or an expression: "foo.bar.baz"
        tok = assertToken(toks.next(
        /* convertValue */
        true), [TokenType.LITERAL, TokenType.ID]);
        var argValueTokens = [tok];

        // Expressions have one or more dereferences: ".identifier"
        if (tok.type == TokenType.ID) {
          for (peek = toks.peek(); peek.type == TokenType.SEPARATOR && peek.value == '.'; peek = toks.peek()) {
            toks.next();
            // Skip '.'.
            tok = assertToken(toks.next(false), [TokenType.ID]);
            argValueTokens.push(tok);
          }
        }

        var argValue = argValueForTokens(argValueTokens);

        if (!args) {
          args = (0, _object.map)();
        }

        args[_value] = argValue;
        peek = toks.peek();
        assertAction(peek.type == TokenType.SEPARATOR && (peek.value == ',' || peek.value == ')'), 'Expected either [,] or [)]');
      } else {
        // Unexpected token.
        assertAction(false, "; unexpected token [" + (tok.value || '') + "]");
      }
    } while (!(tok.type == TokenType.SEPARATOR && tok.value == ')'));
  }

  return args;
}

/**
 * @param {Array<!TokenDef>} tokens
 * @return {?ActionInfoArgValueDef}
 * @private
 */
function argValueForTokens(tokens) {
  if (tokens.length == 0) {
    return null;
  } else if (tokens.length == 1) {
    return (
      /** @type {(boolean|number|string)} */
      tokens[0].value
    );
  } else {
    var values = tokens.map(function (token) {
      return token.value;
    });
    var expression = values.join('.');
    return (
      /** @type {ActionInfoArgExpressionDef} */
      {
        expression: expression
      }
    );
  }
}

/**
 * Dereferences expression args in `args` using values in data.
 * @param {?ActionInfoArgsDef} args
 * @param {?ActionEventDef} event
 * @param {?JsonObject=} opt_args
 * @return {?JsonObject}
 * @private
 */
function dereferenceArgsVariables(args, event, opt_args) {
  if (!args) {
    return args;
  }

  var data = opt_args || (0, _object.dict)({});

  if (event) {
    var detail = (0, _eventHelper.getDetail)(
    /** @type {!Event} */
    event);

    if (detail) {
      data['event'] = detail;
    }
  }

  var applied = (0, _object.map)();
  Object.keys(args).forEach(function (key) {
    var value = args[key];

    // Only JSON expression strings that contain dereferences (e.g. `foo.bar`)
    // are processed as ActionInfoArgExpressionDef. We also support
    // dereferencing strings like `foo` iff there is a corresponding key in
    // `data`. Otherwise, `foo` is treated as a string "foo".
    if (typeof value == 'object' && value.expression) {
      var expr =
      /** @type {ActionInfoArgExpressionDef} */
      value.expression;
      var exprValue = (0, _json.getValueForExpr)(data, expr);
      // If expr can't be found in data, use null instead of undefined.
      value = exprValue === undefined ? null : exprValue;
    }

    if (data[value]) {
      applied[key] = data[value];
    } else {
      applied[key] = value;
    }
  });
  return applied;
}

/**
 * @param {string} s
 * @param {!Element} context
 * @param {?T} condition
 * @param {string=} opt_message
 * @return {T}
 * @template T
 * @private
 */
function assertActionForParser(s, context, condition, opt_message) {
  return (0, _log.userAssert)(condition, 'Invalid action definition in %s: [%s] %s', context, s, opt_message || '');
}

/**
 * @param {string} s
 * @param {!Element} context
 * @param {!TokenDef} tok
 * @param {Array<TokenType>} types
 * @param {*=} opt_value
 * @return {!TokenDef}
 * @private
 */
function assertTokenForParser(s, context, tok, types, opt_value) {
  if (opt_value !== undefined) {
    assertActionForParser(s, context, types.includes(tok.type) && tok.value == opt_value, "; expected [" + opt_value + "]");
  } else {
    assertActionForParser(s, context, types.includes(tok.type));
  }

  return tok;
}

/**
 * @enum {number}
 */
var TokenType = {
  INVALID: 0,
  EOF: 1,
  SEPARATOR: 2,
  LITERAL: 3,
  ID: 4,
  OBJECT: 5
};

/**
 * @typedef {{type: TokenType, value: *}}
 */
var TokenDef;

/** @private @const {string} */
var WHITESPACE_SET = " \t\n\r\f\x0B\xA0\u2028\u2029";

/** @private @const {string} */
var SEPARATOR_SET = ';:.()=,|!';

/** @private @const {string} */
var STRING_SET = '"\'';

/** @private @const {string} */
var OBJECT_SET = '{}';

/** @private @const {string} */
var SPECIAL_SET = WHITESPACE_SET + SEPARATOR_SET + STRING_SET + OBJECT_SET;

/** @private */
var ParserTokenizer = /*#__PURE__*/function () {
  /**
   * @param {string} str
   */
  function ParserTokenizer(str) {
    _classCallCheck(this, ParserTokenizer);

    /** @private @const {string} */
    this.str_ = str;

    /** @private {number} */
    this.index_ = -1;
  }

  /**
   * Returns the next token and advances the position.
   * @param {boolean=} opt_convertValues
   * @return {!TokenDef}
   */
  _createClass(ParserTokenizer, [{
    key: "next",
    value: function next(opt_convertValues) {
      var tok = this.next_(opt_convertValues || false);
      this.index_ = tok.index;
      return tok;
    }
    /**
     * Returns the next token but keeps the current position.
     * @param {boolean=} opt_convertValues
     * @return {!TokenDef}
     */

  }, {
    key: "peek",
    value: function peek(opt_convertValues) {
      return this.next_(opt_convertValues || false);
    }
    /**
     * @param {boolean} convertValues
     * @return {!{type: TokenType, value: *, index: number}}
     */

  }, {
    key: "next_",
    value: function next_(convertValues) {
      var newIndex = this.index_ + 1;

      if (newIndex >= this.str_.length) {
        return {
          type: TokenType.EOF,
          index: this.index_
        };
      }

      var c = this.str_.charAt(newIndex);

      // Whitespace: standard set.
      if (WHITESPACE_SET.indexOf(c) != -1) {
        newIndex++;

        for (; newIndex < this.str_.length; newIndex++) {
          if (WHITESPACE_SET.indexOf(this.str_.charAt(newIndex)) == -1) {
            break;
          }
        }

        if (newIndex >= this.str_.length) {
          return {
            type: TokenType.EOF,
            index: newIndex
          };
        }

        c = this.str_.charAt(newIndex);
      }

      // A numeric. Notice that it steals the `.` from separators.
      if (convertValues && (isNum(c) || c == '.' && newIndex + 1 < this.str_.length && isNum(this.str_[newIndex + 1]))) {
        var hasFraction = c == '.';

        var _end = newIndex + 1;

        for (; _end < this.str_.length; _end++) {
          var c2 = this.str_.charAt(_end);

          if (c2 == '.') {
            hasFraction = true;
            continue;
          }

          if (!isNum(c2)) {
            break;
          }
        }

        var _s = this.str_.substring(newIndex, _end);

        var value = hasFraction ? parseFloat(_s) : parseInt(_s, 10);
        newIndex = _end - 1;
        return {
          type: TokenType.LITERAL,
          value: value,
          index: newIndex
        };
      }

      // Different separators.
      if (SEPARATOR_SET.indexOf(c) != -1) {
        return {
          type: TokenType.SEPARATOR,
          value: c,
          index: newIndex
        };
      }

      // String literal.
      if (STRING_SET.indexOf(c) != -1) {
        var _end2 = -1;

        for (var i = newIndex + 1; i < this.str_.length; i++) {
          if (this.str_.charAt(i) == c) {
            _end2 = i;
            break;
          }
        }

        if (_end2 == -1) {
          return {
            type: TokenType.INVALID,
            index: newIndex
          };
        }

        var _value2 = this.str_.substring(newIndex + 1, _end2);

        newIndex = _end2;
        return {
          type: TokenType.LITERAL,
          value: _value2,
          index: newIndex
        };
      }

      // Object literal.
      if (c == '{') {
        var numberOfBraces = 1;

        var _end3 = -1;

        for (var _i = newIndex + 1; _i < this.str_.length; _i++) {
          var char = this.str_[_i];

          if (char == '{') {
            numberOfBraces++;
          } else if (char == '}') {
            numberOfBraces--;
          }

          if (numberOfBraces <= 0) {
            _end3 = _i;
            break;
          }
        }

        if (_end3 == -1) {
          return {
            type: TokenType.INVALID,
            index: newIndex
          };
        }

        var _value3 = this.str_.substring(newIndex, _end3 + 1);

        newIndex = _end3;
        return {
          type: TokenType.OBJECT,
          value: _value3,
          index: newIndex
        };
      }

      // Advance until next special character.
      var end = newIndex + 1;

      for (; end < this.str_.length; end++) {
        if (SPECIAL_SET.indexOf(this.str_.charAt(end)) != -1) {
          break;
        }
      }

      var s = this.str_.substring(newIndex, end);
      newIndex = end - 1;

      // Boolean literal.
      if (convertValues && (s == 'true' || s == 'false')) {
        var _value4 = s == 'true';

        return {
          type: TokenType.LITERAL,
          value: _value4,
          index: newIndex
        };
      }

      // Identifier.
      if (!isNum(s.charAt(0))) {
        return {
          type: TokenType.ID,
          value: s,
          index: newIndex
        };
      }

      // Key.
      return {
        type: TokenType.LITERAL,
        value: s,
        index: newIndex
      };
    }
  }]);

  return ParserTokenizer;
}();

/**
 * Tests whether a chacter is a number.
 * @param {string} c
 * @return {boolean}
 */
function isNum(c) {
  return c >= '0' && c <= '9';
}

/**
 * @param {!./ampdoc-impl.AmpDoc} ampdoc
 */
function installActionServiceForDoc(ampdoc) {
  (0, _service.registerServiceBuilderForDoc)(ampdoc, 'action', ActionService,
  /* opt_instantiate */
  true);
}

},{"../action-constants":96,"../dom":106,"../error":109,"../event-helper":111,"../format":114,"../json":120,"../log":123,"../mode":124,"../service":130,"../services":133,"../types":139,"../utils/key-codes":147,"../utils/object":149,"../utils/rate-limit":151}],132:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getLanguageCodesFromString = getLanguageCodesFromString;
exports.LocalizationService = void 0;

var _localizedStrings = require("../localized-strings");

var _services = require("../services");

var _dom = require("../dom");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Language code used if there is no language code specified by the document.
 * @const {string}
 */
var FALLBACK_LANGUAGE_CODE = 'default';

/**
 * @const {!RegExp}
 */
var LANGUAGE_CODE_CHUNK_REGEX = /\w+/gi;

/**
 * Gets the string matching the specified localized string ID in the language
 * specified.
 * @param {!Object<string, !../localized-strings.LocalizedStringBundleDef>} localizedStringBundles
 * @param {!Array<string>} languageCodes
 * @param {!LocalizedStringId} localizedStringId
 * @return {string|null}
 */
function findLocalizedString(localizedStringBundles, languageCodes, localizedStringId) {
  var localizedString = null;
  languageCodes.some(function (languageCode) {
    var localizedStringBundle = localizedStringBundles[languageCode];

    if (localizedStringBundle && localizedStringBundle[localizedStringId]) {
      localizedString = localizedStringBundle[localizedStringId].string || localizedStringBundle[localizedStringId].fallback;
      return !!localizedString;
    }

    return false;
  });
  return localizedString;
}

/**
 * @param {string} languageCode
 * @return {!Array<string>} A list of language codes.
 * @visibleForTesting
 */
function getLanguageCodesFromString(languageCode) {
  if (!languageCode) {
    return ['en', FALLBACK_LANGUAGE_CODE];
  }

  var matches = languageCode.match(LANGUAGE_CODE_CHUNK_REGEX) || [];
  return matches.reduce(function (fallbackLanguageCodeList, chunk, index) {
    var fallbackLanguageCode = matches.slice(0, index + 1).join('-').toLowerCase();
    fallbackLanguageCodeList.unshift(fallbackLanguageCode);
    return fallbackLanguageCodeList;
  }, [FALLBACK_LANGUAGE_CODE]);
}

/**
 * Localization service.
 */
var LocalizationService = /*#__PURE__*/function () {
  /**
   * @param {!Element} element
   */
  function LocalizationService(element) {
    _classCallCheck(this, LocalizationService);

    this.element_ = element;

    /**
     * @private @const {?string}
     */
    this.viewerLanguageCode_ = _services.Services.viewerForDoc(element).getParam('lang');

    /**
     * A mapping of language code to localized string bundle.
     * @private @const {!Object<string, !../localized-strings.LocalizedStringBundleDef>}
     */
    this.localizedStringBundles_ = {};
  }

  /**
   * @param {!Element} element
   * @return {!Array<string>}
   * @private
   */
  _createClass(LocalizationService, [{
    key: "getLanguageCodesForElement_",
    value: function getLanguageCodesForElement_(element) {
      var languageEl = (0, _dom.closest)(element, function (el) {
        return el.hasAttribute('lang');
      });
      var languageCode = languageEl ? languageEl.getAttribute('lang') : null;
      var languageCodesToUse = getLanguageCodesFromString(languageCode || '');

      if (this.viewerLanguageCode_) {
        languageCodesToUse.unshift(this.viewerLanguageCode_);
      }

      return languageCodesToUse;
    }
    /**
     * @param {string} languageCode The language code to associate with the
     *     specified localized string bundle.
     * @param {!../localized-strings.LocalizedStringBundleDef} localizedStringBundle
     *     The localized string bundle to register.
     * @return {!LocalizationService} For chaining.
     */

  }, {
    key: "registerLocalizedStringBundle",
    value: function registerLocalizedStringBundle(languageCode, localizedStringBundle) {
      var normalizedLangCode = languageCode.toLowerCase();

      if (!this.localizedStringBundles_[normalizedLangCode]) {
        this.localizedStringBundles_[normalizedLangCode] = {};
      }

      Object.assign(this.localizedStringBundles_[normalizedLangCode], localizedStringBundle);
      return this;
    }
    /**
     * @param {!LocalizedStringId} localizedStringId
     * @param {!Element=} elementToUse The element where the string will be
     *     used.  The language is based on the language at that part of the
     *     document.  If unspecified, will use the document-level language, if
     *     one exists, or the default otherwise.
     * @return {string|null}
     */

  }, {
    key: "getLocalizedString",
    value: function getLocalizedString(localizedStringId, elementToUse) {
      if (elementToUse === void 0) {
        elementToUse = this.element_;
      }

      var languageCodes = this.getLanguageCodesForElement_(elementToUse);
      return findLocalizedString(this.localizedStringBundles_, languageCodes, localizedStringId);
    }
  }]);

  return LocalizationService;
}();

exports.LocalizationService = LocalizationService;

},{"../dom":106,"../localized-strings":122,"../services":133}],133:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Services = exports.SubscriptionService = void 0;

var _service = require("./service");

var _elementService = require("./element-service");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @typedef {!../extensions/amp-subscriptions/0.1/amp-subscriptions.SubscriptionService} */
var SubscriptionService;
exports.SubscriptionService = SubscriptionService;

var Services = /*#__PURE__*/function () {
  function Services() {
    _classCallCheck(this, Services);
  }

  _createClass(Services, null, [{
    key: "accessServiceForDoc",

    /**
     * Hint: Add extensions folder path to compile.js with
     * warnings cannot find modules.
     */

    /**
     * Returns a promise for the Access service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-access/0.1/amp-access.AccessService>}
     */
    value: function accessServiceForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-access/0.1/amp-access.AccessService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'access', 'amp-access')
      );
    }
    /**
     * Returns a promise for the Access service or a promise for null if the
     * service is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-access/0.1/amp-access.AccessService>}
     */

  }, {
    key: "accessServiceForDocOrNull",
    value: function accessServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-access/0.1/amp-access.AccessService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'access', 'amp-access')
      );
    }
    /**
     * Returns a promise for the Subscriptions service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!SubscriptionService>}
     */

  }, {
    key: "subscriptionsServiceForDoc",
    value: function subscriptionsServiceForDoc(element) {
      return (
        /** @type {!Promise<!SubscriptionService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'subscriptions', 'amp-subscriptions')
      );
    }
    /**
     * Returns a promise for the Subscriptions service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?SubscriptionService>}
     */

  }, {
    key: "subscriptionsServiceForDocOrNull",
    value: function subscriptionsServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?SubscriptionService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'subscriptions', 'amp-subscriptions')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/action-impl.ActionService}
     */

  }, {
    key: "actionServiceForDoc",
    value: function actionServiceForDoc(element) {
      return (
        /** @type {!./service/action-impl.ActionService} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'action')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/standard-actions-impl.StandardActions}
     */

  }, {
    key: "standardActionsForDoc",
    value: function standardActionsForDoc(element) {
      return (
        /** @type {!./service/standard-actions-impl.StandardActions} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'standard-actions')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-analytics/0.1/activity-impl.Activity>}
     */

  }, {
    key: "activityForDoc",
    value: function activityForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-analytics/0.1/activity-impl.Activity>} */
        (0, _elementService.getElementServiceForDoc)(element, 'activity', 'amp-analytics')
      );
    }
    /**
     * Returns the global instance of the `AmpDocService` service that can be
     * used to resolve an ampdoc for any node: either in the single-doc or
     * shadow-doc environment.
     * @param {!Window} window
     * @return {!./service/ampdoc-impl.AmpDocService}
     */

  }, {
    key: "ampdocServiceFor",
    value: function ampdocServiceFor(window) {
      return (
        /** @type {!./service/ampdoc-impl.AmpDocService} */
        (0, _service.getService)(window, 'ampdoc')
      );
    }
    /**
     * Returns the AmpDoc for the specified context node.
     * @param {!Node|!./service/ampdoc-impl.AmpDoc} nodeOrAmpDoc
     * @return {!./service/ampdoc-impl.AmpDoc}
     */

  }, {
    key: "ampdoc",
    value: function ampdoc(nodeOrAmpDoc) {
      return (0, _service.getAmpdoc)(nodeOrAmpDoc);
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @param {boolean=} loadAnalytics
     * @return {!Promise<!../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>}
     */

  }, {
    key: "analyticsForDoc",
    value: function analyticsForDoc(element, loadAnalytics) {
      if (loadAnalytics === void 0) {
        loadAnalytics = false;
      }

      if (loadAnalytics) {
        // Get Extensions service and force load analytics extension.
        var ampdoc = (0, _service.getAmpdoc)(element);
        Services.extensionsFor(ampdoc.win).
        /*OK*/
        installExtensionForDoc(ampdoc, 'amp-analytics');
      }

      return (
        /** @type {!Promise<!../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'amp-analytics-instrumentation', 'amp-analytics')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>}
     */

  }, {
    key: "analyticsForDocOrNull",
    value: function analyticsForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-analytics/0.1/instrumentation.InstrumentationService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'amp-analytics-instrumentation', 'amp-analytics')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/batched-xhr-impl.BatchedXhr}
     */

  }, {
    key: "batchedXhrFor",
    value: function batchedXhrFor(window) {
      return (
        /** @type {!./service/batched-xhr-impl.BatchedXhr} */
        (0, _service.getService)(window, 'batched-xhr')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-bind/0.1/bind-impl.Bind>}
     */

  }, {
    key: "bindForDocOrNull",
    value: function bindForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-bind/0.1/bind-impl.Bind>} */
        (0, _elementService.getElementServiceIfAvailableForDocInEmbedScope)(element, 'bind', 'amp-bind')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-script/0.1/amp-script.AmpScriptService>}
     */

  }, {
    key: "scriptForDocOrNull",
    value: function scriptForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-script/0.1/amp-script.AmpScriptService>} */
        (0, _elementService.getElementServiceIfAvailableForDocInEmbedScope)(element, 'amp-script', 'amp-script')
      );
    }
    /**
     * @param {!Element|!ShadowRoot|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/cid-impl.CidDef>}
     */

  }, {
    key: "cidForDoc",
    value: function cidForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/cid-impl.CidDef>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'cid')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/navigation.Navigation}
     */

  }, {
    key: "navigationForDoc",
    value: function navigationForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/navigation.Navigation} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'navigation')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-loader/0.1/amp-loader.LoaderService>}
     */

  }, {
    key: "loaderServiceForDoc",
    value: function loaderServiceForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-loader/0.1/amp-loader.LoaderService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'loader', 'amp-loader')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-standalone/0.1/amp-standalone.StandaloneService>}
     */

  }, {
    key: "standaloneServiceForDoc",
    value: function standaloneServiceForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-standalone/0.1/amp-standalone.StandaloneService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'standalone', 'amp-standalone')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/crypto-impl.Crypto}
     */

  }, {
    key: "cryptoFor",
    value: function cryptoFor(window) {
      return (
        /** @type {!./service/crypto-impl.Crypto} */
        (0, _service.getService)(window, 'crypto')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/document-info-impl.DocumentInfoDef} Info about the doc
     */

  }, {
    key: "documentInfoForDoc",
    value: function documentInfoForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/document-info-impl.DocInfo} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'documentInfo').get()
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/extensions-impl.Extensions}
     */

  }, {
    key: "extensionsFor",
    value: function extensionsFor(window) {
      return (
        /** @type {!./service/extensions-impl.Extensions} */
        (0, _service.getService)(window, 'extensions')
      );
    }
    /**
     * Returns a service to register callbacks we wish to execute when an
     * amp-form is submitted.
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<../extensions/amp-form/0.1/form-submit-service.FormSubmitService>}
     */

  }, {
    key: "formSubmitForDoc",
    value: function formSubmitForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<../extensions/amp-form/0.1/form-submit-service.FormSubmitService>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'form-submit-service')
      );
    }
    /**
     * Returns service to listen for `hidden` attribute mutations.
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/hidden-observer-impl.HiddenObserver}
     */

  }, {
    key: "hiddenObserverForDoc",
    value: function hiddenObserverForDoc(element) {
      return (
        /** @type {!./service/hidden-observer-impl.HiddenObserver} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'hidden-observer')
      );
    }
    /**
     * Returns service implemented in service/history-impl.
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/history-impl.History}
     */

  }, {
    key: "historyForDoc",
    value: function historyForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/history-impl.History} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'history')
      );
    }
    /**
     * @param {!Window} win
     * @return {!./input.Input}
     */

  }, {
    key: "inputFor",
    value: function inputFor(win) {
      return (0, _service.getService)(win, 'input');
    }
    /**s
     * Returns a promise for the Inputmask service.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-inputmask/0.1/amp-inputmask.AmpInputmaskService>}
     */

  }, {
    key: "inputmaskServiceForDocOrNull",
    value: function inputmaskServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-inputmask/0.1/amp-inputmask.AmpInputmaskService>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'inputmask', 'amp-inputmask')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!../extensions/amp-next-page/1.0/service.NextPageService}
     */

  }, {
    key: "nextPageServiceForDoc",
    value: function nextPageServiceForDoc(elementOrAmpDoc) {
      return (
        /** @type {!../extensions/amp-next-page/1.0/service.NextPageService} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'next-page')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/mutator-interface.MutatorInterface}
     */

  }, {
    key: "mutatorForDoc",
    value: function mutatorForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/mutator-interface.MutatorInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'mutator')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/owners-interface.OwnersInterface}
     */

  }, {
    key: "ownersForDoc",
    value: function ownersForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/owners-interface.OwnersInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'owners')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/performance-impl.Performance}
     */

  }, {
    key: "performanceFor",
    value: function performanceFor(window) {
      return (
        /** @type {!./service/performance-impl.Performance}*/
        (0, _service.getService)(window, 'performance')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/performance-impl.Performance}
     */

  }, {
    key: "performanceForOrNull",
    value: function performanceForOrNull(window) {
      return (
        /** @type {!./service/performance-impl.Performance}*/
        (0, _service.getExistingServiceOrNull)(window, 'performance')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/platform-impl.Platform}
     */

  }, {
    key: "platformFor",
    value: function platformFor(window) {
      return (
        /** @type {!./service/platform-impl.Platform} */
        (0, _service.getService)(window, 'platform')
      );
    }
    /**
     * Not installed by default; must be installed in extension code before use.
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/position-observer/position-observer-impl.PositionObserver}
     * @throws If the service is not installed.
     */

  }, {
    key: "positionObserverForDoc",
    value: function positionObserverForDoc(element) {
      return (
        /** @type {!./service/position-observer/position-observer-impl.PositionObserver} */
        (0, _service.getServiceForDoc)(element, 'position-observer')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./preconnect.PreconnectService}
     */

  }, {
    key: "preconnectFor",
    value: function preconnectFor(window) {
      return (0, _service.getService)(window, 'preconnect');
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/resources-interface.ResourcesInterface}
     */

  }, {
    key: "resourcesForDoc",
    value: function resourcesForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/resources-interface.ResourcesInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'resources')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/resources-interface.ResourcesInterface>}
     */

  }, {
    key: "resourcesPromiseForDoc",
    value: function resourcesPromiseForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/resources-interface.ResourcesInterface>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'resources')
      );
    }
    /**
     * @param {!Window} win
     * @return {?Promise<?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService>}
     */

  }, {
    key: "storyVariableServiceForOrNull",
    value: function storyVariableServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-variable', 'amp-story')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService}
     */

  }, {
    key: "storyVariableService",
    value: function storyVariableService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/variable-service.AmpStoryVariableService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-variable')
      );
    }
    /**
     * Version of the story store service depends on which version of amp-story
     * the publisher is loading. They all have the same implementation.
     * @param {!Window} win
     * @return {?Promise<?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService>}
     */

  }, {
    key: "storyStoreServiceForOrNull",
    value: function storyStoreServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-store', 'amp-story')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService}
     */

  }, {
    key: "storyStoreService",
    value: function storyStoreService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/amp-story-store-service.AmpStoryStoreService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-store')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/amp-story-media-query-service.AmpStoryMediaQueryService}
     */

  }, {
    key: "storyMediaQueryService",
    value: function storyMediaQueryService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/amp-story-media-query-service.AmpStoryMediaQueryService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-media-query')
      );
    }
    /**
     * Get promise with story request service
     * @param {!Window} win
     * @return {?Promise<?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService>}
     */

  }, {
    key: "storyRequestServiceForOrNull",
    value: function storyRequestServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-request', 'amp-story')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService}
     */

  }, {
    key: "storyRequestService",
    value: function storyRequestService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/amp-story-request-service.AmpStoryRequestService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-request')
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/media-performance-metrics-service.MediaPerformanceMetricsService}
     */

  }, {
    key: "mediaPerformanceMetricsService",
    value: function mediaPerformanceMetricsService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/media-performance-metrics-service.MediaPerformanceMetricsService} */
        (0, _service.getExistingServiceOrNull)(win, 'media-performance-metrics')
      );
    }
    /**
     * @param {!Element} el
     * @return {!Promise<./service/localization.LocalizationService>}
     */

  }, {
    key: "localizationServiceForOrNull",
    value: function localizationServiceForOrNull(el) {
      return (
        /** @type {!Promise<?./service/localization.LocalizationService>} */
        (0, _service.getServicePromiseForDoc)(el, 'localization')
      );
    }
    /**
     * @param {!Element} element
     * @return {?./service/localization.LocalizationService}
     */

  }, {
    key: "localizationForDoc",
    value: function localizationForDoc(element) {
      return (
        /** @type {?./service/localization.LocalizationService} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'localization')
      );
    }
    /**
     * TODO(#14357): Remove this when amp-story:0.1 is deprecated.
     * @param {!Window} win
     * @return {!Promise<?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService>}
     */

  }, {
    key: "storyAnalyticsServiceForOrNull",
    value: function storyAnalyticsServiceForOrNull(win) {
      return (
        /** @type {!Promise<?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService>} */
        (0, _elementService.getElementServiceIfAvailable)(win, 'story-analytics', 'amp-story', true)
      );
    }
    /**
     * @param {!Window} win
     * @return {?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService}
     */

  }, {
    key: "storyAnalyticsService",
    value: function storyAnalyticsService(win) {
      return (
        /** @type {?../extensions/amp-story/1.0/story-analytics.StoryAnalyticsService} */
        (0, _service.getExistingServiceOrNull)(win, 'story-analytics')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-animation/0.1/web-animation-service.WebAnimationService>}
     */

  }, {
    key: "webAnimationServiceFor",
    value: function webAnimationServiceFor(element) {
      return (
        /** @type {!Promise<!../extensions/amp-animation/0.1/web-animation-service.WebAnimationService>} */
        (0, _elementService.getElementServiceForDoc)(element, 'web-animation', 'amp-animation')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/storage-impl.Storage>}
     */

  }, {
    key: "storageForDoc",
    value: function storageForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/storage-impl.Storage>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'storage')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/template-impl.Templates}
     */

  }, {
    key: "templatesFor",
    value: function templatesFor(window) {
      return (
        /** @type {!./service/template-impl.Templates} */
        (0, _service.getService)(window, 'templates')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/timer-impl.Timer}
     */

  }, {
    key: "timerFor",
    value: function timerFor(window) {
      // TODO(alabiaga): This will always return the top window's Timer service.
      return (
        /** @type {!./service/timer-impl.Timer} */
        (0, _service.getService)(window, 'timer')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/url-replacements-impl.UrlReplacements}
     */

  }, {
    key: "urlReplacementsForDoc",
    value: function urlReplacementsForDoc(element) {
      return (
        /** @type {!./service/url-replacements-impl.UrlReplacements} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'url-replace')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<!../extensions/amp-user-notification/0.1/amp-user-notification.UserNotificationManager>}
     */

  }, {
    key: "userNotificationManagerForDoc",
    value: function userNotificationManagerForDoc(element) {
      return (
        /** @type {!Promise<!../extensions/amp-user-notification/0.1/amp-user-notification.UserNotificationManager>} */
        (0, _elementService.getElementServiceForDoc)(element, 'userNotificationManager', 'amp-user-notification')
      );
    }
    /**
     * Returns a promise for the consentPolicy Service or a promise for null if
     * the service is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-consent/0.1/consent-policy-manager.ConsentPolicyManager>}
     */

  }, {
    key: "consentPolicyServiceForDocOrNull",
    value: function consentPolicyServiceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-consent/0.1/consent-policy-manager.ConsentPolicyManager>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'consentPolicyManager', 'amp-consent')
      );
    }
    /**
     * Returns a promise for the geo service or a promise for null if
     * the service is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-geo/0.1/amp-geo.GeoDef>}
     */

  }, {
    key: "geoForDocOrNull",
    value: function geoForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-geo/0.1/amp-geo.GeoDef>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'geo', 'amp-geo', true)
      );
    }
    /**
     * Unlike most service getters, passing `Node` is necessary for some FIE-scope
     * services since sometimes we only have the FIE Document for context.
     * @param {!Element|!ShadowRoot} element
     * @return {!./service/url-impl.Url}
     */

  }, {
    key: "urlForDoc",
    value: function urlForDoc(element) {
      return (
        /** @type {!./service/url-impl.Url} */
        (0, _service.getExistingServiceForDocInEmbedScope)(element, 'url')
      );
    }
    /**
     * Returns a promise for the experiment variants or a promise for null if it
     * is not available on the current page.
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-experiment/0.1/variant.Variants>}
     */

  }, {
    key: "variantsForDocOrNull",
    value: function variantsForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-experiment/0.1/variant.Variants>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'variant', 'amp-experiment', true)
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/video-manager-impl.VideoManager}
     */

  }, {
    key: "videoManagerForDoc",
    value: function videoManagerForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/video-manager-impl.VideoManager} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'video-manager')
      );
    }
    /**
     * @param {!Element|!ShadowRoot} element
     * @return {!Promise<?../extensions/amp-viewer-assistance/0.1/amp-viewer-assistance.AmpViewerAssistance>}
     */

  }, {
    key: "viewerAssistanceForDocOrNull",
    value: function viewerAssistanceForDocOrNull(element) {
      return (
        /** @type {!Promise<?../extensions/amp-viewer-assistance/0.1/amp-viewer-assistance.AmpViewerAssistance>} */
        (0, _elementService.getElementServiceIfAvailableForDoc)(element, 'amp-viewer-assistance', 'amp-viewer-assistance')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/viewer-interface.ViewerInterface}
     */

  }, {
    key: "viewerForDoc",
    value: function viewerForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/viewer-interface.ViewerInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'viewer')
      );
    }
    /**
     * Returns promise for the viewer. This is an unusual case and necessary only
     * for services that need reference to the viewer before it has been
     * initialized. Most of the code, however, just should use `viewerForDoc`.
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!Promise<!./service/viewer-interface.ViewerInterface>}
     */

  }, {
    key: "viewerPromiseForDoc",
    value: function viewerPromiseForDoc(elementOrAmpDoc) {
      return (
        /** @type {!Promise<!./service/viewer-interface.ViewerInterface>} */
        (0, _service.getServicePromiseForDoc)(elementOrAmpDoc, 'viewer')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/vsync-impl.Vsync}
     */

  }, {
    key: "vsyncFor",
    value: function vsyncFor(window) {
      return (
        /** @type {!./service/vsync-impl.Vsync} */
        (0, _service.getService)(window, 'vsync')
      );
    }
    /**
     * @param {!Element|!./service/ampdoc-impl.AmpDoc} elementOrAmpDoc
     * @return {!./service/viewport/viewport-interface.ViewportInterface}
     */

  }, {
    key: "viewportForDoc",
    value: function viewportForDoc(elementOrAmpDoc) {
      return (
        /** @type {!./service/viewport/viewport-interface.ViewportInterface} */
        (0, _service.getServiceForDoc)(elementOrAmpDoc, 'viewport')
      );
    }
    /**
     * @param {!Window} window
     * @return {!./service/xhr-impl.Xhr}
     */

  }, {
    key: "xhrFor",
    value: function xhrFor(window) {
      return (
        /** @type {!./service/xhr-impl.Xhr} */
        (0, _service.getService)(window, 'xhr')
      );
    }
  }]);

  return Services;
}();

exports.Services = Services;

},{"./element-service":107,"./service":130}],134:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.createShadowRoot = createShadowRoot;
exports.getShadowRootNode = getShadowRootNode;
exports.importShadowBody = importShadowBody;
exports.transformShadowCss = transformShadowCss;
exports.scopeShadowCss = scopeShadowCss;
exports.installShadowStyle = installShadowStyle;
exports.resetShadowStyleCacheForTesting = resetShadowStyleCacheForTesting;
exports.setShadowDomStreamingSupportedForTesting = setShadowDomStreamingSupportedForTesting;
exports.isShadowDomStreamingSupported = isShadowDomStreamingSupported;
exports.createShadowDomWriter = createShadowDomWriter;

var _domWriter = require("./utils/dom-writer");

var _services = require("./services");

var _ShadowCSS = require("../third_party/webcomponentsjs/ShadowCSS");

var _webComponents = require("./web-components");

var _dom = require("./dom");

var _log = require("./log");

var _css = require("./css");

var _styleInstaller = require("./style-installer");

var _style = require("./style");

var _types = require("./types");

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Used for non-composed root-node search. See `getRootNode`.
 * @const {!GetRootNodeOptions}
 */
var UNCOMPOSED_SEARCH = {
  composed: false
};

/** @const {!RegExp} */
var CSS_SELECTOR_BEG_REGEX = /[^\.\-\_0-9a-zA-Z]/;

/** @const {!RegExp} */
var CSS_SELECTOR_END_REGEX = /[^\-\_0-9a-zA-Z]/;
var SHADOW_CSS_CACHE = '__AMP_SHADOW_CSS';

/**
 * @type {boolean|undefined}
 */
var shadowDomStreamingSupported;

/**
 * Creates a shadow root for the specified host and returns it. Polyfills
 * shadow root creation if necessary.
 * @param {!Element} hostElement
 * @return {!ShadowRoot}
 */
function createShadowRoot(hostElement) {
  var win = (0, _types.toWin)(hostElement.ownerDocument.defaultView);
  var existingRoot = hostElement.shadowRoot || hostElement.__AMP_SHADOW_ROOT;

  if (existingRoot) {
    existingRoot.
    /*OK*/
    innerHTML = '';
    return existingRoot;
  }

  var shadowRoot;
  var shadowDomSupported = (0, _webComponents.getShadowDomSupportedVersion)();

  if (shadowDomSupported == _webComponents.ShadowDomVersion.V1) {
    shadowRoot = hostElement.attachShadow({
      mode: 'open'
    });

    if (!shadowRoot.styleSheets) {
      Object.defineProperty(shadowRoot, 'styleSheets', {
        get: function get() {
          var items = [];
          (0, _dom.iterateCursor)(shadowRoot.childNodes, function (child) {
            if (child.tagName === 'STYLE') {
              items.push(child.sheet);
            }
          });
          return items;
        }
      });
    }
  } else if (shadowDomSupported == _webComponents.ShadowDomVersion.V0) {
    shadowRoot = hostElement.createShadowRoot();
  } else {
    shadowRoot = createShadowRootPolyfill(hostElement);
  }

  if (!(0, _webComponents.isShadowCssSupported)()) {
    var rootId = "i-amphtml-sd-" + win.Math.floor(win.Math.random() * 10000);
    shadowRoot.id = rootId;
    shadowRoot.host.classList.add(rootId);
    // CSS isolation.
    (0, _styleInstaller.installCssTransformer)(shadowRoot, function (css) {
      return transformShadowCss(shadowRoot, css);
    });
  }

  return shadowRoot;
}

/**
 * Shadow root polyfill.
 * @param {!Element} hostElement
 * @return {!ShadowRoot}
 */
function createShadowRootPolyfill(hostElement) {
  var doc = hostElement.ownerDocument;
  // Host CSS polyfill.
  hostElement.classList.add('i-amphtml-shadow-host-polyfill');
  var hostStyle = doc.createElement('style');
  hostStyle.textContent = '.i-amphtml-shadow-host-polyfill>:not(i-amphtml-shadow-root)' + '{display:none!important}';
  hostElement.appendChild(hostStyle);
  // Shadow root.
  var shadowRoot
  /** @type {!ShadowRoot} */
  = // Cast to ShadowRoot even though it is an Element
  // TODO(@dvoytenko) Consider to switch to a type union instead.

  /** @type {?}  */
  doc.createElement('i-amphtml-shadow-root');
  hostElement.appendChild(shadowRoot);
  hostElement.__AMP_SHADOW_ROOT = shadowRoot;
  Object.defineProperty(hostElement, 'shadowRoot', {
    enumerable: true,
    configurable: true,
    value: shadowRoot
  });
  // API: https://www.w3.org/TR/shadow-dom/#the-shadowroot-interface
  shadowRoot.host = hostElement;

  // `getElementById` is resolved via `querySelector('#id')`.
  shadowRoot.getElementById = function (id) {
    var escapedId = (0, _css.escapeCssSelectorIdent)(id);
    return (
      /** @type {HTMLElement|null} */
      shadowRoot.
      /*OK*/
      querySelector("#" + escapedId)
    );
  };

  // The styleSheets property should have a list of local styles.
  Object.defineProperty(shadowRoot, 'styleSheets', {
    get: function get() {
      if (!doc.styleSheets) {
        return [];
      }

      return (0, _types.toArray)(doc.styleSheets).filter(function (styleSheet) {
        return shadowRoot.contains(styleSheet.ownerNode);
      });
    }
  });
  return shadowRoot;
}

/**
 * Return shadow root for the specified node.
 * @param {!Node} node
 * @return {?ShadowRoot}
 */
function getShadowRootNode(node) {
  // TODO(#22733): remove in preference to dom's `rootNodeFor`.
  if ((0, _webComponents.isShadowDomSupported)() && Node.prototype.getRootNode) {
    return (
      /** @type {?ShadowRoot} */
      node.getRootNode(UNCOMPOSED_SEARCH)
    );
  }

  // Polyfill shadow root lookup.
  return (
    /** @type {?ShadowRoot} */
    (0, _dom.closestNode)(node, function (n) {
      return (0, _dom.isShadowRoot)(n);
    })
  );
}

/**
 * Imports a body into a shadow root with the workaround for a polyfill case.
 * @param {!ShadowRoot} shadowRoot
 * @param {!Element} body
 * @param {boolean} deep
 * @return {!Element}
 */
function importShadowBody(shadowRoot, body, deep) {
  var doc = shadowRoot.ownerDocument;
  var resultBody;

  if ((0, _webComponents.isShadowCssSupported)()) {
    resultBody = (0, _log.dev)().assertElement(doc.importNode(body, deep));
  } else {
    resultBody = doc.createElement('amp-body');
    (0, _style.setInitialDisplay)(resultBody, 'block');

    for (var i = 0; i < body.attributes.length; i++) {
      resultBody.setAttribute(body.attributes[0].name, body.attributes[0].value);
    }

    if (deep) {
      for (var n = body.firstChild; !!n; n = n.nextSibling) {
        resultBody.appendChild(doc.importNode(n, true));
      }
    }
  }

  (0, _style.setStyle)(resultBody, 'position', 'relative');
  var oldBody = shadowRoot.body;

  if (oldBody) {
    shadowRoot.removeChild(oldBody);
  }

  shadowRoot.appendChild(resultBody);
  Object.defineProperty(shadowRoot, 'body', {
    configurable: true,
    value: resultBody
  });
  return resultBody;
}

/**
 * If necessary, transforms CSS to isolate AMP CSS within the shaodw root and
 * reduce the possibility of high-level conflicts.
 * @param {!ShadowRoot} shadowRoot
 * @param {string} css
 * @return {string}
 */
function transformShadowCss(shadowRoot, css) {
  return scopeShadowCss(shadowRoot, css);
}

/**
 * Transforms CSS to isolate AMP CSS within the shadow root and reduce the
 * possibility of high-level conflicts. There are two types of transformations:
 * 1. Root transformation: `body` -> `amp-body`, etc.
 * 2. Scoping: `a {}` -> `.i-amphtml-sd-123 a {}`.
 *
 * @param {!ShadowRoot} shadowRoot
 * @param {string} css
 * @return {string}
 * @visibleForTesting
 */
function scopeShadowCss(shadowRoot, css) {
  var id = (0, _log.devAssert)(shadowRoot.id);
  var doc = shadowRoot.ownerDocument;
  var rules = null;

  // Try to use a separate document.
  try {
    rules = getStylesheetRules(doc.implementation.createHTMLDocument(''), css);
  } catch (e) {}

  // Try to use the current document.
  if (!rules) {
    try {
      rules = getStylesheetRules(doc, css);
    } catch (e) {// Ignore.
    }
  }

  // No rules could be parsed - return css as is.
  if (!rules) {
    return css;
  }

  // Patch selectors.
  // Invoke `ShadowCSS.scopeRules` via `call` because the way it uses `this`
  // internally conflicts with Closure compiler's advanced optimizations.
  var scopeRules = _ShadowCSS.ShadowCSS.scopeRules;
  return scopeRules.call(_ShadowCSS.ShadowCSS, rules, "." + id, transformRootSelectors);
}

/**
 * Replaces top-level selectors such as `html` and `body` with their polyfill
 * counterparts: `amp-html` and `amp-body`.
 * @param {string} selector
 * @return {string}
 */
function transformRootSelectors(selector) {
  return selector.replace(/(html|body)/g, rootSelectorPrefixer);
}

/**
 * See `transformRootSelectors`.
 * @param {string} match
 * @param {string} name
 * @param {number} pos
 * @param {string} selector
 * @return {string}
 * @private
 */
function rootSelectorPrefixer(match, name, pos, selector) {
  var prev = selector.charAt(pos - 1);
  var next = selector.charAt(pos + match.length);

  if ((!prev || CSS_SELECTOR_BEG_REGEX.test(prev)) && (!next || CSS_SELECTOR_END_REGEX.test(next))) {
    return 'amp-' + match;
  }

  return match;
}

/**
 * @param {!Document} doc
 * @param {string} css
 * @return {?CSSRuleList}
 */
function getStylesheetRules(doc, css) {
  var style = doc.createElement('style');
  style.
  /*OK*/
  textContent = css;

  try {
    (doc.head || doc.documentElement).appendChild(style);

    if (style.sheet) {
      return style.sheet.cssRules;
    }

    return null;
  } finally {
    if (style.parentNode) {
      style.parentNode.removeChild(style);
    }
  }
}

/**
 * @param {!ShadowRoot} shadowRoot
 * @param {string} name
 * @param {string} cssText
 */
function installShadowStyle(shadowRoot, name, cssText) {
  var doc = shadowRoot.ownerDocument;
  var win = (0, _types.toWin)(doc.defaultView);

  if (shadowRoot.adoptedStyleSheets !== undefined && win.CSSStyleSheet.prototype.replaceSync !== undefined) {
    var cache = win[SHADOW_CSS_CACHE] || (win[SHADOW_CSS_CACHE] = {});
    var styleSheet = cache[name];

    if (!styleSheet) {
      styleSheet = new win.CSSStyleSheet();
      styleSheet.replaceSync(cssText);
      cache[name] = styleSheet;
    }

    shadowRoot.adoptedStyleSheets = shadowRoot.adoptedStyleSheets.concat(styleSheet);
  } else {
    var styleEl = doc.createElement('style');
    styleEl.setAttribute('data-name', name);
    styleEl.textContent = cssText;
    shadowRoot.appendChild(styleEl);
  }
}

/**
 * @param {!Window} win
 * @visibleForTesting
 */
function resetShadowStyleCacheForTesting(win) {
  win[SHADOW_CSS_CACHE] = null;
}

/**
 * @param {boolean|undefined} val
 * @visibleForTesting
 */
function setShadowDomStreamingSupportedForTesting(val) {
  shadowDomStreamingSupported = val;
}

/**
 * Returns `true` if the Shadow DOM streaming is supported.
 * @param {!Window} win
 * @return {boolean}
 */
function isShadowDomStreamingSupported(win) {
  if (shadowDomStreamingSupported === undefined) {
    shadowDomStreamingSupported = calcShadowDomStreamingSupported(win);
  }

  return shadowDomStreamingSupported;
}

/**
 * @param {!Window} win
 * @return {boolean}
 */
function calcShadowDomStreamingSupported(win) {
  // API must be supported.
  if (!win.document.implementation || typeof win.document.implementation.createHTMLDocument != 'function') {
    return false;
  }

  // Firefox does not support DOM streaming.
  // See: https://bugzilla.mozilla.org/show_bug.cgi?id=867102
  if (_services.Services.platformFor(win).isFirefox()) {
    return false;
  }

  // Assume full streaming support.
  return true;
}

/**
 * Creates the Shadow DOM writer available on this platform.
 * @param {!Window} win
 * @return {!./utils/dom-writer.DomWriter}
 */
function createShadowDomWriter(win) {
  if (isShadowDomStreamingSupported(win)) {
    return new _domWriter.DomWriterStreamer(win);
  }

  return new _domWriter.DomWriterBulk(win);
}

},{"../third_party/webcomponentsjs/ShadowCSS":156,"./css":105,"./dom":106,"./log":123,"./services":133,"./style":138,"./style-installer":137,"./types":139,"./utils/dom-writer":144,"./web-components":154}],135:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.htmlFor = htmlFor;
exports.svgFor = svgFor;
exports.htmlRefs = htmlRefs;

var _log = require("./log");

var _object = require("./utils/object.js");

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var htmlContainer;
var svgContainer;

/**
 * Creates the html helper for the doc.
 *
 * @param {!Element|!Document} nodeOrDoc
 * @return {function(!Array<string>):!Element}
 */
function htmlFor(nodeOrDoc) {
  var doc = nodeOrDoc.ownerDocument || nodeOrDoc;

  if (!htmlContainer || htmlContainer.ownerDocument !== doc) {
    htmlContainer = doc.createElement('div');
  }

  return html;
}

/**
 * Creates the svg helper for the doc.
 *
 * @param {!Element|!Document} nodeOrDoc
 * @return {function(!Array<string>):!Element}
 */
function svgFor(nodeOrDoc) {
  var doc = nodeOrDoc.ownerDocument || nodeOrDoc;

  if (!svgContainer || svgContainer.ownerDocument !== svgContainer) {
    svgContainer = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
  }

  return svg;
}

/**
 * A tagged template literal helper to generate static SVG trees.
 * This must be used as a tagged template, ie
 *
 * ```
 * const circle = svg`<circle cx="60" cy="60" r="22"></circle>`;
 * ```
 *
 * Only the root element and its subtree will be returned. DO NOT use this to
 * render subtree's with dynamic content, it WILL result in an error!
 *
 * @param {!Array<string>} strings
 * @return {!Element}
 */
function svg(strings) {
  return createNode(svgContainer, strings);
}

/**
 * A tagged template literal helper to generate static DOM trees.
 * This must be used as a tagged template, ie
 *
 * ```
 * const div = html`<div><span></span></div>`;
 * ```
 *
 * Only the root element and its subtree will be returned. DO NOT use this to
 * render subtree's with dynamic content, it WILL result in an error!
 *
 * @param {!Array<string>} strings
 * @return {!Element}
 */
function html(strings) {
  return createNode(htmlContainer, strings);
}

/**
 * Helper used by html and svg string literal functions.
 * @param {!Element} container
 * @param {!Array<string>} strings
 * @return {!Element}
 */
function createNode(container, strings) {
  (0, _log.devAssert)(strings.length === 1, 'Improper html template tag usage.');
  container.
  /*OK*/
  innerHTML = strings[0];
  var el = container.firstElementChild;
  (0, _log.devAssert)(el, 'No elements in template');
  (0, _log.devAssert)(!el.nextElementSibling, 'Too many root elements in template');
  // Clear to free memory.
  container.removeChild(el);
  return el;
}

/**
 * Queries an element for all elements with a "ref" attribute, removing
 * the attribute afterwards.
 * Returns a named map of all ref elements.
 *
 * @param {!Element} root
 * @return {!Object<string, !Element>}
 */
function htmlRefs(root) {
  var elements = root.querySelectorAll('[ref]');
  var refs = (0, _object.map)();

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i];
    var ref = (0, _log.devAssert)(element.getAttribute('ref'), 'Empty ref attr');
    element.removeAttribute('ref');
    (0, _log.devAssert)(refs[ref] === undefined, 'Duplicate ref');
    refs[ref] = element;
  }

  return refs;
}

},{"./log":123,"./utils/object.js":149}],136:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.dashToCamelCase = dashToCamelCase;
exports.camelCaseToDash = camelCaseToDash;
exports.dashToUnderline = dashToUnderline;
exports.endsWith = endsWith;
exports.startsWith = startsWith;
exports.includes = includes;
exports.expandTemplate = expandTemplate;
exports.stringHash32 = stringHash32;
exports.trimEnd = trimEnd;
exports.trimStart = trimStart;
exports.asyncStringReplace = asyncStringReplace;
exports.padStart = padStart;

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param {string} _match
 * @param {string} character
 * @return {string}
 */
function toUpperCase(_match, character) {
  return character.toUpperCase();
}

/**
 * @param {string} match
 * @return {string}
 */
function prependDashAndToLowerCase(match) {
  return '-' + match.toLowerCase();
}

/**
 * @param {string} name Attribute name containing dashes.
 * @return {string} Dashes removed and successive character sent to upper case.
 * visibleForTesting
 */
function dashToCamelCase(name) {
  return name.replace(/-([a-z])/g, toUpperCase);
}

/**
 * Converts a string that is in camelCase to one that is in dash-case.
 *
 * @param {string} string The string to convert.
 * @return {string} The string in dash-case.
 */
function camelCaseToDash(string) {
  return string.replace(/(?!^)[A-Z]/g, prependDashAndToLowerCase);
}

/**
 * @param {string} name Attribute name with dashes
 * @return {string} Dashes replaced by underlines.
 */
function dashToUnderline(name) {
  return name.replace('-', '_');
}

/**
 * Polyfill for String.prototype.endsWith.
 * @param {string} string
 * @param {string} suffix
 * @return {boolean}
 */
function endsWith(string, suffix) {
  var index = string.length - suffix.length;
  return index >= 0 && string.indexOf(suffix, index) == index;
}

/**
 * Polyfill for String.prototype.startsWith.
 * @param {string} string
 * @param {string} prefix
 * @return {boolean}
 */
function startsWith(string, prefix) {
  if (prefix.length > string.length) {
    return false;
  }

  return string.lastIndexOf(prefix, 0) == 0;
}

/**
 * Polyfill for String.prototype.includes.
 * @param {string} string
 * @param {string} substring
 * @param {number=} start
 * @return {boolean}
 */
function includes(string, substring, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + substring.length > string.length) {
    return false;
  }

  return string.indexOf(substring, start) !== -1;
}

/**
 * Expands placeholders in a given template string with values.
 *
 * Placeholders use ${key-name} syntax and are replaced with the value
 * returned from the given getter function.
 *
 * @param {string} template The template string to expand.
 * @param {function(string):*} getter Function used to retrieve a value for a
 *   placeholder. Returns values will be coerced into strings.
 * @param {number=} opt_maxIterations Number of times to expand the template.
 *   Defaults to 1, but should be set to a larger value your placeholder tokens
 *   can be expanded to other placeholder tokens. Take caution with large values
 *   as recursively expanding a string can be exponentially expensive.
 * @return {string}
 */
function expandTemplate(template, getter, opt_maxIterations) {
  var maxIterations = opt_maxIterations || 1;

  var _loop = function _loop(i) {
    var matches = 0;
    template = template.replace(/\${([^}]*)}/g, function (_a, b) {
      matches++;
      return getter(b);
    });

    if (!matches) {
      return "break";
    }
  };

  for (var i = 0; i < maxIterations; i++) {
    var _ret = _loop(i);

    if (_ret === "break") break;
  }

  return template;
}

/**
 * Hash function djb2a
 * This is intended to be a simple, fast hashing function using minimal code.
 * It does *not* have good cryptographic properties.
 * @param {string} str
 * @return {string} 32-bit unsigned hash of the string
 */
function stringHash32(str) {
  var length = str.length;
  var hash = 5381;

  for (var i = 0; i < length; i++) {
    hash = hash * 33 ^ str.charCodeAt(i);
  }

  // Convert from 32-bit signed to unsigned.
  return String(hash >>> 0);
}

/**
 * Trims a string on the end, removing whitespace characters.
 * @param {string} str  A string to trim.
 * @return {string} The string, with trailing whitespace removed.
 */
function trimEnd(str) {
  // TODO(sparhami) Does this get inlined for an ES2019 build?
  if (str.trimEnd) {
    return str.trimEnd();
  }

  return ('_' + str).trim().slice(1);
}

/**
 * Trims any leading whitespace from a string.
 * @param {string} str  A string to trim.
 * @return {string} The string, with leading whitespace removed.
 */
function trimStart(str) {
  if (str.trimStart) {
    return str.trimStart();
  }

  return (str + '_').trim().slice(0, -1);
}

/**
 * Wrapper around String.replace that handles asynchronous resolution.
 * @param {string} str
 * @param {RegExp} regex
 * @param {Function|string} replacer
 * @return {!Promise<string>}
 */
function asyncStringReplace(str, regex, replacer) {
  if (typeof replacer === 'string') {
    return Promise.resolve(str.replace(regex, replacer));
  }

  var stringBuilder = [];
  var lastIndex = 0;
  str.replace(regex, function (match) {
    // String.prototype.replace will pass 3 to n number of arguments to the
    // callback function based on how many capture groups the regex may or may
    // not contain. We know that the match will always be first, and the
    // index will always be second to last.
    var matchIndex = arguments[arguments.length - 2];
    stringBuilder.push(str.slice(lastIndex, matchIndex));
    lastIndex = matchIndex + match.length;
    // Store the promise in it's eventual string position.
    var replacementPromise = replacer.apply(null, arguments);
    stringBuilder.push(replacementPromise);
  });
  stringBuilder.push(str.slice(lastIndex));
  return Promise.all(stringBuilder).then(function (resolved) {
    return resolved.join('');
  });
}

/**
 * Pads the beginning of a string with a substring to a target length.
 * @param {string} s
 * @param {number} targetLength
 * @param {string} padString
 * @return {*} TODO(#23582): Specify return type
 */
function padStart(s, targetLength, padString) {
  if (s.length >= targetLength) {
    return s;
  }

  targetLength = targetLength - s.length;
  var padding = padString;

  while (targetLength > padding.length) {
    padding += padString;
  }

  return padding.slice(0, targetLength) + s;
}

},{}],137:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.installStylesForDoc = installStylesForDoc;
exports.installStylesLegacy = installStylesLegacy;
exports.installCssTransformer = installCssTransformer;
exports.setBodyMadeVisibleForTesting = setBodyMadeVisibleForTesting;
exports.makeBodyVisible = makeBodyVisible;
exports.makeBodyVisibleRecovery = makeBodyVisibleRecovery;
exports.bodyAlwaysVisible = bodyAlwaysVisible;

var _commonSignals = require("./common-signals");

var _services = require("./services");

var _enums = require("./enums");

var _log = require("./log");

var _service = require("./service");

var _dom = require("./dom");

var _object = require("./utils/object");

var _style = require("./style");

var _renderDelayingServices = require("./render-delaying-services");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TRANSFORMER_PROP = '__AMP_CSS_TR';
var STYLE_MAP_PROP = '__AMP_CSS_SM';

/**
 * Adds the given css text to the given ampdoc.
 *
 * The style tags will be at the beginning of the head before all author
 * styles. One element can be the main runtime CSS. This is guaranteed
 * to always be the first stylesheet in the doc.
 *
 * @param {!./service/ampdoc-impl.AmpDoc} ampdoc The ampdoc that should get the new styles.
 * @param {string} cssText
 * @param {?function(!Element)|undefined} cb Called when the new styles are available.
 *     Not using a promise, because this is synchronous when possible.
 *     for better performance.
 * @param {boolean=} opt_isRuntimeCss If true, this style tag will be inserted
 *     as the first element in head and all style elements will be positioned
 *     after.
 * @param {string=} opt_ext
 * @return {!Element}
 */
function installStylesForDoc(ampdoc, cssText, cb, opt_isRuntimeCss, opt_ext) {
  var cssRoot = ampdoc.getHeadNode();
  var style = insertStyleElement(cssRoot, maybeTransform(cssRoot, cssText), opt_isRuntimeCss || false, opt_ext || null);

  if (cb) {
    var rootNode = ampdoc.getRootNode();

    // Styles aren't always available synchronously. E.g. if there is a
    // pending style download, it will have to finish before the new
    // style is visible.
    // For this reason we poll until the style becomes available.
    // Sync case.
    if (styleLoaded(rootNode, style)) {
      cb(style);
      return style;
    }

    // Poll until styles are available.
    var interval = setInterval(function () {
      if (styleLoaded(rootNode, style)) {
        clearInterval(interval);
        cb(style);
      }
    }, 4);
  }

  return style;
}

/**
 * Adds the given css text to the given document.
 * TODO(dvoytenko, #22733): Remove this method once FIE/ampdoc migration is
 * done.
 *
 * @param {!Document} doc The document that should get the new styles.
 * @param {string} cssText
 * @param {?function(!Element)|undefined} cb Called when the new styles are
 *     available. Not using a promise, because this is synchronous when
 *     possible. for better performance.
 * @param {boolean=} opt_isRuntimeCss If true, this style tag will be inserted
 *     as the first element in head and all style elements will be positioned
 *     after.
 * @param {string=} opt_ext
 * @return {!Element}
 */
function installStylesLegacy(doc, cssText, cb, opt_isRuntimeCss, opt_ext) {
  var style = insertStyleElement((0, _log.dev)().assertElement(doc.head), cssText, opt_isRuntimeCss || false, opt_ext || null);

  if (cb) {
    // Styles aren't always available synchronously. E.g. if there is a
    // pending style download, it will have to finish before the new
    // style is visible.
    // For this reason we poll until the style becomes available.
    // Sync case.
    if (styleLoaded(doc, style)) {
      cb(style);
      return style;
    }

    // Poll until styles are available.
    var interval = setInterval(function () {
      if (styleLoaded(doc, style)) {
        clearInterval(interval);
        cb(style);
      }
    }, 4);
  }

  return style;
}

/**
 * Creates the properly configured style element.
 * @param {!Element|!ShadowRoot} cssRoot
 * @param {string} cssText
 * @param {boolean} isRuntimeCss
 * @param {?string} ext
 * @return {!Element}
 */
function insertStyleElement(cssRoot, cssText, isRuntimeCss, ext) {
  var styleMap = cssRoot[STYLE_MAP_PROP];

  if (!styleMap) {
    styleMap = cssRoot[STYLE_MAP_PROP] = (0, _object.map)();
  }

  var isExtCss = !isRuntimeCss && ext && ext != 'amp-custom' && ext != 'amp-keyframes';
  var key = isRuntimeCss ? 'amp-runtime' : isExtCss ? "amp-extension=" + ext : null;

  // Check if it has already been created or discovered.
  if (key) {
    var existing = getExistingStyleElement(cssRoot, styleMap, key);

    if (existing) {
      if (existing.textContent !== cssText) {
        existing.textContent = cssText;
      }

      return existing;
    }
  }

  // Create the new style element and append to cssRoot.
  var doc = cssRoot.ownerDocument || cssRoot;
  var style = doc.createElement('style');
  style.
  /*OK*/
  textContent = cssText;
  var afterElement = null;

  // Make sure that we place style tags after the main runtime CSS. Otherwise
  // the order is random.
  if (isRuntimeCss) {
    style.setAttribute('amp-runtime', '');
  } else if (isExtCss) {
    style.setAttribute('amp-extension', ext || '');
    afterElement = (0, _log.dev)().assertElement(getExistingStyleElement(cssRoot, styleMap, 'amp-runtime'));
  } else {
    if (ext) {
      style.setAttribute(ext, '');
    }

    afterElement = cssRoot.lastChild;
  }

  (0, _dom.insertAfterOrAtStart)(cssRoot, style, afterElement);

  if (key) {
    styleMap[key] = style;
  }

  return style;
}

/**
 * @param {!Element|!ShadowRoot} cssRoot
 * @param {!Object<string, !Element>} styleMap
 * @param {string} key
 * @return {?Element}
 */
function getExistingStyleElement(cssRoot, styleMap, key) {
  // Already cached.
  if (styleMap[key]) {
    return styleMap[key];
  }

  // Check if the style has already been added by the server layout.
  var existing = cssRoot.
  /*OK*/
  querySelector("style[" + key + "]");

  if (existing) {
    styleMap[key] = existing;
    return existing;
  }

  // Nothing found.
  return null;
}

/**
 * Applies a transformer to the CSS text if it has been registered.
 * @param {!Element|!ShadowRoot} cssRoot
 * @param {function(string):string} transformer
 */
function installCssTransformer(cssRoot, transformer) {
  cssRoot[TRANSFORMER_PROP] = transformer;
}

/**
 * Applies a transformer to the CSS text if it has been registered.
 * @param {!Element|!ShadowRoot} cssRoot
 * @param {string} cssText
 * @return {string}
 */
function maybeTransform(cssRoot, cssText) {
  var transformer = cssRoot[TRANSFORMER_PROP];
  return transformer ? transformer(cssText) : cssText;
}

/** @private {boolean} */
var bodyMadeVisible = false;

/**
 * @param {boolean} value
 * @visibleForTesting
 */
function setBodyMadeVisibleForTesting(value) {
  bodyMadeVisible = value;
}

/**
 * Sets the document's body opacity to 1.
 * If the body is not yet available (because our script was loaded
 * synchronously), polls until it is.
 * @param {!Document} doc The document who's body we should make visible.
 */
function makeBodyVisible(doc) {
  (0, _log.devAssert)(doc.defaultView, 'Passed in document must have a defaultView');
  var win =
  /** @type {!Window} */
  doc.defaultView;
  (0, _dom.waitForBodyOpenPromise)(doc).then(function () {
    return (0, _renderDelayingServices.waitForServices)(win);
  }).catch(function (reason) {
    (0, _log.rethrowAsync)(reason);
    return [];
  }).then(function (services) {
    bodyMadeVisible = true;
    setBodyVisibleStyles(doc);
    var ampdoc = (0, _service.getAmpdoc)(doc);
    ampdoc.signals().signal(_commonSignals.CommonSignals.RENDER_START);

    if (services.length > 0) {
      var resources = _services.Services.resourcesForDoc(doc.documentElement);

      resources.
      /*OK*/
      schedulePass(1,
      /* relayoutAll */
      true);
    }

    try {
      var perf = _services.Services.performanceFor(win);

      perf.tick(_enums.TickLabel.MAKE_BODY_VISIBLE);
      perf.flush();
    } catch (e) {}
  });
}

/**
 * Set the document's body opacity to 1. Called in error cases.
 * @param {!Document} doc The document who's body we should make visible.
 */
function makeBodyVisibleRecovery(doc) {
  (0, _log.devAssert)(doc.defaultView, 'Passed in document must have a defaultView');

  if (bodyMadeVisible) {
    return;
  }

  bodyMadeVisible = true;
  setBodyVisibleStyles(doc);
}

/**
 * Make sure that body exists, and make it visible.
 * @param {!Document} doc
 */
function setBodyVisibleStyles(doc) {
  (0, _style.setStyles)((0, _log.dev)().assertElement(doc.body), {
    opacity: 1,
    visibility: 'visible',
    'animation': 'none'
  });
}

/**
 * Indicates that the body is always visible. For instance, in case of PWA.
 * This check is on a module level variable, and could be problematic if you are
 * relying on this function across different binaries.
 * @param {!Window} unusedWin
 */
function bodyAlwaysVisible(unusedWin) {
  bodyMadeVisible = true;
}

/**
 * Checks whether a style element was registered in the DOM.
 * @param {!Document|!ShadowRoot} doc
 * @param {!Element} style
 * @return {boolean}
 */
function styleLoaded(doc, style) {
  var sheets = doc.styleSheets;

  for (var i = 0; i < sheets.length; i++) {
    var sheet = sheets[i];

    if (sheet.ownerNode == style) {
      return true;
    }
  }

  return false;
}

},{"./common-signals":101,"./dom":106,"./enums":108,"./log":123,"./render-delaying-services":128,"./service":130,"./services":133,"./style":138,"./utils/object":149}],138:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.camelCaseToTitleCase = camelCaseToTitleCase;
exports.getVendorJsPropertyName = getVendorJsPropertyName;
exports.setImportantStyles = setImportantStyles;
exports.setStyle = setStyle;
exports.getStyle = getStyle;
exports.setStyles = setStyles;
exports.assertNotDisplay = assertNotDisplay;
exports.assertDoesNotContainDisplay = assertDoesNotContainDisplay;
exports.setInitialDisplay = setInitialDisplay;
exports.toggle = toggle;
exports.px = px;
exports.deg = deg;
exports.translateX = translateX;
exports.translate = translate;
exports.scale = scale;
exports.rotate = rotate;
exports.removeAlphaFromColor = removeAlphaFromColor;
exports.computedStyle = computedStyle;
exports.resetStyles = resetStyles;
exports.propagateObjectFitStyles = propagateObjectFitStyles;

var _log = require("./log");

var _object = require("./utils/object.js");

var _string = require("./string");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Note: loaded by 3p system. Cannot rely on babel polyfills.

/** @type {Object<string, string>} */
var propertyNameCache;

/** @const {!Array<string>} */
var vendorPrefixes = ['Webkit', 'webkit', 'Moz', 'moz', 'ms', 'O', 'o'];

/**
 * @export
 * @param {string} camelCase camel cased string
 * @return {string} title cased string
 */
function camelCaseToTitleCase(camelCase) {
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
}

/**
  Checks the style if a prefixed version of a property exists and returns
 * it or returns an empty string.
 * @private
 * @param {!Object} style
 * @param {string} titleCase the title case version of a css property name
 * @return {string} the prefixed property name or null.
 */
function getVendorJsPropertyName_(style, titleCase) {
  for (var i = 0; i < vendorPrefixes.length; i++) {
    var propertyName = vendorPrefixes[i] + titleCase;

    if (style[propertyName] !== undefined) {
      return propertyName;
    }
  }

  return '';
}

/**
 * Returns the possibly prefixed JavaScript property name of a style property
 * (ex. WebkitTransitionDuration) given a camelCase'd version of the property
 * (ex. transitionDuration).
 * @export
 * @param {!Object} style
 * @param {string} camelCase the camel cased version of a css property name
 * @param {boolean=} opt_bypassCache bypass the memoized cache of property
 *   mapping
 * @return {string}
 */
function getVendorJsPropertyName(style, camelCase, opt_bypassCache) {
  if (isVar(camelCase)) {
    // CSS vars are returned as is.
    return camelCase;
  }

  if (!propertyNameCache) {
    propertyNameCache = (0, _object.map)();
  }

  var propertyName = propertyNameCache[camelCase];

  if (!propertyName || opt_bypassCache) {
    propertyName = camelCase;

    if (style[camelCase] === undefined) {
      var titleCase = camelCaseToTitleCase(camelCase);
      var prefixedPropertyName = getVendorJsPropertyName_(style, titleCase);

      if (style[prefixedPropertyName] !== undefined) {
        propertyName = prefixedPropertyName;
      }
    }

    if (!opt_bypassCache) {
      propertyNameCache[camelCase] = propertyName;
    }
  }

  return propertyName;
}

/**
 * Sets the CSS styles of the specified element with !important. The styles
 * are specified as a map from CSS property names to their values.
 * @param {!Element} element
 * @param {!Object<string, *>} styles
 */
function setImportantStyles(element, styles) {
  var style = element.style;

  for (var k in styles) {
    style.setProperty(getVendorJsPropertyName(style, k), styles[k].toString(), 'important');
  }
}

/**
 * Sets the CSS style of the specified element with optional units, e.g. "px".
 * @param {?Element} element
 * @param {string} property
 * @param {*} value
 * @param {string=} opt_units
 * @param {boolean=} opt_bypassCache
 */
function setStyle(element, property, value, opt_units, opt_bypassCache) {
  var propertyName = getVendorJsPropertyName(element.style, property, opt_bypassCache);

  if (!propertyName) {
    return;
  }

  var styleValue =
  /** @type {string} */
  opt_units ? value + opt_units : value;

  if (isVar(propertyName)) {
    element.style.setProperty(propertyName, styleValue);
  } else {
    element.style[propertyName] = styleValue;
  }
}

/**
 * Returns the value of the CSS style of the specified element.
 * @param {!Element} element
 * @param {string} property
 * @param {boolean=} opt_bypassCache
 * @return {*}
 */
function getStyle(element, property, opt_bypassCache) {
  var propertyName = getVendorJsPropertyName(element.style, property, opt_bypassCache);

  if (!propertyName) {
    return undefined;
  }

  if (isVar(propertyName)) {
    return element.style.getPropertyValue(propertyName);
  }

  return element.style[propertyName];
}

/**
 * Sets the CSS styles of the specified element. The styles
 * a specified as a map from CSS property names to their values.
 * @param {!Element} element
 * @param {!Object<string, *>} styles
 */
function setStyles(element, styles) {
  for (var k in styles) {
    setStyle(element, k, styles[k]);
  }
}

/**
 * Asserts that the style is not the `display` style.
 * This is the only possible way to pass a dynamic style to setStyle.
 *
 * If you wish to set `display`, use the `toggle` helper instead. This is so
 * changes to display can trigger necessary updates. See #17475.
 *
 * @param {string} style
 * @return {string}
 */
function assertNotDisplay(style) {
  if (style === 'display') {
    (0, _log.dev)().error('STYLE', '`display` style detected. You must use toggle instead.');
  }

  return style;
}

/**
 * Asserts that the styles does not contain the `display` style.
 * This is the only possible way to pass a dynamic styles object to setStyles
 * and setImportantStyles.
 *
 * If you wish to set `display`, use the `toggle` helper instead. This is so
 * changes to display can trigger necessary updates. See #17475.
 *
 * @param {!Object<string, *>} styles
 * @return {!Object<string, *>}
 */
function assertDoesNotContainDisplay(styles) {
  if ('display' in styles) {
    (0, _log.dev)().error('STYLE', '`display` style detected in styles. You must use toggle instead.');
  }

  return styles;
}

/**
 * Sets the initial display style of an element. This is a last resort. If you
 * can set the initial display using CSS, YOU MUST.
 * DO NOT USE THIS TO ARBITRARILY SET THE DISPLAY STYLE AFTER INITIAL SETUP.
 *
 * @param {!Element} el
 * @param {string} value
 */
function setInitialDisplay(el, value) {
  var style = el.style;
  (0, _log.devAssert)(value !== '' && value !== 'none', 'Initial display value must not be "none". Use toggle instead.');
  (0, _log.devAssert)(!style['display'], 'setInitialDisplay MUST NOT be used for ' + 'resetting the display style. If you are looking for display:none ' + 'toggling, use toggle instead.');
  style['display'] = value;
}

/**
 * Shows or hides the specified element.
 * @param {!Element} element
 * @param {boolean=} opt_display
 */
function toggle(element, opt_display) {
  if (opt_display === undefined) {
    opt_display = element.hasAttribute('hidden');
  }

  if (opt_display) {
    element.removeAttribute('hidden');
  } else {
    element.setAttribute('hidden', '');
  }
}

/**
 * Returns a pixel value.
 * @param {number} value
 * @return {string}
 */
function px(value) {
  return value + "px";
}

/**
 * Returns a degree value.
 * @param {number} value
 * @return {string}
 */
function deg(value) {
  return value + "deg";
}

/**
 * Returns a "translateX" for CSS "transform" property.
 * @param {number|string} value
 * @return {string}
 */
function translateX(value) {
  if (typeof value == 'string') {
    return "translateX(" + value + ")";
  }

  return "translateX(" + px(value) + ")";
}

/**
 * Returns a "translateX" for CSS "transform" property.
 * @param {number|string} x
 * @param {(number|string)=} opt_y
 * @return {string}
 */
function translate(x, opt_y) {
  if (typeof x == 'number') {
    x = px(x);
  }

  if (opt_y === undefined) {
    return "translate(" + x + ")";
  }

  if (typeof opt_y == 'number') {
    opt_y = px(opt_y);
  }

  return "translate(" + x + ", " + opt_y + ")";
}

/**
 * Returns a "scale" for CSS "transform" property.
 * @param {number|string} value
 * @return {string}
 */
function scale(value) {
  return "scale(" + value + ")";
}

/**
 * Returns a "rotate" for CSS "transform" property.
 * @param {number|string} value
 * @return {string}
 */
function rotate(value) {
  if (typeof value == 'number') {
    value = deg(value);
  }

  return "rotate(" + value + ")";
}

/**
 * Remove alpha value from a rgba color value.
 * Return the new color property with alpha equals if has the alpha value.
 * Caller needs to make sure the input color value is a valid rgba/rgb value
 * @param {string} rgbaColor
 * @return {string}
 */
function removeAlphaFromColor(rgbaColor) {
  return rgbaColor.replace(/\(([^,]+),([^,]+),([^,)]+),[^)]+\)/g, '($1,$2,$3, 1)');
}

/**
 * Gets the computed style of the element. The helper is necessary to enforce
 * the possible `null` value returned by a buggy Firefox.
 *
 * @param {!Window} win
 * @param {!Element} el
 * @return {!Object<string, string>}
 */
function computedStyle(win, el) {
  var style =
  /** @type {?CSSStyleDeclaration} */
  win.getComputedStyle(el);
  return (
    /** @type {!Object<string, string>} */
    style || (0, _object.map)()
  );
}

/**
 * Resets styles that were set dynamically (i.e. inline)
 * @param {!Element} element
 * @param {!Array<string>} properties
 */
function resetStyles(element, properties) {
  for (var i = 0; i < properties.length; i++) {
    setStyle(element, properties[i], null);
  }
}

/**
 * Propagates the object-fit/position element attributes as styles.
 * @param {!Element} fromEl ie: amp-img
 * @param {!Element} toEl ie: the img within amp-img
 */
function propagateObjectFitStyles(fromEl, toEl) {
  if (fromEl.hasAttribute('object-fit')) {
    setStyle(toEl, 'object-fit', fromEl.getAttribute('object-fit'));
  }

  if (fromEl.hasAttribute('object-position')) {
    setStyle(toEl, 'object-position', fromEl.getAttribute('object-position'));
  }
}

/**
 * @param {string} property
 * @return {boolean}
 */
function isVar(property) {
  return (0, _string.startsWith)(property, '--');
}

},{"./log":123,"./string":136,"./utils/object.js":149}],139:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isArray = isArray;
exports.toArray = toArray;
exports.isObject = isObject;
exports.isFiniteNumber = isFiniteNumber;
exports.isEnumValue = isEnumValue;
exports.toWin = toWin;

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @const */
var toString_ = Object.prototype.toString;

/**
 * Returns the ECMA [[Class]] of a value
 * @param {*} value
 * @return {string}
 */
function toString(value) {
  return toString_.call(value);
}

/**
 * Determines if value is actually an Array.
 * @param {*} value
 * @return {boolean}
 */
function isArray(value) {
  return Array.isArray(value);
}

/**
 * Converts an array-like object to an array.
 * @param {?IArrayLike<T>|string} arrayLike
 * @return {!Array<T>}
 * @template T
 */
function toArray(arrayLike) {
  return arrayLike ? Array.prototype.slice.call(arrayLike) : [];
}

/**
 * Determines if value is actually an Object.
 * @param {*} value
 * @return {boolean}
 */
function isObject(value) {
  return toString(value) === '[object Object]';
}

/**
 * Determines if value is of number type and finite.
 * NaN and Infinity are not considered a finite number.
 * String numbers are not considered numbers.
 * @param {*} value
 * @return {boolean}
 */
function isFiniteNumber(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Checks whether `s` is a valid value of `enumObj`.
 *
 * @param {!Object<T>} enumObj
 * @param {T} s
 * @return {boolean}
 * @template T
 */
function isEnumValue(enumObj, s) {
  for (var k in enumObj) {
    if (enumObj[k] === s) {
      return true;
    }
  }

  return false;
}

/**
 * Externs declare that access `defaultView` from `document` or
 * `ownerDocument` is of type `(Window|null)` but most of our parameter types
 * assume that it is never null. This is OK in practice as we ever only get
 * null on disconnected documents or old IE.
 * This helper function casts it into just a simple Window return type.
 *
 * @param {!Window|null} winOrNull
 * @return {!Window}
 */
function toWin(winOrNull) {
  return (
    /** @type {!Window} */
    winOrNull
  );
}

},{}],140:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.parseQueryString_ = parseQueryString_;

var _urlTryDecodeUriComponent = require("./url-try-decode-uri-component");

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var regex = /(?:^[#?]?|&)([^=&]+)(?:=([^&]*))?/g;

/**
 * Parses the query string of an URL. This method returns a simple key/value
 * map. If there are duplicate keys the latest value is returned.
 *
 * DO NOT import the function from this file. Instead, import parseQueryString
 * from `src/url.js`.
 *
 * @param {string} queryString
 * @return {!JsonObject}
 */
function parseQueryString_(queryString) {
  var params =
  /** @type {!JsonObject} */
  Object.create(null);

  if (!queryString) {
    return params;
  }

  var match;

  while (match = regex.exec(queryString)) {
    var name = (0, _urlTryDecodeUriComponent.tryDecodeUriComponent_)(match[1], match[1]);
    var value = match[2] ? (0, _urlTryDecodeUriComponent.tryDecodeUriComponent_)(match[2].replace(/\+/g, ' '), match[2]) : '';
    params[name] = value;
  }

  return params;
}

},{"./url-try-decode-uri-component":141}],141:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.tryDecodeUriComponent_ = tryDecodeUriComponent_;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Tries to decode a URI component, falling back to opt_fallback (or an empty
 * string)
 *
 * DO NOT import the function from this file. Instead, import
 * tryDecodeUriComponent from `src/url.js`.
 *
 * @param {string} component
 * @param {string=} fallback
 * @return {string}
 */
function tryDecodeUriComponent_(component, fallback) {
  if (fallback === void 0) {
    fallback = '';
  }

  try {
    return decodeURIComponent(component);
  } catch (e) {
    return fallback;
  }
}

},{}],142:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getWinOrigin = getWinOrigin;
exports.parseUrlDeprecated = parseUrlDeprecated;
exports.parseUrlWithA = parseUrlWithA;
exports.appendEncodedParamStringToUrl = appendEncodedParamStringToUrl;
exports.addParamToUrl = addParamToUrl;
exports.addParamsToUrl = addParamsToUrl;
exports.addMissingParamsToUrl = addMissingParamsToUrl;
exports.serializeQueryString = serializeQueryString;
exports.isSecureUrlDeprecated = isSecureUrlDeprecated;
exports.assertHttpsUrl = assertHttpsUrl;
exports.assertAbsoluteHttpOrHttpsUrl = assertAbsoluteHttpOrHttpsUrl;
exports.parseQueryString = parseQueryString;
exports.removeFragment = removeFragment;
exports.getFragment = getFragment;
exports.isProxyOrigin = isProxyOrigin;
exports.getProxyServingType = getProxyServingType;
exports.isLocalhostOrigin = isLocalhostOrigin;
exports.isProtocolValid = isProtocolValid;
exports.removeAmpJsParamsFromUrl = removeAmpJsParamsFromUrl;
exports.removeSearch = removeSearch;
exports.removeParamsFromSearch = removeParamsFromSearch;
exports.getSourceUrl = getSourceUrl;
exports.getSourceOrigin = getSourceOrigin;
exports.resolveRelativeUrl = resolveRelativeUrl;
exports.resolveRelativeUrlFallback_ = resolveRelativeUrlFallback_;
exports.getCorsUrl = getCorsUrl;
exports.checkCorsUrl = checkCorsUrl;
exports.tryDecodeUriComponent = tryDecodeUriComponent;
exports.appendPathToUrl = appendPathToUrl;
exports.SOURCE_ORIGIN_PARAM = void 0;

var _lruCache = require("./utils/lru-cache");

var _object = require("./utils/object");

var _string = require("./string");

var _mode = require("./mode");

var _types = require("./types");

var _urlParseQueryString = require("./url-parse-query-string");

var _urlTryDecodeUriComponent = require("./url-try-decode-uri-component");

var _config = require("./config");

var _log = require("./log");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @type {!JsonObject}
 */
var SERVING_TYPE_PREFIX = (0, _object.dict)({
  // No viewer
  'c': true,
  // In viewer
  'v': true,
  // Ad landing page
  'a': true,
  // Ad
  'ad': true,
  // Actions viewer
  'action': true
});

/**
 * Cached a-tag to avoid memory allocation during URL parsing.
 * @type {HTMLAnchorElement}
 */
var a;

/**
 * We cached all parsed URLs. As of now there are no use cases
 * of AMP docs that would ever parse an actual large number of URLs,
 * but we often parse the same one over and over again.
 * @type {LruCache}
 */
var cache;

/** @private @const Matches amp_js_* parameters in query string. */
var AMP_JS_PARAMS_REGEX = /[?&]amp_js[^&]*/;

/** @private @const Matches amp_gsa parameters in query string. */
var AMP_GSA_PARAMS_REGEX = /[?&]amp_gsa[^&]*/;

/** @private @const Matches amp_r parameters in query string. */
var AMP_R_PARAMS_REGEX = /[?&]amp_r[^&]*/;

/** @private @const Matches amp_kit parameters in query string. */
var AMP_KIT_PARAMS_REGEX = /[?&]amp_kit[^&]*/;

/** @private @const Matches usqp parameters from goog experiment in query string. */
var GOOGLE_EXPERIMENT_PARAMS_REGEX = /[?&]usqp[^&]*/;
var INVALID_PROTOCOLS = [
/*eslint no-script-url: 0*/
'javascript:',
/*eslint no-script-url: 0*/
'data:',
/*eslint no-script-url: 0*/
'vbscript:'];

/** @const {string} */
var SOURCE_ORIGIN_PARAM = '__amp_source_origin';
exports.SOURCE_ORIGIN_PARAM = SOURCE_ORIGIN_PARAM;

/**
 * Returns the correct origin for a given window.
 * @param {!Window} win
 * @return {string} origin
 */
function getWinOrigin(win) {
  return win.origin || parseUrlDeprecated(win.location.href).origin;
}

/**
 * Returns a Location-like object for the given URL. If it is relative,
 * the URL gets resolved.
 * Consider the returned object immutable. This is enforced during
 * testing by freezing the object.
 * @param {string} url
 * @param {boolean=} opt_nocache
 * @return {!Location}
 */
function parseUrlDeprecated(url, opt_nocache) {
  if (!a) {
    a =
    /** @type {!HTMLAnchorElement} */
    self.document.createElement('a');
    cache = self.__AMP_URL_CACHE || (self.__AMP_URL_CACHE = new _lruCache.LruCache(100));
  }

  return parseUrlWithA(a, url, opt_nocache ? null : cache);
}

/**
 * Returns a Location-like object for the given URL. If it is relative,
 * the URL gets resolved.
 * Consider the returned object immutable. This is enforced during
 * testing by freezing the object.
 * @param {!HTMLAnchorElement} a
 * @param {string} url
 * @param {LruCache=} opt_cache
 * @return {!Location}
 * @restricted
 */
function parseUrlWithA(a, url, opt_cache) {
  if (opt_cache && opt_cache.has(url)) {
    return opt_cache.get(url);
  }

  a.href = url;

  // IE11 doesn't provide full URL components when parsing relative URLs.
  // Assigning to itself again does the trick #3449.
  if (!a.protocol) {
    a.href = a.href;
  }

  var info =
  /** @type {!Location} */
  {
    href: a.href,
    protocol: a.protocol,
    host: a.host,
    hostname: a.hostname,
    port: a.port == '0' ? '' : a.port,
    pathname: a.pathname,
    search: a.search,
    hash: a.hash,
    origin: null // Set below.

  };

  // Some IE11 specific polyfills.
  // 1) IE11 strips out the leading '/' in the pathname.
  if (info.pathname[0] !== '/') {
    info.pathname = '/' + info.pathname;
  }

  // 2) For URLs with implicit ports, IE11 parses to default ports while
  // other browsers leave the port field empty.
  if (info.protocol == 'http:' && info.port == 80 || info.protocol == 'https:' && info.port == 443) {
    info.port = '';
    info.host = info.hostname;
  }

  // For data URI a.origin is equal to the string 'null' which is not useful.
  // We instead return the actual origin which is the full URL.
  var origin;

  if (a.origin && a.origin != 'null') {
    origin = a.origin;
  } else if (info.protocol == 'data:' || !info.host) {
    origin = info.href;
  } else {
    origin = info.protocol + '//' + info.host;
  }

  info.origin = origin;
  // Freeze during testing to avoid accidental mutation.
  var frozen = (0, _mode.getMode)().test && Object.freeze ? Object.freeze(info) : info;

  if (opt_cache) {
    opt_cache.put(url, frozen);
  }

  return frozen;
}

/**
 * Appends the string just before the fragment part (or optionally
 * to the front of the query string) of the URL.
 * @param {string} url
 * @param {string} paramString
 * @param {boolean=} opt_addToFront
 * @return {string}
 */
function appendEncodedParamStringToUrl(url, paramString, opt_addToFront) {
  if (!paramString) {
    return url;
  }

  var mainAndFragment = url.split('#', 2);
  var mainAndQuery = mainAndFragment[0].split('?', 2);
  var newUrl = mainAndQuery[0] + (mainAndQuery[1] ? opt_addToFront ? "?" + paramString + "&" + mainAndQuery[1] : "?" + mainAndQuery[1] + "&" + paramString : "?" + paramString);
  newUrl += mainAndFragment[1] ? "#" + mainAndFragment[1] : '';
  return newUrl;
}

/**
 * Appends a query string field and value to a url. `key` and `value`
 * will be ran through `encodeURIComponent` before appending.
 * @param {string} url
 * @param {string} key
 * @param {string} value
 * @param {boolean=} opt_addToFront
 * @return {string}
 */
function addParamToUrl(url, key, value, opt_addToFront) {
  var field = encodeURIComponent(key) + "=" + encodeURIComponent(value);
  return appendEncodedParamStringToUrl(url, field, opt_addToFront);
}

/**
 * Appends query string fields and values to a url. The `params` objects'
 * `key`s and `value`s will be transformed into query string keys/values.
 * @param {string} url
 * @param {!JsonObject<string, string|!Array<string>>} params
 * @return {string}
 */
function addParamsToUrl(url, params) {
  return appendEncodedParamStringToUrl(url, serializeQueryString(params));
}

/**
 * Append query string fields and values to a url, only if the key does not
 * exist in current query string.
 * @param {string} url
 * @param {!JsonObject<string, string|!Array<string>>} params
 * @return {string}
 */
function addMissingParamsToUrl(url, params) {
  var location = parseUrlDeprecated(url);
  var existingParams = parseQueryString(location.search);
  var paramsToAdd = (0, _object.dict)({});
  var keys = Object.keys(params);

  for (var i = 0; i < keys.length; i++) {
    if (!(0, _object.hasOwn)(existingParams, keys[i])) {
      paramsToAdd[keys[i]] = params[keys[i]];
    }
  }

  return addParamsToUrl(url, paramsToAdd);
}

/**
 * Serializes the passed parameter map into a query string with both keys
 * and values encoded.
 * @param {!JsonObject<string, string|!Array<string>>} params
 * @return {string}
 */
function serializeQueryString(params) {
  var s = [];

  for (var k in params) {
    var v = params[k];

    if (v == null) {
      continue;
    } else if ((0, _types.isArray)(v)) {
      for (var i = 0; i < v.length; i++) {
        var sv =
        /** @type {string} */
        v[i];
        s.push(encodeURIComponent(k) + "=" + encodeURIComponent(sv));
      }
    } else {
      var _sv =
      /** @type {string} */
      v;
      s.push(encodeURIComponent(k) + "=" + encodeURIComponent(_sv));
    }
  }

  return s.join('&');
}

/**
 * Returns `true` if the URL is secure: either HTTPS or localhost (for testing).
 * @param {string|!Location} url
 * @return {boolean}
 */
function isSecureUrlDeprecated(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return url.protocol == 'https:' || url.hostname == 'localhost' || url.hostname == '127.0.0.1' || (0, _string.endsWith)(url.hostname, '.localhost');
}

/**
 * Asserts that a given url is HTTPS or protocol relative. It's a user-level
 * assert.
 *
 * Provides an exception for localhost.
 *
 * @param {?string|undefined} urlString
 * @param {!Element|string} elementContext Element where the url was found.
 * @param {string=} sourceName Used for error messages.
 * @return {string}
 */
function assertHttpsUrl(urlString, elementContext, sourceName) {
  if (sourceName === void 0) {
    sourceName = 'source';
  }

  (0, _log.userAssert)(urlString != null, '%s %s must be available', elementContext, sourceName);
  // (erwinm, #4560): type cast necessary until #4560 is fixed.
  var theUrlString =
  /** @type {string} */
  urlString;
  (0, _log.userAssert)(isSecureUrlDeprecated(theUrlString) || /^(\/\/)/.test(theUrlString), '%s %s must start with ' + '"https://" or "//" or be relative and served from ' + 'either https or from localhost. Invalid value: %s', elementContext, sourceName, theUrlString);
  return theUrlString;
}

/**
 * Asserts that a given url is an absolute HTTP or HTTPS URL.
 * @param {string} urlString
 * @return {string}
 */
function assertAbsoluteHttpOrHttpsUrl(urlString) {
  (0, _log.userAssert)(/^https?\:/i.test(urlString), 'URL must start with "http://" or "https://". Invalid value: %s', urlString);
  return parseUrlDeprecated(urlString).href;
}

/**
 * Parses the query string of an URL. This method returns a simple key/value
 * map. If there are duplicate keys the latest value is returned.
 *
 * This function is implemented in a separate file to avoid a circular
 * dependency.
 *
 * @param {string} queryString
 * @return {!JsonObject}
 */
function parseQueryString(queryString) {
  return (0, _urlParseQueryString.parseQueryString_)(queryString);
}

/**
 * Returns the URL without fragment. If URL doesn't contain fragment, the same
 * string is returned.
 * @param {string} url
 * @return {string}
 */
function removeFragment(url) {
  var index = url.indexOf('#');

  if (index == -1) {
    return url;
  }

  return url.substring(0, index);
}

/**
 * Returns the fragment from the URL. If the URL doesn't contain fragment,
 * the empty string is returned.
 * @param {string} url
 * @return {string}
 */
function getFragment(url) {
  var index = url.indexOf('#');

  if (index == -1) {
    return '';
  }

  return url.substring(index);
}

/**
 * Returns whether the URL has the origin of a proxy.
 * @param {string|!Location} url URL of an AMP document.
 * @return {boolean}
 */
function isProxyOrigin(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return _config.urls.cdnProxyRegex.test(url.origin);
}

/**
 * For proxy-origin URLs, returns the serving type. Otherwise, returns null.
 * E.g., 'https://amp-com.cdn.ampproject.org/a/s/amp.com/amp_document.html'
 * returns 'a'.
 * @param {string|!Location} url URL of an AMP document.
 * @return {?string}
 */
function getProxyServingType(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  if (!isProxyOrigin(url)) {
    return null;
  }

  var path = url.pathname.split('/', 2);
  return path[1];
}

/**
 * Returns whether the URL origin is localhost.
 * @param {string|!Location} url URL of an AMP document.
 * @return {boolean}
 */
function isLocalhostOrigin(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return _config.urls.localhostRegex.test(url.origin);
}

/**
 * Returns whether the URL has valid protocol.
 * Deep link protocol is valid, but not javascript etc.
 * @param {string|!Location} url
 * @return {boolean}
 */
function isProtocolValid(url) {
  if (!url) {
    return true;
  }

  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  return !INVALID_PROTOCOLS.includes(url.protocol);
}

/**
 * Returns a URL without AMP JS parameters.
 * @param {string} url
 * @return {string}
 */
function removeAmpJsParamsFromUrl(url) {
  var parsed = parseUrlDeprecated(url);
  var search = removeAmpJsParamsFromSearch(parsed.search);
  return parsed.origin + parsed.pathname + search + parsed.hash;
}

/**
 * Returns a URL without a query string.
 * @param {string} url
 * @return {string}
 */
function removeSearch(url) {
  var index = url.indexOf('?');

  if (index == -1) {
    return url;
  }

  var fragment = getFragment(url);
  return url.substring(0, index) + fragment;
}

/**
 * Removes parameters that start with amp js parameter pattern and returns the
 * new search string.
 * @param {string} urlSearch
 * @return {string}
 */
function removeAmpJsParamsFromSearch(urlSearch) {
  if (!urlSearch || urlSearch == '?') {
    return '';
  }

  var search = urlSearch.replace(AMP_JS_PARAMS_REGEX, '').replace(AMP_GSA_PARAMS_REGEX, '').replace(AMP_R_PARAMS_REGEX, '').replace(AMP_KIT_PARAMS_REGEX, '').replace(GOOGLE_EXPERIMENT_PARAMS_REGEX, '').replace(/^[?&]/, '');
  // Removes first ? or &.
  return search ? '?' + search : '';
}

/**
 * Removes parameters with param name and returns the new search string.
 * @param {string} urlSearch
 * @param {string} paramName
 * @return {string}
 */
function removeParamsFromSearch(urlSearch, paramName) {
  // TODO: reuse the function in removeAmpJsParamsFromSearch. Accept paramNames
  // as an array.
  if (!urlSearch || urlSearch == '?') {
    return '';
  }

  var paramRegex = new RegExp("[?&]" + paramName + "=[^&]*", 'g');
  var search = urlSearch.replace(paramRegex, '').replace(/^[?&]/, '');
  return search ? '?' + search : '';
}

/**
 * Returns the source URL of an AMP document for documents served
 * on a proxy origin or directly.
 * @param {string|!Location} url URL of an AMP document.
 * @return {string}
 */
function getSourceUrl(url) {
  if (typeof url == 'string') {
    url = parseUrlDeprecated(url);
  }

  // Not a proxy URL - return the URL itself.
  if (!isProxyOrigin(url)) {
    return url.href;
  }

  // A proxy URL.
  // Example path that is being matched here.
  // https://cdn.ampproject.org/c/s/www.origin.com/foo/
  // The /s/ is optional and signals a secure origin.
  var path = url.pathname.split('/');
  var prefix = path[1];
  (0, _log.userAssert)(SERVING_TYPE_PREFIX[prefix], 'Unknown path prefix in url %s', url.href);
  var domainOrHttpsSignal = path[2];
  var origin = domainOrHttpsSignal == 's' ? 'https://' + decodeURIComponent(path[3]) : 'http://' + decodeURIComponent(domainOrHttpsSignal);
  // Sanity test that what we found looks like a domain.
  (0, _log.userAssert)(origin.indexOf('.') > 0, 'Expected a . in origin %s', origin);
  path.splice(1, domainOrHttpsSignal == 's' ? 3 : 2);
  return origin + path.join('/') + removeAmpJsParamsFromSearch(url.search) + (url.hash || '');
}

/**
 * Returns the source origin of an AMP document for documents served
 * on a proxy origin or directly.
 * @param {string|!Location} url URL of an AMP document.
 * @return {string} The source origin of the URL.
 */
function getSourceOrigin(url) {
  return parseUrlDeprecated(getSourceUrl(url)).origin;
}

/**
 * Returns absolute URL resolved based on the relative URL and the base.
 * @param {string} relativeUrlString
 * @param {string|!Location} baseUrl
 * @return {string}
 */
function resolveRelativeUrl(relativeUrlString, baseUrl) {
  if (typeof baseUrl == 'string') {
    baseUrl = parseUrlDeprecated(baseUrl);
  }

  if (typeof URL == 'function') {
    return new URL(relativeUrlString, baseUrl.href).toString();
  }

  return resolveRelativeUrlFallback_(relativeUrlString, baseUrl);
}

/**
 * Fallback for URL resolver when URL class is not available.
 * @param {string} relativeUrlString
 * @param {string|!Location} baseUrl
 * @return {string}
 * @private Visible for testing.
 */
function resolveRelativeUrlFallback_(relativeUrlString, baseUrl) {
  if (typeof baseUrl == 'string') {
    baseUrl = parseUrlDeprecated(baseUrl);
  }

  relativeUrlString = relativeUrlString.replace(/\\/g, '/');
  var relativeUrl = parseUrlDeprecated(relativeUrlString);

  // Absolute URL.
  if ((0, _string.startsWith)(relativeUrlString.toLowerCase(), relativeUrl.protocol)) {
    return relativeUrl.href;
  }

  // Protocol-relative URL.
  if ((0, _string.startsWith)(relativeUrlString, '//')) {
    return baseUrl.protocol + relativeUrlString;
  }

  // Absolute path.
  if ((0, _string.startsWith)(relativeUrlString, '/')) {
    return baseUrl.origin + relativeUrlString;
  }

  // Relative path.
  return baseUrl.origin + baseUrl.pathname.replace(/\/[^/]*$/, '/') + relativeUrlString;
}

/**
 * Add "__amp_source_origin" query parameter to the URL.
 * @param {!Window} win
 * @param {string} url
 * @return {string}
 */
function getCorsUrl(win, url) {
  checkCorsUrl(url);
  var sourceOrigin = getSourceOrigin(win.location.href);
  return addParamToUrl(url, SOURCE_ORIGIN_PARAM, sourceOrigin);
}

/**
 * Checks if the url has __amp_source_origin and throws if it does.
 * @param {string} url
 */
function checkCorsUrl(url) {
  var parsedUrl = parseUrlDeprecated(url);
  var query = parseQueryString(parsedUrl.search);
  (0, _log.userAssert)(!(SOURCE_ORIGIN_PARAM in query), 'Source origin is not allowed in %s', url);
}

/**
 * Tries to decode a URI component, falling back to opt_fallback (or an empty
 * string)
 *
 * @param {string} component
 * @param {string=} opt_fallback
 * @return {string}
 */
function tryDecodeUriComponent(component, opt_fallback) {
  return (0, _urlTryDecodeUriComponent.tryDecodeUriComponent_)(component, opt_fallback);
}

/**
 * Adds the path to the given url.
 *
 * @param {!Location} url
 * @param {string} path
 * @return {string}
 */
function appendPathToUrl(url, path) {
  var pathname = url.pathname.replace(/\/?$/, '/') + path.replace(/^\//, '');
  return url.origin + pathname + url.search + url.hash;
}

},{"./config":102,"./log":123,"./mode":124,"./string":136,"./types":139,"./url-parse-query-string":140,"./url-try-decode-uri-component":141,"./utils/lru-cache":148,"./utils/object":149}],143:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.areEqualOrdered = areEqualOrdered;
exports.remove = remove;
exports.findIndex = findIndex;
exports.fromIterator = fromIterator;
exports.pushIfNotExist = pushIfNotExist;
exports.removeItem = removeItem;
exports.lastItem = lastItem;

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Compares if two arrays contains exactly same elements of same number
 * of same order. Note that it does NOT handle NaN case as expected.
 *
 * @param {!Array<T>} arr1
 * @param {!Array<T>} arr2
 * @return {boolean}
 * @template T
 */
function areEqualOrdered(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}

/**
 * Removes elements that shouldRemove returns true for from the array.
 *
 * @param {!Array<T>} array
 * @param {function(T, number, !Array<T>):boolean} shouldRemove
 * @return {!Array<T>}
 * @template T
 */
function remove(array, shouldRemove) {
  var removed = [];
  var index = 0;

  for (var i = 0; i < array.length; i++) {
    var item = array[i];

    if (shouldRemove(item, i, array)) {
      removed.push(item);
    } else {
      if (index < i) {
        array[index] = item;
      }

      index++;
    }
  }

  if (index < array.length) {
    array.length = index;
  }

  return removed;
}

/**
 * Returns the index of the first element matching the predicate.
 * Like Array#findIndex.
 *
 * @param {!Array<T>} array
 * @param {function(T, number, !Array<T>):boolean} predicate
 * @return {number}
 * @template T
 */
function findIndex(array, predicate) {
  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i], i, array)) {
      return i;
    }
  }

  return -1;
}

/**
 * Converts the given iterator to an array.
 *
 * @param {!Iterator<T>} iterator
 * @return {Array<T>}
 * @template T
 */
function fromIterator(iterator) {
  var array = [];

  for (var e = iterator.next(); !e.done; e = iterator.next()) {
    array.push(e.value);
  }

  return array;
}

/**
 * Adds item to array if it is not already present.
 *
 * @param {Array<T>} array
 * @param {T} item
 * @return {boolean}
 * @template T
 */
function pushIfNotExist(array, item) {
  if (array.indexOf(item) < 0) {
    array.push(item);
    return true;
  }

  return false;
}

/**
 * Removes the first matching item in the array. Returns `true` if the array
 * has changed.
 *
 * @param {!Array<T>} array
 * @param {T} item
 * @return {boolean}
 * @template T
 */
function removeItem(array, item) {
  var index = array.indexOf(item);

  if (index == -1) {
    return false;
  }

  array.splice(index, 1);
  return true;
}

/**
 * Returns the last item in an array.
 *
 * @param {Array<T>} array
 * @template T
 * @return {?T}
 */
function lastItem(array) {
  return array[array.length - 1];
}

},{}],144:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.removeNoScriptElements = removeNoScriptElements;
exports.DomWriterBulk = exports.DomWriterStreamer = exports.DomWriter = void 0;

var _resolvedPromise3 = require("./../resolved-promise");

var _services = require("../services");

var _dom = require("../dom");

var _log = require("../log");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Takes as an input a text stream, parses it and incrementally reconstructs
 * it in the new target root.
 *
 * See https://jakearchibald.com/2016/fun-hacks-faster-content/ for more
 * details.
 *
 * @interface
 * @extends {WritableStreamDefaultWriter}
 * @visibleForTesting
 */
var DomWriter = /*#__PURE__*/function () {
  function DomWriter() {
    _classCallCheck(this, DomWriter);
  }

  _createClass(DomWriter, [{
    key: "onBody",

    /**
     * Sets the callback that will be called when body has been parsed.
     *
     * For shadow use case, unlike most of other nodes, `<body>` cannot be simply
     * merged to support Shadow DOM polyfill where the use of `<body>`
     * element is not possible.
     *
     * The callback will be given the parsed document and it must return back
     * the reconstructed `<body>` node in the target DOM where all children
     * will be streamed into.
     *
     * @param {function(!Document):!Element} unusedCallback
     */
    value: function onBody(unusedCallback) {}
    /**
     * Sets the callback that will be called when new nodes have been merged
     * into the target DOM.
     * @param {function()} unusedCallback
     */

  }, {
    key: "onBodyChunk",
    value: function onBodyChunk(unusedCallback) {}
    /**
     * Sets the callback that will be called when the DOM has been fully
     * constructed.
     * @param {function()} unusedCallback
     */

  }, {
    key: "onEnd",
    value: function onEnd(unusedCallback) {}
  }]);

  return DomWriter;
}();

exports.DomWriter = DomWriter;

/**
 * Takes as an input a text stream, parses it and incrementally reconstructs
 * it in the given root.
 *
 * See https://jakearchibald.com/2016/fun-hacks-faster-content/ for more
 * details.
 *
 * @implements {DomWriter}
 * @visibleForTesting
 */
var DomWriterStreamer = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function DomWriterStreamer(win) {
    _classCallCheck(this, DomWriterStreamer);

    /** @const @private {!Document} */
    this.parser_ = win.document.implementation.createHTMLDocument('');
    this.parser_.open();

    /** @const @private */
    this.vsync_ = _services.Services.vsyncFor(win);

    /** @private @const */
    this.boundMerge_ = this.merge_.bind(this);

    /** @private {?function(!Document):!Element} */
    this.onBody_ = null;

    /** @private {?function()} */
    this.onBodyChunk_ = null;

    /** @private {?function()} */
    this.onEnd_ = null;

    /** @private {boolean} */
    this.mergeScheduled_ = false;

    /** @const @private {!Promise} */
    this.success_ = (0, _resolvedPromise3.resolvedPromise)();

    /** @private {boolean} */
    this.eof_ = false;

    /** @private {?Element} */
    this.targetBody_ = null;
  }

  /** @override */
  _createClass(DomWriterStreamer, [{
    key: "onBody",
    value: function onBody(callback) {
      this.onBody_ = callback;
    }
    /** @override */

  }, {
    key: "onBodyChunk",
    value: function onBodyChunk(callback) {
      this.onBodyChunk_ = callback;
    }
    /** @override */

  }, {
    key: "onEnd",
    value: function onEnd(callback) {
      this.onEnd_ = callback;
    }
    /** @override */

  }, {
    key: "write",
    value: function write(chunk) {
      if (this.eof_) {
        throw new Error('closed already');
      }

      if (chunk) {
        this.parser_.write(
        /** @type {string} */
        chunk);
      }

      this.schedule_();
      return this.success_;
    }
    /** @override */

  }, {
    key: "close",
    value: function close() {
      this.parser_.close();
      this.eof_ = true;
      this.schedule_();
      return this.success_;
    }
    /** @override */

  }, {
    key: "abort",
    value: function abort(unusedReason) {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "releaseLock",
    value: function releaseLock() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "schedule_",

    /** @private */
    value: function schedule_() {
      (0, _log.devAssert)(this.onBody_ && this.onBodyChunk_ && this.onEnd_);

      if (!this.mergeScheduled_) {
        this.mergeScheduled_ = true;
        this.vsync_.mutate(this.boundMerge_);
      }
    }
    /** @private */

  }, {
    key: "merge_",
    value: function merge_() {
      this.mergeScheduled_ = false;

      // Body has been newly parsed.
      if (!this.targetBody_ && this.parser_.body) {
        this.targetBody_ = this.onBody_(this.parser_);
      }

      // Merge body children.
      if (this.targetBody_) {
        var inputBody = (0, _log.dev)().assertElement(this.parser_.body);
        var targetBody = (0, _log.devAssert)(this.targetBody_);
        var transferCount = 0;
        removeNoScriptElements(inputBody);

        while (inputBody.firstChild) {
          transferCount++;
          targetBody.appendChild(inputBody.firstChild);
        }

        if (transferCount > 0) {
          this.onBodyChunk_();
        }
      }

      // EOF.
      if (this.eof_) {
        this.onEnd_();
      }
    }
  }, {
    key: "closed",
    get: function get() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "desiredSize",
    get: function get() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "ready",
    get: function get() {
      throw new Error('Not implemented');
    }
  }]);

  return DomWriterStreamer;
}();

exports.DomWriterStreamer = DomWriterStreamer;

/**
 * Takes as an input a text stream, aggregates it and parses it in one bulk.
 * This is a workaround against the browsers that do not support streaming DOM
 * parsing. Mainly currently Firefox.
 *
 * See https://github.com/whatwg/html/issues/2827 and
 * https://bugzilla.mozilla.org/show_bug.cgi?id=867102
 *
 * @implements {DomWriter}
 * @visibleForTesting
 */
var DomWriterBulk = /*#__PURE__*/function () {
  /**
   * @param {!Window} win
   */
  function DomWriterBulk(win) {
    _classCallCheck(this, DomWriterBulk);

    /** @private {!Array<string>} */
    this.fullHtml_ = [];

    /** @const @private */
    this.vsync_ = _services.Services.vsyncFor(win);

    /** @private {?function(!Document):!Element} */
    this.onBody_ = null;

    /** @private {?function()} */
    this.onBodyChunk_ = null;

    /** @private {?function()} */
    this.onEnd_ = null;

    /** @const @private {!Promise} */
    this.success_ = (0, _resolvedPromise3.resolvedPromise)();

    /** @private {boolean} */
    this.eof_ = false;
  }

  /** @override */
  _createClass(DomWriterBulk, [{
    key: "onBody",
    value: function onBody(callback) {
      this.onBody_ = callback;
    }
    /** @override */

  }, {
    key: "onBodyChunk",
    value: function onBodyChunk(callback) {
      this.onBodyChunk_ = callback;
    }
    /** @override */

  }, {
    key: "onEnd",
    value: function onEnd(callback) {
      this.onEnd_ = callback;
    }
    /** @override */

  }, {
    key: "write",
    value: function write(chunk) {
      (0, _log.devAssert)(this.onBody_ && this.onBodyChunk_ && this.onEnd_);

      if (this.eof_) {
        throw new Error('closed already');
      }

      if (chunk) {
        this.fullHtml_.push((0, _log.dev)().assertString(chunk));
      }

      return this.success_;
    }
    /** @override */

  }, {
    key: "close",
    value: function close() {
      var _this = this;

      (0, _log.devAssert)(this.onBody_ && this.onBodyChunk_ && this.onEnd_);
      this.eof_ = true;
      this.vsync_.mutate(function () {
        return _this.complete_();
      });
      return this.success_;
    }
    /** @override */

  }, {
    key: "abort",
    value: function abort(unusedReason) {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "releaseLock",
    value: function releaseLock() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "complete_",

    /** @private */
    value: function complete_() {
      var fullHtml = this.fullHtml_.join('');
      var doc = new DOMParser().parseFromString(fullHtml, 'text/html');

      // Merge body.
      if (doc.body) {
        var inputBody = doc.body;
        var targetBody = this.onBody_(doc);
        var transferCount = 0;
        removeNoScriptElements(inputBody);

        while (inputBody.firstChild) {
          transferCount++;
          targetBody.appendChild(inputBody.firstChild);
        }

        if (transferCount > 0) {
          this.onBodyChunk_();
        }
      }

      // EOF.
      this.onEnd_();
    }
  }, {
    key: "closed",
    get: function get() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "desiredSize",
    get: function get() {
      throw new Error('Not implemented');
    }
    /** @override */

  }, {
    key: "ready",
    get: function get() {
      throw new Error('Not implemented');
    }
  }]);

  return DomWriterBulk;
}();

exports.DomWriterBulk = DomWriterBulk;

/**
 * Remove any noscript elements.
 *
 * According to the spec
 * (https://w3c.github.io/DOM-Parsing/#the-domparser-interface), with
 * `DOMParser().parseFromString`, contents of `noscript` get parsed as markup,
 * so we need to remove them manually. Why? ¯\_(ツ)_/¯ `createHTMLDocument()`
 * seems to behave the same way.
 *
 * @param {!Element} parent
 */
function removeNoScriptElements(parent) {
  var noscriptElements = (0, _dom.childElementsByTag)(parent, 'noscript');
  (0, _dom.iterateCursor)(noscriptElements, function (element) {
    (0, _dom.removeElement)(element);
  });
}

},{"../dom":106,"../log":123,"../services":133,"./../resolved-promise":129}],145:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.once = once;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(rsimha, #15334): Enable this rule.

/* eslint jsdoc/check-types: 0 */

/**
 * Creates a function that is evaluated only once and returns the cached result
 * subsequently.
 *
 * Please note that `once` only takes the function definition into account,
 * so it will return the same cached value even when the arguments are
 * different.
 *
 * @param {function(...):T} fn
 * @return {function(...):T}
 * @template T
 */
function once(fn) {
  var evaluated = false;
  var retValue = null;
  var callback = fn;
  return function () {
    if (!evaluated) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      retValue = callback.apply(self, args);
      evaluated = true;
      callback = null;
    }

    return retValue;
  };
}

},{}],146:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.guaranteeSrcForSrcsetUnsupportedBrowsers = guaranteeSrcForSrcsetUnsupportedBrowsers;
exports.transparentPng = transparentPng;

/**
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Sets the img src to the first url in the srcset if srcset is defined but
 * src is not for browsers that do not support srcset.
 * @param {!Element} img
 */
function guaranteeSrcForSrcsetUnsupportedBrowsers(img) {
  // The <img> tag does not have a src and does not support srcset
  if (!img.hasAttribute('src') && 'srcset' in img == false) {
    var srcset = img.getAttribute('srcset');
    var matches = /\S+/.exec(srcset);

    if (matches == null) {
      return;
    }

    var srcseturl = matches[0];
    img.setAttribute('src', srcseturl);
  }
}

/**
 * Generates a transparent PNG of a given width/height.
 *
 * @param {!Document} doc
 * @param {number} width
 * @param {number} height
 * @return {string}
 */
function transparentPng(doc, width, height) {
  var canvas = doc.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  // Canvases are fully transparent by default, so we don't actually need to
  // draw anything.
  return canvas.toDataURL();
}

},{}],147:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.Keys = exports.KeyCodes = void 0;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @enum {number}
 */
var KeyCodes = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40
};
exports.KeyCodes = KeyCodes;

/**
 * @enum {string}
 */
var Keys = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: ' ',
  LEFT_ARROW: 'ArrowLeft',
  UP_ARROW: 'ArrowUp',
  RIGHT_ARROW: 'ArrowRight',
  DOWN_ARROW: 'ArrowDown',
  TAB: 'Tab',
  BACKSPACE: 'Backspace',
  HOME: 'Home',
  END: 'End'
};
exports.Keys = Keys;

},{}],148:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.LruCache = void 0;

var _log = require("../log");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const {string} */
var TAG = 'lru-cache';

/**
 * @template T
 */
var LruCache = /*#__PURE__*/function () {
  /**
   * @param {number} capacity
   */
  function LruCache(capacity) {
    _classCallCheck(this, LruCache);

    /** @private @const {number} */
    this.capacity_ = capacity;

    /** @private {number} */
    this.size_ = 0;

    /**
     * An incrementing counter to define the last access.
     * @private {number}
     */
    this.access_ = 0;

    /** @private {!Object<(number|string), {payload: T, access: number}>} */
    this.cache_ = Object.create(null);
  }

  /**
   * Returns whether key is cached.
   *
   * @param {number|string} key
   * @return {boolean}
   */
  _createClass(LruCache, [{
    key: "has",
    value: function has(key) {
      return !!this.cache_[key];
    }
    /**
     * @param {number|string} key
     * @return {T} The cached payload.
     */

  }, {
    key: "get",
    value: function get(key) {
      var cacheable = this.cache_[key];

      if (cacheable) {
        cacheable.access = ++this.access_;
        return cacheable.payload;
      }

      return undefined;
    }
    /**
     * @param {number|string} key
     * @param {T} payload The payload to cache.
     */

  }, {
    key: "put",
    value: function put(key, payload) {
      if (!this.has(key)) {
        this.size_++;
      }

      this.cache_[key] = {
        payload: payload,
        access: this.access_
      };
      this.evict_();
    }
    /**
     * Evicts the oldest cache entry, if we've exceeded capacity.
     */

  }, {
    key: "evict_",
    value: function evict_() {
      if (this.size_ <= this.capacity_) {
        return;
      }

      (0, _log.dev)().warn(TAG, 'Trimming LRU cache');
      var cache = this.cache_;
      var oldest = this.access_ + 1;
      var oldestKey;

      for (var key in cache) {
        var access = cache[key].access;

        if (access < oldest) {
          oldest = access;
          oldestKey = key;
        }
      }

      if (oldestKey !== undefined) {
        delete cache[oldestKey];
        this.size_--;
      }
    }
  }]);

  return LruCache;
}();

exports.LruCache = LruCache;

},{"../log":123}],149:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.map = map;
exports.dict = dict;
exports.hasOwn = hasOwn;
exports.ownProperty = ownProperty;
exports.deepMerge = deepMerge;
exports.omit = omit;
exports.objectsEqualShallow = objectsEqualShallow;

var _types = require("../types");

/**
 * Copyright 2015 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @const */
var hasOwn_ = Object.prototype.hasOwnProperty;

/**
 * Returns a map-like object.
 * If opt_initial is provided, copies its own properties into the
 * newly created object.
 * @param {T=} opt_initial This should typically be an object literal.
 * @return {T}
 * @template T
 */
function map(opt_initial) {
  var obj = Object.create(null);

  if (opt_initial) {
    Object.assign(obj, opt_initial);
  }

  return obj;
}

/**
 * Return an empty JsonObject or makes the passed in object literal
 * an JsonObject.
 * The JsonObject type is just a simple object that is at-dict.
 * See
 * https://github.com/google/closure-compiler/wiki/@struct-and-@dict-Annotations
 * for what a dict is type-wise.
 * The linter enforces that the argument is, in fact, at-dict like.
 * @param {!Object=} opt_initial
 * @return {!JsonObject}
 */
function dict(opt_initial) {
  // We do not copy. The linter enforces that the passed in object is a literal
  // and thus the caller cannot have a reference to it.
  return (
    /** @type {!JsonObject} */
    opt_initial || {}
  );
}

/**
 * Checks if the given key is a property in the map.
 *
 * @param {T}  obj a map like property.
 * @param {string}  key
 * @return {boolean}
 * @template T
 */
function hasOwn(obj, key) {
  return hasOwn_.call(obj, key);
}

/**
 * Returns obj[key] iff key is obj's own property (is not inherited).
 * Otherwise, returns undefined.
 *
 * @param {Object} obj
 * @param {string} key
 * @return {*}
 */
function ownProperty(obj, key) {
  if (hasOwn(obj, key)) {
    return obj[key];
  } else {
    return undefined;
  }
}

/**
 * Deep merges source into target.
 *
 * @param {!Object} target
 * @param {!Object} source
 * @param {number} depth The maximum merge depth. If exceeded, Object.assign
 *                       will be used instead.
 * @return {!Object}
 * @throws {Error} If source contains a circular reference.
 * Note: Only nested objects are deep-merged, primitives and arrays are not.
 */
function deepMerge(target, source, depth) {
  if (depth === void 0) {
    depth = 10;
  }

  // Keep track of seen objects to detect recursive references.
  var seen = [];

  /** @type {!Array<{t: !Object, s: !Object, d: number}>} */
  var queue = [];
  queue.push({
    t: target,
    s: source,
    d: 0
  });

  var _loop = function _loop() {
    var _queue$shift = queue.shift(),
        t = _queue$shift.t,
        s = _queue$shift.s,
        d = _queue$shift.d;

    if (seen.includes(s)) {
      throw new Error('Source object has a circular reference.');
    }

    seen.push(s);

    if (t === s) {
      return "continue";
    }

    if (d > depth) {
      Object.assign(t, s);
      return "continue";
    }

    Object.keys(s).forEach(function (key) {
      var newValue = s[key];

      // Perform a deep merge IFF both target and source have the same key
      // whose corresponding values are objects.
      if (hasOwn(t, key)) {
        var oldValue = t[key];

        if ((0, _types.isObject)(newValue) && (0, _types.isObject)(oldValue)) {
          queue.push({
            t: oldValue,
            s: newValue,
            d: d + 1
          });
          return;
        }
      }

      t[key] = newValue;
    });
  };

  // BFS to ensure objects don't have recursive references at shallower depths.
  while (queue.length > 0) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return target;
}

/**
 * @param {!Object} o An object to remove properties from
 * @param {!Array<string>} props A list of properties to remove from the Object
 * @return {!Object} An object with the given properties removed
 */
function omit(o, props) {
  return Object.keys(o).reduce(function (acc, key) {
    if (!props.includes(key)) {
      acc[key] = o[key];
    }

    return acc;
  }, {});
}

/**
 * @param {!Object|null|undefined} o1
 * @param {!Object|null|undefined} o2
 * @return {boolean}
 */
function objectsEqualShallow(o1, o2) {
  if (o1 == null || o2 == null) {
    // Null is only equal to null, and undefined to undefined.
    return o1 === o2;
  }

  for (var k in o1) {
    if (o1[k] !== o2[k]) {
      return false;
    }
  }

  for (var _k in o2) {
    if (o2[_k] !== o1[_k]) {
      return false;
    }
  }

  return true;
}

},{"../types":139}],150:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.tryResolve = tryResolve;
exports.some = some;
exports.LastAddedResolver = exports.Deferred = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a Deferred struct, which holds a pending promise and its associated
 * resolve and reject functions.
 *
 * This is preferred instead of creating a Promise instance to extract the
 * resolve/reject functions yourself:
 *
 * ```
 * // Avoid doing
 * let resolve;
 * const promise = new Promise(res => {
 *   resolve = res;
 * });
 *
 * // Good
 * const deferred = new Deferred();
 * const { promise, resolve } = deferred;
 * ```
 *
 * @template T
 */
var Deferred =
/**
 * Creates an instance of Deferred.
 */
function Deferred() {
  _classCallCheck(this, Deferred);

  var resolve, reject;

  /**
   * @const {!Promise<T>}
   */
  this.promise = new
  /*OK*/
  Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });

  /**
   * @const {function(T=)}
   */
  this.resolve = resolve;

  /**
   * @const {function(*=)}
   */
  this.reject = reject;
};

exports.Deferred = Deferred;

/**
 * Creates a promise resolved to the return value of fn.
 * If fn sync throws, it will cause the promise to reject.
 *
 * @param {function():T} fn
 * @return {!Promise<T>}
 * @template T
 */
function tryResolve(fn) {
  return new Promise(function (resolve) {
    resolve(fn());
  });
}

/**
 * Returns a promise which resolves if a threshold amount of the given promises
 * resolve, and rejects otherwise.
 * @param {!Array<!Promise>} promises The array of promises to test.
 * @param {number} count The number of promises that must resolve for the
 *     returned promise to resolve.
 * @return {!Promise} A promise that resolves if any of the given promises
 *     resolve, and which rejects otherwise.
 */
function some(promises, count) {
  if (count === void 0) {
    count = 1;
  }

  return new Promise(function (resolve, reject) {
    count = Math.max(count, 0);
    var extra = promises.length - count;

    if (extra < 0) {
      reject(new Error('not enough promises to resolve'));
    }

    if (promises.length == 0) {
      resolve([]);
    }

    var values = [];
    var reasons = [];

    var onFulfilled = function onFulfilled(value) {
      if (values.length < count) {
        values.push(value);
      }

      if (values.length == count) {
        resolve(values);
      }
    };

    var onRejected = function onRejected(reason) {
      if (reasons.length <= extra) {
        reasons.push(reason);
      }

      if (reasons.length > extra) {
        reject(reasons);
      }
    };

    for (var i = 0; i < promises.length; i++) {
      Promise.resolve(promises[i]).then(onFulfilled, onRejected);
    }
  });
}

/**
 * Resolves with the result of the last promise added.
 * @implements {IThenable}
 */
var LastAddedResolver = /*#__PURE__*/function () {
  /**
   * @param {!Array<!Promise>=} opt_promises
   */
  function LastAddedResolver(opt_promises) {
    _classCallCheck(this, LastAddedResolver);

    var resolve_, reject_;

    /** @private @const {!Promise} */
    this.promise_ = new Promise(function (resolve, reject) {
      resolve_ = resolve;
      reject_ = reject;
    });

    /** @private */
    this.resolve_ = resolve_;

    /** @private */
    this.reject_ = reject_;

    /** @private */
    this.count_ = 0;

    if (opt_promises) {
      for (var i = 0; i < opt_promises.length; i++) {
        this.add(opt_promises[i]);
      }
    }
  }

  /**
   * Add a promise to possibly be resolved.
   * @param {!Promise} promise
   * @return {!Promise}
   */
  _createClass(LastAddedResolver, [{
    key: "add",
    value: function add(promise) {
      var _this = this;

      var countAtAdd = ++this.count_;
      Promise.resolve(promise).then(function (result) {
        if (_this.count_ === countAtAdd) {
          _this.resolve_(result);
        }
      }, function (error) {
        // Don't follow behavior of Promise.all and Promise.race error so that
        // this will only reject when most recently added promise fails.
        if (_this.count_ === countAtAdd) {
          _this.reject_(error);
        }
      });
      return this.promise_;
    }
    /** @override */

  }, {
    key: "then",
    value: function then(opt_resolve, opt_reject) {
      return this.promise_.then(opt_resolve, opt_reject);
    }
  }]);

  return LastAddedResolver;
}();

exports.LastAddedResolver = LastAddedResolver;

},{}],151:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.throttle = throttle;
exports.debounce = debounce;

/**
 * Copyright 2016 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Wraps a given callback and applies a rate limit.
 * It throttles the calls so that no consequent calls have time interval
 * smaller than the given minimal interval.
 *
 * @param {!Window} win
 * @param {function(...T):R} callback
 * @param {number} minInterval the minimum time interval in millisecond
 * @return {function(...T)}
 * @template T
 * @template R
 */
function throttle(win, callback, minInterval) {
  var locker = 0;
  var nextCallArgs = null;

  /**
   * @param {!Object} args
   */
  function fire(args) {
    nextCallArgs = null;
    // Lock the fire for minInterval milliseconds
    locker = win.setTimeout(waiter, minInterval);
    callback.apply(null, args);
  }

  /**
   * Waiter function
   */
  function waiter() {
    locker = 0;

    // If during the period there're invocations queued up, fire once.
    if (nextCallArgs) {
      fire(nextCallArgs);
    }
  }

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (locker) {
      nextCallArgs = args;
    } else {
      fire(args);
    }
  };
}

/**
 * Wraps a given callback and applies a wait timer, so that minInterval
 * milliseconds must pass since the last call before the callback is actually
 * invoked.
 *
 * @param {!Window} win
 * @param {function(...T):R} callback
 * @param {number} minInterval the minimum time interval in millisecond
 * @return {function(...T)}
 * @template T
 * @template R
 */
function debounce(win, callback, minInterval) {
  var locker = 0;
  var timestamp = 0;
  var nextCallArgs = null;

  /**
   * @param {?Array} args
   */
  function fire(args) {
    nextCallArgs = null;
    callback.apply(null, args);
  }

  /**
   * Wait function for debounce
   */
  function waiter() {
    locker = 0;
    var remaining = minInterval - (win.Date.now() - timestamp);

    if (remaining > 0) {
      locker = win.setTimeout(waiter, remaining);
    } else {
      fire(nextCallArgs);
    }
  }

  return function () {
    timestamp = win.Date.now();

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    nextCallArgs = args;

    if (!locker) {
      locker = win.setTimeout(waiter, minInterval);
    }
  };
}

},{}],152:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.getInternalVideoElementFor = getInternalVideoElementFor;
exports.VideoUtils = void 0;

var _log = require("../log");

var _function = require("./function");

var _style = require("../style");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @param {!Window} win
 * @param {boolean} isLiteViewer
 * @return {!Promise<boolean>}
 */
function isAutoplaySupportedImpl(win, isLiteViewer) {
  // We do not support autoplay in amp-lite viewer regardless of platform.
  if (isLiteViewer) {
    return Promise.resolve(false);
  }

  // To detect autoplay, we create a video element and call play on it, if
  // `paused` is true after `play()` call, autoplay is supported. Although
  // this is unintuitive, it works across browsers and is currently the lightest
  // way to detect autoplay without using a data source.
  var detectionElement = win.document.createElement('video');
  // NOTE(aghassemi): We need both attributes and properties due to Chrome and
  // Safari differences when dealing with non-attached elements.
  detectionElement.setAttribute('muted', '');
  detectionElement.setAttribute('playsinline', '');
  detectionElement.setAttribute('webkit-playsinline', '');
  detectionElement.setAttribute('height', '0');
  detectionElement.setAttribute('width', '0');
  detectionElement.muted = true;
  detectionElement.playsinline = true;
  detectionElement.webkitPlaysinline = true;
  (0, _style.setStyles)(detectionElement, {
    position: 'fixed',
    top: '0',
    width: '0',
    height: '0',
    opacity: '0'
  });
  // Promise wrapped this way to catch both sync throws and async rejections.
  // More info: https://github.com/tc39/proposal-promise-try
  new Promise(function (resolve) {
    return resolve(detectionElement.play());
  }).catch(function () {// Suppress any errors, useless to report as they are expected.
  });
  return Promise.resolve(!detectionElement.paused);
}

/** @private {?(function(Window, boolean):!Promise<boolean>)} */
var _isAutoplaySupported = null;

/**
 * Sets if autoplay is supported.
 */
function setIsAutoplaySupported() {
  _isAutoplaySupported =
  /** @type {function(Window, boolean):!Promise<boolean>} */
  (0, _function.once)(isAutoplaySupportedImpl);
}

/**
 * Wrapper around static utilities for testability.
 */
var VideoUtils = /*#__PURE__*/function () {
  function VideoUtils() {
    _classCallCheck(this, VideoUtils);
  }

  _createClass(VideoUtils, null, [{
    key: "isAutoplaySupported",

    /**
     * Determines autoplay support.
     *
     * Note that even if platfrom supports autoplay, users or browsers can disable
     * autoplay to save data / battery. This detects both platfrom support and
     * when autoplay has been disabled by the user.
     *
     * @param {!Window} win
     * @param {boolean} isLiteViewer
     * @return {!Promise<boolean>}
     */
    value: function isAutoplaySupported(win, isLiteViewer) {
      if (!_isAutoplaySupported) {
        setIsAutoplaySupported();
      }

      return _isAutoplaySupported(win, isLiteViewer);
    }
    /** @visibleForTesting */

  }, {
    key: "resetIsAutoplaySupported",
    value: function resetIsAutoplaySupported() {
      setIsAutoplaySupported();
    }
  }]);

  return VideoUtils;
}();

exports.VideoUtils = VideoUtils;

/**
 * @param {!Element} element
 * @return {!Element}
 * Note: Not included in `VideoUtils` as we don't need to test a
 * static selector.
 */
function getInternalVideoElementFor(element) {
  return (0, _log.dev)().assertElement(element.querySelector('video, iframe'));
}

},{"../log":123,"../style":138,"./function":145}],153:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.isDockable = isDockable;
exports.delegateAutoplay = delegateAutoplay;
exports.userInteractedWith = userInteractedWith;
exports.setIsMediaComponent = setIsMediaComponent;
exports.MEDIA_COMPONENT_CLASSNAME = exports.VideoServiceSignals = exports.VideoOrBaseElementDef = exports.videoAnalyticsCustomEventTypeKey = exports.VideoAnalyticsEvents = exports.PlayingStates = exports.PlayingStateDef = exports.VideoEvents = exports.VideoAttributes = exports.VideoInterface = exports.MIN_VISIBILITY_RATIO_FOR_AUTOPLAY = void 0;

var _log = require("./log");

var _dom = require("./dom");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MIN_VISIBILITY_RATIO_FOR_AUTOPLAY = 0.5;
exports.MIN_VISIBILITY_RATIO_FOR_AUTOPLAY = MIN_VISIBILITY_RATIO_FOR_AUTOPLAY;

/**
 * VideoInterface defines a common video API which any AMP component that plays
 * videos is expected to implement.
 *
 * AMP runtime uses this common API to provide consistent video experience and
 * analytics across all video players.
 *
 * Components implementing this interface must also extend
 * {@link ./base-element.BaseElement} and register with the
 * Video Manager {@link ./service/video-manager-impl.VideoManager} during
 * their `builtCallback`.
 *
 * @interface
 */
var VideoInterface = /*#__PURE__*/function () {
  function VideoInterface() {
    _classCallCheck(this, VideoInterface);
  }

  _createClass(VideoInterface, [{
    key: "supportsPlatform",

    /**
     * Whether the component supports video playback in the current platform.
     * If false, component will be not treated as a video component.
     * @return {boolean}
     */
    value: function supportsPlatform() {}
    /**
     * Whether users can interact with the video such as pausing it.
     * Example of non-interactive videos include design background videos where
     * all controls are hidden from the user.
     *
     * @return {boolean}
     */

  }, {
    key: "isInteractive",
    value: function isInteractive() {}
    /**
     * Current playback time in seconds at time of trigger.
     *
     * This is used for analytics metadata.
     *
     * @return {number}
     */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {}
    /**
     * Total duration of the video in seconds
     *
     * This is used for analytics metadata.
     *
     * @return {number}
     */

  }, {
    key: "getDuration",
    value: function getDuration() {}
    /**
     * Get a 2d array of start and stop times that the user has watched.
     * This is used for analytics metadata.
     * @return {!Array<Array<number>>}
     */

  }, {
    key: "getPlayedRanges",
    value: function getPlayedRanges() {}
    /**
     * Plays the video.
     *
     * @param {boolean} unusedIsAutoplay Whether the call to the `play` method is
     * triggered by the autoplay functionality. Video players can use this hint
     * to make decisions such as not playing pre-roll video ads.
     */

  }, {
    key: "play",
    value: function play(unusedIsAutoplay) {}
    /**
     * Pauses the video.
     */

  }, {
    key: "pause",
    value: function pause() {}
    /**
     * Mutes the video.
     * Implementation is required for autoplay and mute/unmute controls on docked
     * video.
     */

  }, {
    key: "mute",
    value: function mute() {}
    /**
     * Unmutes the video.
     * Implementation is required for autoplay and mute/unmute controls on docked
     * video.
     */

  }, {
    key: "unmute",
    value: function unmute() {}
    /**
     * Makes the video UI controls visible.
     *
     * AMP will not call this method if `controls` attribute is not set.
     *
     * Implementation is required for docked video.
     */

  }, {
    key: "showControls",
    value: function showControls() {}
    /**
     * Hides the video UI controls.
     *
     * AMP will not call this method if `controls` attribute is not set.
     *
     * Implementation is required for docked video.
     */

  }, {
    key: "hideControls",
    value: function hideControls() {}
    /**
     * Returns video's meta data (artwork, title, artist, album, etc.) for use
     * with the Media Session API
     * @return {!./mediasession-helper.MetadataDef|undefined} metadata
     *   - artwork (Array): URL to the poster image (preferably a 512x512 PNG)
     *   - title (string): Name of the video
     *   - artist (string): Name of the video's author/artist
     *   - album (string): Name of the video's album if it exists
     */

  }, {
    key: "getMetadata",
    value: function getMetadata() {}
    /**
     * If returning true, it's assumed that the embedded video document internally
     * implements a feature to enter fullscreen on device rotation, so that the
     * VideoManager does not override it.
     *
     * Otherwise, the feature is implemented automatically when using the
     * `rotate-to-fullscreen` attribute.
     *
     * @return {boolean}
     */

  }, {
    key: "preimplementsAutoFullscreen",
    value: function preimplementsAutoFullscreen() {}
    /**
     * If returning true, it's assumed that the embedded video document internally
     * implements the MediaSession API internally so that the VideoManager won't
     * replace it.
     *
     * Otherwise provided and inferred metadata are used to update the video's
     * Media Session.
     *
     * @return {boolean}
     */

  }, {
    key: "preimplementsMediaSessionAPI",
    value: function preimplementsMediaSessionAPI() {}
    /**
     * Enables fullscreen on the internal video element
     * NOTE: While implementing, keep in mind that Safari/iOS do not allow taking
     * any element other than <video> to fullscreen, if the player has an internal
     * implementation of fullscreen (flash for example) then check
     * if Services.platformFor(this.win).isSafari is true and use the internal
     * implementation instead. If not, it is recommended to take the iframe
     * to fullscreen using fullscreenEnter from dom.js
     */

  }, {
    key: "fullscreenEnter",
    value: function fullscreenEnter() {}
    /**
     * Quits fullscreen mode
     */

  }, {
    key: "fullscreenExit",
    value: function fullscreenExit() {}
    /**
     * Returns whether the video is currently in fullscreen mode or not.
     * @return {boolean}
     */

  }, {
    key: "isFullscreen",
    value: function isFullscreen() {}
    /**
     * Seeks the video to a specified time.
     * @param {number} unusedTimeSeconds
     */

  }, {
    key: "seekTo",
    value: function seekTo(unusedTimeSeconds) {}
  }]);

  return VideoInterface;
}();

exports.VideoInterface = VideoInterface;

/**
 * Attributes
 *
 * Components implementing the VideoInterface are expected to support
 * the following attributes.
 *
 * @const {!Object<string, string>}
 */
var VideoAttributes = {
  /**
   * autoplay
   *
   * Whether the developer has configured autoplay on the component.
   * This is normally done by setting `autoplay` attribute on the component.
   *
   * AMP runtime manages autoplay behavior itself using methods such as `play`,
   * `pause`, `showControls`, `hideControls`, `mute`, etc.. therefore components
   * should not propagate the autoplay attribute to the underlying player
   * implementation.
   *
   * When a video is requested to autoplay, AMP will automatically
   * mute and hide the controls for the video, when video is 75% visible in
   * the viewport, AMP will play the video and later pauses it when 25%
   * or more of the video exits the viewport. If an auto-playing video also has
   * controls, AMP will install a tap
   * handler on the video, and when an end-user taps the video, AMP will show
   * the controls.
   *
   */
  AUTOPLAY: 'autoplay',

  /**
   * dock
   *
   * Setting the `dock` attribute on the component makes the video minimize
   * to the corner when scrolled out of view and has been interacted with.
   */
  DOCK: 'dock',

  /**
   * rotate-to-fullscreen
   *
   * If enabled, this automatically expands the currently visible video and
   * playing to fullscreen when the user changes the device's orientation to
   * landscape if the video was started following a user interaction
   * (not autoplay)
   *
   * Dependent upon browser support of
   * http://caniuse.com/#feat=screen-orientation
   * and http://caniuse.com/#feat=fullscreen
   */
  ROTATE_TO_FULLSCREEN: 'rotate-to-fullscreen',

  /**
   * noaudio
   *
   * If set and autoplay, the equalizer icon will not be displayed.
   */
  NO_AUDIO: 'noaudio'
};
exports.VideoAttributes = VideoAttributes;

/**
 * Events
 *
 * Components implementing the VideoInterface are expected to dispatch
 * the following DOM events.
 *
 * @const {!Object<string, string>}
 */
var VideoEvents = {
  /**
   * registered
   *
   * Fired when the video player element is built and has been registered with
   * the video manager.
   *
   * @event registered
   */
  REGISTERED: 'registered',

  /**
   * load
   *
   * Fired when the video player is loaded and calls to methods such as `play()`
   * are allowed.
   *
   * @event load
   */
  LOAD: 'load',

  /**
   * loadedmetadata
   *
   * Fired when the video's metadata becomes available (e.g. duration).
   *
   * @event loadedmetadata
   */
  LOADEDMETADATA: 'loadedmetadata',

  /**
   * play
   *
   * Fired when the video plays (either because of autoplay or the play method).
   *
   * Note: Because this event was not originally present in this interface, we
   * cannot rely on all all implementations to emit it.
   *
   * @event play
   */
  PLAY: 'play',

  /**
   * playing
   *
   * Fired when the video begins playing.
   *
   * @event playing
   */
  PLAYING: 'playing',

  /**
   * pause
   *
   * Fired when the video pauses.
   *
   * @event pause
   */
  PAUSE: 'pause',

  /**
   * ended
   *
   * Fired when the video ends.
   *
   * This event should be fired in addition to `pause` when video ends.
   *
   * @event ended
   */
  ENDED: 'ended',

  /**
   * muted
   *
   * Fired when the video is muted.
   *
   * @event muted
   */
  MUTED: 'muted',

  /**
   * unmuted
   *
   * Fired when the video is unmuted.
   *
   * @event unmuted
   */
  UNMUTED: 'unmuted',

  /**
   * amp:video:visibility
   *
   * Fired when the video's visibility changes. Normally fired
   * from `viewportCallback`.
   *
   * @event amp:video:visibility
   * @property {boolean} visible Whether the video player is visible or not.
   */
  VISIBILITY: 'amp:video:visibility',

  /**
   * reload
   *
   * Fired when the video's src changes.
   *
   * @event reloaded
   */
  RELOAD: 'reloaded',

  /**
   * pre/mid/post Ad start
   *
   * Fired when an Ad starts playing.
   *
   * This is used to remove any overlay shims during Ad play during autoplay
   * or minimized-to-corner version of the player.
   *
   * @event ad_start
   */
  AD_START: 'ad_start',

  /**
   * pre/mid/post Ad ends
   *
   * Fired when an Ad ends playing.
   *
   * This is used to restore any overlay shims during Ad play during autoplay
   * or minimized-to-corner version of the player.
   *
   * @event ad_end
   */
  AD_END: 'ad_end',

  /**
   * A 3p video player can send signals for analytics whose meaning doesn't
   * fit for other events. In this case, a `tick` event is sent with additional
   * information in its data property.
   *
   * @event amp:video:tick
   */
  CUSTOM_TICK: 'amp:video:tick'
};
exports.VideoEvents = VideoEvents;

/** @typedef {string} */
var PlayingStateDef;
exports.PlayingStateDef = PlayingStateDef;

/**
 * Playing States
 *
 * Internal playing states used to distinguish between video playing on user's
 * command and videos playing automatically
 *
 * @const {!Object<string, PlayingStateDef>}
 */
var PlayingStates = {
  /**
   * playing_manual
   *
   * When the video user manually interacted with the video and the video
   * is now playing
   *
   * @event playing_manual
   */
  PLAYING_MANUAL: 'playing_manual',

  /**
   * playing_auto
   *
   * When the video has autoplay and the user hasn't interacted with it yet
   *
   * @event playing_auto
   */
  PLAYING_AUTO: 'playing_auto',

  /**
   * paused
   *
   * When the video is paused.
   *
   * @event paused
   */
  PAUSED: 'paused'
};
exports.PlayingStates = PlayingStates;

/** @enum {string} */
var VideoAnalyticsEvents = {
  /**
   * video-ended
   *
   * Indicates that a video ended.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-ended
   */
  ENDED: 'video-ended',

  /**
   * video-pause
   *
   * Indicates that a video paused.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-pause
   */
  PAUSE: 'video-pause',

  /**
   * video-play
   *
   * Indicates that a video began to play.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-play
   */
  PLAY: 'video-play',

  /**
   * video-session
   *
   * Indicates that some segment of the video played.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-session
   */
  SESSION: 'video-session',

  /**
   * video-session-visible
   *
   * Indicates that some segment of the video played in the viewport.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-session-visible
   */
  SESSION_VISIBLE: 'video-session-visible',

  /**
   * video-seconds-played
   *
   * Indicates that a video was playing when the
   * video-seconds-played interval fired.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-session-visible
   */
  SECONDS_PLAYED: 'video-seconds-played',

  /**
   * video-hosted-custom
   *
   * Indicates that a custom event incoming from a 3p frame is to be logged.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-custom
   */
  CUSTOM: 'video-hosted-custom',

  /**
   * video-percentage-played
   *
   * Indicates that a percentage interval has been played.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-custom
   */
  PERCENTAGE_PLAYED: 'video-percentage-played',

  /**
   * video-ad-start
   *
   * Indicates that an ad begins to play.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-ad-start
   */
  AD_START: 'video-ad-start',

  /**
   * video-ad-end
   *
   * Indicates that an ad ended.
   * @property {!VideoAnalyticsDetailsDef} details
   * @event video-ad-end
   */
  AD_END: 'video-ad-end'
};
exports.VideoAnalyticsEvents = VideoAnalyticsEvents;

/**
 * This key can't predictably collide with custom var names as defined in
 * analytics user configuration.
 * @type {string}
 */
var videoAnalyticsCustomEventTypeKey = '__amp:eventType';
exports.videoAnalyticsCustomEventTypeKey = videoAnalyticsCustomEventTypeKey;

/**
 * Helper union type to be used internally, so that the compiler treats
 * `VideoInterface` objects as `BaseElement`s, which they should be anyway.
 *
 * WARNING: Don't use to `register` at the Service level. Registering should
 * only allow `VideoInterface` as a guarding measure.
 *
 * @typedef {!VideoInterface|!./base-element.BaseElement}
 */
var VideoOrBaseElementDef;
exports.VideoOrBaseElementDef = VideoOrBaseElementDef;

/**
 * @param {!Element} element
 * @return {boolean}
 */
function isDockable(element) {
  return element.hasAttribute(VideoAttributes.DOCK);
}

/** @enum {string} */
var VideoServiceSignals = {
  USER_INTERACTED: 'user-interacted',
  PLAYBACK_DELEGATED: 'playback-delegated'
};
exports.VideoServiceSignals = VideoServiceSignals;

/** @param {!AmpElement|!VideoOrBaseElementDef} video */
function delegateAutoplay(video) {
  (0, _dom.whenUpgradedToCustomElement)((0, _log.dev)().assertElement(video)).then(function (el) {
    el.signals().signal(VideoServiceSignals.PLAYBACK_DELEGATED);
  });
}

/** @param {!AmpElement|!VideoOrBaseElementDef} video */
function userInteractedWith(video) {
  video.signals().signal(VideoServiceSignals.USER_INTERACTED);
}

/**
 * Classname that media components should annotate themselves with.
 * This applies to all video and audio playback components, regardless of
 * whether they implement a common interface or not.
 *
 * TODO(go.amp.dev/issue/26984): This isn't exclusive to video, but there's no
 * better place to put this now due to OWNERShip. Move.
 */
var MEDIA_COMPONENT_CLASSNAME = 'i-amphtml-media-component';
exports.MEDIA_COMPONENT_CLASSNAME = MEDIA_COMPONENT_CLASSNAME;

/**
 * Annotates media component element with a common classname.
 * This applies to all video and audio playback components, regardless of
 * whether they implement a common interface or not.
 * @param {!Element} element
 *
 * TODO(go.amp.dev/issue/26984): This isn't exclusive to video, but there's no
 * better place to put this now due to OWNERShip. Move.
 */
function setIsMediaComponent(element) {
  element.classList.add(MEDIA_COMPONENT_CLASSNAME);
}

},{"./dom":106,"./log":123}],154:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.setShadowDomSupportedVersionForTesting = setShadowDomSupportedVersionForTesting;
exports.setShadowCssSupportedForTesting = setShadowCssSupportedForTesting;
exports.isShadowDomSupported = isShadowDomSupported;
exports.isShadowCssSupported = isShadowCssSupported;
exports.getShadowDomSupportedVersion = getShadowDomSupportedVersion;
exports.ShadowDomVersion = void 0;

/**
 * Copyright 2017 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Possible versions of Shadow DOM spec
 * @const
 * @enum {string}
 */
var ShadowDomVersion = {
  NONE: 'none',
  V0: 'v0',
  V1: 'v1'
};
exports.ShadowDomVersion = ShadowDomVersion;

/**
 * @type {ShadowDomVersion|undefined}
 * @visibleForTesting
 */
var shadowDomSupportedVersion;

/**
 * @type {boolean|undefined}
 * @visibleForTesting
 */
var shadowCssSupported;

/**
 * @param {ShadowDomVersion|undefined} val
 * @visibleForTesting
 */
function setShadowDomSupportedVersionForTesting(val) {
  shadowDomSupportedVersion = val;
}

/**
 * @param {boolean|undefined} val
 * @visibleForTesting
 */
function setShadowCssSupportedForTesting(val) {
  shadowCssSupported = val;
}

/**
 * Returns `true` if the Shadow DOM is supported.
 * @return {boolean}
 */
function isShadowDomSupported() {
  return getShadowDomSupportedVersion() != ShadowDomVersion.NONE;
}

/**
 * Returns `true` if Shadow CSS encapsulation is supported.
 * @return {boolean}
 */
function isShadowCssSupported() {
  if (shadowCssSupported === undefined) {
    shadowCssSupported = isShadowDomSupported() && (isNative(Element.prototype.attachShadow) || isNative(Element.prototype.createShadowRoot));
  }

  return shadowCssSupported;
}

/**
 * Returns `true` if the passed function is native to the browser, and is not
 * polyfilled
 * @param {Function|undefined} func A function that is attatched to a JS
 * object.
 * @return {boolean}
 */
function isNative(func) {
  return !!func && func.toString().indexOf('[native code]') != -1;
}

/**
 * Returns the supported version of Shadow DOM spec.
 * @param {?typeof Element=} opt_elementClass optional for testing
 * @return {ShadowDomVersion}
 */
function getShadowDomSupportedVersion(opt_elementClass) {
  if (shadowDomSupportedVersion === undefined) {
    shadowDomSupportedVersion = getShadowDomVersion(opt_elementClass || Element);
  }

  return shadowDomSupportedVersion;
}

/**
 * Returns shadow dom version.
 *
 * @param {?typeof Element=} element
 * @return {ShadowDomVersion}
 */
function getShadowDomVersion(element) {
  if (!!element.prototype.attachShadow) {
    return ShadowDomVersion.V1;
  } else if (!!element.prototype.createShadowRoot) {
    return ShadowDomVersion.V0;
  }

  return ShadowDomVersion.NONE;
}

},{}],155:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.cssEscape = cssEscape;

/*! https://mths.be/cssescape v1.5.1 by @mathias | MIT license */

/**
 * This regex consists of 4 matching capture groups and one (non-matching) fallback:
 *
 * - (\0), catch the null terminator character so it may be replaced by UTF
 *   Replacement Char
 * - ^(-)$, catch a solitary dash char, so that it may be backslash escaped.
 *   This is a separate capture group so that the legal-chars (group 4) doesn't
 *   capture it first, since that group doesn't need to escape its dash.
 * - ([\x01-\x1f\x7f]|^-?[0-9]), catch a UTF control char, or any leading
 *   number (with an optional leading dash). The control or the number (but not
 *   the leading dash) must be hex-escaped,.
 * - ([\x80-\uffff0-9a-zA-Z_-]+), catch legal-chars, with the exception of a
 *   solitary dash, which will already have matched in group 1.
 * - [^], finally, a catch-all that allows us to backslash escape the char.
 *
 * Together, this matches everything necessary for CSS.escape.
 */
var regex = /(\0)|^(-)$|([\x01-\x1f\x7f]|^-?[0-9])|([\x80-\uffff0-9a-zA-Z_-]+)|[^]/g;

function escaper(match, nil, dash, hexEscape, chars) {
  // Chars is the legal-chars (group 4) capture
  if (chars) {
    return chars;
  }

  // Nil is the null terminator (group 1) capture
  if (nil) {
    return "\uFFFD";
  }

  // Both UTF control chars, and leading numbers (with optional leading dash)
  // (group 3) must be backslash escaped with a trailing space.  Funnily, the
  // leading dash must not be escaped, but the number. :shrug:
  if (hexEscape) {
    return match.slice(0, -1) + '\\' + match.slice(-1).charCodeAt(0).toString(16) + ' ';
  }

  // Finally, the solitary dash and the catch-all chars require backslash
  // escaping.
  return '\\' + match;
}

/**
 * https://drafts.csswg.org/cssom/#serialize-an-identifier
 * @param {string} value
 * @return {string}
 */
function cssEscape(value) {
  return String(value).replace(regex, escaper);
}

},{}],156:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.ShadowCSS = void 0;

/**
* @license
* Copyright (c) 2014 The Polymer Project Authors. All rights reserved.
* Use of this source code is governed by a BSD-style
* license that can be found in the LICENSE file or at
* https://developers.google.com/open-source/licenses/bsd */

/*
  This is a limited shim for ShadowDOM css styling.
  https://dvcs.w3.org/hg/webcomponents/raw-file/tip/spec/shadow/index.html#styles

  The intention here is to support only the styling features which can be
  relatively simply implemented. The goal is to allow users to avoid the
  most obvious pitfalls and do so without compromising performance significantly.
  For ShadowDOM styling that's not covered here, a set of best practices
  can be provided that should allow users to accomplish more complex styling.

  The following is a list of specific ShadowDOM styling features and a brief
  discussion of the approach used to shim.

  Shimmed features:

  * :host, :host-context: ShadowDOM allows styling of the shadowRoot's host
  element using the :host rule. To shim this feature, the :host styles are
  reformatted and prefixed with a given scope name and promoted to a
  document level stylesheet.
  For example, given a scope name of .foo, a rule like this:

    :host {
        background: red;
      }
    }

  becomes:

    .foo {
      background: red;
    }

  * encapsultion: Styles defined within ShadowDOM, apply only to
  dom inside the ShadowDOM. Polymer uses one of two techniques to imlement
  this feature.

  By default, rules are prefixed with the host element tag name
  as a descendant selector. This ensures styling does not leak out of the 'top'
  of the element's ShadowDOM. For example,

  div {
      font-weight: bold;
    }

  becomes:

  x-foo div {
      font-weight: bold;
    }

  becomes:


  Alternatively, if WebComponents.ShadowCSS.strictStyling is set to true then
  selectors are scoped by adding an attribute selector suffix to each
  simple selector that contains the host element tag name. Each element
  in the element's ShadowDOM template is also given the scope attribute.
  Thus, these rules match only elements that have the scope attribute.
  For example, given a scope name of x-foo, a rule like this:

    div {
      font-weight: bold;
    }

  becomes:

    div[x-foo] {
      font-weight: bold;
    }

  Note that elements that are dynamically added to a scope must have the scope
  selector added to them manually.

  * upper/lower bound encapsulation: Styles which are defined outside a
  shadowRoot should not cross the ShadowDOM boundary and should not apply
  inside a shadowRoot.

  This styling behavior is not emulated. Some possible ways to do this that
  were rejected due to complexity and/or performance concerns include: (1) reset
  every possible property for every possible selector for a given scope name;
  (2) re-implement css in javascript.

  As an alternative, users should make sure to use selectors
  specific to the scope in which they are working.

  * ::distributed: This behavior is not emulated. It's often not necessary
  to style the contents of a specific insertion point and instead, descendants
  of the host element can be styled selectively. Users can also create an
  extra node around an insertion point and style that node's contents
  via descendent selectors. For example, with a shadowRoot like this:

    <style>
      ::content(div) {
        background: red;
      }
    </style>
    <content></content>

  could become:

    <style>
      / *@polyfill .content-container div * /
      ::content(div) {
        background: red;
      }
    </style>
    <div class="content-container">
      <content></content>
    </div>

  Note the use of @polyfill in the comment above a ShadowDOM specific style
  declaration. This is a directive to the styling shim to use the selector
  in comments in lieu of the next selector when running under polyfill.
*/
var ShadowCSS = {
  strictStyling: false,
  // change a selector like 'div' to 'name div'

  /** @this {ShadowCSS} */
  scopeRules: function scopeRules(cssRules, scopeSelector, opt_transformer) {
    var cssText = '';

    if (cssRules) {
      Array.prototype.forEach.call(cssRules, function (rule) {
        if (rule.selectorText && rule.style && rule.style.cssText !== undefined) {
          cssText += this.scopeSelector(rule.selectorText, scopeSelector, this.strictStyling, opt_transformer) + ' {\n\t';
          cssText += this.propertiesFromRule(rule) + '\n}\n\n';
        } else if (rule.type === CSSRule.MEDIA_RULE) {
          cssText += '@media ' + rule.media.mediaText + ' {\n';
          cssText += this.scopeRules(rule.cssRules, scopeSelector);
          cssText += '\n}\n\n';
        } else {
          // KEYFRAMES_RULE in IE throws when we query cssText
          // when it contains a -webkit- property.
          // if this happens, we fallback to constructing the rule
          // from the CSSRuleSet
          // https://connect.microsoft.com/IE/feedbackdetail/view/955703/accessing-csstext-of-a-keyframe-rule-that-contains-a-webkit-property-via-cssom-generates-exception
          try {
            if (rule.cssText) {
              cssText += rule.cssText + '\n\n';
            }
          } catch (x) {
            if (rule.type === CSSRule.KEYFRAMES_RULE && rule.cssRules) {
              cssText += this.ieSafeCssTextFromKeyFrameRule(rule);
            }
          }
        }
      }, this);
    }

    return cssText;
  },

  /** @this {ShadowCSS} */
  ieSafeCssTextFromKeyFrameRule: function ieSafeCssTextFromKeyFrameRule(rule) {
    var cssText = '@keyframes ' + rule.name + ' {';
    Array.prototype.forEach.call(rule.cssRules, function (rule) {
      cssText += ' ' + rule.keyText + ' {' + rule.style.cssText + '}';
    });
    cssText += ' }';
    return cssText;
  },

  /** @this {ShadowCSS} */
  scopeSelector: function scopeSelector(selector, _scopeSelector, strict, opt_transformer) {
    var r = [],
        parts = selector.split(',');
    parts.forEach(function (p) {
      p = p.trim();

      if (opt_transformer) {
        p = opt_transformer(p);
      }

      if (this.selectorNeedsScoping(p, _scopeSelector)) {
        p = strict && !p.match(polyfillHostNoCombinator) ? this.applyStrictSelectorScope(p, _scopeSelector) : this.applySelectorScope(p, _scopeSelector);
      }

      r.push(p);
    }, this);
    return r.join(', ');
  },

  /** @this {ShadowCSS} */
  selectorNeedsScoping: function selectorNeedsScoping(selector, scopeSelector) {
    if (Array.isArray(scopeSelector)) {
      return true;
    }

    var re = this.makeScopeMatcher(scopeSelector);
    return !selector.match(re);
  },

  /** @this {ShadowCSS} */
  makeScopeMatcher: function makeScopeMatcher(scopeSelector) {
    scopeSelector = scopeSelector.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
    return new RegExp('^(' + scopeSelector + ')' + selectorReSuffix, 'm');
  },

  /** @this {ShadowCSS} */
  applySelectorScope: function applySelectorScope(selector, selectorScope) {
    return Array.isArray(selectorScope) ? this.applySelectorScopeList(selector, selectorScope) : this.applySimpleSelectorScope(selector, selectorScope);
  },
  // apply an array of selectors

  /** @this {ShadowCSS} */
  applySelectorScopeList: function applySelectorScopeList(selector, scopeSelectorList) {
    var r = [];

    for (var i = 0, s; s = scopeSelectorList[i]; i++) {
      r.push(this.applySimpleSelectorScope(selector, s));
    }

    return r.join(', ');
  },
  // scope via name and [is=name]

  /** @this {ShadowCSS} */
  applySimpleSelectorScope: function applySimpleSelectorScope(selector, scopeSelector) {
    if (selector.match(polyfillHostRe)) {
      selector = selector.replace(polyfillHostNoCombinator, scopeSelector);
      return selector.replace(polyfillHostRe, scopeSelector + ' ');
    } else {
      return scopeSelector + ' ' + selector;
    }
  },
  // return a selector with [name] suffix on each simple selector
  // e.g. .foo.bar > .zot becomes .foo[name].bar[name] > .zot[name]

  /** @this {ShadowCSS} */
  applyStrictSelectorScope: function applyStrictSelectorScope(selector, scopeSelector) {
    scopeSelector = scopeSelector.replace(/\[is=([^\]]*)\]/g, '$1');
    var splits = [' ', '>', '+', '~'],
        scoped = selector,
        attrName = '[' + scopeSelector + ']';
    splits.forEach(function (sep) {
      var parts = scoped.split(sep);
      scoped = parts.map(function (p) {
        // remove :host since it should be unnecessary
        var t = p.trim().replace(polyfillHostRe, '');

        if (t && splits.indexOf(t) < 0 && t.indexOf(attrName) < 0) {
          p = t.replace(/([^:]*)(:*)(.*)/, '$1' + attrName + '$2$3');
        }

        return p;
      }).join(sep);
    });
    return scoped;
  },

  /** @this {ShadowCSS} */
  propertiesFromRule: function propertiesFromRule(rule) {
    var cssText = rule.style.cssText;

    // TODO(sorvell): Safari cssom incorrectly removes quotes from the content
    // property. (https://bugs.webkit.org/show_bug.cgi?id=118045)
    // don't replace attr rules
    if (rule.style.content && !rule.style.content.match(/['"]+|attr/)) {
      cssText = cssText.replace(/content:[^;]*;/g, 'content: \'' + rule.style.content + '\';');
    }

    // TODO(sorvell): we can workaround this issue here, but we need a list
    // of troublesome properties to fix https://github.com/Polymer/platform/issues/53
    //
    // inherit rules can be omitted from cssText
    // TODO(sorvell): remove when Blink bug is fixed:
    // https://code.google.com/p/chromium/issues/detail?id=358273
    var style = rule.style;

    for (var i in style) {
      if (style[i] === 'initial') {
        cssText += i + ': initial; ';
      }
    }

    return cssText;
  }
};
exports.ShadowCSS = ShadowCSS;
var selectorRe = /([^{]*)({[\s\S]*?})/gim,
    cssCommentRe = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//gim,
    // TODO(sorvell): remove either content or comment
cssCommentNextSelectorRe = /\/\*\s*@polyfill ([^*]*\*+([^/*][^*]*\*+)*\/)([^{]*?){/gim,
    cssContentNextSelectorRe = /polyfill-next-selector[^}]*content\:[\s]*?['"](.*?)['"][;\s]*}([^{]*?){/gim,
    // TODO(sorvell): remove either content or comment
cssCommentRuleRe = /\/\*\s@polyfill-rule([^*]*\*+([^/*][^*]*\*+)*)\//gim,
    cssContentRuleRe = /(polyfill-rule)[^}]*(content\:[\s]*['"](.*?)['"])[;\s]*[^}]*}/gim,
    // TODO(sorvell): remove either content or comment
cssCommentUnscopedRuleRe = /\/\*\s@polyfill-unscoped-rule([^*]*\*+([^/*][^*]*\*+)*)\//gim,
    cssContentUnscopedRuleRe = /(polyfill-unscoped-rule)[^}]*(content\:[\s]*['"](.*?)['"])[;\s]*[^}]*}/gim,
    cssPseudoRe = /::(x-[^\s{,(]*)/gim,
    cssPartRe = /::part\(([^)]*)\)/gim,
    // note: :host pre-processed to -shadowcsshost.
polyfillHost = '-shadowcsshost',
    // note: :host-context pre-processed to -shadowcsshostcontext.
polyfillHostContext = '-shadowcsscontext',
    parenSuffix = ')(?:\\((' + '(?:\\([^)(]*\\)|[^)(]*)+?' + ')\\))?([^,{]*)';
var cssColonHostRe = new RegExp('(' + polyfillHost + parenSuffix, 'gim'),
    cssColonHostContextRe = new RegExp('(' + polyfillHostContext + parenSuffix, 'gim'),
    selectorReSuffix = '([>\\s~+\[.,{:][\\s\\S]*)?$',
    colonHostRe = /\:host/gim,
    colonHostContextRe = /\:host-context/gim,

/* host name without combinator */
polyfillHostNoCombinator = polyfillHost + '-no-combinator',
    polyfillHostRe = new RegExp(polyfillHost, 'gim'),
    polyfillHostContextRe = new RegExp(polyfillHostContext, 'gim'),
    shadowDOMSelectorsRe = [/>>>/g, /::shadow/g, /::content/g, // Deprecated selectors
/\/deep\//g, // former >>>
/\/shadow\//g, // former ::shadow
/\/shadow-deep\//g, // former /deep/
/\^\^/g, // former /shadow/
/\^(?!=)/g // former /shadow-deep/
];

},{}]},{},[58])

